import {
  protoOf180f3jzyo7rfj as protoOf,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  defineProp3hxgpk2knu2px as defineProp,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Unit_instanceat14thlj150z as Unit_instance,
  LinkedHashSet_init_$Create$161uomhguzhxi as LinkedHashSet_init_$Create$,
  ArrayList_init_$Create$2rimpp4x9tjd3 as ArrayList_init_$Create$,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  sortedWith13ny3qsmk2kn8 as sortedWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  to2cs3ny02qtbcb as to,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  toList3jhuyej2anx2q as toList,
  toMap1vec9topfei08 as toMap,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString30pk9tzaqopn as toString,
  toString1pkumu07cwy4m as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  joinToString1cxrrlmo0chqs as joinToString,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$snys8oz8txtu as LinkedHashMap_init_$Create$,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  emptyMapr06gerzljqtm as emptyMap,
  ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$_0,
  copyToArray2j022khrow2yi as copyToArray,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  joinToStringxqcavsxcmh4q as joinToString_0,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  plus2m1vv33moko5t as plus,
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfvhqybd2zx248 as listOf,
  plus310ted5e4i90h as plus_0,
  addAll1k27qatfgp3k5 as addAll,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  IndexOutOfBoundsException_init_$Create$lgvynu6unvfx as IndexOutOfBoundsException_init_$Create$,
  asSequence1nrrcrdtwpkc5 as asSequence,
  toListx6x8nvfmvvht as toList_0,
  UnsupportedOperationException_init_$Create$1usmxm8d6ijjz as UnsupportedOperationException_init_$Create$,
  asSequence2jzw5xbq99nu9 as asSequence_0,
  sequenceOf1mtha40gp6gat as sequenceOf,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  flatten21nlxz4anepug as flatten,
  filter184huxd00uyfg as filter,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
  any3lcolwko9usbz as any,
  firstOrNull1gk7vzkf4h3nq as firstOrNull,
  Exception_init_$Create$1f9k5rt5gytdg as Exception_init_$Create$,
  asSequence2phdjljfh9jhx as asSequence_1,
  mapsbvh18eqox7a as map,
  firstOrNull175qkyx53x0vd as firstOrNull_0,
  contains1tccixv8iwdcq as contains,
  Collection1k04j3hzsbod0 as Collection,
  toSet2orjxp16sotqu as toSet,
  addAll3rgorw6ix9mgp as addAll_0,
  toSet2morh2kqexfa2 as toSet_0,
  HashSet_init_$Create$2bsk5herqkxxm as HashSet_init_$Create$,
  compareBy2697bq0ffft96 as compareBy,
  sortWith23lt7r6b8svqd as sortWith,
  lazy2hsh8ze7j6ikd as lazy,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
  compareTo3ankvs086tmwq as compareTo,
  setOf1u3mizs95ngxo as setOf,
  subtractbrsvji8bjf9 as subtract,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  distinct10qe1scfdvu5k as distinct,
  last3cd86tb14cwl6 as last,
  Paire9pteg33gng7 as Pair,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  emptySequence25zpp7hgtqwdd as emptySequence,
  IllegalArgumentException_init_$Create$sfel9vrfa7w2 as IllegalArgumentException_init_$Create$,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  any2h2vr68v3604v as any_0,
  sortedWith2csnbbb21k0lg as sortedWith_0,
  asIterable314gqyxouondo as asIterable,
  flatMapgxtanzi5fvh9 as flatMap,
  none369ray3udrc57 as none,
  firstOrNull1982767dljvdy as firstOrNull_1,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  until1jbpn0z3f8lbg as until,
  round2mrvepag8eey0 as round,
  KProperty02ce7r476m8633 as KProperty0,
  Enum3alwj03lh1n41 as Enum,
  get_indicesc04v40g017hw as get_indices,
  contentDeepEquals38knrynwk1e6k as contentDeepEquals,
  LinkedHashMap_init_$Create$2gfxg59gogbfz as LinkedHashMap_init_$Create$_0,
  filterNotNullhujglslymx1l as filterNotNull,
  KtMutableList1beimitadwkna as KtMutableList,
  IllegalStateException_init_$Create$1nm9y6jd3c9iy as IllegalStateException_init_$Create$,
  reversedArray1jvawboiqjp41 as reversedArray,
  first1vi3grnpj1175 as first,
  BooleanCompanionObject_instance3nn0izprmvlr6 as BooleanCompanionObject_instance,
  toList383f556t1dixk as toList_1,
  NoSuchElementException_init_$Create$3t0s5oqnkdmdn as NoSuchElementException_init_$Create$,
  sequence2vgswtrxvqoa7 as sequence,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  addAll21mdhg523wnoa as addAll_1,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  isFinite2t9l5a275mxm6 as isFinite,
  isNaNymqb93xtq8w8 as isNaN_0,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  first58ocm7j58k3q as first_0,
  distinct17vua5ffe1cfv as distinct_0,
  toMutableList3ewlpx8m5ca2q as toMutableList,
  minus1djrl64vbav3y as minus,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toInt2q8uldh7sc951 as toInt,
  removeFirst1io7eo7dqtj5o as removeFirst,
  plus20p0vtfmu0596 as plus_1,
  asList2ho2pewtsfvv as asList,
  toMutableList20rdgwi7d3cwi as toMutableList_0,
  removeAll3o43e67jmwdpc as removeAll,
  zip2suipyqmdw72q as zip,
  listOf1jh22dvmctj1r as listOf_0,
  plus1di085adi7f7m as plus_2,
  reversednxqwdkac9dn0 as reversed,
  roundToInt1ue8x8yshtznx as roundToInt,
  println2shhhgwwt4c61 as println,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark3e7hmed1q029a as ValueTimeMark,
  Duration5ynfiptaqcrg as Duration,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  Triple1vhi3d0dgpnjb as Triple,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  numberToLong1a4cndvg6c52s as numberToLong,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3elpl3cwdan58 as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  sort15ai02l4kxbfa as sort,
  startsWith26w8qjqapeeq6 as startsWith,
  endsWith3cq61xxngobwh as endsWith,
  indexOfwa4w6635jewi as indexOf,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  substring2pnd9wgs9hwtx as substring,
  Long2qws0ah9gnpki as Long,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  Duration__toDouble_impl_a56y2bg1tednt31ina as Duration__toDouble_impl_a56y2b,
} from './kotlin-kotlin-stdlib.mjs';
import {
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$3p6j2tgfvvykj as UnknownFieldException_init_$Create$,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  serializer3u3hsxnenk49x as serializer,
  DoubleSerializer_getInstance2y096mioqlqlr as DoubleSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  BooleanSerializer_getInstance1a8uvzxl1s4k4 as BooleanSerializer_getInstance,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  Jsonsmkyu9xjl7fv as Json,
  Default_getInstance2o39jijms8bnj as Default_getInstance,
  JsonElementSerializer_getInstance2oljfos0dzhs0 as JsonElementSerializer_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
//region block: imports
var imul = Math.imul;
var sign = Math.sign;
//endregion
//region block: pre-declaration
function setLogModule(logger, basePackageName, $super) {
  logger = logger === VOID ? null : logger;
  basePackageName = basePackageName === VOID ? null : basePackageName;
  return this.x1j(logger, basePackageName);
}
function addHistoryModule(history, historySize, $super) {
  history = history === VOID ? null : history;
  historySize = historySize === VOID ? 500 : historySize;
  return this.y1j(history, historySize);
}
initMetadataForInterface(Core, 'Core');
initMetadataForInterface(CoreFactory, 'CoreFactory');
initMetadataForInterface(CoreModules, 'CoreModules');
initMetadataForClass(CoreServices, 'CoreServices');
initMetadataForClass(AddPartAction, 'AddPartAction');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion);
initMetadataForClass(AssemblyPart, 'AssemblyPart');
initMetadataForClass(AssemblyPartSnapInfo, 'AssemblyPartSnapInfo', AssemblyPartSnapInfo);
initMetadataForCompanion(Companion_0);
function get_serializable() {
  return false;
}
function get_doStoreInSnapshot() {
  return true;
}
initMetadataForInterface(Component, 'Component');
initMetadataForClass(AssemblyPartIdsComponent, 'AssemblyPartIdsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_1);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AssemblyPartsComponent, 'AssemblyPartsComponent', AssemblyPartsComponent, VOID, [Component], VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_2);
initMetadataForClass(AssemblyStructureComponent, 'AssemblyStructureComponent', VOID, VOID, [Component]);
initMetadataForClass(PartPair, 'PartPair');
initMetadataForCompanion(Companion_3);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Serialized, 'Serialized', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForInterface(JsonSerializable, 'JsonSerializable');
function get_serializable_0() {
  return true;
}
initMetadataForInterface(SerializableComponent, 'SerializableComponent', VOID, VOID, [JsonSerializable, Component]);
initMetadataForClass(ProductPartComponent, 'ProductPartComponent', VOID, VOID, [SerializableComponent]);
initMetadataForClass(RemovePartAction, 'RemovePartAction');
initMetadataForCompanion(Companion_5);
initMetadataForClass(CatalogSizeComponent, 'CatalogSizeComponent', VOID, VOID, [Component]);
function beforeDeserialize(json, catalogVersions) {
  return json;
}
function beforeParsingComponents(serializableTree, catalogVersions) {
}
function beforeBuildingEntities(serializableTree, catalogVersions) {
}
function afterDeserializeComplete(root, catalogVersions) {
}
initMetadataForInterface(DeserializationInterceptor, 'DeserializationInterceptor');
function productSpecification(productRef, params, $super) {
  params = params === VOID ? null : params;
  return this.t1t(productRef, params);
}
function createCustomAssembly(originalProduct, newParts, productManager) {
  var newSpecification = this.createCustomAssemblySpecification(originalProduct, newParts);
  var tmp;
  if (newSpecification == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.catalog.ProductCatalog.createCustomAssembly.<anonymous>' call
    tmp = productManager.createFromSpecification(originalProduct, newSpecification);
  }
  return tmp;
}
function createCustomAssemblySpecification(originalProduct, newParts) {
  var specification = this.productSpecification(originalProduct);
  var partsComponent = specification == null ? null : specification.findComponent(Companion_getInstance_2().id);
  var tmp2_safe_receiver = partsComponent == null ? null : partsComponent.t1s_1;
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(tmp2_safe_receiver.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = tmp2_safe_receiver.i2().k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.core.catalog.ProductCatalog.createCustomAssemblySpecification.<anonymous>' call
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = newParts.length;
        while (inductionVariable < last) {
          var element = newParts[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.catalog.ProductCatalog.createCustomAssemblySpecification.<anonymous>.<anonymous>' call
          if (element.partKey === item.b2()) {
            tmp$ret$2 = element;
            break $l$block;
          }
        }
        tmp$ret$2 = null;
      }
      var tmp0_safe_receiver = tmp$ret$2;
      var newPartProductRef = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.productRef;
      var tmp_0;
      if (!(newPartProductRef == null)) {
        tmp_0 = to(item.b2(), newPartProductRef);
      } else {
        tmp_0 = to(item.b2(), item.c2());
      }
      var tmp$ret$4 = tmp_0;
      destination.h(tmp$ret$4);
    }
    tmp = destination;
  }
  var tmp3_safe_receiver = tmp;
  var newPartsMap = tmp3_safe_receiver == null ? null : toMap(tmp3_safe_receiver);
  var tmp_1;
  if (!(newPartsMap == null)) {
    tmp_1 = specification.addComponent(AssemblyPartsComponent_init_$Create$(newPartsMap));
  } else {
    tmp_1 = specification;
  }
  return tmp_1;
}
initMetadataForInterface(ProductCatalog, 'ProductCatalog', VOID, VOID, [DeserializationInterceptor]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(ProductCatalogFunctions, 'ProductCatalogFunctions', ProductCatalogFunctions);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ProductComponent, 'ProductComponent', VOID, VOID, [Component]);
function createEntity(productRef, params, entityId, $super) {
  params = params === VOID ? null : params;
  entityId = entityId === VOID ? null : entityId;
  return this.y1t(productRef, params, entityId);
}
function createEntityInternal(productRef, params, entityId, $super) {
  params = params === VOID ? null : params;
  entityId = entityId === VOID ? null : entityId;
  return this.z1t(productRef, params, entityId);
}
function productSpecification_0(productRef, params, $super) {
  params = params === VOID ? null : params;
  return this.t1t(productRef, params);
}
function createFromSpecification(productRef, specification, entityId, $super) {
  entityId = entityId === VOID ? null : entityId;
  return this.a1u(productRef, specification, entityId);
}
function createFromSpecificationInternal(productRef, specification, entityId, $super) {
  entityId = entityId === VOID ? null : entityId;
  return this.b1u(productRef, specification, entityId);
}
initMetadataForInterface(ProductManager, 'ProductManager');
initMetadataForCompanion(Companion_8);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ProductParams, 'ProductParams', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_9);
initMetadataForClass(ProductParamsComponent, 'ProductParamsComponent', VOID, VOID, [SerializableComponent]);
initMetadataForClass(ProductSpecification, 'ProductSpecification');
initMetadataForCompanion(Companion_10);
initMetadataForClass(ProductStructureComponent, 'ProductStructureComponent', VOID, VOID, [Component]);
initMetadataForClass(ProductStructureConnection, 'ProductStructureConnection');
initMetadataForClass(ProductStructureItem, 'ProductStructureItem');
initMetadataForCompanion(Companion_11);
initMetadataForInterface(System, 'System');
initMetadataForInterface(EcsSystem, 'EcsSystem', VOID, VOID, [System]);
initMetadataForClass(EcsSystemImpl, 'EcsSystemImpl', VOID, VOID, [EcsSystem]);
initMetadataForClass(SystemBase, 'SystemBase', VOID, EcsSystemImpl);
initMetadataForClass(ProductResizingSystem, 'ProductResizingSystem', VOID, SystemBase);
initMetadataForClass(CircularBuffer$iterator$1);
initMetadataForClass(CircularBuffer, 'CircularBuffer');
initMetadataForCompanion(Companion_12);
initMetadataForClass(ColliderComponent, 'ColliderComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(ColliderShapeComponent, 'ColliderShapeComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(ColliderUtils, 'ColliderUtils', ColliderUtils);
initMetadataForClass(Collision, 'Collision');
initMetadataForCompanion(Companion_15);
initMetadataForCompanion(Companion_16);
initMetadataForClass(CollisionUtils, 'CollisionUtils', CollisionUtils);
initMetadataForCompanion(Companion_17);
initMetadataForInterface(Validation, 'Validation');
initMetadataForClass(ValidationImpl, 'ValidationImpl', VOID, VOID, [Validation]);
initMetadataForClass(CollisionValidation, 'CollisionValidation', CollisionValidation, ValidationImpl);
initMetadataForCompanion(Companion_18);
initMetadataForClass(ValidationResult, 'ValidationResult');
initMetadataForClass(CollisionValidationResult, 'CollisionValidationResult', VOID, ValidationResult);
initMetadataForCompanion(Companion_19);
initMetadataForClass(SystemBase2, 'SystemBase2', VOID, SystemBase);
initMetadataForClass(WorldColliderUpdateSystem, 'WorldColliderUpdateSystem', WorldColliderUpdateSystem, SystemBase2);
initMetadataForCompanion(Companion_20);
initMetadataForClass(ComponentIdSpan, 'ComponentIdSpan', ComponentIdSpan);
initMetadataForCompanion(Companion_21);
initMetadataForClass(ComponentIds, 'ComponentIds', ComponentIds);
initMetadataForCompanion(Companion_22);
initMetadataForClass(ComponentUtils, 'ComponentUtils', ComponentUtils);
initMetadataForClass(AlignmentConnection, 'AlignmentConnection');
initMetadataForCompanion(Companion_23);
initMetadataForClass(ChildConnectionValidation, 'ChildConnectionValidation', ChildConnectionValidation, ValidationImpl);
initMetadataForClass(Connection, 'Connection');
initMetadataForCompanion(Companion_24);
initMetadataForClass(ConnectionRootComponent, 'ConnectionRootComponent', ConnectionRootComponent, VOID, [Component]);
initMetadataForCompanion(Companion_25);
initMetadataForClass(ConnectionUtils, 'ConnectionUtils', ConnectionUtils);
initMetadataForCompanion(Companion_26);
initMetadataForClass(GuestConnectionsComponent, 'GuestConnectionsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_27);
initMetadataForClass(HostConnectionsComponent, 'HostConnectionsComponent', HostConnectionsComponent, VOID, [Component]);
initMetadataForCompanion(Companion_28);
initMetadataForClass(TemporarilyPauseConnectionParentingComponent, 'TemporarilyPauseConnectionParentingComponent', TemporarilyPauseConnectionParentingComponent, VOID, [Component]);
initMetadataForCompanion(Companion_29);
initMetadataForClass(TemporaryParentConnectionValidation, 'TemporaryParentConnectionValidation', TemporaryParentConnectionValidation, ValidationImpl);
initMetadataForCompanion(Companion_30);
initMetadataForClass(UpdateHostConnectionsSystem, 'UpdateHostConnectionsSystem', UpdateHostConnectionsSystem, SystemBase);
initMetadataForCompanion(Companion_31);
initMetadataForClass(Connector, 'Connector');
initMetadataForObject(ConnectorTagConstants, 'ConnectorTagConstants');
initMetadataForCompanion(Companion_32);
initMetadataForClass(ConnectorType, 'ConnectorType', ConnectorType);
initMetadataForCompanion(Companion_33);
initMetadataForClass(ConnectorUtils, 'ConnectorUtils', ConnectorUtils);
initMetadataForCompanion(Companion_34);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ConnectorsComponent, 'ConnectorsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_35);
initMetadataForClass(DisableConnectorsSystem, 'DisableConnectorsSystem', DisableConnectorsSystem, SystemBase);
initMetadataForCompanion(Companion_36);
initMetadataForClass(DisabledConnectorsComponent, 'DisabledConnectorsComponent', VOID, VOID, [Component]);
initMetadataForClass(EdgeConnector, 'EdgeConnector', VOID, Connector);
initMetadataForClass(PointConnector, 'PointConnector', VOID, Connector);
initMetadataForClass(PointSeriesConnector, 'PointSeriesConnector', VOID, Connector);
initMetadataForClass(PointSeriesSubConnector, 'PointSeriesSubConnector', VOID, Connector);
initMetadataForClass(RelativeConnectorData, 'RelativeConnectorData');
initMetadataForCompanion(Companion_37);
initMetadataForClass(RelativeConnectorRepositioner, 'RelativeConnectorRepositioner', RelativeConnectorRepositioner);
initMetadataForCompanion(Companion_38);
initMetadataForClass(RelativeConnectorsComponent, 'RelativeConnectorsComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_39);
initMetadataForClass(RotationDegreeOfFreedom, 'RotationDegreeOfFreedomImpostor', RotationDegreeOfFreedom);
initMetadataForClass(KtRotationDegreeOfFreedom, 'RotationDegreeOfFreedom', VOID, Enum);
initMetadataForCompanion(Companion_40);
initMetadataForClass(SurfaceConnector, 'SurfaceConnector', VOID, Connector);
initMetadataForClass(DebugLine, 'DebugLine');
initMetadataForCompanion(Companion_41);
initMetadataForClass(DebugLinesComponent, 'DebugLinesComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_42);
initMetadataForClass(DebugSurfacesComponent, 'DebugSurfacesComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_43);
initMetadataForClass(DragSurfacesComponent, 'DragSurfacesComponent', VOID, VOID, [Component]);
initMetadataForClass(DragSurface, 'DragSurface');
initMetadataForCompanion(Companion_44);
initMetadataForClass(DraggableComponent, 'DraggableComponent', DraggableComponent, VOID, [Component]);
initMetadataForCompanion(Companion_45);
initMetadataForClass(SomethingIsDraggedComponent, 'SomethingIsDraggedComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_46);
initMetadataForClass(ViewerDragEventComponent, 'ViewerDragEventComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_47);
initMetadataForClass(WorldDragSurfaceUpdateSystem, 'WorldDragSurfaceUpdateSystem', WorldDragSurfaceUpdateSystem, SystemBase2);
initMetadataForCompanion(Companion_48);
initMetadataForClass(WorldDragSurfacesComponent, 'WorldDragSurfacesComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_49);
initMetadataForClass(WorldSpaceDragEventComponent, 'WorldSpaceDragEventComponent', VOID, VOID, [Component]);
initMetadataForClass(ComponentHolder, 'ComponentHolder', ComponentHolder);
initMetadataForInterface(ComponentListener, 'ComponentListener');
initMetadataForCompanion(Companion_50);
initMetadataForClass(Entity, 'Entity');
initMetadataForInterface(EntityManager, 'EntityManager');
initMetadataForCompanion(Companion_51);
initMetadataForClass(EntityManagerImpl, 'EntityManagerImpl', EntityManagerImpl, VOID, [EntityManager]);
initMetadataForInterface(EntityManagerWatcher, 'EntityManagerWatcher');
initMetadataForClass(EntityManagerWatcherList, 'EntityManagerWatcherList', EntityManagerWatcherList, VOID, [KtMutableList, EntityManagerWatcher]);
initMetadataForCompanion(Companion_52);
initMetadataForClass(ComponentListenerImpl, 'ComponentListenerImpl', VOID, VOID, [ComponentListener]);
initMetadataForClass(SystemBase3, 'SystemBase3', VOID, SystemBase2);
initMetadataForClass(SystemBase4, 'SystemBase4', VOID, SystemBase3);
initMetadataForClass(SystemBase5, 'SystemBase5', VOID, SystemBase4);
initMetadataForObject(SystemGraphHelper, 'SystemGraphHelper');
initMetadataForCompanion(Companion_53);
initMetadataForClass(AutomaticGroupBuilderSystem, 'AutomaticGroupBuilderSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_54);
initMetadataForClass(AutomaticGroupComponent, 'AutomaticGroupComponent', AutomaticGroupComponent, VOID, [Component, SerializableComponent]);
initMetadataForCompanion(Companion_55);
initMetadataForClass(AutomaticGroupIdCountComponent, 'AutomaticGroupIdCountComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_56);
initMetadataForClass(EntityGroupUtils, 'EntityGroupUtils', EntityGroupUtils);
initMetadataForCompanion(Companion_57);
initMetadataForClass(StaticComponent, 'StaticComponent', StaticComponent, VOID, [Component]);
initMetadataForCompanion(Companion_58);
initMetadataForClass(ChildComponent, 'ChildComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_59);
initMetadataForClass(ConnectionParentingSystem, 'ConnectionParentingSystem', ConnectionParentingSystem, SystemBase);
initMetadataForCompanion(Companion_60);
initMetadataForClass(DisposeTemporaryParentSystem, 'DisposeTemporaryParentSystem', DisposeTemporaryParentSystem, SystemBase);
initMetadataForClass(EntityWithComponent, 'EntityWithComponent');
initMetadataForCompanion(Companion_61);
initMetadataForClass(HierarchySystem, 'HierarchySystem', VOID, SystemBase);
initMetadataForCompanion(Companion_62);
initMetadataForClass(HierarchyUtils, 'HierarchyUtils', HierarchyUtils);
initMetadataForLambda(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCompanion(Companion_63);
initMetadataForClass(InSceneComponent, 'InSceneComponent', InSceneComponent, VOID, [Component]);
initMetadataForCompanion(Companion_64);
initMetadataForClass(ParentComponent, 'ParentComponent', VOID, VOID, [Component]);
initMetadataForClass(RestoreSnapRootOnChildrenOfTemporaryParentSystem, 'RestoreSnapRootOnChildrenOfTemporaryParentSystem', RestoreSnapRootOnChildrenOfTemporaryParentSystem, SystemBase);
initMetadataForObject(SceneComponent_0, 'SceneComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_65);
initMetadataForClass(SceneGraphSystem, 'SceneGraphSystem', VOID, SystemBase);
initMetadataForInterface(SceneManager, 'SceneManager');
initMetadataForCompanion(Companion_66);
initMetadataForClass(TemporaryParentComponent, 'TemporaryParentComponent', TemporaryParentComponent, VOID, [Component]);
function takeSnapshot(snapshotName, $super) {
  snapshotName = snapshotName === VOID ? '' : snapshotName;
  return this.v2t(snapshotName);
}
initMetadataForInterface(History, 'History');
initMetadataForClass(HistoryEvent, 'HistoryEvent', VOID, Enum);
initMetadataForCompanion(Companion_67);
initMetadataForClass(HistoryChangedEventComponent, 'HistoryChangedEventComponent', VOID, VOID, [Component]);
initMetadataForClass(HistoryImpl, 'HistoryImpl', VOID, VOID, [History]);
initMetadataForClass(LogLevel, 'LogLevel', VOID, Enum);
initMetadataForInterface(Logger, 'Logger');
initMetadataForClass(LoggerImpl, 'LoggerImpl', LoggerImpl, VOID, [Logger]);
initMetadataForClass(LoggerWrap, 'LoggerWrap', VOID, VOID, [Logger]);
initMetadataForObject(LoggerState, 'LoggerState');
initMetadataForClass(AxisAngle, 'AxisAngle');
initMetadataForClass(Degrees, 'Degrees');
function alignBottom(outer) {
  return new Vector(0.0, -this.height / 2 + outer.height / 2, 0.0);
}
function alignTop(outer) {
  return this.alignBottom(outer).unaryMinus();
}
function alignRight(outer) {
  return new Vector(this.width / 2 - outer.width / 2, 0.0, 0.0);
}
function alignLeft(outer) {
  return this.alignRight(outer).unaryMinus();
}
function alignFront(outer) {
  return new Vector(0.0, 0.0, this.depth / 2 - outer.depth / 2);
}
function alignBack(outer) {
  return this.alignFront(outer).unaryMinus();
}
initMetadataForInterface(Dimension, 'Dimension');
initMetadataForClass(DualDouble, 'DualDouble');
initMetadataForCompanion(Companion_68);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Margin, 'Margin', Margin, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_69);
initMetadataForClass(MathUtils, 'MathUtils', MathUtils);
initMetadataForCompanion(Companion_70);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ModelTransform, 'ModelTransform', ModelTransform, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_71);
initMetadataForInterface(Raycastable, 'Raycastable');
initMetadataForClass(Plane, 'Plane', VOID, VOID, [Raycastable]);
initMetadataForCompanion(Companion_72);
initMetadataForClass(Polygon, 'Polygon', VOID, VOID, [Raycastable]);
initMetadataForCompanion(Companion_73);
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Quaternion, 'Quaternion', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForClass(Radians, 'Radians');
initMetadataForClass(RelativeBoxOffset, 'RelativeBoxOffset');
initMetadataForCompanion(Companion_74);
initMetadataForClass(RelationOriginAlongX, 'RelationOriginAlongX', RelationOriginAlongX);
initMetadataForCompanion(Companion_75);
initMetadataForClass(RelationOriginAlongY, 'RelationOriginAlongY', RelationOriginAlongY);
initMetadataForCompanion(Companion_76);
initMetadataForClass(RelationOriginAlongZ, 'RelationOriginAlongZ', RelationOriginAlongZ);
initMetadataForCompanion(Companion_77);
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RelationOrigin, 'RelationOrigin', RelationOrigin, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_78);
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Size, 'Size', Size, VOID, [Dimension], VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForCompanion(Companion_79);
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Transform, 'Transform', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_80);
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Vector, 'Vector', Vector, VOID, [Dimension], VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForCompanion(Companion_81);
initMetadataForClass(VectorConstants, 'VectorConstants', VectorConstants);
initMetadataForClass(InnerMeasurement, 'InnerMeasurement');
initMetadataForCompanion(Companion_82);
initMetadataForClass(MeasurementUtils, 'MeasurementUtils', MeasurementUtils);
initMetadataForCompanion(Companion_83);
initMetadataForClass(DisplayNameComponent, 'DisplayNameComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_84);
initMetadataForClass(ProductUtils, 'ProductUtils', ProductUtils);
initMetadataForCompanion(Companion_85);
initMetadataForClass(ProppingComponent, 'ProppingComponent', ProppingComponent, VOID, [Component]);
initMetadataForCompanion(Companion_86);
initMetadataForClass(TemplateDataComponent, 'TemplateDataComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_87);
initMetadataForClass(ProductStructureBuilder, 'ProductStructureBuilder', ProductStructureBuilder);
initMetadataForCompanion(Companion_88);
initMetadataForClass(Ray, 'Ray');
initMetadataForClass(RaycastHit, 'RaycastHit');
initMetadataForClass(RaycastResult, 'RaycastResult');
initMetadataForCompanion(Companion_89);
initMetadataForClass(RaycastUtils, 'RaycastUtils', RaycastUtils);
initMetadataForCompanion(Companion_90);
initMetadataForClass(LoadedModelInfoComponent, 'LoadedModelInfoComponent', LoadedModelInfoComponent, VOID, [Component]);
initMetadataForCompanion(Companion_91);
initMetadataForClass(ModelInfoComponent, 'ModelInfoComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_92);
initMetadataForClass(ModelLoaderSystem, 'ModelLoaderSystem', VOID, SystemBase4);
initMetadataForCompanion(Companion_93);
initMetadataForClass(ModelTransformComponent, 'ModelTransformComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_94);
initMetadataForClass(ModelUtils, 'ModelUtils', ModelUtils);
initMetadataForCompanion(Companion_95);
initMetadataForClass(OutlineableComponent, 'OutlineableComponent', OutlineableComponent, VOID, [Component]);
initMetadataForCompanion(Companion_96);
initMetadataForClass(PauseViewerUpdatesComponent, 'PauseViewerUpdatesComponent', PauseViewerUpdatesComponent, VOID, [Component]);
initMetadataForCompanion(Companion_97);
initMetadataForClass(RenderSystem, 'RenderSystem', RenderSystem, SystemBase);
initMetadataForCompanion(Companion_98);
initMetadataForClass(RenderedComponent, 'RenderedComponent', RenderedComponent, VOID, [Component]);
function createSphere(radius, entity, $super) {
  entity = entity === VOID ? null : entity;
  return this.w32(radius, entity);
}
function cloneObject(vo, entity, $super) {
  entity = entity === VOID ? null : entity;
  return this.x32(vo, entity);
}
function createBox(width, height, depth, entity, $super) {
  entity = entity === VOID ? null : entity;
  return this.y32(width, height, depth, entity);
}
function createPlane(width, depth, entity, $super) {
  entity = entity === VOID ? null : entity;
  return this.z32(width, depth, entity);
}
function createSurface(vertices, normal, entity, $super) {
  entity = entity === VOID ? null : entity;
  return this.a33(vertices, normal, entity);
}
function groupMeshes(meshes, entity, $super) {
  entity = entity === VOID ? null : entity;
  return this.b33(meshes, entity);
}
function createUiLine(start, end, color, thickness, $super) {
  color = color === VOID ? Companion_getInstance_81().ZERO : color;
  return this.c33(start, end, color, thickness);
}
function createUiDashedLine(start, end, color, thickness, $super) {
  color = color === VOID ? Companion_getInstance_81().ZERO : color;
  return this.d33(start, end, color, thickness);
}
function updateUiLine(id, start, end, color, thickness, $super) {
  color = color === VOID ? Companion_getInstance_81().ZERO : color;
  return this.e33(id, start, end, color, thickness);
}
function loadModel(entity, url, textureFile, modelLoaded, modelLoadFailed, loadingBoxSize, loadingBoxCenter, $super) {
  loadingBoxSize = loadingBoxSize === VOID ? null : loadingBoxSize;
  loadingBoxCenter = loadingBoxCenter === VOID ? null : loadingBoxCenter;
  return this.f33(entity, url, textureFile, modelLoaded, modelLoadFailed, loadingBoxSize, loadingBoxCenter);
}
function debug(enable, $super) {
  enable = enable === VOID ? false : enable;
  return this.g33(enable);
}
function createEmpty(entity, $super) {
  entity = entity === VOID ? null : entity;
  return this.h33(entity);
}
function createGhostModel(modelUrl, modelLoaded, r, g, b, alpha, loadingBoxSize, $super) {
  r = r === VOID ? 0.0 : r;
  g = g === VOID ? 0.0 : g;
  b = b === VOID ? 1.0 : b;
  alpha = alpha === VOID ? 0.5 : alpha;
  loadingBoxSize = loadingBoxSize === VOID ? null : loadingBoxSize;
  return this.i33(modelUrl, modelLoaded, r, g, b, alpha, loadingBoxSize);
}
initMetadataForInterface(Viewer, 'Viewer');
initMetadataForCompanion(Companion_99);
initMetadataForClass(ViewerComponent, 'ViewerComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_100);
initMetadataForClass(ViewerLineIdsComponent, 'ViewerLineIdsComponent', VOID, VOID, [Component]);
function setScaleV(v) {
  return this.setScale(v.X, v.Y, v.Z);
}
initMetadataForInterface(ViewerObject, 'ViewerObject');
initMetadataForCompanion(Companion_101);
initMetadataForClass(ViewerObjectComponent, 'ViewerObjectComponent', VOID, VOID, [Component]);
initMetadataForClass(ViewerObjectTransformSystem, 'ViewerObjectTransformSystem', ViewerObjectTransformSystem, SystemBase4);
initMetadataForClass(ViewerObjectVisibilitySystem, 'ViewerObjectVisibilitySystem', ViewerObjectVisibilitySystem, SystemBase3);
initMetadataForClass(ViewerPresenceSystem, 'ViewerPresenceSystem', VOID, SystemBase);
initMetadataForCompanion(Companion_102);
initMetadataForClass(EntityReplaceHelper, 'EntityReplaceHelper');
initMetadataForCompanion(Companion_103);
initMetadataForClass(FastReplaceAction, 'FastReplaceAction');
initMetadataForClass(ReplaceAction, 'ReplaceAction');
initMetadataForClass(ReplacePartAction, 'ReplacePartAction');
initMetadataForCompanion(Companion_104);
initMetadataForClass(SlowReplaceInProgressComponent, 'SlowReplaceInProgressComponent', SlowReplaceInProgressComponent, VOID, [Component]);
initMetadataForCompanion(Companion_105);
initMetadataForClass(ClickEventComponent, 'ClickEventComponent', VOID, VOID, [Component]);
initMetadataForObject(MultiSelectionEnabledComponent_0, 'MultiSelectionEnabledComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_106);
initMetadataForClass(SelectableComponent, 'SelectableComponent', SelectableComponent, VOID, [Component]);
initMetadataForCompanion(Companion_107);
initMetadataForClass(SelectedComponent, 'SelectedComponent', SelectedComponent, VOID, [Component]);
initMetadataForClass(CatalogVersion, 'CatalogVersion');
initMetadataForCompanion(Companion_108);
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(CatalogsHeader, 'CatalogsHeader', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForInterface(ComponentDeserializer, 'ComponentDeserializer');
initMetadataForClass(ComponentDeserializerRegistry, 'ComponentDeserializerRegistry', ComponentDeserializerRegistry);
initMetadataForClass(DeserializationInterceptorRegistry, 'DeserializationInterceptorRegistry', DeserializationInterceptorRegistry);
initMetadataForCompanion(Companion_109);
initMetadataForInterface(Serializer, 'Serializer');
initMetadataForClass(JsonSerializer, 'JsonSerializer', JsonSerializer, VOID, [Serializer]);
initMetadataForCompanion(Companion_110);
initMetadataForClass(PreviouslySerializedIdComponent, 'PreviouslySerializedIdComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_111);
initMetadataForClass(SceneReloadingComponent, 'SceneReloadingComponent', SceneReloadingComponent, VOID, [Component]);
function addComponent(key, json) {
  // Inline function 'kotlin.collections.set' call
  var this_0 = ensureNotNull(this.i38());
  var value = Default_getInstance().z16(json);
  this_0.q2(key, value);
}
initMetadataForInterface(SerializableEntity, 'SerializableEntity');
initMetadataForCompanion(Companion_112);
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_113);
initMetadataForClass(SerializableConnection, 'SerializableConnection', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SerializableGuestConnectionsComponent, 'SerializableGuestConnectionsComponent', VOID, VOID, [SerializableComponent], VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_114);
initMetadataForClass(SerializableRootComponent, 'SerializableRootComponent', SerializableRootComponent, VOID, [SerializableComponent]);
initMetadataForCompanion(Companion_115);
initMetadataForClass(SerializableSceneComponent, 'SerializableSceneComponent', SerializableSceneComponent, VOID, [SerializableComponent]);
function entitiesArray() {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.n2k();
  return copyToArray(this_0);
}
initMetadataForInterface(SerializableTree, 'SerializableTree');
initMetadataForCompanion(Companion_116);
initMetadataForClass(UnserializableEntityComponent, 'UnserializableEntityComponent', UnserializableEntityComponent, VOID, [Component]);
initMetadataForCompanion(Companion_117);
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(VersionHeader, 'VersionHeader', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForCompanion(Companion_118);
initMetadataForClass(ShadowEntityWithParent, 'ShadowEntityWithParent');
initMetadataForClass(NewEntityWithShadowChildren, 'NewEntityWithShadowChildren');
initMetadataForClass(InterceptingAssemblyPartCatalog, 'InterceptingAssemblyPartCatalog', VOID, VOID, [ProductCatalog]);
initMetadataForCompanion(Companion_119);
initMetadataForClass(EntityTreeBuilder, 'EntityTreeBuilder');
initMetadataForCompanion(Companion_120);
initMetadataForClass(GroupInfoDuringDeserializingComponent, 'GroupInfoDuringDeserializingComponent', VOID, VOID, [Component]);
initMetadataForClass(ProductRefLevel, 'ProductRefLevel');
initMetadataForCompanion(Companion_121);
initMetadataForClass(EntityAndDO, 'EntityAndDO');
initMetadataForClass(EntityPartKey, 'EntityPartKey');
initMetadataForClass(SerializableEntityConverter, 'SerializableEntityConverter');
initMetadataForCompanion(Companion_122);
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SerializableEntityV13, 'SerializableEntityV13', SerializableEntityV13, VOID, [SerializableEntity], VOID, VOID, {0: $serializer_getInstance_13});
initMetadataForCompanion(Companion_123);
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SerializableTreeV13, 'SerializableTreeV13', VOID, VOID, [SerializableTree], VOID, VOID, {0: $serializer_getInstance_14});
initMetadataForCompanion(Companion_124);
initMetadataForClass(AxisAlignedBox, 'AxisAlignedBox');
initMetadataForCompanion(Companion_125);
function transform(transform) {
  return this.rotate(transform.rotation).move(transform.position);
}
initMetadataForInterface(Polyhedron, 'Polyhedron', VOID, VOID, [Raycastable]);
initMetadataForClass(ConvexPolyhedron, 'ConvexPolyhedron', VOID, VOID, [Polyhedron, Raycastable]);
initMetadataForCompanion(Companion_126);
initMetadataForClass(Cuboid, 'Cuboid', VOID, ConvexPolyhedron);
initMetadataForCompanion(Companion_127);
initMetadataForClass(Cylinder, 'Cylinder', VOID, ConvexPolyhedron);
initMetadataForClass(Face, 'Face');
initMetadataForClass(PolyhedronGroup, 'PolyhedronGroup', VOID, VOID, [Polyhedron, Raycastable]);
initMetadataForCompanion(Companion_128);
initMetadataForClass(PolyhedronUtils, 'PolyhedronUtils', PolyhedronUtils);
initMetadataForCompanion(Companion_129);
initMetadataForClass(MovedToCandidateSnapPositionComponent, 'MovedToCandidateSnapPositionComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_130);
initMetadataForClass(MovedToValidSnapPositionComponent, 'MovedToValidSnapPositionComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_131);
initMetadataForClass(RestrictAllowedRequiredHostsComponent, 'RestrictAllowedRequiredHostsComponent', VOID, VOID, [Component]);
initMetadataForClass(Snap, 'Snap');
initMetadataForCompanion(Companion_132);
initMetadataForClass(SnapActionCandidateSortAndSelectStrategies, 'SnapActionCandidateSortAndSelectStrategies', SnapActionCandidateSortAndSelectStrategies);
initMetadataForInterface(SnapActionCandidateSortAndSelectStrategy, 'SnapActionCandidateSortAndSelectStrategy');
initMetadataForClass(SelectAll, 'SelectAll', SelectAll, VOID, [SnapActionCandidateSortAndSelectStrategy]);
initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(SortByPriorityInActivationDistanceThenDistance, 'SortByPriorityInActivationDistanceThenDistance', SortByPriorityInActivationDistanceThenDistance, VOID, [SnapActionCandidateSortAndSelectStrategy]);
initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(SortByPriorityThenDistance, 'SortByPriorityThenDistance', SortByPriorityThenDistance, VOID, [SnapActionCandidateSortAndSelectStrategy]);
initMetadataForClass(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(SortByDistance, 'SortByDistance', SortByDistance, VOID, [SnapActionCandidateSortAndSelectStrategy]);
initMetadataForClass(sam$kotlin_Comparator$0_5, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_6, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_133);
initMetadataForClass(SnapActionInProgressComponent, 'SnapActionInProgressComponent', SnapActionInProgressComponent, VOID, [Component]);
initMetadataForCompanion(Companion_134);
initMetadataForClass(SnapCandidateComponent, 'SnapCandidateComponent', SnapCandidateComponent, VOID, [Component]);
initMetadataForCompanion(Companion_135);
initMetadataForClass(SnapPostProcessingUtil, 'SnapPostProcessingUtil', SnapPostProcessingUtil);
initMetadataForCompanion(Companion_136);
initMetadataForClass(SnapRootComponent, 'SnapRootComponent', SnapRootComponent, VOID, [Component]);
initMetadataForClass(SnapSettings, 'SnapSettings', SnapSettings);
initMetadataForClass(AlternativeSnap, 'AlternativeSnap');
initMetadataForCompanion(Companion_137);
initMetadataForClass(SnapUtils, 'SnapUtils', SnapUtils);
initMetadataForClass(EntityState, 'EntityState');
initMetadataForCompanion(Companion_138);
initMetadataForClass(IsLoadingSnapshotComponent, 'IsLoadingSnapshotComponent', IsLoadingSnapshotComponent, VOID, [Component]);
initMetadataForCompanion(Companion_139);
initMetadataForClass(SnapshotIgnoreComponent, 'SnapshotIgnoreComponent', SnapshotIgnoreComponent, VOID, [Component]);
initMetadataForCompanion(Companion_140);
initMetadataForClass(SnapshotService, 'SnapshotService');
initMetadataForInterface(Snapshot, 'Snapshot');
initMetadataForClass(SnapshotImpl, 'SnapshotImpl', VOID, VOID, [Snapshot]);
initMetadataForCompanion(Companion_141);
initMetadataForClass(UpdatedFromSnapshotEventComponent, 'UpdatedFromSnapshotEventComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_142);
initMetadataForClass(ApiSystemIds, 'ApiSystemIds', ApiSystemIds);
initMetadataForObject(AlwaysHangDownComponent_0, 'AlwaysHangDownComponent', VOID, VOID, [Component]);
initMetadataForCompanion(Companion_143);
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Serialized_0, 'Serialized', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
initMetadataForCompanion(Companion_144);
initMetadataForClass(LocalTransformComponent, 'LocalTransformComponent', VOID, VOID, [JsonSerializable, Component]);
initMetadataForCompanion(Companion_145);
initMetadataForClass(TransformSystem, 'TransformSystem', TransformSystem, SystemBase);
initMetadataForCompanion(Companion_146);
initMetadataForClass(TransformUtils, 'TransformUtils', TransformUtils);
initMetadataForCompanion(Companion_147);
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Serialized_1, 'Serialized', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
initMetadataForCompanion(Companion_148);
initMetadataForClass(WorldTransformComponent, 'WorldTransformComponent', VOID, VOID, [SerializableComponent]);
initMetadataForClass(Measurer, 'Measurer', Measurer);
initMetadataForObject(UrlHelper, 'UrlHelper');
initMetadataForClass(UrlDetails, 'UrlDetails');
initMetadataForCompanion(Companion_149);
initMetadataForClass(NoValidConnectorAvailableValidationResult, 'NoValidConnectorAvailableValidationResult', VOID, ValidationResult);
initMetadataForClass(SnapValidationResult, 'SnapValidationResult');
initMetadataForCompanion(Companion_150);
initMetadataForClass(UnknownErrorValidationResult, 'UnknownErrorValidationResult', VOID, ValidationResult);
initMetadataForCompanion(Companion_151);
initMetadataForClass(ValidSnapActionCandidateOrErrors, 'ValidSnapActionCandidateOrErrors');
initMetadataForClass(ValidationResultType, 'ValidationResultType', VOID, Enum);
initMetadataForCompanion(Companion_152);
initMetadataForClass(ValidationResultFail, 'ValidationResultFail', VOID, ValidationResult);
initMetadataForClass(ValidationResultWarning, 'ValidationResultWarning', VOID, ValidationResult);
initMetadataForCompanion(Companion_153);
function validateCurrentState(entity, earlyOut, $super) {
  earlyOut = earlyOut === VOID ? true : earlyOut;
  return this.w3h(entity, earlyOut);
}
function validateSnapCandidate(snap, earlyOut, $super) {
  earlyOut = earlyOut === VOID ? true : earlyOut;
  return this.x3h(snap, earlyOut);
}
function validateSnap(snap, earlyOut, $super) {
  earlyOut = earlyOut === VOID ? true : earlyOut;
  return this.y3h(snap, earlyOut);
}
function validateSnapCandidates(snaps, earlyOut, $super) {
  earlyOut = earlyOut === VOID ? true : earlyOut;
  return this.z3h(snaps, earlyOut);
}
function validateSnaps(snaps, earlyOut, $super) {
  earlyOut = earlyOut === VOID ? true : earlyOut;
  return this.a3i(snaps, earlyOut);
}
function getFirstValidSnap(snaps, sortByWarnings, $super) {
  sortByWarnings = sortByWarnings === VOID ? true : sortByWarnings;
  return this.b3i(snaps, sortByWarnings);
}
initMetadataForInterface(ValidationService, 'ValidationService');
initMetadataForClass(ValidationMeasurement, 'ValidationMeasurement');
initMetadataForClass(ValidationMeasurements, 'ValidationMeasurements');
initMetadataForClass(ValidationServiceMeasurer, 'ValidationServiceMeasurer', ValidationServiceMeasurer);
initMetadataForClass(ValidationMode, 'ValidationMode', VOID, Enum);
//endregion
function Core() {
}
function CoreFactory() {
}
function CoreModules() {
}
function CoreServices(coreModules, entityManager, sceneManager, componentDeserializerRegistry, deserializationInterceptorRegistry, validations, serializer, productManager, snapshotService, coreFactory) {
  this.coreModules = coreModules;
  this.entityManager = entityManager;
  this.sceneManager = sceneManager;
  this.componentDeserializerRegistry = componentDeserializerRegistry;
  this.deserializationInterceptorRegistry = deserializationInterceptorRegistry;
  this.validations = validations;
  this.serializer = serializer;
  this.productManager = productManager;
  this.snapshotService = snapshotService;
  this.coreFactory = coreFactory;
}
protoOf(CoreServices).b1k = function () {
  return this.coreModules;
};
protoOf(CoreServices).c1k = function () {
  return this.entityManager;
};
protoOf(CoreServices).d1k = function () {
  return this.sceneManager;
};
protoOf(CoreServices).e1k = function () {
  return this.componentDeserializerRegistry;
};
protoOf(CoreServices).f1k = function () {
  return this.deserializationInterceptorRegistry;
};
protoOf(CoreServices).g1k = function () {
  return this.validations;
};
protoOf(CoreServices).h1k = function () {
  return this.serializer;
};
protoOf(CoreServices).i1k = function () {
  return this.productManager;
};
protoOf(CoreServices).j1k = function () {
  return this.snapshotService;
};
protoOf(CoreServices).k1k = function () {
  return this.coreFactory;
};
protoOf(CoreServices).l1k = function () {
  return LoggerState_getInstance().o1k();
};
function connectPartToAssembly($this, entity) {
  Companion_instance.u1k($this.r1k_1, entity, $this.q1k_1);
}
function AddPartAction(newEntity, assemblyPart, parent, entityManager, validationService) {
  this.p1k_1 = newEntity;
  this.q1k_1 = assemblyPart;
  this.r1k_1 = parent;
  this.s1k_1 = entityManager;
  this.t1k_1 = new EntityReplaceHelper(this.p1k_1, null, this.r1k_1, validationService);
}
protoOf(AddPartAction).v1k = function () {
  this.t1k_1.s4();
};
protoOf(AddPartAction).f1l = function () {
  connectPartToAssembly(this, this.p1k_1);
};
protoOf(AddPartAction).toString = function () {
  return 'Add part action for new ' + this.p1k_1.toString();
};
function assembleChildren($this, parent, assemblyPart, partsMap, productManager, entityManager, partIds) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var usedHostConnections = LinkedHashSet_init_$Create$();
  var tmp0_safe_receiver = assemblyPart.children;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$1;
      $l$block_1: {
        // Inline function 'com.ikea.core.assemblies.Companion.assembleChildren.<anonymous>' call
        var tmp0_elvis_lhs = partsMap.f2(element.partKey);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = null;
          break $l$block_1;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var productRefForPart = tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(productRefForPart) === 0) {
          tmp$ret$1 = null;
          break $l$block_1;
        }
        var tmp2_safe_receiver = partIds == null ? null : partIds.parts;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.f2(element.partKey);
        var id = tmp3_elvis_lhs == null ? entityManager.getNextId() : tmp3_elvis_lhs;
        var tmp4_elvis_lhs = productManager.createEntityInternal(productRefForPart, VOID, id);
        var tmp_1;
        if (tmp4_elvis_lhs == null) {
          tmp$ret$1 = null;
          break $l$block_1;
        } else {
          tmp_1 = tmp4_elvis_lhs;
        }
        var childEntity = tmp_1;
        Companion_instance.g1l(parent, childEntity, element, usedHostConnections);
        if (element.children == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          assembleChildren(Companion_instance, childEntity, element, partsMap, productManager, entityManager, partIds);
        }
        tmp$ret$1 = childEntity;
      }
      var tmp0_safe_receiver_0 = tmp$ret$1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver_0);
      }
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp1_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.assemblies.Companion.assembleChildren.<anonymous>.<anonymous>' call
      Companion_instance_62.h1l(element_0, parent);
    }
  }
}
function findEntityInHierarchyThatHasConnector($this, childEntity, connectorKey) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = get_hierarchy(childEntity);
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.assemblies.Companion.findEntityInHierarchyThatHasConnector.<anonymous>' call
      var tmp0_safe_receiver = get_connectorsComponent(element);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable_0 = 0;
          var last_0 = tmp1_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp1_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.assemblies.Companion.findEntityInHierarchyThatHasConnector.<anonymous>.<anonymous>' call
            if (element_0.key === connectorKey) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
          tmp$ret$1 = false;
        }
        tmp = tmp$ret$1;
      }
      var tmp2_elvis_lhs = tmp;
      if (tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs) {
        tmp$ret$3 = element;
        break $l$block_0;
      }
    }
    tmp$ret$3 = null;
  }
  return tmp$ret$3;
}
function transferAnyParentConnectionToTheConnectionRoot($this, childEntity, parent) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.assemblies.Companion.transferAnyParentConnectionToTheConnectionRoot.<anonymous>' call
  var hostedConnections = childEntity.__getComponentForKotlin(Companion_getInstance_28().id);
  var tmp0_elvis_lhs = get_connectionRootEntity(parent);
  var parentRoot = tmp0_elvis_lhs == null ? parent : tmp0_elvis_lhs;
  var tmp2_safe_receiver = hostedConnections == null ? null : hostedConnections.connections;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp2_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp2_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.assemblies.Companion.transferAnyParentConnectionToTheConnectionRoot.<anonymous>.<anonymous>' call
      addHostedConnection(parentRoot, element);
    }
  }
  childEntity.removeComponent(Companion_getInstance_28().id);
}
function findClosestSnap($this, hostEntity, childEntity, assemblyPart, usedHostConnectors) {
  var settings = new SnapSettings(false, true, false, true);
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = Companion_instance_137.p1l(childEntity, hostEntity, settings);
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = AssemblyBuilder$Companion$findClosestSnap$lambda;
  var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
  var snaps = sortedWith(this_0, tmp$ret$0);
  var tmp0_safe_receiver = assemblyPart.snapInfo;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>' call
    var tmp_1;
    if (assemblyPart.snapInfo.useClosest) {
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = snaps.k();
        while (tmp0_iterator.m()) {
          var element = tmp0_iterator.n();
          // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>.<anonymous>' call
          if (!usedHostConnectors.s(element.hostConnector)) {
            tmp$ret$3 = element;
            break $l$block;
          }
        }
        tmp$ret$3 = null;
      }
      tmp_1 = tmp$ret$3;
    } else {
      var tmp$ret$5;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator_0 = snaps.k();
        while (tmp0_iterator_0.m()) {
          var element_0 = tmp0_iterator_0.n();
          // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>.<anonymous>' call
          if ((isBlank(tmp0_safe_receiver.connectorOnHost) || element_0.hostConnector.key === tmp0_safe_receiver.connectorOnHost) && (isBlank(tmp0_safe_receiver.connector) || element_0.guestConnector.key === tmp0_safe_receiver.connector)) {
            tmp$ret$5 = element_0;
            break $l$block_0;
          }
        }
        tmp$ret$5 = null;
      }
      tmp_1 = tmp$ret$5;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function partKeyToProductRefForEntity($this, entity) {
  var partKey = get_partKey(entity);
  var productRef = get_productRef(entity);
  var tmp;
  if (partKey == null || productRef == null) {
    tmp = null;
  } else {
    tmp = to(partKey, productRef);
  }
  return tmp;
}
function partKeyToEntityIdForEntity($this, entity) {
  var partKey = get_partKey(entity);
  var entityId = entity.id;
  var tmp;
  if (partKey == null) {
    tmp = null;
  } else {
    tmp = to(partKey, entityId);
  }
  return tmp;
}
function sam$kotlin_Comparator$0(function_0) {
  this.w1l_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).md = function (a, b) {
  return this.w1l_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0).s3 = function () {
  return this.w1l_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.s3());
};
function AssemblyBuilder$Companion$findClosestSnap$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>' call
  var tmp = a.movement.size;
  // Inline function 'com.ikea.core.assemblies.Companion.findClosestSnap.<anonymous>' call
  var tmp$ret$1 = b.movement.size;
  return compareValues(tmp, tmp$ret$1);
}
function Companion() {
}
protoOf(Companion).x1l = function (entity, assemblyPart, partsMap, productManager, entityManager, partIds) {
  assembleChildren(this, entity, assemblyPart, partsMap, productManager, entityManager, partIds);
  Companion_instance_37.y1l(entity);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_descendants(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.assemblies.Companion.buildAssembly.<anonymous>' call
    productManager.notifyCreatedListeners(element);
  }
};
protoOf(Companion).g1l = function (parent, childEntity, childPart, usedHostConnections) {
  if (!childEntity.hasComponent(Companion_getInstance_149().id)) {
    Companion_instance_146.z1l(childEntity, get_worldTransform(parent));
  }
  setParentMaintainWorldTransform(childEntity, parent);
  var tmp0_safe_receiver = childPart.relativeTransform;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    Companion_instance_146.b1m(childEntity, tmp0_safe_receiver);
  }
  var tmp;
  if (!(childPart.snapInfo == null)) {
    var shouldSearchForSnap = childPart.snapInfo.useClosest || isBlank(childPart.snapInfo.connector) || isBlank(childPart.snapInfo.connectorOnHost);
    var hadSnapRootComponent = childEntity.hasComponent(Companion_getInstance_137().id);
    childEntity.addComponentInternal(new SnapRootComponent());
    var tmp_0;
    if (shouldSearchForSnap) {
      tmp_0 = findClosestSnap(this, parent, childEntity, childPart, toList(usedHostConnections));
    } else {
      var host = findEntityInHierarchyThatHasConnector(this, parent, childPart.snapInfo.connectorOnHost);
      var guest = findEntityInHierarchyThatHasConnector(this, childEntity, childPart.snapInfo.connector);
      var tmp_1 = Companion_instance_137;
      var tmp_2 = host == null ? parent : host;
      tmp_0 = tmp_1.c1m(tmp_2, guest == null ? childEntity : guest, childPart.snapInfo.connectorOnHost, childPart.snapInfo.connector);
    }
    var snap = tmp_0;
    if (!hadSnapRootComponent) {
      childEntity.removeComponentInternal(Companion_getInstance_137().id);
    }
    tmp = snap;
  } else {
    tmp = null;
  }
  var snap_0 = tmp;
  if (snap_0 == null || childPart.locked) {
    childEntity.removeComponent(Companion_getInstance_45().id);
    childEntity.removeComponent(Companion_getInstance_107().id);
    childEntity.addComponent(new ProductPartComponent(childPart.partKey));
    childEntity.removeComponent(Companion_getInstance_25().id);
    childEntity.removeComponent(Companion_getInstance_137().id);
    transferAnyParentConnectionToTheConnectionRoot(this, childEntity, parent);
  } else {
    var connectorsDeltaTransform = snap_0.hostConnector.getDeltaTransformToGuestConnectorEntity(parent, childEntity, snap_0.guestConnector);
    var connection = fromConnectors(childEntity, snap_0.guestConnector, parent, snap_0.hostConnector, connectorsDeltaTransform);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = [connection];
    childEntity.addComponent(new GuestConnectionsComponent(tmp$ret$4));
  }
  setParentMaintainWorldTransform(childEntity, parent);
  if (snap_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    usedHostConnections.h(snap_0.hostConnector);
    snap_0.doInitialAssemblySnap();
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = childPart.additionalComponents;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.assemblies.Companion.connectChildPart.<anonymous>' call
    childEntity.addComponent(element);
  }
  return childEntity;
};
protoOf(Companion).u1k = function (parent, childEntity, childPart, usedHostConnections, $super) {
  var tmp;
  if (usedHostConnections === VOID) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp = LinkedHashSet_init_$Create$();
  } else {
    tmp = usedHostConnections;
  }
  usedHostConnections = tmp;
  return $super === VOID ? this.g1l(parent, childEntity, childPart, usedHostConnections) : $super.g1l.call(this, parent, childEntity, childPart, usedHostConnections);
};
protoOf(Companion).d1m = function (entity, includeSubAssemblies) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(entity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.assemblies.Companion.partsMapForEntity.<anonymous>' call
    if (get_isProductPart(element)) {
      destination.h(element);
    }
  }
  var childParts = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = childParts.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.assemblies.Companion.partsMapForEntity.<anonymous>' call
    var tmp0_safe_receiver = partKeyToProductRefForEntity(Companion_instance, element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_0.h(tmp0_safe_receiver);
    }
  }
  var partsMap = toMutableMap(toMap(destination_0));
  // Inline function 'kotlin.collections.fold' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = childParts.k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.assemblies.Companion.partsMapForEntity.<anonymous>' call
    if (includeSubAssemblies || !element_1.hasComponent(Companion_getInstance_3().id)) {
      destination_1.h(element_1);
    }
  }
  var accumulator = partsMap;
  var tmp0_iterator_1 = destination_1.k();
  while (tmp0_iterator_1.m()) {
    var element_2 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.assemblies.Companion.partsMapForEntity.<anonymous>' call
    var total = accumulator;
    var childrenPartsMap = Companion_instance.d1m(element_2, includeSubAssemblies);
    total.s2(childrenPartsMap);
    accumulator = total;
  }
  return partsMap;
};
protoOf(Companion).e1m = function (entity, includeSubAssemblies) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(entity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.assemblies.Companion.partIdsMapForEntity.<anonymous>' call
    if (get_isProductPart(element)) {
      destination.h(element);
    }
  }
  var childParts = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = childParts.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.assemblies.Companion.partIdsMapForEntity.<anonymous>' call
    var tmp0_safe_receiver = partKeyToEntityIdForEntity(Companion_instance, element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_0.h(tmp0_safe_receiver);
    }
  }
  var idsMap = toMutableMap(toMap(destination_0));
  // Inline function 'kotlin.collections.fold' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = childParts.k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.assemblies.Companion.partIdsMapForEntity.<anonymous>' call
    if (includeSubAssemblies || !element_1.hasComponent(Companion_getInstance_3().id)) {
      destination_1.h(element_1);
    }
  }
  var accumulator = idsMap;
  var tmp0_iterator_1 = destination_1.k();
  while (tmp0_iterator_1.m()) {
    var element_2 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.assemblies.Companion.partIdsMapForEntity.<anonymous>' call
    var total = accumulator;
    var childrenIdsMap = Companion_instance.e1m(element_2, includeSubAssemblies);
    total.s2(childrenIdsMap);
    accumulator = total;
  }
  return idsMap;
};
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function AssemblyPart(partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents) {
  relativeTransform = relativeTransform === VOID ? null : relativeTransform;
  snapInfo = snapInfo === VOID ? null : snapInfo;
  children = children === VOID ? null : children;
  locked = locked === VOID ? true : locked;
  variant = variant === VOID ? null : variant;
  var tmp;
  if (additionalComponents === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = additionalComponents;
  }
  additionalComponents = tmp;
  this.partKey = partKey;
  this.relativeTransform = relativeTransform;
  this.snapInfo = snapInfo;
  this.children = children;
  this.locked = locked;
  this.variant = variant;
  this.additionalComponents = additionalComponents;
}
protoOf(AssemblyPart).f1m = function () {
  return this.partKey;
};
protoOf(AssemblyPart).g1m = function () {
  return this.relativeTransform;
};
protoOf(AssemblyPart).h1m = function () {
  return this.snapInfo;
};
protoOf(AssemblyPart).i1m = function () {
  return this.children;
};
protoOf(AssemblyPart).j1m = function () {
  return this.locked;
};
protoOf(AssemblyPart).k1m = function () {
  return this.variant;
};
protoOf(AssemblyPart).l1m = function () {
  return this.additionalComponents;
};
protoOf(AssemblyPart).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof AssemblyPart))
    THROW_CCE();
  if (!(this.partKey === other.partKey))
    return false;
  return true;
};
protoOf(AssemblyPart).hashCode = function () {
  return getStringHashCode(this.partKey);
};
protoOf(AssemblyPart).tf = function () {
  return this.partKey;
};
protoOf(AssemblyPart).uf = function () {
  return this.relativeTransform;
};
protoOf(AssemblyPart).m1m = function () {
  return this.snapInfo;
};
protoOf(AssemblyPart).n1m = function () {
  return this.children;
};
protoOf(AssemblyPart).o1m = function () {
  return this.locked;
};
protoOf(AssemblyPart).p1m = function () {
  return this.variant;
};
protoOf(AssemblyPart).q1m = function () {
  return this.additionalComponents;
};
protoOf(AssemblyPart).r1m = function (partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents) {
  return new AssemblyPart(partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents);
};
protoOf(AssemblyPart).copy = function (partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents, $super) {
  partKey = partKey === VOID ? this.partKey : partKey;
  relativeTransform = relativeTransform === VOID ? this.relativeTransform : relativeTransform;
  snapInfo = snapInfo === VOID ? this.snapInfo : snapInfo;
  children = children === VOID ? this.children : children;
  locked = locked === VOID ? this.locked : locked;
  variant = variant === VOID ? this.variant : variant;
  additionalComponents = additionalComponents === VOID ? this.additionalComponents : additionalComponents;
  return this.r1m(partKey, relativeTransform, snapInfo, children, locked, variant, additionalComponents);
};
protoOf(AssemblyPart).toString = function () {
  return 'AssemblyPart(partKey=' + this.partKey + ', relativeTransform=' + toString(this.relativeTransform) + ', snapInfo=' + toString(this.snapInfo) + ', children=' + toString_0(this.children) + ', locked=' + this.locked + ', variant=' + this.variant + ', additionalComponents=' + toString_0(this.additionalComponents) + ')';
};
function AssemblyPartSnapInfo(connectorOnHost, connector, useClosest) {
  connectorOnHost = connectorOnHost === VOID ? '' : connectorOnHost;
  connector = connector === VOID ? '' : connector;
  useClosest = useClosest === VOID ? false : useClosest;
  this.connectorOnHost = connectorOnHost;
  this.connector = connector;
  this.useClosest = useClosest;
}
protoOf(AssemblyPartSnapInfo).s1m = function () {
  return this.connectorOnHost;
};
protoOf(AssemblyPartSnapInfo).t1m = function () {
  return this.connector;
};
protoOf(AssemblyPartSnapInfo).u1m = function () {
  return this.useClosest;
};
protoOf(AssemblyPartSnapInfo).tf = function () {
  return this.connectorOnHost;
};
protoOf(AssemblyPartSnapInfo).uf = function () {
  return this.connector;
};
protoOf(AssemblyPartSnapInfo).m1m = function () {
  return this.useClosest;
};
protoOf(AssemblyPartSnapInfo).v1m = function (connectorOnHost, connector, useClosest) {
  return new AssemblyPartSnapInfo(connectorOnHost, connector, useClosest);
};
protoOf(AssemblyPartSnapInfo).copy = function (connectorOnHost, connector, useClosest, $super) {
  connectorOnHost = connectorOnHost === VOID ? this.connectorOnHost : connectorOnHost;
  connector = connector === VOID ? this.connector : connector;
  useClosest = useClosest === VOID ? this.useClosest : useClosest;
  return this.v1m(connectorOnHost, connector, useClosest);
};
protoOf(AssemblyPartSnapInfo).toString = function () {
  return 'AssemblyPartSnapInfo(connectorOnHost=' + this.connectorOnHost + ', connector=' + this.connector + ', useClosest=' + this.useClosest + ')';
};
protoOf(AssemblyPartSnapInfo).hashCode = function () {
  var result = getStringHashCode(this.connectorOnHost);
  result = imul(result, 31) + getStringHashCode(this.connector) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.useClosest) | 0;
  return result;
};
protoOf(AssemblyPartSnapInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AssemblyPartSnapInfo))
    return false;
  var tmp0_other_with_cast = other instanceof AssemblyPartSnapInfo ? other : THROW_CCE();
  if (!(this.connectorOnHost === tmp0_other_with_cast.connectorOnHost))
    return false;
  if (!(this.connector === tmp0_other_with_cast.connector))
    return false;
  if (!(this.useClosest === tmp0_other_with_cast.useClosest))
    return false;
  return true;
};
function Companion_0() {
  Companion_instance_0 = this;
  this.id = Companion_instance_21.n1q_1;
}
protoOf(Companion_0).n1s = function () {
  return this.id;
};
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 == null)
    new Companion_0();
  return Companion_instance_0;
}
function AssemblyPartIdsComponent$toString$lambda(it) {
  return it.b2() + ':' + it.c2();
}
function AssemblyPartIdsComponent(parts) {
  Companion_getInstance_1();
  this.parts = parts;
}
protoOf(AssemblyPartIdsComponent).o1s = function () {
  return this.parts;
};
protoOf(AssemblyPartIdsComponent).p1s = function () {
  return Companion_getInstance_1().id;
};
protoOf(AssemblyPartIdsComponent).eq = function (other) {
  return false;
};
protoOf(AssemblyPartIdsComponent).toString = function () {
  var tmp = this.parts.i2();
  return 'AssemblyPartsIdsComponent(' + joinToString(tmp, VOID, VOID, VOID, VOID, VOID, AssemblyPartIdsComponent$toString$lambda) + ')';
};
protoOf(AssemblyPartIdsComponent).tf = function () {
  return this.parts;
};
protoOf(AssemblyPartIdsComponent).q1s = function (parts) {
  return new AssemblyPartIdsComponent(parts);
};
protoOf(AssemblyPartIdsComponent).copy = function (parts, $super) {
  parts = parts === VOID ? this.parts : parts;
  return this.q1s(parts);
};
protoOf(AssemblyPartIdsComponent).hashCode = function () {
  return hashCode(this.parts);
};
protoOf(AssemblyPartIdsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AssemblyPartIdsComponent))
    return false;
  var tmp0_other_with_cast = other instanceof AssemblyPartIdsComponent ? other : THROW_CCE();
  if (!equals(this.parts, tmp0_other_with_cast.parts))
    return false;
  return true;
};
function AssemblyPartsComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function AssemblyPartsComponent_init_$Init$(partPairs, $this) {
  AssemblyPartsComponent.call($this);
  var tmp = $this;
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(partPairs.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var inductionVariable = 0;
  var last = partPairs.length;
  while (inductionVariable < last) {
    var element = partPairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'com.ikea.core.assemblies.AssemblyPartsComponent.<init>.<anonymous>' call
    var pair = to(element.partKey, element.productRef);
    destination.q2(pair.rf_1, pair.sf_1);
  }
  tmp.t1s_1 = destination;
  return $this;
}
function fromPartPairs(partPairs) {
  return AssemblyPartsComponent_init_$Init$(partPairs, objectCreate(protoOf(AssemblyPartsComponent)));
}
function AssemblyPartsComponent_init_$Init$_0(parts, $this) {
  AssemblyPartsComponent.call($this);
  $this.t1s_1 = parts;
  return $this;
}
function AssemblyPartsComponent_init_$Create$(parts) {
  return AssemblyPartsComponent_init_$Init$_0(parts, objectCreate(protoOf(AssemblyPartsComponent)));
}
function Companion_1() {
  Companion_instance_1 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.u1s_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
  this.id = Companion_instance_21.m1o_1;
  this.serializationKey = 'AssemblyPartsComponent';
  var tmp_0 = this;
  tmp_0.v1s_1 = Json(VOID, AssemblyPartsComponent$Companion$serializer$lambda);
}
protoOf(Companion_1).n1s = function () {
  return this.id;
};
protoOf(Companion_1).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_1).x1s = function (json) {
  return this.v1s_1.y16(this.z18(), json);
};
protoOf(Companion_1).z18 = function () {
  return $serializer_getInstance();
};
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 == null)
    new Companion_1();
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.assemblies.AssemblyPartsComponent', this, 1);
  tmp0_serialDesc.lw('parts', false);
  this.y1s_1 = tmp0_serialDesc;
}
protoOf($serializer).z1s = function (encoder, value) {
  var tmp0_desc = this.y1s_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_2().u1s_1;
  tmp1_output.sq(tmp0_desc, 0, tmp2_cached[0], value.t1s_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer).ul = function (encoder, value) {
  return this.z1s(encoder, value instanceof AssemblyPartsComponent ? value : THROW_CCE());
};
protoOf($serializer).vl = function (decoder) {
  var tmp0_desc = this.y1s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  var tmp6_cached = Companion_getInstance_2().u1s_1;
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.np(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.np(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return AssemblyPartsComponent_init_$Create$_0(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).tl = function () {
  return this.y1s_1;
};
protoOf($serializer).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_2().u1s_1[0]];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function AssemblyPartsComponent_init_$Init$_1(seen0, parts, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().y1s_1);
  }
  $this.t1s_1 = parts;
  $this.t1s_1 = emptyMap();
  return $this;
}
function AssemblyPartsComponent_init_$Create$_0(seen0, parts, serializationConstructorMarker) {
  return AssemblyPartsComponent_init_$Init$_1(seen0, parts, serializationConstructorMarker, objectCreate(protoOf(AssemblyPartsComponent)));
}
function AssemblyPartsComponent$toString$lambda(it) {
  return it.b2() + ':' + it.c2();
}
function AssemblyPartsComponent() {
  Companion_getInstance_2();
  this.t1s_1 = emptyMap();
}
protoOf(AssemblyPartsComponent).a1t = function (_set____db54di) {
  this.t1s_1 = _set____db54di;
};
protoOf(AssemblyPartsComponent).o1s = function () {
  return this.t1s_1;
};
protoOf(AssemblyPartsComponent).p1s = function () {
  return Companion_getInstance_2().id;
};
protoOf(AssemblyPartsComponent).eq = function (other) {
  return false;
};
protoOf(AssemblyPartsComponent).toString = function () {
  var tmp = this.t1s_1.i2();
  return 'AssemblyPartsComponent(' + joinToString(tmp, VOID, VOID, VOID, VOID, VOID, AssemblyPartsComponent$toString$lambda) + ')';
};
protoOf(AssemblyPartsComponent).asArray = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.t1s_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.assemblies.AssemblyPartsComponent.asArray.<anonymous>' call
    var tmp$ret$1 = new PartPair(item.b2(), item.c2());
    destination.h(tmp$ret$1);
  }
  return copyToArray(destination);
};
function Companion_2() {
  Companion_instance_2 = this;
  this.id = Companion_instance_21.i1n_1;
}
protoOf(Companion_2).n1s = function () {
  return this.id;
};
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 == null)
    new Companion_2();
  return Companion_instance_2;
}
function toString$withChildren(ap) {
  var tmp = ensureNotNull(ap.children);
  return ap.partKey + '(' + joinToString_0(tmp, VOID, VOID, VOID, VOID, VOID, AssemblyStructureComponent$toString$withChildren$lambda) + ')';
}
function toString$noChildren(ap) {
  return ap.partKey + ':0';
}
function AssemblyStructureComponent$toString$lambda(ap) {
  var tmp;
  if (!(ap.children == null)) {
    tmp = toString$withChildren(ap);
  } else {
    tmp = toString$noChildren(ap);
  }
  return tmp;
}
function AssemblyStructureComponent$toString$withChildren$lambda(it) {
  return it.partKey;
}
function AssemblyStructureComponent(parts) {
  Companion_getInstance_3();
  this.parts = parts;
}
protoOf(AssemblyStructureComponent).o1s = function () {
  return this.parts;
};
protoOf(AssemblyStructureComponent).p1s = function () {
  return Companion_getInstance_3().id;
};
protoOf(AssemblyStructureComponent).eq = function (other) {
  return false;
};
protoOf(AssemblyStructureComponent).toString = function () {
  var partsStr = joinToString_0(this.parts, VOID, VOID, VOID, VOID, VOID, AssemblyStructureComponent$toString$lambda);
  return 'AssemblyStructureComponent(' + partsStr + ')';
};
function get_isAssembly(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_getInstance_3().id);
}
function PartPair(partKey, productRef) {
  this.partKey = partKey;
  this.productRef = productRef;
}
protoOf(PartPair).f1m = function () {
  return this.partKey;
};
protoOf(PartPair).b1t = function () {
  return this.productRef;
};
protoOf(PartPair).tf = function () {
  return this.partKey;
};
protoOf(PartPair).uf = function () {
  return this.productRef;
};
protoOf(PartPair).c1t = function (partKey, productRef) {
  return new PartPair(partKey, productRef);
};
protoOf(PartPair).copy = function (partKey, productRef, $super) {
  partKey = partKey === VOID ? this.partKey : partKey;
  productRef = productRef === VOID ? this.productRef : productRef;
  return this.c1t(partKey, productRef);
};
protoOf(PartPair).toString = function () {
  return 'PartPair(partKey=' + this.partKey + ', productRef=' + this.productRef + ')';
};
protoOf(PartPair).hashCode = function () {
  var result = getStringHashCode(this.partKey);
  result = imul(result, 31) + getStringHashCode(this.productRef) | 0;
  return result;
};
protoOf(PartPair).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PartPair))
    return false;
  var tmp0_other_with_cast = other instanceof PartPair ? other : THROW_CCE();
  if (!(this.partKey === tmp0_other_with_cast.partKey))
    return false;
  if (!(this.productRef === tmp0_other_with_cast.productRef))
    return false;
  return true;
};
function ProductPartComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_3() {
}
protoOf(Companion_3).z18 = function () {
  return $serializer_getInstance_0();
};
var Companion_instance_3;
function Companion_getInstance_4() {
  return Companion_instance_3;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.assemblies.ProductPartComponent.Serialized', this, 1);
  tmp0_serialDesc.lw('partKey', false);
  this.d1t_1 = tmp0_serialDesc;
}
protoOf($serializer_0).e1t = function (encoder, value) {
  var tmp0_desc = this.d1t_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.f1t_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_0).ul = function (encoder, value) {
  return this.e1t(encoder, value instanceof Serialized ? value : THROW_CCE());
};
protoOf($serializer_0).vl = function (decoder) {
  var tmp0_desc = this.d1t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return Serialized_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_0).tl = function () {
  return this.d1t_1;
};
protoOf($serializer_0).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function Serialized_init_$Init$(seen0, partKey, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_0().d1t_1);
  }
  $this.f1t_1 = partKey;
  return $this;
}
function Serialized_init_$Create$(seen0, partKey, serializationConstructorMarker) {
  return Serialized_init_$Init$(seen0, partKey, serializationConstructorMarker, objectCreate(protoOf(Serialized)));
}
function Companion_4() {
  Companion_instance_4 = this;
  this.id = Companion_instance_21.n1o_1;
  this.serializationKey = 'ProductPartComponent';
  var tmp = this;
  tmp.g1t_1 = Json(VOID, ProductPartComponent$Companion$serializer$lambda);
}
protoOf(Companion_4).n1s = function () {
  return this.id;
};
protoOf(Companion_4).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_4).fromJson = function (json) {
  var result = this.g1t_1.y16(Companion_instance_3.z18(), json);
  return new ProductPartComponent(result.f1t_1);
};
var Companion_instance_4;
function Companion_getInstance_5() {
  if (Companion_instance_4 == null)
    new Companion_4();
  return Companion_instance_4;
}
function Serialized(partKey) {
  this.f1t_1 = partKey;
}
function ProductPartComponent(partKey) {
  Companion_getInstance_5();
  this.partKey = partKey;
}
protoOf(ProductPartComponent).f1m = function () {
  return this.partKey;
};
protoOf(ProductPartComponent).toJson = function (parse) {
  return Companion_getInstance_5().g1t_1.x16(Companion_instance_3.z18(), new Serialized(this.partKey));
};
protoOf(ProductPartComponent).eq = function (other) {
  return (other instanceof ProductPartComponent ? other : THROW_CCE()).partKey === this.partKey;
};
protoOf(ProductPartComponent).serializationKey = function () {
  return Companion_getInstance_5().serializationKey;
};
protoOf(ProductPartComponent).p1s = function () {
  return Companion_getInstance_5().id;
};
protoOf(ProductPartComponent).tf = function () {
  return this.partKey;
};
protoOf(ProductPartComponent).h1t = function (partKey) {
  return new ProductPartComponent(partKey);
};
protoOf(ProductPartComponent).copy = function (partKey, $super) {
  partKey = partKey === VOID ? this.partKey : partKey;
  return this.h1t(partKey);
};
protoOf(ProductPartComponent).toString = function () {
  return 'ProductPartComponent(partKey=' + this.partKey + ')';
};
protoOf(ProductPartComponent).hashCode = function () {
  return getStringHashCode(this.partKey);
};
protoOf(ProductPartComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProductPartComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ProductPartComponent ? other : THROW_CCE();
  if (!(this.partKey === tmp0_other_with_cast.partKey))
    return false;
  return true;
};
function get_partKey(_this__u8e3s4) {
  var tmp0_safe_receiver = get_productPart(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.partKey;
}
function get_isProductPart(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_getInstance_5().id);
}
function get_productPart(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_5().id);
}
function connectPartToAssembly_0($this, entity) {
  Companion_instance.u1k($this.k1t_1, entity, $this.j1t_1);
}
function RemovePartAction(oldEntity, assemblyPart, parent, entityManager, validationService) {
  this.i1t_1 = oldEntity;
  this.j1t_1 = assemblyPart;
  this.k1t_1 = parent;
  this.l1t_1 = entityManager;
  this.m1t_1 = validationService;
  this.n1t_1 = Companion_instance_102.q1t(this.i1t_1, null, this.m1t_1);
  var tmp = this;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_immediateConnectionRootDescendants(this.i1t_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.assemblies.RemovePartAction.descendantEntityHelpers.<anonymous>' call
    var tmp$ret$0 = EntityReplaceHelper_init_$Create$(item, null, this.m1t_1, 1.7976931348623157E308);
    destination.h(tmp$ret$0);
  }
  tmp.o1t_1 = destination;
  this.p1t_1 = EntityReplaceHelper_init_$Create$(this.i1t_1, null, this.m1t_1);
}
protoOf(RemovePartAction).v1k = function () {
  connectPartToAssembly_0(this, this.i1t_1);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.o1t_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.assemblies.RemovePartAction.rollback.<anonymous>' call
    element.r1t();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = this.n1t_1.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.assemblies.RemovePartAction.rollback.<anonymous>' call
    element_0.r1t();
  }
};
protoOf(RemovePartAction).f1l = function () {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.n1t_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.assemblies.RemovePartAction.perform.<anonymous>' call
    element.s4();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = this.o1t_1.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.assemblies.RemovePartAction.perform.<anonymous>' call
    element_0.s4();
  }
  this.p1t_1.s4();
};
protoOf(RemovePartAction).toString = function () {
  return 'Remove part Action old ' + this.i1t_1.toString();
};
function Companion_5() {
  Companion_instance_5 = this;
  this.id = Companion_instance_21.a1s_1;
}
protoOf(Companion_5).n1s = function () {
  return this.id;
};
var Companion_instance_5;
function Companion_getInstance_6() {
  if (Companion_instance_5 == null)
    new Companion_5();
  return Companion_instance_5;
}
function CatalogSizeComponent(size) {
  Companion_getInstance_6();
  this.size = size;
}
protoOf(CatalogSizeComponent).o = function () {
  return this.size;
};
protoOf(CatalogSizeComponent).p1s = function () {
  return Companion_getInstance_6().id;
};
protoOf(CatalogSizeComponent).eq = function (other) {
  return (other instanceof CatalogSizeComponent ? other : THROW_CCE()).size.equals(this.size);
};
function ProductCatalog() {
}
function Companion_6() {
}
protoOf(Companion_6).u1t = function (assembly) {
  var partsMap = Companion_instance.d1m(assembly, false);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(partsMap.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = partsMap.i2().k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.catalog.Companion.getPartsMap.<anonymous>' call
    var tmp$ret$1 = new PartPair(item.b2(), item.c2());
    destination.h(tmp$ret$1);
  }
  return copyToArray(destination);
};
protoOf(Companion_6).v1t = function (entity, parts) {
  return AssemblyPartsComponent_init_$Create$(generatePartHierarchy(entity, parts));
};
protoOf(Companion_6).createAssemblyPartsComponent$default = function (entity, parts, $super) {
  parts = parts === VOID ? null : parts;
  return $super === VOID ? this.v1t(entity, parts) : $super.v1t.call(this, entity, parts);
};
protoOf(Companion_6).w1t = function (entity, parts, includeUnused) {
  var tmp;
  if (includeUnused) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = generatePartHierarchyFromStructure(entity, parts);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.i2().k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.core.catalog.Companion.createAssemblyParts.<anonymous>' call
      var tmp$ret$1 = new PartPair(item.b2(), item.c2());
      destination.h(tmp$ret$1);
    }
    tmp = copyToArray(destination);
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = generatePartHierarchy(entity, parts);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(this_1.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = this_1.i2().k();
    while (tmp0_iterator_0.m()) {
      var item_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.catalog.Companion.createAssemblyParts.<anonymous>' call
      var tmp$ret$6 = new PartPair(item_0.b2(), item_0.c2());
      destination_0.h(tmp$ret$6);
    }
    tmp = copyToArray(destination_0);
  }
  return tmp;
};
protoOf(Companion_6).createAssemblyParts$default = function (entity, parts, includeUnused, $super) {
  parts = parts === VOID ? null : parts;
  includeUnused = includeUnused === VOID ? false : includeUnused;
  return $super === VOID ? this.w1t(entity, parts, includeUnused) : $super.w1t.call(this, entity, parts, includeUnused);
};
var Companion_instance_6;
function Companion_getInstance_7() {
  return Companion_instance_6;
}
function getPartsMap(assembly) {
  return Companion_instance_6.u1t(assembly);
}
function createAssemblyPartsComponent(entity, parts) {
  return Companion_instance_6.v1t(entity, parts);
}
function createAssemblyPartsComponent_0(entity, parts, $super) {
  parts = parts === VOID ? null : parts;
  return createAssemblyPartsComponent(entity, parts);
}
function createAssemblyParts(entity, parts, includeUnused) {
  return Companion_instance_6.w1t(entity, parts, includeUnused);
}
function createAssemblyParts_0(entity, parts, includeUnused, $super) {
  parts = parts === VOID ? null : parts;
  includeUnused = includeUnused === VOID ? false : includeUnused;
  return createAssemblyParts(entity, parts, includeUnused);
}
function ProductCatalogFunctions() {
}
function generatePartHierarchy(entity, parts) {
  parts = parts === VOID ? null : parts;
  var tmp;
  if (parts == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(parts.length), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var inductionVariable = 0;
    var last = parts.length;
    while (inductionVariable < last) {
      var element = parts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'com.ikea.core.catalog.generatePartHierarchy.<anonymous>' call
      var pair = to(element.partKey, element.productRef);
      destination.q2(pair.rf_1, pair.sf_1);
    }
    tmp = destination;
  }
  var tmp1_elvis_lhs = tmp;
  var newPartsMap = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.associate' call
  var this_0 = Companion_instance_6.u1t(entity);
  var capacity_0 = coerceAtLeast(mapCapacity(this_0.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
  var inductionVariable_0 = 0;
  var last_0 = this_0.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = this_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'com.ikea.core.catalog.generatePartHierarchy.<anonymous>' call
    var pair_0 = to(element_0.partKey, element_0.productRef);
    destination_0.q2(pair_0.rf_1, pair_0.sf_1);
  }
  var oldPartsMap = destination_0;
  return plus(oldPartsMap, newPartsMap);
}
function generatePartHierarchyFromStructure(entity, parts) {
  parts = parts === VOID ? null : parts;
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_3().id);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.catalog.generatePartHierarchyFromStructure.<anonymous>' call
    tmp = generatePartHierarchyFromStructure$_anonymous_$traverse_4layzz(tmp0_safe_receiver.parts);
  }
  var tmp1_elvis_lhs = tmp;
  var allPartKeys = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  var partsMap = Companion_instance.d1m(entity, false);
  // Inline function 'kotlin.collections.associateWith' call
  var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(allPartKeys, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var tmp0_iterator = allPartKeys.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.catalog.generatePartHierarchyFromStructure.<anonymous>' call
    var tmp_0;
    if (parts == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = parts.length;
        while (inductionVariable < last) {
          var element_0 = parts[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.catalog.generatePartHierarchyFromStructure.<anonymous>.<anonymous>' call
          if (element_0.partKey === element) {
            tmp$ret$3 = element_0;
            break $l$block;
          }
        }
        tmp$ret$3 = null;
      }
      tmp_0 = tmp$ret$3;
    }
    var tmp1_safe_receiver = tmp_0;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.productRef;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? partsMap.f2(element) : tmp2_elvis_lhs;
    var ref = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    result.q2(element, ref);
  }
  return result;
}
function generatePartHierarchyFromStructure$_anonymous_$traverse_4layzz(parts) {
  var tmp;
  if (parts == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = parts.length;
    while (inductionVariable < last) {
      var element = parts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.catalog.generatePartHierarchyFromStructure.<anonymous>$traverse.<anonymous>' call
      var list = plus_0(listOf(element.partKey), generatePartHierarchyFromStructure$_anonymous_$traverse_4layzz(element.children));
      addAll(destination, list);
    }
    tmp = destination;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function Companion_7() {
  Companion_instance_7 = this;
  this.id = Companion_instance_21.o1n_1;
}
protoOf(Companion_7).n1s = function () {
  return this.id;
};
var Companion_instance_7;
function Companion_getInstance_8() {
  if (Companion_instance_7 == null)
    new Companion_7();
  return Companion_instance_7;
}
function ProductComponent(productRef) {
  Companion_getInstance_8();
  this.productRef = productRef;
}
protoOf(ProductComponent).b1t = function () {
  return this.productRef;
};
protoOf(ProductComponent).p1s = function () {
  return Companion_getInstance_8().id;
};
protoOf(ProductComponent).eq = function (other) {
  return (other instanceof ProductComponent ? other : THROW_CCE()).productRef === this.productRef;
};
protoOf(ProductComponent).equals = function (other) {
  var tmp;
  if (other instanceof ProductComponent) {
    tmp = other.productRef === this.productRef;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ProductComponent).hashCode = function () {
  return getStringHashCode(this.productRef);
};
protoOf(ProductComponent).tf = function () {
  return this.productRef;
};
protoOf(ProductComponent).h1t = function (productRef) {
  return new ProductComponent(productRef);
};
protoOf(ProductComponent).copy = function (productRef, $super) {
  productRef = productRef === VOID ? this.productRef : productRef;
  return this.h1t(productRef);
};
protoOf(ProductComponent).toString = function () {
  return 'ProductComponent(productRef=' + this.productRef + ')';
};
function get_productRefOrEmptyString(_this__u8e3s4) {
  var tmp0_elvis_lhs = get_productRef(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function get_productRef(_this__u8e3s4) {
  var tmp0_safe_receiver = get_productComponent(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.productRef;
}
function get_productComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_8().id);
}
function ProductManager() {
}
function Companion_8() {
}
protoOf(Companion_8).z18 = function () {
  return $serializer_getInstance_1();
};
var Companion_instance_8;
function Companion_getInstance_9() {
  return Companion_instance_8;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.catalog.ProductParams', this, 1);
  tmp0_serialDesc.lw('size', false);
  this.c1u_1 = tmp0_serialDesc;
}
protoOf($serializer_1).d1u = function (encoder, value) {
  var tmp0_desc = this.c1u_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.sq(tmp0_desc, 0, $serializer_getInstance_6(), value.size);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_1).ul = function (encoder, value) {
  return this.d1u(encoder, value instanceof ProductParams ? value : THROW_CCE());
};
protoOf($serializer_1).vl = function (decoder) {
  var tmp0_desc = this.c1u_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.np(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.np(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return ProductParams_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_1).tl = function () {
  return this.c1u_1;
};
protoOf($serializer_1).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_6()];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function ProductParams_init_$Init$(seen0, size, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_1().c1u_1);
  }
  $this.size = size;
  return $this;
}
function ProductParams_init_$Create$(seen0, size, serializationConstructorMarker) {
  return ProductParams_init_$Init$(seen0, size, serializationConstructorMarker, objectCreate(protoOf(ProductParams)));
}
function ProductParams(size) {
  this.size = size;
}
protoOf(ProductParams).o = function () {
  return this.size;
};
protoOf(ProductParams).tf = function () {
  return this.size;
};
protoOf(ProductParams).e1u = function (size) {
  return new ProductParams(size);
};
protoOf(ProductParams).copy = function (size, $super) {
  size = size === VOID ? this.size : size;
  return this.e1u(size);
};
protoOf(ProductParams).toString = function () {
  return 'ProductParams(size=' + this.size.toString() + ')';
};
protoOf(ProductParams).hashCode = function () {
  return this.size.hashCode();
};
protoOf(ProductParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProductParams))
    return false;
  var tmp0_other_with_cast = other instanceof ProductParams ? other : THROW_CCE();
  if (!this.size.equals(tmp0_other_with_cast.size))
    return false;
  return true;
};
function ProductParamsComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_9() {
  Companion_instance_9 = this;
  this.id = Companion_instance_21.c1s_1;
  this.serializationKey = 'params';
  var tmp = this;
  tmp.f1u_1 = Json(VOID, ProductParamsComponent$Companion$serializer$lambda);
}
protoOf(Companion_9).n1s = function () {
  return this.id;
};
protoOf(Companion_9).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_9).x1s = function (json) {
  var data = this.f1u_1.y16(Companion_instance_8.z18(), json);
  return new ProductParamsComponent(data, false);
};
var Companion_instance_9;
function Companion_getInstance_10() {
  if (Companion_instance_9 == null)
    new Companion_9();
  return Companion_instance_9;
}
function ProductParamsComponent(params, isOriginalParams) {
  Companion_getInstance_10();
  isOriginalParams = isOriginalParams === VOID ? false : isOriginalParams;
  this.params = params;
  this.isOriginalParams = isOriginalParams;
  this.g1u_1 = !this.isOriginalParams;
  this.h1u_1 = Companion_getInstance_10().id;
}
protoOf(ProductParamsComponent).i1u = function () {
  return this.params;
};
protoOf(ProductParamsComponent).j1u = function () {
  return this.isOriginalParams;
};
protoOf(ProductParamsComponent).toJson = function (parse) {
  return Companion_getInstance_10().f1u_1.x16(Companion_instance_8.z18(), this.params);
};
protoOf(ProductParamsComponent).r1s = function () {
  return this.g1u_1;
};
protoOf(ProductParamsComponent).serializationKey = function () {
  return 'params';
};
protoOf(ProductParamsComponent).p1s = function () {
  return this.h1u_1;
};
protoOf(ProductParamsComponent).eq = function (other) {
  return this.params.equals((other instanceof ProductParamsComponent ? other : THROW_CCE()).params);
};
function ProductSpecification(components) {
  this.components = components;
  this.k1u_1 = 0;
}
protoOf(ProductSpecification).l1u = function () {
  return this.components;
};
protoOf(ProductSpecification).hasComponent = function (componentId) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = this.components;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.catalog.ProductSpecification.hasComponent.<anonymous>' call
      if (element.typeId === componentId) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
};
protoOf(ProductSpecification).addComponent = function (component) {
  var specWithoutComponent = this.removeComponent(component.typeId);
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = specWithoutComponent.components;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [component];
  var newComponents = tmp$ret$0.concat(tmp$ret$3);
  return new ProductSpecification(newComponents);
};
protoOf(ProductSpecification).m1u = function (components) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = this;
  var tmp0_iterator = components.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.catalog.ProductSpecification.addComponents.<anonymous>' call
    accumulator = accumulator.addComponent(element);
  }
  return accumulator;
};
protoOf(ProductSpecification).removeComponent = function (componentId) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.filterNotTo' call
  var this_0 = this.components;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.catalog.ProductSpecification.removeComponent.<anonymous>' call
    if (!(element.typeId === componentId)) {
      destination.h(element);
    }
  }
  var newComponents = copyToArray(destination);
  return this.copy(newComponents);
};
protoOf(ProductSpecification).findComponent = function (componentId) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = this.components;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.catalog.ProductSpecification.findComponent.<anonymous>' call
      if (element.typeId === componentId) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var component = tmp$ret$1;
  return !(component == null) ? unsafeCast(component) : null;
};
protoOf(ProductSpecification).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ProductSpecification))
    THROW_CCE();
  if (!contentEquals(this.components, other.components))
    return false;
  return true;
};
protoOf(ProductSpecification).hashCode = function () {
  if (this.k1u_1 === 0)
    this.k1u_1 = contentHashCode(this.components);
  return this.k1u_1;
};
protoOf(ProductSpecification).tf = function () {
  return this.components;
};
protoOf(ProductSpecification).n1u = function (components) {
  return new ProductSpecification(components);
};
protoOf(ProductSpecification).copy = function (components, $super) {
  components = components === VOID ? this.components : components;
  return this.n1u(components);
};
protoOf(ProductSpecification).toString = function () {
  return 'ProductSpecification(components=' + toString_0(this.components) + ')';
};
function Companion_10() {
}
protoOf(Companion_10).n1s = function () {
  return Companion_instance_21.i1r_1;
};
var Companion_instance_10;
function Companion_getInstance_11() {
  return Companion_instance_10;
}
function ProductStructureComponent(products) {
  this.products = products;
}
protoOf(ProductStructureComponent).o1u = function () {
  return this.products;
};
protoOf(ProductStructureComponent).p1s = function () {
  return Companion_instance_10.id;
};
protoOf(ProductStructureComponent).eq = function (other) {
  var otherStructure = other instanceof ProductStructureComponent ? other : THROW_CCE();
  return contentEquals(otherStructure.products, this.products);
};
function ProductStructureConnection(offeringPartKey, demandingConnector, offeringConnector) {
  this.offeringPartKey = offeringPartKey;
  this.demandingConnector = demandingConnector;
  this.offeringConnector = offeringConnector;
}
protoOf(ProductStructureConnection).p1u = function () {
  return this.offeringPartKey;
};
protoOf(ProductStructureConnection).q1u = function () {
  return this.demandingConnector;
};
protoOf(ProductStructureConnection).r1u = function () {
  return this.offeringConnector;
};
protoOf(ProductStructureConnection).tf = function () {
  return this.offeringPartKey;
};
protoOf(ProductStructureConnection).uf = function () {
  return this.demandingConnector;
};
protoOf(ProductStructureConnection).m1m = function () {
  return this.offeringConnector;
};
protoOf(ProductStructureConnection).s1u = function (offeringPartKey, demandingConnector, offeringConnector) {
  return new ProductStructureConnection(offeringPartKey, demandingConnector, offeringConnector);
};
protoOf(ProductStructureConnection).copy = function (offeringPartKey, demandingConnector, offeringConnector, $super) {
  offeringPartKey = offeringPartKey === VOID ? this.offeringPartKey : offeringPartKey;
  demandingConnector = demandingConnector === VOID ? this.demandingConnector : demandingConnector;
  offeringConnector = offeringConnector === VOID ? this.offeringConnector : offeringConnector;
  return this.s1u(offeringPartKey, demandingConnector, offeringConnector);
};
protoOf(ProductStructureConnection).toString = function () {
  return 'ProductStructureConnection(offeringPartKey=' + this.offeringPartKey + ', demandingConnector=' + this.demandingConnector + ', offeringConnector=' + this.offeringConnector + ')';
};
protoOf(ProductStructureConnection).hashCode = function () {
  var result = getStringHashCode(this.offeringPartKey);
  result = imul(result, 31) + getStringHashCode(this.demandingConnector) | 0;
  result = imul(result, 31) + getStringHashCode(this.offeringConnector) | 0;
  return result;
};
protoOf(ProductStructureConnection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProductStructureConnection))
    return false;
  var tmp0_other_with_cast = other instanceof ProductStructureConnection ? other : THROW_CCE();
  if (!(this.offeringPartKey === tmp0_other_with_cast.offeringPartKey))
    return false;
  if (!(this.demandingConnector === tmp0_other_with_cast.demandingConnector))
    return false;
  if (!(this.offeringConnector === tmp0_other_with_cast.offeringConnector))
    return false;
  return true;
};
function ProductStructureItem(partKey, productRef, snap, relativeTransform) {
  snap = snap === VOID ? null : snap;
  relativeTransform = relativeTransform === VOID ? null : relativeTransform;
  this.partKey = partKey;
  this.productRef = productRef;
  this.snap = snap;
  this.relativeTransform = relativeTransform;
}
protoOf(ProductStructureItem).f1m = function () {
  return this.partKey;
};
protoOf(ProductStructureItem).b1t = function () {
  return this.productRef;
};
protoOf(ProductStructureItem).t1u = function () {
  return this.snap;
};
protoOf(ProductStructureItem).g1m = function () {
  return this.relativeTransform;
};
function applyNewParams($this, entity, paramsComponent) {
  if (!hasProductRef($this, entity)) {
    var tmp = Companion_getInstance_12().v1u_1;
    tmp.warn(ProductResizingSystem$applyNewParams$lambda);
    return Unit_instance;
  }
  resize($this, entity, paramsComponent.params);
}
function hasProductRef($this, entity) {
  return !(get_productRef(entity) == null);
}
function resize($this, entity, params) {
  var tmp0_elvis_lhs = get_productRef(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var productRef = tmp;
  var resizedProduct = $this.f1v_1.productSpecification(productRef, params);
  if (resizedProduct == null) {
    var tmp_0 = Companion_getInstance_12().v1u_1;
    tmp_0.warn(ProductResizingSystem$resize$lambda(productRef));
    return Unit_instance;
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = resizedProduct.components;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.catalog.resize.ProductResizingSystem.resize.<anonymous>' call
    entity.addComponent(element);
  }
}
function Companion_11() {
  Companion_instance_11 = this;
  this.u1u_1 = 'ProductParamsSystem';
  this.v1u_1 = LoggerState_getInstance().g1v('ProductParamsSystem');
}
var Companion_instance_11;
function Companion_getInstance_12() {
  if (Companion_instance_11 == null)
    new Companion_11();
  return Companion_instance_11;
}
function ProductResizingSystem$applyNewParams$lambda() {
  return 'Trying to modify an entity with ProductParamsComponent that has no ProductComponent';
}
function ProductResizingSystem$resize$lambda($productRef) {
  return function () {
    return 'Could not find product with ref ' + $productRef + ' for resizing';
  };
}
function ProductResizingSystem(productManager) {
  Companion_getInstance_12();
  SystemBase.call(this, Companion_getInstance_143().p1v_1, Companion_getInstance_10().id);
  this.f1v_1 = productManager;
  this.enable();
}
protoOf(ProductResizingSystem).u1v = function (entity, newComponent) {
  applyNewParams(this, entity, newComponent);
};
protoOf(ProductResizingSystem).v1v = function (entity, newComponent) {
  return this.u1v(entity, newComponent instanceof ProductParamsComponent ? newComponent : THROW_CCE());
};
protoOf(ProductResizingSystem).w1v = function (entity, oldComponent, newComponent) {
  applyNewParams(this, entity, newComponent);
};
protoOf(ProductResizingSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ProductParamsComponent ? oldComponent : THROW_CCE();
  return this.w1v(entity, tmp, newComponent instanceof ProductParamsComponent ? newComponent : THROW_CCE());
};
protoOf(ProductResizingSystem).y1v = function (entity, oldComponent) {
};
protoOf(ProductResizingSystem).z1v = function (entity, oldComponent) {
  return this.y1v(entity, oldComponent instanceof ProductParamsComponent ? oldComponent : THROW_CCE());
};
function start($this) {
  return $this.u1w_1 - ($this.o() - 1 | 0) | 0;
}
function wrappedIndex($this, index) {
  return (index + $this.t1w_1.o() | 0) % $this.t1w_1.o() | 0;
}
function CircularBuffer$iterator$1(this$0) {
  this.x1w_1 = this$0;
  this.w1w_1 = 0;
}
protoOf(CircularBuffer$iterator$1).m = function () {
  return this.w1w_1 < this.x1w_1.o();
};
protoOf(CircularBuffer$iterator$1).n = function () {
  var _unary__edvuaz = this.w1w_1;
  this.w1w_1 = _unary__edvuaz + 1 | 0;
  return this.x1w_1.q(_unary__edvuaz);
};
function CircularBuffer(size) {
  var tmp = this;
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList_init_$Create$_0(size);
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.MutableList.<anonymous>' call
      // Inline function 'com.ikea.core.collections.CircularBuffer.internalArray.<anonymous>' call
      list.h(null);
    }
     while (inductionVariable < size);
  tmp.t1w_1 = list;
  this.u1w_1 = -1;
  this.v1w_1 = 0;
}
protoOf(CircularBuffer).o = function () {
  return this.v1w_1;
};
protoOf(CircularBuffer).y1w = function (item) {
  if ((this.v1w_1 + 1 | 0) > this.t1w_1.o()) {
    throw IndexOutOfBoundsException_init_$Create$('Not allowed to add more item than size');
  }
  this.u1w_1 = wrappedIndex(this, this.u1w_1 + 1 | 0);
  this.t1w_1.n2(this.u1w_1, item);
  this.v1w_1 = this.v1w_1 + 1 | 0;
};
protoOf(CircularBuffer).q = function (index) {
  var tmp;
  if (this.u1w_1 < 0 || index < 0 || index >= this.o()) {
    throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds for length ' + this.o());
  } else {
    var tmp0_elvis_lhs = this.t1w_1.q(wrappedIndex(this, start(this) + index | 0));
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' is not assigned');
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(CircularBuffer).z1w = function () {
  var tmp;
  switch (this.v1w_1) {
    case 0:
      tmp = null;
      break;
    case 1:
      var removed = this.q(0);
      this.m2();
      tmp = removed;
      break;
    default:
      var removed_0 = this.q(this.o() - 1 | 0);
      this.u1w_1 = wrappedIndex(this, this.u1w_1 - 1 | 0);
      this.v1w_1 = this.v1w_1 - 1 | 0;
      tmp = removed_0;
      break;
  }
  return tmp;
};
protoOf(CircularBuffer).m2 = function () {
  this.u1w_1 = -1;
  this.v1w_1 = 0;
};
protoOf(CircularBuffer).a1x = function () {
  var tmp;
  if (this.v1w_1 === 0) {
    tmp = null;
  } else {
    var removed = this.q(0);
    if (this.v1w_1 === 1) {
      this.m2();
    } else {
      this.v1w_1 = this.v1w_1 - 1 | 0;
    }
    tmp = removed;
  }
  return tmp;
};
protoOf(CircularBuffer).k = function () {
  return new CircularBuffer$iterator$1(this);
};
protoOf(CircularBuffer).b1x = function () {
  return toList_0(asSequence(this.k()));
};
function objectOrientedBoundingBoxForEntityHierarchy($this, entity, onlyAssembly) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var vertices = ArrayList_init_$Create$();
  objectOrientedBoundingBoxForEntityHierarchy$extractEntity(vertices, onlyAssembly, entity, Companion_getInstance_80().c1x_1);
  var tmp;
  if (vertices.r()) {
    tmp = Companion_getInstance_127().ZERO;
  } else {
    var tmp_0 = Companion_getInstance_127();
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$1 = copyToArray(vertices);
    tmp = tmp_0.fromNonCuboidVertices(tmp$ret$1);
  }
  return tmp;
}
function objectOrientedBoundingBoxForEntityHierarchy$extractEntity(vertices, $onlyAssembly, innerEntity, localTransform) {
  var tmp0_safe_receiver = get_colliderShapeComponent(innerEntity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.collision.Companion.objectOrientedBoundingBoxForEntityHierarchy.extractEntity.<anonymous>' call
    vertices.p(Companion_getInstance_129().m1x(tmp0_safe_receiver.polyhedron, localTransform));
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(innerEntity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.collision.Companion.objectOrientedBoundingBoxForEntityHierarchy.extractEntity.<anonymous>' call
    if (!$onlyAssembly || element.hasComponent(Companion_getInstance_5().id)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.collision.Companion.objectOrientedBoundingBoxForEntityHierarchy.extractEntity.<anonymous>' call
    objectOrientedBoundingBoxForEntityHierarchy$extractEntity(vertices, $onlyAssembly, element_0, localTransform.concatenate(get_localTransform(element_0)));
  }
}
function ColliderComponent$Companion$axisAlignedBoundingBoxForEntityHierarchies$lambda($set) {
  return function (it) {
    $set.h(it);
    return Unit_instance;
  };
}
function Companion_12() {
  Companion_instance_12 = this;
  this.id = Companion_instance_21.u1n_1;
}
protoOf(Companion_12).n1s = function () {
  return this.id;
};
protoOf(Companion_12).axisAlignedBoundingBoxForEntityHierarchies = function (entities) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var set = LinkedHashSet_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.collision.Companion.axisAlignedBoundingBoxForEntityHierarchies.<anonymous>' call
    forEachInHierarchy_0(element, ColliderComponent$Companion$axisAlignedBoundingBoxForEntityHierarchies$lambda(set));
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$1 = copyToArray(set);
  return this.axisAlignedBoundingBoxForEntities(tmp$ret$1);
};
protoOf(Companion_12).axisAlignedBoundingBoxForEntities = function (entities) {
  // Inline function 'kotlin.collections.ifEmpty' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.collision.Companion.axisAlignedBoundingBoxForEntities.<anonymous>' call
    var tmp0_safe_receiver = get_collider(element);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver_0);
    }
  }
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  if (destination.r()) {
    // Inline function 'com.ikea.core.collision.Companion.axisAlignedBoundingBoxForEntities.<anonymous>' call
    tmp = null;
  } else {
    tmp = destination;
  }
  var tmp0_safe_receiver_1 = tmp;
  var tmp_0;
  if (tmp0_safe_receiver_1 == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.reduceRight' call
    var iterator = tmp0_safe_receiver_1.z1(tmp0_safe_receiver_1.o());
    if (!iterator.c5())
      throw UnsupportedOperationException_init_$Create$("Empty list can't be reduced.");
    var accumulator = iterator.e5();
    while (iterator.c5()) {
      // Inline function 'com.ikea.core.collision.Companion.axisAlignedBoundingBoxForEntities.<anonymous>' call
      var combined = iterator.e5();
      var next = accumulator;
      accumulator = combined.createCombined(next);
    }
    tmp_0 = accumulator;
  }
  return tmp_0;
};
protoOf(Companion_12).objectOrientedBoundingBoxForEntityHierarchy = function (entity) {
  return objectOrientedBoundingBoxForEntityHierarchy(this, entity, false);
};
protoOf(Companion_12).objectOrientedBoundingBoxForAssemblyHierarchy = function (entity) {
  return objectOrientedBoundingBoxForEntityHierarchy(this, entity, true);
};
var Companion_instance_12;
function Companion_getInstance_13() {
  if (Companion_instance_12 == null)
    new Companion_12();
  return Companion_instance_12;
}
function ColliderComponent(worldPolyhedron) {
  Companion_getInstance_13();
  this.worldPolyhedron = worldPolyhedron;
}
protoOf(ColliderComponent).n1x = function () {
  return this.worldPolyhedron;
};
protoOf(ColliderComponent).p1s = function () {
  return Companion_getInstance_13().id;
};
protoOf(ColliderComponent).eq = function (other) {
  return equals((other instanceof ColliderComponent ? other : THROW_CCE()).worldPolyhedron, this.worldPolyhedron);
};
protoOf(ColliderComponent).tf = function () {
  return this.worldPolyhedron;
};
protoOf(ColliderComponent).o1x = function (worldPolyhedron) {
  return new ColliderComponent(worldPolyhedron);
};
protoOf(ColliderComponent).copy = function (worldPolyhedron, $super) {
  worldPolyhedron = worldPolyhedron === VOID ? this.worldPolyhedron : worldPolyhedron;
  return this.o1x(worldPolyhedron);
};
protoOf(ColliderComponent).toString = function () {
  return 'ColliderComponent(worldPolyhedron=' + toString_0(this.worldPolyhedron) + ')';
};
protoOf(ColliderComponent).hashCode = function () {
  return hashCode(this.worldPolyhedron);
};
protoOf(ColliderComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ColliderComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ColliderComponent ? other : THROW_CCE();
  if (!equals(this.worldPolyhedron, tmp0_other_with_cast.worldPolyhedron))
    return false;
  return true;
};
function get_collider(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_13().id);
}
function get_axisAlignedBoundingBoxForHierarchy(_this__u8e3s4) {
  var tmp = Companion_getInstance_13();
  var tmp0_elvis_lhs = get_snapRoot(_this__u8e3s4);
  return tmp.axisAlignedBoundingBoxForEntities(get_hierarchy(tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs));
}
function get_objectOrientedBoundingBoxForHierarchy(_this__u8e3s4) {
  return Companion_getInstance_13().objectOrientedBoundingBoxForEntityHierarchy(_this__u8e3s4);
}
function get_objectOrientedBoundingBoxForAssemblyHierarchy(_this__u8e3s4) {
  return Companion_getInstance_13().objectOrientedBoundingBoxForAssemblyHierarchy(_this__u8e3s4);
}
function get_axisAlignedBoundingBoxForSnappableHierarchy(_this__u8e3s4) {
  if (!(get_snapRoot(_this__u8e3s4) == null)) {
    return Companion_getInstance_13().axisAlignedBoundingBoxForEntities(get_snapRootSubTree(_this__u8e3s4));
  }
  return get_axisAlignedBoundingBoxForHierarchy(_this__u8e3s4);
}
function Companion_13() {
  Companion_instance_13 = this;
  this.id = Companion_instance_21.p1n_1;
}
protoOf(Companion_13).n1s = function () {
  return this.id;
};
var Companion_instance_13;
function Companion_getInstance_14() {
  if (Companion_instance_13 == null)
    new Companion_13();
  return Companion_instance_13;
}
function ColliderShapeComponent(polyhedron, ids) {
  Companion_getInstance_14();
  ids = ids === VOID ? null : ids;
  this.polyhedron = polyhedron;
  this.ids = ids;
}
protoOf(ColliderShapeComponent).p1x = function () {
  return this.polyhedron;
};
protoOf(ColliderShapeComponent).q1x = function () {
  return this.ids;
};
protoOf(ColliderShapeComponent).p1s = function () {
  return Companion_getInstance_14().id;
};
protoOf(ColliderShapeComponent).eq = function (other) {
  return equals((other instanceof ColliderShapeComponent ? other : THROW_CCE()).polyhedron, this.polyhedron);
};
protoOf(ColliderShapeComponent).hashCode = function () {
  return hashCode(this.polyhedron);
};
protoOf(ColliderShapeComponent).equals = function (other) {
  var tmp;
  if (other instanceof ColliderShapeComponent) {
    tmp = equals(this.polyhedron, other.polyhedron);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ColliderShapeComponent).tf = function () {
  return this.polyhedron;
};
protoOf(ColliderShapeComponent).uf = function () {
  return this.ids;
};
protoOf(ColliderShapeComponent).r1x = function (polyhedron, ids) {
  return new ColliderShapeComponent(polyhedron, ids);
};
protoOf(ColliderShapeComponent).copy = function (polyhedron, ids, $super) {
  polyhedron = polyhedron === VOID ? this.polyhedron : polyhedron;
  ids = ids === VOID ? this.ids : ids;
  return this.r1x(polyhedron, ids);
};
protoOf(ColliderShapeComponent).toString = function () {
  return 'ColliderShapeComponent(polyhedron=' + toString_0(this.polyhedron) + ', ids=' + toString_0(this.ids) + ')';
};
function get_colliderShapeComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_14().id);
}
function Companion_14() {
}
protoOf(Companion_14).s1x = function (entity) {
  return get_colliderShapeComponent(entity);
};
protoOf(Companion_14).t1x = function (entity) {
  return get_collider(entity);
};
protoOf(Companion_14).u1x = function (entity) {
  return get_axisAlignedBoundingBoxForHierarchy(entity);
};
protoOf(Companion_14).v1x = function (entity) {
  return get_objectOrientedBoundingBoxForHierarchy(entity);
};
protoOf(Companion_14).w1x = function (entity) {
  return get_objectOrientedBoundingBoxForAssemblyHierarchy(entity);
};
var Companion_instance_14;
function Companion_getInstance_15() {
  return Companion_instance_14;
}
function colliderShapeComponent(entity) {
  return Companion_instance_14.s1x(entity);
}
function colliderComponent(entity) {
  return Companion_instance_14.t1x(entity);
}
function axisAlignedBoundingBoxForHierarchy(entity) {
  return Companion_instance_14.u1x(entity);
}
function objectOrientedBoundingBoxForHierarchy(entity) {
  return Companion_instance_14.v1x(entity);
}
function objectOrientedBoundingBoxForAssemblyHierarchy(entity) {
  return Companion_instance_14.w1x(entity);
}
function ColliderUtils() {
}
function Collision(self_0, other, interpenetration) {
  this.self = self_0;
  this.other = other;
  this.interpenetration = interpenetration;
  this.selfWorldTransformAtTimeOfCollision = get_worldTransform(this.self);
}
protoOf(Collision).x1x = function () {
  return this.self;
};
protoOf(Collision).y1x = function () {
  return this.other;
};
protoOf(Collision).z1x = function () {
  return this.interpenetration;
};
protoOf(Collision).a1y = function () {
  return this.selfWorldTransformAtTimeOfCollision;
};
protoOf(Collision).toString = function () {
  return this.self.toString() + ' collision at ' + this.selfWorldTransformAtTimeOfCollision.toString() + ' with ' + this.other.toString() + ' interpenetration ' + this.interpenetration.toString();
};
protoOf(Collision).tf = function () {
  return this.self;
};
protoOf(Collision).uf = function () {
  return this.other;
};
protoOf(Collision).m1m = function () {
  return this.interpenetration;
};
protoOf(Collision).b1y = function (self_0, other, interpenetration) {
  return new Collision(self_0, other, interpenetration);
};
protoOf(Collision).copy = function (self_0, other, interpenetration, $super) {
  self_0 = self_0 === VOID ? this.self : self_0;
  other = other === VOID ? this.other : other;
  interpenetration = interpenetration === VOID ? this.interpenetration : interpenetration;
  return this.b1y(self_0, other, interpenetration);
};
protoOf(Collision).hashCode = function () {
  var result = this.self.hashCode();
  result = imul(result, 31) + this.other.hashCode() | 0;
  result = imul(result, 31) + this.interpenetration.hashCode() | 0;
  return result;
};
protoOf(Collision).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Collision))
    return false;
  var tmp0_other_with_cast = other instanceof Collision ? other : THROW_CCE();
  if (!this.self.equals(tmp0_other_with_cast.self))
    return false;
  if (!this.other.equals(tmp0_other_with_cast.other))
    return false;
  if (!this.interpenetration.equals(tmp0_other_with_cast.interpenetration))
    return false;
  return true;
};
function Companion_15() {
  this.c1y_1 = 0.1;
}
var Companion_instance_15;
function Companion_getInstance_16() {
  return Companion_instance_15;
}
function CollisionUtils$Companion$getFirstCollision$lambda($otherEntities, $entity, $disposition, $res) {
  return function (current) {
    var tmp0_safe_receiver = get_collider(current);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = $otherEntities;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.collision.Companion.getFirstCollision.<anonymous>.<anonymous>.<anonymous>' call
        if (!(element.id === $entity.id)) {
          var tmp;
          if ($disposition == null) {
            var tmp0_safe_receiver_0 = get_collider(element);
            var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.worldPolyhedron;
            var tmp2_elvis_lhs = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.penetration(tmp1_safe_receiver);
            tmp = tmp2_elvis_lhs == null ? Companion_getInstance_81().ZERO : tmp2_elvis_lhs;
          } else {
            var tmp3_safe_receiver = get_collider(element);
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.worldPolyhedron;
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.penetrationAlongAxis(tmp1_safe_receiver, $disposition);
            tmp = tmp5_elvis_lhs == null ? Companion_getInstance_81().ZERO : tmp5_elvis_lhs;
          }
          var interpenetration = tmp;
          if (!interpenetration.equals(Companion_getInstance_81().ZERO)) {
            $res._v = new Collision(current, element, interpenetration);
            return true;
          }
        }
      }
    }
    return false;
  };
}
function Companion_16() {
}
protoOf(Companion_16).d1y = function (entity, disposition, otherEntities) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = toList_0(getPenetrations(entity, disposition, asSequence_0(otherEntities), true));
  return copyToArray(this_0);
};
protoOf(Companion_16).e1y = function (entity, disposition, otherEntities) {
  var res = {_v: null};
  findInHierarchy_0(entity, CollisionUtils$Companion$getFirstCollision$lambda(otherEntities, entity, disposition, res));
  return res._v;
};
var Companion_instance_16;
function Companion_getInstance_17() {
  return Companion_instance_16;
}
function getAllCollisions(entity, disposition, otherEntities) {
  return Companion_instance_16.d1y(entity, disposition, otherEntities);
}
function getFirstCollision(entity, disposition, otherEntities) {
  return Companion_instance_16.e1y(entity, disposition, otherEntities);
}
function CollisionUtils() {
}
function getPenetrations(entity, disposition, otherEntities, checkMyChildren) {
  disposition = disposition === VOID ? null : disposition;
  var entitiesInSubTree = checkMyChildren ? get_hierarchySequence(entity) : sequenceOf([entity]);
  return flatten(mapNotNull(entitiesInSubTree, getPenetrations$lambda(otherEntities, entity, disposition)));
}
function getPenetrations$lambda$lambda($entity) {
  return function (other) {
    return !other.equals($entity);
  };
}
function getPenetrations$lambda$lambda_0($disposition, $worldPoly, $current) {
  return function (other) {
    var tmp;
    if ($disposition == null) {
      var tmp0_safe_receiver = get_collider(other);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.penetration($worldPoly);
      tmp = tmp2_elvis_lhs == null ? Companion_getInstance_81().ZERO : tmp2_elvis_lhs;
    } else {
      var tmp3_safe_receiver = get_collider(other);
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.worldPolyhedron;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.penetrationAlongAxis($worldPoly, $disposition);
      tmp = tmp5_elvis_lhs == null ? Companion_getInstance_81().ZERO : tmp5_elvis_lhs;
    }
    var interpenetration = tmp;
    return !interpenetration.equals(Companion_getInstance_81().ZERO) ? new Collision($current, other, interpenetration) : null;
  };
}
function getPenetrations$lambda($otherEntities, $entity, $disposition) {
  return function (current) {
    var tmp0_safe_receiver = get_collider(current);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.collision.getPenetrations.<anonymous>.<anonymous>' call
      var tmp_0 = filter($otherEntities, getPenetrations$lambda$lambda($entity));
      tmp = mapNotNull(tmp_0, getPenetrations$lambda$lambda_0($disposition, tmp1_safe_receiver, current));
    }
    return tmp;
  };
}
function validate($this, entity, snap, earlyOut) {
  var otherEntities = hierarchyExceptSubTreeArray(Companion_instance_137.f1y(snap, entity), entity);
  var tmp;
  if (earlyOut) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = listOfNotNull(Companion_instance_16.e1y(entity, null, otherEntities));
    tmp = copyToArray(this_0);
  } else {
    tmp = Companion_instance_16.d1y(entity, null, otherEntities);
  }
  var collisions = tmp;
  return any(collisions) ? new CollisionValidationResult(collisions, get_productRefOrEmptyString(entity), $this.severity, $this) : null;
}
function Companion_17() {
  this.ID = 'Collision';
}
protoOf(Companion_17).j1y = function () {
  return this.ID;
};
var Companion_instance_17;
function Companion_getInstance_18() {
  return Companion_instance_17;
}
function CollisionValidation() {
  ValidationImpl.call(this);
  this.h1y_1 = Companion_instance_17.ID;
  this.i1y_1 = false;
  this.severity = ValidationResultType_FAIL_getInstance();
}
protoOf(CollisionValidation).n1s = function () {
  return this.h1y_1;
};
protoOf(CollisionValidation).k1y = function (_set____db54di) {
  this.severity = _set____db54di;
};
protoOf(CollisionValidation).l1y = function () {
  return this.severity;
};
protoOf(CollisionValidation).enableExhaustiveValidation = function () {
  this.i1y_1 = true;
};
protoOf(CollisionValidation).disableExhaustiveValidation = function () {
  this.i1y_1 = false;
};
protoOf(CollisionValidation).validateCurrentState = function (entity) {
  return validate(this, entity, null, !this.i1y_1);
};
protoOf(CollisionValidation).validateSnap = function (snap) {
  return validate(this, snap.guestRoot, snap, !this.i1y_1);
};
function Companion_18() {
  this.ID = 'CollisionValidationResult';
}
protoOf(Companion_18).j1y = function () {
  return this.ID;
};
var Companion_instance_18;
function Companion_getInstance_19() {
  return Companion_instance_18;
}
function CollisionValidationResult$toString$lambda(collision) {
  return collision.toString();
}
function CollisionValidationResult(collisions, productRef, severity, rule) {
  ValidationResult.call(this, severity, productRef, rule);
  this.collisions = collisions;
  this.o1y_1 = productRef;
}
protoOf(CollisionValidationResult).p1y = function () {
  return this.collisions;
};
protoOf(CollisionValidationResult).b1t = function () {
  return this.o1y_1;
};
protoOf(CollisionValidationResult).n1s = function () {
  return Companion_instance_18.ID;
};
protoOf(CollisionValidationResult).toString = function () {
  var collizions = joinToString_0(this.collisions, VOID, VOID, VOID, VOID, VOID, CollisionValidationResult$toString$lambda);
  return 'CollisionValidationResult [' + this.o1y_1 + '] has collisions [' + collizions + ']';
};
protoOf(CollisionValidationResult).q1y = function () {
  var tmp0_safe_receiver = firstOrNull(this.collisions);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.other;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_collider(tmp1_safe_receiver);
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.worldPolyhedron;
  var totalAabb = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.axisAlignedBoundingBox;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.collisions;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.collision.CollisionValidationResult.<get-aabbOfAllCollidedWith>.<anonymous>' call
    var otherAabb = get_axisAlignedBoundingBoxForSnappableHierarchy(element.other);
    var tmp;
    if (totalAabb == null) {
      tmp = otherAabb;
    } else {
      var tmp0_safe_receiver_0 = totalAabb;
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.createCombined(otherAabb);
    }
    totalAabb = tmp;
  }
  var tmp4_elvis_lhs = totalAabb;
  return tmp4_elvis_lhs == null ? new AxisAlignedBox(Companion_getInstance_81().ZERO, Companion_getInstance_81().ZERO) : tmp4_elvis_lhs;
};
function Companion_19() {
  this.u1y_1 = 'WorldColliderUpdateSystem';
}
var Companion_instance_19;
function Companion_getInstance_20() {
  return Companion_instance_19;
}
function updateWorldCollider($this, entity) {
  var tmp0_safe_receiver = calculateWorldCollider($this, entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.collision.WorldColliderUpdateSystem.updateWorldCollider.<anonymous>' call
    entity.addComponent(tmp0_safe_receiver);
  }
}
function calculateWorldCollider($this, entity) {
  var tmp0_safe_receiver = get_colliderShapeComponent(entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var basePolyhedron = tmp;
  var transformedPolyhedron = Companion_instance_146.v1y(basePolyhedron, entity);
  return new ColliderComponent(transformedPolyhedron);
}
function WorldColliderUpdateSystem() {
  var tmp = Companion_instance_19.u1y_1;
  var tmp_0 = Companion_instance_21.g1n_1;
  var tmp_1 = Companion_instance_21.p1n_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [Companion_instance_21.u1n_1];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [Companion_instance_145.ID];
  SystemBase2.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp$ret$5, null);
}
protoOf(WorldColliderUpdateSystem).h1z = function (entity, newComponent) {
  updateWorldCollider(this, entity);
};
protoOf(WorldColliderUpdateSystem).v1v = function (entity, newComponent) {
  return this.h1z(entity, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(WorldColliderUpdateSystem).i1z = function (entity, oldComponent, newComponent) {
  updateWorldCollider(this, entity);
};
protoOf(WorldColliderUpdateSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE();
  return this.i1z(entity, tmp, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(WorldColliderUpdateSystem).j1z = function (entity, oldComponent) {
  updateWorldCollider(this, entity);
};
protoOf(WorldColliderUpdateSystem).z1v = function (entity, oldComponent) {
  return this.j1z(entity, oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE());
};
protoOf(WorldColliderUpdateSystem).k1z = function (entity, newComponent) {
  updateWorldCollider(this, entity);
};
protoOf(WorldColliderUpdateSystem).l1z = function (entity, newComponent) {
  return this.k1z(entity, newComponent instanceof ColliderShapeComponent ? newComponent : THROW_CCE());
};
protoOf(WorldColliderUpdateSystem).m1z = function (entity, oldComponent, newComponent) {
  updateWorldCollider(this, entity);
};
protoOf(WorldColliderUpdateSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ColliderShapeComponent ? oldComponent : THROW_CCE();
  return this.m1z(entity, tmp, newComponent instanceof ColliderShapeComponent ? newComponent : THROW_CCE());
};
protoOf(WorldColliderUpdateSystem).o1z = function (entity, oldComponent) {
  entity.removeComponent(Companion_instance_21.u1n_1);
};
protoOf(WorldColliderUpdateSystem).p1z = function (entity, oldComponent) {
  return this.o1z(entity, oldComponent instanceof ColliderShapeComponent ? oldComponent : THROW_CCE());
};
function Companion_20() {
  this.b20_1 = 0;
  this.c20_1 = 1000;
  this.d20_1 = 1500;
  this.e20_1 = 2000;
  this.f20_1 = 90000;
  this.g20_1 = 100000;
  this.h20_1 = 101000;
  this.i20_1 = 101500;
  this.j20_1 = 102000;
  this.k20_1 = 103000;
  this.l20_1 = 104000;
  this.m20_1 = 105000;
  this.n20_1 = 106000;
  this.o20_1 = 107000;
  this.p20_1 = 108000;
  this.q20_1 = 109000;
  this.r20_1 = 110000;
}
protoOf(Companion_20).s20 = function () {
  return this.b20_1;
};
protoOf(Companion_20).t20 = function () {
  return this.c20_1;
};
protoOf(Companion_20).u20 = function () {
  return this.d20_1;
};
protoOf(Companion_20).v20 = function () {
  return this.e20_1;
};
protoOf(Companion_20).w20 = function () {
  return this.f20_1;
};
protoOf(Companion_20).x20 = function () {
  return this.g20_1;
};
protoOf(Companion_20).y20 = function () {
  return this.h20_1;
};
protoOf(Companion_20).z20 = function () {
  return this.i20_1;
};
protoOf(Companion_20).a21 = function () {
  return this.j20_1;
};
protoOf(Companion_20).b21 = function () {
  return this.k20_1;
};
protoOf(Companion_20).c21 = function () {
  return this.l20_1;
};
protoOf(Companion_20).d21 = function () {
  return this.m20_1;
};
protoOf(Companion_20).e21 = function () {
  return this.n20_1;
};
protoOf(Companion_20).f21 = function () {
  return this.o20_1;
};
protoOf(Companion_20).g21 = function () {
  return this.p20_1;
};
protoOf(Companion_20).h21 = function () {
  return this.q20_1;
};
protoOf(Companion_20).i21 = function () {
  return this.r20_1;
};
var Companion_instance_20;
function Companion_getInstance_21() {
  return Companion_instance_20;
}
function get_CORE_BASE_ID() {
  return Companion_instance_20.b20_1;
}
function get_PAX_RANGE_BASE_ID() {
  return Companion_instance_20.c20_1;
}
function get_BESTA_RANGE_BASE_ID() {
  return Companion_instance_20.d20_1;
}
function get_STORAGEONE_RANGE_BASE_ID() {
  return Companion_instance_20.e20_1;
}
function get_SNYGGIS_BASE_ID() {
  return Companion_instance_20.f20_1;
}
function get_CONCEPT_PLANNER_BASE_ID() {
  return Companion_instance_20.g20_1;
}
function get_PAX_PLANNER_BASE_ID() {
  return Companion_instance_20.h20_1;
}
function get_BESTA_PLANNER_BASE_ID() {
  return Companion_instance_20.i20_1;
}
function get_SPACE_PLANNER_BASE_ID() {
  return Companion_instance_20.j20_1;
}
function get_SKYTTA_PLANNER_BASE_ID() {
  return Companion_instance_20.k20_1;
}
function get_WALL_DECO_PLANNER_BASE_ID() {
  return Companion_instance_20.l20_1;
}
function get_CORE_TOOLBOX_BASE_ID() {
  return Companion_instance_20.m20_1;
}
function get_CORE_TOOLBOX_EXPERIMENTAL_BASE_ID() {
  return Companion_instance_20.n20_1;
}
function get_KVADRAT_BASE_ID() {
  return Companion_instance_20.o20_1;
}
function get_CORE_COMMUNITY_BASE_ID() {
  return Companion_instance_20.p20_1;
}
function get_SOFA_BASE_ID() {
  return Companion_instance_20.q20_1;
}
function get_KITCHEN_CONFIGURATOR_BASE_ID() {
  return Companion_instance_20.r20_1;
}
function ComponentIdSpan() {
}
function Companion_21() {
  this.w1m_1 = 0;
  this.x1m_1 = 1;
  this.y1m_1 = 2;
  this.z1m_1 = 3;
  this.a1n_1 = 4;
  this.b1n_1 = 5;
  this.c1n_1 = 6;
  this.d1n_1 = 7;
  this.e1n_1 = 8;
  this.f1n_1 = 9;
  this.g1n_1 = 10;
  this.h1n_1 = 11;
  this.i1n_1 = 12;
  this.j1n_1 = 13;
  this.k1n_1 = 14;
  this.l1n_1 = 15;
  this.m1n_1 = 16;
  this.n1n_1 = 17;
  this.o1n_1 = 18;
  this.p1n_1 = 19;
  this.q1n_1 = 20;
  this.r1n_1 = 21;
  this.s1n_1 = 22;
  this.t1n_1 = 23;
  this.u1n_1 = 24;
  this.v1n_1 = 25;
  this.w1n_1 = 26;
  this.x1n_1 = 27;
  this.y1n_1 = 28;
  this.z1n_1 = 29;
  this.a1o_1 = 30;
  this.b1o_1 = 31;
  this.c1o_1 = 32;
  this.d1o_1 = 33;
  this.e1o_1 = 34;
  this.f1o_1 = 35;
  this.g1o_1 = 36;
  this.h1o_1 = 38;
  this.i1o_1 = 39;
  this.j1o_1 = 40;
  this.k1o_1 = 41;
  this.l1o_1 = 42;
  this.m1o_1 = 43;
  this.n1o_1 = 44;
  this.o1o_1 = 45;
  this.p1o_1 = 46;
  this.q1o_1 = 47;
  this.r1o_1 = 48;
  this.s1o_1 = 49;
  this.t1o_1 = 50;
  this.u1o_1 = 51;
  this.v1o_1 = 52;
  this.w1o_1 = 53;
  this.x1o_1 = 54;
  this.y1o_1 = 55;
  this.z1o_1 = 56;
  this.a1p_1 = 57;
  this.b1p_1 = 58;
  this.c1p_1 = 59;
  this.d1p_1 = 60;
  this.e1p_1 = 61;
  this.f1p_1 = 62;
  this.g1p_1 = 63;
  this.h1p_1 = 64;
  this.i1p_1 = 65;
  this.j1p_1 = 66;
  this.k1p_1 = 67;
  this.l1p_1 = 68;
  this.m1p_1 = 69;
  this.n1p_1 = 70;
  this.o1p_1 = 71;
  this.p1p_1 = 72;
  this.q1p_1 = 73;
  this.r1p_1 = 74;
  this.s1p_1 = 75;
  this.t1p_1 = 76;
  this.u1p_1 = 77;
  this.v1p_1 = 78;
  this.w1p_1 = 79;
  this.x1p_1 = 80;
  this.y1p_1 = 81;
  this.z1p_1 = 82;
  this.a1q_1 = 83;
  this.b1q_1 = 84;
  this.c1q_1 = 85;
  this.d1q_1 = 86;
  this.e1q_1 = 87;
  this.f1q_1 = 88;
  this.g1q_1 = 89;
  this.h1q_1 = 90;
  this.i1q_1 = 91;
  this.j1q_1 = 92;
  this.k1q_1 = 93;
  this.l1q_1 = 94;
  this.m1q_1 = 95;
  this.n1q_1 = 96;
  this.o1q_1 = 97;
  this.p1q_1 = 98;
  this.q1q_1 = 99;
  this.r1q_1 = 100;
  this.s1q_1 = 101;
  this.t1q_1 = 102;
  this.u1q_1 = 103;
  this.v1q_1 = 104;
  this.w1q_1 = 105;
  this.x1q_1 = 106;
  this.y1q_1 = 107;
  this.z1q_1 = 108;
  this.a1r_1 = 109;
  this.b1r_1 = 110;
  this.c1r_1 = 111;
  this.d1r_1 = 112;
  this.e1r_1 = 113;
  this.f1r_1 = 114;
  this.g1r_1 = 116;
  this.h1r_1 = 117;
  this.i1r_1 = 118;
  this.j1r_1 = 119;
  this.k1r_1 = 120;
  this.l1r_1 = 121;
  this.m1r_1 = 122;
  this.n1r_1 = 123;
  this.o1r_1 = 124;
  this.p1r_1 = 125;
  this.q1r_1 = 126;
  this.r1r_1 = 127;
  this.s1r_1 = 128;
  this.t1r_1 = 129;
  this.u1r_1 = 130;
  this.v1r_1 = 131;
  this.w1r_1 = 132;
  this.x1r_1 = 133;
  this.y1r_1 = 134;
  this.z1r_1 = 135;
  this.a1s_1 = 136;
  this.b1s_1 = 137;
  this.c1s_1 = 138;
  this.d1s_1 = 139;
  this.e1s_1 = 140;
  this.f1s_1 = 141;
  this.g1s_1 = 142;
  this.h1s_1 = 143;
  this.i1s_1 = 144;
  this.j1s_1 = 145;
  this.k1s_1 = 146;
  this.l1s_1 = 147;
  this.m1s_1 = this.l1s_1;
}
protoOf(Companion_21).j21 = function () {
  return this.w1m_1;
};
protoOf(Companion_21).k21 = function () {
  return this.x1m_1;
};
protoOf(Companion_21).l21 = function () {
  return this.y1m_1;
};
protoOf(Companion_21).m21 = function () {
  return this.z1m_1;
};
protoOf(Companion_21).n21 = function () {
  return this.a1n_1;
};
protoOf(Companion_21).o21 = function () {
  return this.b1n_1;
};
protoOf(Companion_21).p21 = function () {
  return this.c1n_1;
};
protoOf(Companion_21).q21 = function () {
  return this.d1n_1;
};
protoOf(Companion_21).r21 = function () {
  return this.e1n_1;
};
protoOf(Companion_21).s21 = function () {
  return this.f1n_1;
};
protoOf(Companion_21).t21 = function () {
  return this.g1n_1;
};
protoOf(Companion_21).u21 = function () {
  return this.h1n_1;
};
protoOf(Companion_21).v21 = function () {
  return this.i1n_1;
};
protoOf(Companion_21).w21 = function () {
  return this.j1n_1;
};
protoOf(Companion_21).x21 = function () {
  return this.k1n_1;
};
protoOf(Companion_21).y21 = function () {
  return this.l1n_1;
};
protoOf(Companion_21).z21 = function () {
  return this.m1n_1;
};
protoOf(Companion_21).a22 = function () {
  return this.n1n_1;
};
protoOf(Companion_21).b22 = function () {
  return this.o1n_1;
};
protoOf(Companion_21).c22 = function () {
  return this.p1n_1;
};
protoOf(Companion_21).d22 = function () {
  return this.q1n_1;
};
protoOf(Companion_21).e22 = function () {
  return this.r1n_1;
};
protoOf(Companion_21).f22 = function () {
  return this.s1n_1;
};
protoOf(Companion_21).g22 = function () {
  return this.t1n_1;
};
protoOf(Companion_21).h22 = function () {
  return this.u1n_1;
};
protoOf(Companion_21).i22 = function () {
  return this.v1n_1;
};
protoOf(Companion_21).j22 = function () {
  return this.w1n_1;
};
protoOf(Companion_21).k22 = function () {
  return this.x1n_1;
};
protoOf(Companion_21).l22 = function () {
  return this.y1n_1;
};
protoOf(Companion_21).m22 = function () {
  return this.z1n_1;
};
protoOf(Companion_21).n22 = function () {
  return this.a1o_1;
};
protoOf(Companion_21).o22 = function () {
  return this.b1o_1;
};
protoOf(Companion_21).p22 = function () {
  return this.c1o_1;
};
protoOf(Companion_21).q22 = function () {
  return this.d1o_1;
};
protoOf(Companion_21).r22 = function () {
  return this.e1o_1;
};
protoOf(Companion_21).s22 = function () {
  return this.f1o_1;
};
protoOf(Companion_21).t22 = function () {
  return this.g1o_1;
};
protoOf(Companion_21).u22 = function () {
  return this.h1o_1;
};
protoOf(Companion_21).v22 = function () {
  return this.i1o_1;
};
protoOf(Companion_21).w22 = function () {
  return this.j1o_1;
};
protoOf(Companion_21).x22 = function () {
  return this.k1o_1;
};
protoOf(Companion_21).y22 = function () {
  return this.l1o_1;
};
protoOf(Companion_21).z22 = function () {
  return this.m1o_1;
};
protoOf(Companion_21).a23 = function () {
  return this.n1o_1;
};
protoOf(Companion_21).b23 = function () {
  return this.o1o_1;
};
protoOf(Companion_21).c23 = function () {
  return this.p1o_1;
};
protoOf(Companion_21).d23 = function () {
  return this.q1o_1;
};
protoOf(Companion_21).e23 = function () {
  return this.r1o_1;
};
protoOf(Companion_21).f23 = function () {
  return this.s1o_1;
};
protoOf(Companion_21).g23 = function () {
  return this.t1o_1;
};
protoOf(Companion_21).h23 = function () {
  return this.u1o_1;
};
protoOf(Companion_21).i23 = function () {
  return this.v1o_1;
};
protoOf(Companion_21).j23 = function () {
  return this.w1o_1;
};
protoOf(Companion_21).k23 = function () {
  return this.x1o_1;
};
protoOf(Companion_21).l23 = function () {
  return this.y1o_1;
};
protoOf(Companion_21).m23 = function () {
  return this.z1o_1;
};
protoOf(Companion_21).n23 = function () {
  return this.a1p_1;
};
protoOf(Companion_21).o23 = function () {
  return this.b1p_1;
};
protoOf(Companion_21).p23 = function () {
  return this.c1p_1;
};
protoOf(Companion_21).q23 = function () {
  return this.d1p_1;
};
protoOf(Companion_21).r23 = function () {
  return this.e1p_1;
};
protoOf(Companion_21).s23 = function () {
  return this.f1p_1;
};
protoOf(Companion_21).t23 = function () {
  return this.g1p_1;
};
protoOf(Companion_21).u23 = function () {
  return this.h1p_1;
};
protoOf(Companion_21).v23 = function () {
  return this.i1p_1;
};
protoOf(Companion_21).w23 = function () {
  return this.j1p_1;
};
protoOf(Companion_21).x23 = function () {
  return this.k1p_1;
};
protoOf(Companion_21).y23 = function () {
  return this.l1p_1;
};
protoOf(Companion_21).z23 = function () {
  return this.m1p_1;
};
protoOf(Companion_21).a24 = function () {
  return this.n1p_1;
};
protoOf(Companion_21).b24 = function () {
  return this.o1p_1;
};
protoOf(Companion_21).c24 = function () {
  return this.p1p_1;
};
protoOf(Companion_21).d24 = function () {
  return this.q1p_1;
};
protoOf(Companion_21).e24 = function () {
  return this.r1p_1;
};
protoOf(Companion_21).f24 = function () {
  return this.s1p_1;
};
protoOf(Companion_21).g24 = function () {
  return this.t1p_1;
};
protoOf(Companion_21).h24 = function () {
  return this.u1p_1;
};
protoOf(Companion_21).i24 = function () {
  return this.v1p_1;
};
protoOf(Companion_21).j24 = function () {
  return this.w1p_1;
};
protoOf(Companion_21).k24 = function () {
  return this.x1p_1;
};
protoOf(Companion_21).l24 = function () {
  return this.y1p_1;
};
protoOf(Companion_21).m24 = function () {
  return this.z1p_1;
};
protoOf(Companion_21).n24 = function () {
  return this.a1q_1;
};
protoOf(Companion_21).o24 = function () {
  return this.b1q_1;
};
protoOf(Companion_21).p24 = function () {
  return this.c1q_1;
};
protoOf(Companion_21).q24 = function () {
  return this.d1q_1;
};
protoOf(Companion_21).r24 = function () {
  return this.e1q_1;
};
protoOf(Companion_21).s24 = function () {
  return this.f1q_1;
};
protoOf(Companion_21).t24 = function () {
  return this.g1q_1;
};
protoOf(Companion_21).u24 = function () {
  return this.h1q_1;
};
protoOf(Companion_21).v24 = function () {
  return this.i1q_1;
};
protoOf(Companion_21).w24 = function () {
  return this.j1q_1;
};
protoOf(Companion_21).x24 = function () {
  return this.k1q_1;
};
protoOf(Companion_21).y24 = function () {
  return this.l1q_1;
};
protoOf(Companion_21).z24 = function () {
  return this.m1q_1;
};
protoOf(Companion_21).a25 = function () {
  return this.n1q_1;
};
protoOf(Companion_21).b25 = function () {
  return this.o1q_1;
};
protoOf(Companion_21).c25 = function () {
  return this.p1q_1;
};
protoOf(Companion_21).d25 = function () {
  return this.q1q_1;
};
protoOf(Companion_21).e25 = function () {
  return this.r1q_1;
};
protoOf(Companion_21).f25 = function () {
  return this.s1q_1;
};
protoOf(Companion_21).g25 = function () {
  return this.t1q_1;
};
protoOf(Companion_21).h25 = function () {
  return this.u1q_1;
};
protoOf(Companion_21).i25 = function () {
  return this.v1q_1;
};
protoOf(Companion_21).j25 = function () {
  return this.w1q_1;
};
protoOf(Companion_21).k25 = function () {
  return this.x1q_1;
};
protoOf(Companion_21).l25 = function () {
  return this.y1q_1;
};
protoOf(Companion_21).m25 = function () {
  return this.z1q_1;
};
protoOf(Companion_21).n25 = function () {
  return this.a1r_1;
};
protoOf(Companion_21).o25 = function () {
  return this.b1r_1;
};
protoOf(Companion_21).p25 = function () {
  return this.c1r_1;
};
protoOf(Companion_21).q25 = function () {
  return this.d1r_1;
};
protoOf(Companion_21).r25 = function () {
  return this.e1r_1;
};
protoOf(Companion_21).s25 = function () {
  return this.f1r_1;
};
protoOf(Companion_21).t25 = function () {
  return this.g1r_1;
};
protoOf(Companion_21).u25 = function () {
  return this.h1r_1;
};
protoOf(Companion_21).v25 = function () {
  return this.i1r_1;
};
protoOf(Companion_21).w25 = function () {
  return this.j1r_1;
};
protoOf(Companion_21).x25 = function () {
  return this.k1r_1;
};
protoOf(Companion_21).y25 = function () {
  return this.l1r_1;
};
protoOf(Companion_21).z25 = function () {
  return this.m1r_1;
};
protoOf(Companion_21).a26 = function () {
  return this.n1r_1;
};
protoOf(Companion_21).b26 = function () {
  return this.o1r_1;
};
protoOf(Companion_21).c26 = function () {
  return this.p1r_1;
};
protoOf(Companion_21).d26 = function () {
  return this.q1r_1;
};
protoOf(Companion_21).e26 = function () {
  return this.r1r_1;
};
protoOf(Companion_21).f26 = function () {
  return this.s1r_1;
};
protoOf(Companion_21).g26 = function () {
  return this.t1r_1;
};
protoOf(Companion_21).h26 = function () {
  return this.u1r_1;
};
protoOf(Companion_21).i26 = function () {
  return this.v1r_1;
};
protoOf(Companion_21).j26 = function () {
  return this.w1r_1;
};
protoOf(Companion_21).k26 = function () {
  return this.x1r_1;
};
protoOf(Companion_21).l26 = function () {
  return this.y1r_1;
};
protoOf(Companion_21).m26 = function () {
  return this.z1r_1;
};
protoOf(Companion_21).n26 = function () {
  return this.a1s_1;
};
protoOf(Companion_21).o26 = function () {
  return this.b1s_1;
};
protoOf(Companion_21).p26 = function () {
  return this.c1s_1;
};
protoOf(Companion_21).q26 = function () {
  return this.d1s_1;
};
protoOf(Companion_21).r26 = function () {
  return this.e1s_1;
};
protoOf(Companion_21).s26 = function () {
  return this.f1s_1;
};
protoOf(Companion_21).t26 = function () {
  return this.g1s_1;
};
protoOf(Companion_21).u26 = function () {
  return this.h1s_1;
};
protoOf(Companion_21).v26 = function () {
  return this.i1s_1;
};
protoOf(Companion_21).w26 = function () {
  return this.j1s_1;
};
protoOf(Companion_21).x26 = function () {
  return this.k1s_1;
};
protoOf(Companion_21).y26 = function () {
  return this.l1s_1;
};
protoOf(Companion_21).z26 = function () {
  return this.m1s_1;
};
protoOf(Companion_21).debugToString = function (id) {
  return id === this.w1m_1 ? 'Selected' : id === this.g1n_1 ? 'WorldTransform' : id === this.c1n_1 ? 'LocalTransform' : id === this.b1n_1 ? 'InScene' : id === this.n1n_1 ? 'Child' : id === this.k1o_1 ? 'RoomDimensions' : id === this.x1o_1 ? 'RoomActiveConnectors' : id.toString();
};
protoOf(Companion_21).a27 = function (component) {
  return component.typeId <= Companion_instance_21.m1s_1;
};
protoOf(Companion_21).isCoreComponentId = function (componentId) {
  return componentId <= Companion_instance_21.m1s_1;
};
var Companion_instance_21;
function Companion_getInstance_22() {
  return Companion_instance_21;
}
function get_SELECTED_COMPONENT_ID() {
  return Companion_instance_21.w1m_1;
}
function get_SELECTABLE_COMPONENT_ID() {
  return Companion_instance_21.x1m_1;
}
function get_PROPPING_HOST_CONNECTORS_COMPONENT_ID() {
  return Companion_instance_21.y1m_1;
}
function get_DRAGGABLE_COMPONENT_ID() {
  return Companion_instance_21.z1m_1;
}
function get_COLLISION_VISUALIZATION_SCENE_DATA_COMPONENT_ID() {
  return Companion_instance_21.a1n_1;
}
function get_IN_SCENE_COMPONENT_ID() {
  return Companion_instance_21.b1n_1;
}
function get_LOCAL_TRANSFORM_COMPONENT_ID() {
  return Companion_instance_21.c1n_1;
}
function get_PROPPING_COMPONENT_ID() {
  return Companion_instance_21.d1n_1;
}
function get_RESTRICT_ALLOWED_REQUIRED_HOSTS_COMPONENT_ID() {
  return Companion_instance_21.e1n_1;
}
function get_RENDERED_COMPONENT_ID() {
  return Companion_instance_21.f1n_1;
}
function get_WORLD_TRANSFORM_COMPONENT_ID() {
  return Companion_instance_21.g1n_1;
}
function get_CONNECTORS_COMPONENT_ID() {
  return Companion_instance_21.h1n_1;
}
function get_ASSEMBLY_STRUCTURE_COMPONENT_ID() {
  return Companion_instance_21.i1n_1;
}
function get_MODEL_INFO_COMPONENT_ID() {
  return Companion_instance_21.j1n_1;
}
function get_OUTLINED_COMPONENT_ID() {
  return Companion_instance_21.k1n_1;
}
function get_DISPLAY_NAME_COMPONENT_ID() {
  return Companion_instance_21.l1n_1;
}
function get_PARENT_COMPONENT_ID() {
  return Companion_instance_21.m1n_1;
}
function get_CHILD_COMPONENT_ID() {
  return Companion_instance_21.n1n_1;
}
function get_PRODUCT_COMPONENT_ID() {
  return Companion_instance_21.o1n_1;
}
function get_COLLIDER_SHAPE_COMPONENT_ID() {
  return Companion_instance_21.p1n_1;
}
function get_LOADED_MODEL_INFO_COMPONENT_ID() {
  return Companion_instance_21.q1n_1;
}
function get_SNAP_CANDIDATE_COMPONENT_ID() {
  return Companion_instance_21.r1n_1;
}
function get_CONNECTOR_VISUALIZATION_NODE_COMPONENT_ID() {
  return Companion_instance_21.s1n_1;
}
function get_COLLIDER_VISUALIZATION_NODE_COMPONENT_ID() {
  return Companion_instance_21.t1n_1;
}
function get_COLLIDER_COMPONENT_ID() {
  return Companion_instance_21.u1n_1;
}
function get_UNSERIALIZABLE_ENTITY_COMPONENT_ID() {
  return Companion_instance_21.v1n_1;
}
function get_ALWAYS_HANG_DOWN_COMPONENT_ID() {
  return Companion_instance_21.w1n_1;
}
function get_VIEWER_CAMERA_STATE_COMPONENT_ID() {
  return Companion_instance_21.x1n_1;
}
function get_CONNECTION_ROOT_COMPONENT() {
  return Companion_instance_21.y1n_1;
}
function get_ALLOWED_DOOR_PAIRS_COMPONENT_ID() {
  return Companion_instance_21.z1n_1;
}
function get_DOOR_COMPONENT_ID() {
  return Companion_instance_21.a1o_1;
}
function get_FRAME_COMPONENT_ID() {
  return Companion_instance_21.b1o_1;
}
function get_DOOR_FRONT_COMPONENT_ID() {
  return Companion_instance_21.c1o_1;
}
function get_COMMUNICATION_SIZE_COMPONENT_ID() {
  return Companion_instance_21.d1o_1;
}
function get_SNAP_ACTION_IN_PROGRESS_COMPONENT() {
  return Companion_instance_21.e1o_1;
}
function get_VIEWER_OBJECT_COMPONENT_ID() {
  return Companion_instance_21.f1o_1;
}
function get_IS_LOADING_SNAPSHOT_COMPONENT_ID() {
  return Companion_instance_21.g1o_1;
}
function get_AUTOMATIC_ENTITY_GROUP_COMPONENT_ID() {
  return Companion_instance_21.h1o_1;
}
function get_HANDLE_COMPONENT_ID() {
  return Companion_instance_21.i1o_1;
}
function get_META_DATA_COMPONENT_ID() {
  return Companion_instance_21.j1o_1;
}
function get_ROOM_DIMENSIONS_COMPONENT_ID() {
  return Companion_instance_21.k1o_1;
}
function get_RELATIVE_CONNECTORS_COMPONENT_ID() {
  return Companion_instance_21.l1o_1;
}
function get_ASSEMBLY_PARTS_COMPONENT_ID() {
  return Companion_instance_21.m1o_1;
}
function get_PRODUCT_PART_COMPONENT_ID() {
  return Companion_instance_21.n1o_1;
}
function get_MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID() {
  return Companion_instance_21.o1o_1;
}
function get_INCLUDED_HANDLE_COMPONENT_ID() {
  return Companion_instance_21.p1o_1;
}
function get_SNAP_ROOT_COMPONENT_ID() {
  return Companion_instance_21.q1o_1;
}
function get_LEG_COMPONENT_ID() {
  return Companion_instance_21.r1o_1;
}
function get_TEMPLATE_DATA_COMPONENT_ID() {
  return Companion_instance_21.s1o_1;
}
function get_DRAWER_COMPONENT_ID() {
  return Companion_instance_21.t1o_1;
}
function get_ALIGNMENT_CONNECTIONS_COMPONENT_ID() {
  return Companion_instance_21.u1o_1;
}
function get_HANDLE_UNDER_ALIGNMENT_COMPONENT_ID() {
  return Companion_instance_21.v1o_1;
}
function get_ROOM_COMPONENT_ID() {
  return Companion_instance_21.w1o_1;
}
function get_ROOM_ACTIVE_CONNECTORS_COMPONENT_ID() {
  return Companion_instance_21.x1o_1;
}
function get_TEMPORARY_PARENT_COMPONENT_ID() {
  return Companion_instance_21.y1o_1;
}
function get_MULTISELECTION_ENABLED_COMPONENT_ID() {
  return Companion_instance_21.z1o_1;
}
function get_OUTLINEABLE_COMPONENT_ID() {
  return Companion_instance_21.a1p_1;
}
function get_PLACEMENT_ZONE_BY_HEIGHT_COMPONENT_ID() {
  return Companion_instance_21.b1p_1;
}
function get_RECOMMENDED_INITIAL_POSITION_FROM_FLOOR_COMPONENT_ID() {
  return Companion_instance_21.c1p_1;
}
function get_RECOMMENDED_INITIAL_POSITION_FROM_PARENT_COMPONENT_ID() {
  return Companion_instance_21.d1p_1;
}
function get_FUNCTIONAL_MARGIN_SHAPE_COMPONENT_ID() {
  return Companion_instance_21.e1p_1;
}
function get_FUNCTIONAL_MARGIN_COMPONENT_ID() {
  return Companion_instance_21.f1p_1;
}
function get_LIGHT_COMPONENT_ID() {
  return Companion_instance_21.g1p_1;
}
function get_ROOM_ALIGNMENT_EDGES_COMPONENT_ID() {
  return Companion_instance_21.h1p_1;
}
function get_IS_DRAGGED_COMPONENT_ID() {
  return Companion_instance_21.i1p_1;
}
function get_SOMETHING_IS_DRAGGED_COMPONENT_ID() {
  return Companion_instance_21.j1p_1;
}
function get_FREE_MOVE_COMPONENT_ID() {
  return Companion_instance_21.k1p_1;
}
function get_MOVED_TO_CANDIDATE_SNAP_POSITION_COMPONENT_ID() {
  return Companion_instance_21.l1p_1;
}
function get_DRAG_STATE_COMPONENT() {
  return Companion_instance_21.m1p_1;
}
function get_ROOM_GEOMETRY_COMPONENT_ID() {
  return Companion_instance_21.n1p_1;
}
function get_DISABLED_CONNECTOR_KEYS_COMPONENT_ID() {
  return Companion_instance_21.o1p_1;
}
function get_VISUAL_LIGHT_SOURCE_COMPONENT_ID() {
  return Companion_instance_21.p1p_1;
}
function get_SCENE_RELOADING_COMPONENT_ID() {
  return Companion_instance_21.q1p_1;
}
function get_DRAG_SURFACES_COMPONENT_ID() {
  return Companion_instance_21.r1p_1;
}
function get_DISABLED_ROOM_CONNECTORS_COMPONENT_ID() {
  return Companion_instance_21.s1p_1;
}
function get_SERIALIZABLE_SCENE_COMPONENT() {
  return Companion_instance_21.t1p_1;
}
function get_ENTITY_CONNECTOR_VISUALIZATION_COMPONENT_ID() {
  return Companion_instance_21.u1p_1;
}
function get_ENTITY_COLLIDER_VISUALIZATION_COMPONENT_ID() {
  return Companion_instance_21.v1p_1;
}
function get_ENTITY_HOST_ZONE_VISUALIZATION_COMPONENT_ID() {
  return Companion_instance_21.w1p_1;
}
function get_ENTITY_FUNCTIONAL_ZONE_VISUALIZATION_COMPONENT_ID() {
  return Companion_instance_21.x1p_1;
}
function get_DRAG_SURFACE_ENTITY_PAIR_CACHE_COMPONENT() {
  return Companion_instance_21.y1p_1;
}
function get_VIEWER_COMPONENT_ID() {
  return Companion_instance_21.z1p_1;
}
function get_DECORATOR_COMPONENT_ID() {
  return Companion_instance_21.a1q_1;
}
function get_VIEWER_DRAG_EVENT_COMPONENT_ID() {
  return Companion_instance_21.b1q_1;
}
function get_WORLD_SPACE_DRAG_EVENT_COMPONENT_ID() {
  return Companion_instance_21.c1q_1;
}
function get_CLICK_EVENT_COMPONENT_ID() {
  return Companion_instance_21.d1q_1;
}
function get_PROPPING_INFO_COMPONENT_ID() {
  return Companion_instance_21.e1q_1;
}
function get_HISTORY_CHANGED_EVENT_COMPONENT_ID() {
  return Companion_instance_21.f1q_1;
}
function get_SERIALIZABLE_ROOT_COMPONENT_ID() {
  return Companion_instance_21.g1q_1;
}
function get_PAUSE_VIEWER_UPDATES_COMPONENT() {
  return Companion_instance_21.h1q_1;
}
function get_WORLD_DRAG_SURFACES_COMPONENT_ID() {
  return Companion_instance_21.i1q_1;
}
function get_DEBUG_LINES_COMPONENT() {
  return Companion_instance_21.j1q_1;
}
function get_VIEWER_LINE_IDS_COMPONENT() {
  return Companion_instance_21.k1q_1;
}
function get_GRAB_OFFSET_COMPONENT_ID() {
  return Companion_instance_21.l1q_1;
}
function get_SNAPSHOT_IGNORE_COMPONENT() {
  return Companion_instance_21.m1q_1;
}
function get_ASSEMBLY_PART_IDS_COMPONENT_ID() {
  return Companion_instance_21.n1q_1;
}
function get_SCENE_COMPONENT_ID() {
  return Companion_instance_21.o1q_1;
}
function get_COLLIDER_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID() {
  return Companion_instance_21.p1q_1;
}
function get_CONNECTOR_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID() {
  return Companion_instance_21.q1q_1;
}
function get_PREVIOUSLY_SERIALIZED_ID_COMPONENT_ID() {
  return Companion_instance_21.r1q_1;
}
function get_STATIC_COMPONENT_ID() {
  return Companion_instance_21.s1q_1;
}
function get_POLYHEDRON_VISUALIZATION_HOLDER_COMPONENT_ID() {
  return Companion_instance_21.t1q_1;
}
function get_ROOM_PART_COMPONENT_ID() {
  return Companion_instance_21.u1q_1;
}
function get_GUEST_CONNECTIONS_COMPONENT_ID() {
  return Companion_instance_21.v1q_1;
}
function get_HOST_CONNECTIONS_COMPONENT_ID() {
  return Companion_instance_21.w1q_1;
}
function get_SERIALIZABLE_CONNECTIONS_COMPONENT_ID() {
  return Companion_instance_21.x1q_1;
}
function get_TEMPORARILY_PAUSE_CONNECTIONS_PARENTING_COMPONENT_ID() {
  return Companion_instance_21.y1q_1;
}
function get_POLYHEDRON_VISUALIZATION_NODE_COMPONENT_ID() {
  return Companion_instance_21.z1q_1;
}
function get_COLLIDER_VISUALIZATION_CONFIG_COMPONENT_ID() {
  return Companion_instance_21.a1r_1;
}
function get_CONNECTOR_VISUALIZATION_CONFIG_COMPONENT_ID() {
  return Companion_instance_21.b1r_1;
}
function get_OUTLINE_BLOCKING_COMPONENT_ID() {
  return Companion_instance_21.c1r_1;
}
function get_LABEL_COMPONENT_ID() {
  return Companion_instance_21.d1r_1;
}
function get_DRAG_PROJECTION_POINT_COMPONENT_ID() {
  return Companion_instance_21.e1r_1;
}
function get_COLORED_OUTLINE_COMPONENT_ID() {
  return Companion_instance_21.f1r_1;
}
function get_AUTOMATIC_GROUP_ID_COUNT_COMPONENT_ID() {
  return Companion_instance_21.g1r_1;
}
function get_SCENE_MANAGER_CACHE_COMPONENT_ID() {
  return Companion_instance_21.h1r_1;
}
function get_PRODUCT_STRUCTURE_COMPONENT_ID() {
  return Companion_instance_21.i1r_1;
}
function get_CAMERA_COMPONENT_ID() {
  return Companion_instance_21.j1r_1;
}
function get_DEBUG_SURFACES_COMPONENT() {
  return Companion_instance_21.k1r_1;
}
function get_FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID() {
  return Companion_instance_21.l1r_1;
}
function get_FUNCTIONAL_ZONES_WORLD_COMPONENT_ID() {
  return Companion_instance_21.m1r_1;
}
function get_UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID() {
  return Companion_instance_21.n1r_1;
}
function get_MODEL_TRANSFORM_COMPONENT_ID() {
  return Companion_instance_21.o1r_1;
}
function get_AUTO_ADAPT_SESSION_COMPONENT_ID() {
  return Companion_instance_21.p1r_1;
}
function get_AUTO_ADAPT_GUEST_COMPONENT_ID() {
  return Companion_instance_21.q1r_1;
}
function get_AUTO_ADAPT_HOST_COMPONENT_ID() {
  return Companion_instance_21.r1r_1;
}
function get_AUTO_ADAPT_CACHED_VARIANTS_COMPONENT_ID() {
  return Companion_instance_21.s1r_1;
}
function get_AUTO_ADAPT_VARIANT_COMPONENT_ID() {
  return Companion_instance_21.t1r_1;
}
function get_FORCE_AUTO_ADAPT_WHEN_PARENT_IS_DRAGGED_COMPONENT_ID() {
  return Companion_instance_21.u1r_1;
}
function get_REPLACED_WITH_AUTO_ADAPT_EVENT_COMPONENT_ID() {
  return Companion_instance_21.v1r_1;
}
function get_AUTO_ADAPT_CHILD_FAILED_EVENT_COMPONENT_ID() {
  return Companion_instance_21.w1r_1;
}
function get_AUTO_ADAPT_PRODUCT_SPECIFICATIONS_COMPONENT_ID() {
  return Companion_instance_21.x1r_1;
}
function get_VISUALIZATION_ENTITY_COMPONENT_ID() {
  return Companion_instance_21.y1r_1;
}
function get_ROOM_PART_ID_COMPONENT_ID() {
  return Companion_instance_21.z1r_1;
}
function get_CATALOG_SIZE_COMPONENT_ID() {
  return Companion_instance_21.a1s_1;
}
function get_GROUP_INFO_DURING_DESERIALIZING_COMPONENT_ID() {
  return Companion_instance_21.b1s_1;
}
function get_PRODUCT_PARAMS_COMPONENT_ID() {
  return Companion_instance_21.c1s_1;
}
function get_MULTI_DRAG_COMMON_PARENT_COMPONENT_ID() {
  return Companion_instance_21.d1s_1;
}
function get_REMOVED_DRAG_COMPONENTS_COMPONENT_ID() {
  return Companion_instance_21.e1s_1;
}
function get_PROPPING_PARENT_COMPONENT_ID() {
  return Companion_instance_21.f1s_1;
}
function get_PROPPING_HOST_CONNECTOR_DATA_COMPONENT_ID() {
  return Companion_instance_21.g1s_1;
}
function get_LARGEST_FITTING_PROPPING_COMPONENT_ID() {
  return Companion_instance_21.h1s_1;
}
function get_TEMPORARILY_IGNORE_MY_PROPPING_FUNCTIONAL_ZONES_COMPONENT_ID() {
  return Companion_instance_21.i1s_1;
}
function get_CURRENT_PROPPING_COMPONENT_ID() {
  return Companion_instance_21.j1s_1;
}
function get_SLOW_REPLACE_IN_PROGRESS_COMPONENT_ID() {
  return Companion_instance_21.k1s_1;
}
function get_SELECTION_GROUPS_COMPONENT_ID() {
  return Companion_instance_21.l1s_1;
}
function get_highestCoreComponentId() {
  return Companion_instance_21.m1s_1;
}
function isCoreComponent(component) {
  return Companion_instance_21.a27(component);
}
function isCoreComponentId(componentId) {
  return Companion_instance_21.isCoreComponentId(componentId);
}
function ComponentIds() {
}
function Companion_22() {
}
protoOf(Companion_22).b27 = function (entity) {
  return get_isSelected(entity);
};
protoOf(Companion_22).c27 = function (entity) {
  return get_selectableComponent(entity);
};
protoOf(Companion_22).d27 = function (entity) {
  return get_isSelectable(entity);
};
protoOf(Companion_22).e27 = function (entity) {
  return get_displayName(entity);
};
protoOf(Companion_22).f27 = function (entity) {
  return get_connectorsComponent(entity);
};
protoOf(Companion_22).g27 = function (entity) {
  var tmp0_safe_receiver = get_connectorsComponent(entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
};
protoOf(Companion_22).h27 = function (entity) {
  return get_highestPriorityConnection(entity);
};
protoOf(Companion_22).i27 = function (entity) {
  return get_snapRoot(entity);
};
protoOf(Companion_22).j27 = function (entity) {
  return entity.hasComponent(Companion_instance_21.w1o_1);
};
protoOf(Companion_22).k27 = function (entity) {
  var draggable = findWithComponentInUpwardsHierarchy_0(entity, Companion_getInstance_45().id);
  var snapRoot = draggable == null ? null : findWithComponentInUpwardsHierarchy_0(draggable, Companion_getInstance_137().id);
  return snapRoot;
};
protoOf(Companion_22).l27 = function (entity) {
  return findWithComponentInUpwardsHierarchy_0(entity, Companion_getInstance_107().id);
};
protoOf(Companion_22).m27 = function (entity) {
  return get_previousId(entity);
};
var Companion_instance_22;
function Companion_getInstance_23() {
  return Companion_instance_22;
}
function isSelected(entity) {
  return Companion_instance_22.b27(entity);
}
function selectableComponent(entity) {
  return Companion_instance_22.c27(entity);
}
function isSelectable(entity) {
  return Companion_instance_22.d27(entity);
}
function displayName(entity) {
  return Companion_instance_22.e27(entity);
}
function connectorsComponent(entity) {
  return Companion_instance_22.f27(entity);
}
function connectors(entity) {
  return Companion_instance_22.g27(entity);
}
function connection(entity) {
  return Companion_instance_22.h27(entity);
}
function snapRoot(entity) {
  return Companion_instance_22.i27(entity);
}
function isRoom(entity) {
  return Companion_instance_22.j27(entity);
}
function draggableRootEntity(entity) {
  return Companion_instance_22.k27(entity);
}
function selectableRootEntity(entity) {
  return Companion_instance_22.l27(entity);
}
function previousId(entity) {
  return Companion_instance_22.m27(entity);
}
function ComponentUtils() {
}
function get_selectableRoot(_this__u8e3s4) {
  return Companion_instance_22.l27(_this__u8e3s4);
}
function get_draggableRootEntity(_this__u8e3s4) {
  return Companion_instance_22.k27(_this__u8e3s4);
}
function isSameConnector($this, otherEntity1, otherEntity2, otherConnector1, otherConnector2) {
  return $this.demandingEntity === otherEntity1 && $this.demandingConnector.key === otherConnector1.key && $this.offeringEntity === otherEntity2 && $this.offeringConnector.key === otherConnector2.key;
}
function AlignmentConnection(demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform) {
  this.demandingEntity = demandingEntity;
  this.demandingConnector = demandingConnector;
  this.offeringEntity = offeringEntity;
  this.offeringConnector = offeringConnector;
  this.offeringDemandingConnectorDeltaTransform = offeringDemandingConnectorDeltaTransform;
}
protoOf(AlignmentConnection).n27 = function () {
  return this.demandingEntity;
};
protoOf(AlignmentConnection).q1u = function () {
  return this.demandingConnector;
};
protoOf(AlignmentConnection).o27 = function () {
  return this.offeringEntity;
};
protoOf(AlignmentConnection).r1u = function () {
  return this.offeringConnector;
};
protoOf(AlignmentConnection).p27 = function () {
  return this.offeringDemandingConnectorDeltaTransform;
};
protoOf(AlignmentConnection).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof AlignmentConnection))
    THROW_CCE();
  return isSameConnector(this, other.demandingEntity, other.offeringEntity, other.demandingConnector, other.offeringConnector) && this.offeringDemandingConnectorDeltaTransform.almostEquals(other.offeringDemandingConnectorDeltaTransform) || (isSameConnector(this, other.offeringEntity, other.demandingEntity, other.offeringConnector, other.demandingConnector) && this.offeringDemandingConnectorDeltaTransform.almostEquals(other.offeringDemandingConnectorDeltaTransform.inverse()));
};
protoOf(AlignmentConnection).toString = function () {
  return '' + get_displayName(this.demandingEntity) + ', ' + this.demandingConnector.key + ', ' + get_displayName(this.offeringEntity) + ', ' + this.offeringConnector.key;
};
protoOf(AlignmentConnection).hashCode = function () {
  var result = this.demandingEntity.hashCode();
  result = imul(31, result) + this.offeringEntity.hashCode() | 0;
  return result;
};
protoOf(AlignmentConnection).tf = function () {
  return this.demandingEntity;
};
protoOf(AlignmentConnection).uf = function () {
  return this.demandingConnector;
};
protoOf(AlignmentConnection).m1m = function () {
  return this.offeringEntity;
};
protoOf(AlignmentConnection).n1m = function () {
  return this.offeringConnector;
};
protoOf(AlignmentConnection).o1m = function () {
  return this.offeringDemandingConnectorDeltaTransform;
};
protoOf(AlignmentConnection).q27 = function (demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform) {
  return new AlignmentConnection(demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform);
};
protoOf(AlignmentConnection).copy = function (demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform, $super) {
  demandingEntity = demandingEntity === VOID ? this.demandingEntity : demandingEntity;
  demandingConnector = demandingConnector === VOID ? this.demandingConnector : demandingConnector;
  offeringEntity = offeringEntity === VOID ? this.offeringEntity : offeringEntity;
  offeringConnector = offeringConnector === VOID ? this.offeringConnector : offeringConnector;
  offeringDemandingConnectorDeltaTransform = offeringDemandingConnectorDeltaTransform === VOID ? this.offeringDemandingConnectorDeltaTransform : offeringDemandingConnectorDeltaTransform;
  return this.q27(demandingEntity, demandingConnector, offeringEntity, offeringConnector, offeringDemandingConnectorDeltaTransform);
};
function Companion_23() {
  this.ID = 'ChildConnection';
}
protoOf(Companion_23).j1y = function () {
  return this.ID;
};
var Companion_instance_23;
function Companion_getInstance_24() {
  return Companion_instance_23;
}
function validate_0($this, entity, snap) {
  var productRef = toString(get_productRef(entity));
  if (!(snap == null))
    return null;
  var tmp0_elvis_lhs = get_highestPriorityConnection(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var connection = tmp;
  var host = connection.hostConnectorEntity;
  var oldHostConnector_0 = oldHostConnector($this, connection);
  var tmp1_safe_receiver = get_connectorsComponent(host);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r27();
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp2_safe_receiver.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.connections.ChildConnectionValidation.validate.<anonymous>' call
        if (element.key === oldHostConnector_0.key) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp_0 = tmp$ret$1;
  }
  var tmp3_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp3_elvis_lhs == null) {
    return Companion_instance_153.fail('The host connector ' + connection.hostConnectorKey + ' could no longer be found on ' + host.toString(), productRef, $this);
  } else {
    tmp_1 = tmp3_elvis_lhs;
  }
  var hostConnector = tmp_1;
  var hostConnectorStillContainsGuest = hostConnector.containsConnector(get_worldTransform(host), get_worldTransform(connection.guestConnectorEntity), connection.guestConnector);
  if (!hostConnectorStillContainsGuest)
    return Companion_instance_153.fail('The host connector ' + connection.hostConnectorKey + ' could no longer supports the guest connector position', productRef, $this);
  return null;
}
function oldHostConnector($this, connection) {
  var hostConnector = connection.hostConnector;
  var tmp;
  if (hostConnector instanceof PointSeriesSubConnector) {
    tmp = hostConnector.series;
  } else {
    tmp = hostConnector;
  }
  return tmp;
}
function ChildConnectionValidation() {
  ValidationImpl.call(this);
  this.f28_1 = Companion_instance_23.ID;
}
protoOf(ChildConnectionValidation).n1s = function () {
  return this.f28_1;
};
protoOf(ChildConnectionValidation).validateCurrentState = function (entity) {
  return validate_0(this, entity, null);
};
protoOf(ChildConnectionValidation).validateSnap = function (snap) {
  return validate_0(this, snap.guestRoot, snap);
};
function Connection_init_$Init$(guestConnectorEntity, guestConnector, hostConnectorEntity, hostConnector, hostGuestConnectorDeltaTransform, $this) {
  Connection.call($this, guestConnectorEntity, guestConnector.key, hostConnectorEntity, hostConnector.key, hostGuestConnectorDeltaTransform);
  return $this;
}
function fromConnectors(guestConnectorEntity, guestConnector, hostConnectorEntity, hostConnector, hostGuestConnectorDeltaTransform) {
  return Connection_init_$Init$(guestConnectorEntity, guestConnector, hostConnectorEntity, hostConnector, hostGuestConnectorDeltaTransform, objectCreate(protoOf(Connection)));
}
function Connection(guestConnectorEntity, guestConnectorKey, hostConnectorEntity, hostConnectorKey, hostGuestConnectorDeltaTransform) {
  this.guestConnectorEntity = guestConnectorEntity;
  this.guestConnectorKey = guestConnectorKey;
  this.hostConnectorEntity = hostConnectorEntity;
  this.hostConnectorKey = hostConnectorKey;
  this.hostGuestConnectorDeltaTransform = hostGuestConnectorDeltaTransform;
  this.hostGuestDeltaTransform = get_worldTransform(this.guestConnectorEntity).delta(get_worldTransform(this.hostConnectorEntity));
}
protoOf(Connection).g28 = function () {
  return this.guestConnectorEntity;
};
protoOf(Connection).h28 = function () {
  return this.guestConnectorKey;
};
protoOf(Connection).i28 = function () {
  return this.hostConnectorEntity;
};
protoOf(Connection).j28 = function () {
  return this.hostConnectorKey;
};
protoOf(Connection).k28 = function () {
  return this.hostGuestConnectorDeltaTransform;
};
protoOf(Connection).l28 = function () {
  var tmp0_elvis_lhs = get_connectionRootEntity(this.guestConnectorEntity);
  return tmp0_elvis_lhs == null ? this.guestConnectorEntity : tmp0_elvis_lhs;
};
protoOf(Connection).m28 = function () {
  var tmp0_elvis_lhs = get_connectionRootEntity(this.hostConnectorEntity);
  return tmp0_elvis_lhs == null ? this.hostConnectorEntity : tmp0_elvis_lhs;
};
protoOf(Connection).n28 = function () {
  return this.hostConnector.priority + this.guestConnector.priority | 0;
};
protoOf(Connection).o28 = function () {
  var tmp0_elvis_lhs = this.guestConnectorEntity.getComponentUnsafe(Companion_instance_21.h1n_1).getConnectorByKey(this.guestConnectorKey);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw Exception_init_$Create$('Connector key ' + this.guestConnectorKey + ' does not exist on ' + this.toString());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(Connection).p28 = function () {
  var tmp0_elvis_lhs = this.hostConnectorEntity.getComponentUnsafe(Companion_instance_21.h1n_1).getConnectorByKey(this.hostConnectorKey);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw Exception_init_$Create$('Connector key ' + this.hostConnectorKey + ' does not exist on ' + this.toString());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(Connection).q28 = function () {
  return this.hostGuestDeltaTransform;
};
protoOf(Connection).r28 = function () {
  return this.guestConnectionRoot.equals(this.guestConnectorEntity);
};
protoOf(Connection).s28 = function () {
  return get_worldTransform(this.guestConnectorEntity).transformPosition(this.guestConnector.transform.position);
};
protoOf(Connection).t28 = function () {
  return get_worldTransform(this.hostConnectorEntity).transformPosition(this.hostConnector.transform.position);
};
protoOf(Connection).toString = function () {
  return 'Connection[' + get_displayName(this.hostConnectionRoot) + ' ' + this.hostConnectorKey + '<->' + this.guestConnectionRoot.toString() + '.displayName} ' + this.guestConnectorKey + ' delta: ' + this.hostGuestConnectorDeltaTransform.toString() + ']';
};
protoOf(Connection).tf = function () {
  return this.guestConnectorEntity;
};
protoOf(Connection).uf = function () {
  return this.guestConnectorKey;
};
protoOf(Connection).m1m = function () {
  return this.hostConnectorEntity;
};
protoOf(Connection).n1m = function () {
  return this.hostConnectorKey;
};
protoOf(Connection).o1m = function () {
  return this.hostGuestConnectorDeltaTransform;
};
protoOf(Connection).u28 = function (guestConnectorEntity, guestConnectorKey, hostConnectorEntity, hostConnectorKey, hostGuestConnectorDeltaTransform) {
  return new Connection(guestConnectorEntity, guestConnectorKey, hostConnectorEntity, hostConnectorKey, hostGuestConnectorDeltaTransform);
};
protoOf(Connection).copy = function (guestConnectorEntity, guestConnectorKey, hostConnectorEntity, hostConnectorKey, hostGuestConnectorDeltaTransform, $super) {
  guestConnectorEntity = guestConnectorEntity === VOID ? this.guestConnectorEntity : guestConnectorEntity;
  guestConnectorKey = guestConnectorKey === VOID ? this.guestConnectorKey : guestConnectorKey;
  hostConnectorEntity = hostConnectorEntity === VOID ? this.hostConnectorEntity : hostConnectorEntity;
  hostConnectorKey = hostConnectorKey === VOID ? this.hostConnectorKey : hostConnectorKey;
  hostGuestConnectorDeltaTransform = hostGuestConnectorDeltaTransform === VOID ? this.hostGuestConnectorDeltaTransform : hostGuestConnectorDeltaTransform;
  return this.u28(guestConnectorEntity, guestConnectorKey, hostConnectorEntity, hostConnectorKey, hostGuestConnectorDeltaTransform);
};
protoOf(Connection).hashCode = function () {
  var result = this.guestConnectorEntity.hashCode();
  result = imul(result, 31) + getStringHashCode(this.guestConnectorKey) | 0;
  result = imul(result, 31) + this.hostConnectorEntity.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.hostConnectorKey) | 0;
  result = imul(result, 31) + this.hostGuestConnectorDeltaTransform.hashCode() | 0;
  return result;
};
protoOf(Connection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Connection))
    return false;
  var tmp0_other_with_cast = other instanceof Connection ? other : THROW_CCE();
  if (!this.guestConnectorEntity.equals(tmp0_other_with_cast.guestConnectorEntity))
    return false;
  if (!(this.guestConnectorKey === tmp0_other_with_cast.guestConnectorKey))
    return false;
  if (!this.hostConnectorEntity.equals(tmp0_other_with_cast.hostConnectorEntity))
    return false;
  if (!(this.hostConnectorKey === tmp0_other_with_cast.hostConnectorKey))
    return false;
  if (!this.hostGuestConnectorDeltaTransform.equals(tmp0_other_with_cast.hostGuestConnectorDeltaTransform))
    return false;
  return true;
};
function Companion_24() {
  Companion_instance_24 = this;
  this.id = Companion_instance_21.y1n_1;
}
protoOf(Companion_24).n1s = function () {
  return this.id;
};
var Companion_instance_24;
function Companion_getInstance_25() {
  if (Companion_instance_24 == null)
    new Companion_24();
  return Companion_instance_24;
}
function ConnectionRootComponent() {
  Companion_getInstance_25();
}
protoOf(ConnectionRootComponent).p1s = function () {
  return Companion_getInstance_25().id;
};
protoOf(ConnectionRootComponent).eq = function (other) {
  return true;
};
function get_isConnectionRoot(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_getInstance_25().id);
}
function tryCreatePartConnection($this, hostPart, guestPart, guestConnector) {
  var tmp0_safe_receiver = get_connectorsComponent(hostPart);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r27();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : asSequence_1(tmp1_safe_receiver);
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    tmp = filter(tmp2_safe_receiver, ConnectionUtils$Companion$tryCreatePartConnection$lambda(guestConnector));
  }
  var tmp3_safe_receiver = tmp;
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    tmp_0 = filter(tmp3_safe_receiver, ConnectionUtils$Companion$tryCreatePartConnection$lambda_0(hostPart, guestConnector, guestPart));
  }
  var tmp4_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp4_safe_receiver == null) {
    tmp_1 = null;
  } else {
    tmp_1 = map(tmp4_safe_receiver, ConnectionUtils$Companion$tryCreatePartConnection$lambda_1(hostPart, guestPart, guestConnector));
  }
  var tmp5_safe_receiver = tmp_1;
  var connection = tmp5_safe_receiver == null ? null : firstOrNull_0(tmp5_safe_receiver);
  return connection;
}
function tryAligning($this, guestAlignment, hostAlignment, hostEntity, guestEntity, result) {
  var matchingAlignmentTags = guestAlignment.hasMatchingTypeAndDemandsTo(hostAlignment);
  var canAlign = matchingAlignmentTags && (hostAlignment.containsConnector(get_worldTransform(hostEntity), get_worldTransform(guestEntity), guestAlignment) || guestAlignment.containsConnector(get_worldTransform(guestEntity), get_worldTransform(hostEntity), hostAlignment));
  if (canAlign) {
    var connectorsDeltaTransform = hostAlignment.getDeltaTransformToGuestConnectorEntity(hostEntity, guestEntity, guestAlignment);
    result.h(new AlignmentConnection(guestEntity, guestAlignment, hostEntity, hostAlignment, connectorsDeltaTransform));
  }
}
function getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly($this, entity) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var list = ArrayList_init_$Create$();
  getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly$searchConnectionGraphForGuests(entity, list, entity);
  return list;
}
function disconnectGroup($this, group) {
  var hierarchy = get_hierarchy(group);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = hierarchy.length;
  while (inductionVariable < last) {
    var element = hierarchy[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.Companion.disconnectGroup.<anonymous>' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_guestConnections(element);
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.connections.Companion.disconnectGroup.<anonymous>.<anonymous>' call
      if (contains(hierarchy, element_0.hostConnectorEntity)) {
        destination.h(element_0);
      }
    }
    var guestConnectionsToKeep = copyToArray(destination);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(guestConnectionsToKeep.length === 0))
      element.addComponent(new GuestConnectionsComponent(guestConnectionsToKeep));
    else {
      element.removeComponent(Companion_getInstance_27().id);
    }
  }
  setParent_0(group, null);
  return hierarchy;
}
function disconnectSingle($this, entity) {
  var guestsThatAreNotChildren = getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly($this, entity);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = guestsThatAreNotChildren.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.connections.Companion.disconnectSingle.<anonymous>' call
    element.removeComponent(Companion_getInstance_27().id);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator_0 = guestsThatAreNotChildren.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.connections.Companion.disconnectSingle.<anonymous>' call
    if (!element_0.isDisposed) {
      destination.h(element_0);
    }
  }
  return copyToArray(destination);
}
function getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly$searchConnectionGraphForGuests($entity, list, host) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_hostedConnections(host);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.Companion.getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly.searchConnectionGraphForGuests.<anonymous>' call
    var tmp0_safe_receiver = get_parent(element.guestConnectionRoot);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_connectionRootEntity(tmp0_safe_receiver);
    var parentOrAssembly = tmp1_elvis_lhs == null ? get_parent(element.guestConnectionRoot) : tmp1_elvis_lhs;
    if (!equals(parentOrAssembly, host) && !host.equals(element.guestConnectionRoot)) {
      getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly$searchConnectionGraphForGuests($entity, list, element.guestConnectionRoot);
    }
  }
  var isOriginalEntityButNotEntityGroup = host.equals($entity) && !get_isAutomaticGroup($entity);
  var tmp;
  if (host.hasComponent(Companion_getInstance_27().id) || isOriginalEntityButNotEntityGroup) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_0;
      if (isInterface(list, Collection)) {
        tmp_0 = list.r();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = list.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.connections.Companion.getEntityAndGuestsThatAreNotChildrenOfEntityOrAssembly.searchConnectionGraphForGuests.<anonymous>' call
        if (element_0.equals(host)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp = tmp$ret$0;
  } else {
    tmp = false;
  }
  if (tmp) {
    list.h(host);
  }
}
function ConnectionUtils$Companion$tryCreatePartConnection$lambda($guestConnector) {
  return function (hostConnector) {
    return $guestConnector.hasMatchingTypeAndDemandsTo(hostConnector);
  };
}
function ConnectionUtils$Companion$tryCreatePartConnection$lambda_0($hostPart, $guestConnector, $guestPart) {
  return function (hostConnector) {
    return hostConnector.closestSubConnectorFromOwnerEntity($hostPart, $guestConnector.getWorldPositionFromOwnerEntity($guestPart)).containsConnector(get_worldTransform($hostPart), get_worldTransform($guestPart), $guestConnector);
  };
}
function ConnectionUtils$Companion$tryCreatePartConnection$lambda_1($hostPart, $guestPart, $guestConnector) {
  return function (hostConnector) {
    var connectorsDeltaTransform = hostConnector.getDeltaTransformToGuestConnectorEntity($hostPart, $guestPart, $guestConnector);
    var hostConnectorPossiblySubConnector = hostConnector.closestSubConnectorFromOwnerEntity($hostPart, $guestConnector.getWorldPositionFromOwnerEntity($guestPart));
    return fromConnectors($guestPart, $guestConnector, $hostPart, hostConnectorPossiblySubConnector, connectorsDeltaTransform);
  };
}
function ConnectionUtils$Companion$matchingAlignmentConnections$lambda(it) {
  return !(get_alignmentConnectors(it) == null);
}
function Companion_25() {
}
protoOf(Companion_25).w28 = function (entity) {
  return get_guestConnections(entity);
};
protoOf(Companion_25).x28 = function (entity) {
  return get_highestPriorityConnection(entity);
};
protoOf(Companion_25).y28 = function (entity) {
  return get_isConnectionRoot(entity);
};
protoOf(Companion_25).z28 = function (entity) {
  return Companion_instance_62.a29(entity, Companion_getInstance_25().id);
};
protoOf(Companion_25).b29 = function (entity) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = get_immediateConnectionRootDescendants(entity);
  return copyToArray(this_0);
};
protoOf(Companion_25).c29 = function (entity) {
  var tmp0_elvis_lhs = get_snapRoot(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var snapRoot = tmp;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_snappingEntitiesArray(snapRoot);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.Companion.getExistingOutgoingGuestConnections.<anonymous>' call
    var tmp0_elvis_lhs_0 = get_connectionRootEntity(item);
    var tmp$ret$1 = tmp0_elvis_lhs_0 == null ? item : tmp0_elvis_lhs_0;
    destination.h(tmp$ret$1);
  }
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_1 = toSet(destination);
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = this_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.connections.Companion.getExistingOutgoingGuestConnections.<anonymous>' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = get_guestConnections(element);
    var destination_1 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_2.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_2[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.connections.Companion.getExistingOutgoingGuestConnections.<anonymous>.<anonymous>' call
      if (!equals(get_snapRoot(element_0.hostConnectorEntity), snapRoot)) {
        destination_1.h(element_0);
      }
    }
    var list = destination_1;
    addAll(destination_0, list);
  }
  return copyToArray(destination_0);
};
protoOf(Companion_25).d29 = function (guestSnapRoot, hostRoot) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [hostRoot];
  return this.e29(guestSnapRoot, tmp$ret$2);
};
protoOf(Companion_25).e29 = function (guestSnapRoot, hostRoots) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = hostRoots.length;
  while (inductionVariable < last) {
    var element = hostRoots[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.Companion.calculateAllConnectionsToHierarchies.<anonymous>' call
    var list = hierarchyExceptSubTreeSequence(element, guestSnapRoot);
    addAll_0(destination, list);
  }
  var others = asSequence_1(destination);
  var snappingEntities = get_snappingHierarchyEntitiesList(guestSnapRoot);
  if (snappingEntities.r()) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var res = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = snappingEntities.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.connections.Companion.calculateAllConnectionsToHierarchies.<anonymous>' call
    var tmp0_safe_receiver = get_connectorsComponent(element_0);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = tmp1_safe_receiver.k();
      while (tmp0_iterator_0.m()) {
        var element_1 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.connections.Companion.calculateAllConnectionsToHierarchies.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.sequences.forEach' call
        var tmp0_iterator_1 = others.k();
        while (tmp0_iterator_1.m()) {
          var element_2 = tmp0_iterator_1.n();
          // Inline function 'com.ikea.core.connections.Companion.calculateAllConnectionsToHierarchies.<anonymous>.<anonymous>.<anonymous>' call
          var partConnection = tryCreatePartConnection(Companion_instance_25, element_2, element_0, element_1);
          if (!(partConnection == null)) {
            res.h(partConnection);
          }
        }
      }
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(res);
};
protoOf(Companion_25).g29 = function (connectionsRoot, hostRoot) {
  var guestHierarchyRoot = Companion_instance_62.h29(connectionsRoot);
  var isPartOfSameHierarchy = hostRoot.equals(guestHierarchyRoot);
  var tmp;
  if (isPartOfSameHierarchy) {
    tmp = this.d29(connectionsRoot, hostRoot);
  } else {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [hostRoot, guestHierarchyRoot];
    tmp = this.e29(connectionsRoot, tmp$ret$2);
  }
  var connections = tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(connections.length === 0)) {
    var guestConnections = new GuestConnectionsComponent(connections);
    connectionsRoot.addComponent(guestConnections);
  } else {
    connectionsRoot.removeComponent(Companion_getInstance_27().id);
  }
};
protoOf(Companion_25).i29 = function (entity, otherEntities) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var result = ArrayList_init_$Create$();
  var tmp = get_snappingHierarchyEntitiesSequence(entity);
  var guestAssemblyHierarchy = toSet_0(filter(tmp, ConnectionUtils$Companion$matchingAlignmentConnections$lambda));
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = otherEntities.length;
  while (inductionVariable < last) {
    var element = otherEntities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.Companion.matchingAlignmentConnections.<anonymous>' call
    if (!guestAssemblyHierarchy.s(element)) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = guestAssemblyHierarchy.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.connections.Companion.matchingAlignmentConnections.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver = get_alignmentConnectors(element_0);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var tmp0_iterator_0 = tmp0_safe_receiver.k();
          while (tmp0_iterator_0.m()) {
            var element_1 = tmp0_iterator_0.n();
            // Inline function 'com.ikea.core.connections.Companion.matchingAlignmentConnections.<anonymous>.<anonymous>.<anonymous>' call
            var tmp0_safe_receiver_0 = get_alignmentConnectors(element);
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.collections.forEach' call
              var tmp0_iterator_1 = tmp0_safe_receiver_0.k();
              while (tmp0_iterator_1.m()) {
                var element_2 = tmp0_iterator_1.n();
                // Inline function 'com.ikea.core.connections.Companion.matchingAlignmentConnections.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                tryAligning(Companion_instance_25, element_1, element_2, element, element_0, result);
              }
            }
            var tmp1_safe_receiver = get_hostConnectors(element);
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.collections.forEach' call
              var tmp0_iterator_2 = tmp1_safe_receiver.k();
              while (tmp0_iterator_2.m()) {
                var element_3 = tmp0_iterator_2.n();
                // Inline function 'com.ikea.core.connections.Companion.matchingAlignmentConnections.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                tryAligning(Companion_instance_25, element_1, element_3, element, element_0, result);
              }
            }
          }
        }
      }
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(result);
};
protoOf(Companion_25).j29 = function (entity) {
  if (get_isGroup(entity)) {
    return disconnectGroup(this, entity);
  } else {
    return disconnectSingle(this, entity);
  }
};
protoOf(Companion_25).k29 = function (entity) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [entity];
  this.l29(tmp$ret$2);
  return entity;
};
protoOf(Companion_25).l29 = function (entities) {
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    $l$block: {
      // Inline function 'com.ikea.core.connections.Companion.disconnectAndDisposeEntitiesAndHierarchies.<anonymous>' call
      if (element.isDisposed) {
        break $l$block;
      }
      var disconnectedEntities = Companion_instance_25.j29(element);
      element.dispose();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = disconnectedEntities.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = disconnectedEntities[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.connections.Companion.disconnectAndDisposeEntitiesAndHierarchies.<anonymous>.<anonymous>' call
        if (!element_0.isDisposed) {
          destination.h(element_0);
        }
      }
      var tmp0_iterator = destination.k();
      while (tmp0_iterator.m()) {
        var element_1 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.connections.Companion.disconnectAndDisposeEntitiesAndHierarchies.<anonymous>.<anonymous>' call
        element_1.dispose();
      }
    }
  }
  return entities;
};
var Companion_instance_25;
function Companion_getInstance_26() {
  return Companion_instance_25;
}
function getGuestConnections(entity) {
  return Companion_instance_25.w28(entity);
}
function getHighestPriorityConnection(entity) {
  return Companion_instance_25.x28(entity);
}
function isConnectionRoot(entity) {
  return Companion_instance_25.y28(entity);
}
function connectionRootEntity(entity) {
  return Companion_instance_25.z28(entity);
}
function immediateConnectionRootDescendants(entity) {
  return Companion_instance_25.b29(entity);
}
function getExistingOutgoingGuestConnections(entity) {
  return Companion_instance_25.c29(entity);
}
function calculateAllConnectionsToHierarchy(guestSnapRoot, hostRoot) {
  return Companion_instance_25.d29(guestSnapRoot, hostRoot);
}
function calculateAllConnectionsToHierarchies(guestSnapRoot, hostRoots) {
  return Companion_instance_25.e29(guestSnapRoot, hostRoots);
}
function refreshConnections(connectionsRoot, hostRoot) {
  return Companion_instance_25.g29(connectionsRoot, hostRoot);
}
function matchingAlignmentConnections(entity, otherEntities) {
  return Companion_instance_25.i29(entity, otherEntities);
}
function disconnect(entity) {
  return Companion_instance_25.j29(entity);
}
function disconnectAndDisposeEntityAndHierarchy(entity) {
  return Companion_instance_25.k29(entity);
}
function disconnectAndDisposeEntitiesAndHierarchies(entities) {
  return Companion_instance_25.l29(entities);
}
function ConnectionUtils() {
}
function get_highestPriorityConnection(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_27().id);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.highestPriorityConnection;
}
function get_connectionRootEntity(_this__u8e3s4) {
  return Companion_instance_25.z28(_this__u8e3s4);
}
function get_guestConnections(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_27().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connections;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function get_immediateConnectionRootDescendants(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_children(_this__u8e3s4);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.<get-immediateConnectionRootDescendants>.<anonymous>' call
    var list = get_isConnectionRoot(element) ? listOf(element) : get_immediateConnectionRootDescendants(element);
    addAll(destination, list);
  }
  return destination;
}
function Companion_26() {
  Companion_instance_26 = this;
  this.id = Companion_instance_21.v1q_1;
  this.v28_1 = LoggerState_getInstance().g1v('GuestConnectionsComponent');
}
protoOf(Companion_26).n1s = function () {
  return this.id;
};
var Companion_instance_26;
function Companion_getInstance_27() {
  if (Companion_instance_26 == null)
    new Companion_26();
  return Companion_instance_26;
}
function GuestConnectionsComponent$lambda(it) {
  return it.guestConnectorEntity.id;
}
function GuestConnectionsComponent$lambda_0(it) {
  return it.hostConnectorEntity.id;
}
function GuestConnectionsComponent$lambda_1(it) {
  return it.guestConnectorKey;
}
function GuestConnectionsComponent$lambda_2(it) {
  return it.hostConnectorKey;
}
function GuestConnectionsComponent$hasMultipleHosts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.count' call
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.connections;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.hasMultipleHosts$delegate.<anonymous>.<anonymous>' call
      if (!get_isStatic(element.hostConnectorEntity)) {
        destination.h(element);
      }
    }
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$();
    var tmp0_iterator = destination.k();
    while (tmp0_iterator.m()) {
      var e = tmp0_iterator.n();
      // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.hasMultipleHosts$delegate.<anonymous>.<anonymous>' call
      var key = get_connectionRootEntity(e.hostConnectorEntity);
      if (set.h(key)) {
        list.h(e);
      }
    }
    return list.o() > 1;
  };
}
function GuestConnectionsComponent$withReplacedConnection$lambda($newConnection) {
  return function () {
    return "couldn't find a connection matching " + $newConnection.toString() + ' to replace on ' + get_displayName($newConnection.guestConnectorEntity);
  };
}
function GuestConnectionsComponent(connections) {
  Companion_getInstance_27();
  this.connections = connections;
  this.m29_1 = Companion_getInstance_27().id;
  var tmp = GuestConnectionsComponent$lambda;
  var tmp_0 = GuestConnectionsComponent$lambda_0;
  var tmp_1 = GuestConnectionsComponent$lambda_1;
  sortWith(this.connections, compareBy([tmp, tmp_0, tmp_1, GuestConnectionsComponent$lambda_2]));
  var tmp_2 = this;
  tmp_2.n29_1 = lazy(GuestConnectionsComponent$hasMultipleHosts$delegate$lambda(this));
}
protoOf(GuestConnectionsComponent).o29 = function () {
  return this.connections;
};
protoOf(GuestConnectionsComponent).p1s = function () {
  return this.m29_1;
};
protoOf(GuestConnectionsComponent).eq = function (other) {
  if (this === other)
    return true;
  var that = unsafeCast(other);
  return contentEquals(this.connections, that.connections);
};
protoOf(GuestConnectionsComponent).p29 = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.n29_1;
  hasMultipleHosts$factory();
  return this_0.c2();
};
protoOf(GuestConnectionsComponent).q29 = function () {
  var tmp$ret$1;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxByOrNull' call
    var this_0 = this.connections;
    // Inline function 'kotlin.collections.isEmpty' call
    if (this_0.length === 0) {
      tmp$ret$1 = null;
      break $l$block_0;
    }
    var maxElem = this_0[0];
    var lastIndex = get_lastIndex(this_0);
    if (lastIndex === 0) {
      tmp$ret$1 = maxElem;
      break $l$block_0;
    }
    // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.<get-highestPriorityConnection>.<anonymous>' call
    var maxValue = maxElem.priority;
    var inductionVariable = 1;
    if (inductionVariable <= lastIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this_0[i];
        // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.<get-highestPriorityConnection>.<anonymous>' call
        var v = e.priority;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (!(i === lastIndex));
    tmp$ret$1 = maxElem;
  }
  return tmp$ret$1;
};
protoOf(GuestConnectionsComponent).withReplacedConnection = function (newConnection) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = this.connections;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.GuestConnectionsComponent.withReplacedConnection.<anonymous>' call
      if (element.guestConnectorEntity.equals(newConnection.guestConnectorEntity) && element.guestConnectorKey === newConnection.guestConnectorKey && element.hostConnectorKey === newConnection.hostConnectorKey) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var connectionToRemove = tmp$ret$1;
  if (connectionToRemove == null) {
    var tmp = Companion_getInstance_27().v28_1;
    tmp.warn(GuestConnectionsComponent$withReplacedConnection$lambda(newConnection));
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = this.connections;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [newConnection];
    var tmp$ret$7 = tmp$ret$3.concat(tmp$ret$6);
    return new GuestConnectionsComponent(tmp$ret$7);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = subtract(this.connections, setOf(connectionToRemove));
  var connectionsWithoutConnectionToRemove = copyToArray(this_1);
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$12 = [newConnection];
  var connectionsWithReplaced = connectionsWithoutConnectionToRemove.concat(tmp$ret$12);
  return new GuestConnectionsComponent(connectionsWithReplaced);
};
function get_hasMultipleHosts(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_27().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasMultipleHosts;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function centerOfConnections(connections) {
  var centerOfConnections = Companion_getInstance_81().ZERO;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = connections.length;
  while (inductionVariable < last) {
    var element = connections[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.centerOfConnections.<anonymous>' call
    centerOfConnections = centerOfConnections.plus(element.guestConnectorWorldPosition);
  }
  var tmp = centerOfConnections;
  // Inline function 'kotlin.collections.count' call
  var tmp$ret$0 = connections.length;
  centerOfConnections = tmp.__divIntForKotlin(tmp$ret$0);
  return centerOfConnections;
}
function hasMultipleHosts$factory() {
  return getPropertyCallableRef('hasMultipleHosts', 1, KProperty1, function (receiver) {
    return receiver.hasMultipleHosts;
  }, null);
}
function Companion_27() {
  Companion_instance_27 = this;
  this.id = Companion_instance_21.w1q_1;
}
protoOf(Companion_27).n1s = function () {
  return this.id;
};
var Companion_instance_27;
function Companion_getInstance_28() {
  if (Companion_instance_27 == null)
    new Companion_27();
  return Companion_instance_27;
}
function HostConnectionsComponent$lambda(it) {
  return it.guestConnectorEntity.id;
}
function HostConnectionsComponent$lambda_0(it) {
  return it.hostConnectorEntity.id;
}
function HostConnectionsComponent$lambda_1(it) {
  return it.guestConnectorKey;
}
function HostConnectionsComponent$lambda_2(it) {
  return it.hostConnectorKey;
}
function HostConnectionsComponent(connections) {
  Companion_getInstance_28();
  var tmp;
  if (connections === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = connections;
  }
  connections = tmp;
  this.connections = connections;
  this.o1l_1 = Companion_getInstance_28().id;
  var tmp_0 = HostConnectionsComponent$lambda;
  var tmp_1 = HostConnectionsComponent$lambda_0;
  var tmp_2 = HostConnectionsComponent$lambda_1;
  sortWith(this.connections, compareBy([tmp_0, tmp_1, tmp_2, HostConnectionsComponent$lambda_2]));
}
protoOf(HostConnectionsComponent).o29 = function () {
  return this.connections;
};
protoOf(HostConnectionsComponent).p1s = function () {
  return this.o1l_1;
};
protoOf(HostConnectionsComponent).eq = function (other) {
  if (this === other)
    return true;
  var that = unsafeCast(other);
  return contentEquals(this.connections, that.connections);
};
protoOf(HostConnectionsComponent).hashCode = function () {
  var result = contentHashCode(this.connections);
  result = imul(31, result) + this.o1l_1 | 0;
  return result;
};
protoOf(HostConnectionsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof HostConnectionsComponent))
    THROW_CCE();
  return this.eq(other);
};
protoOf(HostConnectionsComponent).tf = function () {
  return this.connections;
};
protoOf(HostConnectionsComponent).r29 = function (connections) {
  return new HostConnectionsComponent(connections);
};
protoOf(HostConnectionsComponent).copy = function (connections, $super) {
  connections = connections === VOID ? this.connections : connections;
  return this.r29(connections);
};
protoOf(HostConnectionsComponent).toString = function () {
  return 'HostConnectionsComponent(connections=' + toString_0(this.connections) + ')';
};
function get_hostedConnections(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_28().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connections;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function isHostingEntityWithMultipleHosts(_this__u8e3s4) {
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_hostedConnections(_this__u8e3s4);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.isHostingEntityWithMultipleHosts.<anonymous>' call
      var tmp$ret$0 = item.guestConnectionRoot;
      destination.h(tmp$ret$0);
    }
    var this_1 = distinct(destination);
    var tmp;
    if (isInterface(this_1, Collection)) {
      tmp = this_1.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$3 = false;
      break $l$block_0;
    }
    var tmp0_iterator = this_1.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.connections.isHostingEntityWithMultipleHosts.<anonymous>' call
      if (get_hasMultipleHosts(element) || isHostingEntityWithMultipleHosts(element)) {
        tmp$ret$3 = true;
        break $l$block_0;
      }
    }
    tmp$ret$3 = false;
  }
  return tmp$ret$3;
}
function addHostedConnection(_this__u8e3s4, connection) {
  var oldHostConnections = get_hostedConnections(_this__u8e3s4);
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [connection];
  var newHostConnections = oldHostConnections.concat(tmp$ret$3);
  _this__u8e3s4.addComponent(new HostConnectionsComponent(newHostConnections));
}
function removeHostedConnection(_this__u8e3s4, connection) {
  var oldHostConnections = get_hostedConnections(_this__u8e3s4);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = oldHostConnections.length;
  while (inductionVariable < last) {
    var element = oldHostConnections[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.removeHostedConnection.<anonymous>' call
    if (!element.equals(connection)) {
      destination.h(element);
    }
  }
  var newHostConnections = copyToArray(destination);
  // Inline function 'kotlin.collections.isEmpty' call
  if (newHostConnections.length === 0)
    _this__u8e3s4.removeComponent(Companion_getInstance_28().id);
  else {
    _this__u8e3s4.addComponent(new HostConnectionsComponent(newHostConnections));
  }
}
function get_guests(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_hostedConnections(_this__u8e3s4);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.<get-guests>.<anonymous>' call
    var tmp$ret$0 = item.guestConnectionRoot;
    destination.h(tmp$ret$0);
  }
  return distinct(destination);
}
function Companion_28() {
  Companion_instance_28 = this;
  this.s29_1 = Companion_instance_21.y1q_1;
}
var Companion_instance_28;
function Companion_getInstance_29() {
  if (Companion_instance_28 == null)
    new Companion_28();
  return Companion_instance_28;
}
function TemporarilyPauseConnectionParentingComponent() {
  Companion_getInstance_29();
  this.t29_1 = Companion_getInstance_29().s29_1;
}
protoOf(TemporarilyPauseConnectionParentingComponent).p1s = function () {
  return this.t29_1;
};
protoOf(TemporarilyPauseConnectionParentingComponent).eq = function (other) {
  return true;
};
function Companion_29() {
  this.ID = 'TemporaryParentConnectionValidation';
}
protoOf(Companion_29).j1y = function () {
  return this.ID;
};
var Companion_instance_29;
function Companion_getInstance_30() {
  return Companion_instance_29;
}
function validateSnap$canAllChildrenFormConnections($snap, entity) {
  var tmp$ret$3;
  $l$block_2: {
    // Inline function 'kotlin.collections.all' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(entity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last_0 = this_0.length;
    while (inductionVariable < last_0) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connections.TemporaryParentConnectionValidation.validateSnap.canAllChildrenFormConnections.<anonymous>' call
      if (!(element === $snap.guest)) {
        destination.h(element);
      }
    }
    var tmp;
    if (isInterface(destination, Collection)) {
      tmp = destination.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$3 = true;
      break $l$block_2;
    }
    var tmp0_iterator = destination.k();
    while (tmp0_iterator.m()) {
      var element_0 = tmp0_iterator.n();
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'com.ikea.core.connections.TemporaryParentConnectionValidation.validateSnap.canAllChildrenFormConnections.<anonymous>' call
        var tmp_0;
        if (element_0.hasComponent(Companion_getInstance_67().u29_1)) {
          tmp$ret$4 = validateSnap$canAllChildrenFormConnections($snap, element_0);
          break $l$block_1;
        } else {
          tmp$ret$4 = hasAtLeastOneConnectorFulfilledOnHosts(element_0, get_hierarchy(last(get_upwardsHierarchy($snap.host))));
          break $l$block_1;
        }
      }
      if (!tmp$ret$4) {
        tmp$ret$3 = false;
        break $l$block_2;
      }
    }
    tmp$ret$3 = true;
  }
  return tmp$ret$3;
}
function TemporaryParentConnectionValidation() {
  ValidationImpl.call(this);
  this.w29_1 = Companion_instance_29.ID;
}
protoOf(TemporaryParentConnectionValidation).n1s = function () {
  return this.w29_1;
};
protoOf(TemporaryParentConnectionValidation).validateCurrentState = function (entity) {
  return null;
};
protoOf(TemporaryParentConnectionValidation).validateSnap = function (snap) {
  if (!snap.guestRoot.hasComponent(Companion_instance_21.y1o_1)) {
    return null;
  }
  var tmp;
  if (validateSnap$canAllChildrenFormConnections(snap, snap.guestRoot)) {
    tmp = null;
  } else {
    var tmp_0 = Companion_instance_153;
    var tmp0_elvis_lhs = get_productRef(snap.guestRoot);
    tmp = tmp_0.fail('No available connection for entity with temporary parent', tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this);
  }
  return tmp;
};
function Companion_30() {
  this.x29_1 = 'UpdateHostConnectionsSystem';
}
var Companion_instance_30;
function Companion_getInstance_31() {
  return Companion_instance_30;
}
function UpdateHostConnectionsSystem() {
  SystemBase.call(this, Companion_instance_30.x29_1, Companion_getInstance_27().id);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.h2a_1 = [Companion_getInstance_28().id];
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.i2a_1 = [Companion_getInstance_60().j2a_1];
}
protoOf(UpdateHostConnectionsSystem).j1w = function () {
  return this.h2a_1;
};
protoOf(UpdateHostConnectionsSystem).k1w = function () {
  return this.i2a_1;
};
protoOf(UpdateHostConnectionsSystem).l2a = function (entity, newComponent) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = newComponent.connections;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.UpdateHostConnectionsSystem.onAddComponent.<anonymous>' call
    var tmp0_safe_receiver = get_connectionRootEntity(element.hostConnectorEntity);
    if (tmp0_safe_receiver == null)
      null;
    else {
      addHostedConnection(tmp0_safe_receiver, element);
    }
  }
};
protoOf(UpdateHostConnectionsSystem).v1v = function (entity, newComponent) {
  return this.l2a(entity, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(UpdateHostConnectionsSystem).m2a = function (entity, oldComponent, newComponent) {
  this.n2a(entity, oldComponent);
  this.l2a(entity, newComponent);
};
protoOf(UpdateHostConnectionsSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE();
  return this.m2a(entity, tmp, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(UpdateHostConnectionsSystem).n2a = function (entity, oldComponent) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = oldComponent.connections;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connections.UpdateHostConnectionsSystem.onRemoveComponent.<anonymous>' call
    if (!element.hostConnectorEntity.isDisposed) {
      var tmp0_safe_receiver = get_connectionRootEntity(element.hostConnectorEntity);
      if (tmp0_safe_receiver == null)
        null;
      else {
        removeHostedConnection(tmp0_safe_receiver, element);
      }
    }
  }
};
protoOf(UpdateHostConnectionsSystem).z1v = function (entity, oldComponent) {
  return this.n2a(entity, oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE());
};
function closestOnEdge(_this__u8e3s4, vertices) {
  var minDist = 1.7976931348623157E308;
  var p = vertices[0];
  var tmp;
  if (vertices.length <= 2) {
    tmp = 1;
  } else {
    tmp = vertices.length;
  }
  var edgesCnt = tmp;
  var inductionVariable = 0;
  if (inductionVariable < edgesCnt)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p1 = vertices[i];
      var p2 = vertices[(i + 1 | 0) % vertices.length | 0];
      var _destruct__k2r9zo = closestPointOnSegment(_this__u8e3s4, p1, p2);
      var dist = _destruct__k2r9zo.tf();
      var pp = _destruct__k2r9zo.uf();
      if (dist < minDist) {
        minDist = dist;
        p = pp;
      }
    }
     while (inductionVariable < edgesCnt);
  return p;
}
function closestPointOnSegment(guest, p1, p2) {
  var r = p2.minus(p1).normalize().__timesOperatorKotlin(guest.minus(p1));
  var tmp;
  if (r < 0) {
    tmp = new Pair(guest.minus(p1).size, p1);
  } else if (r > p2.minus(p1).size) {
    tmp = new Pair(guest.minus(p2).size, p2);
  } else {
    var e = p2.minus(p1).normalize();
    tmp = new Pair(e.cross(guest.minus(p1)).size, e.times(r).plus(p1));
  }
  return tmp;
}
function calculateRotationForGuestToSnapToMe($this, hostTransform, guestTransform, guestConnector) {
  var tmp0_subject = guestConnector.rotationalDegreeOfFreedom;
  if (tmp0_subject === RotationDegreeOfFreedom_NONE_getInstance().u2_1) {
    return guestTransform.rotation.inverse().times(guestConnector.transform.rotation.inverse()).times($this.transform.rotation).times(hostTransform.rotation);
  } else if (tmp0_subject === RotationDegreeOfFreedom_ONE_getInstance().u2_1) {
    var rotationAxisLS = $this.transform.up;
    var rotationAxisWS = hostTransform.transformVector(rotationAxisLS);
    var currentGuestRotationAxisWS = guestTransform.transformVector(guestConnector.transform.up);
    return currentGuestRotationAxisWS.getRotationTo(rotationAxisWS);
  } else
    throw new NotImplementedError('Rotational degree of freedom: ' + guestConnector.rotationalDegreeOfFreedom);
}
function calculateMovement($this, hostTransform, hostConnector, guestTransform, rotation, guestRootTransform) {
  var guestConnectorWorldSpace = guestTransform.transformPosition($this.transform.position);
  var guestConnectorPosAfterRotation = guestConnectorWorldSpace.rotateAroundPivot(rotation, guestRootTransform.position);
  var closestHostConnectorInWorldSpace = hostConnector.closestWhenUsingTransform(hostTransform, guestConnectorPosAfterRotation);
  return closestHostConnectorInWorldSpace.minus(guestConnectorPosAfterRotation);
}
function Companion_31() {
  this.DEFAULT_GUEST_ACTIVATION_DISTANCE = 200.0;
  this.DEFAULT_HOST_ACTIVATION_DISTANCE = 0.0;
}
protoOf(Companion_31).o2a = function () {
  return this.DEFAULT_GUEST_ACTIVATION_DISTANCE;
};
protoOf(Companion_31).p2a = function () {
  return this.DEFAULT_HOST_ACTIVATION_DISTANCE;
};
var Companion_instance_31;
function Companion_getInstance_32() {
  return Companion_instance_31;
}
function Connector$findHostConnectorsWithMatchingTypeAndDemands$lambda(this$0) {
  return function (hostConnector) {
    return this$0.hasMatchingTypeAndDemandsTo(hostConnector);
  };
}
function Connector$allSubConnectors$delegate$lambda(this$0) {
  return function () {
    return sequenceOf([this$0]);
  };
}
function Connector() {
  this.q2a_1 = RotationDegreeOfFreedom_NONE_getInstance().u2_1;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.r2a_1 = [];
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.s2a_1 = [];
  var tmp_1 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_1.t2a_1 = [];
  var tmp_2 = this;
  tmp_2.u2a_1 = lazy(Connector$allSubConnectors$delegate$lambda(this));
  this.v2a_1 = false;
}
protoOf(Connector).a2b = function () {
  return this.q2a_1;
};
protoOf(Connector).b2b = function (_set____db54di) {
  this.r2a_1 = _set____db54di;
};
protoOf(Connector).c2b = function () {
  return this.r2a_1;
};
protoOf(Connector).d2b = function (_set____db54di) {
  this.s2a_1 = _set____db54di;
};
protoOf(Connector).e2b = function () {
  return this.s2a_1;
};
protoOf(Connector).f2b = function (_set____db54di) {
  this.t2a_1 = _set____db54di;
};
protoOf(Connector).g2b = function () {
  return this.t2a_1;
};
protoOf(Connector).setDemands = function (tag) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  this.demandsArray = tag.slice();
  return this;
};
protoOf(Connector).setOffers = function (tag) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  this.offersArray = tag.slice();
  return this;
};
protoOf(Connector).withTag = function (name) {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = this.tagArray;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [name];
  var newTags = tmp$ret$0.concat(tmp$ret$3);
  this.tagArray = newTags;
  return this;
};
protoOf(Connector).removeTag = function (name) {
  if (contains(this.tagArray, name)) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.tagArray;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.Connector.removeTag.<anonymous>' call
      if (!(element === name)) {
        destination.h(element);
      }
    }
    this.tagArray = copyToArray(destination);
  }
  return this;
};
protoOf(Connector).tags = function () {
  return this.tagArray;
};
protoOf(Connector).offers = function () {
  return this.offersArray;
};
protoOf(Connector).demands = function () {
  return this.demandsArray;
};
protoOf(Connector).closestWhenUsingTransform = function (ownerTransform, pointWorldSpace) {
  var pointInLocalSpace = ownerTransform.inverseTransformPosition(pointWorldSpace);
  var closestInLocalSpace = this.closest(pointInLocalSpace);
  return ownerTransform.transformPosition(closestInLocalSpace);
};
protoOf(Connector).calculateRotation = function (hostTransform, hostConnector, guestTransform) {
  return calculateRotationForGuestToSnapToMe(hostConnector, hostTransform, guestTransform, this);
};
protoOf(Connector).calculateEndTransform = function (hostTransform, hostConnector, guestConnectorEntityTransform, guestSnappingRootTransform) {
  var rotation = this.calculateRotation(hostTransform, hostConnector, guestConnectorEntityTransform);
  var movement = calculateMovement(this, hostTransform, hostConnector, guestConnectorEntityTransform, rotation, guestSnappingRootTransform);
  var newWorldPosition = guestSnappingRootTransform.position.plus(movement);
  var newWorldRotation = guestSnappingRootTransform.rotation.times(rotation);
  return new Transform(newWorldPosition, newWorldRotation);
};
protoOf(Connector).isOffering = function (tag) {
  return contains(this.offers(), tag);
};
protoOf(Connector).isDemanding = function (tag) {
  return contains(this.demands(), tag);
};
protoOf(Connector).hasTag = function (tag) {
  return contains(this.tags(), tag);
};
protoOf(Connector).k2b = function (connectorsComponent) {
  var tmp1_safe_receiver = connectorsComponent == null ? null : connectorsComponent.i1l_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : asSequence_1(tmp1_safe_receiver);
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    tmp = filter(tmp2_safe_receiver, Connector$findHostConnectorsWithMatchingTypeAndDemands$lambda(this));
  }
  var tmp3_elvis_lhs = tmp;
  return tmp3_elvis_lhs == null ? emptySequence() : tmp3_elvis_lhs;
};
protoOf(Connector).hasMatchingTypeAndDemandsTo = function (offeringConnector) {
  var tmp;
  if (Companion_instance_32.p2b(this.type, offeringConnector.type)) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var indexedObject = this.demands();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.connectors.Connector.hasMatchingTypeAndDemandsTo.<anonymous>' call
        if (!offeringConnector.isOffering(element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    tmp = tmp$ret$1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(Connector).hasMatchingTags = function (offeringConnector) {
  return this.hasMatchingTypeAndDemandsTo(offeringConnector);
};
protoOf(Connector).containsConnector = function (ownerTransform, guestTransform, guestConnector) {
  var rotationNeededToSnap = guestConnector.calculateRotation(ownerTransform, this, guestTransform);
  if (!rotationNeededToSnap.equals(Companion_getInstance_74().q2b_1))
    return false;
  var movement = calculateMovement(guestConnector, ownerTransform, this, guestTransform, rotationNeededToSnap, guestTransform);
  return movement.equals(Companion_getInstance_81().ZERO);
};
protoOf(Connector).u2b = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.u2a_1;
  allSubConnectors$factory();
  return this_0.c2();
};
protoOf(Connector).v2b = function () {
  return this.v2a_1;
};
protoOf(Connector).closestSubConnector = function (localSpacePoint) {
  return this;
};
protoOf(Connector).closestSubConnectorFromOwnerEntity = function (owner, worldSpacePoint) {
  return this;
};
protoOf(Connector).closestSubConnectorFromOwnerAndGuest = function (owner, guest, guestConnector) {
  return this;
};
protoOf(Connector).getWorldPositionFromOwnerEntity = function (ownerEntity) {
  return this.getWorldPositionFromOwnerTransform(get_worldTransform(ownerEntity));
};
protoOf(Connector).getWorldPositionFromOwnerTransform = function (ownerTransform) {
  return ownerTransform.transformPosition(this.transform.position);
};
protoOf(Connector).equals = function (other) {
  return this === other;
};
protoOf(Connector).hashCode = function () {
  return getStringHashCode(this.key) + this.type | 0;
};
protoOf(Connector).getWorldRotation = function (transform) {
  return transform.transformRotation(this.transform.rotation);
};
protoOf(Connector).getDeltaTransformToGuestConnectorEntity = function (ownerEntity, guest, guestConnector) {
  return this.getDeltaTransformToGuestConnectorTransform(get_worldTransform(ownerEntity), get_worldTransform(guest), guestConnector);
};
protoOf(Connector).getDeltaTransformToGuestConnectorTransform = function (ownerTransform, guestTransform, guestConnector) {
  var hostConnectorTransform = ownerTransform.concatenate(this.transform);
  var guestConnectorTransform = guestTransform.concatenate(guestConnector.transform);
  return guestConnectorTransform.delta(hostConnectorTransform);
};
protoOf(Connector).isRotatedUpward = function (ownerEntity) {
  var totalRotation = get_worldRotation(ownerEntity).times(this.transform.rotation);
  var dotProduct = Companion_getInstance_81().UP.rotate(totalRotation).__timesOperatorKotlin(Companion_getInstance_81().UP);
  return dotProduct >= 0;
};
protoOf(Connector).isInActivationDistance = function (guestTransform, hostConnector, hostTransform) {
  var positionWorldSpace = this.getWorldPositionFromOwnerTransform(guestTransform);
  var closestPointInHostConnector = hostConnector.closestWhenUsingTransform(hostTransform, positionWorldSpace);
  var distance = positionWorldSpace.distanceTo(closestPointInHostConnector);
  return distance <= this.activationDistance + hostConnector.activationDistance;
};
function allSubConnectors$factory() {
  return getPropertyCallableRef('allSubConnectors', 1, KProperty1, function (receiver) {
    return receiver.u2b();
  }, null);
}
function ConnectorTagConstants() {
  this.w2b_1 = 'requireUpwardParent';
  this.x2b_1 = 'requireDownwardParent';
}
var ConnectorTagConstants_instance;
function ConnectorTagConstants_getInstance() {
  return ConnectorTagConstants_instance;
}
function Companion_32() {
  this.l2b_1 = 0;
  this.m2b_1 = 1;
  this.n2b_1 = 2;
  this.o2b_1 = 3;
}
protoOf(Companion_32).y2b = function () {
  return this.l2b_1;
};
protoOf(Companion_32).z2b = function () {
  return this.m2b_1;
};
protoOf(Companion_32).a2c = function () {
  return this.n2b_1;
};
protoOf(Companion_32).b2c = function () {
  return this.o2b_1;
};
protoOf(Companion_32).p2b = function (demanding, offering) {
  var tmp;
  if (demanding === this.l2b_1) {
    tmp = offering === this.m2b_1;
  } else if (demanding === this.m2b_1) {
    tmp = false;
  } else if (demanding === this.n2b_1) {
    tmp = offering === this.n2b_1 || offering === this.m2b_1;
  } else if (demanding === this.o2b_1) {
    tmp = false;
  } else {
    throw IllegalArgumentException_init_$Create$('There are only 4 connector types. Do not try to cheat CORE!');
  }
  return tmp;
};
var Companion_instance_32;
function Companion_getInstance_33() {
  return Companion_instance_32;
}
function get_GUEST() {
  return Companion_instance_32.l2b_1;
}
function get_HOST() {
  return Companion_instance_32.m2b_1;
}
function get_ALIGNMENT() {
  return Companion_instance_32.n2b_1;
}
function get_INTERNAL() {
  return Companion_instance_32.o2b_1;
}
function matches(demanding, offering) {
  return Companion_instance_32.p2b(demanding, offering);
}
function ConnectorType() {
}
function checkRequiredConnectorsOnParts($this, hostPart, guestPart, requiredConnector) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.sequences.any' call
    var tmp0_iterator = requiredConnector.k2b(get_connectorsComponent(hostPart)).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.connectors.Companion.checkRequiredConnectorsOnParts.<anonymous>' call
      if (element.containsConnector(get_worldTransform(hostPart), get_worldTransform(guestPart), requiredConnector)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function setEnabledStateForConnector($this, connectorKey, entity, enable) {
  var tmp0_elvis_lhs = entity.__getComponentForKotlin(Companion_getInstance_35().id);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var connectorsComponent = tmp;
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = connectorsComponent.connectors;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.Companion.setEnabledStateForConnector.<anonymous>' call
      var it = this_0[i];
      var tmp_0;
      if (it.key === connectorKey) {
        tmp_0 = it.enable(enable);
      } else {
        tmp_0 = it;
      }
      arr[i] = tmp_0;
    }
     while (inductionVariable <= last);
  var updatedConnectors = isArray(arr) ? arr : THROW_CCE();
  entity.addComponent(new ConnectorsComponent(updatedConnectors));
}
function findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost_pjpnxs($guestPart, $connector, host) {
  return !(findInHierarchyExceptHierarchyOfIgnored_0(host, $guestPart, ConnectorUtils$Companion$findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost$lambda_mo7f3n($guestPart, $connector)) == null);
}
function ConnectorUtils$Companion$snappingEntitiesSequence$lambda(it) {
  return it.hasComponent(Companion_getInstance_35().id);
}
function ConnectorUtils$Companion$snappingEntitiesSequence$lambda_0(it) {
  var tmp;
  var tmp0_safe_receiver = get_connectorsComponent(it);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
  if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
    tmp = true;
  } else {
    var tmp2_safe_receiver = get_connectorsComponent(it);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
    tmp = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
  }
  return tmp;
}
function ConnectorUtils$Companion$hasAtLeastOneConnectorFulfilledOnHosts$lambda($guestPart) {
  return function (hostPart) {
    return !equals(get_snapRoot(hostPart), get_snapRoot($guestPart));
  };
}
function ConnectorUtils$Companion$findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost$lambda_mo7f3n($$guestPart, $$connector) {
  return function (hostPart) {
    return checkRequiredConnectorsOnParts(Companion_instance_33, hostPart, $$guestPart, $$connector);
  };
}
function Companion_33() {
}
protoOf(Companion_33).e2c = function (entity) {
  var tmp = hierarchyExceptSubTreesWithComponentSequence(entity, Companion_getInstance_137().id);
  var tmp_0 = filter(tmp, ConnectorUtils$Companion$snappingEntitiesSequence$lambda);
  return filter(tmp_0, ConnectorUtils$Companion$snappingEntitiesSequence$lambda_0);
};
protoOf(Companion_33).f2c = function (entity) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = hierarchyExceptSubTreesWithComponentArray(entity, Companion_getInstance_137().id);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connectors.Companion.snappingEntitiesArray.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_35().id)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.connectors.Companion.snappingEntitiesArray.<anonymous>' call
    var tmp;
    var tmp0_safe_receiver = get_connectorsComponent(element_0);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
    if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
      tmp = true;
    } else {
      var tmp2_safe_receiver = get_connectorsComponent(element_0);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
      tmp = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
    }
    if (tmp) {
      destination_0.h(element_0);
    }
  }
  return copyToArray(destination_0);
};
protoOf(Companion_33).g2c = function (hostHierarchyRoots, guest) {
  var tmp0_safe_receiver = guest.__getComponentForKotlin(Companion_instance_131.id);
  var eligibleHosts = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allowedHosts;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_hierarchy(guest);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connectors.Companion.findUnfulfilledRequiredConnectors.<anonymous>' call
    var tmp0_safe_receiver_0 = get_connectorsComponent(element);
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.i2c();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !tmp1_safe_receiver.r();
    }
    if (tmp === true) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.connectors.Companion.findUnfulfilledRequiredConnectors.<anonymous>' call
    var tmp0_safe_receiver_1 = get_connectorsComponent(element_0);
    var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.i2c();
    var tmp_0;
    if (tmp1_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_1 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = tmp1_safe_receiver_0.k();
      while (tmp0_iterator_0.m()) {
        var element_1 = tmp0_iterator_0.n();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        var tmp$ret$7;
        $l$block_0: {
          // Inline function 'com.ikea.core.connectors.Companion.findUnfulfilledRequiredConnectors.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.find' call
          var this_1 = get_guestConnections(element_0);
          var tmp$ret$5;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_0 = 0;
            var last_0 = this_1.length;
            while (inductionVariable_0 < last_0) {
              var element_2 = this_1[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.connectors.Companion.findUnfulfilledRequiredConnectors.<anonymous>.<anonymous>.<anonymous>' call
              if (element_2.guestConnector.equals(element_1)) {
                tmp$ret$5 = element_2;
                break $l$block;
              }
            }
            tmp$ret$5 = null;
          }
          var currentConnectionToRequiredConnector = tmp$ret$5;
          var tmp1_safe_receiver_1 = currentConnectionToRequiredConnector == null ? null : currentConnectionToRequiredConnector.hostConnector;
          var isStillContained = (tmp1_safe_receiver_1 == null ? null : tmp1_safe_receiver_1.containsConnector(get_worldTransform(currentConnectionToRequiredConnector.hostConnectorEntity), get_worldTransform(element_0), element_1)) === true;
          if (isStillContained) {
            tmp$ret$7 = null;
            break $l$block_0;
          }
          var tmp_1;
          var tmp$ret$9;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var indexedObject = eligibleHosts == null ? hostHierarchyRoots : eligibleHosts;
            var inductionVariable_1 = 0;
            var last_1 = indexedObject.length;
            while (inductionVariable_1 < last_1) {
              var element_3 = indexedObject[inductionVariable_1];
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              // Inline function 'com.ikea.core.connectors.Companion.findUnfulfilledRequiredConnectors.<anonymous>.<anonymous>.<anonymous>' call
              if (findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost_pjpnxs(element_0, element_1, element_3)) {
                tmp$ret$9 = true;
                break $l$block_1;
              }
            }
            tmp$ret$9 = false;
          }
          if (tmp$ret$9) {
            tmp_1 = true;
          } else {
            tmp_1 = findUnfulfilledRequiredConnectors$_anonymous_$_anonymous_$checkHost_pjpnxs(element_0, element_1, guest);
          }
          var wasFulfilled = tmp_1;
          var tmp_2;
          if (!wasFulfilled) {
            tmp_2 = element_1;
          } else {
            tmp_2 = null;
          }
          tmp$ret$7 = tmp_2;
        }
        var tmp0_safe_receiver_2 = tmp$ret$7;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_1.h(tmp0_safe_receiver_2);
        }
      }
      tmp_0 = destination_1;
    }
    var tmp2_elvis_lhs = tmp_0;
    var unfulfilledConnectors = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
    var list = unfulfilledConnectors;
    addAll(destination_0, list);
  }
  return copyToArray(destination_0);
};
protoOf(Companion_33).j2c = function (host, guest) {
  var tmp0_elvis_lhs = get_hostConnectors(host);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var hostConnectors = tmp;
  var tmp1_elvis_lhs = get_guestConnectors(guest);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var guestConnectors = tmp_0;
  var _iterator__ex2g4s = hostConnectors.k();
  while (_iterator__ex2g4s.m()) {
    var hostConnector = _iterator__ex2g4s.n();
    var _iterator__ex2g4s_0 = guestConnectors.k();
    while (_iterator__ex2g4s_0.m()) {
      var guestConnector = _iterator__ex2g4s_0.n();
      if (guestConnector.hasMatchingTypeAndDemandsTo(hostConnector)) {
        return true;
      }
    }
  }
  return false;
};
protoOf(Companion_33).hasAtLeastOneConnectorFulfilledOnHosts = function (hosts, guest) {
  var tmp0_safe_receiver = guest.__getComponentForKotlin(Companion_instance_131.id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allowedHosts;
  var eligibleHosts = tmp1_elvis_lhs == null ? hosts : tmp1_elvis_lhs;
  var tmp$ret$7;
  $l$block_3: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = hierarchyExceptSubTreesWithComponentArray(guest, Companion_getInstance_137().id);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.Companion.hasAtLeastOneConnectorFulfilledOnHosts.<anonymous>' call
      var tmp0_safe_receiver_0 = get_connectorsComponent(element);
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.f29();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$0;
        $l$block_2: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp1_safe_receiver, Collection)) {
            tmp_0 = tmp1_safe_receiver.r();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          var tmp0_iterator = tmp1_safe_receiver.k();
          while (tmp0_iterator.m()) {
            var element_0 = tmp0_iterator.n();
            // Inline function 'com.ikea.core.connectors.Companion.hasAtLeastOneConnectorFulfilledOnHosts.<anonymous>.<anonymous>' call
            var tmp$ret$4;
            $l$block_1: {
              // Inline function 'kotlin.collections.any' call
              var inductionVariable_0 = 0;
              var last_0 = eligibleHosts.length;
              while (inductionVariable_0 < last_0) {
                var element_1 = eligibleHosts[inductionVariable_0];
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'com.ikea.core.connectors.Companion.hasAtLeastOneConnectorFulfilledOnHosts.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$2;
                $l$block_0: {
                  // Inline function 'kotlin.sequences.any' call
                  var tmp_1 = hierarchyExceptSubTreeSequence(element_1, element);
                  var tmp0_iterator_0 = filter(tmp_1, ConnectorUtils$Companion$hasAtLeastOneConnectorFulfilledOnHosts$lambda(element)).k();
                  while (tmp0_iterator_0.m()) {
                    var element_2 = tmp0_iterator_0.n();
                    // Inline function 'com.ikea.core.connectors.Companion.hasAtLeastOneConnectorFulfilledOnHosts.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    if (checkRequiredConnectorsOnParts(Companion_instance_33, element_2, element, element_0)) {
                      tmp$ret$2 = true;
                      break $l$block_0;
                    }
                  }
                  tmp$ret$2 = false;
                }
                if (tmp$ret$2) {
                  tmp$ret$4 = true;
                  break $l$block_1;
                }
              }
              tmp$ret$4 = false;
            }
            if (tmp$ret$4) {
              tmp$ret$0 = true;
              break $l$block_2;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      }
      var tmp2_elvis_lhs = tmp;
      if (tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs) {
        tmp$ret$7 = true;
        break $l$block_3;
      }
    }
    tmp$ret$7 = false;
  }
  return tmp$ret$7;
};
protoOf(Companion_33).k2c = function (connector) {
  return connector instanceof EdgeConnector;
};
protoOf(Companion_33).l2c = function (connector) {
  return connector instanceof PointConnector;
};
protoOf(Companion_33).m2c = function (connector) {
  return connector instanceof PointSeriesConnector;
};
protoOf(Companion_33).n2c = function (connector) {
  return connector instanceof PointSeriesSubConnector;
};
protoOf(Companion_33).o2c = function (connector) {
  return connector instanceof SurfaceConnector;
};
protoOf(Companion_33).p2c = function (connectorKey, entity) {
  setEnabledStateForConnector(this, connectorKey, entity, true);
};
protoOf(Companion_33).q2c = function (connectorKey, entity) {
  setEnabledStateForConnector(this, connectorKey, entity, false);
};
var Companion_instance_33;
function Companion_getInstance_34() {
  return Companion_instance_33;
}
function snappingEntitiesArray(entity) {
  return Companion_instance_33.f2c(entity);
}
function findUnfulfilledRequiredConnectors(hostHierarchyRoots, guest) {
  return Companion_instance_33.g2c(hostHierarchyRoots, guest);
}
function hasAtLeastOneConnectorWithMatchingOffersDemands(host, guest) {
  return Companion_instance_33.j2c(host, guest);
}
function isEdgeConnector(connector) {
  return Companion_instance_33.k2c(connector);
}
function isPointConnector(connector) {
  return Companion_instance_33.l2c(connector);
}
function isPointSeriesConnector(connector) {
  return Companion_instance_33.m2c(connector);
}
function isPointSeriesSubConnector(connector) {
  return Companion_instance_33.n2c(connector);
}
function isSurfaceConnector(connector) {
  return Companion_instance_33.o2c(connector);
}
function enableConnectorByKey(connectorKey, entity) {
  return Companion_instance_33.p2c(connectorKey, entity);
}
function disableConnectorByKey(connectorKey, entity) {
  return Companion_instance_33.q2c(connectorKey, entity);
}
function ConnectorUtils() {
}
function get_snappingEntitiesArray(_this__u8e3s4) {
  return Companion_instance_33.f2c(_this__u8e3s4);
}
function hasAtLeastOneConnectorFulfilledOnHosts(_this__u8e3s4, hosts) {
  return Companion_instance_33.hasAtLeastOneConnectorFulfilledOnHosts(hosts, _this__u8e3s4);
}
function get_snappingEntitiesSequence(_this__u8e3s4) {
  return Companion_instance_33.e2c(_this__u8e3s4);
}
function Companion_34() {
  Companion_instance_34 = this;
  this.id = Companion_instance_21.h1n_1;
  this.c2c_1 = LoggerState_getInstance().g1v('ConnectorsComponent');
}
protoOf(Companion_34).n1s = function () {
  return this.id;
};
var Companion_instance_34;
function Companion_getInstance_35() {
  if (Companion_instance_34 == null)
    new Companion_34();
  return Companion_instance_34;
}
function sam$kotlin_Comparator$0_0(function_0) {
  this.r2c_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_0).md = function (a, b) {
  return this.r2c_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).s3 = function () {
  return this.r2c_1;
};
protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
  return hashCode(this.s3());
};
function sam$kotlin_Comparator$0_1(function_0) {
  this.s2c_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_1).md = function (a, b) {
  return this.s2c_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_1).s3 = function () {
  return this.s2c_1;
};
protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
  return hashCode(this.s3());
};
function ConnectorsComponent$hostConnectors$delegate$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.connectors.ConnectorsComponent.hostConnectors$delegate.<anonymous>.<anonymous>' call
  var tmp = -a.priority | 0;
  // Inline function 'com.ikea.core.connectors.ConnectorsComponent.hostConnectors$delegate.<anonymous>.<anonymous>' call
  var tmp$ret$1 = -b.priority | 0;
  return compareValues(tmp, tmp$ret$1);
}
function ConnectorsComponent$hostConnectors$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.i1l_1;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.connectors.ConnectorsComponent.hostConnectors$delegate.<anonymous>.<anonymous>' call
      if (element.type === Companion_instance_32.m2b_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = ConnectorsComponent$hostConnectors$delegate$lambda$lambda;
    var tmp$ret$3 = new sam$kotlin_Comparator$0_0(tmp);
    return sortedWith_0(destination, tmp$ret$3);
  };
}
function ConnectorsComponent$guestConnectors$delegate$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.connectors.ConnectorsComponent.guestConnectors$delegate.<anonymous>.<anonymous>' call
  var tmp = -a.priority | 0;
  // Inline function 'com.ikea.core.connectors.ConnectorsComponent.guestConnectors$delegate.<anonymous>.<anonymous>' call
  var tmp$ret$1 = -b.priority | 0;
  return compareValues(tmp, tmp$ret$1);
}
function ConnectorsComponent$guestConnectors$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.i1l_1;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.connectors.ConnectorsComponent.guestConnectors$delegate.<anonymous>.<anonymous>' call
      if (element.type === Companion_instance_32.l2b_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = ConnectorsComponent$guestConnectors$delegate$lambda$lambda;
    var tmp$ret$3 = new sam$kotlin_Comparator$0_1(tmp);
    return sortedWith_0(destination, tmp$ret$3);
  };
}
function ConnectorsComponent$alignmentConnectors$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.i1l_1;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.connectors.ConnectorsComponent.alignmentConnectors$delegate.<anonymous>.<anonymous>' call
      if (element.type === Companion_instance_32.n2b_1) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ConnectorsComponent$requiredConnectors$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.i1l_1;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.connectors.ConnectorsComponent.requiredConnectors$delegate.<anonymous>.<anonymous>' call
      if (element.required) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ConnectorsComponent$getConnectorByKey$lambda($connectorKey) {
  return function () {
    return 'Found more than one value when getting connector by key ' + $connectorKey + '. Keys must be uniquely defined in the range.';
  };
}
function ConnectorsComponent$getConnectorByKey$lambda_0(it) {
  return it.u2b();
}
function ConnectorsComponent$getConnectorByKey$lambda_1($connectorKey) {
  return function (it) {
    return it.key === $connectorKey;
  };
}
function ConnectorsComponent(connectors) {
  Companion_getInstance_35();
  this.connectors = connectors;
  var tmp = this;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.connectors;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connectors.ConnectorsComponent.enabledConnectors.<anonymous>' call
    if (element.enabled) {
      destination.h(element);
    }
  }
  tmp.i1l_1 = destination;
  var tmp_0 = this;
  tmp_0.j1l_1 = lazy(ConnectorsComponent$hostConnectors$delegate$lambda(this));
  var tmp_1 = this;
  tmp_1.k1l_1 = lazy(ConnectorsComponent$guestConnectors$delegate$lambda(this));
  var tmp_2 = this;
  tmp_2.l1l_1 = lazy(ConnectorsComponent$alignmentConnectors$delegate$lambda(this));
  var tmp_3 = this;
  tmp_3.m1l_1 = lazy(ConnectorsComponent$requiredConnectors$delegate$lambda(this));
  this.n1l_1 = asSequence_1(this.i2c());
}
protoOf(ConnectorsComponent).t2c = function () {
  return this.connectors;
};
protoOf(ConnectorsComponent).p1s = function () {
  return Companion_getInstance_35().id;
};
protoOf(ConnectorsComponent).u2c = function () {
  return this.i1l_1;
};
protoOf(ConnectorsComponent).v2c = function () {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = this.i1l_1;
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.connectors.ConnectorsComponent.<get-tags>.<anonymous>' call
    var list = asIterable(element.tags());
    addAll(destination, list);
  }
  return destination;
};
protoOf(ConnectorsComponent).r27 = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.j1l_1;
  hostConnectors$factory();
  return this_0.c2();
};
protoOf(ConnectorsComponent).f29 = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.k1l_1;
  guestConnectors$factory();
  return this_0.c2();
};
protoOf(ConnectorsComponent).d2c = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.l1l_1;
  alignmentConnectors$factory();
  return this_0.c2();
};
protoOf(ConnectorsComponent).i2c = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.m1l_1;
  requiredConnectors$factory();
  return this_0.c2();
};
protoOf(ConnectorsComponent).w2c = function () {
  return this.n1l_1;
};
protoOf(ConnectorsComponent).eq = function (other) {
  return false;
};
protoOf(ConnectorsComponent).getConnectorByKey = function (connectorKey) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.connectors;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connectors.ConnectorsComponent.getConnectorByKey.<anonymous>' call
    if (element.key === connectorKey) {
      destination.h(element);
    }
  }
  var listOfConnectors = destination;
  // Inline function 'kotlin.collections.count' call
  if (listOfConnectors.o() > 1) {
    var tmp = Companion_getInstance_35().c2c_1;
    tmp.error(ConnectorsComponent$getConnectorByKey$lambda(connectorKey));
  } else {
    if (none(listOfConnectors)) {
      var tmp_0 = asSequence_0(this.connectors);
      var tmp_1 = flatMap(tmp_0, ConnectorsComponent$getConnectorByKey$lambda_0);
      listOfConnectors = toList_0(filter(tmp_1, ConnectorsComponent$getConnectorByKey$lambda_1(connectorKey)));
    }
  }
  return firstOrNull_1(listOfConnectors);
};
protoOf(ConnectorsComponent).plusConnectors = function (connectorsToAdd) {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = this.connectors.concat(connectorsToAdd);
  return new ConnectorsComponent(tmp$ret$1);
};
protoOf(ConnectorsComponent).minusConnectors = function (connectorsToRemove) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.connectors;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connectors.ConnectorsComponent.minusConnectors.<anonymous>' call
    if (!contains(connectorsToRemove, element)) {
      destination.h(element);
    }
  }
  var tmp$ret$3 = copyToArray(destination);
  return new ConnectorsComponent(tmp$ret$3);
};
function get_connectorsComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_35().id);
}
function get_alignmentConnectors(_this__u8e3s4) {
  var tmp0_safe_receiver = get_connectorsComponent(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2c();
}
function get_hostConnectors(_this__u8e3s4) {
  var tmp0_safe_receiver = get_connectorsComponent(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r27();
}
function get_guestConnectors(_this__u8e3s4) {
  var tmp0_safe_receiver = get_connectorsComponent(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
}
function get_connectors(_this__u8e3s4) {
  var tmp0_safe_receiver = get_connectorsComponent(_this__u8e3s4);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function hostConnectors$factory() {
  return getPropertyCallableRef('hostConnectors', 1, KProperty1, function (receiver) {
    return receiver.r27();
  }, null);
}
function guestConnectors$factory() {
  return getPropertyCallableRef('guestConnectors', 1, KProperty1, function (receiver) {
    return receiver.f29();
  }, null);
}
function alignmentConnectors$factory() {
  return getPropertyCallableRef('alignmentConnectors', 1, KProperty1, function (receiver) {
    return receiver.d2c();
  }, null);
}
function requiredConnectors$factory() {
  return getPropertyCallableRef('requiredConnectors', 1, KProperty1, function (receiver) {
    return receiver.i2c();
  }, null);
}
function Companion_35() {
  this.ID = 'DisableConnectorsSystem';
}
protoOf(Companion_35).j1y = function () {
  return this.ID;
};
protoOf(Companion_35).updateConnectors = function (entity) {
  var tmp0_elvis_lhs = entity.__getComponentForKotlin(Companion_getInstance_35().id);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var connectorsComponent = tmp;
  var tmp1_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_37().id);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.disabledConnectorKeys;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_0 = [];
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var disabledConnectors = tmp_0;
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = connectorsComponent.connectors;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.Companion.updateConnectors.<anonymous>' call
      var it = this_0[i];
      var enable = !contains(disabledConnectors, it.key);
      arr[i] = it.enable(enable);
    }
     while (inductionVariable <= last);
  var updatedConnectors = isArray(arr) ? arr : THROW_CCE();
  entity.addComponent(new ConnectorsComponent(updatedConnectors));
};
var Companion_instance_35;
function Companion_getInstance_36() {
  return Companion_instance_35;
}
function DisableConnectorsSystem() {
  SystemBase.call(this, Companion_instance_35.ID, Companion_getInstance_37().id);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g2d_1 = [Companion_instance_21.h1n_1];
}
protoOf(DisableConnectorsSystem).h2d = function (entity, newComponent) {
  Companion_instance_35.updateConnectors(entity);
};
protoOf(DisableConnectorsSystem).v1v = function (entity, newComponent) {
  return this.h2d(entity, newComponent instanceof DisabledConnectorsComponent ? newComponent : THROW_CCE());
};
protoOf(DisableConnectorsSystem).i2d = function (entity, oldComponent, newComponent) {
  Companion_instance_35.updateConnectors(entity);
};
protoOf(DisableConnectorsSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof DisabledConnectorsComponent ? oldComponent : THROW_CCE();
  return this.i2d(entity, tmp, newComponent instanceof DisabledConnectorsComponent ? newComponent : THROW_CCE());
};
protoOf(DisableConnectorsSystem).j2d = function (entity, oldComponent) {
  Companion_instance_35.updateConnectors(entity);
};
protoOf(DisableConnectorsSystem).z1v = function (entity, oldComponent) {
  return this.j2d(entity, oldComponent instanceof DisabledConnectorsComponent ? oldComponent : THROW_CCE());
};
protoOf(DisableConnectorsSystem).j1w = function () {
  return this.g2d_1;
};
function Companion_36() {
  Companion_instance_36 = this;
  this.id = Companion_instance_21.o1p_1;
}
protoOf(Companion_36).n1s = function () {
  return this.id;
};
var Companion_instance_36;
function Companion_getInstance_37() {
  if (Companion_instance_36 == null)
    new Companion_36();
  return Companion_instance_36;
}
function DisabledConnectorsComponent(disabledConnectorKeys) {
  Companion_getInstance_37();
  this.disabledConnectorKeys = disabledConnectorKeys;
}
protoOf(DisabledConnectorsComponent).n2d = function () {
  return this.disabledConnectorKeys;
};
protoOf(DisabledConnectorsComponent).p1s = function () {
  return Companion_getInstance_37().id;
};
protoOf(DisabledConnectorsComponent).eq = function (other) {
  return contentEquals((other instanceof DisabledConnectorsComponent ? other : THROW_CCE()).disabledConnectorKeys, this.disabledConnectorKeys);
};
function EdgeConnector(key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required) {
  rotation = rotation === VOID ? Companion_getInstance_74().q2b_1 : rotation;
  priority = priority === VOID ? 0 : priority;
  activationDistance = activationDistance === VOID ? type === Companion_instance_32.m2b_1 ? Companion_instance_31.DEFAULT_HOST_ACTIVATION_DISTANCE : Companion_instance_31.DEFAULT_GUEST_ACTIVATION_DISTANCE : activationDistance;
  enabled = enabled === VOID ? true : enabled;
  var tmp;
  if (tagArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = tagArray;
  }
  tagArray = tmp;
  var tmp_0;
  if (offersArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [];
  } else {
    tmp_0 = offersArray;
  }
  offersArray = tmp_0;
  var tmp_1;
  if (demandsArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = [];
  } else {
    tmp_1 = demandsArray;
  }
  demandsArray = tmp_1;
  required = required === VOID ? false : required;
  Connector.call(this);
  this.u2d_1 = key;
  this.v2d_1 = type;
  this.p1 = p1;
  this.p2 = p2;
  this.w2d_1 = rotation;
  this.x2d_1 = priority;
  this.y2d_1 = activationDistance;
  this.z2d_1 = enabled;
  this.a2e_1 = tagArray;
  this.b2e_1 = offersArray;
  this.c2e_1 = demandsArray;
  this.d2e_1 = required;
  var tmp_2 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_2.e2e_1 = [this.p1, this.p2];
  this.f2e_1 = true;
  this.direction = this.p2.minus(this.p1).normalize();
  this.g2e_1 = this.p1.plus(this.p2).div(2.0);
  this.h2e_1 = new Transform(this.g2e_1, this.w2d_1);
}
protoOf(EdgeConnector).b2 = function () {
  return this.u2d_1;
};
protoOf(EdgeConnector).w2a = function () {
  return this.v2d_1;
};
protoOf(EdgeConnector).i2e = function () {
  return this.p1;
};
protoOf(EdgeConnector).j2e = function () {
  return this.p2;
};
protoOf(EdgeConnector).n28 = function () {
  return this.x2d_1;
};
protoOf(EdgeConnector).h2b = function () {
  return this.y2d_1;
};
protoOf(EdgeConnector).i2b = function () {
  return this.z2d_1;
};
protoOf(EdgeConnector).b2b = function (_set____db54di) {
  this.a2e_1 = _set____db54di;
};
protoOf(EdgeConnector).c2b = function () {
  return this.a2e_1;
};
protoOf(EdgeConnector).d2b = function (_set____db54di) {
  this.b2e_1 = _set____db54di;
};
protoOf(EdgeConnector).e2b = function () {
  return this.b2e_1;
};
protoOf(EdgeConnector).f2b = function (_set____db54di) {
  this.c2e_1 = _set____db54di;
};
protoOf(EdgeConnector).g2b = function () {
  return this.c2e_1;
};
protoOf(EdgeConnector).x2a = function () {
  return this.d2e_1;
};
protoOf(EdgeConnector).equalsByValue = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  var tmp_5;
  var tmp_6;
  var tmp_7;
  var tmp_8;
  if (other instanceof EdgeConnector) {
    tmp_8 = other.u2d_1 === this.u2d_1;
  } else {
    tmp_8 = false;
  }
  if (tmp_8) {
    tmp_7 = other.p1.equals(this.p1);
  } else {
    tmp_7 = false;
  }
  if (tmp_7) {
    tmp_6 = other.p2.equals(this.p2);
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    tmp_5 = other.w2d_1.equals(this.w2d_1);
  } else {
    tmp_5 = false;
  }
  if (tmp_5) {
    tmp_4 = other.x2d_1 === this.x2d_1;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = other.y2d_1 === this.y2d_1;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = other.z2d_1 === this.z2d_1;
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = contentEquals(other.a2e_1, this.a2e_1);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = contentEquals(other.offers(), this.offers());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = contentEquals(other.demands(), this.demands());
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(EdgeConnector).j2b = function () {
  return this.f2e_1;
};
protoOf(EdgeConnector).k2e = function () {
  return this.direction;
};
protoOf(EdgeConnector).y2a = function () {
  return 0.0;
};
protoOf(EdgeConnector).reposition = function (newPositions) {
  if (newPositions.length < 2) {
    throw IllegalArgumentException_init_$Create$('Can not reposition edge connector with ' + newPositions.length + ' point(s).');
  }
  return this.copy(VOID, VOID, newPositions[0], newPositions[1]);
};
protoOf(EdgeConnector).move = function (movementDelta) {
  return this.copy(VOID, VOID, this.p1.plus(movementDelta), this.p2.plus(movementDelta));
};
protoOf(EdgeConnector).rotate = function (rotationDelta) {
  return this.copy(VOID, VOID, VOID, VOID, this.w2d_1.times(rotationDelta));
};
protoOf(EdgeConnector).enable = function (enable) {
  return this.copy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, enable);
};
protoOf(EdgeConnector).z2a = function () {
  return this.h2e_1;
};
protoOf(EdgeConnector).closest = function (child) {
  return closestOnEdge(child, this.e2e_1);
};
protoOf(EdgeConnector).contains = function (localSpacePoint) {
  return localSpacePoint.pointOnLine(this.p1, this.p2);
};
protoOf(EdgeConnector).shift = function (name, transition) {
  return this.copy(name, VOID, this.p1.plus(transition), this.p2.plus(transition));
};
protoOf(EdgeConnector).withKey = function (key) {
  return this.copy(key);
};
protoOf(EdgeConnector).tf = function () {
  return this.u2d_1;
};
protoOf(EdgeConnector).uf = function () {
  return this.v2d_1;
};
protoOf(EdgeConnector).m1m = function () {
  return this.p1;
};
protoOf(EdgeConnector).n1m = function () {
  return this.p2;
};
protoOf(EdgeConnector).p1m = function () {
  return this.x2d_1;
};
protoOf(EdgeConnector).q1m = function () {
  return this.y2d_1;
};
protoOf(EdgeConnector).l2e = function () {
  return this.z2d_1;
};
protoOf(EdgeConnector).m2e = function () {
  return this.a2e_1;
};
protoOf(EdgeConnector).n2e = function () {
  return this.b2e_1;
};
protoOf(EdgeConnector).o2e = function () {
  return this.c2e_1;
};
protoOf(EdgeConnector).p2e = function () {
  return this.d2e_1;
};
protoOf(EdgeConnector).q2e = function (key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required) {
  return new EdgeConnector(key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required);
};
protoOf(EdgeConnector).copy = function (key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required, $super) {
  key = key === VOID ? this.u2d_1 : key;
  type = type === VOID ? this.v2d_1 : type;
  p1 = p1 === VOID ? this.p1 : p1;
  p2 = p2 === VOID ? this.p2 : p2;
  rotation = rotation === VOID ? this.w2d_1 : rotation;
  priority = priority === VOID ? this.x2d_1 : priority;
  activationDistance = activationDistance === VOID ? this.y2d_1 : activationDistance;
  enabled = enabled === VOID ? this.z2d_1 : enabled;
  tagArray = tagArray === VOID ? this.a2e_1 : tagArray;
  offersArray = offersArray === VOID ? this.b2e_1 : offersArray;
  demandsArray = demandsArray === VOID ? this.c2e_1 : demandsArray;
  required = required === VOID ? this.d2e_1 : required;
  return this.q2e(key, type, p1, p2, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required);
};
protoOf(EdgeConnector).toString = function () {
  return 'EdgeConnector(key=' + this.u2d_1 + ', type=' + this.v2d_1 + ', p1=' + this.p1.toString() + ', p2=' + this.p2.toString() + ', rotation=' + this.w2d_1.toString() + ', priority=' + this.x2d_1 + ', activationDistance=' + this.y2d_1 + ', enabled=' + this.z2d_1 + ', tagArray=' + toString_0(this.a2e_1) + ', offersArray=' + toString_0(this.b2e_1) + ', demandsArray=' + toString_0(this.c2e_1) + ', required=' + this.d2e_1 + ')';
};
protoOf(EdgeConnector).hashCode = function () {
  var result = getStringHashCode(this.u2d_1);
  result = imul(result, 31) + this.v2d_1 | 0;
  result = imul(result, 31) + this.p1.hashCode() | 0;
  result = imul(result, 31) + this.p2.hashCode() | 0;
  result = imul(result, 31) + this.w2d_1.hashCode() | 0;
  result = imul(result, 31) + this.x2d_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.y2d_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.z2d_1) | 0;
  result = imul(result, 31) + hashCode(this.a2e_1) | 0;
  result = imul(result, 31) + hashCode(this.b2e_1) | 0;
  result = imul(result, 31) + hashCode(this.c2e_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.d2e_1) | 0;
  return result;
};
protoOf(EdgeConnector).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EdgeConnector))
    return false;
  var tmp0_other_with_cast = other instanceof EdgeConnector ? other : THROW_CCE();
  if (!(this.u2d_1 === tmp0_other_with_cast.u2d_1))
    return false;
  if (!(this.v2d_1 === tmp0_other_with_cast.v2d_1))
    return false;
  if (!this.p1.equals(tmp0_other_with_cast.p1))
    return false;
  if (!this.p2.equals(tmp0_other_with_cast.p2))
    return false;
  if (!this.w2d_1.equals(tmp0_other_with_cast.w2d_1))
    return false;
  if (!(this.x2d_1 === tmp0_other_with_cast.x2d_1))
    return false;
  if (!equals(this.y2d_1, tmp0_other_with_cast.y2d_1))
    return false;
  if (!(this.z2d_1 === tmp0_other_with_cast.z2d_1))
    return false;
  if (!equals(this.a2e_1, tmp0_other_with_cast.a2e_1))
    return false;
  if (!equals(this.b2e_1, tmp0_other_with_cast.b2e_1))
    return false;
  if (!equals(this.c2e_1, tmp0_other_with_cast.c2e_1))
    return false;
  if (!(this.d2e_1 === tmp0_other_with_cast.d2e_1))
    return false;
  return true;
};
function PointConnector(key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required) {
  transform = transform === VOID ? Companion_getInstance_80().c1x_1 : transform;
  priority = priority === VOID ? 0 : priority;
  activationDistance = activationDistance === VOID ? type === Companion_instance_32.m2b_1 ? Companion_instance_31.DEFAULT_HOST_ACTIVATION_DISTANCE : Companion_instance_31.DEFAULT_GUEST_ACTIVATION_DISTANCE : activationDistance;
  enabled = enabled === VOID ? true : enabled;
  var tmp;
  if (tagArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = tagArray;
  }
  tagArray = tmp;
  var tmp_0;
  if (offersArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [];
  } else {
    tmp_0 = offersArray;
  }
  offersArray = tmp_0;
  var tmp_1;
  if (demandsArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = [];
  } else {
    tmp_1 = demandsArray;
  }
  demandsArray = tmp_1;
  worldSpaceOffsetOnHanging = worldSpaceOffsetOnHanging === VOID ? 0.0 : worldSpaceOffsetOnHanging;
  rotationalDegreeOfFreedom = rotationalDegreeOfFreedom === VOID ? RotationDegreeOfFreedom_NONE_getInstance().u2_1 : rotationalDegreeOfFreedom;
  required = required === VOID ? false : required;
  Connector.call(this);
  this.x2e_1 = key;
  this.y2e_1 = type;
  this.z2e_1 = transform;
  this.a2f_1 = priority;
  this.b2f_1 = activationDistance;
  this.c2f_1 = enabled;
  this.d2f_1 = tagArray;
  this.e2f_1 = offersArray;
  this.f2f_1 = demandsArray;
  this.g2f_1 = worldSpaceOffsetOnHanging;
  this.h2f_1 = rotationalDegreeOfFreedom;
  this.i2f_1 = required;
  this.j2f_1 = false;
}
protoOf(PointConnector).b2 = function () {
  return this.x2e_1;
};
protoOf(PointConnector).w2a = function () {
  return this.y2e_1;
};
protoOf(PointConnector).z2a = function () {
  return this.z2e_1;
};
protoOf(PointConnector).n28 = function () {
  return this.a2f_1;
};
protoOf(PointConnector).h2b = function () {
  return this.b2f_1;
};
protoOf(PointConnector).i2b = function () {
  return this.c2f_1;
};
protoOf(PointConnector).b2b = function (_set____db54di) {
  this.d2f_1 = _set____db54di;
};
protoOf(PointConnector).c2b = function () {
  return this.d2f_1;
};
protoOf(PointConnector).d2b = function (_set____db54di) {
  this.e2f_1 = _set____db54di;
};
protoOf(PointConnector).e2b = function () {
  return this.e2f_1;
};
protoOf(PointConnector).f2b = function (_set____db54di) {
  this.f2f_1 = _set____db54di;
};
protoOf(PointConnector).g2b = function () {
  return this.f2f_1;
};
protoOf(PointConnector).y2a = function () {
  return this.g2f_1;
};
protoOf(PointConnector).a2b = function () {
  return this.h2f_1;
};
protoOf(PointConnector).x2a = function () {
  return this.i2f_1;
};
protoOf(PointConnector).equalsByValue = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  var tmp_5;
  var tmp_6;
  if (other instanceof PointConnector) {
    tmp_6 = other.x2e_1 === this.x2e_1;
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    tmp_5 = other.z2e_1.equals(this.z2e_1);
  } else {
    tmp_5 = false;
  }
  if (tmp_5) {
    tmp_4 = other.a2f_1 === this.a2f_1;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = other.b2f_1 === this.b2f_1;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = other.c2f_1 === this.c2f_1;
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = contentEquals(other.d2f_1, this.d2f_1);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = contentEquals(other.offers(), this.offers());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = contentEquals(other.demands(), this.demands());
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(PointConnector).j2b = function () {
  return this.j2f_1;
};
protoOf(PointConnector).move = function (movementDelta) {
  return this.copy(VOID, VOID, (new Transform(movementDelta)).concatenate(this.z2e_1));
};
protoOf(PointConnector).rotate = function (rotationDelta) {
  return this.copy(VOID, VOID, this.z2e_1.copy(VOID, this.z2e_1.rotation.times(rotationDelta)));
};
protoOf(PointConnector).contains = function (localSpacePoint) {
  return this.z2e_1.position.equals(localSpacePoint);
};
protoOf(PointConnector).closest = function (child) {
  return this.z2e_1.position;
};
protoOf(PointConnector).closestWhenUsingTransform = function (ownerTransform, pointWorldSpace) {
  return this.getWorldPositionFromOwnerTransform(ownerTransform);
};
protoOf(PointConnector).enable = function (enable) {
  return this.copy(VOID, VOID, VOID, VOID, VOID, enable);
};
protoOf(PointConnector).reposition = function (newPositions) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (newPositions.length === 0) {
    throw IllegalArgumentException_init_$Create$('Can not reposition a point connector with 0 points.');
  }
  return this.copy(VOID, VOID, this.z2e_1.copy(newPositions[0]));
};
protoOf(PointConnector).withKey = function (key) {
  return this.copy(key);
};
protoOf(PointConnector).toString = function () {
  return '' + getKClassFromExpression(this).oa() + ' ' + this.x2e_1;
};
protoOf(PointConnector).tf = function () {
  return this.x2e_1;
};
protoOf(PointConnector).uf = function () {
  return this.y2e_1;
};
protoOf(PointConnector).m1m = function () {
  return this.z2e_1;
};
protoOf(PointConnector).n1m = function () {
  return this.a2f_1;
};
protoOf(PointConnector).o1m = function () {
  return this.b2f_1;
};
protoOf(PointConnector).p1m = function () {
  return this.c2f_1;
};
protoOf(PointConnector).q1m = function () {
  return this.d2f_1;
};
protoOf(PointConnector).l2e = function () {
  return this.e2f_1;
};
protoOf(PointConnector).m2e = function () {
  return this.f2f_1;
};
protoOf(PointConnector).n2e = function () {
  return this.g2f_1;
};
protoOf(PointConnector).o2e = function () {
  return this.h2f_1;
};
protoOf(PointConnector).p2e = function () {
  return this.i2f_1;
};
protoOf(PointConnector).k2f = function (key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required) {
  return new PointConnector(key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required);
};
protoOf(PointConnector).copy = function (key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required, $super) {
  key = key === VOID ? this.x2e_1 : key;
  type = type === VOID ? this.y2e_1 : type;
  transform = transform === VOID ? this.z2e_1 : transform;
  priority = priority === VOID ? this.a2f_1 : priority;
  activationDistance = activationDistance === VOID ? this.b2f_1 : activationDistance;
  enabled = enabled === VOID ? this.c2f_1 : enabled;
  tagArray = tagArray === VOID ? this.d2f_1 : tagArray;
  offersArray = offersArray === VOID ? this.e2f_1 : offersArray;
  demandsArray = demandsArray === VOID ? this.f2f_1 : demandsArray;
  worldSpaceOffsetOnHanging = worldSpaceOffsetOnHanging === VOID ? this.g2f_1 : worldSpaceOffsetOnHanging;
  rotationalDegreeOfFreedom = rotationalDegreeOfFreedom === VOID ? this.h2f_1 : rotationalDegreeOfFreedom;
  required = required === VOID ? this.i2f_1 : required;
  return this.k2f(key, type, transform, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, rotationalDegreeOfFreedom, required);
};
protoOf(PointConnector).hashCode = function () {
  var result = getStringHashCode(this.x2e_1);
  result = imul(result, 31) + this.y2e_1 | 0;
  result = imul(result, 31) + this.z2e_1.hashCode() | 0;
  result = imul(result, 31) + this.a2f_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.b2f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.c2f_1) | 0;
  result = imul(result, 31) + hashCode(this.d2f_1) | 0;
  result = imul(result, 31) + hashCode(this.e2f_1) | 0;
  result = imul(result, 31) + hashCode(this.f2f_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.g2f_1) | 0;
  result = imul(result, 31) + this.h2f_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.i2f_1) | 0;
  return result;
};
protoOf(PointConnector).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PointConnector))
    return false;
  var tmp0_other_with_cast = other instanceof PointConnector ? other : THROW_CCE();
  if (!(this.x2e_1 === tmp0_other_with_cast.x2e_1))
    return false;
  if (!(this.y2e_1 === tmp0_other_with_cast.y2e_1))
    return false;
  if (!this.z2e_1.equals(tmp0_other_with_cast.z2e_1))
    return false;
  if (!(this.a2f_1 === tmp0_other_with_cast.a2f_1))
    return false;
  if (!equals(this.b2f_1, tmp0_other_with_cast.b2f_1))
    return false;
  if (!(this.c2f_1 === tmp0_other_with_cast.c2f_1))
    return false;
  if (!equals(this.d2f_1, tmp0_other_with_cast.d2f_1))
    return false;
  if (!equals(this.e2f_1, tmp0_other_with_cast.e2f_1))
    return false;
  if (!equals(this.f2f_1, tmp0_other_with_cast.f2f_1))
    return false;
  if (!equals(this.g2f_1, tmp0_other_with_cast.g2f_1))
    return false;
  if (!(this.h2f_1 === tmp0_other_with_cast.h2f_1))
    return false;
  if (!(this.i2f_1 === tmp0_other_with_cast.i2f_1))
    return false;
  return true;
};
function _get_direction__hwzary($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.b2g_1;
  direction$factory();
  return this_0.c2();
}
function getNumberOfSubConnectors($this, first, last, spacing) {
  return numberToInt(last.minus(first).size / spacing) + 1 | 0;
}
function PointSeriesConnector$direction$delegate$lambda(this$0) {
  return function () {
    return !this$0.last.equals(this$0.first) ? this$0.last.minus(this$0.first).normalize() : Companion_getInstance_81().UP;
  };
}
function PointSeriesConnector$allSubConnectors$delegate$lambda$lambda(this$0) {
  return function (pos) {
    return new PointSeriesSubConnector(pos, this$0);
  };
}
function PointSeriesConnector$allSubConnectors$delegate$lambda(this$0) {
  return function () {
    return map(this$0.f2g_1, PointSeriesConnector$allSubConnectors$delegate$lambda$lambda(this$0));
  };
}
function PointSeriesConnector(key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required) {
  rotation = rotation === VOID ? Companion_getInstance_74().q2b_1 : rotation;
  priority = priority === VOID ? 0 : priority;
  activationDistance = activationDistance === VOID ? type === Companion_instance_32.m2b_1 ? Companion_instance_31.DEFAULT_HOST_ACTIVATION_DISTANCE : Companion_instance_31.DEFAULT_GUEST_ACTIVATION_DISTANCE : activationDistance;
  enabled = enabled === VOID ? true : enabled;
  var tmp;
  if (tagArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = tagArray;
  }
  tagArray = tmp;
  var tmp_0;
  if (offersArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [];
  } else {
    tmp_0 = offersArray;
  }
  offersArray = tmp_0;
  var tmp_1;
  if (demandsArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = [];
  } else {
    tmp_1 = demandsArray;
  }
  demandsArray = tmp_1;
  worldSpaceOffsetOnHanging = worldSpaceOffsetOnHanging === VOID ? 0.0 : worldSpaceOffsetOnHanging;
  subConnectorSpacing = subConnectorSpacing === VOID ? 30.0 : subConnectorSpacing;
  required = required === VOID ? false : required;
  Connector.call(this);
  this.r2f_1 = key;
  this.s2f_1 = type;
  this.first = first;
  this.last = last;
  this.rotation = rotation;
  this.t2f_1 = priority;
  this.u2f_1 = activationDistance;
  this.v2f_1 = enabled;
  this.w2f_1 = tagArray;
  this.x2f_1 = offersArray;
  this.y2f_1 = demandsArray;
  this.z2f_1 = worldSpaceOffsetOnHanging;
  this.subConnectorSpacing = subConnectorSpacing;
  this.a2g_1 = required;
  this.subConnectorCount = getNumberOfSubConnectors(this, this.first, this.last, this.subConnectorSpacing);
  var tmp_2 = this;
  tmp_2.b2g_1 = lazy(PointSeriesConnector$direction$delegate$lambda(this));
  this.c2g_1 = _get_direction__hwzary(this).times(this.subConnectorSpacing);
  this.d2g_1 = this.last.minus(this.first).size;
  this.e2g_1 = false;
  this.f2g_1 = asSequence_1(until(0, this.subConnectorCount));
  this.g2g_1 = this.first.plus(this.offset(this.subConnectorCount / 2 | 0));
  this.h2g_1 = new Transform(this.g2g_1, this.rotation);
  this.i2g_1 = true;
  var tmp_3 = this;
  tmp_3.j2g_1 = lazy(PointSeriesConnector$allSubConnectors$delegate$lambda(this));
}
protoOf(PointSeriesConnector).b2 = function () {
  return this.r2f_1;
};
protoOf(PointSeriesConnector).w2a = function () {
  return this.s2f_1;
};
protoOf(PointSeriesConnector).k2g = function () {
  return this.first;
};
protoOf(PointSeriesConnector).l2g = function () {
  return this.last;
};
protoOf(PointSeriesConnector).m2g = function () {
  return this.rotation;
};
protoOf(PointSeriesConnector).n28 = function () {
  return this.t2f_1;
};
protoOf(PointSeriesConnector).h2b = function () {
  return this.u2f_1;
};
protoOf(PointSeriesConnector).i2b = function () {
  return this.v2f_1;
};
protoOf(PointSeriesConnector).b2b = function (_set____db54di) {
  this.w2f_1 = _set____db54di;
};
protoOf(PointSeriesConnector).c2b = function () {
  return this.w2f_1;
};
protoOf(PointSeriesConnector).d2b = function (_set____db54di) {
  this.x2f_1 = _set____db54di;
};
protoOf(PointSeriesConnector).e2b = function () {
  return this.x2f_1;
};
protoOf(PointSeriesConnector).f2b = function (_set____db54di) {
  this.y2f_1 = _set____db54di;
};
protoOf(PointSeriesConnector).g2b = function () {
  return this.y2f_1;
};
protoOf(PointSeriesConnector).y2a = function () {
  return this.z2f_1;
};
protoOf(PointSeriesConnector).n2g = function () {
  return this.subConnectorSpacing;
};
protoOf(PointSeriesConnector).x2a = function () {
  return this.a2g_1;
};
protoOf(PointSeriesConnector).equalsByValue = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  var tmp_5;
  var tmp_6;
  var tmp_7;
  var tmp_8;
  if (other instanceof PointSeriesConnector) {
    tmp_8 = other.r2f_1 === this.r2f_1;
  } else {
    tmp_8 = false;
  }
  if (tmp_8) {
    tmp_7 = other.first.equals(this.first);
  } else {
    tmp_7 = false;
  }
  if (tmp_7) {
    tmp_6 = other.last.equals(this.last);
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    tmp_5 = other.rotation.equals(this.rotation);
  } else {
    tmp_5 = false;
  }
  if (tmp_5) {
    tmp_4 = other.t2f_1 === this.t2f_1;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = other.u2f_1 === this.u2f_1;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = other.v2f_1 === this.v2f_1;
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = contentEquals(other.w2f_1, this.w2f_1);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = contentEquals(other.offers(), this.offers());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = contentEquals(other.demands(), this.demands());
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(PointSeriesConnector).o2g = function () {
  return this.subConnectorCount;
};
protoOf(PointSeriesConnector).j2b = function () {
  return this.e2g_1;
};
protoOf(PointSeriesConnector).z2a = function () {
  return this.h2g_1;
};
protoOf(PointSeriesConnector).v2b = function () {
  return this.i2g_1;
};
protoOf(PointSeriesConnector).reposition = function (newPositions) {
  if (newPositions.length < 2) {
    throw IllegalArgumentException_init_$Create$('Can not reposition point series connector with ' + newPositions.length + ' point(s).');
  }
  var newFirst = newPositions[0];
  var newLast = newPositions[1];
  var subConnectorCount = getNumberOfSubConnectors(this, newFirst, newLast, this.subConnectorSpacing);
  var step = newLast.minus(newFirst).normalize().times(this.subConnectorSpacing);
  var calculatedLast = newFirst.plus(step.__timesIntForKotlin(subConnectorCount - 1 | 0));
  return this.copy(VOID, VOID, newFirst, calculatedLast, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.subConnectorSpacing);
};
protoOf(PointSeriesConnector).move = function (movementDelta) {
  return this.copy(VOID, VOID, this.first.plus(movementDelta), this.last.plus(movementDelta));
};
protoOf(PointSeriesConnector).rotate = function (rotationDelta) {
  return this.copy(VOID, VOID, VOID, VOID, this.rotation.times(rotationDelta));
};
protoOf(PointSeriesConnector).contains = function (localSpacePoint) {
  var lengthToConnection = localSpacePoint.minus(this.first).size;
  if (lengthToConnection > this.d2g_1)
    return false;
  var steps = round(lengthToConnection / this.subConnectorSpacing);
  var diffVec = this.first.plus(this.c2g_1.times(steps)).minus(localSpacePoint);
  return diffVec.equals(Companion_getInstance_81().ZERO);
};
protoOf(PointSeriesConnector).enable = function (enable) {
  return this.copy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, enable);
};
protoOf(PointSeriesConnector).closest = function (child) {
  if (child.equals(this.first))
    return this.first;
  if (this.first.equals(this.last))
    return this.first;
  var projection = child.minus(this.first).size * (child.minus(this.first).__timesOperatorKotlin(this.last.minus(this.first)) / (child.minus(this.first).size * this.last.minus(this.first).size));
  var connectionPoint = round(projection / this.subConnectorSpacing);
  var closest = connectionPoint < 0 ? 0.0 : connectionPoint >= this.subConnectorCount ? this.subConnectorCount - 1 : connectionPoint;
  return this.last.minus(this.first).div(this.last.minus(this.first).size).times(closest).times(this.subConnectorSpacing).plus(this.first);
};
protoOf(PointSeriesConnector).shift = function (name, transition) {
  return this.copy(name, VOID, transition.plus(this.first), this.last.plus(transition));
};
protoOf(PointSeriesConnector).offset = function (offset) {
  if (this.first.equals(this.last))
    return Companion_getInstance_81().ZERO;
  return this.last.minus(this.first).setSize(1.0).times(this.subConnectorSpacing * offset);
};
protoOf(PointSeriesConnector).u2b = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.j2g_1;
  allSubConnectors$factory_0();
  return this_0.c2();
};
protoOf(PointSeriesConnector).closestSubConnector = function (localSpacePoint) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.sequences.minByOrNull' call
    var iterator = this.f2g_1.k();
    if (!iterator.m()) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    var minElem = iterator.n();
    if (!iterator.m()) {
      tmp$ret$0 = minElem;
      break $l$block_0;
    }
    // Inline function 'com.ikea.core.connectors.PointSeriesConnector.closestSubConnector.<anonymous>' call
    var it = minElem;
    var minValue = this.getSubConnectorPosition(it).distanceTo(localSpacePoint);
    do {
      var e = iterator.n();
      // Inline function 'com.ikea.core.connectors.PointSeriesConnector.closestSubConnector.<anonymous>' call
      var v = this.getSubConnectorPosition(e).distanceTo(localSpacePoint);
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.m());
    tmp$ret$0 = minElem;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var pos = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  return new PointSeriesSubConnector(pos, this);
};
protoOf(PointSeriesConnector).closestSubConnectorFromOwnerEntity = function (owner, worldSpacePoint) {
  var positionLocalSpace = get_worldTransform(owner).inverseTransformPosition(worldSpacePoint);
  return this.closestSubConnector(positionLocalSpace);
};
protoOf(PointSeriesConnector).closestSubConnectorFromOwnerAndGuest = function (owner, guest, guestConnector) {
  var guestConnectorPositionHostSpace = get_worldTransform(guest).transformPosition(guestConnector.transform.position);
  return this.closestSubConnectorFromOwnerEntity(owner, guestConnectorPositionHostSpace);
};
protoOf(PointSeriesConnector).getSubConnectorPosition = function (subConnectorIndex) {
  return this.first.plus(this.c2g_1.__timesIntForKotlin(subConnectorIndex));
};
protoOf(PointSeriesConnector).withKey = function (key) {
  return this.copy(key);
};
protoOf(PointSeriesConnector).tf = function () {
  return this.r2f_1;
};
protoOf(PointSeriesConnector).uf = function () {
  return this.s2f_1;
};
protoOf(PointSeriesConnector).m1m = function () {
  return this.first;
};
protoOf(PointSeriesConnector).n1m = function () {
  return this.last;
};
protoOf(PointSeriesConnector).o1m = function () {
  return this.rotation;
};
protoOf(PointSeriesConnector).p1m = function () {
  return this.t2f_1;
};
protoOf(PointSeriesConnector).q1m = function () {
  return this.u2f_1;
};
protoOf(PointSeriesConnector).l2e = function () {
  return this.v2f_1;
};
protoOf(PointSeriesConnector).m2e = function () {
  return this.w2f_1;
};
protoOf(PointSeriesConnector).n2e = function () {
  return this.x2f_1;
};
protoOf(PointSeriesConnector).o2e = function () {
  return this.y2f_1;
};
protoOf(PointSeriesConnector).p2e = function () {
  return this.z2f_1;
};
protoOf(PointSeriesConnector).p2g = function () {
  return this.subConnectorSpacing;
};
protoOf(PointSeriesConnector).q2g = function () {
  return this.a2g_1;
};
protoOf(PointSeriesConnector).r2g = function (key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required) {
  return new PointSeriesConnector(key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required);
};
protoOf(PointSeriesConnector).copy = function (key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required, $super) {
  key = key === VOID ? this.r2f_1 : key;
  type = type === VOID ? this.s2f_1 : type;
  first = first === VOID ? this.first : first;
  last = last === VOID ? this.last : last;
  rotation = rotation === VOID ? this.rotation : rotation;
  priority = priority === VOID ? this.t2f_1 : priority;
  activationDistance = activationDistance === VOID ? this.u2f_1 : activationDistance;
  enabled = enabled === VOID ? this.v2f_1 : enabled;
  tagArray = tagArray === VOID ? this.w2f_1 : tagArray;
  offersArray = offersArray === VOID ? this.x2f_1 : offersArray;
  demandsArray = demandsArray === VOID ? this.y2f_1 : demandsArray;
  worldSpaceOffsetOnHanging = worldSpaceOffsetOnHanging === VOID ? this.z2f_1 : worldSpaceOffsetOnHanging;
  subConnectorSpacing = subConnectorSpacing === VOID ? this.subConnectorSpacing : subConnectorSpacing;
  required = required === VOID ? this.a2g_1 : required;
  return this.r2g(key, type, first, last, rotation, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, worldSpaceOffsetOnHanging, subConnectorSpacing, required);
};
protoOf(PointSeriesConnector).toString = function () {
  return 'PointSeriesConnector(key=' + this.r2f_1 + ', type=' + this.s2f_1 + ', first=' + this.first.toString() + ', last=' + this.last.toString() + ', rotation=' + this.rotation.toString() + ', priority=' + this.t2f_1 + ', activationDistance=' + this.u2f_1 + ', enabled=' + this.v2f_1 + ', tagArray=' + toString_0(this.w2f_1) + ', offersArray=' + toString_0(this.x2f_1) + ', demandsArray=' + toString_0(this.y2f_1) + ', worldSpaceOffsetOnHanging=' + this.z2f_1 + ', subConnectorSpacing=' + this.subConnectorSpacing + ', required=' + this.a2g_1 + ')';
};
protoOf(PointSeriesConnector).hashCode = function () {
  var result = getStringHashCode(this.r2f_1);
  result = imul(result, 31) + this.s2f_1 | 0;
  result = imul(result, 31) + this.first.hashCode() | 0;
  result = imul(result, 31) + this.last.hashCode() | 0;
  result = imul(result, 31) + this.rotation.hashCode() | 0;
  result = imul(result, 31) + this.t2f_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.u2f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.v2f_1) | 0;
  result = imul(result, 31) + hashCode(this.w2f_1) | 0;
  result = imul(result, 31) + hashCode(this.x2f_1) | 0;
  result = imul(result, 31) + hashCode(this.y2f_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.z2f_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.subConnectorSpacing) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.a2g_1) | 0;
  return result;
};
protoOf(PointSeriesConnector).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PointSeriesConnector))
    return false;
  var tmp0_other_with_cast = other instanceof PointSeriesConnector ? other : THROW_CCE();
  if (!(this.r2f_1 === tmp0_other_with_cast.r2f_1))
    return false;
  if (!(this.s2f_1 === tmp0_other_with_cast.s2f_1))
    return false;
  if (!this.first.equals(tmp0_other_with_cast.first))
    return false;
  if (!this.last.equals(tmp0_other_with_cast.last))
    return false;
  if (!this.rotation.equals(tmp0_other_with_cast.rotation))
    return false;
  if (!(this.t2f_1 === tmp0_other_with_cast.t2f_1))
    return false;
  if (!equals(this.u2f_1, tmp0_other_with_cast.u2f_1))
    return false;
  if (!(this.v2f_1 === tmp0_other_with_cast.v2f_1))
    return false;
  if (!equals(this.w2f_1, tmp0_other_with_cast.w2f_1))
    return false;
  if (!equals(this.x2f_1, tmp0_other_with_cast.x2f_1))
    return false;
  if (!equals(this.y2f_1, tmp0_other_with_cast.y2f_1))
    return false;
  if (!equals(this.z2f_1, tmp0_other_with_cast.z2f_1))
    return false;
  if (!equals(this.subConnectorSpacing, tmp0_other_with_cast.subConnectorSpacing))
    return false;
  if (!(this.a2g_1 === tmp0_other_with_cast.a2g_1))
    return false;
  return true;
};
function direction$factory() {
  return getPropertyCallableRef('direction', 1, KProperty1, function (receiver) {
    return _get_direction__hwzary(receiver);
  }, null);
}
function allSubConnectors$factory_0() {
  return getPropertyCallableRef('allSubConnectors', 1, KProperty1, function (receiver) {
    return receiver.u2b();
  }, null);
}
function PointSeriesSubConnector$_init_$ref_dzni41() {
  var l = function (p0, p1) {
    return new PointSeriesSubConnector(p0, p1);
  };
  l.callableName = '<init>';
  return l;
}
function PointSeriesSubConnector$_init_$ref_dzni41_0() {
  var l = function (p0, p1) {
    return new PointSeriesSubConnector(p0, p1);
  };
  l.callableName = '<init>';
  return l;
}
function PointSeriesSubConnector$_init_$ref_dzni41_1() {
  var l = function (p0, p1) {
    return new PointSeriesSubConnector(p0, p1);
  };
  l.callableName = '<init>';
  return l;
}
function PointSeriesSubConnector$withKey$lambda() {
  return "Can't change the key of a PointSeriesSubConnector. The key is derived from the the parent series connector";
}
function PointSeriesSubConnector(hole, series) {
  Connector.call(this);
  this.hole = hole;
  this.series = series;
  this.positionInSeries = this.series.getSubConnectorPosition(this.hole);
  this.y27_1 = LoggerState_getInstance().g1v('PointSeriesSubConnector');
  this.z27_1 = new PointConnector(this.series.r2f_1 + '-' + this.hole, this.series.s2f_1, new Transform(this.positionInSeries, this.series.rotation), this.series.t2f_1, this.series.u2f_1, this.series.v2f_1, this.series.tags());
  this.a28_1 = this.series.a2g_1;
  this.b28_1 = this.z27_1.z2e_1;
  this.c28_1 = this.z27_1.c2f_1;
  this.d28_1 = this.z27_1.j2f_1;
}
protoOf(PointSeriesSubConnector).s2g = function () {
  return this.hole;
};
protoOf(PointSeriesSubConnector).t2g = function () {
  return this.series;
};
protoOf(PointSeriesSubConnector).u2g = function () {
  return this.positionInSeries;
};
protoOf(PointSeriesSubConnector).b2 = function () {
  return this.z27_1.x2e_1;
};
protoOf(PointSeriesSubConnector).w2a = function () {
  return this.series.s2f_1;
};
protoOf(PointSeriesSubConnector).x2a = function () {
  return this.a28_1;
};
protoOf(PointSeriesSubConnector).y2a = function () {
  return this.z27_1.g2f_1;
};
protoOf(PointSeriesSubConnector).contains = function (localSpacePoint) {
  return this.z27_1.contains(localSpacePoint);
};
protoOf(PointSeriesSubConnector).enable = function (enable) {
  return this.z27_1.enable(enable);
};
protoOf(PointSeriesSubConnector).z2a = function () {
  return this.b28_1;
};
protoOf(PointSeriesSubConnector).tags = function () {
  return this.z27_1.tags();
};
protoOf(PointSeriesSubConnector).offers = function () {
  return this.series.offers();
};
protoOf(PointSeriesSubConnector).demands = function () {
  return this.series.demands();
};
protoOf(PointSeriesSubConnector).h2b = function () {
  return this.z27_1.b2f_1;
};
protoOf(PointSeriesSubConnector).i2b = function () {
  return this.c28_1;
};
protoOf(PointSeriesSubConnector).j2b = function () {
  return this.d28_1;
};
protoOf(PointSeriesSubConnector).closest = function (child) {
  return this.z27_1.closest(child);
};
protoOf(PointSeriesSubConnector).n28 = function () {
  return this.z27_1.a2f_1;
};
protoOf(PointSeriesSubConnector).move = function (movementDelta) {
  throw UnsupportedOperationException_init_$Create$(toString_0(PointSeriesSubConnector$_init_$ref_dzni41()) + ' is not allowed to move, any changes must be applied to its ' + toString_0(series$factory(this)));
};
protoOf(PointSeriesSubConnector).rotate = function (rotationDelta) {
  throw UnsupportedOperationException_init_$Create$(toString_0(PointSeriesSubConnector$_init_$ref_dzni41_0()) + ' is not allowed to move, any changes must be applied to its ' + toString_0(series$factory_0(this)));
};
protoOf(PointSeriesSubConnector).reposition = function (newPositions) {
  throw UnsupportedOperationException_init_$Create$(toString_0(PointSeriesSubConnector$_init_$ref_dzni41_1()) + ' is not allowed to move, any changes must be applied to its ' + toString_0(series$factory_1(this)));
};
protoOf(PointSeriesSubConnector).toString = function () {
  return '' + getKClassFromExpression(this).oa() + ' ' + this.key;
};
protoOf(PointSeriesSubConnector).equalsByValue = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  if (other instanceof PointSeriesSubConnector) {
    tmp_1 = other.z27_1.equalsByValue(this.z27_1);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = other.positionInSeries.equals(this.positionInSeries);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = other.series.equalsByValue(this.series);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(PointSeriesSubConnector).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof PointSeriesSubConnector))
    THROW_CCE();
  if (!(this.hole === other.hole))
    return false;
  if (!this.series.equals(other.series))
    return false;
  return true;
};
protoOf(PointSeriesSubConnector).withKey = function (key) {
  this.y27_1.warn(PointSeriesSubConnector$withKey$lambda);
  return this;
};
protoOf(PointSeriesSubConnector).hashCode = function () {
  var result = protoOf(Connector).hashCode.call(this);
  result = imul(31, result) + this.hole | 0;
  result = imul(31, result) + this.series.hashCode() | 0;
  return result;
};
protoOf(PointSeriesSubConnector).tf = function () {
  return this.hole;
};
protoOf(PointSeriesSubConnector).uf = function () {
  return this.series;
};
protoOf(PointSeriesSubConnector).v2g = function (hole, series) {
  return new PointSeriesSubConnector(hole, series);
};
protoOf(PointSeriesSubConnector).copy = function (hole, series, $super) {
  hole = hole === VOID ? this.hole : hole;
  series = series === VOID ? this.series : series;
  return this.v2g(hole, series);
};
function series$factory($b0) {
  return getPropertyCallableRef('series', 0, KProperty0, function () {
    return $b0.series;
  }, null);
}
function series$factory_0($b0) {
  return getPropertyCallableRef('series', 0, KProperty0, function () {
    return $b0.series;
  }, null);
}
function series$factory_1($b0) {
  return getPropertyCallableRef('series', 0, KProperty0, function () {
    return $b0.series;
  }, null);
}
function RelativeConnectorData(connectorKey, relativePositions) {
  this.connectorKey = connectorKey;
  this.relativePositions = relativePositions;
}
protoOf(RelativeConnectorData).w2g = function () {
  return this.connectorKey;
};
protoOf(RelativeConnectorData).x2g = function () {
  return this.relativePositions;
};
protoOf(RelativeConnectorData).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof RelativeConnectorData))
    THROW_CCE();
  if (!(this.connectorKey === other.connectorKey))
    return false;
  return true;
};
protoOf(RelativeConnectorData).hashCode = function () {
  return getStringHashCode(this.connectorKey);
};
protoOf(RelativeConnectorData).tf = function () {
  return this.connectorKey;
};
protoOf(RelativeConnectorData).uf = function () {
  return this.relativePositions;
};
protoOf(RelativeConnectorData).y2g = function (connectorKey, relativePositions) {
  return new RelativeConnectorData(connectorKey, relativePositions);
};
protoOf(RelativeConnectorData).copy = function (connectorKey, relativePositions, $super) {
  connectorKey = connectorKey === VOID ? this.connectorKey : connectorKey;
  relativePositions = relativePositions === VOID ? this.relativePositions : relativePositions;
  return this.y2g(connectorKey, relativePositions);
};
protoOf(RelativeConnectorData).toString = function () {
  return 'RelativeConnectorData(connectorKey=' + this.connectorKey + ', relativePositions=' + toString_0(this.relativePositions) + ')';
};
function productBounds($this, entity) {
  return Companion_getInstance_13().objectOrientedBoundingBoxForAssemblyHierarchy(entity).axisAlignedBoundingBox;
}
function Companion_37() {
}
protoOf(Companion_37).y1l = function (entity) {
  var tmp0_elvis_lhs = get_relativeConnectorsComponent(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var relativeConnectors = tmp;
  var bounds = productBounds(this, entity);
  if (bounds.width === 0.0 && bounds.height === 0.0 && bounds.depth === 0.0)
    return Unit_instance;
  var newSnappableComponent = this.z2g(get_connectorsComponent(entity), relativeConnectors, bounds);
  if (!(newSnappableComponent == null)) {
    entity.addComponent(newSnappableComponent);
  }
};
protoOf(Companion_37).z2g = function (connectorsComponent, relativeConnectorsComponent, aabb) {
  var tmp;
  if (connectorsComponent == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.connectors.Companion.repositionRelativeConnectors.<anonymous>' call
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = connectorsComponent.connectors;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4;
        $l$block_0: {
          // Inline function 'com.ikea.core.connectors.Companion.repositionRelativeConnectors.<anonymous>.<anonymous>' call
          var connector = this_0[i];
          // Inline function 'kotlin.collections.find' call
          var this_1 = relativeConnectorsComponent.connectors;
          var tmp$ret$2;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_0 = 0;
            var last_0 = this_1.length;
            while (inductionVariable_0 < last_0) {
              var element = this_1[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.core.connectors.Companion.repositionRelativeConnectors.<anonymous>.<anonymous>.<anonymous>' call
              if (element.connectorKey === connector.key) {
                tmp$ret$2 = element;
                break $l$block;
              }
            }
            tmp$ret$2 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$2;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$4 = connector;
            break $l$block_0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var relativeConnectorInfo = tmp_0;
          tmp$ret$4 = Companion_instance_37.c2h(connector, relativeConnectorInfo, aabb);
        }
        arr[i] = tmp$ret$4;
      }
       while (inductionVariable <= last);
    tmp = isArray(arr) ? arr : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_1 = [];
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var translatedConnectors = tmp_1;
  var tmp_2;
  var tmp_3;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(translatedConnectors.length === 0)) {
    tmp_3 = !(connectorsComponent == null);
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = new ConnectorsComponent(translatedConnectors);
  } else {
    tmp_2 = connectorsComponent;
  }
  return tmp_2;
};
protoOf(Companion_37).c2h = function (connector, relativeConnectorData, aabb) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = relativeConnectorData.relativePositions;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.connectors.Companion.repositionConnector.<anonymous>' call
    var tmp$ret$0 = item.applyToBox(aabb);
    destination.h(tmp$ret$0);
  }
  var movedConnectorPoints = copyToArray(destination);
  var newConnector = connector.reposition(movedConnectorPoints);
  var tmp;
  if (newConnector.equalsByValue(connector)) {
    tmp = connector;
  } else {
    tmp = newConnector;
  }
  return tmp;
};
protoOf(Companion_37).d2h = function (entity) {
  return get_objectOrientedBoundingBoxForHierarchy(entity).axisAlignedBoundingBox;
};
var Companion_instance_37;
function Companion_getInstance_38() {
  return Companion_instance_37;
}
function repositionRelativeConnectorsFromBounds(entity) {
  return Companion_instance_37.y1l(entity);
}
function repositionRelativeConnectors(connectorsComponent, relativeConnectorsComponent, aabb) {
  return Companion_instance_37.z2g(connectorsComponent, relativeConnectorsComponent, aabb);
}
function repositionConnector(connector, relativeConnectorData, aabb) {
  return Companion_instance_37.c2h(connector, relativeConnectorData, aabb);
}
function localBounds(entity) {
  return Companion_instance_37.d2h(entity);
}
function RelativeConnectorRepositioner() {
}
function Companion_38() {
  Companion_instance_38 = this;
  this.id = Companion_instance_21.l1o_1;
}
protoOf(Companion_38).n1s = function () {
  return this.id;
};
var Companion_instance_38;
function Companion_getInstance_39() {
  if (Companion_instance_38 == null)
    new Companion_38();
  return Companion_instance_38;
}
function RelativeConnectorsComponent(connectors) {
  Companion_getInstance_39();
  this.connectors = connectors;
  this.a2h_1 = Companion_getInstance_39().id;
  this.b2h_1 = 0;
}
protoOf(RelativeConnectorsComponent).t2c = function () {
  return this.connectors;
};
protoOf(RelativeConnectorsComponent).p1s = function () {
  return this.a2h_1;
};
protoOf(RelativeConnectorsComponent).eq = function (other) {
  return false;
};
protoOf(RelativeConnectorsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof RelativeConnectorsComponent))
    THROW_CCE();
  if (!contentEquals(this.connectors, other.connectors))
    return false;
  return true;
};
protoOf(RelativeConnectorsComponent).hashCode = function () {
  if (this.b2h_1 === 0) {
    this.b2h_1 = contentHashCode(this.connectors);
  }
  return this.b2h_1;
};
protoOf(RelativeConnectorsComponent).tf = function () {
  return this.connectors;
};
protoOf(RelativeConnectorsComponent).e2h = function (connectors) {
  return new RelativeConnectorsComponent(connectors);
};
protoOf(RelativeConnectorsComponent).copy = function (connectors, $super) {
  connectors = connectors === VOID ? this.connectors : connectors;
  return this.e2h(connectors);
};
protoOf(RelativeConnectorsComponent).toString = function () {
  return 'RelativeConnectorsComponent(connectors=' + toString_0(this.connectors) + ')';
};
function get_relativeConnectorsComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_39().id);
}
function Companion_39() {
  this.f2h_1 = 0;
  this.g2h_1 = 1;
}
protoOf(Companion_39).h2h = function () {
  return this.f2h_1;
};
protoOf(Companion_39).i2h = function () {
  return this.g2h_1;
};
var Companion_instance_39;
function Companion_getInstance_40() {
  return Companion_instance_39;
}
function get_NONE() {
  return Companion_instance_39.f2h_1;
}
function get_ONE() {
  return Companion_instance_39.g2h_1;
}
function RotationDegreeOfFreedom() {
}
var RotationDegreeOfFreedom_NONE_instance;
var RotationDegreeOfFreedom_ONE_instance;
var RotationDegreeOfFreedom_entriesInitialized;
function RotationDegreeOfFreedom_initEntries() {
  if (RotationDegreeOfFreedom_entriesInitialized)
    return Unit_instance;
  RotationDegreeOfFreedom_entriesInitialized = true;
  RotationDegreeOfFreedom_NONE_instance = new KtRotationDegreeOfFreedom('NONE', 0);
  RotationDegreeOfFreedom_ONE_instance = new KtRotationDegreeOfFreedom('ONE', 1);
}
function KtRotationDegreeOfFreedom(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function RotationDegreeOfFreedom_NONE_getInstance() {
  RotationDegreeOfFreedom_initEntries();
  return RotationDegreeOfFreedom_NONE_instance;
}
function RotationDegreeOfFreedom_ONE_getInstance() {
  RotationDegreeOfFreedom_initEntries();
  return RotationDegreeOfFreedom_ONE_instance;
}
function validateNoCollinearPointsInSurfaceConnector($this) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listOfVerticesToRemove = ArrayList_init_$Create$();
  var previousIndex = $this.vertices.length - 1 | 0;
  var inductionVariable = 0;
  var last = $this.vertices.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.vertices[index].minus($this.vertices[previousIndex]).cross($this.vertices[(index + 1 | 0) % $this.vertices.length | 0].minus($this.vertices[index])).size < 0.001) {
        var tmp = Companion_getInstance_41().logger;
        tmp.warn(SurfaceConnector$validateNoCollinearPointsInSurfaceConnector$lambda(index));
        listOfVerticesToRemove.h(index);
      }
      previousIndex = index;
    }
     while (inductionVariable <= last);
  var tmp_0 = $this;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_indices($this.vertices);
  var destination = ArrayList_init_$Create$();
  var inductionVariable_0 = this_0.w_1;
  var last_0 = this_0.x_1;
  if (inductionVariable_0 <= last_0)
    do {
      var element = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.connectors.SurfaceConnector.validateNoCollinearPointsInSurfaceConnector.<anonymous>' call
      var i = element;
      if (!listOfVerticesToRemove.s(i)) {
        destination.h(element);
      }
    }
     while (!(element === last_0));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.connectors.SurfaceConnector.validateNoCollinearPointsInSurfaceConnector.<anonymous>' call
    var tmp$ret$4 = $this.vertices[item];
    destination_0.h(tmp$ret$4);
  }
  tmp_0.vertices = copyToArray(destination_0);
}
function Companion_40() {
  Companion_instance_40 = this;
  this.logger = LoggerState_getInstance().g1v('Surface Connector');
}
protoOf(Companion_40).l1k = function () {
  return this.logger;
};
var Companion_instance_40;
function Companion_getInstance_41() {
  if (Companion_instance_40 == null)
    new Companion_40();
  return Companion_instance_40;
}
function SurfaceConnector$validateNoCollinearPointsInSurfaceConnector$lambda($index) {
  return function () {
    return 'Vertex supplied to surface connector at index ' + $index + ' is collinear, removing vertex.';
  };
}
function SurfaceConnector(key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required) {
  Companion_getInstance_41();
  priority = priority === VOID ? 0 : priority;
  activationDistance = activationDistance === VOID ? type === Companion_instance_32.m2b_1 ? Companion_instance_31.DEFAULT_HOST_ACTIVATION_DISTANCE : Companion_instance_31.DEFAULT_GUEST_ACTIVATION_DISTANCE : activationDistance;
  enabled = enabled === VOID ? true : enabled;
  var tmp;
  if (tagArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = tagArray;
  }
  tagArray = tmp;
  var tmp_0;
  if (offersArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0 = [];
  } else {
    tmp_0 = offersArray;
  }
  offersArray = tmp_0;
  var tmp_1;
  if (demandsArray === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1 = [];
  } else {
    tmp_1 = demandsArray;
  }
  demandsArray = tmp_1;
  required = required === VOID ? false : required;
  Connector.call(this);
  this.p2h_1 = key;
  this.q2h_1 = type;
  this.vertices = vertices;
  this.r2h_1 = priority;
  this.s2h_1 = activationDistance;
  this.t2h_1 = enabled;
  this.u2h_1 = tagArray;
  this.v2h_1 = offersArray;
  this.w2h_1 = demandsArray;
  this.x2h_1 = required;
  if (this.vertices.length < 3) {
    throw IllegalArgumentException_init_$Create$('A surface connector needs at least 3 vertices. Provided vertices: ' + this.vertices);
  }
  this.anchor = get_geometricMean(this.vertices);
  this.normal = Companion_getInstance_129().a2i(this.vertices);
  validateNoCollinearPointsInSurfaceConnector(this);
  this.y2h_1 = Companion_instance_146.b2i(this.normal, this.anchor);
  this.z2h_1 = true;
  this.plane = new Plane(this.anchor, this.normal);
}
protoOf(SurfaceConnector).b2 = function () {
  return this.p2h_1;
};
protoOf(SurfaceConnector).w2a = function () {
  return this.q2h_1;
};
protoOf(SurfaceConnector).c2i = function (_set____db54di) {
  this.vertices = _set____db54di;
};
protoOf(SurfaceConnector).d2i = function () {
  return this.vertices;
};
protoOf(SurfaceConnector).n28 = function () {
  return this.r2h_1;
};
protoOf(SurfaceConnector).h2b = function () {
  return this.s2h_1;
};
protoOf(SurfaceConnector).i2b = function () {
  return this.t2h_1;
};
protoOf(SurfaceConnector).b2b = function (_set____db54di) {
  this.u2h_1 = _set____db54di;
};
protoOf(SurfaceConnector).c2b = function () {
  return this.u2h_1;
};
protoOf(SurfaceConnector).d2b = function (_set____db54di) {
  this.v2h_1 = _set____db54di;
};
protoOf(SurfaceConnector).e2b = function () {
  return this.v2h_1;
};
protoOf(SurfaceConnector).f2b = function (_set____db54di) {
  this.w2h_1 = _set____db54di;
};
protoOf(SurfaceConnector).g2b = function () {
  return this.w2h_1;
};
protoOf(SurfaceConnector).x2a = function () {
  return this.x2h_1;
};
protoOf(SurfaceConnector).e2i = function () {
  return this.anchor;
};
protoOf(SurfaceConnector).f2i = function () {
  return this.normal;
};
protoOf(SurfaceConnector).z2a = function () {
  return this.y2h_1;
};
protoOf(SurfaceConnector).equalsByValue = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  var tmp_5;
  var tmp_6;
  var tmp_7;
  if (other instanceof SurfaceConnector) {
    tmp_7 = other.p2h_1 === this.p2h_1;
  } else {
    tmp_7 = false;
  }
  if (tmp_7) {
    tmp_6 = contentEquals(other.vertices, this.vertices);
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    tmp_5 = other.y2h_1.equals(this.y2h_1);
  } else {
    tmp_5 = false;
  }
  if (tmp_5) {
    tmp_4 = other.r2h_1 === this.r2h_1;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = other.s2h_1 === this.s2h_1;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = other.t2h_1 === this.t2h_1;
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = contentEquals(other.u2h_1, this.u2h_1);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = contentEquals(other.offers(), this.offers());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = contentEquals(other.demands(), this.demands());
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(SurfaceConnector).j2b = function () {
  return this.z2h_1;
};
protoOf(SurfaceConnector).y2a = function () {
  return 0.0;
};
protoOf(SurfaceConnector).g2i = function () {
  return this.plane;
};
protoOf(SurfaceConnector).reposition = function (newPositions) {
  return new SurfaceConnector(this.p2h_1, this.q2h_1, newPositions, this.r2h_1, this.s2h_1, this.t2h_1, this.u2h_1, this.v2h_1);
};
protoOf(SurfaceConnector).move = function (movementDelta) {
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.vertices;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.SurfaceConnector.move.<anonymous>' call
      arr[i] = this_0[i].plus(movementDelta);
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return this.copy(VOID, VOID, tmp$ret$2);
};
protoOf(SurfaceConnector).rotate = function (rotationDelta) {
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.vertices;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.connectors.SurfaceConnector.rotate.<anonymous>' call
      arr[i] = this_0[i].rotate(rotationDelta);
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return this.copy(VOID, VOID, tmp$ret$2);
};
protoOf(SurfaceConnector).enable = function (enable) {
  return this.copy(VOID, VOID, VOID, VOID, VOID, enable);
};
protoOf(SurfaceConnector).closest = function (child) {
  var pE = child.projectOnPlaneFromPoints(this.vertices[0], this.vertices[1], this.vertices[2]);
  return this.contains(pE) ? pE : closestOnEdge(child, this.vertices);
};
protoOf(SurfaceConnector).contains = function (localSpacePoint) {
  var tmp;
  if (closestOnEdge(localSpacePoint, this.vertices).distanceTo(localSpacePoint) < 1.0E-4) {
    tmp = true;
  } else {
    tmp = Companion_getInstance_129().pointInPolygon(localSpacePoint, this.vertices, this.normal);
  }
  return tmp;
};
protoOf(SurfaceConnector).withKey = function (key) {
  return this.copy(key);
};
protoOf(SurfaceConnector).tf = function () {
  return this.p2h_1;
};
protoOf(SurfaceConnector).uf = function () {
  return this.q2h_1;
};
protoOf(SurfaceConnector).m1m = function () {
  return this.vertices;
};
protoOf(SurfaceConnector).n1m = function () {
  return this.r2h_1;
};
protoOf(SurfaceConnector).o1m = function () {
  return this.s2h_1;
};
protoOf(SurfaceConnector).p1m = function () {
  return this.t2h_1;
};
protoOf(SurfaceConnector).q1m = function () {
  return this.u2h_1;
};
protoOf(SurfaceConnector).l2e = function () {
  return this.v2h_1;
};
protoOf(SurfaceConnector).m2e = function () {
  return this.w2h_1;
};
protoOf(SurfaceConnector).n2e = function () {
  return this.x2h_1;
};
protoOf(SurfaceConnector).h2i = function (key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required) {
  return new SurfaceConnector(key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required);
};
protoOf(SurfaceConnector).copy = function (key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required, $super) {
  key = key === VOID ? this.p2h_1 : key;
  type = type === VOID ? this.q2h_1 : type;
  vertices = vertices === VOID ? this.vertices : vertices;
  priority = priority === VOID ? this.r2h_1 : priority;
  activationDistance = activationDistance === VOID ? this.s2h_1 : activationDistance;
  enabled = enabled === VOID ? this.t2h_1 : enabled;
  tagArray = tagArray === VOID ? this.u2h_1 : tagArray;
  offersArray = offersArray === VOID ? this.v2h_1 : offersArray;
  demandsArray = demandsArray === VOID ? this.w2h_1 : demandsArray;
  required = required === VOID ? this.x2h_1 : required;
  return this.h2i(key, type, vertices, priority, activationDistance, enabled, tagArray, offersArray, demandsArray, required);
};
protoOf(SurfaceConnector).toString = function () {
  return 'SurfaceConnector(key=' + this.p2h_1 + ', type=' + this.q2h_1 + ', vertices=' + toString_0(this.vertices) + ', priority=' + this.r2h_1 + ', activationDistance=' + this.s2h_1 + ', enabled=' + this.t2h_1 + ', tagArray=' + toString_0(this.u2h_1) + ', offersArray=' + toString_0(this.v2h_1) + ', demandsArray=' + toString_0(this.w2h_1) + ', required=' + this.x2h_1 + ')';
};
protoOf(SurfaceConnector).hashCode = function () {
  var result = getStringHashCode(this.p2h_1);
  result = imul(result, 31) + this.q2h_1 | 0;
  result = imul(result, 31) + hashCode(this.vertices) | 0;
  result = imul(result, 31) + this.r2h_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.s2h_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.t2h_1) | 0;
  result = imul(result, 31) + hashCode(this.u2h_1) | 0;
  result = imul(result, 31) + hashCode(this.v2h_1) | 0;
  result = imul(result, 31) + hashCode(this.w2h_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.x2h_1) | 0;
  return result;
};
protoOf(SurfaceConnector).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SurfaceConnector))
    return false;
  var tmp0_other_with_cast = other instanceof SurfaceConnector ? other : THROW_CCE();
  if (!(this.p2h_1 === tmp0_other_with_cast.p2h_1))
    return false;
  if (!(this.q2h_1 === tmp0_other_with_cast.q2h_1))
    return false;
  if (!equals(this.vertices, tmp0_other_with_cast.vertices))
    return false;
  if (!(this.r2h_1 === tmp0_other_with_cast.r2h_1))
    return false;
  if (!equals(this.s2h_1, tmp0_other_with_cast.s2h_1))
    return false;
  if (!(this.t2h_1 === tmp0_other_with_cast.t2h_1))
    return false;
  if (!equals(this.u2h_1, tmp0_other_with_cast.u2h_1))
    return false;
  if (!equals(this.v2h_1, tmp0_other_with_cast.v2h_1))
    return false;
  if (!equals(this.w2h_1, tmp0_other_with_cast.w2h_1))
    return false;
  if (!(this.x2h_1 === tmp0_other_with_cast.x2h_1))
    return false;
  return true;
};
function DebugLine(start, end, color, thickness) {
  this.start = start;
  this.end = end;
  this.color = color;
  this.thickness = thickness;
}
protoOf(DebugLine).kd = function () {
  return this.start;
};
protoOf(DebugLine).i2i = function () {
  return this.end;
};
protoOf(DebugLine).j2i = function () {
  return this.color;
};
protoOf(DebugLine).k2i = function () {
  return this.thickness;
};
protoOf(DebugLine).tf = function () {
  return this.start;
};
protoOf(DebugLine).uf = function () {
  return this.end;
};
protoOf(DebugLine).m1m = function () {
  return this.color;
};
protoOf(DebugLine).n1m = function () {
  return this.thickness;
};
protoOf(DebugLine).l2i = function (start, end, color, thickness) {
  return new DebugLine(start, end, color, thickness);
};
protoOf(DebugLine).copy = function (start, end, color, thickness, $super) {
  start = start === VOID ? this.start : start;
  end = end === VOID ? this.end : end;
  color = color === VOID ? this.color : color;
  thickness = thickness === VOID ? this.thickness : thickness;
  return this.l2i(start, end, color, thickness);
};
protoOf(DebugLine).toString = function () {
  return 'DebugLine(start=' + this.start.toString() + ', end=' + this.end.toString() + ', color=' + this.color.toString() + ', thickness=' + this.thickness + ')';
};
protoOf(DebugLine).hashCode = function () {
  var result = this.start.hashCode();
  result = imul(result, 31) + this.end.hashCode() | 0;
  result = imul(result, 31) + this.color.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.thickness) | 0;
  return result;
};
protoOf(DebugLine).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DebugLine))
    return false;
  var tmp0_other_with_cast = other instanceof DebugLine ? other : THROW_CCE();
  if (!this.start.equals(tmp0_other_with_cast.start))
    return false;
  if (!this.end.equals(tmp0_other_with_cast.end))
    return false;
  if (!this.color.equals(tmp0_other_with_cast.color))
    return false;
  if (!equals(this.thickness, tmp0_other_with_cast.thickness))
    return false;
  return true;
};
function Companion_41() {
  Companion_instance_41 = this;
  this.id = Companion_instance_21.j1q_1;
}
protoOf(Companion_41).n1s = function () {
  return this.id;
};
var Companion_instance_41;
function Companion_getInstance_42() {
  if (Companion_instance_41 == null)
    new Companion_41();
  return Companion_instance_41;
}
function DebugLinesComponent(lines) {
  Companion_getInstance_42();
  this.lines = lines;
}
protoOf(DebugLinesComponent).m2i = function () {
  return this.lines;
};
protoOf(DebugLinesComponent).p1s = function () {
  return Companion_getInstance_42().id;
};
protoOf(DebugLinesComponent).eq = function (other) {
  return contentDeepEquals(this.lines, (other instanceof DebugLinesComponent ? other : THROW_CCE()).lines);
};
function Companion_42() {
  Companion_instance_42 = this;
  this.id = Companion_instance_21.k1r_1;
}
protoOf(Companion_42).n1s = function () {
  return this.id;
};
var Companion_instance_42;
function Companion_getInstance_43() {
  if (Companion_instance_42 == null)
    new Companion_42();
  return Companion_instance_42;
}
function DebugSurfacesComponent(surfaces) {
  Companion_getInstance_43();
  this.surfaces = surfaces;
}
protoOf(DebugSurfacesComponent).n2i = function () {
  return this.surfaces;
};
protoOf(DebugSurfacesComponent).p1s = function () {
  return Companion_getInstance_43().id;
};
protoOf(DebugSurfacesComponent).eq = function (other) {
  return contentDeepEquals(this.surfaces, (other instanceof DebugSurfacesComponent ? other : THROW_CCE()).surfaces);
};
function Companion_43() {
  Companion_instance_43 = this;
  this.id = Companion_instance_21.r1p_1;
}
protoOf(Companion_43).n1s = function () {
  return this.id;
};
var Companion_instance_43;
function Companion_getInstance_44() {
  if (Companion_instance_43 == null)
    new Companion_43();
  return Companion_instance_43;
}
function DragSurfacesComponent(surfaces, basedOnCollider) {
  Companion_getInstance_44();
  basedOnCollider = basedOnCollider === VOID ? false : basedOnCollider;
  this.surfaces = surfaces;
  this.basedOnCollider = basedOnCollider;
}
protoOf(DragSurfacesComponent).n2i = function () {
  return this.surfaces;
};
protoOf(DragSurfacesComponent).o2i = function () {
  return this.basedOnCollider;
};
protoOf(DragSurfacesComponent).p1s = function () {
  return Companion_getInstance_44().id;
};
protoOf(DragSurfacesComponent).eq = function (other) {
  var tmp;
  if (contentDeepEquals(this.surfaces, (other instanceof DragSurfacesComponent ? other : THROW_CCE()).surfaces)) {
    tmp = this.basedOnCollider === other.basedOnCollider;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(DragSurfacesComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof DragSurfacesComponent))
    THROW_CCE();
  if (!contentEquals(this.surfaces, other.surfaces))
    return false;
  if (!(this.basedOnCollider === other.basedOnCollider))
    return false;
  return true;
};
protoOf(DragSurfacesComponent).hashCode = function () {
  var result = contentHashCode(this.surfaces);
  result = imul(31, result) + getBooleanHashCode(this.basedOnCollider) | 0;
  return result;
};
protoOf(DragSurfacesComponent).tf = function () {
  return this.surfaces;
};
protoOf(DragSurfacesComponent).uf = function () {
  return this.basedOnCollider;
};
protoOf(DragSurfacesComponent).p2i = function (surfaces, basedOnCollider) {
  return new DragSurfacesComponent(surfaces, basedOnCollider);
};
protoOf(DragSurfacesComponent).copy = function (surfaces, basedOnCollider, $super) {
  surfaces = surfaces === VOID ? this.surfaces : surfaces;
  basedOnCollider = basedOnCollider === VOID ? this.basedOnCollider : basedOnCollider;
  return this.p2i(surfaces, basedOnCollider);
};
protoOf(DragSurfacesComponent).toString = function () {
  return 'DragSurfacesComponent(surfaces=' + toString_0(this.surfaces) + ', basedOnCollider=' + this.basedOnCollider + ')';
};
function DragSurface(surface, connectorKeys, isFallbackSurface) {
  connectorKeys = connectorKeys === VOID ? null : connectorKeys;
  isFallbackSurface = isFallbackSurface === VOID ? false : isFallbackSurface;
  this.surface = surface;
  this.connectorKeys = connectorKeys;
  this.isFallbackSurface = isFallbackSurface;
}
protoOf(DragSurface).q2i = function () {
  return this.surface;
};
protoOf(DragSurface).r2i = function () {
  return this.connectorKeys;
};
protoOf(DragSurface).s2i = function () {
  return this.isFallbackSurface;
};
protoOf(DragSurface).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof DragSurface))
    THROW_CCE();
  if (!equals(this.surface, other.surface))
    return false;
  if (!(this.connectorKeys == null)) {
    if (other.connectorKeys == null)
      return false;
    if (!contentEquals(this.connectorKeys, other.connectorKeys))
      return false;
  } else if (!(other.connectorKeys == null))
    return false;
  return true;
};
protoOf(DragSurface).hashCode = function () {
  var result = hashCode(this.surface);
  var tmp = imul(31, result);
  var tmp0_safe_receiver = this.connectorKeys;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contentHashCode(tmp0_safe_receiver);
  result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  return result;
};
protoOf(DragSurface).tf = function () {
  return this.surface;
};
protoOf(DragSurface).uf = function () {
  return this.connectorKeys;
};
protoOf(DragSurface).m1m = function () {
  return this.isFallbackSurface;
};
protoOf(DragSurface).t2i = function (surface, connectorKeys, isFallbackSurface) {
  return new DragSurface(surface, connectorKeys, isFallbackSurface);
};
protoOf(DragSurface).copy = function (surface, connectorKeys, isFallbackSurface, $super) {
  surface = surface === VOID ? this.surface : surface;
  connectorKeys = connectorKeys === VOID ? this.connectorKeys : connectorKeys;
  isFallbackSurface = isFallbackSurface === VOID ? this.isFallbackSurface : isFallbackSurface;
  return this.t2i(surface, connectorKeys, isFallbackSurface);
};
protoOf(DragSurface).toString = function () {
  return 'DragSurface(surface=' + toString_0(this.surface) + ', connectorKeys=' + toString_0(this.connectorKeys) + ', isFallbackSurface=' + this.isFallbackSurface + ')';
};
function get_dragSurfacesComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_instance_21.r1p_1);
}
function Companion_44() {
  Companion_instance_44 = this;
  this.id = Companion_instance_21.z1m_1;
}
protoOf(Companion_44).n1s = function () {
  return this.id;
};
var Companion_instance_44;
function Companion_getInstance_45() {
  if (Companion_instance_44 == null)
    new Companion_44();
  return Companion_instance_44;
}
function DraggableComponent() {
  Companion_getInstance_45();
}
protoOf(DraggableComponent).p1s = function () {
  return Companion_getInstance_45().id;
};
protoOf(DraggableComponent).eq = function (other) {
  return true;
};
function Companion_45() {
  Companion_instance_45 = this;
  this.id = Companion_instance_21.j1p_1;
}
protoOf(Companion_45).n1s = function () {
  return this.id;
};
var Companion_instance_45;
function Companion_getInstance_46() {
  if (Companion_instance_45 == null)
    new Companion_45();
  return Companion_instance_45;
}
function SomethingIsDraggedComponent(entity) {
  Companion_getInstance_46();
  this.entity = entity;
  this.u2i_1 = false;
}
protoOf(SomethingIsDraggedComponent).v2i = function () {
  return this.entity;
};
protoOf(SomethingIsDraggedComponent).p1s = function () {
  return Companion_getInstance_46().id;
};
protoOf(SomethingIsDraggedComponent).eq = function (other) {
  return (other instanceof SomethingIsDraggedComponent ? other : THROW_CCE()).entity.equals(this.entity);
};
protoOf(SomethingIsDraggedComponent).s1s = function () {
  return this.u2i_1;
};
function Companion_46() {
  Companion_instance_46 = this;
  this.id = Companion_instance_21.b1q_1;
}
protoOf(Companion_46).n1s = function () {
  return this.id;
};
var Companion_instance_46;
function Companion_getInstance_47() {
  if (Companion_instance_46 == null)
    new Companion_46();
  return Companion_instance_46;
}
function ViewerDragEventComponent$rayFromCameraToDragEnd$delegate$lambda(this$0) {
  return function () {
    var rayDir = this$0.planePoint.minus(this$0.cameraPosition).normalize();
    var ray = new Ray(this$0.cameraPosition, rayDir);
    return ray;
  };
}
function ViewerDragEventComponent(planePoint, planeNormal, delta, cameraPosition) {
  Companion_getInstance_47();
  this.planePoint = planePoint;
  this.planeNormal = planeNormal;
  this.delta = delta;
  this.cameraPosition = cameraPosition;
  var tmp = this;
  tmp.w2i_1 = lazy(ViewerDragEventComponent$rayFromCameraToDragEnd$delegate$lambda(this));
  this.x2i_1 = Companion_getInstance_47().id;
  this.y2i_1 = false;
}
protoOf(ViewerDragEventComponent).z2i = function () {
  return this.planePoint;
};
protoOf(ViewerDragEventComponent).a2j = function () {
  return this.planeNormal;
};
protoOf(ViewerDragEventComponent).b2j = function () {
  return this.delta;
};
protoOf(ViewerDragEventComponent).c2j = function () {
  return this.cameraPosition;
};
protoOf(ViewerDragEventComponent).d2j = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.w2i_1;
  rayFromCameraToDragEnd$factory();
  return this_0.c2();
};
protoOf(ViewerDragEventComponent).p1s = function () {
  return this.x2i_1;
};
protoOf(ViewerDragEventComponent).eq = function (other) {
  if (!(other instanceof ViewerDragEventComponent))
    return false;
  return other.planePoint.equals(this.planePoint) && other.planeNormal.equals(this.planeNormal) && other.delta.equals(this.delta) && other.cameraPosition.equals(this.cameraPosition);
};
protoOf(ViewerDragEventComponent).s1s = function () {
  return this.y2i_1;
};
protoOf(ViewerDragEventComponent).tf = function () {
  return this.planePoint;
};
protoOf(ViewerDragEventComponent).uf = function () {
  return this.planeNormal;
};
protoOf(ViewerDragEventComponent).m1m = function () {
  return this.delta;
};
protoOf(ViewerDragEventComponent).n1m = function () {
  return this.cameraPosition;
};
protoOf(ViewerDragEventComponent).e2j = function (planePoint, planeNormal, delta, cameraPosition) {
  return new ViewerDragEventComponent(planePoint, planeNormal, delta, cameraPosition);
};
protoOf(ViewerDragEventComponent).copy = function (planePoint, planeNormal, delta, cameraPosition, $super) {
  planePoint = planePoint === VOID ? this.planePoint : planePoint;
  planeNormal = planeNormal === VOID ? this.planeNormal : planeNormal;
  delta = delta === VOID ? this.delta : delta;
  cameraPosition = cameraPosition === VOID ? this.cameraPosition : cameraPosition;
  return this.e2j(planePoint, planeNormal, delta, cameraPosition);
};
protoOf(ViewerDragEventComponent).toString = function () {
  return 'ViewerDragEventComponent(planePoint=' + this.planePoint.toString() + ', planeNormal=' + this.planeNormal.toString() + ', delta=' + this.delta.toString() + ', cameraPosition=' + this.cameraPosition.toString() + ')';
};
protoOf(ViewerDragEventComponent).hashCode = function () {
  var result = this.planePoint.hashCode();
  result = imul(result, 31) + this.planeNormal.hashCode() | 0;
  result = imul(result, 31) + this.delta.hashCode() | 0;
  result = imul(result, 31) + this.cameraPosition.hashCode() | 0;
  return result;
};
protoOf(ViewerDragEventComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ViewerDragEventComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ViewerDragEventComponent ? other : THROW_CCE();
  if (!this.planePoint.equals(tmp0_other_with_cast.planePoint))
    return false;
  if (!this.planeNormal.equals(tmp0_other_with_cast.planeNormal))
    return false;
  if (!this.delta.equals(tmp0_other_with_cast.delta))
    return false;
  if (!this.cameraPosition.equals(tmp0_other_with_cast.cameraPosition))
    return false;
  return true;
};
function rayFromCameraToDragEnd$factory() {
  return getPropertyCallableRef('rayFromCameraToDragEnd', 1, KProperty1, function (receiver) {
    return receiver.rayFromCameraToDragEnd;
  }, null);
}
function Companion_47() {
  this.f2j_1 = 'WorldDragSurfaceUpdateSystem';
}
var Companion_instance_47;
function Companion_getInstance_48() {
  return Companion_instance_47;
}
function updateDragSurfaces($this, entity) {
  var tmp0_safe_receiver = calculateWorldDragSurfaces($this, entity);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.dragging.WorldDragSurfaceUpdateSystem.updateDragSurfaces.<anonymous>' call
    entity.addComponent(tmp0_safe_receiver);
  }
}
function calculateWorldDragSurfaces($this, entity) {
  var tmp0_safe_receiver = get_dragSurfacesComponent(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.surfaces;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(tmp1_safe_receiver.length);
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var item = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.dragging.WorldDragSurfaceUpdateSystem.calculateWorldDragSurfaces.<anonymous>' call
      var transformedPoly = Companion_instance_146.v1y(item.surface, entity);
      var tmp$ret$0 = item.copy(transformedPoly);
      destination.h(tmp$ret$0);
    }
    tmp = destination;
  }
  var tmp2_safe_receiver = tmp;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp2_safe_receiver);
  }
  var transformedSurfaces = tmp_0;
  var tmp_1;
  if (transformedSurfaces == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.dragging.WorldDragSurfaceUpdateSystem.calculateWorldDragSurfaces.<anonymous>' call
    tmp_1 = new WorldDragSurfacesComponent(transformedSurfaces);
  }
  return tmp_1;
}
function WorldDragSurfaceUpdateSystem() {
  var tmp = Companion_instance_47.f2j_1;
  var tmp_0 = Companion_instance_21.g1n_1;
  var tmp_1 = Companion_instance_21.r1p_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = [Companion_getInstance_49().id];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [Companion_instance_145.ID];
  SystemBase2.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp$ret$5, null);
}
protoOf(WorldDragSurfaceUpdateSystem).h1z = function (entity, newComponent) {
  updateDragSurfaces(this, entity);
};
protoOf(WorldDragSurfaceUpdateSystem).v1v = function (entity, newComponent) {
  return this.h1z(entity, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(WorldDragSurfaceUpdateSystem).i1z = function (entity, oldComponent, newComponent) {
  updateDragSurfaces(this, entity);
};
protoOf(WorldDragSurfaceUpdateSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE();
  return this.i1z(entity, tmp, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(WorldDragSurfaceUpdateSystem).j1z = function (entity, oldComponent) {
  updateDragSurfaces(this, entity);
};
protoOf(WorldDragSurfaceUpdateSystem).z1v = function (entity, oldComponent) {
  return this.j1z(entity, oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE());
};
protoOf(WorldDragSurfaceUpdateSystem).r2j = function (entity, newComponent) {
  updateDragSurfaces(this, entity);
};
protoOf(WorldDragSurfaceUpdateSystem).l1z = function (entity, newComponent) {
  return this.r2j(entity, newComponent instanceof DragSurfacesComponent ? newComponent : THROW_CCE());
};
protoOf(WorldDragSurfaceUpdateSystem).s2j = function (entity, oldComponent, newComponent) {
  updateDragSurfaces(this, entity);
};
protoOf(WorldDragSurfaceUpdateSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof DragSurfacesComponent ? oldComponent : THROW_CCE();
  return this.s2j(entity, tmp, newComponent instanceof DragSurfacesComponent ? newComponent : THROW_CCE());
};
protoOf(WorldDragSurfaceUpdateSystem).t2j = function (entity, oldComponent) {
  entity.removeComponent(Companion_getInstance_49().id);
};
protoOf(WorldDragSurfaceUpdateSystem).p1z = function (entity, oldComponent) {
  return this.t2j(entity, oldComponent instanceof DragSurfacesComponent ? oldComponent : THROW_CCE());
};
function Companion_48() {
  Companion_instance_48 = this;
  this.id = Companion_instance_21.i1q_1;
}
protoOf(Companion_48).n1s = function () {
  return this.id;
};
var Companion_instance_48;
function Companion_getInstance_49() {
  if (Companion_instance_48 == null)
    new Companion_48();
  return Companion_instance_48;
}
function WorldDragSurfacesComponent(surfaces) {
  Companion_getInstance_49();
  this.surfaces = surfaces;
}
protoOf(WorldDragSurfacesComponent).n2i = function () {
  return this.surfaces;
};
protoOf(WorldDragSurfacesComponent).p1s = function () {
  return Companion_getInstance_49().id;
};
protoOf(WorldDragSurfacesComponent).eq = function (other) {
  return contentDeepEquals(this.surfaces, (other instanceof WorldDragSurfacesComponent ? other : THROW_CCE()).surfaces);
};
protoOf(WorldDragSurfacesComponent).hashCode = function () {
  return hashCode(this.surfaces);
};
protoOf(WorldDragSurfacesComponent).equals = function (other) {
  var tmp;
  if (other instanceof WorldDragSurfacesComponent) {
    tmp = contentDeepEquals(this.surfaces, other.surfaces);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(WorldDragSurfacesComponent).tf = function () {
  return this.surfaces;
};
protoOf(WorldDragSurfacesComponent).u2j = function (surfaces) {
  return new WorldDragSurfacesComponent(surfaces);
};
protoOf(WorldDragSurfacesComponent).copy = function (surfaces, $super) {
  surfaces = surfaces === VOID ? this.surfaces : surfaces;
  return this.u2j(surfaces);
};
protoOf(WorldDragSurfacesComponent).toString = function () {
  return 'WorldDragSurfacesComponent(surfaces=' + toString_0(this.surfaces) + ')';
};
function Companion_49() {
  Companion_instance_49 = this;
  this.id = Companion_instance_21.c1q_1;
}
protoOf(Companion_49).n1s = function () {
  return this.id;
};
var Companion_instance_49;
function Companion_getInstance_50() {
  if (Companion_instance_49 == null)
    new Companion_49();
  return Companion_instance_49;
}
function WorldSpaceDragEventComponent(point, rayFromCameraToDragPoint) {
  Companion_getInstance_50();
  this.point = point;
  this.rayFromCameraToDragPoint = rayFromCameraToDragPoint;
  this.v2j_1 = Companion_getInstance_50().id;
  this.w2j_1 = false;
}
protoOf(WorldSpaceDragEventComponent).x2j = function () {
  return this.point;
};
protoOf(WorldSpaceDragEventComponent).y2j = function () {
  return this.rayFromCameraToDragPoint;
};
protoOf(WorldSpaceDragEventComponent).p1s = function () {
  return this.v2j_1;
};
protoOf(WorldSpaceDragEventComponent).eq = function (other) {
  if (!(other instanceof WorldSpaceDragEventComponent))
    return false;
  return other.point.equals(this.point) && other.rayFromCameraToDragPoint.equals(this.rayFromCameraToDragPoint);
};
protoOf(WorldSpaceDragEventComponent).s1s = function () {
  return this.w2j_1;
};
protoOf(WorldSpaceDragEventComponent).tf = function () {
  return this.point;
};
protoOf(WorldSpaceDragEventComponent).uf = function () {
  return this.rayFromCameraToDragPoint;
};
protoOf(WorldSpaceDragEventComponent).z2j = function (point, rayFromCameraToDragPoint) {
  return new WorldSpaceDragEventComponent(point, rayFromCameraToDragPoint);
};
protoOf(WorldSpaceDragEventComponent).copy = function (point, rayFromCameraToDragPoint, $super) {
  point = point === VOID ? this.point : point;
  rayFromCameraToDragPoint = rayFromCameraToDragPoint === VOID ? this.rayFromCameraToDragPoint : rayFromCameraToDragPoint;
  return this.z2j(point, rayFromCameraToDragPoint);
};
protoOf(WorldSpaceDragEventComponent).toString = function () {
  return 'WorldSpaceDragEventComponent(point=' + this.point.toString() + ', rayFromCameraToDragPoint=' + this.rayFromCameraToDragPoint.toString() + ')';
};
protoOf(WorldSpaceDragEventComponent).hashCode = function () {
  var result = this.point.hashCode();
  result = imul(result, 31) + this.rayFromCameraToDragPoint.hashCode() | 0;
  return result;
};
protoOf(WorldSpaceDragEventComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WorldSpaceDragEventComponent))
    return false;
  var tmp0_other_with_cast = other instanceof WorldSpaceDragEventComponent ? other : THROW_CCE();
  if (!this.point.equals(tmp0_other_with_cast.point))
    return false;
  if (!this.rayFromCameraToDragPoint.equals(tmp0_other_with_cast.rayFromCameraToDragPoint))
    return false;
  return true;
};
function Component() {
}
function ComponentHolder() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.a2k_1 = LinkedHashMap_init_$Create$_0();
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = Companion_instance_21.m1s_1 + 1 | 0;
  tmp_0.b2k_1 = fillArrayVal(Array(size), null);
}
protoOf(ComponentHolder).c2k = function () {
  var core = filterNotNull(this.b2k_1);
  var rest = this.a2k_1.h2();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = plus_0(core, rest);
  return copyToArray(this_0);
};
protoOf(ComponentHolder).getComponent = function (componentId) {
  return fastComponent(this, componentId);
};
protoOf(ComponentHolder).d2k = function (componentId) {
  var tmp;
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    tmp = this.b2k_1[componentId];
  } else {
    tmp = this.a2k_1.f2(componentId);
  }
  return tmp;
};
protoOf(ComponentHolder).e2k = function (c) {
  var typeId = c.typeId;
  var old = this.d2k(typeId);
  if (old == null || !old.eq(c)) {
    if (Companion_instance_21.a27(c)) {
      this.b2k_1[typeId] = c;
    } else {
      // Inline function 'kotlin.collections.set' call
      this.a2k_1.q2(typeId, c);
    }
  }
  return !(old == null) ? unsafeCast(old) : old;
};
protoOf(ComponentHolder).f2k = function (componentId) {
  var tmp;
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    var tmp_0;
    if (!(this.b2k_1[componentId] == null)) {
      var c = ensureNotNull(this.b2k_1[componentId]);
      this.b2k_1[componentId] = null;
      tmp_0 = c;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  } else {
    tmp = this.a2k_1.r2(componentId);
  }
  return tmp;
};
protoOf(ComponentHolder).__getComponentForKotlin = function (componentId) {
  return fastComponent(this, componentId);
};
protoOf(ComponentHolder).g2k = function (componentId) {
  var tmp;
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    tmp = !(this.b2k_1[componentId] == null);
  } else {
    tmp = this.a2k_1.d2(componentId);
  }
  return tmp;
};
function ComponentListener() {
}
function EcsSystem() {
}
function System() {
}
function Companion_50() {
  Companion_instance_50 = this;
  this.logger = LoggerState_getInstance().g1v('Entity');
}
protoOf(Companion_50).l1k = function () {
  return this.logger;
};
var Companion_instance_50;
function Companion_getInstance_51() {
  if (Companion_instance_50 == null)
    new Companion_50();
  return Companion_instance_50;
}
function Entity(id, entityManager) {
  Companion_getInstance_51();
  this.id = id;
  this.entityManager = entityManager;
  this.v1l_1 = false;
}
protoOf(Entity).n1s = function () {
  return this.id;
};
protoOf(Entity).c1k = function () {
  return this.entityManager;
};
protoOf(Entity).i2k = function () {
  return this.components();
};
protoOf(Entity).j2k = function () {
  return this.entityManager.isDisposed(this);
};
protoOf(Entity).k2k = function (_set____db54di) {
  this.v1l_1 = _set____db54di;
};
protoOf(Entity).l2k = function () {
  return this.v1l_1;
};
protoOf(Entity).m2k = function () {
  return this.v1l_1;
};
protoOf(Entity).addComponent = function (c) {
  return this.entityManager.addComponent(this, c);
};
protoOf(Entity).removeComponent = function (componentId) {
  return this.entityManager.removeComponent(this, componentId);
};
protoOf(Entity).components = function () {
  return this.entityManager.getComponents(this);
};
protoOf(Entity).getComponent = function (componentId) {
  return this.entityManager.getComponent(this, componentId);
};
protoOf(Entity).addComponentInternal = function (c) {
  return this.entityManager.addComponentInternal(this, c);
};
protoOf(Entity).removeComponentInternal = function (componentId) {
  return this.entityManager.removeComponentInternal(this, componentId);
};
protoOf(Entity).dispose = function () {
  this.entityManager.disposeEntity(this);
};
protoOf(Entity).__getComponentForKotlin = function (componentId) {
  return this.entityManager.__getComponentForKotlin(this, componentId);
};
protoOf(Entity).getComponentUnsafe = function (componentId) {
  return this.entityManager.getComponentUnsafe(this, componentId);
};
protoOf(Entity).hasComponent = function (componentId) {
  return this.entityManager.hasComponent(this, componentId);
};
protoOf(Entity).toString = function () {
  if (this.isDisposed)
    return '' + this.id + ':-disposed-';
  var productComponent = this.__getComponentForKotlin(Companion_getInstance_8().id);
  var tmp1_elvis_lhs = productComponent == null ? null : productComponent.productRef;
  var ref = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  var displayNameComponent = this.__getComponentForKotlin(Companion_getInstance_84().id);
  var tmp3_elvis_lhs = displayNameComponent == null ? null : displayNameComponent.name;
  var displayName = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
  return ref + ':' + this.id + ':' + displayName;
};
protoOf(Entity).equals = function (other) {
  var tmp;
  if (other instanceof Entity) {
    tmp = other.id === this.id;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(Entity).hashCode = function () {
  return this.id;
};
function EntityManager() {
}
function validateInput($this, entity, componentId) {
  if (entity.id < 0) {
    throw IllegalArgumentException_init_$Create$('Entities are not allowed to have an id lower than 0');
  }
  if (componentId < 0) {
    throw IllegalArgumentException_init_$Create$('Components are not allowed to have an id lower than 0. ComponentId: ' + componentId);
  }
  return true;
}
function componentHolder($this, entityId) {
  if (entityId < 0 || entityId > $this.r2k_1.o()) {
    return null;
  }
  return $this.r2k_1.q(entityId);
}
function removeComponentHolder($this, entityId) {
  $this.r2k_1.n2(entityId, null);
}
function componentListeners($this, componentId) {
  return componentId < $this.s2k_1.length ? $this.s2k_1[componentId] : $this.t2k_1.f2(componentId);
}
function growComponentsTo($this, minSize) {
  var newSize = minSize + $this.o2k_1 | 0;
  $this.r2k_1.z5(newSize);
  while ($this.r2k_1.o() < newSize) {
    $this.r2k_1.h(null);
  }
}
function doEntityPassSystemFilter($this, entity, system) {
  if (system == null)
    return true;
  var tmp0_elvis_lhs = system.mandatoryComponents;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return true;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var componentFilter = tmp;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = componentFilter.length;
  while (inductionVariable < last) {
    var element = componentFilter[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.doEntityPassSystemFilter.<anonymous>' call
    if (!$this.hasComponent(entity, element))
      return false;
  }
  return true;
}
function doEntityIgnoreSystemFilter($this, entity, system) {
  if (system == null)
    return false;
  var tmp0_elvis_lhs = system.ignoreEntitiesWithComponents;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var ignoreComponentFilter = tmp;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = ignoreComponentFilter.length;
  while (inductionVariable < last) {
    var element = ignoreComponentFilter[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.doEntityIgnoreSystemFilter.<anonymous>' call
    if ($this.hasComponent(entity, element))
      return true;
  }
  return false;
}
function shouldSystemActOnEvent($this, entity, system) {
  if (system == null)
    return true;
  if (system.isEnabled) {
    if (doEntityIgnoreSystemFilter($this, entity, system))
      return false;
    if (doEntityPassSystemFilter($this, entity, system))
      return true;
  }
  return false;
}
function notifyComponentAdded($this, entity, comp) {
  var tmp0_safe_receiver = componentListeners($this, comp.typeId);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentAdded.<anonymous>' call
      if (!entity.isDisposed && shouldSystemActOnEvent($this, entity, element.ownerSystem)) {
        $this.c2l_1.beforeNotifyOnAdd(element);
        element.onAdd(entity, comp);
        $this.c2l_1.afterNotifyOnAdd(element);
      }
    }
  }
  if (Companion_instance_21.isCoreComponentId(comp.typeId)) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = ensureNotNull($this.u2k_1[comp.typeId]);
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentAdded.<anonymous>' call
      if (!entity.isDisposed)
        element_0(entity, comp);
    }
  } else {
    var tmp1_safe_receiver = $this.v2k_1.f2(comp.typeId);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp1_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = tmp1_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentAdded.<anonymous>' call
        if (!entity.isDisposed)
          element_1(entity, comp);
      }
    }
  }
}
function notifyComponentRemoved($this, entity, comp) {
  var tmp0_safe_receiver = componentListeners($this, comp.typeId);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentRemoved.<anonymous>' call
      if (!entity.isDisposed && shouldSystemActOnEvent($this, entity, element.ownerSystem)) {
        $this.c2l_1.beforeNotifyOnRemove(element);
        element.onRemove(entity, comp);
        $this.c2l_1.afterNotifyOnRemove(element);
      }
    }
  }
  if (Companion_instance_21.isCoreComponentId(comp.typeId)) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = ensureNotNull($this.y2k_1[comp.typeId]);
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentRemoved.<anonymous>' call
      if (!entity.isDisposed)
        element_0(entity, comp);
    }
  } else {
    var tmp1_safe_receiver = $this.z2k_1.f2(comp.typeId);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp1_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = tmp1_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentRemoved.<anonymous>' call
        if (!entity.isDisposed)
          element_1(entity, comp);
      }
    }
  }
}
function notifyComponentUpdated($this, entity, old, comp) {
  var tmp0_safe_receiver = componentListeners($this, comp.typeId);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentUpdated.<anonymous>' call
      if (!entity.isDisposed && shouldSystemActOnEvent($this, entity, element.ownerSystem)) {
        $this.c2l_1.beforeNotifyOnUpdate(element);
        element.onUpdate(entity, old, comp);
        $this.c2l_1.afterNotifyOnUpdate(element);
      }
    }
  }
  if (Companion_instance_21.isCoreComponentId(comp.typeId)) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = ensureNotNull($this.w2k_1[comp.typeId]);
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentUpdated.<anonymous>' call
      if (!entity.isDisposed)
        element_0(entity, old, comp);
    }
  } else {
    var tmp1_safe_receiver = $this.x2k_1.f2(comp.typeId);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp1_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = tmp1_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.notifyComponentUpdated.<anonymous>' call
        if (!entity.isDisposed)
          element_1(entity, old, comp);
      }
    }
  }
}
function addComponentWithNotifyCallback($this, entity, component, onUpdate, onAdd) {
  validateInput($this, entity, component.typeId);
  $this.c2l_1.beforeAddComponent(entity, component);
  var old = null;
  var componentHolder_0 = componentHolder($this, entity.id);
  if (!(componentHolder_0 == null)) {
    old = componentHolder_0.e2k(component);
    if (old == null) {
      if (onAdd == null)
        null;
      else
        onAdd(entity, component);
    } else if (!old.eq(component)) {
      if (onUpdate == null)
        null;
      else
        onUpdate(entity, component, old);
    }
  } else {
    var tmp = Companion_getInstance_52().logger;
    tmp.error(EntityManagerImpl$addComponentWithNotifyCallback$lambda(component, entity));
  }
  $this.c2l_1.afterAddComponent(entity, component);
  return old;
}
function removeFromComponentHolder($this, entity, componentId, onRemove) {
  validateInput($this, entity, componentId);
  $this.c2l_1.beforeRemoveComponent(entity, componentId);
  var old = null;
  var componentHolder_0 = componentHolder($this, entity.id);
  if (!(componentHolder_0 == null)) {
    old = componentHolder_0.f2k(componentId);
    if (onRemove == null)
      null;
    else
      onRemove(entity, old);
  } else {
    var tmp = Companion_getInstance_52().logger;
    tmp.error(EntityManagerImpl$removeFromComponentHolder$lambda(componentId, entity));
  }
  $this.c2l_1.afterRemoveComponent(entity, componentId);
  return old;
}
function Companion_51() {
  Companion_instance_51 = this;
  this.DEFAULT_ENTITIES_ARRAY_GROW_SIZE = 1000;
  this.logger = LoggerState_getInstance().g1v('EntityManagerImpl');
}
protoOf(Companion_51).d2l = function () {
  return this.DEFAULT_ENTITIES_ARRAY_GROW_SIZE;
};
protoOf(Companion_51).l1k = function () {
  return this.logger;
};
var Companion_instance_51;
function Companion_getInstance_52() {
  if (Companion_instance_51 == null)
    new Companion_51();
  return Companion_instance_51;
}
function EntityManagerImpl$createEntityInternal$lambda() {
  return 'Warning: Duplicate Entity added by EntityManager.createEntity()';
}
function EntityManagerImpl$addComponent$lambda(this$0) {
  return function (e, c, oldComponent) {
    notifyComponentUpdated(this$0, e, oldComponent, c);
    return Unit_instance;
  };
}
function EntityManagerImpl$addComponent$lambda_0(this$0) {
  return function (e, c) {
    notifyComponentAdded(this$0, e, c);
    return Unit_instance;
  };
}
function EntityManagerImpl$addComponentWithNotifyCallback$lambda($component, $entity) {
  return function () {
    return "Can't add component (id: " + $component.typeId + ') to a disposed entity (id: ' + $entity.id + ')';
  };
}
function EntityManagerImpl$removeComponent$lambda(this$0) {
  return function (e, oldComponent) {
    if (oldComponent == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      notifyComponentRemoved(this$0, e, oldComponent);
    }
    return Unit_instance;
  };
}
function EntityManagerImpl$removeFromComponentHolder$lambda($componentId, $entity) {
  return function () {
    return 'Trying to remove component with componentId ' + $componentId + ' from entity with id ' + $entity.id + " that doesn't exist in the EntityManager";
  };
}
function EntityManagerImpl$getComponents$lambda($entity) {
  return function () {
    return 'Trying to get components of entity with id ' + $entity.id + " that doesn't exist in the EntityManager";
  };
}
function EntityManagerImpl$getUncastComponent$lambda($componentId, $entity) {
  return function () {
    return 'Trying to get component with componentId ' + $componentId + ' of entity with id ' + $entity.id + " that doesn't exist in the EntityManager";
  };
}
function EntityManagerImpl$getComponent$lambda($componentId, $entity) {
  return function () {
    return 'Trying to get component with componentId ' + $componentId + ' of entity with id ' + $entity.id + " that doesn't exist in the EntityManager";
  };
}
function EntityManagerImpl$hasComponent$lambda($entity, $componentId) {
  return function () {
    return 'Trying to check if entity ' + $entity.id + ' has a component with componentId ' + $componentId + ", but the entity doesn't exist in the EntityManager";
  };
}
function EntityManagerImpl$registerSystem$lambda($system) {
  return function () {
    return $system.id + ' is already registered';
  };
}
function EntityManagerImpl(entitiesArrayGrowSize) {
  Companion_getInstance_52();
  entitiesArrayGrowSize = entitiesArrayGrowSize === VOID ? Companion_getInstance_52().DEFAULT_ENTITIES_ARRAY_GROW_SIZE : entitiesArrayGrowSize;
  this.o2k_1 = entitiesArrayGrowSize;
  this.p2k_1 = 0;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableSetOf' call
  tmp.q2k_1 = LinkedHashSet_init_$Create$();
  this.r2k_1 = ArrayList_init_$Create$_0(this.o2k_1);
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = Companion_instance_21.m1s_1 + 1 | 0;
  tmp_0.s2k_1 = fillArrayVal(Array(size), null);
  var tmp_1 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_1.t2k_1 = LinkedHashMap_init_$Create$_0();
  var tmp_2 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size_0 = Companion_instance_21.m1s_1 + 1 | 0;
  tmp_2.u2k_1 = fillArrayVal(Array(size_0), null);
  var tmp_3 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_3.v2k_1 = LinkedHashMap_init_$Create$_0();
  var tmp_4 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size_1 = Companion_instance_21.m1s_1 + 1 | 0;
  tmp_4.w2k_1 = fillArrayVal(Array(size_1), null);
  var tmp_5 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_5.x2k_1 = LinkedHashMap_init_$Create$_0();
  var tmp_6 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size_2 = Companion_instance_21.m1s_1 + 1 | 0;
  tmp_6.y2k_1 = fillArrayVal(Array(size_2), null);
  var tmp_7 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_7.z2k_1 = LinkedHashMap_init_$Create$_0();
  var tmp_8 = this;
  // Inline function 'kotlin.emptyArray' call
  tmp_8.a2l_1 = [];
  var tmp_9 = this;
  // Inline function 'kotlin.emptyArray' call
  tmp_9.b2l_1 = [];
  this.c2l_1 = new EntityManagerWatcherList();
  var inductionVariable = 0;
  var last = Companion_instance_21.m1s_1;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$11 = [];
      this.u2k_1[i] = tmp$ret$11;
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$12 = [];
      this.w2k_1[i] = tmp$ret$12;
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$13 = [];
      this.y2k_1[i] = tmp$ret$13;
    }
     while (!(i === last));
}
protoOf(EntityManagerImpl).n2k = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.q2k_1;
  return copyToArray(this_0);
};
protoOf(EntityManagerImpl).getNextId = function () {
  this.p2k_1 = this.p2k_1 + 1 | 0;
  return this.p2k_1;
};
protoOf(EntityManagerImpl).e2l = function () {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var map = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var indexedObject = this.s2k_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var item = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.allListeners.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    if ((item == null ? null : any(item)) === true) {
      // Inline function 'kotlin.collections.set' call
      map.q2(tmp1, item);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this.t2k_1.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.allListeners.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var key = element.b2();
    var value = element.c2();
    map.q2(key, value);
  }
  return map;
};
protoOf(EntityManagerImpl).createEntity = function () {
  return this.createEntityInternal(this.getNextId());
};
protoOf(EntityManagerImpl).createEntityInternal = function (entityId) {
  var tmp = this;
  // Inline function 'kotlin.math.max' call
  var b = this.p2k_1;
  tmp.p2k_1 = Math.max(entityId, b);
  if (entityId >= this.r2k_1.o()) {
    growComponentsTo(this, entityId);
  }
  var entity = this.createEntityObject(entityId);
  if (!this.q2k_1.h(entity)) {
    var tmp_0 = Companion_getInstance_52().logger;
    tmp_0.error(EntityManagerImpl$createEntityInternal$lambda);
    throw IllegalArgumentException_init_$Create$('Entity with id ' + entityId + ' already exists.');
  }
  this.r2k_1.n2(entityId, new ComponentHolder());
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.a2l_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.createEntityInternal.<anonymous>' call
    element(entity);
  }
  return entity;
};
protoOf(EntityManagerImpl).createEntityObject = function (uniqueId) {
  return new Entity(uniqueId, this);
};
protoOf(EntityManagerImpl).disposeEntity = function (entity) {
  entity.v1l_1 = true;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.getComponents(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.disposeEntity.<anonymous>' call
    notifyComponentRemoved(this, entity, element);
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject_0 = this.b2l_1;
  var inductionVariable_0 = 0;
  var last_0 = indexedObject_0.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = indexedObject_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.disposeEntity.<anonymous>' call
    element_0(entity);
  }
  this.removeEntityInternal(entity);
  entity.v1l_1 = false;
};
protoOf(EntityManagerImpl).removeEntityInternal = function (entity) {
  this.q2k_1.j2(entity);
  removeComponentHolder(this, entity.id);
};
protoOf(EntityManagerImpl).findEntity = function (entityId) {
  if (componentHolder(this, entityId) == null)
    return null;
  return this.createEntityObject(entityId);
};
protoOf(EntityManagerImpl).addComponent = function (entity, component) {
  var tmp = EntityManagerImpl$addComponent$lambda(this);
  return addComponentWithNotifyCallback(this, entity, component, tmp, EntityManagerImpl$addComponent$lambda_0(this));
};
protoOf(EntityManagerImpl).addComponentInternal = function (entity, c) {
  return addComponentWithNotifyCallback(this, entity, c, null, null);
};
protoOf(EntityManagerImpl).removeComponent = function (entity, componentId) {
  return removeFromComponentHolder(this, entity, componentId, EntityManagerImpl$removeComponent$lambda(this));
};
protoOf(EntityManagerImpl).removeComponentInternal = function (entity, componentId) {
  return removeFromComponentHolder(this, entity, componentId, null);
};
protoOf(EntityManagerImpl).getComponents = function (entity) {
  var componentHolder_0 = componentHolder(this, entity.id);
  if (componentHolder_0 == null) {
    var tmp = Companion_getInstance_52().logger;
    tmp.error(EntityManagerImpl$getComponents$lambda(entity));
  }
  var tmp1_elvis_lhs = componentHolder_0 == null ? null : componentHolder_0.c2k();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_0 = [];
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
};
protoOf(EntityManagerImpl).getComponent = function (entity, componentId) {
  validateInput(this, entity, componentId);
  var componentHolder_0 = componentHolder(this, entity.id);
  if (componentHolder_0 == null) {
    var tmp = Companion_getInstance_52().logger;
    tmp.error(EntityManagerImpl$getUncastComponent$lambda(componentId, entity));
    return null;
  }
  return fastComponent(componentHolder_0, componentId);
};
protoOf(EntityManagerImpl).f2l = function (entity, componentId) {
  validateInput(this, entity, componentId);
  var componentHolder_0 = componentHolder(this, entity.id);
  if (componentHolder_0 == null) {
    var tmp = Companion_getInstance_52().logger;
    tmp.error(EntityManagerImpl$getComponent$lambda(componentId, entity));
  }
  var tmp_0;
  if (componentHolder_0 == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getComponent.<anonymous>' call
    tmp_0 = fastComponent(componentHolder_0, componentId);
  }
  return tmp_0;
};
protoOf(EntityManagerImpl).__getComponentForKotlin = function (entity, componentId) {
  return this.f2l(entity, componentId);
};
protoOf(EntityManagerImpl).getComponentUnsafe = function (entity, componentId) {
  var tmp0_elvis_lhs = this.f2l(entity, componentId);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw Exception_init_$Create$('Component with id ' + componentId + ' does not exist on ' + toString_0(this));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(EntityManagerImpl).hasComponent = function (entity, componentId) {
  validateInput(this, entity, componentId);
  var componentHolder_0 = componentHolder(this, entity.id);
  if (componentHolder_0 == null) {
    var tmp = Companion_getInstance_52().logger;
    tmp.error(EntityManagerImpl$hasComponent$lambda(entity, componentId));
  }
  var tmp1_elvis_lhs = componentHolder_0 == null ? null : componentHolder_0.g2k(componentId);
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
};
protoOf(EntityManagerImpl).isDisposed = function (entity) {
  return componentHolder(this, entity.id) == null;
};
protoOf(EntityManagerImpl).subscribeAdd = function (componentId, listener) {
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    // Inline function 'kotlin.collections.plus' call
    var this_0 = ensureNotNull(this.u2k_1[componentId]);
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [typeof listener === 'function' ? listener : THROW_CCE()];
    var tmp$ret$4 = this_0.concat(tmp$ret$3);
    this.u2k_1[componentId] = tmp$ret$4;
  } else {
    var list = this.v2k_1.f2(componentId);
    var tmp0_safe_receiver = list;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = [typeof listener === 'function' ? listener : THROW_CCE()];
      tmp = tmp0_safe_receiver.concat(tmp$ret$8);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = [typeof listener === 'function' ? listener : THROW_CCE()];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    list = tmp_0;
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.v2k_1;
    var value = list;
    this_1.q2(componentId, value);
  }
  return listener;
};
protoOf(EntityManagerImpl).unsubscribeAdd = function (componentId, listener) {
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = ensureNotNull(this.u2k_1[componentId]);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeAdd.<anonymous>' call
      if (!equals(element, listener)) {
        destination.h(element);
      }
    }
    var tmp$ret$3 = copyToArray(destination);
    this.u2k_1[componentId] = tmp$ret$3;
  } else {
    var tmp0_safe_receiver = this.v2k_1.f2(componentId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var this_1 = this.v2k_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = tmp0_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp0_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeAdd.<anonymous>.<anonymous>' call
        if (!equals(element_0, listener)) {
          destination_0.h(element_0);
        }
      }
      var value = copyToArray(destination_0);
      this_1.q2(componentId, value);
    }
  }
};
protoOf(EntityManagerImpl).subscribeUpdate = function (componentId, listener) {
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    // Inline function 'kotlin.collections.plus' call
    var this_0 = ensureNotNull(this.w2k_1[componentId]);
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [typeof listener === 'function' ? listener : THROW_CCE()];
    var tmp$ret$4 = this_0.concat(tmp$ret$3);
    this.w2k_1[componentId] = tmp$ret$4;
  } else {
    var list = this.x2k_1.f2(componentId);
    var tmp0_safe_receiver = list;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = [typeof listener === 'function' ? listener : THROW_CCE()];
      tmp = tmp0_safe_receiver.concat(tmp$ret$8);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = [typeof listener === 'function' ? listener : THROW_CCE()];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    list = tmp_0;
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.x2k_1;
    var value = list;
    this_1.q2(componentId, value);
  }
  return listener;
};
protoOf(EntityManagerImpl).unsubscribeUpdate = function (componentId, listener) {
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = ensureNotNull(this.w2k_1[componentId]);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeUpdate.<anonymous>' call
      if (!equals(element, listener)) {
        destination.h(element);
      }
    }
    var tmp$ret$3 = copyToArray(destination);
    this.w2k_1[componentId] = tmp$ret$3;
  } else {
    var tmp0_safe_receiver = this.x2k_1.f2(componentId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var this_1 = this.x2k_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = tmp0_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp0_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeUpdate.<anonymous>.<anonymous>' call
        if (!equals(element_0, listener)) {
          destination_0.h(element_0);
        }
      }
      var value = copyToArray(destination_0);
      this_1.q2(componentId, value);
    }
  }
};
protoOf(EntityManagerImpl).subscribeRemove = function (componentId, listener) {
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    // Inline function 'kotlin.collections.plus' call
    var this_0 = ensureNotNull(this.y2k_1[componentId]);
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [typeof listener === 'function' ? listener : THROW_CCE()];
    var tmp$ret$4 = this_0.concat(tmp$ret$3);
    this.y2k_1[componentId] = tmp$ret$4;
  } else {
    var list = this.z2k_1.f2(componentId);
    var tmp0_safe_receiver = list;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = [typeof listener === 'function' ? listener : THROW_CCE()];
      tmp = tmp0_safe_receiver.concat(tmp$ret$8);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = [typeof listener === 'function' ? listener : THROW_CCE()];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    list = tmp_0;
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.z2k_1;
    var value = list;
    this_1.q2(componentId, value);
  }
  return listener;
};
protoOf(EntityManagerImpl).unsubscribeRemove = function (componentId, listener) {
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = ensureNotNull(this.y2k_1[componentId]);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeRemove.<anonymous>' call
      if (!equals(element, listener)) {
        destination.h(element);
      }
    }
    var tmp$ret$3 = copyToArray(destination);
    this.y2k_1[componentId] = tmp$ret$3;
  } else {
    var tmp0_safe_receiver = this.z2k_1.f2(componentId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var this_1 = this.z2k_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = tmp0_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp0_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeRemove.<anonymous>.<anonymous>' call
        if (!equals(element_0, listener)) {
          destination_0.h(element_0);
        }
      }
      var value = copyToArray(destination_0);
      this_1.q2(componentId, value);
    }
  }
};
protoOf(EntityManagerImpl).subscribeEntityCreated = function (listener) {
  var tmp = this;
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = this.a2l_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [listener];
  tmp.a2l_1 = tmp$ret$0.concat(tmp$ret$3);
};
protoOf(EntityManagerImpl).unsubscribeEntityCreated = function (listener) {
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.a2l_1;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeEntityCreated.<anonymous>' call
    if (!equals(element, listener)) {
      destination.h(element);
    }
  }
  tmp.a2l_1 = copyToArray(destination);
};
protoOf(EntityManagerImpl).subscribeEntityRemoved = function (listener) {
  var tmp = this;
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = this.b2l_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [listener];
  tmp.b2l_1 = tmp$ret$0.concat(tmp$ret$3);
};
protoOf(EntityManagerImpl).unsubscribeEntityRemoved = function (listener) {
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.b2l_1;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unsubscribeEntityRemoved.<anonymous>' call
    if (!equals(element, listener)) {
      destination.h(element);
    }
  }
  tmp.b2l_1 = copyToArray(destination);
};
protoOf(EntityManagerImpl).removeAllComponents = function (entity) {
  var components = this.getComponents(entity);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = components.length;
  while (inductionVariable < last) {
    var element = components[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.removeAllComponents.<anonymous>' call
    notifyComponentRemoved(this, entity, element);
  }
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = components.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = components[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.removeAllComponents.<anonymous>' call
    this.removeComponentInternal(entity, element_0.typeId);
  }
  return components;
};
protoOf(EntityManagerImpl).registerSystem = function (system) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = this.getSystemsRegistered();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.registerSystem.<anonymous>' call
      if (equals(element, system)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    var tmp = Companion_getInstance_52().logger;
    tmp.warn(EntityManagerImpl$registerSystem$lambda(system));
    return Unit_instance;
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject_0 = system.componentListeners;
  var inductionVariable_0 = 0;
  var last_0 = indexedObject_0.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = indexedObject_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.registerSystem.<anonymous>' call
    if (element_0.componentId < this.s2k_1.length) {
      if (this.s2k_1[element_0.componentId] == null) {
        var tmp_0 = element_0.componentId;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = [element_0];
        this.s2k_1[tmp_0] = tmp$ret$4;
      } else {
        var tmp_1 = element_0.componentId;
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = ensureNotNull(this.s2k_1[element_0.componentId]);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [element_0];
        var tmp$ret$9 = tmp$ret$5.concat(tmp$ret$8);
        this.s2k_1[tmp_1] = tmp$ret$9;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var sorted = SystemGraphHelper_getInstance().h2l(ensureNotNull(this.s2k_1[element_0.componentId]));
        this.s2k_1[element_0.componentId] = sorted;
      }
    } else {
      if (!this.t2k_1.d2(element_0.componentId)) {
        // Inline function 'kotlin.collections.set' call
        var this_0 = this.t2k_1;
        var key = element_0.componentId;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var value = [element_0];
        this_0.q2(key, value);
      } else {
        // Inline function 'kotlin.collections.set' call
        var this_1 = this.t2k_1;
        var key_0 = element_0.componentId;
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$14 = ensureNotNull(this.t2k_1.f2(element_0.componentId));
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$17 = [element_0];
        var value_0 = tmp$ret$14.concat(tmp$ret$17);
        this_1.q2(key_0, value_0);
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var sorted_0 = SystemGraphHelper_getInstance().h2l(ensureNotNull(this.t2k_1.f2(element_0.componentId)));
        var this_2 = this.t2k_1;
        var key_1 = element_0.componentId;
        this_2.q2(key_1, sorted_0);
      }
    }
  }
  system.onRegister();
};
protoOf(EntityManagerImpl).unregisterSystem = function (system) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = system.componentListeners;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unregisterSystem.<anonymous>' call
    if (element.componentId < this.s2k_1.length) {
      if (!(this.s2k_1[element.componentId] == null)) {
        var tmp = element.componentId;
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = ensureNotNull(this.s2k_1[element.componentId]);
        var destination = ArrayList_init_$Create$();
        var inductionVariable_0 = 0;
        var last_0 = this_0.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = this_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unregisterSystem.<anonymous>.<anonymous>' call
          if (!equals(element_0, element)) {
            destination.h(element_0);
          }
        }
        var tmp$ret$3 = copyToArray(destination);
        this.s2k_1[tmp] = tmp$ret$3;
      }
    } else {
      if (this.t2k_1.d2(element.componentId)) {
        // Inline function 'kotlin.collections.set' call
        var this_1 = this.t2k_1;
        var key = element.componentId;
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_2 = ensureNotNull(this.t2k_1.f2(element.componentId));
        var destination_0 = ArrayList_init_$Create$();
        var inductionVariable_1 = 0;
        var last_1 = this_2.length;
        while (inductionVariable_1 < last_1) {
          var element_1 = this_2[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.ecs.EntityManagerImpl.unregisterSystem.<anonymous>.<anonymous>' call
          if (!equals(element_1, element)) {
            destination_0.h(element_1);
          }
        }
        var value = copyToArray(destination_0);
        this_1.q2(key, value);
      }
    }
  }
  system.onUnregister();
};
protoOf(EntityManagerImpl).getSystem = function (systemId) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = this.getSystemsRegistered();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystem.<anonymous>' call
      if (element.id === systemId) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
};
protoOf(EntityManagerImpl).getSystemsRegisteredForComponent = function (componentId) {
  var tmp0_elvis_lhs = componentListeners(this, componentId);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var listeners = tmp;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = listeners.length;
  while (inductionVariable < last) {
    var element = listeners[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegisteredForComponent.<anonymous>' call
    var tmp0_safe_receiver = element.ownerSystem;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  var systems = destination;
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(systems);
};
protoOf(EntityManagerImpl).getSystemsRegistered = function () {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var all = LinkedHashSet_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.s2k_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegistered.<anonymous>' call
    if (element == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = element.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = element[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegistered.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver = element_0.ownerSystem;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          all.h(tmp0_safe_receiver);
        }
      }
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this.t2k_1.i2().k();
  while (tmp0_iterator.m()) {
    var element_1 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegistered.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = element_1.c2();
    var inductionVariable_1 = 0;
    var last_1 = indexedObject_0.length;
    while (inductionVariable_1 < last_1) {
      var element_2 = indexedObject_0[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.ecs.EntityManagerImpl.getSystemsRegistered.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_0 = element_2.ownerSystem;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        all.h(tmp0_safe_receiver_0);
      }
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(all);
};
protoOf(EntityManagerImpl).anonymousListenersCountForAddComponent = function (componentId) {
  var tmp;
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    var tmp0_safe_receiver = this.u2k_1[componentId];
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.length;
    tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  } else {
    var tmp2_safe_receiver = this.v2k_1.f2(componentId);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.length;
    tmp = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
  }
  return tmp;
};
protoOf(EntityManagerImpl).anonymousListenersCountForUpdateComponent = function (componentId) {
  var tmp;
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    var tmp0_safe_receiver = this.w2k_1[componentId];
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.length;
    tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  } else {
    var tmp2_safe_receiver = this.x2k_1.f2(componentId);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.length;
    tmp = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
  }
  return tmp;
};
protoOf(EntityManagerImpl).anonymousListenersCountForRemoveComponent = function (componentId) {
  var tmp;
  if (Companion_instance_21.isCoreComponentId(componentId)) {
    var tmp0_safe_receiver = this.y2k_1[componentId];
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.length;
    tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  } else {
    var tmp2_safe_receiver = this.z2k_1.f2(componentId);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.length;
    tmp = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
  }
  return tmp;
};
protoOf(EntityManagerImpl).addWatcher = function (watcher) {
  this.c2l_1.j2l(watcher);
};
protoOf(EntityManagerImpl).removeWatcher = function (watcher) {
  this.c2l_1.k2l(watcher);
};
function EntityManagerWatcher() {
}
function EntityManagerWatcherList() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.i2l_1 = ArrayList_init_$Create$();
}
protoOf(EntityManagerWatcherList).beforeAddComponent = function (entity, component) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeAddComponent.<anonymous>' call
    element.beforeAddComponent(entity, component);
  }
};
protoOf(EntityManagerWatcherList).afterAddComponent = function (entity, component) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterAddComponent.<anonymous>' call
    element.afterAddComponent(entity, component);
  }
};
protoOf(EntityManagerWatcherList).beforeRemoveComponent = function (entity, componentId) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeRemoveComponent.<anonymous>' call
    element.beforeRemoveComponent(entity, componentId);
  }
};
protoOf(EntityManagerWatcherList).afterRemoveComponent = function (entity, componentId) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterRemoveComponent.<anonymous>' call
    element.afterRemoveComponent(entity, componentId);
  }
};
protoOf(EntityManagerWatcherList).beforeNotifyOnAdd = function (componentListener) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeNotifyOnAdd.<anonymous>' call
    element.beforeNotifyOnAdd(componentListener);
  }
};
protoOf(EntityManagerWatcherList).afterNotifyOnAdd = function (componentListener) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterNotifyOnAdd.<anonymous>' call
    element.afterNotifyOnAdd(componentListener);
  }
};
protoOf(EntityManagerWatcherList).beforeNotifyOnUpdate = function (componentListener) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeNotifyOnUpdate.<anonymous>' call
    element.beforeNotifyOnUpdate(componentListener);
  }
};
protoOf(EntityManagerWatcherList).afterNotifyOnUpdate = function (componentListener) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterNotifyOnUpdate.<anonymous>' call
    element.afterNotifyOnUpdate(componentListener);
  }
};
protoOf(EntityManagerWatcherList).beforeNotifyOnRemove = function (componentListener) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.beforeNotifyOnRemove.<anonymous>' call
    element.beforeNotifyOnRemove(componentListener);
  }
};
protoOf(EntityManagerWatcherList).afterNotifyOnRemove = function (componentListener) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.ecs.EntityManagerWatcherList.afterNotifyOnRemove.<anonymous>' call
    element.afterNotifyOnRemove(componentListener);
  }
};
protoOf(EntityManagerWatcherList).j2l = function (element) {
  return this.i2l_1.h(element);
};
protoOf(EntityManagerWatcherList).h = function (element) {
  return this.j2l((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
};
protoOf(EntityManagerWatcherList).l2l = function (index, element) {
  this.i2l_1.o2(index, element);
};
protoOf(EntityManagerWatcherList).o2 = function (index, element) {
  return this.l2l(index, (!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
};
protoOf(EntityManagerWatcherList).m2l = function (index, elements) {
  return this.i2l_1.k2(index, elements);
};
protoOf(EntityManagerWatcherList).k2 = function (index, elements) {
  return this.m2l(index, elements);
};
protoOf(EntityManagerWatcherList).n2l = function (elements) {
  return this.i2l_1.p(elements);
};
protoOf(EntityManagerWatcherList).p = function (elements) {
  return this.n2l(elements);
};
protoOf(EntityManagerWatcherList).asJsArrayView = function () {
  return this.i2l_1.asJsArrayView();
};
protoOf(EntityManagerWatcherList).m2 = function () {
  this.i2l_1.m2();
};
protoOf(EntityManagerWatcherList).y1 = function () {
  return this.i2l_1.y1();
};
protoOf(EntityManagerWatcherList).z1 = function (index) {
  return this.i2l_1.z1(index);
};
protoOf(EntityManagerWatcherList).k2l = function (element) {
  return this.i2l_1.j2(element);
};
protoOf(EntityManagerWatcherList).j2 = function (element) {
  if (!(!(element == null) ? isInterface(element, EntityManagerWatcher) : false))
    return false;
  return this.k2l((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
};
protoOf(EntityManagerWatcherList).o2l = function (elements) {
  return this.i2l_1.i1(elements);
};
protoOf(EntityManagerWatcherList).i1 = function (elements) {
  return this.o2l(elements);
};
protoOf(EntityManagerWatcherList).p2 = function (index) {
  return this.i2l_1.p2(index);
};
protoOf(EntityManagerWatcherList).p2l = function (elements) {
  return this.i2l_1.l2(elements);
};
protoOf(EntityManagerWatcherList).l2 = function (elements) {
  return this.p2l(elements);
};
protoOf(EntityManagerWatcherList).q2l = function (index, element) {
  return this.i2l_1.n2(index, element);
};
protoOf(EntityManagerWatcherList).n2 = function (index, element) {
  return this.q2l(index, (!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
};
protoOf(EntityManagerWatcherList).a2 = function (fromIndex, toIndex) {
  return this.i2l_1.a2(fromIndex, toIndex);
};
protoOf(EntityManagerWatcherList).asJsReadonlyArrayView = function () {
  return this.i2l_1.asJsReadonlyArrayView();
};
protoOf(EntityManagerWatcherList).r2l = function (element) {
  return this.i2l_1.s(element);
};
protoOf(EntityManagerWatcherList).s = function (element) {
  if (!(!(element == null) ? isInterface(element, EntityManagerWatcher) : false))
    return false;
  return this.r2l((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
};
protoOf(EntityManagerWatcherList).s2l = function (elements) {
  return this.i2l_1.w1(elements);
};
protoOf(EntityManagerWatcherList).w1 = function (elements) {
  return this.s2l(elements);
};
protoOf(EntityManagerWatcherList).q = function (index) {
  return this.i2l_1.q(index);
};
protoOf(EntityManagerWatcherList).t2l = function (element) {
  return this.i2l_1.t(element);
};
protoOf(EntityManagerWatcherList).t = function (element) {
  if (!(!(element == null) ? isInterface(element, EntityManagerWatcher) : false))
    return -1;
  return this.t2l((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
};
protoOf(EntityManagerWatcherList).r = function () {
  return this.i2l_1.r();
};
protoOf(EntityManagerWatcherList).k = function () {
  return this.i2l_1.k();
};
protoOf(EntityManagerWatcherList).u2l = function (element) {
  return this.i2l_1.x1(element);
};
protoOf(EntityManagerWatcherList).x1 = function (element) {
  if (!(!(element == null) ? isInterface(element, EntityManagerWatcher) : false))
    return -1;
  return this.u2l((!(element == null) ? isInterface(element, EntityManagerWatcher) : false) ? element : THROW_CCE());
};
protoOf(EntityManagerWatcherList).o = function () {
  return this.i2l_1.o();
};
function Companion_52() {
  Companion_instance_52 = this;
  this.v2l_1 = LoggerState_getInstance().g1v('SystemBase');
}
var Companion_instance_52;
function Companion_getInstance_53() {
  if (Companion_instance_52 == null)
    new Companion_52();
  return Companion_instance_52;
}
function SystemBase$onAddComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.v1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent';
  return l;
}
function SystemBase$onUpdateComponent$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.x1v(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent';
  return l;
}
function SystemBase$onRemoveComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.z1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent';
  return l;
}
function SystemBase$printDependencies$lambda(this$0) {
  return function () {
    return this$0.id;
  };
}
function SystemBase$printDependencies$lambda_0(this$0) {
  return function () {
    return ' listens to: ' + this$0.c1w_1;
  };
}
function SystemBase$printDependencies$lambda_1(this$0) {
  return function () {
    return ' changes:   ' + joinToString_0(this$0.doingChangesOnComponent, ', ');
  };
}
function SystemBase$printDependencies$lambda_2($before) {
  return function () {
    return ' before me: ' + joinToString_0($before, ', ');
  };
}
function SystemBase$printDependencies$lambda_3($before) {
  return function () {
    return ' after me:  ' + joinToString_0($before, ', ');
  };
}
function SystemBase(id, componentId, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe, mandatoryComponents, ignoreEntitiesWithComponents) {
  Companion_getInstance_53();
  var tmp;
  if (doingChangesOnComponent === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = doingChangesOnComponent;
  }
  doingChangesOnComponent = tmp;
  systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
  systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
  mandatoryComponents = mandatoryComponents === VOID ? null : mandatoryComponents;
  ignoreEntitiesWithComponents = ignoreEntitiesWithComponents === VOID ? null : ignoreEntitiesWithComponents;
  EcsSystemImpl.call(this);
  this.b1w_1 = id;
  this.c1w_1 = componentId;
  this.d1w_1 = doingChangesOnComponent;
  this.e1w_1 = systemsBeforeMe;
  this.f1w_1 = systemsAfterMe;
  this.g1w_1 = mandatoryComponents;
  this.h1w_1 = ignoreEntitiesWithComponents;
  var tmp_0 = this;
  // Inline function 'kotlin.emptyArray' call
  tmp_0.i1w_1 = [];
}
protoOf(SystemBase).n1s = function () {
  return this.b1w_1;
};
protoOf(SystemBase).k2d = function () {
  return this.c1w_1;
};
protoOf(SystemBase).j1w = function () {
  return this.d1w_1;
};
protoOf(SystemBase).k1w = function () {
  return this.e1w_1;
};
protoOf(SystemBase).l1w = function () {
  return this.f1w_1;
};
protoOf(SystemBase).m1w = function () {
  return this.g1w_1;
};
protoOf(SystemBase).n1w = function () {
  return this.h1w_1;
};
protoOf(SystemBase).v1v = function (entity, newComponent) {
};
protoOf(SystemBase).x1v = function (entity, oldComponent, newComponent) {
};
protoOf(SystemBase).z1v = function (entity, oldComponent) {
};
protoOf(SystemBase).o1w = function () {
  // Inline function 'kotlin.collections.isEmpty' call
  if (this.i1w_1.length === 0) {
    this.i1w_1 = this.p1w();
  }
  return this.i1w_1;
};
protoOf(SystemBase).p1w = function () {
  // Inline function 'kotlin.arrayOf' call
  var tmp = SystemBase$onAddComponent$ref(this);
  var tmp_0 = SystemBase$onUpdateComponent$ref(this);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new ComponentListenerImpl(this, this.c1w_1, tmp, tmp_0, SystemBase$onRemoveComponent$ref(this))];
};
protoOf(SystemBase).q1w = function () {
  var tmp = Companion_getInstance_53().v2l_1;
  tmp.info(SystemBase$printDependencies$lambda(this));
  var tmp_0 = Companion_getInstance_53().v2l_1;
  tmp_0.info(SystemBase$printDependencies$lambda_0(this));
  var tmp_1 = Companion_getInstance_53().v2l_1;
  tmp_1.info(SystemBase$printDependencies$lambda_1(this));
  var tmp0_safe_receiver = this.systemsBeforeMe;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2 = Companion_getInstance_53().v2l_1;
    tmp_2.info(SystemBase$printDependencies$lambda_2(tmp0_safe_receiver));
  }
  var tmp1_safe_receiver = this.systemsAfterMe;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_3 = Companion_getInstance_53().v2l_1;
    tmp_3.info(SystemBase$printDependencies$lambda_3(tmp1_safe_receiver));
  }
};
function EcsSystemImpl() {
  this.r1w_1 = true;
}
protoOf(EcsSystemImpl).s1w = function () {
  return this.r1w_1;
};
protoOf(EcsSystemImpl).enable = function () {
  this.r1w_1 = true;
};
protoOf(EcsSystemImpl).disable = function () {
  this.r1w_1 = false;
};
protoOf(EcsSystemImpl).l2d = function (entityManager) {
  entityManager.registerSystem(this);
};
protoOf(EcsSystemImpl).m2d = function (entityManager) {
  entityManager.unregisterSystem(this);
};
protoOf(EcsSystemImpl).onRegister = function () {
};
protoOf(EcsSystemImpl).onUnregister = function () {
};
function ComponentListenerImpl(ownerSystem, componentId, onComponentAddedRef, onComponentUpdatedRef, onComponentRemovedRef) {
  this.w2l_1 = ownerSystem;
  this.x2l_1 = componentId;
  this.y2l_1 = onComponentAddedRef;
  this.z2l_1 = onComponentUpdatedRef;
  this.a2m_1 = onComponentRemovedRef;
}
protoOf(ComponentListenerImpl).h2k = function () {
  return this.w2l_1;
};
protoOf(ComponentListenerImpl).k2d = function () {
  return this.x2l_1;
};
protoOf(ComponentListenerImpl).onAdd = function (entity, newComponent) {
  this.y2l_1(entity, unsafeCast(newComponent));
};
protoOf(ComponentListenerImpl).onUpdate = function (entity, oldComponent, newComponent) {
  this.z2l_1(entity, unsafeCast(oldComponent), unsafeCast(newComponent));
};
protoOf(ComponentListenerImpl).onRemove = function (entity, oldComponent) {
  this.a2m_1(entity, unsafeCast(oldComponent));
};
function SystemBase4$onAddComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.v1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent';
  return l;
}
function SystemBase4$onUpdateComponent$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.x1v(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent';
  return l;
}
function SystemBase4$onRemoveComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.z1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent';
  return l;
}
function SystemBase4$onAddComponent2$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.l1z(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent2';
  return l;
}
function SystemBase4$onUpdateComponent2$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.n1z(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent2';
  return l;
}
function SystemBase4$onRemoveComponent2$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.p1z(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent2';
  return l;
}
function SystemBase4$onAddComponent3$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.n2m(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent3';
  return l;
}
function SystemBase4$onUpdateComponent3$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.o2m(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent3';
  return l;
}
function SystemBase4$onRemoveComponent3$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.p2m(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent3';
  return l;
}
function SystemBase4$onAddComponent4$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.d2n(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent4';
  return l;
}
function SystemBase4$onUpdateComponent4$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.e2n(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent4';
  return l;
}
function SystemBase4$onRemoveComponent4$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.f2n(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent4';
  return l;
}
function SystemBase4(id, component1Id, component2Id, component3Id, component4Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe) {
  var tmp;
  if (doingChangesOnComponent === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = doingChangesOnComponent;
  }
  doingChangesOnComponent = tmp;
  systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
  systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
  SystemBase3.call(this, id, component1Id, component2Id, component3Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe);
  this.c2n_1 = component4Id;
}
protoOf(SystemBase4).g2n = function () {
  return this.c2n_1;
};
protoOf(SystemBase4).d2n = function (entity, newComponent) {
};
protoOf(SystemBase4).e2n = function (entity, oldComponent, newComponent) {
};
protoOf(SystemBase4).f2n = function (entity, oldComponent) {
};
protoOf(SystemBase4).p1w = function () {
  // Inline function 'kotlin.arrayOf' call
  var tmp = SystemBase4$onAddComponent$ref(this);
  var tmp_0 = SystemBase4$onUpdateComponent$ref(this);
  var tmp_1 = new ComponentListenerImpl(this, this.z1z_1, tmp, tmp_0, SystemBase4$onRemoveComponent$ref(this));
  var tmp_2 = SystemBase4$onAddComponent2$ref(this);
  var tmp_3 = SystemBase4$onUpdateComponent2$ref(this);
  var tmp_4 = new ComponentListenerImpl(this, this.a20_1, tmp_2, tmp_3, SystemBase4$onRemoveComponent2$ref(this));
  var tmp_5 = SystemBase4$onAddComponent3$ref(this);
  var tmp_6 = SystemBase4$onUpdateComponent3$ref(this);
  var tmp_7 = new ComponentListenerImpl(this, this.m2m_1, tmp_5, tmp_6, SystemBase4$onRemoveComponent3$ref(this));
  var tmp_8 = SystemBase4$onAddComponent4$ref(this);
  var tmp_9 = SystemBase4$onUpdateComponent4$ref(this);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [tmp_1, tmp_4, tmp_7, new ComponentListenerImpl(this, this.c2n_1, tmp_8, tmp_9, SystemBase4$onRemoveComponent4$ref(this))];
};
function SystemBase3$onAddComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.v1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent';
  return l;
}
function SystemBase3$onUpdateComponent$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.x1v(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent';
  return l;
}
function SystemBase3$onRemoveComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.z1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent';
  return l;
}
function SystemBase3$onAddComponent2$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.l1z(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent2';
  return l;
}
function SystemBase3$onUpdateComponent2$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.n1z(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent2';
  return l;
}
function SystemBase3$onRemoveComponent2$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.p1z(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent2';
  return l;
}
function SystemBase3$onAddComponent3$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.n2m(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent3';
  return l;
}
function SystemBase3$onUpdateComponent3$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.o2m(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent3';
  return l;
}
function SystemBase3$onRemoveComponent3$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.p2m(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent3';
  return l;
}
function SystemBase3(id, component1Id, component2Id, component3Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe) {
  var tmp;
  if (doingChangesOnComponent === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = doingChangesOnComponent;
  }
  doingChangesOnComponent = tmp;
  systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
  systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
  SystemBase2.call(this, id, component1Id, component2Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe);
  this.m2m_1 = component3Id;
}
protoOf(SystemBase3).h2n = function () {
  return this.m2m_1;
};
protoOf(SystemBase3).n2m = function (entity, newComponent) {
};
protoOf(SystemBase3).o2m = function (entity, oldComponent, newComponent) {
};
protoOf(SystemBase3).p2m = function (entity, oldComponent) {
};
protoOf(SystemBase3).p1w = function () {
  // Inline function 'kotlin.arrayOf' call
  var tmp = SystemBase3$onAddComponent$ref(this);
  var tmp_0 = SystemBase3$onUpdateComponent$ref(this);
  var tmp_1 = new ComponentListenerImpl(this, this.z1z_1, tmp, tmp_0, SystemBase3$onRemoveComponent$ref(this));
  var tmp_2 = SystemBase3$onAddComponent2$ref(this);
  var tmp_3 = SystemBase3$onUpdateComponent2$ref(this);
  var tmp_4 = new ComponentListenerImpl(this, this.a20_1, tmp_2, tmp_3, SystemBase3$onRemoveComponent2$ref(this));
  var tmp_5 = SystemBase3$onAddComponent3$ref(this);
  var tmp_6 = SystemBase3$onUpdateComponent3$ref(this);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [tmp_1, tmp_4, new ComponentListenerImpl(this, this.m2m_1, tmp_5, tmp_6, SystemBase3$onRemoveComponent3$ref(this))];
};
function SystemBase2$onAddComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.v1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent';
  return l;
}
function SystemBase2$onUpdateComponent$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.x1v(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent';
  return l;
}
function SystemBase2$onRemoveComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.z1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent';
  return l;
}
function SystemBase2$onAddComponent2$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.l1z(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent2';
  return l;
}
function SystemBase2$onUpdateComponent2$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.n1z(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent2';
  return l;
}
function SystemBase2$onRemoveComponent2$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.p1z(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent2';
  return l;
}
function SystemBase2(id, component1Id, component2Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe) {
  var tmp;
  if (doingChangesOnComponent === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = doingChangesOnComponent;
  }
  doingChangesOnComponent = tmp;
  systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
  systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
  SystemBase.call(this, id, component1Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe);
  this.z1z_1 = component1Id;
  this.a20_1 = component2Id;
}
protoOf(SystemBase2).i2n = function () {
  return this.z1z_1;
};
protoOf(SystemBase2).j2n = function () {
  return this.a20_1;
};
protoOf(SystemBase2).l1z = function (entity, newComponent) {
};
protoOf(SystemBase2).n1z = function (entity, oldComponent, newComponent) {
};
protoOf(SystemBase2).p1z = function (entity, oldComponent) {
};
protoOf(SystemBase2).p1w = function () {
  // Inline function 'kotlin.arrayOf' call
  var tmp = SystemBase2$onAddComponent$ref(this);
  var tmp_0 = SystemBase2$onUpdateComponent$ref(this);
  var tmp_1 = new ComponentListenerImpl(this, this.z1z_1, tmp, tmp_0, SystemBase2$onRemoveComponent$ref(this));
  var tmp_2 = SystemBase2$onAddComponent2$ref(this);
  var tmp_3 = SystemBase2$onUpdateComponent2$ref(this);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [tmp_1, new ComponentListenerImpl(this, this.a20_1, tmp_2, tmp_3, SystemBase2$onRemoveComponent2$ref(this))];
};
function SystemBase5$onAddComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.v1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent';
  return l;
}
function SystemBase5$onUpdateComponent$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.x1v(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent';
  return l;
}
function SystemBase5$onRemoveComponent$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.z1v(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent';
  return l;
}
function SystemBase5$onAddComponent2$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.l1z(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent2';
  return l;
}
function SystemBase5$onUpdateComponent2$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.n1z(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent2';
  return l;
}
function SystemBase5$onRemoveComponent2$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.p1z(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent2';
  return l;
}
function SystemBase5$onAddComponent3$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.n2m(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent3';
  return l;
}
function SystemBase5$onUpdateComponent3$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.o2m(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent3';
  return l;
}
function SystemBase5$onRemoveComponent3$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.p2m(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent3';
  return l;
}
function SystemBase5$onAddComponent4$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.d2n(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent4';
  return l;
}
function SystemBase5$onUpdateComponent4$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.e2n(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent4';
  return l;
}
function SystemBase5$onRemoveComponent4$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.f2n(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent4';
  return l;
}
function SystemBase5$onAddComponent5$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.y2n(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onAddComponent5';
  return l;
}
function SystemBase5$onUpdateComponent5$ref($boundThis) {
  var l = function (p0, p1, p2) {
    $boundThis.z2n(p0, p1, p2);
    return Unit_instance;
  };
  l.callableName = 'onUpdateComponent5';
  return l;
}
function SystemBase5$onRemoveComponent5$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.a2o(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'onRemoveComponent5';
  return l;
}
function SystemBase5(id, component1Id, component2Id, component3Id, component4Id, component5Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe) {
  var tmp;
  if (doingChangesOnComponent === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = doingChangesOnComponent;
  }
  doingChangesOnComponent = tmp;
  systemsBeforeMe = systemsBeforeMe === VOID ? null : systemsBeforeMe;
  systemsAfterMe = systemsAfterMe === VOID ? null : systemsAfterMe;
  SystemBase4.call(this, id, component1Id, component2Id, component3Id, component4Id, doingChangesOnComponent, systemsBeforeMe, systemsAfterMe);
  this.x2n_1 = component5Id;
}
protoOf(SystemBase5).b2o = function () {
  return this.x2n_1;
};
protoOf(SystemBase5).y2n = function (entity, newComponent) {
};
protoOf(SystemBase5).z2n = function (entity, oldComponent, newComponent) {
};
protoOf(SystemBase5).a2o = function (entity, oldComponent) {
};
protoOf(SystemBase5).p1w = function () {
  // Inline function 'kotlin.arrayOf' call
  var tmp = SystemBase5$onAddComponent$ref(this);
  var tmp_0 = SystemBase5$onUpdateComponent$ref(this);
  var tmp_1 = new ComponentListenerImpl(this, this.z1z_1, tmp, tmp_0, SystemBase5$onRemoveComponent$ref(this));
  var tmp_2 = SystemBase5$onAddComponent2$ref(this);
  var tmp_3 = SystemBase5$onUpdateComponent2$ref(this);
  var tmp_4 = new ComponentListenerImpl(this, this.a20_1, tmp_2, tmp_3, SystemBase5$onRemoveComponent2$ref(this));
  var tmp_5 = SystemBase5$onAddComponent3$ref(this);
  var tmp_6 = SystemBase5$onUpdateComponent3$ref(this);
  var tmp_7 = new ComponentListenerImpl(this, this.m2m_1, tmp_5, tmp_6, SystemBase5$onRemoveComponent3$ref(this));
  var tmp_8 = SystemBase5$onAddComponent4$ref(this);
  var tmp_9 = SystemBase5$onUpdateComponent4$ref(this);
  var tmp_10 = new ComponentListenerImpl(this, this.c2n_1, tmp_8, tmp_9, SystemBase5$onRemoveComponent4$ref(this));
  var tmp_11 = SystemBase5$onAddComponent5$ref(this);
  var tmp_12 = SystemBase5$onUpdateComponent5$ref(this);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [tmp_1, tmp_4, tmp_7, tmp_10, new ComponentListenerImpl(this, this.x2n_1, tmp_11, tmp_12, SystemBase5$onRemoveComponent5$ref(this))];
};
function convertGraphToArray($this, listeners, edges) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var resultingList = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = listeners.length;
  while (inductionVariable < last) {
    var element = listeners[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.SystemGraphHelper.convertGraphToArray.<anonymous>' call
    // Inline function 'kotlin.collections.find' call
    var this_0 = edges.h2();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.ecs.SystemGraphHelper.convertGraphToArray.<anonymous>.<anonymous>' call
        if (contains(element_0, element)) {
          tmp$ret$2 = element_0;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    if (tmp$ret$2 == null) {
      convertGraphToArray$iterateGraph(resultingList, edges, element);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(resultingList);
}
function extractOrderOfRegistrationEdgesArr($this, listeners, edges) {
  var previous = null;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = listeners.length;
  while (inductionVariable < last) {
    var element = listeners[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractOrderOfRegistrationEdgesArr.<anonymous>' call
    var tmp;
    if (!(previous == null) && edges.f2(element) == null) {
      // Inline function 'kotlin.collections.find' call
      var this_0 = edges.h2();
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = this_0.k();
        while (tmp0_iterator.m()) {
          var element_0 = tmp0_iterator.n();
          // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractOrderOfRegistrationEdgesArr.<anonymous>.<anonymous>' call
          if (contains(element_0, element)) {
            tmp$ret$1 = element_0;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1 == null;
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'kotlin.collections.getOrElse' call
      var key = ensureNotNull(previous);
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_elvis_lhs = edges.f2(key);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractOrderOfRegistrationEdgesArr.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var list = tmp_0;
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = list;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$9 = [element];
      list = tmp$ret$6.concat(tmp$ret$9);
      // Inline function 'kotlin.collections.set' call
      var key_0 = ensureNotNull(previous);
      var value = list;
      edges.q2(key_0, value);
    }
    previous = element;
  }
}
function extractRealEdgesArr($this, listeners) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var edges = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = listeners.length;
  while (inductionVariable < last) {
    var element = listeners[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>' call
    var tmp0_safe_receiver = element.ownerSystem;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.systemsAfterMe;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp1_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp1_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable_1 = 0;
          var last_1 = listeners.length;
          while (inductionVariable_1 < last_1) {
            var element_1 = listeners[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>.<anonymous>' call
            var tmp0_safe_receiver_0 = element_1.ownerSystem;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.id) === element_0) {
              tmp$ret$2 = element_1;
              break $l$block;
            }
          }
          tmp$ret$2 = null;
        }
        var tmp0_safe_receiver_1 = tmp$ret$2;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.collections.getOrElse' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp0_elvis_lhs = edges.f2(element);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.emptyArray' call
            tmp = [];
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var list = tmp;
          // Inline function 'kotlin.collections.plus' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$7 = list;
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$10 = [tmp0_safe_receiver_1];
          list = tmp$ret$7.concat(tmp$ret$10);
          var value = list;
          edges.q2(element, value);
        }
      }
    }
    var tmp2_safe_receiver = element.ownerSystem;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.systemsBeforeMe;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_2 = 0;
      var last_2 = tmp3_safe_receiver.length;
      while (inductionVariable_2 < last_2) {
        var element_2 = tmp3_safe_receiver[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$14;
        $l$block_0: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable_3 = 0;
          var last_3 = listeners.length;
          while (inductionVariable_3 < last_3) {
            var element_3 = listeners[inductionVariable_3];
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>.<anonymous>' call
            var tmp0_safe_receiver_2 = element_3.ownerSystem;
            if ((tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.id) === element_2) {
              tmp$ret$14 = element_3;
              break $l$block_0;
            }
          }
          tmp$ret$14 = null;
        }
        var tmp0_safe_receiver_3 = tmp$ret$14;
        if (tmp0_safe_receiver_3 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.collections.getOrElse' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp0_elvis_lhs_0 = edges.f2(tmp0_safe_receiver_3);
          var tmp_0;
          if (tmp0_elvis_lhs_0 == null) {
            // Inline function 'com.ikea.core.ecs.SystemGraphHelper.extractRealEdgesArr.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.emptyArray' call
            tmp_0 = [];
          } else {
            tmp_0 = tmp0_elvis_lhs_0;
          }
          var list_0 = tmp_0;
          // Inline function 'kotlin.collections.plus' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$19 = list_0;
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$22 = [element];
          list_0 = tmp$ret$19.concat(tmp$ret$22);
          var value_0 = list_0;
          edges.q2(tmp0_safe_receiver_3, value_0);
        }
      }
    }
  }
  return edges;
}
function convertGraphToArray$iterateGraph(resultingList, $edges, listener) {
  if (!resultingList.s(listener)) {
    var tmp0_safe_receiver = $edges.f2(listener);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.ecs.SystemGraphHelper.convertGraphToArray.iterateGraph.<anonymous>' call
        if (!resultingList.s(element)) {
          convertGraphToArray$iterateGraph(resultingList, $edges, element);
        }
      }
    }
    if (!resultingList.s(listener)) {
      resultingList.h(listener);
    }
  }
}
function SystemGraphHelper$sortListeners$lambda() {
  return 'There is a cyclic dependency between your systems!';
}
function SystemGraphHelper() {
  SystemGraphHelper_instance = this;
  this.g2l_1 = LoggerState_getInstance().g1v('SystemGraphHelper');
}
protoOf(SystemGraphHelper).h2l = function (listeners) {
  if (listeners.length === 1)
    return listeners;
  var edges = extractRealEdgesArr(this, listeners);
  if (edges.r())
    return listeners;
  extractOrderOfRegistrationEdgesArr(this, listeners, edges);
  var resultingList = convertGraphToArray(this, listeners, edges);
  var tmp;
  if (resultingList.length === listeners.length) {
    tmp = reversedArray(resultingList);
  } else {
    this.g2l_1.warn(SystemGraphHelper$sortListeners$lambda);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = listeners.length;
    while (inductionVariable < last) {
      var element = listeners[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.ecs.SystemGraphHelper.sortListeners.<anonymous>' call
      if (element instanceof SystemBase) {
        element.q1w();
      }
    }
    throw IllegalStateException_init_$Create$('There is a cyclic dependency between your systems! You can get more information if you enable the logger INFO-level output.');
  }
  return tmp;
};
var SystemGraphHelper_instance;
function SystemGraphHelper_getInstance() {
  if (SystemGraphHelper_instance == null)
    new SystemGraphHelper();
  return SystemGraphHelper_instance;
}
function handleLockedMemberOfGroup($this, entityGroup, potentiallyLockedMember) {
  if (Companion_instance_56.c2o(potentiallyLockedMember, entityGroup)) {
    potentiallyLockedMember.removeComponent(Companion_getInstance_137().id);
  }
}
function AutomaticGroupBuilderSystem$Companion$removeFromEntityGroup$lambda($child) {
  return function () {
    return '' + get_displayName($child) + ' was not a member of an entity group';
  };
}
function hasOnlyOneHostAndItIsStatic($this, entity) {
  return !get_hasMultipleHosts(entity) && !get_isInGroupWithNonStaticHosts(entity);
}
function productEntities($this, connectionRoot) {
  return hierarchyExceptSubTreesWithComponentArray(connectionRoot, Companion_getInstance_25().id);
}
function findEntityGroupAmongConnections($this, connectionsComponent) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = connectionsComponent.connections;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findEntityGroupAmongConnections.<anonymous>' call
      if (!element.hostConnectorEntity.isDisposed && !(get_automaticEntityGroup(element.hostConnectorEntity) == null)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectorEntity;
  return tmp1_safe_receiver == null ? null : get_automaticEntityGroup(tmp1_safe_receiver);
}
function buildEntityGroup($this, newGuest) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var entities = LinkedHashSet_init_$Create$();
  findEntitiesToPutInEntityGroup($this, newGuest, entities);
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = entities.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.buildEntityGroup.<anonymous>' call
      var tmp0_safe_receiver = get_parent(element);
      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_getInstance_55().id)) === true) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_safe_receiver_0 = tmp$ret$2;
  var existingEntityGroup = tmp0_safe_receiver_0 == null ? null : get_parent(tmp0_safe_receiver_0);
  var tmp;
  if (!(existingEntityGroup == null)) {
    tmp = get_parent(existingEntityGroup);
  } else {
    var tmp1_elvis_lhs = findStaticHost($this, entities);
    tmp = tmp1_elvis_lhs == null ? findAParentOutsideTheGroup($this, entities) : tmp1_elvis_lhs;
  }
  var parent = tmp;
  var entityGroup = Companion_instance_56.p2o($this.o2o_1, parent, $this.n2o_1);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = entities.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.buildEntityGroup.<anonymous>' call
    assignEntityToEntityGroup($this, element_0, entityGroup);
  }
  Companion_getInstance_54().recenterGroup(entityGroup);
}
function findAParentOutsideTheGroup($this, entities) {
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$3;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = entities.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findAParentOutsideTheGroup.<anonymous>' call
      var tmp;
      if (get_parent(element) == null) {
        tmp = false;
      } else {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(entities, Collection)) {
            tmp_0 = entities.r();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator_0 = entities.k();
          while (tmp0_iterator_0.m()) {
            var element_0 = tmp0_iterator_0.n();
            // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findAParentOutsideTheGroup.<anonymous>.<anonymous>' call
            if (contains(hierarchyExceptSubTreesWithComponentArray(element_0, Companion_getInstance_25().id), get_parent(element))) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        var hasParentInGroup = tmp$ret$0;
        tmp = !hasParentInGroup;
      }
      if (tmp) {
        tmp$ret$3 = element;
        break $l$block_1;
      }
    }
    tmp$ret$3 = null;
  }
  var entityWithParentOutsideGroup = tmp$ret$3;
  return entityWithParentOutsideGroup == null ? null : get_parent(entityWithParentOutsideGroup);
}
function findStaticHost($this, entities) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = entities.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findStaticHost.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_guestConnections(element);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element_0 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findStaticHost.<anonymous>.<anonymous>' call
      if (get_isStatic(element_0.hostConnectorEntity))
        return element_0.hostConnectorEntity;
    }
  }
  return null;
}
function findEntitiesToPutInEntityGroup($this, entity, entities) {
  if (entity.hasComponent(Companion_instance_21.s1q_1))
    return Unit_instance;
  var tmp0_elvis_lhs = get_connectionRootEntity(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var entityRoot = tmp;
  if (entities.s(entityRoot))
    return Unit_instance;
  entities.h(entityRoot);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = productEntities($this, entityRoot);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findEntitiesToPutInEntityGroup.<anonymous>' call
    var list = asIterable(get_guestConnections(element));
    addAll(destination, list);
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.findEntitiesToPutInEntityGroup.<anonymous>' call
    findEntitiesToPutInEntityGroup($this, element_0.hostConnectorEntity, entities);
  }
}
function assignEntityToEntityGroup($this, entity, entityGroup) {
  var otherEntityGroup = get_automaticEntityGroup(entity);
  if (equals(otherEntityGroup, entityGroup)) {
    return Unit_instance;
  }
  var tmp0_safe_receiver = entityGroup.__getComponentForKotlin(Companion_getInstance_55().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.withNewGroupMember(entity);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [entity];
    tmp = new AutomaticGroupComponent(tmp$ret$2);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var newAutomaticEntityGroupComponent = tmp;
  entityGroup.addComponent(newAutomaticEntityGroupComponent);
  handleLockedMemberOfGroup(Companion_getInstance_54(), entityGroup, entity);
  Companion_getInstance_54().setGroupMemberComponents(entity, entityGroup);
  if (otherEntityGroup == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var children = get_children(otherEntityGroup);
    detachEntityGroup($this, otherEntityGroup);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = children.length;
    while (inductionVariable < last) {
      var element = children[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.assignEntityToEntityGroup.<anonymous>.<anonymous>' call
      assignEntityToEntityGroup($this, element, entityGroup);
    }
  }
}
function detachEntityGroup($this, entityGroup) {
  if (!get_isInScene(entityGroup))
    return Unit_instance;
  setParent_0(entityGroup, null);
}
function Companion_53() {
  Companion_instance_53 = this;
  this.ID = 'AutomaticGroupBuilderSystem';
  this.q2o_1 = LoggerState_getInstance().g1v('AutomaticGroupBuilderSystem');
}
protoOf(Companion_53).j1y = function () {
  return this.ID;
};
protoOf(Companion_53).handleLockedMembersOfGroup = function (entityGroup) {
  var tmp0_safe_receiver = entityGroup.__getComponentForKotlin(Companion_getInstance_55().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.members;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var members = tmp;
  var inductionVariable = 0;
  var last = members.length;
  while (inductionVariable < last) {
    var member = members[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    handleLockedMemberOfGroup(this, entityGroup, member);
  }
};
protoOf(Companion_53).removeFromEntityGroup = function (child) {
  var entityGroup = get_parent(child);
  if (entityGroup == null) {
    this.q2o_1.warn(AutomaticGroupBuilderSystem$Companion$removeFromEntityGroup$lambda(child));
    return Unit_instance;
  }
  var tmp0_safe_receiver = get_highestPriorityConnection(child);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectionRoot;
  var newParent = tmp1_elvis_lhs == null ? get_parent(entityGroup) : tmp1_elvis_lhs;
  setParentMaintainWorldTransform(child, newParent);
  if (get_isConnectionRoot(child)) {
    child.addComponent(new SnapRootComponent());
  }
  if (!child.hasComponent(Companion_getInstance_29().s29_1)) {
    this.recenterGroup(entityGroup);
  }
};
protoOf(Companion_53).recenterGroup = function (entityGroup) {
  if (!any(get_children(entityGroup)))
    return Unit_instance;
  var newGroupCenter = Companion_getInstance_81().ZERO;
  var newRotation = get_worldRotation(first(get_children(entityGroup)));
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_children(entityGroup);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.groups.Companion.recenterGroup.<anonymous>' call
    newGroupCenter = newGroupCenter.plus(get_worldPosition(element));
  }
  var tmp = newGroupCenter;
  // Inline function 'kotlin.collections.count' call
  var tmp$ret$0 = get_children(entityGroup).length;
  newGroupCenter = tmp.__divIntForKotlin(tmp$ret$0);
  if (!get_worldPosition(entityGroup).equals(newGroupCenter)) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_children(entityGroup);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable_0 = 0;
    var last_0 = this_0.length;
    while (inductionVariable_0 < last_0) {
      var item = this_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.groups.Companion.recenterGroup.<anonymous>' call
      destination.h(item);
    }
    var children = destination;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = children.k();
    while (tmp0_iterator.m()) {
      var element_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.groups.Companion.recenterGroup.<anonymous>' call
      setParentMaintainWorldTransform(element_0, null);
    }
    Companion_instance_146.z1l(entityGroup, new Transform(newGroupCenter, newRotation));
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = children.k();
    while (tmp0_iterator_0.m()) {
      var element_1 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.groups.Companion.recenterGroup.<anonymous>' call
      setParentMaintainWorldTransform(element_1, entityGroup);
    }
  }
};
protoOf(Companion_53).setGroupMemberComponents = function (entity, entityGroup) {
  setParentMaintainWorldTransform(entity, entityGroup);
};
var Companion_instance_53;
function Companion_getInstance_54() {
  if (Companion_instance_53 == null)
    new Companion_53();
  return Companion_instance_53;
}
function AutomaticGroupBuilderSystem(entityManager) {
  Companion_getInstance_54();
  var tmp = Companion_getInstance_54().ID;
  var tmp_0 = Companion_getInstance_27().id;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [Companion_instance_21.z1m_1, Companion_instance_21.x1m_1, Companion_instance_21.q1o_1, Companion_instance_21.n1n_1, Companion_instance_21.h1o_1, Companion_instance_21.g1n_1];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [Companion_getInstance_60().j2a_1, Companion_instance_30.x29_1];
  SystemBase.call(this, tmp, tmp_0, tmp_1, tmp$ret$5, null);
  this.n2o_1 = entityManager;
  this.o2o_1 = this.n2o_1.createEntity();
}
protoOf(AutomaticGroupBuilderSystem).l2a = function (entity, newComponent) {
  if (entity.hasComponent(Companion_getInstance_29().s29_1))
    return Unit_instance;
  if (hasOnlyOneHostAndItIsStatic(this, entity))
    return Unit_instance;
  buildEntityGroup(this, entity);
};
protoOf(AutomaticGroupBuilderSystem).v1v = function (entity, newComponent) {
  return this.l2a(entity, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(AutomaticGroupBuilderSystem).m2a = function (entity, oldComponent, newComponent) {
  this.n2a(entity, oldComponent);
  this.l2a(entity, newComponent);
};
protoOf(AutomaticGroupBuilderSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE();
  return this.m2a(entity, tmp, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(AutomaticGroupBuilderSystem).n2a = function (entity, oldComponent) {
  if (entity.hasComponent(Companion_getInstance_29().s29_1))
    return Unit_instance;
  if (!oldComponent.hasMultipleHosts)
    return Unit_instance;
  var tmp0_elvis_lhs = findEntityGroupAmongConnections(this, oldComponent);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var oldEntityGroup = tmp;
  var children = get_children(oldEntityGroup);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = children.length;
  while (inductionVariable < last) {
    var element = children[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.onRemoveComponent.<anonymous>' call
    element.addComponent(new TemporarilyPauseConnectionParentingComponent());
    Companion_getInstance_54().removeFromEntityGroup(element);
    element.removeComponent(Companion_getInstance_29().s29_1);
  }
  detachEntityGroup(this, oldEntityGroup);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = children.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = children[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.onRemoveComponent.<anonymous>' call
    if (get_hasMultipleHosts(element_0)) {
      destination.h(element_0);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_1 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.groups.AutomaticGroupBuilderSystem.onRemoveComponent.<anonymous>' call
    buildEntityGroup(this, element_1);
  }
};
protoOf(AutomaticGroupBuilderSystem).z1v = function (entity, oldComponent) {
  return this.n2a(entity, oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE());
};
function AutomaticGroupComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_54() {
  Companion_instance_54 = this;
  this.id = Companion_instance_21.h1o_1;
  this.serializationKey = 'EntityGroupParentComponent';
  var tmp = this;
  tmp.d2o_1 = Json(VOID, AutomaticGroupComponent$Companion$serializer$lambda);
}
protoOf(Companion_54).n1s = function () {
  return this.id;
};
protoOf(Companion_54).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_54).fromJson = function () {
  return new AutomaticGroupComponent();
};
var Companion_instance_54;
function Companion_getInstance_55() {
  if (Companion_instance_54 == null)
    new Companion_54();
  return Companion_instance_54;
}
function AutomaticGroupComponent(members) {
  Companion_getInstance_55();
  var tmp;
  if (members === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = members;
  }
  members = tmp;
  this.members = members;
}
protoOf(AutomaticGroupComponent).r2o = function () {
  return this.members;
};
protoOf(AutomaticGroupComponent).p1s = function () {
  return Companion_getInstance_55().id;
};
protoOf(AutomaticGroupComponent).toJson = function (parse) {
  return Companion_getInstance_55().d2o_1.x16(serializer(BooleanCompanionObject_instance), true);
};
protoOf(AutomaticGroupComponent).serializationKey = function () {
  return Companion_getInstance_55().serializationKey;
};
protoOf(AutomaticGroupComponent).eq = function (other) {
  var otherEntityGroup = other instanceof AutomaticGroupComponent ? other : THROW_CCE();
  return contentEquals(this.members, otherEntityGroup.members);
};
protoOf(AutomaticGroupComponent).toString = function () {
  return Companion_getInstance_55().serializationKey;
};
protoOf(AutomaticGroupComponent).withNewGroupMember = function (entity) {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = this.members;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [entity];
  var tmp$ret$4 = tmp$ret$0.concat(tmp$ret$3);
  return new AutomaticGroupComponent(tmp$ret$4);
};
protoOf(AutomaticGroupComponent).withoutOldGroupMember = function (entity) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = subtract(this.members, setOf(entity));
  var tmp$ret$0 = copyToArray(this_0);
  return new AutomaticGroupComponent(tmp$ret$0);
};
function get_isAutomaticGroup(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_getInstance_55().id);
}
function get_isInGroupWithNonStaticHosts(_this__u8e3s4) {
  var tmp0_safe_receiver = get_automaticEntityGroup(_this__u8e3s4);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_children(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.<get-isInGroupWithNonStaticHosts>.<anonymous>' call
      var list = toList_1(get_guestConnections(element));
      addAll(destination, list);
    }
    tmp = destination;
  }
  var tmp2_safe_receiver = tmp;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = tmp2_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.groups.<get-isInGroupWithNonStaticHosts>.<anonymous>' call
      if (!get_isStatic(element_0.hostConnectorEntity)) {
        destination_0.h(element_0);
      }
    }
    tmp_0 = destination_0;
  }
  var tmp3_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp3_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_safe_receiver, 10));
    var tmp0_iterator_0 = tmp3_safe_receiver.k();
    while (tmp0_iterator_0.m()) {
      var item = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.groups.<get-isInGroupWithNonStaticHosts>.<anonymous>' call
      var tmp$ret$6 = item.hostConnectorEntity;
      destination_1.h(tmp$ret$6);
    }
    tmp_1 = destination_1;
  }
  var tmp4_safe_receiver = tmp_1;
  var tmp_2;
  if (tmp4_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = tmp4_safe_receiver.k();
    while (tmp0_iterator_1.m()) {
      var element_1 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.groups.<get-isInGroupWithNonStaticHosts>.<anonymous>' call
      if (!equals(get_automaticEntityGroup(element_1), get_automaticEntityGroup(_this__u8e3s4))) {
        destination_2.h(element_1);
      }
    }
    tmp_2 = destination_2;
  }
  var hosts = tmp_2;
  return !(hosts == null) && any_0(hosts);
}
function get_automaticEntityGroup(_this__u8e3s4) {
  if (get_isAutomaticGroup(_this__u8e3s4))
    return _this__u8e3s4;
  var tmp;
  var tmp1_safe_receiver = get_connectionRootEntity(_this__u8e3s4);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_parent(tmp1_safe_receiver);
  if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hasComponent(Companion_getInstance_55().id)) === true) {
    var tmp0_safe_receiver = get_connectionRootEntity(_this__u8e3s4);
    tmp = tmp0_safe_receiver == null ? null : get_parent(tmp0_safe_receiver);
  } else {
    tmp = null;
  }
  return tmp;
}
function get_isMemberOfAutomaticGroup(_this__u8e3s4) {
  var tmp0_safe_receiver = get_parent(_this__u8e3s4);
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_getInstance_55().id)) === true;
}
function setAutomaticGroupParentToHighestPrioConnectionOutsideGroup(_this__u8e3s4) {
  var tmp0_elvis_lhs = get_highestPrioConnectionOutsideGroup(_this__u8e3s4);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var highestPrioConnection = tmp;
  var tmp1_elvis_lhs = get_snapRoot(highestPrioConnection.hostConnectorEntity);
  var newParent = tmp1_elvis_lhs == null ? highestPrioConnection.hostConnectorEntity : tmp1_elvis_lhs;
  var tmp2_safe_receiver = get_automaticEntityGroup(_this__u8e3s4);
  if (tmp2_safe_receiver == null)
    null;
  else {
    setParentMaintainWorldTransform(tmp2_safe_receiver, newParent);
  }
}
function get_highestPrioConnectionOutsideGroup(_this__u8e3s4) {
  var tmp0_safe_receiver = get_automaticEntityGroup(_this__u8e3s4);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_children(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.groups.<get-highestPrioConnectionOutsideGroup>.<anonymous>' call
      var list = toList_1(get_guestConnections(element));
      addAll(destination, list);
    }
    tmp = destination;
  }
  var tmp2_safe_receiver = tmp;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = tmp2_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.core.groups.<get-highestPrioConnectionOutsideGroup>.<anonymous>' call
      if (!equals(get_automaticEntityGroup(element_0.hostConnectorEntity), get_automaticEntityGroup(_this__u8e3s4))) {
        destination_0.h(element_0);
      }
    }
    tmp_0 = destination_0;
  }
  var groupConnections = tmp_0;
  if (groupConnections == null)
    return null;
  if (!any_0(groupConnections))
    return null;
  var tmp$ret$6;
  $l$block: {
    // Inline function 'kotlin.collections.maxBy' call
    var iterator = groupConnections.k();
    if (!iterator.m())
      throw NoSuchElementException_init_$Create$();
    var maxElem = iterator.n();
    if (!iterator.m()) {
      tmp$ret$6 = maxElem;
      break $l$block;
    }
    // Inline function 'com.ikea.core.groups.<get-highestPrioConnectionOutsideGroup>.<anonymous>' call
    var maxValue = maxElem.priority;
    do {
      var e = iterator.n();
      // Inline function 'com.ikea.core.groups.<get-highestPrioConnectionOutsideGroup>.<anonymous>' call
      var v = e.priority;
      if (compareTo(maxValue, v) < 0) {
        maxElem = e;
        maxValue = v;
      }
    }
     while (iterator.m());
    tmp$ret$6 = maxElem;
  }
  return tmp$ret$6;
}
function addAutomaticGroupMember(_this__u8e3s4, newMember) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_55().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.withNewGroupMember(newMember);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var newGroupComponent = tmp;
  _this__u8e3s4.addComponent(newGroupComponent);
}
function removeAutomaticGroupMember(_this__u8e3s4, oldMember) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_55().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.withoutOldGroupMember(oldMember);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var newGroupComponent = tmp;
  _this__u8e3s4.addComponent(newGroupComponent);
}
function Companion_55() {
  Companion_instance_55 = this;
  this.Id = Companion_instance_21.g1r_1;
}
protoOf(Companion_55).s2o = function () {
  return this.Id;
};
var Companion_instance_55;
function Companion_getInstance_56() {
  if (Companion_instance_55 == null)
    new Companion_55();
  return Companion_instance_55;
}
function AutomaticGroupIdCountComponent(nextAutomaticGroupId) {
  Companion_getInstance_56();
  this.nextAutomaticGroupId = nextAutomaticGroupId;
  this.t2o_1 = Companion_getInstance_56().Id;
}
protoOf(AutomaticGroupIdCountComponent).u2o = function () {
  return this.nextAutomaticGroupId;
};
protoOf(AutomaticGroupIdCountComponent).p1s = function () {
  return this.t2o_1;
};
protoOf(AutomaticGroupIdCountComponent).eq = function (other) {
  return (other instanceof AutomaticGroupIdCountComponent ? other : THROW_CCE()).nextAutomaticGroupId === this.nextAutomaticGroupId;
};
protoOf(AutomaticGroupIdCountComponent).withIncrementedId = function () {
  return new AutomaticGroupIdCountComponent(this.nextAutomaticGroupId + 1 | 0);
};
function incrementNextAutomaticGroupId($this, stateHolderEntity, entityManager) {
  var component = stateHolderEntity.__getComponentForKotlin(Companion_getInstance_56().Id);
  var tmp1_elvis_lhs = component == null ? null : component.withIncrementedId();
  var newComponent = tmp1_elvis_lhs == null ? new AutomaticGroupIdCountComponent(1) : tmp1_elvis_lhs;
  entityManager.addComponent(stateHolderEntity, newComponent);
  return newComponent.nextAutomaticGroupId;
}
function Companion_56() {
}
protoOf(Companion_56).v2o = function (entity) {
  return get_isAutomaticGroup(entity);
};
protoOf(Companion_56).w2o = function (potentiallyLockedMember) {
  if (get_isAutomaticGroup(potentiallyLockedMember))
    return true;
  return this.c2o(potentiallyLockedMember, get_automaticEntityGroup(potentiallyLockedMember)) || isHostingEntityWithMultipleHosts(potentiallyLockedMember);
};
protoOf(Companion_56).c2o = function (potentialHost, entityGroup) {
  var tmp1_safe_receiver = entityGroup == null ? get_automaticEntityGroup(potentialHost) : entityGroup;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.sequences.any' call
      var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(potentialHost, Companion_getInstance_25().id).k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.groups.Companion.isHostingMemberInThisAutomaticGroup.<anonymous>.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var indexedObject = get_hostedConnections(element);
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var element_0 = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.groups.Companion.isHostingMemberInThisAutomaticGroup.<anonymous>.<anonymous>.<anonymous>' call
            var tmp0_safe_receiver = get_connectionRootEntity(element_0.guestConnectorEntity);
            if (equals(tmp0_safe_receiver == null ? null : get_parent(tmp0_safe_receiver), tmp1_safe_receiver)) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
          tmp$ret$1 = false;
        }
        if (tmp$ret$1) {
          tmp$ret$3 = true;
          break $l$block_0;
        }
      }
      tmp$ret$3 = false;
    }
    return tmp$ret$3;
  }
  return false;
};
protoOf(Companion_56).isHostingMemberInThisAutomaticGroup$default = function (potentialHost, entityGroup, $super) {
  entityGroup = entityGroup === VOID ? null : entityGroup;
  return $super === VOID ? this.c2o(potentialHost, entityGroup) : $super.c2o.call(this, potentialHost, entityGroup);
};
protoOf(Companion_56).x2o = function (entity) {
  return get_automaticEntityGroup(entity);
};
protoOf(Companion_56).p2o = function (stateHolderEntity, parent, entityManager) {
  var entityGroup = entityManager.createEntity();
  var groupId = incrementNextAutomaticGroupId(this, stateHolderEntity, entityManager);
  entityGroup.addComponent(new DisplayNameComponent('Automatic Entity Group ' + groupId));
  setParent_0(entityGroup, parent);
  entityGroup.addComponent(new DraggableComponent());
  entityGroup.addComponent(new SelectableComponent());
  entityGroup.addComponent(new SnapRootComponent());
  entityGroup.addComponent(new AutomaticGroupComponent());
  return entityGroup;
};
var Companion_instance_56;
function Companion_getInstance_57() {
  return Companion_instance_56;
}
function isAutomaticGroup(entity) {
  return Companion_instance_56.v2o(entity);
}
function isEntityLockedInAutomaticGroup(potentiallyLockedMember) {
  return Companion_instance_56.w2o(potentiallyLockedMember);
}
function isHostingMemberInThisAutomaticGroup(potentialHost, entityGroup) {
  return Companion_instance_56.c2o(potentialHost, entityGroup);
}
function isHostingMemberInThisAutomaticGroup_0(potentialHost, entityGroup, $super) {
  entityGroup = entityGroup === VOID ? null : entityGroup;
  return isHostingMemberInThisAutomaticGroup(potentialHost, entityGroup);
}
function getAutomaticEntityGroupOfEntity(entity) {
  return Companion_instance_56.x2o(entity);
}
function createAutomaticEntityGroup(stateHolderEntity, parent, entityManager) {
  return Companion_instance_56.p2o(stateHolderEntity, parent, entityManager);
}
function EntityGroupUtils() {
}
function get_isGroup(_this__u8e3s4) {
  return get_isAutomaticGroup(_this__u8e3s4);
}
function Companion_57() {
  Companion_instance_57 = this;
  this.id = Companion_instance_21.s1q_1;
}
protoOf(Companion_57).n1s = function () {
  return this.id;
};
var Companion_instance_57;
function Companion_getInstance_58() {
  if (Companion_instance_57 == null)
    new Companion_57();
  return Companion_instance_57;
}
function StaticComponent() {
  Companion_getInstance_58();
  this.y2o_1 = Companion_getInstance_58().id;
}
protoOf(StaticComponent).p1s = function () {
  return this.y2o_1;
};
protoOf(StaticComponent).eq = function (other) {
  return true;
};
function get_isStatic(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_instance_21.s1q_1);
}
function Companion_58() {
  Companion_instance_58 = this;
  this.z2o_1 = Companion_instance_21.n1n_1;
}
protoOf(Companion_58).n1s = function () {
  return this.z2o_1;
};
var Companion_instance_58;
function Companion_getInstance_59() {
  if (Companion_instance_58 == null)
    new Companion_58();
  return Companion_instance_58;
}
function get_id() {
  return Companion_getInstance_59().z2o_1;
}
function ChildComponent(parent) {
  Companion_getInstance_59();
  this.parent = parent;
}
protoOf(ChildComponent).a2p = function () {
  return this.parent;
};
protoOf(ChildComponent).eq = function (other) {
  return unsafeCast(other).parent.equals(this.parent);
};
protoOf(ChildComponent).equals = function (other) {
  var tmp;
  if (other instanceof ChildComponent) {
    tmp = other.parent.equals(this.parent);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ChildComponent).hashCode = function () {
  return this.parent.hashCode();
};
protoOf(ChildComponent).p1s = function () {
  return Companion_getInstance_59().z2o_1;
};
protoOf(ChildComponent).tf = function () {
  return this.parent;
};
protoOf(ChildComponent).b2p = function (parent) {
  return new ChildComponent(parent);
};
protoOf(ChildComponent).copy = function (parent, $super) {
  parent = parent === VOID ? this.parent : parent;
  return this.b2p(parent);
};
protoOf(ChildComponent).toString = function () {
  return 'ChildComponent(parent=' + this.parent.toString() + ')';
};
function get_parent(_this__u8e3s4) {
  var tmp0_safe_receiver = get_childComponent(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parent;
}
function get_childComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_59().z2o_1);
}
function updateParent($this, entity, guestConnectionsComponent) {
  var tmp;
  if (get_isInGroupWithNonStaticHosts(entity)) {
    tmp = true;
  } else {
    var tmp_0;
    if (!equals(get_snapRoot(entity), entity)) {
      var tmp0_safe_receiver = get_parent(entity);
      tmp_0 = (tmp0_safe_receiver == null ? null : get_isAutomaticGroup(tmp0_safe_receiver)) === true;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  if (tmp)
    return Unit_instance;
  var mainConnection = guestConnectionsComponent.highestPriorityConnection;
  if (mainConnection == null) {
    var tmp_1 = Companion_getInstance_60().k2a_1;
    tmp_1.error(ConnectionParentingSystem$updateParent$lambda);
    return Unit_instance;
  }
  setParentMaintainWorldTransform(entity, mainConnection.hostConnectorEntity);
}
function unParent($this, guestRoot) {
  if (get_isMemberOfAutomaticGroup(guestRoot) && isHostingEntityWithMultipleHosts(guestRoot)) {
    return Unit_instance;
  }
  setParentMaintainWorldTransform(guestRoot, null);
}
function Companion_59() {
  Companion_instance_59 = this;
  this.j2a_1 = 'ConnectionParentingSystem';
  this.k2a_1 = LoggerState_getInstance().g1v('ConnectionSystem');
}
var Companion_instance_59;
function Companion_getInstance_60() {
  if (Companion_instance_59 == null)
    new Companion_59();
  return Companion_instance_59;
}
function ConnectionParentingSystem$updateParent$lambda() {
  return 'Added a connections component without connections, something is broken';
}
function ConnectionParentingSystem() {
  Companion_getInstance_60();
  SystemBase.call(this, Companion_getInstance_60().j2a_1, Companion_getInstance_27().id);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.l2p_1 = [Companion_instance_21.m1n_1, Companion_instance_21.n1n_1, Companion_instance_21.g1n_1];
  var tmp_0 = this;
  // Inline function 'kotlin.emptyArray' call
  tmp_0.m2p_1 = [];
}
protoOf(ConnectionParentingSystem).j1w = function () {
  return this.l2p_1;
};
protoOf(ConnectionParentingSystem).l1w = function () {
  return this.m2p_1;
};
protoOf(ConnectionParentingSystem).l2a = function (entity, newComponent) {
  if (entity.hasComponent(Companion_getInstance_29().s29_1))
    return Unit_instance;
  updateParent(this, entity, newComponent);
};
protoOf(ConnectionParentingSystem).v1v = function (entity, newComponent) {
  return this.l2a(entity, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(ConnectionParentingSystem).m2a = function (entity, oldComponent, newComponent) {
  if (entity.hasComponent(Companion_getInstance_29().s29_1))
    return Unit_instance;
  updateParent(this, entity, newComponent);
};
protoOf(ConnectionParentingSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE();
  return this.m2a(entity, tmp, newComponent instanceof GuestConnectionsComponent ? newComponent : THROW_CCE());
};
protoOf(ConnectionParentingSystem).n2a = function (entity, oldComponent) {
  if (entity.hasComponent(Companion_getInstance_29().s29_1))
    return Unit_instance;
  unParent(this, entity);
};
protoOf(ConnectionParentingSystem).z1v = function (entity, oldComponent) {
  return this.n2a(entity, oldComponent instanceof GuestConnectionsComponent ? oldComponent : THROW_CCE());
};
function Companion_60() {
  this.n2p_1 = 'DisposeTemporaryParentSystem';
}
var Companion_instance_60;
function Companion_getInstance_61() {
  return Companion_instance_60;
}
function DisposeTemporaryParentSystem() {
  SystemBase.call(this, 'DisposeTemporaryParentSystem', Companion_getInstance_131().id);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.x2p_1 = [Companion_getInstance_67().u29_1];
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.y2p_1 = [Companion_instance_61.ID];
}
protoOf(DisposeTemporaryParentSystem).m1w = function () {
  return this.x2p_1;
};
protoOf(DisposeTemporaryParentSystem).k1w = function () {
  return this.y2p_1;
};
protoOf(DisposeTemporaryParentSystem).z2p = function (entity, oldComponent) {
  if (entity.isDisposed)
    return Unit_instance;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.DisposeTemporaryParentSystem.onRemoveComponent.<anonymous>' call
      if (!element.hasComponent(Companion_getInstance_67().u29_1)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1)
    return Unit_instance;
  entity.dispose();
};
protoOf(DisposeTemporaryParentSystem).z1v = function (entity, oldComponent) {
  return this.z2p(entity, oldComponent instanceof MovedToValidSnapPositionComponent ? oldComponent : THROW_CCE());
};
function EntityWithComponent(entity, component) {
  this.entity = entity;
  this.component = component;
}
protoOf(EntityWithComponent).v2i = function () {
  return this.entity;
};
protoOf(EntityWithComponent).a2q = function () {
  return this.component;
};
protoOf(EntityWithComponent).tf = function () {
  return this.entity;
};
protoOf(EntityWithComponent).uf = function () {
  return this.component;
};
protoOf(EntityWithComponent).b2q = function (entity, component) {
  return new EntityWithComponent(entity, component);
};
protoOf(EntityWithComponent).copy = function (entity, component, $super) {
  entity = entity === VOID ? this.entity : entity;
  component = component === VOID ? this.component : component;
  return this.b2q(entity, component);
};
protoOf(EntityWithComponent).toString = function () {
  return 'EntityWithComponent(entity=' + this.entity.toString() + ', component=' + toString_0(this.component) + ')';
};
protoOf(EntityWithComponent).hashCode = function () {
  var result = this.entity.hashCode();
  result = imul(result, 31) + hashCode(this.component) | 0;
  return result;
};
protoOf(EntityWithComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EntityWithComponent))
    return false;
  var tmp0_other_with_cast = other instanceof EntityWithComponent ? other : THROW_CCE();
  if (!this.entity.equals(tmp0_other_with_cast.entity))
    return false;
  if (!equals(this.component, tmp0_other_with_cast.component))
    return false;
  return true;
};
function entityRemoved($this, entity) {
  if (entity.hasComponent(Companion_getInstance_65().id)) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.HierarchySystem.entityRemoved.<anonymous>' call
      if (!element.isDisposed) {
        element.removeComponent(Companion_getInstance_27().id);
        $this.l2q_1.disposeEntity(element);
      }
    }
  }
}
function onUpdateChild($this, child, oldComponent, newComponent) {
  var newParent = newComponent.parent;
  var tmp0_elvis_lhs = get_parentComponent(newParent);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    tmp = new ParentComponent(tmp$ret$0);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parentComponent = tmp;
  var siblings = parentComponent.children;
  if (contains(siblings, child))
    return Unit_instance;
  var oldParent = oldComponent == null ? null : oldComponent.parent;
  var tmp3_safe_receiver = oldParent == null ? null : get_parentComponent(oldParent);
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (contains(tmp3_safe_receiver.children, child)) {
      var oldParentComponentWithoutMe = tmp3_safe_receiver.removeChild(child);
      if (oldParentComponentWithoutMe == null)
        oldParent.removeComponent(Companion_getInstance_65().id);
      else
        oldParent.addComponent(oldParentComponentWithoutMe);
    }
  }
  if (newParent.id === child.id)
    throw IllegalStateException_init_$Create$('HierarchySystem do not allow an entity to be its own child: ' + newParent.toString());
  var newParentComponentWithMe = parentComponent.addChild(child);
  newParent.addComponent(newParentComponentWithMe);
}
function Companion_61() {
  this.ID = 'HierarchySystem';
}
protoOf(Companion_61).j1y = function () {
  return this.ID;
};
var Companion_instance_61;
function Companion_getInstance_62() {
  return Companion_instance_61;
}
function HierarchySystem$entityRemoved$ref($boundThis) {
  var l = function (p0) {
    entityRemoved($boundThis, p0);
    return Unit_instance;
  };
  l.callableName = 'entityRemoved';
  return l;
}
function HierarchySystem(entityManager) {
  var tmp = Companion_instance_21.n1n_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [Companion_instance_21.c1n_1, Companion_instance_21.m1n_1];
  SystemBase.call(this, 'HierarchySystem', tmp, tmp$ret$2, null, null);
  this.l2q_1 = entityManager;
  this.l2q_1.subscribeEntityRemoved(HierarchySystem$entityRemoved$ref(this));
}
protoOf(HierarchySystem).m2q = function (entity, newComponent) {
  if (!entity.hasComponent(Companion_getInstance_145().id)) {
    entity.addComponent(Companion_getInstance_145().IDENTITY);
  }
  onUpdateChild(this, entity, newComponent, newComponent);
};
protoOf(HierarchySystem).v1v = function (entity, newComponent) {
  return this.m2q(entity, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
protoOf(HierarchySystem).o2q = function (entity, oldComponent, newComponent) {
  onUpdateChild(this, entity, oldComponent, newComponent);
};
protoOf(HierarchySystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE();
  return this.o2q(entity, tmp, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
protoOf(HierarchySystem).p2q = function (entity, oldComponent) {
  var parent = oldComponent.parent;
  if (!parent.isDisposed) {
    var tmp0_safe_receiver = get_parentComponent(parent);
    var childrenAfter = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.removeChild(entity);
    if (childrenAfter == null)
      parent.removeComponent(Companion_getInstance_65().id);
    else
      parent.addComponent(childrenAfter);
  }
};
protoOf(HierarchySystem).z1v = function (entity, oldComponent) {
  return this.p2q(entity, oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE());
};
function generateAssemblyHierarchy($this, me) {
  var res = ArrayList_init_$Create$_0(20);
  generateAssemblyHierarchy$add(res, me);
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(res);
}
function generateAssemblyHierarchy$add(res, e) {
  res.h(e);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(e);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.Companion.generateAssemblyHierarchy.add.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_5().id)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    generateAssemblyHierarchy$add(res, element_0);
  }
}
function hierarchyExceptSubTreesWithComponent$add($componentId, $entity, l, e) {
  if (!e.hasComponent($componentId) || e.equals($entity)) {
    l.h(e);
    var tmp0_safe_receiver = get_parentComponent(e);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        hierarchyExceptSubTreesWithComponent$add($componentId, $entity, l, element);
      }
    }
  }
}
function forEachInHierarchy$iterate($func, e) {
  $func(e);
  var tmp0_safe_receiver = e.__getComponentForKotlin(Companion_getInstance_65().id);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      forEachInHierarchy$iterate($func, element);
    }
  }
}
function forEachInHierarchyExceptHierarchyOfIgnored$iterate($ignored, $func, e) {
  if (!e.equals($ignored)) {
    $func(e);
    var tmp0_safe_receiver = e.__getComponentForKotlin(Companion_getInstance_65().id);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        forEachInHierarchyExceptHierarchyOfIgnored$iterate($ignored, $func, element);
      }
    }
  }
}
function forEachInHierarchyExceptSubHierarchiesWithComponent$iterate($componentId, $func, e) {
  if (!e.hasComponent($componentId)) {
    $func(e);
    var tmp0_safe_receiver = e.__getComponentForKotlin(Companion_getInstance_65().id);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        forEachInHierarchyExceptSubHierarchiesWithComponent$iterate($componentId, $func, element);
      }
    }
  }
}
function findInHierarchy$iterate(res, $finder, e) {
  if (res._v == null) {
    if ($finder(e)) {
      res._v = e;
    } else {
      var tmp0_safe_receiver = e.__getComponentForKotlin(Companion_getInstance_65().id);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          findInHierarchy$iterate(res, $finder, element);
        }
      }
    }
  }
}
function findInHierarchyExceptHierarchyOfIgnored$iterate(res, $ignored, $finder, e) {
  if (res._v == null && !e.equals($ignored)) {
    if ($finder(e)) {
      res._v = e;
    } else {
      var tmp0_safe_receiver = e.__getComponentForKotlin(Companion_getInstance_65().id);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          findInHierarchyExceptHierarchyOfIgnored$iterate(res, $ignored, $finder, element);
        }
      }
    }
  }
}
function filterInHierarchy$iterate($finder, res, e) {
  if ($finder(e)) {
    var tmp;
    if (res._v == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [e];
    } else {
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = ensureNotNull(res._v);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = [e];
      tmp = tmp$ret$3.concat(tmp$ret$6);
    }
    res._v = tmp;
  }
  var tmp0_safe_receiver = e.__getComponentForKotlin(Companion_getInstance_65().id);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      filterInHierarchy$iterate($finder, res, element);
    }
  }
}
function findInUpwardsHierarchy$iterate(res, $finder, e) {
  if (res._v == null) {
    if ($finder(e)) {
      res._v = e;
    } else {
      var tmp0_safe_receiver = e.__getComponentForKotlin(Companion_getInstance_59().z2o_1);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parent;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        findInUpwardsHierarchy$iterate(res, $finder, tmp1_safe_receiver);
      }
    }
  }
}
function HierarchyUtils$Companion$forEachDescendantWithComponent$lambda($entity, $componentId, $func) {
  return function (it) {
    var tmp;
    if (it === $entity) {
      return Unit_instance;
    }
    var matchingComponent = it.__getComponentForKotlin($componentId);
    var tmp_0;
    if (!(matchingComponent == null)) {
      tmp_0 = $func(it, matchingComponent);
    }
    return Unit_instance;
  };
}
function HierarchyUtils$Companion$forEachInHierarchyWithComponent$lambda($componentId, $func) {
  return function (it) {
    var matchingComponent = it.__getComponentForKotlin($componentId);
    var tmp;
    if (!(matchingComponent == null)) {
      tmp = $func(it, matchingComponent);
    }
    return Unit_instance;
  };
}
function HierarchyUtils$Companion$getHierarchyWithComponent$lambda($componentId) {
  return function (it) {
    return it.hasComponent($componentId);
  };
}
function Companion_62() {
}
protoOf(Companion_62).q2q = function (original, services) {
  var serialized = toJsonString(original);
  var deserialized = (new JsonSerializer(VOID, services.deserializationInterceptorRegistry)).deserializeToEntityHierarchies(serialized, services);
  return first(deserialized);
};
protoOf(Companion_62).r2q = function (entity) {
  return get_parentComponent(entity);
};
protoOf(Companion_62).s2q = function (entity) {
  return get_childComponent(entity);
};
protoOf(Companion_62).t2q = function (entity) {
  return get_parent(entity);
};
protoOf(Companion_62).h29 = function (entity) {
  var current = entity;
  while (!(get_parent(current) == null)) {
    current = ensureNotNull(get_parent(current));
  }
  return current;
};
protoOf(Companion_62).h1l = function (entity, parent) {
  setParent_0(entity, parent);
};
protoOf(Companion_62).u2q = function (entity, parent) {
  setParentMaintainWorldTransform(entity, parent);
};
protoOf(Companion_62).v2q = function (entity) {
  return get_isAssembly(entity);
};
protoOf(Companion_62).w2q = function (assemblyRoot) {
  return generateAssemblyHierarchy(this, assemblyRoot);
};
protoOf(Companion_62).x2q = function (assemblyRoot) {
  var assemblyEntities = Companion_instance_62.w2q(assemblyRoot);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = assemblyEntities.length;
  while (inductionVariable < last) {
    var element = assemblyEntities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.Companion.getAssemblyChildren.<anonymous>' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(element);
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.Companion.getAssemblyChildren.<anonymous>.<anonymous>' call
      if (!contains(assemblyEntities, element_0)) {
        destination_0.h(element_0);
      }
    }
    var list = destination_0;
    addAll(destination, list);
  }
  var children = destination;
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(children);
};
protoOf(Companion_62).y2q = function (entity) {
  var parentComponent = entity.__getComponentForKotlin(Companion_getInstance_65().id);
  var tmp1_elvis_lhs = parentComponent == null ? null : parentComponent.allDescendants();
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
};
protoOf(Companion_62).z2q = function (entity) {
  var parentComponent = entity.__getComponentForKotlin(Companion_getInstance_65().id);
  var tmp1_elvis_lhs = parentComponent == null ? null : parentComponent.children;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
};
protoOf(Companion_62).a2r = function (entity) {
  var parentComponent = entity.__getComponentForKotlin(Companion_getInstance_65().id);
  var tmp1_elvis_lhs = parentComponent == null ? null : parentComponent.hierarchy(entity);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [entity];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
};
protoOf(Companion_62).b2r = function (entity, componentId) {
  var l = ArrayList_init_$Create$_0(20);
  hierarchyExceptSubTreesWithComponent$add(componentId, entity, l, entity);
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(l);
};
protoOf(Companion_62).c2r = function (entity, componentId, func) {
  this.d2r(entity, HierarchyUtils$Companion$forEachDescendantWithComponent$lambda(entity, componentId, func));
};
protoOf(Companion_62).d2r = function (entity, func) {
  forEachInHierarchy$iterate(func, entity);
};
protoOf(Companion_62).e2r = function (entity, ignored, func) {
  forEachInHierarchyExceptHierarchyOfIgnored$iterate(ignored, func, entity);
};
protoOf(Companion_62).f2r = function (entity, componentId, func) {
  func(entity);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_children(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.Companion.forEachInHierarchyExceptSubHierarchiesWithComponent.<anonymous>' call
    forEachInHierarchyExceptSubHierarchiesWithComponent$iterate(componentId, func, element);
  }
};
protoOf(Companion_62).g2r = function (entity, componentId, func) {
  this.d2r(entity, HierarchyUtils$Companion$forEachInHierarchyWithComponent$lambda(componentId, func));
};
protoOf(Companion_62).h2r = function (entity, finder) {
  var res = {_v: null};
  findInHierarchy$iterate(res, finder, entity);
  return res._v;
};
protoOf(Companion_62).i2r = function (entity, ignored, finder) {
  var res = {_v: null};
  findInHierarchyExceptHierarchyOfIgnored$iterate(res, ignored, finder, entity);
  return res._v;
};
protoOf(Companion_62).j2r = function (entity, finder) {
  var res = {_v: null};
  filterInHierarchy$iterate(finder, res, entity);
  var tmp0_elvis_lhs = res._v;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(Companion_62).k2r = function (entity, other) {
  return this.l2r(entity, other);
};
protoOf(Companion_62).l2r = function (entity, ancestor) {
  var currentEntity = get_parent(entity);
  while (!(currentEntity == null)) {
    if (equals(currentEntity, ancestor))
      return true;
    currentEntity = get_parent(currentEntity);
  }
  return false;
};
protoOf(Companion_62).a29 = function (entity, componentId) {
  var currentEntity = entity;
  while (!(currentEntity == null) && !currentEntity.isDisposed) {
    if (currentEntity.hasComponent(componentId))
      return currentEntity;
    var tmp0_safe_receiver = get_childComponent(currentEntity);
    currentEntity = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parent;
  }
  return null;
};
protoOf(Companion_62).m2r = function (entity, componentId) {
  var tmp0_safe_receiver = this.a29(entity, componentId);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.hierarchies.Companion.getEntityAndComponentForFirstEntityWithComponentInUpwardsHierarchy.<anonymous>' call
    tmp = new EntityWithComponent(tmp0_safe_receiver, tmp0_safe_receiver.getComponentUnsafe(componentId));
  }
  return tmp;
};
protoOf(Companion_62).n2r = function (entity, componentId) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_descendants(entity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.Companion.getDescendantsWithComponent.<anonymous>' call
    if (element.hasComponent(componentId)) {
      destination.h(element);
    }
  }
  return copyToArray(destination);
};
protoOf(Companion_62).o2r = function (entity, componentId) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.n2r(entity, componentId);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.Companion.getEntitiesAndComponentsForDescendantsWithComponent.<anonymous>' call
    var tmp$ret$0 = new EntityWithComponent(item, item.getComponentUnsafe(componentId));
    destination.h(tmp$ret$0);
  }
  return copyToArray(destination);
};
protoOf(Companion_62).p2r = function (entity, componentId) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = get_descendants(entity);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.Companion.getDescendantWithComponent.<anonymous>' call
      if (element.hasComponent(componentId)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
};
protoOf(Companion_62).q2r = function (entity, componentId) {
  var tmp0_safe_receiver = this.p2r(entity, componentId);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.hierarchies.Companion.getEntityAndComponentForDescendantWithComponent.<anonymous>' call
    tmp = new EntityWithComponent(tmp0_safe_receiver, tmp0_safe_receiver.getComponentUnsafe(componentId));
  }
  return tmp;
};
protoOf(Companion_62).r2r = function (entity, componentId) {
  return filterInHierarchy_0(entity, HierarchyUtils$Companion$getHierarchyWithComponent$lambda(componentId));
};
protoOf(Companion_62).s2r = function (entity, componentId) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.r2r(entity, componentId);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.Companion.getEntitiesAndComponentsForHierarchyWithComponent.<anonymous>' call
    var tmp$ret$0 = new EntityWithComponent(item, item.getComponentUnsafe(componentId));
    destination.h(tmp$ret$0);
  }
  return copyToArray(destination);
};
protoOf(Companion_62).t2r = function (entity, componentId) {
  var tmp;
  if (entity.hasComponent(componentId)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = get_parent(entity);
    tmp = (tmp0_safe_receiver == null ? null : hasComponentInUpwardsHierarchy_0(tmp0_safe_receiver, componentId)) === true;
  }
  return tmp;
};
protoOf(Companion_62).u2r = function (entity) {
  var parent = entity;
  // Inline function 'kotlin.collections.mutableListOf' call
  var entities = ArrayList_init_$Create$();
  while (!(parent == null)) {
    entities.h(parent);
    parent = get_parent(parent);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(entities);
};
protoOf(Companion_62).v2r = function (entity) {
  var parent = get_parent(entity);
  // Inline function 'kotlin.collections.mutableListOf' call
  var entities = ArrayList_init_$Create$();
  while (!(parent == null)) {
    entities.h(parent);
    parent = get_parent(parent);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(entities);
};
protoOf(Companion_62).w2r = function (entity, finder) {
  var res = {_v: null};
  findInUpwardsHierarchy$iterate(res, finder, entity);
  return res._v;
};
var Companion_instance_62;
function Companion_getInstance_63() {
  return Companion_instance_62;
}
function duplicateEntity(original, services) {
  return Companion_instance_62.q2q(original, services);
}
function parentComponent(entity) {
  return Companion_instance_62.r2q(entity);
}
function childComponent(entity) {
  return Companion_instance_62.s2q(entity);
}
function parent(entity) {
  return Companion_instance_62.t2q(entity);
}
function rootOf(entity) {
  return Companion_instance_62.h29(entity);
}
function setParent(entity, parent) {
  return Companion_instance_62.h1l(entity, parent);
}
function setParentMaintainTransform(entity, parent) {
  return Companion_instance_62.u2q(entity, parent);
}
function isAssembly(entity) {
  return Companion_instance_62.v2q(entity);
}
function getAssemblyEntities(assemblyRoot) {
  return Companion_instance_62.w2q(assemblyRoot);
}
function getAssemblyChildren(assemblyRoot) {
  return Companion_instance_62.x2q(assemblyRoot);
}
function descendants(entity) {
  return Companion_instance_62.y2q(entity);
}
function children(entity) {
  return Companion_instance_62.z2q(entity);
}
function hierarchy(entity) {
  return Companion_instance_62.a2r(entity);
}
function hierarchyExceptSubTreesWithComponent(entity, componentId) {
  return Companion_instance_62.b2r(entity, componentId);
}
function forEachDescendantWithComponent(entity, componentId, func) {
  return Companion_instance_62.c2r(entity, componentId, func);
}
function forEachInHierarchy(entity, func) {
  return Companion_instance_62.d2r(entity, func);
}
function forEachInHierarchyExceptHierarchyOfIgnored(entity, ignored, func) {
  return Companion_instance_62.e2r(entity, ignored, func);
}
function forEachInHierarchyExceptSubHierarchiesWithComponent(entity, componentId, func) {
  return Companion_instance_62.f2r(entity, componentId, func);
}
function forEachInHierarchyWithComponent(entity, componentId, func) {
  return Companion_instance_62.g2r(entity, componentId, func);
}
function findInHierarchy(entity, finder) {
  return Companion_instance_62.h2r(entity, finder);
}
function findInHierarchyExceptHierarchyOfIgnored(entity, ignored, finder) {
  return Companion_instance_62.i2r(entity, ignored, finder);
}
function filterInHierarchy(entity, finder) {
  return Companion_instance_62.j2r(entity, finder);
}
function isDescendantOf(entity, other) {
  return Companion_instance_62.k2r(entity, other);
}
function hasAncestor(entity, ancestor) {
  return Companion_instance_62.l2r(entity, ancestor);
}
function findWithComponentInUpwardsHierarchy(entity, componentId) {
  return Companion_instance_62.a29(entity, componentId);
}
function getEntityAndComponentForFirstEntityWithComponentInUpwardsHierarchy(entity, componentId) {
  return Companion_instance_62.m2r(entity, componentId);
}
function getDescendantsWithComponent(entity, componentId) {
  return Companion_instance_62.n2r(entity, componentId);
}
function getEntitiesAndComponentsForDescendantsWithComponent(entity, componentId) {
  return Companion_instance_62.o2r(entity, componentId);
}
function getDescendantWithComponent(entity, componentId) {
  return Companion_instance_62.p2r(entity, componentId);
}
function getEntityAndComponentForDescendantWithComponent(entity, componentId) {
  return Companion_instance_62.q2r(entity, componentId);
}
function getHierarchyWithComponent(entity, componentId) {
  return Companion_instance_62.r2r(entity, componentId);
}
function getEntitiesAndComponentsForHierarchyWithComponent(entity, componentId) {
  return Companion_instance_62.s2r(entity, componentId);
}
function hasComponentInUpwardsHierarchy(entity, componentId) {
  return Companion_instance_62.t2r(entity, componentId);
}
function getUpwardsHierarchy(entity) {
  return Companion_instance_62.u2r(entity);
}
function getAncestors(entity) {
  return Companion_instance_62.v2r(entity);
}
function findInUpwardsHierarchy(entity, finder) {
  return Companion_instance_62.w2r(entity, finder);
}
function HierarchyUtils() {
}
function forEachInHierarchy_0(_this__u8e3s4, func) {
  return Companion_instance_62.d2r(_this__u8e3s4, func);
}
function get_children(_this__u8e3s4) {
  return Companion_instance_62.z2q(_this__u8e3s4);
}
function findInHierarchy_0(_this__u8e3s4, finder) {
  return Companion_instance_62.h2r(_this__u8e3s4, finder);
}
function get_hierarchySequence(_this__u8e3s4) {
  return hierarchyExceptSubTreeSequence(_this__u8e3s4, null);
}
function hierarchyExceptSubTreeArray(_this__u8e3s4, subTreeRoot) {
  var l = ArrayList_init_$Create$_0(20);
  hierarchyExceptSubTreeArray$add(subTreeRoot, l, _this__u8e3s4);
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(l);
}
function findWithComponentInUpwardsHierarchy_0(_this__u8e3s4, componentId) {
  return Companion_instance_62.a29(_this__u8e3s4, componentId);
}
function hierarchyExceptSubTreeSequence(_this__u8e3s4, subtreeRoot) {
  return hierarchyExceptSubTreeSequence$iterateHierarchySequence(subtreeRoot, _this__u8e3s4);
}
function get_hierarchy(_this__u8e3s4) {
  return Companion_instance_62.a2r(_this__u8e3s4);
}
function setParent_0(_this__u8e3s4, parent) {
  if (!(parent == null)) {
    _this__u8e3s4.addComponent(new ChildComponent(parent));
  } else {
    _this__u8e3s4.removeComponent(Companion_getInstance_59().z2o_1);
  }
}
function get_upwardsHierarchy(_this__u8e3s4) {
  return Companion_instance_62.u2r(_this__u8e3s4);
}
function hierarchyExceptSubTreesWithComponentSequence(_this__u8e3s4, componentId) {
  return hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence(_this__u8e3s4, componentId, _this__u8e3s4);
}
function hierarchyExceptSubTreesWithComponentArray(_this__u8e3s4, componentId) {
  return Companion_instance_62.b2r(_this__u8e3s4, componentId);
}
function findInHierarchyExceptHierarchyOfIgnored_0(_this__u8e3s4, ignored, func) {
  return Companion_instance_62.i2r(_this__u8e3s4, ignored, func);
}
function setParentMaintainWorldTransform(_this__u8e3s4, parent) {
  var pos = get_worldPosition(_this__u8e3s4);
  var rot = get_worldRotation(_this__u8e3s4);
  setParent_0(_this__u8e3s4, parent);
  Companion_instance_146.z1l(_this__u8e3s4, new Transform(pos, rot));
}
function get_descendants(_this__u8e3s4) {
  return Companion_instance_62.y2q(_this__u8e3s4);
}
function filterInHierarchy_0(_this__u8e3s4, finder) {
  return Companion_instance_62.j2r(_this__u8e3s4, finder);
}
function hasComponentInUpwardsHierarchy_0(_this__u8e3s4, componentId) {
  return Companion_instance_62.t2r(_this__u8e3s4, componentId);
}
function get_childrenSequence(_this__u8e3s4) {
  var parentComponent = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_65().id);
  var tmp1_safe_receiver = parentComponent == null ? null : parentComponent.children;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : asSequence_0(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? emptySequence() : tmp2_elvis_lhs;
}
function forEachInHierarchyExceptHierarchyOfIgnored_0(_this__u8e3s4, ignored, func) {
  return Companion_instance_62.e2r(_this__u8e3s4, ignored, func);
}
function getHierarchyWithComponent_0(_this__u8e3s4, componentId) {
  return Companion_instance_62.r2r(_this__u8e3s4, componentId);
}
function isDescendantOf_0(_this__u8e3s4, other) {
  return Companion_instance_62.k2r(_this__u8e3s4, other);
}
function forEachInHierarchyExceptSubHierarchiesWithComponent_0(_this__u8e3s4, componentId, func) {
  return Companion_instance_62.f2r(_this__u8e3s4, componentId, func);
}
function hasAncestor_0(_this__u8e3s4, ancestor) {
  return Companion_instance_62.l2r(_this__u8e3s4, ancestor);
}
function hierarchyContains(_this__u8e3s4, entity) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.sequences.any' call
    var tmp0_iterator = get_hierarchySequence(_this__u8e3s4).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.hierarchies.hierarchyContains.<anonymous>' call
      if (element.equals(entity)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function findInUpwardsHierarchy_0(_this__u8e3s4, finder) {
  return Companion_instance_62.w2r(_this__u8e3s4, finder);
}
function hierarchyExceptSubTreeArray$add($subTreeRoot, l, e) {
  if (!(e.id === $subTreeRoot.id)) {
    l.h(e);
    var tmp0_safe_receiver = get_parentComponent(e);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        hierarchyExceptSubTreeArray$add($subTreeRoot, l, element);
      }
    }
  }
}
function hierarchyExceptSubTreeSequence$iterateHierarchySequence($subtreeRoot, e) {
  if (!e.equals($subtreeRoot)) {
    return sequence(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda_0(e, $subtreeRoot, null));
  }
  return emptySequence();
}
function hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence($this_hierarchyExceptSubTreesWithComponentSequence, $componentId, e) {
  if (e.equals($this_hierarchyExceptSubTreesWithComponentSequence) || !e.hasComponent($componentId)) {
    return sequence(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda_0(e, $this_hierarchyExceptSubTreesWithComponentSequence, $componentId, null));
  }
  return emptySequence();
}
function hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda$lambda($subtreeRoot) {
  return function (it) {
    return hierarchyExceptSubTreeSequence$iterateHierarchySequence($subtreeRoot, it);
  };
}
function hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda($e, $subtreeRoot, resultContinuation) {
  this.f2s_1 = $e;
  this.g2s_1 = $subtreeRoot;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda).i2s = function ($this$sequence, $completion) {
  var tmp = this.j2s($this$sequence, $completion);
  tmp.l9_1 = Unit_instance;
  tmp.m9_1 = null;
  return tmp.r9();
};
protoOf(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda).ja = function (p1, $completion) {
  return this.i2s(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
};
protoOf(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda).r9 = function () {
  var suspendResult = this.l9_1;
  $sm: do
    try {
      var tmp = this.j9_1;
      switch (tmp) {
        case 0:
          this.k9_1 = 3;
          this.j9_1 = 1;
          suspendResult = this.h2s_1.wf(this.f2s_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.j9_1 = 2;
          var tmp_0 = get_childrenSequence(this.f2s_1);
          suspendResult = this.h2s_1.yf(flatMap(tmp_0, hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda$lambda(this.g2s_1)), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.m9_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.k9_1 === 3) {
        throw e;
      } else {
        this.j9_1 = this.k9_1;
        this.m9_1 = e;
      }
    }
   while (true);
};
protoOf(hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda).j2s = function ($this$sequence, completion) {
  var i = new hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda(this.f2s_1, this.g2s_1, completion);
  i.h2s_1 = $this$sequence;
  return i;
};
function hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda_0($e, $subtreeRoot, resultContinuation) {
  var i = new hierarchyExceptSubTreeSequence$iterateHierarchySequence$slambda($e, $subtreeRoot, resultContinuation);
  var l = function ($this$sequence, $completion) {
    return i.i2s($this$sequence, $completion);
  };
  l.$arity = 1;
  return l;
}
function hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda$lambda($this_hierarchyExceptSubTreesWithComponentSequence, $componentId) {
  return function (it) {
    return hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence($this_hierarchyExceptSubTreesWithComponentSequence, $componentId, it);
  };
}
function hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda($e, $this_hierarchyExceptSubTreesWithComponentSequence, $componentId, resultContinuation) {
  this.s2s_1 = $e;
  this.t2s_1 = $this_hierarchyExceptSubTreesWithComponentSequence;
  this.u2s_1 = $componentId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda).i2s = function ($this$sequence, $completion) {
  var tmp = this.j2s($this$sequence, $completion);
  tmp.l9_1 = Unit_instance;
  tmp.m9_1 = null;
  return tmp.r9();
};
protoOf(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda).ja = function (p1, $completion) {
  return this.i2s(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
};
protoOf(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda).r9 = function () {
  var suspendResult = this.l9_1;
  $sm: do
    try {
      var tmp = this.j9_1;
      switch (tmp) {
        case 0:
          this.k9_1 = 3;
          this.j9_1 = 1;
          suspendResult = this.v2s_1.wf(this.s2s_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.j9_1 = 2;
          var tmp_0 = get_childrenSequence(this.s2s_1);
          suspendResult = this.v2s_1.yf(flatMap(tmp_0, hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda$lambda(this.t2s_1, this.u2s_1)), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.m9_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.k9_1 === 3) {
        throw e;
      } else {
        this.j9_1 = this.k9_1;
        this.m9_1 = e;
      }
    }
   while (true);
};
protoOf(hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda).j2s = function ($this$sequence, completion) {
  var i = new hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda(this.s2s_1, this.t2s_1, this.u2s_1, completion);
  i.v2s_1 = $this$sequence;
  return i;
};
function hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda_0($e, $this_hierarchyExceptSubTreesWithComponentSequence, $componentId, resultContinuation) {
  var i = new hierarchyExceptSubTreesWithComponentSequence$iterateHierarchySequence$slambda($e, $this_hierarchyExceptSubTreesWithComponentSequence, $componentId, resultContinuation);
  var l = function ($this$sequence, $completion) {
    return i.i2s($this$sequence, $completion);
  };
  l.$arity = 1;
  return l;
}
function Companion_63() {
}
protoOf(Companion_63).n1s = function () {
  return Companion_instance_21.b1n_1;
};
var Companion_instance_63;
function Companion_getInstance_64() {
  return Companion_instance_63;
}
function InSceneComponent() {
}
protoOf(InSceneComponent).p1s = function () {
  return Companion_instance_63.id;
};
protoOf(InSceneComponent).eq = function (other) {
  return true;
};
function get_isInScene(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_instance_63.id) || _this__u8e3s4.hasComponent(SceneComponent_instance.id);
}
function generateHierarchy($this, me) {
  var res = ArrayList_init_$Create$_0(20);
  if (me == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.hierarchies.ParentComponent.generateHierarchy.<anonymous>' call
    res.h(me);
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.children;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    generateHierarchy$add(res, element);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(res);
}
function generateHierarchy$default($this, me, $super) {
  me = me === VOID ? null : me;
  return generateHierarchy($this, me);
}
function Companion_64() {
  Companion_instance_64 = this;
  this.id = Companion_instance_21.m1n_1;
}
protoOf(Companion_64).n1s = function () {
  return this.id;
};
var Companion_instance_64;
function Companion_getInstance_65() {
  if (Companion_instance_64 == null)
    new Companion_64();
  return Companion_instance_64;
}
function generateHierarchy$add(res, e) {
  res.h(e);
  var tmp0_safe_receiver = get_parentComponent(e);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      generateHierarchy$add(res, element);
    }
  }
}
function ParentComponent(children) {
  Companion_getInstance_65();
  this.children = children;
}
protoOf(ParentComponent).i1m = function () {
  return this.children;
};
protoOf(ParentComponent).p1s = function () {
  return Companion_getInstance_65().id;
};
protoOf(ParentComponent).addChild = function (c) {
  var tmp;
  if (contains(this.children, c)) {
    tmp = this;
  } else {
    // Inline function 'kotlin.collections.plusElement' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = this.children;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [c];
    var tmp$ret$4 = tmp$ret$0.concat(tmp$ret$3);
    tmp = new ParentComponent(tmp$ret$4);
  }
  return tmp;
};
protoOf(ParentComponent).removeChild = function (c) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.children;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.hierarchies.ParentComponent.removeChild.<anonymous>' call
    if (!c.equals(element)) {
      destination.h(element);
    }
  }
  var childrenAfter = copyToArray(destination);
  if (any(childrenAfter))
    return new ParentComponent(childrenAfter);
  return null;
};
protoOf(ParentComponent).addChildren = function (newChildren) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var setOfChildren = LinkedHashSet_init_$Create$();
  addAll_1(setOfChildren, this.children);
  addAll_1(setOfChildren, newChildren);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$1 = copyToArray(setOfChildren);
  return new ParentComponent(tmp$ret$1);
};
protoOf(ParentComponent).hierarchy = function (me) {
  return generateHierarchy(this, me);
};
protoOf(ParentComponent).allDescendants = function () {
  return generateHierarchy$default(this);
};
protoOf(ParentComponent).eq = function (other) {
  var otherParent = other instanceof ParentComponent ? other : THROW_CCE();
  var tmp;
  if (otherParent.children.length === this.children.length) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var indexedObject = this.children;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.hierarchies.ParentComponent.eq.<anonymous>' call
        if (!contains(otherParent.children, element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    tmp = tmp$ret$1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ParentComponent).equals = function (other) {
  var tmp;
  if (other instanceof ParentComponent) {
    var tmp_0;
    if (other.children.length === this.children.length) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.all' call
        var indexedObject = this.children;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.hierarchies.ParentComponent.equals.<anonymous>' call
          if (!contains(other.children, element)) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp_0 = tmp$ret$1;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ParentComponent).hashCode = function () {
  return hashCode(this.children);
};
protoOf(ParentComponent).tf = function () {
  return this.children;
};
protoOf(ParentComponent).w2s = function (children) {
  return new ParentComponent(children);
};
protoOf(ParentComponent).copy = function (children, $super) {
  children = children === VOID ? this.children : children;
  return this.w2s(children);
};
protoOf(ParentComponent).toString = function () {
  return 'ParentComponent(children=' + toString_0(this.children) + ')';
};
function get_parentComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_65().id);
}
function RestoreSnapRootOnChildrenOfTemporaryParentSystem() {
  SystemBase.call(this, 'RestoreSnapRootOnChildrenOfTemporaryParentSystem', Companion_getInstance_59().z2o_1);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g2t_1 = [Companion_instance_61.ID];
}
protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem).l1w = function () {
  return this.g2t_1;
};
protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem).o2q = function (entity, oldComponent, newComponent) {
  if (oldComponent.parent.hasComponent(Companion_getInstance_67().u29_1)) {
    entity.addComponent(new SnapRootComponent());
  }
};
protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE();
  return this.o2q(entity, tmp, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
function SceneComponent_0() {
}
protoOf(SceneComponent_0).p1s = function () {
  return this.id;
};
protoOf(SceneComponent_0).n1s = function () {
  return Companion_instance_21.o1q_1;
};
protoOf(SceneComponent_0).eq = function (other) {
  return true;
};
var SceneComponent_instance;
function SceneComponent_getInstance() {
  return SceneComponent_instance;
}
function Companion_65() {
  this.h2t_1 = 'SceneGraphSystem';
}
var Companion_instance_65;
function Companion_getInstance_66() {
  return Companion_instance_65;
}
function updateWithInfoFromParent($this, entity) {
  var tmp = Companion_instance_62;
  tmp.d2r(entity, SceneGraphSystem$updateWithInfoFromParent$update$ref($this));
}
function isScene($this, entity) {
  return entity.hasComponent(SceneComponent_instance.id);
}
function removeInSceneComponent($this, entity) {
  if (isInScene($this, entity)) {
    entity.removeComponent(Companion_instance_63.id);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.hierarchies.SceneGraphSystem.removeInSceneComponent.<anonymous>' call
      removeInSceneComponent($this, element);
    }
  }
}
function isInScene($this, entity) {
  return !(entity == null) && get_isInScene(entity);
}
function updateWithInfoFromParent$update(this$0, e) {
  if (e.isDisposed || e.isBeingDisposed)
    return Unit_instance;
  var tmp;
  if (isScene(this$0, e)) {
    tmp = true;
  } else {
    var tmp_0;
    var tmp0_safe_receiver = get_parent(e);
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isDisposed) === false) {
      tmp_0 = isInScene(this$0, get_parent(e));
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  if (tmp) {
    if (!isInScene(this$0, e)) {
      e.addComponent(new InSceneComponent());
    }
  } else {
    removeInSceneComponent(this$0, e);
  }
}
function SceneGraphSystem$updateWithInfoFromParent$update$ref(this$0) {
  var l = function (p0) {
    updateWithInfoFromParent$update(this$0, p0);
    return Unit_instance;
  };
  l.callableName = 'update';
  return l;
}
function SceneGraphSystem(sceneManager) {
  var tmp = Companion_instance_21.n1n_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [Companion_instance_21.b1n_1];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [Companion_instance_61.ID];
  SystemBase.call(this, 'SceneGraphSystem', tmp, tmp_0, tmp$ret$5, null);
  this.r2t_1 = sceneManager;
}
protoOf(SceneGraphSystem).m2q = function (entity, newComponent) {
  updateWithInfoFromParent(this, entity);
};
protoOf(SceneGraphSystem).v1v = function (entity, newComponent) {
  return this.m2q(entity, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
protoOf(SceneGraphSystem).o2q = function (entity, oldComponent, newComponent) {
  updateWithInfoFromParent(this, entity);
};
protoOf(SceneGraphSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE();
  return this.o2q(entity, tmp, newComponent instanceof ChildComponent ? newComponent : THROW_CCE());
};
protoOf(SceneGraphSystem).p2q = function (entity, oldComponent) {
  entity.removeComponent(Companion_instance_63.id);
  updateWithInfoFromParent(this, entity);
};
protoOf(SceneGraphSystem).z1v = function (entity, oldComponent) {
  return this.p2q(entity, oldComponent instanceof ChildComponent ? oldComponent : THROW_CCE());
};
function SceneManager() {
}
function Companion_66() {
  Companion_instance_66 = this;
  this.u29_1 = Companion_instance_21.y1o_1;
}
var Companion_instance_66;
function Companion_getInstance_67() {
  if (Companion_instance_66 == null)
    new Companion_66();
  return Companion_instance_66;
}
function TemporaryParentComponent() {
  Companion_getInstance_67();
}
protoOf(TemporaryParentComponent).p1s = function () {
  return Companion_getInstance_67().u29_1;
};
protoOf(TemporaryParentComponent).eq = function (other) {
  return true;
};
function History() {
}
var HistoryEvent_TAKE_SNAPSHOT_instance;
var HistoryEvent_UNDO_instance;
var HistoryEvent_REDO_instance;
var HistoryEvent_CLEAR_instance;
var HistoryEvent_DISCARD_SNAPSHOT_instance;
function values() {
  return [HistoryEvent_TAKE_SNAPSHOT_getInstance(), HistoryEvent_UNDO_getInstance(), HistoryEvent_REDO_getInstance(), HistoryEvent_CLEAR_getInstance(), HistoryEvent_DISCARD_SNAPSHOT_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'TAKE_SNAPSHOT':
      return HistoryEvent_TAKE_SNAPSHOT_getInstance();
    case 'UNDO':
      return HistoryEvent_UNDO_getInstance();
    case 'REDO':
      return HistoryEvent_REDO_getInstance();
    case 'CLEAR':
      return HistoryEvent_CLEAR_getInstance();
    case 'DISCARD_SNAPSHOT':
      return HistoryEvent_DISCARD_SNAPSHOT_getInstance();
    default:
      HistoryEvent_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var HistoryEvent_entriesInitialized;
function HistoryEvent_initEntries() {
  if (HistoryEvent_entriesInitialized)
    return Unit_instance;
  HistoryEvent_entriesInitialized = true;
  HistoryEvent_TAKE_SNAPSHOT_instance = new HistoryEvent('TAKE_SNAPSHOT', 0);
  HistoryEvent_UNDO_instance = new HistoryEvent('UNDO', 1);
  HistoryEvent_REDO_instance = new HistoryEvent('REDO', 2);
  HistoryEvent_CLEAR_instance = new HistoryEvent('CLEAR', 3);
  HistoryEvent_DISCARD_SNAPSHOT_instance = new HistoryEvent('DISCARD_SNAPSHOT', 4);
}
function HistoryEvent(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Companion_67() {
  Companion_instance_67 = this;
  this.id = Companion_instance_21.f1q_1;
}
protoOf(Companion_67).n1s = function () {
  return this.id;
};
var Companion_instance_67;
function Companion_getInstance_68() {
  if (Companion_instance_67 == null)
    new Companion_67();
  return Companion_instance_67;
}
function HistoryChangedEventComponent(historyEvent) {
  Companion_getInstance_68();
  this.historyEvent = historyEvent;
  this.y2t_1 = Companion_getInstance_68().id;
}
protoOf(HistoryChangedEventComponent).z2t = function () {
  return this.historyEvent;
};
protoOf(HistoryChangedEventComponent).p1s = function () {
  return this.y2t_1;
};
protoOf(HistoryChangedEventComponent).eq = function (other) {
  return true;
};
function triggerHistoryChangedEvent(_this__u8e3s4, event, entityManager) {
  entityManager.addComponent(_this__u8e3s4, new HistoryChangedEventComponent(event));
  entityManager.removeComponent(_this__u8e3s4, Companion_getInstance_68().id);
}
function HistoryEvent_TAKE_SNAPSHOT_getInstance() {
  HistoryEvent_initEntries();
  return HistoryEvent_TAKE_SNAPSHOT_instance;
}
function HistoryEvent_UNDO_getInstance() {
  HistoryEvent_initEntries();
  return HistoryEvent_UNDO_instance;
}
function HistoryEvent_REDO_getInstance() {
  HistoryEvent_initEntries();
  return HistoryEvent_REDO_instance;
}
function HistoryEvent_CLEAR_getInstance() {
  HistoryEvent_initEntries();
  return HistoryEvent_CLEAR_instance;
}
function HistoryEvent_DISCARD_SNAPSHOT_getInstance() {
  HistoryEvent_initEntries();
  return HistoryEvent_DISCARD_SNAPSHOT_instance;
}
function makeFreeSlots($this) {
  if ($this.g2u_1.o() >= $this.c2u_1) {
    removeOld($this);
  }
}
function purgeFutureSnapshots($this) {
  while ($this.g2u_1.o() > 0 && $this.g2u_1.o() > $this.f2u_1) {
    $this.g2u_1.z1w();
    triggerHistoryChangedEvent($this.e2u_1, HistoryEvent_DISCARD_SNAPSHOT_getInstance(), $this.a2u_1);
  }
}
function removeOld($this) {
  $this.g2u_1.a1x();
  $this.f2u_1 = $this.f2u_1 - 1 | 0;
}
function _get_isAtTopOfStack__ylrnny($this) {
  return $this.f2u_1 >= ($this.g2u_1.o() - 1 | 0);
}
function HistoryImpl(entityManager, snapshotService, maxHistorySize) {
  maxHistorySize = maxHistorySize === VOID ? 500 : maxHistorySize;
  this.a2u_1 = entityManager;
  this.b2u_1 = snapshotService;
  this.c2u_1 = maxHistorySize;
  if (this.c2u_1 < 1) {
    throw Exception_init_$Create$('History was initialized with size ' + this.c2u_1 + ', please initialize with at least size 2.');
  }
  this.d2u_1 = false;
  this.e2u_1 = this.a2u_1.createEntity();
  this.f2u_1 = 0;
  this.g2u_1 = new CircularBuffer(this.c2u_1);
}
protoOf(HistoryImpl).u2t = function () {
  return this.d2u_1;
};
protoOf(HistoryImpl).v2t = function (snapshotName) {
  if (this.isPaused)
    return Unit_instance;
  makeFreeSlots(this);
  purgeFutureSnapshots(this);
  this.g2u_1.y1w(this.b2u_1.takeSnapshot(snapshotName));
  this.f2u_1 = this.f2u_1 + 1 | 0;
  triggerHistoryChangedEvent(this.e2u_1, HistoryEvent_TAKE_SNAPSHOT_getInstance(), this.a2u_1);
};
protoOf(HistoryImpl).getSnapshots = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.g2u_1.b1x();
  return copyToArray(this_0);
};
protoOf(HistoryImpl).discardLatestSnapshot = function () {
  this.g2u_1.z1w();
  if (this.g2u_1.o() < this.f2u_1) {
    this.f2u_1 = this.f2u_1 - 1 | 0;
  }
  triggerHistoryChangedEvent(this.e2u_1, HistoryEvent_DISCARD_SNAPSHOT_getInstance(), this.a2u_1);
};
protoOf(HistoryImpl).clear = function () {
  this.f2u_1 = 0;
  this.g2u_1.m2();
  this.d2u_1 = false;
  triggerHistoryChangedEvent(this.e2u_1, HistoryEvent_CLEAR_getInstance(), this.a2u_1);
};
protoOf(HistoryImpl).redo = function () {
  if (this.isPaused)
    return Unit_instance;
  if (this.canRedo()) {
    this.f2u_1 = this.f2u_1 + 1 | 0;
    var snapshot = this.g2u_1.q(this.f2u_1);
    this.b2u_1.loadSnapshot(snapshot);
    if (_get_isAtTopOfStack__ylrnny(this)) {
      this.discardLatestSnapshot();
    }
    triggerHistoryChangedEvent(this.e2u_1, HistoryEvent_REDO_getInstance(), this.a2u_1);
  }
};
protoOf(HistoryImpl).undo = function () {
  if (this.isPaused)
    return Unit_instance;
  if (this.canUndo()) {
    if (_get_isAtTopOfStack__ylrnny(this)) {
      this.takeSnapshot('undo temp snapshot');
      this.f2u_1 = this.f2u_1 - 1 | 0;
    }
    this.f2u_1 = this.f2u_1 - 1 | 0;
    var snapshot = this.g2u_1.q(this.f2u_1);
    this.b2u_1.loadSnapshot(snapshot);
    triggerHistoryChangedEvent(this.e2u_1, HistoryEvent_UNDO_getInstance(), this.a2u_1);
  }
};
protoOf(HistoryImpl).canUndo = function () {
  return this.f2u_1 > 0;
};
protoOf(HistoryImpl).pause = function () {
  this.d2u_1 = true;
};
protoOf(HistoryImpl).unPause = function () {
  this.d2u_1 = false;
};
protoOf(HistoryImpl).canRedo = function () {
  return !_get_isAtTopOfStack__ylrnny(this);
};
protoOf(HistoryImpl).historySize = function () {
  return this.g2u_1.o();
};
protoOf(HistoryImpl).getHistory = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.g2u_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.history.HistoryImpl.getHistory.<anonymous>' call
    var tmp$ret$0 = item.name;
    destination.h(tmp$ret$0);
  }
  return copyToArray(destination);
};
protoOf(HistoryImpl).remainingItemsToUndo = function () {
  return this.f2u_1;
};
var LogLevel_DEBUG_instance;
var LogLevel_INFO_instance;
var LogLevel_WARN_instance;
var LogLevel_ERROR_instance;
var LogLevel_NONE_instance;
function values_0() {
  return [LogLevel_DEBUG_getInstance(), LogLevel_INFO_getInstance(), LogLevel_WARN_getInstance(), LogLevel_ERROR_getInstance(), LogLevel_NONE_getInstance()];
}
function valueOf_0(value) {
  switch (value) {
    case 'DEBUG':
      return LogLevel_DEBUG_getInstance();
    case 'INFO':
      return LogLevel_INFO_getInstance();
    case 'WARN':
      return LogLevel_WARN_getInstance();
    case 'ERROR':
      return LogLevel_ERROR_getInstance();
    case 'NONE':
      return LogLevel_NONE_getInstance();
    default:
      LogLevel_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var LogLevel_entriesInitialized;
function LogLevel_initEntries() {
  if (LogLevel_entriesInitialized)
    return Unit_instance;
  LogLevel_entriesInitialized = true;
  LogLevel_DEBUG_instance = new LogLevel('DEBUG', 0);
  LogLevel_INFO_instance = new LogLevel('INFO', 1);
  LogLevel_WARN_instance = new LogLevel('WARN', 2);
  LogLevel_ERROR_instance = new LogLevel('ERROR', 3);
  LogLevel_NONE_instance = new LogLevel('NONE', 4);
}
function LogLevel(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function LogLevel_DEBUG_getInstance() {
  LogLevel_initEntries();
  return LogLevel_DEBUG_instance;
}
function LogLevel_INFO_getInstance() {
  LogLevel_initEntries();
  return LogLevel_INFO_instance;
}
function LogLevel_WARN_getInstance() {
  LogLevel_initEntries();
  return LogLevel_WARN_instance;
}
function LogLevel_ERROR_getInstance() {
  LogLevel_initEntries();
  return LogLevel_ERROR_instance;
}
function LogLevel_NONE_getInstance() {
  LogLevel_initEntries();
  return LogLevel_NONE_instance;
}
function Logger() {
}
function LoggerImpl() {
  this.l2u_1 = LogLevel_ERROR_getInstance();
}
protoOf(LoggerImpl).j2u = function (_set____db54di) {
  this.l2u_1 = _set____db54di;
};
protoOf(LoggerImpl).k2u = function () {
  return this.l2u_1;
};
protoOf(LoggerImpl).debug = function (f) {
  if (this.l2u_1.x2(LogLevel_DEBUG_getInstance()) <= 0) {
    echoStandardConsole(f());
  }
};
protoOf(LoggerImpl).error = function (f) {
  if (this.l2u_1.x2(LogLevel_ERROR_getInstance()) <= 0) {
    echoStandardConsole(f());
  }
};
protoOf(LoggerImpl).warn = function (f) {
  if (this.l2u_1.x2(LogLevel_WARN_getInstance()) <= 0) {
    echoStandardConsole(f());
  }
};
protoOf(LoggerImpl).info = function (f) {
  if (this.l2u_1.x2(LogLevel_INFO_getInstance()) <= 0) {
    echoStandardConsole(f());
  }
};
function LoggerState$LoggerWrap$debug$lambda(this$0, $f) {
  return function () {
    return this$0.m2u_1 + toString($f());
  };
}
function LoggerState$LoggerWrap$error$lambda(this$0, $f) {
  return function () {
    return this$0.m2u_1 + toString($f());
  };
}
function LoggerState$LoggerWrap$warn$lambda(this$0, $f) {
  return function () {
    return this$0.m2u_1 + toString($f());
  };
}
function LoggerState$LoggerWrap$info$lambda(this$0, $f) {
  return function () {
    return this$0.m2u_1 + toString($f());
  };
}
function LoggerWrap(packageColon) {
  this.m2u_1 = packageColon;
}
protoOf(LoggerWrap).j2u = function (_) {
};
protoOf(LoggerWrap).k2u = function () {
  return LoggerState_getInstance().m1k_1.logLevel;
};
protoOf(LoggerWrap).debug = function (f) {
  var tmp = LoggerState_getInstance().m1k_1;
  tmp.debug(LoggerState$LoggerWrap$debug$lambda(this, f));
};
protoOf(LoggerWrap).error = function (f) {
  var tmp = LoggerState_getInstance().m1k_1;
  tmp.error(LoggerState$LoggerWrap$error$lambda(this, f));
};
protoOf(LoggerWrap).warn = function (f) {
  var tmp = LoggerState_getInstance().m1k_1;
  tmp.warn(LoggerState$LoggerWrap$warn$lambda(this, f));
};
protoOf(LoggerWrap).info = function (f) {
  var tmp = LoggerState_getInstance().m1k_1;
  tmp.info(LoggerState$LoggerWrap$info$lambda(this, f));
};
function LoggerState() {
  LoggerState_instance = this;
  this.m1k_1 = new LoggerImpl();
  this.n1k_1 = 'com.ikea';
}
protoOf(LoggerState).n2u = function (level) {
  this.m1k_1.logLevel = level;
};
protoOf(LoggerState).o2u = function (logger, basePackageName) {
  this.m1k_1 = logger;
  this.n1k_1 = basePackageName;
};
protoOf(LoggerState).g1v = function (packageName) {
  return this.n1k_1 === '' ? new LoggerWrap(packageName + ':') : new LoggerWrap(this.n1k_1 + '.' + packageName + ':');
};
protoOf(LoggerState).o1k = function () {
  return this.m1k_1;
};
var LoggerState_instance;
function LoggerState_getInstance() {
  if (LoggerState_instance == null)
    new LoggerState();
  return LoggerState_instance;
}
function AxisAngle(axis, angle) {
  this.axis = axis;
  this.angle = angle;
}
protoOf(AxisAngle).p2u = function () {
  return this.axis;
};
protoOf(AxisAngle).q2u = function () {
  return this.angle;
};
protoOf(AxisAngle).tf = function () {
  return this.axis;
};
protoOf(AxisAngle).uf = function () {
  return this.angle;
};
protoOf(AxisAngle).r2u = function (axis, angle) {
  return new AxisAngle(axis, angle);
};
protoOf(AxisAngle).copy = function (axis, angle, $super) {
  axis = axis === VOID ? this.axis : axis;
  angle = angle === VOID ? this.angle : angle;
  return this.r2u(axis, angle);
};
protoOf(AxisAngle).toString = function () {
  return 'AxisAngle(axis=' + this.axis.toString() + ', angle=' + this.angle.toString() + ')';
};
protoOf(AxisAngle).hashCode = function () {
  var result = this.axis.hashCode();
  result = imul(result, 31) + this.angle.hashCode() | 0;
  return result;
};
protoOf(AxisAngle).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AxisAngle))
    return false;
  var tmp0_other_with_cast = other instanceof AxisAngle ? other : THROW_CCE();
  if (!this.axis.equals(tmp0_other_with_cast.axis))
    return false;
  if (!this.angle.equals(tmp0_other_with_cast.angle))
    return false;
  return true;
};
function Degrees(value) {
  this.value = value;
}
protoOf(Degrees).c2 = function () {
  return this.value;
};
protoOf(Degrees).toRadian = function () {
  return new Radians(this.value * Companion_getInstance_74().t2b_1);
};
protoOf(Degrees).tf = function () {
  return this.value;
};
protoOf(Degrees).s2u = function (value) {
  return new Degrees(value);
};
protoOf(Degrees).copy = function (value, $super) {
  value = value === VOID ? this.value : value;
  return this.s2u(value);
};
protoOf(Degrees).toString = function () {
  return 'Degrees(value=' + this.value + ')';
};
protoOf(Degrees).hashCode = function () {
  return getNumberHashCode(this.value);
};
protoOf(Degrees).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Degrees))
    return false;
  var tmp0_other_with_cast = other instanceof Degrees ? other : THROW_CCE();
  if (!equals(this.value, tmp0_other_with_cast.value))
    return false;
  return true;
};
function Dimension() {
}
function DualDouble(first, last) {
  this.first = first;
  this.last = last;
}
protoOf(DualDouble).w2u = function (_set____db54di) {
  this.first = _set____db54di;
};
protoOf(DualDouble).k2g = function () {
  return this.first;
};
protoOf(DualDouble).x2u = function (_set____db54di) {
  this.last = _set____db54di;
};
protoOf(DualDouble).l2g = function () {
  return this.last;
};
protoOf(DualDouble).y2u = function () {
  return (this.first + this.last) / 2;
};
protoOf(DualDouble).a = function () {
  return this.last - this.first;
};
function Companion_68() {
}
protoOf(Companion_68).z18 = function () {
  return $serializer_getInstance_2();
};
var Companion_instance_68;
function Companion_getInstance_69() {
  return Companion_instance_68;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Margin', this, 6);
  tmp0_serialDesc.lw('top', true);
  tmp0_serialDesc.lw('right', true);
  tmp0_serialDesc.lw('bottom', true);
  tmp0_serialDesc.lw('left', true);
  tmp0_serialDesc.lw('back', true);
  tmp0_serialDesc.lw('front', true);
  this.z2u_1 = tmp0_serialDesc;
}
protoOf($serializer_2).a2v = function (encoder, value) {
  var tmp0_desc = this.z2u_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !equals(value.top, 0.0)) {
    tmp1_output.oq(tmp0_desc, 0, value.top);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !equals(value.right, 0.0)) {
    tmp1_output.oq(tmp0_desc, 1, value.right);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !equals(value.bottom, 0.0)) {
    tmp1_output.oq(tmp0_desc, 2, value.bottom);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !equals(value.left, 0.0)) {
    tmp1_output.oq(tmp0_desc, 3, value.left);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !equals(value.back, 0.0)) {
    tmp1_output.oq(tmp0_desc, 4, value.back);
  }
  if (tmp1_output.yq(tmp0_desc, 5) ? true : !equals(value.front, 0.0)) {
    tmp1_output.oq(tmp0_desc, 5, value.front);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_2).ul = function (encoder, value) {
  return this.a2v(encoder, value instanceof Margin ? value : THROW_CCE());
};
protoOf($serializer_2).vl = function (decoder) {
  var tmp0_desc = this.z2u_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = 0.0;
  var tmp8_local4 = 0.0;
  var tmp9_local5 = 0.0;
  var tmp10_input = decoder.bp(tmp0_desc);
  if (tmp10_input.rp()) {
    tmp4_local0 = tmp10_input.jp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.jp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.jp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.jp(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.jp(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.jp(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.jp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.jp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.jp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.jp(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.jp(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.jp(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.cp(tmp0_desc);
  return Margin_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_2).tl = function () {
  return this.z2u_1;
};
protoOf($serializer_2).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
};
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function Margin_init_$Init$(seen0, top, right, bottom, left, back, front, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_2().z2u_1);
  }
  if (0 === (seen0 & 1))
    $this.top = 0.0;
  else
    $this.top = top;
  if (0 === (seen0 & 2))
    $this.right = 0.0;
  else
    $this.right = right;
  if (0 === (seen0 & 4))
    $this.bottom = 0.0;
  else
    $this.bottom = bottom;
  if (0 === (seen0 & 8))
    $this.left = 0.0;
  else
    $this.left = left;
  if (0 === (seen0 & 16))
    $this.back = 0.0;
  else
    $this.back = back;
  if (0 === (seen0 & 32))
    $this.front = 0.0;
  else
    $this.front = front;
  return $this;
}
function Margin_init_$Create$(seen0, top, right, bottom, left, back, front, serializationConstructorMarker) {
  return Margin_init_$Init$(seen0, top, right, bottom, left, back, front, serializationConstructorMarker, objectCreate(protoOf(Margin)));
}
function Margin(top, right, bottom, left, back, front) {
  top = top === VOID ? 0.0 : top;
  right = right === VOID ? 0.0 : right;
  bottom = bottom === VOID ? 0.0 : bottom;
  left = left === VOID ? 0.0 : left;
  back = back === VOID ? 0.0 : back;
  front = front === VOID ? 0.0 : front;
  this.top = top;
  this.right = right;
  this.bottom = bottom;
  this.left = left;
  this.back = back;
  this.front = front;
}
protoOf(Margin).b2v = function () {
  return this.top;
};
protoOf(Margin).c2v = function () {
  return this.right;
};
protoOf(Margin).d2v = function () {
  return this.bottom;
};
protoOf(Margin).e2v = function () {
  return this.left;
};
protoOf(Margin).f2v = function () {
  return this.back;
};
protoOf(Margin).g2v = function () {
  return this.front;
};
protoOf(Margin).innerSize = function (size) {
  return new Vector(size.X - (this.left + this.right), size.Y - (this.top + this.bottom), size.Z - (this.front + this.back));
};
protoOf(Margin).innerOrigin = function () {
  return new Vector((this.left - this.right) / 2, (this.bottom - this.top) / 2, (this.back - this.front) / 2);
};
protoOf(Margin).outerSize = function (box) {
  return new Vector(box.X + (this.left + this.right), box.Y + (this.top + this.bottom), box.Z + (this.front + this.back));
};
protoOf(Margin).equal = function (value) {
  return new Margin(value, value, value, value, value, value);
};
protoOf(Margin).equals = function (other) {
  var tmp;
  if (other instanceof Margin) {
    tmp = (other.top === this.top && other.right === this.right && other.bottom === this.bottom && other.left === this.left && other.back === this.back && other.front === this.front);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(Margin).hashCode = function () {
  return numberToInt(this.top * 3 + this.right * 13 + this.bottom * 23 + this.left * 37 + this.back * 61 + this.front * 97);
};
protoOf(Margin).backBox = function (outerSize) {
  return new Vector(outerSize.width, outerSize.height, this.back);
};
protoOf(Margin).frontBox = function (outerSize) {
  return new Vector(outerSize.width, outerSize.height, this.front);
};
protoOf(Margin).rightBox = function (outerSize) {
  return new Vector(this.right, outerSize.height, outerSize.depth);
};
protoOf(Margin).leftBox = function (outerSize) {
  return new Vector(this.left, outerSize.height, outerSize.depth);
};
protoOf(Margin).topBox = function (outerSize) {
  return new Vector(outerSize.width, this.top, outerSize.depth);
};
protoOf(Margin).bottomBox = function (outerSize) {
  return new Vector(outerSize.width, this.bottom, outerSize.depth);
};
protoOf(Margin).tf = function () {
  return this.top;
};
protoOf(Margin).uf = function () {
  return this.right;
};
protoOf(Margin).m1m = function () {
  return this.bottom;
};
protoOf(Margin).n1m = function () {
  return this.left;
};
protoOf(Margin).o1m = function () {
  return this.back;
};
protoOf(Margin).p1m = function () {
  return this.front;
};
protoOf(Margin).h2v = function (top, right, bottom, left, back, front) {
  return new Margin(top, right, bottom, left, back, front);
};
protoOf(Margin).copy = function (top, right, bottom, left, back, front, $super) {
  top = top === VOID ? this.top : top;
  right = right === VOID ? this.right : right;
  bottom = bottom === VOID ? this.bottom : bottom;
  left = left === VOID ? this.left : left;
  back = back === VOID ? this.back : back;
  front = front === VOID ? this.front : front;
  return this.h2v(top, right, bottom, left, back, front);
};
protoOf(Margin).toString = function () {
  return 'Margin(top=' + this.top + ', right=' + this.right + ', bottom=' + this.bottom + ', left=' + this.left + ', back=' + this.back + ', front=' + this.front + ')';
};
function Companion_69() {
  Companion_instance_69 = this;
  this.i2v_1 = Companion_getInstance_80().c1x_1;
  this.j2v_1 = Companion_getInstance_74().q2b_1;
}
protoOf(Companion_69).k2v = function () {
  return this.i2v_1;
};
protoOf(Companion_69).l2v = function () {
  return this.j2v_1;
};
protoOf(Companion_69).m2v = function (axis, angleDegrees) {
  return Companion_getInstance_74().n2v(axis, (new Degrees(angleDegrees)).toRadian());
};
protoOf(Companion_69).o2v = function (forward, up) {
  return Companion_getInstance_74().p2v(forward, up);
};
protoOf(Companion_69).q2v = function (forward, up) {
  return Companion_getInstance_74().r2v(forward, up);
};
protoOf(Companion_69).s2v = function (right, up, forward) {
  return Companion_getInstance_74().s2v(right, up, forward);
};
protoOf(Companion_69).t2v = function (angles) {
  return Companion_getInstance_74().fromEulerDegreesVector(angles);
};
protoOf(Companion_69).u2v = function (x, y, z) {
  return Companion_getInstance_74().v2v(new Radians(x), new Radians(y), new Radians(z));
};
protoOf(Companion_69).w2v = function (vertices) {
  return Companion_getInstance_125().z2v(vertices);
};
protoOf(Companion_69).a2w = function (points) {
  return get_geometricMean(points);
};
protoOf(Companion_69).b2w = function (quaternion) {
  var te = new Float64Array(16);
  var x = quaternion.x;
  var y = quaternion.y;
  var z = quaternion.z;
  var w = quaternion.w;
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  te[0] = 1 - (yy + zz);
  te[1] = xy + wz;
  te[2] = xz - wy;
  te[3] = 0.0;
  te[4] = xy - wz;
  te[5] = 1 - (xx + zz);
  te[6] = yz + wx;
  te[7] = 0.0;
  te[8] = xz + wy;
  te[9] = yz - wx;
  te[10] = 1 - (xx + yy);
  te[11] = 0.0;
  te[12] = 0.0;
  te[13] = 0.0;
  te[14] = 0.0;
  te[15] = 1.0;
  return te;
};
var Companion_instance_69;
function Companion_getInstance_70() {
  if (Companion_instance_69 == null)
    new Companion_69();
  return Companion_instance_69;
}
function get_transformIdentity() {
  return Companion_getInstance_70().i2v_1;
}
function get_quaternionIdentity() {
  return Companion_getInstance_70().j2v_1;
}
function quaternionFromAxisAngle(axis, angleDegrees) {
  return Companion_getInstance_70().m2v(axis, angleDegrees);
}
function quaternionFromLookDirection(forward, up) {
  return Companion_getInstance_70().o2v(forward, up);
}
function quaternionFromLookDirectionUnsafe(forward, up) {
  return Companion_getInstance_70().q2v(forward, up);
}
function quaternionFromBaseVectors(right, up, forward) {
  return Companion_getInstance_70().s2v(right, up, forward);
}
function quaternionFromEulerDegrees(angles) {
  return Companion_getInstance_70().t2v(angles);
}
function quaternionFromEulerRadians(x, y, z) {
  return Companion_getInstance_70().u2v(x, y, z);
}
function axisAlignedBoxFromVertices(vertices) {
  return Companion_getInstance_70().w2v(vertices);
}
function geometricMeanFromPoints(points) {
  return Companion_getInstance_70().a2w(points);
}
function quaternionToRotationMatrix(quaternion) {
  return Companion_getInstance_70().b2w(quaternion);
}
function MathUtils() {
  Companion_getInstance_70();
}
function Companion_70() {
}
protoOf(Companion_70).z18 = function () {
  return $serializer_getInstance_3();
};
var Companion_instance_70;
function Companion_getInstance_71() {
  return Companion_instance_70;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.ModelTransform', this, 3);
  tmp0_serialDesc.lw('p', true);
  tmp0_serialDesc.lw('r', true);
  tmp0_serialDesc.lw('s', true);
  this.d2w_1 = tmp0_serialDesc;
}
protoOf($serializer_3).e2w = function (encoder, value) {
  var tmp0_desc = this.d2w_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.position == null)) {
    tmp1_output.uq(tmp0_desc, 0, $serializer_getInstance_8(), value.position);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.rotation == null)) {
    tmp1_output.uq(tmp0_desc, 1, $serializer_getInstance_8(), value.rotation);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.scale == null)) {
    tmp1_output.uq(tmp0_desc, 2, $serializer_getInstance_8(), value.scale);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_3).ul = function (encoder, value) {
  return this.e2w(encoder, value instanceof ModelTransform ? value : THROW_CCE());
};
protoOf($serializer_3).vl = function (decoder) {
  var tmp0_desc = this.d2w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.pp(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, $serializer_getInstance_8(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, $serializer_getInstance_8(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.pp(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, $serializer_getInstance_8(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, $serializer_getInstance_8(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return ModelTransform_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_3).tl = function () {
  return this.d2w_1;
};
protoOf($serializer_3).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_8())];
};
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function ModelTransform_init_$Init$(seen0, position, rotation, scale, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_3().d2w_1);
  }
  if (0 === (seen0 & 1))
    $this.position = null;
  else
    $this.position = position;
  if (0 === (seen0 & 2))
    $this.rotation = null;
  else
    $this.rotation = rotation;
  if (0 === (seen0 & 4))
    $this.scale = null;
  else
    $this.scale = scale;
  return $this;
}
function ModelTransform_init_$Create$(seen0, position, rotation, scale, serializationConstructorMarker) {
  return ModelTransform_init_$Init$(seen0, position, rotation, scale, serializationConstructorMarker, objectCreate(protoOf(ModelTransform)));
}
function ModelTransform(position, rotation, scale) {
  position = position === VOID ? null : position;
  rotation = rotation === VOID ? null : rotation;
  scale = scale === VOID ? null : scale;
  this.position = position;
  this.rotation = rotation;
  this.scale = scale;
}
protoOf(ModelTransform).f2w = function () {
  return this.position;
};
protoOf(ModelTransform).m2g = function () {
  return this.rotation;
};
protoOf(ModelTransform).g2w = function () {
  return this.scale;
};
protoOf(ModelTransform).z2a = function () {
  var tmp0_elvis_lhs = this.position;
  var tmp = tmp0_elvis_lhs == null ? Companion_getInstance_81().ZERO : tmp0_elvis_lhs;
  var tmp_0 = Companion_getInstance_74();
  var tmp1_elvis_lhs = this.rotation;
  return new Transform(tmp, tmp_0.fromEulerDegreesVector(tmp1_elvis_lhs == null ? Companion_getInstance_81().ZERO : tmp1_elvis_lhs));
};
protoOf(ModelTransform).applyInverse = function (aab) {
  var tmp0_elvis_lhs = this.scale;
  var scale = tmp0_elvis_lhs == null ? Companion_getInstance_81().ONE : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = this.position;
  var position = tmp1_elvis_lhs == null ? Companion_getInstance_81().ZERO : tmp1_elvis_lhs;
  var rotation = this.rotation;
  var cuboid = Companion_getInstance_127().fromAABB(aab);
  cuboid = cuboid.scale(new Vector(1 / scale.X, 1 / scale.Y, 1 / scale.Z));
  cuboid = cuboid.move(position.unaryMinus());
  if (!(rotation == null)) {
    cuboid = cuboid.rotate(Companion_getInstance_74().fromEulerDegreesVector(rotation).inverse());
  }
  return cuboid.axisAlignedBoundingBox;
};
protoOf(ModelTransform).applyTo = function (vo) {
  vo.setPosition(Companion_getInstance_81().ZERO);
  vo.setRotation(Companion_getInstance_74().q2b_1);
  var tmp0_safe_receiver = this.rotation;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.math.ModelTransform.applyTo.<anonymous>' call
    vo.setRotationEulerAngleDegrees(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = this.position;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.math.ModelTransform.applyTo.<anonymous>' call
    vo.setPosition(tmp1_safe_receiver);
  }
  var tmp2_safe_receiver = this.scale;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.math.ModelTransform.applyTo.<anonymous>' call
    vo.setScaleV(tmp2_safe_receiver);
  }
};
protoOf(ModelTransform).tf = function () {
  return this.position;
};
protoOf(ModelTransform).uf = function () {
  return this.rotation;
};
protoOf(ModelTransform).m1m = function () {
  return this.scale;
};
protoOf(ModelTransform).h2w = function (position, rotation, scale) {
  return new ModelTransform(position, rotation, scale);
};
protoOf(ModelTransform).copy = function (position, rotation, scale, $super) {
  position = position === VOID ? this.position : position;
  rotation = rotation === VOID ? this.rotation : rotation;
  scale = scale === VOID ? this.scale : scale;
  return this.h2w(position, rotation, scale);
};
protoOf(ModelTransform).toString = function () {
  return 'ModelTransform(position=' + toString(this.position) + ', rotation=' + toString(this.rotation) + ', scale=' + toString(this.scale) + ')';
};
protoOf(ModelTransform).hashCode = function () {
  var result = this.position == null ? 0 : this.position.hashCode();
  result = imul(result, 31) + (this.rotation == null ? 0 : this.rotation.hashCode()) | 0;
  result = imul(result, 31) + (this.scale == null ? 0 : this.scale.hashCode()) | 0;
  return result;
};
protoOf(ModelTransform).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ModelTransform))
    return false;
  var tmp0_other_with_cast = other instanceof ModelTransform ? other : THROW_CCE();
  if (!equals(this.position, tmp0_other_with_cast.position))
    return false;
  if (!equals(this.rotation, tmp0_other_with_cast.rotation))
    return false;
  if (!equals(this.scale, tmp0_other_with_cast.scale))
    return false;
  return true;
};
function Companion_71() {
  this.i2w_1 = 1.0E-4;
}
protoOf(Companion_71).createFromPoints = function (p1, p2, p3) {
  var point = p1.plus(p2).plus(p3).times(1.0 / 3.0);
  var a1 = p2.minus(p1);
  var a2 = p3.minus(p1);
  var normal = a1.cross(a2).normalize();
  return new Plane(point, normal);
};
var Companion_instance_71;
function Companion_getInstance_72() {
  return Companion_instance_71;
}
function Plane(pointInPlane, normal) {
  this.pointInPlane = pointInPlane;
  this.normal = normal;
}
protoOf(Plane).j2w = function () {
  return this.pointInPlane;
};
protoOf(Plane).f2i = function () {
  return this.normal;
};
protoOf(Plane).raycast = function (ray) {
  var tmp0_elvis_lhs = this.raycastDistance(ray);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var s = tmp;
  return new RaycastResult(ray.getPointAlongRay(s), this.normal);
};
protoOf(Plane).raycastDistance = function (ray) {
  var denominator = ray.direction.__timesOperatorKotlin(this.normal);
  if (denominator > 0)
    return null;
  // Inline function 'kotlin.math.absoluteValue' call
  if (Math.abs(denominator) < Companion_instance_71.i2w_1)
    return null;
  var s = this.pointInPlane.minus(ray.origin).__timesOperatorKotlin(this.normal) * (1.0 / denominator);
  if (s < 0)
    return null;
  return s;
};
protoOf(Plane).k2w = function (point, epsilon) {
  var diff = point.minus(this.pointInPlane);
  // Inline function 'kotlin.math.abs' call
  var x = diff.dot(this.normal);
  return Math.abs(x) <= epsilon;
};
protoOf(Plane).contains = function (point, epsilon, $super) {
  epsilon = epsilon === VOID ? 1.0 : epsilon;
  return this.k2w(point, epsilon);
};
protoOf(Plane).projectOnPlane = function (vectorToProject) {
  return vectorToProject.minus(times(vectorToProject.dot(this.normal), this.normal));
};
protoOf(Plane).tf = function () {
  return this.pointInPlane;
};
protoOf(Plane).uf = function () {
  return this.normal;
};
protoOf(Plane).l2w = function (pointInPlane, normal) {
  return new Plane(pointInPlane, normal);
};
protoOf(Plane).copy = function (pointInPlane, normal, $super) {
  pointInPlane = pointInPlane === VOID ? this.pointInPlane : pointInPlane;
  normal = normal === VOID ? this.normal : normal;
  return this.l2w(pointInPlane, normal);
};
protoOf(Plane).toString = function () {
  return 'Plane(pointInPlane=' + this.pointInPlane.toString() + ', normal=' + this.normal.toString() + ')';
};
protoOf(Plane).hashCode = function () {
  var result = this.pointInPlane.hashCode();
  result = imul(result, 31) + this.normal.hashCode() | 0;
  return result;
};
protoOf(Plane).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Plane))
    return false;
  var tmp0_other_with_cast = other instanceof Plane ? other : THROW_CCE();
  if (!this.pointInPlane.equals(tmp0_other_with_cast.pointInPlane))
    return false;
  if (!this.normal.equals(tmp0_other_with_cast.normal))
    return false;
  return true;
};
function Companion_72() {
}
protoOf(Companion_72).createPolygonAndCalculateNormal = function (vertices) {
  // Inline function 'kotlin.collections.count' call
  if (vertices.length < 3) {
    return null;
  }
  var normal = Companion_getInstance_129().a2i(vertices);
  return new Polygon(vertices, normal);
};
var Companion_instance_72;
function Companion_getInstance_73() {
  return Companion_instance_72;
}
function Polygon(vertices, normal) {
  this.vertices = vertices;
  this.normal = normal;
}
protoOf(Polygon).d2i = function () {
  return this.vertices;
};
protoOf(Polygon).f2i = function () {
  return this.normal;
};
protoOf(Polygon).validateCoplanarPoints = function () {
  var firstDirection = this.vertices[1].minus(this.vertices[0]);
  var inductionVariable = 2;
  // Inline function 'kotlin.collections.count' call
  var last = this.vertices.length;
  if (inductionVariable < last)
    do {
      var vertexIndex = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var currentDirection = this.vertices[vertexIndex].minus(this.vertices[0]);
      var currentNormal = firstDirection.cross(currentDirection).normalize();
      // Inline function 'kotlin.math.abs' call
      var x = currentNormal.__timesOperatorKotlin(this.normal);
      var tmp$ret$1 = Math.abs(x);
      if (!almostEquals(tmp$ret$1, 1.0)) {
        return false;
      }
    }
     while (inductionVariable < last);
  return true;
};
protoOf(Polygon).raycast = function (ray) {
  var polygonPlane = new Plane(this.vertices[0], this.normal);
  var hit = polygonPlane.raycast(ray);
  var hitPoint = hit == null ? null : hit.point;
  var tmp;
  if (hitPoint == null) {
    tmp = hit;
  } else if (almostEquals(closestOnEdge(hitPoint, this.vertices).distanceTo(hitPoint), 0.0, 1.0E-4) || Companion_getInstance_129().pointInPolygon(hitPoint, this.vertices, this.normal)) {
    tmp = hit;
  } else {
    tmp = null;
  }
  return tmp;
};
protoOf(Polygon).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof Polygon))
    THROW_CCE();
  if (!contentEquals(this.vertices, other.vertices))
    return false;
  if (!this.normal.equals(other.normal))
    return false;
  return true;
};
protoOf(Polygon).hashCode = function () {
  var result = contentHashCode(this.vertices);
  result = imul(31, result) + this.normal.hashCode() | 0;
  return result;
};
protoOf(Polygon).tf = function () {
  return this.vertices;
};
protoOf(Polygon).uf = function () {
  return this.normal;
};
protoOf(Polygon).m2w = function (vertices, normal) {
  return new Polygon(vertices, normal);
};
protoOf(Polygon).copy = function (vertices, normal, $super) {
  vertices = vertices === VOID ? this.vertices : vertices;
  normal = normal === VOID ? this.normal : normal;
  return this.m2w(vertices, normal);
};
protoOf(Polygon).toString = function () {
  return 'Polygon(vertices=' + toString_0(this.vertices) + ', normal=' + this.normal.toString() + ')';
};
function Quaternion_init_$Init$(w, x, y, z, $this) {
  Quaternion.call($this, w, x, y, z, false);
  return $this;
}
function fromCoefficients(w, x, y, z) {
  return Quaternion_init_$Init$(w, x, y, z, objectCreate(protoOf(Quaternion)));
}
function toRotationMatrix($this) {
  var te = new Float64Array(16);
  var x2 = $this.x + $this.x;
  var y2 = $this.y + $this.y;
  var z2 = $this.z + $this.z;
  var xx = $this.x * x2;
  var xy = $this.x * y2;
  var xz = $this.x * z2;
  var yy = $this.y * y2;
  var yz = $this.y * z2;
  var zz = $this.z * z2;
  var wx = $this.w * x2;
  var wy = $this.w * y2;
  var wz = $this.w * z2;
  te[0] = 1 - (yy + zz);
  te[1] = xy + wz;
  te[2] = xz - wy;
  te[5] = 1 - (xx + zz);
  te[8] = xz + wy;
  te[9] = yz - wx;
  te[10] = 1 - (xx + yy);
  return te;
}
function Companion_73() {
  Companion_instance_73 = this;
  this.q2b_1 = new Quaternion(1.0, 0.0, 0.0, 0.0, true);
  this.r2b_1 = 2 * 3.141592653589793;
  this.s2b_1 = 180.0 / 3.141592653589793;
  this.t2b_1 = this.r2b_1 / 360.0;
}
protoOf(Companion_73).n2w = function () {
  return this.q2b_1;
};
protoOf(Companion_73).o2w = function () {
  return this.r2b_1;
};
protoOf(Companion_73).p2w = function () {
  return this.s2b_1;
};
protoOf(Companion_73).q2w = function () {
  return this.t2b_1;
};
protoOf(Companion_73).r2w = function (q1) {
  var q = q1;
  if (q.w > 1)
    q = q.normalize();
  // Inline function 'kotlin.math.acos' call
  var x = q.w;
  var tmp$ret$0 = Math.acos(x);
  var angle = new Radians(2 * tmp$ret$0);
  // Inline function 'kotlin.math.sqrt' call
  var x_0 = 1 - q.w * q.w;
  var s = Math.sqrt(x_0);
  var tmp;
  if (s < 0.001) {
    var x_1 = q.x;
    var y = q.y;
    var z = q.z;
    tmp = new AxisAngle(new Vector(x_1, y, z), angle);
  } else {
    var x_2 = q.x / s;
    var y_0 = q.y / s;
    var z_0 = q.z / s;
    tmp = new AxisAngle(new Vector(x_2, y_0, z_0), angle);
  }
  return tmp;
};
protoOf(Companion_73).p2v = function (lookDirection, up) {
  var backward = lookDirection.__timesIntForKotlin(-1);
  var backwardLengthSq = backward.dot(backward);
  var upLengthSq = up.dot(up);
  // Inline function 'kotlin.math.sqrt' call
  var tmp$ret$0 = Math.sqrt(backwardLengthSq);
  var backwardRsqrt = backward.times(1.0 / tmp$ret$0);
  // Inline function 'kotlin.math.sqrt' call
  var tmp$ret$1 = Math.sqrt(upLengthSq);
  var upRsqrt = up.times(1.0 / tmp$ret$1);
  var t = upRsqrt.cross(backward).normalize();
  var tLengthSq = t.dot(t);
  // Inline function 'kotlin.math.sqrt' call
  var tmp$ret$2 = Math.sqrt(tLengthSq);
  var tRsqrt = t.times(1.0 / tmp$ret$2);
  // Inline function 'kotlin.math.min' call
  // Inline function 'kotlin.math.min' call
  var a = Math.min(backwardLengthSq, upLengthSq);
  var mn = Math.min(a, tLengthSq);
  // Inline function 'kotlin.math.max' call
  // Inline function 'kotlin.math.max' call
  var a_0 = Math.max(backwardLengthSq, upLengthSq);
  var mx = Math.max(a_0, tLengthSq);
  var accept = mn > 1.0E-35 && mx < 1.0E35 && isFinite(backwardLengthSq) && isFinite(upLengthSq) && isFinite(tLengthSq);
  if (accept) {
    var crossT = backwardRsqrt.cross(t);
    return this.s2v(tRsqrt, crossT, backwardRsqrt.unaryMinus());
  } else {
    return this.q2b_1;
  }
};
protoOf(Companion_73).fromLookDirection$default = function (lookDirection, up, $super) {
  up = up === VOID ? Companion_getInstance_81().UP : up;
  return $super === VOID ? this.p2v(lookDirection, up) : $super.p2v.call(this, lookDirection, up);
};
protoOf(Companion_73).r2v = function (lookDirection, up) {
  var t = lookDirection.cross(up).normalize();
  var crossT = t.cross(lookDirection);
  return this.s2v(t, crossT, lookDirection);
};
protoOf(Companion_73).fromLookDirectionUnsafe$default = function (lookDirection, up, $super) {
  up = up === VOID ? Companion_getInstance_81().UP : up;
  return $super === VOID ? this.r2v(lookDirection, up) : $super.r2v.call(this, lookDirection, up);
};
protoOf(Companion_73).s2v = function (right, up, forward) {
  var m00 = right.X;
  var m10 = right.Y;
  var m20 = right.Z;
  var m01 = up.X;
  var m11 = up.Y;
  var m21 = up.Z;
  var m02 = -forward.X;
  var m12 = -forward.Y;
  var m22 = -forward.Z;
  var trace = m00 + m11 + m22;
  if (trace > 0) {
    // Inline function 'kotlin.math.sqrt' call
    var x = trace + 1.0;
    var S = Math.sqrt(x) * 2;
    var qw = 0.25 * S;
    var qx = (m21 - m12) / S;
    var qy = (m02 - m20) / S;
    var qz = (m10 - m01) / S;
    return fromCoefficients(qw, qx, qy, qz).normalize();
  } else if (!!(m00 > m11 & m00 > m22)) {
    // Inline function 'kotlin.math.sqrt' call
    var x_0 = 1.0 + m00 - m11 - m22;
    var S_0 = Math.sqrt(x_0) * 2;
    var qw_0 = (m21 - m12) / S_0;
    var qx_0 = 0.25 * S_0;
    var qy_0 = (m01 + m10) / S_0;
    var qz_0 = (m02 + m20) / S_0;
    return fromCoefficients(qw_0, qx_0, qy_0, qz_0).normalize();
  } else if (m11 > m22) {
    // Inline function 'kotlin.math.sqrt' call
    var x_1 = 1.0 + m11 - m00 - m22;
    var S_1 = Math.sqrt(x_1) * 2;
    var qw_1 = (m02 - m20) / S_1;
    var qx_1 = (m01 + m10) / S_1;
    var qy_1 = 0.25 * S_1;
    var qz_1 = (m12 + m21) / S_1;
    return fromCoefficients(qw_1, qx_1, qy_1, qz_1).normalize();
  } else {
    // Inline function 'kotlin.math.sqrt' call
    var x_2 = 1.0 + m22 - m00 - m11;
    var S_2 = Math.sqrt(x_2) * 2;
    var qw_2 = (m10 - m01) / S_2;
    var qx_2 = (m02 + m20) / S_2;
    var qy_2 = (m12 + m21) / S_2;
    var qz_2 = 0.25 * S_2;
    return fromCoefficients(qw_2, qx_2, qy_2, qz_2).normalize();
  }
};
protoOf(Companion_73).n2v = function (axis, angle) {
  if (axis.equals(Companion_getInstance_81().ZERO) || angle.value === 0.0)
    return this.q2b_1;
  var normalizedAxis = axis.normalize();
  // Inline function 'kotlin.math.sin' call
  var x = angle.value / 2;
  var s = Math.sin(x);
  var x_0 = normalizedAxis.X * s;
  var y = normalizedAxis.Y * s;
  var z = normalizedAxis.Z * s;
  // Inline function 'kotlin.math.cos' call
  var x_1 = angle.value / 2;
  var w = Math.cos(x_1);
  return fromCoefficients(w, x_0, y, z).normalize();
};
protoOf(Companion_73).fromEulerDegreesVector = function (angles) {
  return this.v2v(new Radians(angles.X * this.t2b_1), new Radians(angles.Y * this.t2b_1), new Radians(angles.Z * this.t2b_1));
};
protoOf(Companion_73).s2w = function (xAngle, yAngle, zAngle) {
  return this.v2v(xAngle.toRadian(), yAngle.toRadian(), zAngle.toRadian());
};
protoOf(Companion_73).fromEulerDegrees$default = function (xAngle, yAngle, zAngle, $super) {
  xAngle = xAngle === VOID ? new Degrees(0.0) : xAngle;
  yAngle = yAngle === VOID ? new Degrees(0.0) : yAngle;
  zAngle = zAngle === VOID ? new Degrees(0.0) : zAngle;
  return $super === VOID ? this.s2w(xAngle, yAngle, zAngle) : $super.s2w.call(this, xAngle, yAngle, zAngle);
};
protoOf(Companion_73).fromEulerDegreesRadians = function (radians) {
  return this.v2v(new Radians(radians.X), new Radians(radians.Y), new Radians(radians.Z));
};
protoOf(Companion_73).v2v = function (xAngle, yAngle, zAngle) {
  // Inline function 'kotlin.math.cos' call
  var x = xAngle.value / 2;
  var c1 = Math.cos(x);
  // Inline function 'kotlin.math.cos' call
  var x_0 = yAngle.value / 2;
  var c2 = Math.cos(x_0);
  // Inline function 'kotlin.math.cos' call
  var x_1 = zAngle.value / 2;
  var c3 = Math.cos(x_1);
  // Inline function 'kotlin.math.sin' call
  var x_2 = xAngle.value / 2;
  var s1 = Math.sin(x_2);
  // Inline function 'kotlin.math.sin' call
  var x_3 = yAngle.value / 2;
  var s2 = Math.sin(x_3);
  // Inline function 'kotlin.math.sin' call
  var x_4 = zAngle.value / 2;
  var s3 = Math.sin(x_4);
  var x_5 = s1 * c2 * c3 + c1 * s2 * s3;
  var y = c1 * s2 * c3 - s1 * c2 * s3;
  var z = c1 * c2 * s3 - s1 * s2 * c3;
  var w = c1 * c2 * c3 + s1 * s2 * s3;
  return fromCoefficients(w, x_5, y, z).normalize();
};
protoOf(Companion_73).fromEuler$default = function (xAngle, yAngle, zAngle, $super) {
  xAngle = xAngle === VOID ? new Radians(0.0) : xAngle;
  yAngle = yAngle === VOID ? new Radians(0.0) : yAngle;
  zAngle = zAngle === VOID ? new Radians(0.0) : zAngle;
  return $super === VOID ? this.v2v(xAngle, yAngle, zAngle) : $super.v2v.call(this, xAngle, yAngle, zAngle);
};
protoOf(Companion_73).z18 = function () {
  return $serializer_getInstance_4();
};
var Companion_instance_73;
function Companion_getInstance_74() {
  if (Companion_instance_73 == null)
    new Companion_73();
  return Companion_instance_73;
}
function $serializer_4() {
  $serializer_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Quaternion', this, 5);
  tmp0_serialDesc.lw('w', false);
  tmp0_serialDesc.lw('x', false);
  tmp0_serialDesc.lw('y', false);
  tmp0_serialDesc.lw('z', false);
  tmp0_serialDesc.lw('isIdentity', true);
  this.t2w_1 = tmp0_serialDesc;
}
protoOf($serializer_4).u2w = function (encoder, value) {
  var tmp0_desc = this.t2w_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.oq(tmp0_desc, 0, value.w);
  tmp1_output.oq(tmp0_desc, 1, value.x);
  tmp1_output.oq(tmp0_desc, 2, value.y);
  tmp1_output.oq(tmp0_desc, 3, value.z);
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.isIdentity === (value.w === 1.0 && value.x === 0.0 && value.y === 0.0 && value.z === 0.0))) {
    tmp1_output.iq(tmp0_desc, 4, value.isIdentity);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_4).ul = function (encoder, value) {
  return this.u2w(encoder, value instanceof Quaternion ? value : THROW_CCE());
};
protoOf($serializer_4).vl = function (decoder) {
  var tmp0_desc = this.t2w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = 0.0;
  var tmp8_local4 = false;
  var tmp10_input = decoder.bp(tmp0_desc);
  if (tmp10_input.rp()) {
    tmp4_local0 = tmp10_input.jp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.jp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.jp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.jp(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.dp(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.jp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.jp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.jp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.jp(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.dp(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.cp(tmp0_desc);
  return Quaternion_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_4).tl = function () {
  return this.t2w_1;
};
protoOf($serializer_4).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), BooleanSerializer_getInstance()];
};
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 == null)
    new $serializer_4();
  return $serializer_instance_4;
}
function copy($this, w, x, y, z, normalized) {
  return new Quaternion(w, x, y, z, normalized);
}
function copy$default($this, w, x, y, z, normalized, $super) {
  w = w === VOID ? $this.w : w;
  x = x === VOID ? $this.x : x;
  y = y === VOID ? $this.y : y;
  z = z === VOID ? $this.z : z;
  normalized = normalized === VOID ? $this.c2w_1 : normalized;
  return copy($this, w, x, y, z, normalized);
}
function Quaternion_init_$Init$_0(seen0, w, x, y, z, isIdentity, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_4().t2w_1);
  }
  $this.w = w;
  $this.x = x;
  $this.y = y;
  $this.z = z;
  $this.c2w_1 = false;
  if (0 === (seen0 & 16))
    $this.isIdentity = ($this.w === 1.0 && $this.x === 0.0 && $this.y === 0.0 && $this.z === 0.0);
  else
    $this.isIdentity = isIdentity;
  return $this;
}
function Quaternion_init_$Create$(seen0, w, x, y, z, isIdentity, serializationConstructorMarker) {
  return Quaternion_init_$Init$_0(seen0, w, x, y, z, isIdentity, serializationConstructorMarker, objectCreate(protoOf(Quaternion)));
}
function get_IDENTITY() {
  return Companion_getInstance_74().q2b_1;
}
function get_PI2() {
  return Companion_getInstance_74().r2b_1;
}
function get_RADIANS_TO_DEGREES() {
  return Companion_getInstance_74().s2b_1;
}
function get_PI2_DIV_360() {
  return Companion_getInstance_74().t2b_1;
}
function toAxisAngle(q1) {
  return Companion_getInstance_74().r2w(q1);
}
function fromLookDirection(lookDirection, up) {
  return Companion_getInstance_74().p2v(lookDirection, up);
}
function fromLookDirection_0(lookDirection, up, $super) {
  up = up === VOID ? Companion_getInstance_81().UP : up;
  return fromLookDirection(lookDirection, up);
}
function fromLookDirectionUnsafe(lookDirection, up) {
  return Companion_getInstance_74().r2v(lookDirection, up);
}
function fromLookDirectionUnsafe_0(lookDirection, up, $super) {
  up = up === VOID ? Companion_getInstance_81().UP : up;
  return fromLookDirectionUnsafe(lookDirection, up);
}
function quaternionFromBaseVectors_0(right, up, forward) {
  return Companion_getInstance_74().s2v(right, up, forward);
}
function fromAxisAngle(axis, angle) {
  return Companion_getInstance_74().n2v(axis, angle);
}
function fromEulerDegreesVector(angles) {
  return Companion_getInstance_74().fromEulerDegreesVector(angles);
}
function fromEulerDegrees(xAngle, yAngle, zAngle) {
  return Companion_getInstance_74().s2w(xAngle, yAngle, zAngle);
}
function fromEulerDegrees_0(xAngle, yAngle, zAngle, $super) {
  xAngle = xAngle === VOID ? new Degrees(0.0) : xAngle;
  yAngle = yAngle === VOID ? new Degrees(0.0) : yAngle;
  zAngle = zAngle === VOID ? new Degrees(0.0) : zAngle;
  return fromEulerDegrees(xAngle, yAngle, zAngle);
}
function fromEulerDegreesRadians(radians) {
  return Companion_getInstance_74().fromEulerDegreesRadians(radians);
}
function fromEuler(xAngle, yAngle, zAngle) {
  return Companion_getInstance_74().v2v(xAngle, yAngle, zAngle);
}
function fromEuler_0(xAngle, yAngle, zAngle, $super) {
  xAngle = xAngle === VOID ? new Radians(0.0) : xAngle;
  yAngle = yAngle === VOID ? new Radians(0.0) : yAngle;
  zAngle = zAngle === VOID ? new Radians(0.0) : zAngle;
  return fromEuler(xAngle, yAngle, zAngle);
}
function Quaternion$toEuler$lambda(value, min, max) {
  // Inline function 'kotlin.math.max' call
  // Inline function 'kotlin.math.min' call
  var b = Math.min(max, value);
  return Math.max(min, b);
}
function Quaternion(w, x, y, z, normalized) {
  Companion_getInstance_74();
  normalized = normalized === VOID ? false : normalized;
  this.w = w;
  this.x = x;
  this.y = y;
  this.z = z;
  this.c2w_1 = normalized;
  this.isIdentity = (this.w === 1.0 && this.x === 0.0 && this.y === 0.0 && this.z === 0.0);
}
protoOf(Quaternion).v2w = function () {
  return this.w;
};
protoOf(Quaternion).w2w = function () {
  return this.x;
};
protoOf(Quaternion).x2w = function () {
  return this.y;
};
protoOf(Quaternion).y2w = function () {
  return this.z;
};
protoOf(Quaternion).times = function (q) {
  var tmp;
  if (this.isIdentity) {
    tmp = q;
  } else if (q.isIdentity) {
    tmp = this;
  } else {
    var q1 = q;
    var q2 = this;
    var x = q1.x * q2.w + q1.y * q2.z - q1.z * q2.y + q1.w * q2.x;
    var y = -q1.x * q2.z + q1.y * q2.w + q1.z * q2.x + q1.w * q2.y;
    var z = q1.x * q2.y - q1.y * q2.x + q1.z * q2.w + q1.w * q2.z;
    var w = -q1.x * q2.x - q1.y * q2.y - q1.z * q2.z + q1.w * q2.w;
    tmp = fromCoefficients(w, x, y, z).normalize();
  }
  return tmp;
};
protoOf(Quaternion).conjugate = function () {
  return fromCoefficients(this.w, -this.x, -this.y, -this.z);
};
protoOf(Quaternion).magnitude = function () {
  // Inline function 'kotlin.math.sqrt' call
  var x = this.w * this.w + this.x * this.x + this.y * this.y + this.z * this.z;
  return Math.sqrt(x);
};
protoOf(Quaternion).normalize = function () {
  var tmp;
  if (this.c2w_1) {
    tmp = this;
  } else {
    var magnitude = this.magnitude();
    tmp = new Quaternion(this.w / magnitude, this.x / magnitude, this.y / magnitude, this.z / magnitude, true);
  }
  return tmp;
};
protoOf(Quaternion).div = function (scalar) {
  return fromCoefficients(this.w / scalar, this.x / scalar, this.y / scalar, this.z / scalar);
};
protoOf(Quaternion).inverse = function () {
  var tmp;
  if (this.isIdentity) {
    tmp = this;
  } else {
    tmp = this.conjugate().div(this.magnitude());
  }
  return tmp;
};
protoOf(Quaternion).unaryMinus = function () {
  return this.inverse();
};
protoOf(Quaternion).z2w = function (floatingPoints) {
  var w2 = round(floatingPoints * this.w) / floatingPoints;
  var x2 = round(floatingPoints * this.x) / floatingPoints;
  var y2 = round(floatingPoints * this.y) / floatingPoints;
  var z2 = round(floatingPoints * this.z) / floatingPoints;
  return fromCoefficients(w2 === -0.0 ? 0.0 : w2, x2 === -0.0 ? 0.0 : x2, y2 === -0.0 ? 0.0 : y2, z2 === -0.0 ? 0.0 : z2);
};
protoOf(Quaternion).round = function (floatingPoints, $super) {
  floatingPoints = floatingPoints === VOID ? 1000.0 : floatingPoints;
  return this.z2w(floatingPoints);
};
protoOf(Quaternion).toEulerDegrees = function () {
  var radians = this.toEuler();
  return new Vector(radians.X * Companion_getInstance_74().s2b_1, radians.Y * Companion_getInstance_74().s2b_1, radians.Z * Companion_getInstance_74().s2b_1);
};
protoOf(Quaternion).a2x = function () {
  return this.toEulerDegrees();
};
protoOf(Quaternion).toEuler = function () {
  var clamp = Quaternion$toEuler$lambda;
  var te = toRotationMatrix(this);
  var m11 = te[0];
  var m13 = te[8];
  var m21 = te[1];
  var m22 = te[5];
  var m23 = te[9];
  var m31 = te[2];
  var m33 = te[10];
  // Inline function 'kotlin.math.asin' call
  var x = -clamp(m23, -1.0, 1.0);
  var eulerX = Math.asin(x);
  var eulerZ;
  var eulerY;
  // Inline function 'kotlin.math.abs' call
  if (Math.abs(m23) < 0.9999999) {
    // Inline function 'kotlin.math.atan2' call
    eulerY = Math.atan2(m13, m33);
    // Inline function 'kotlin.math.atan2' call
    eulerZ = Math.atan2(m21, m22);
  } else {
    // Inline function 'kotlin.math.atan2' call
    var y = -m31;
    eulerY = Math.atan2(y, m11);
    eulerZ = 0.0;
  }
  return new Vector(eulerX, eulerY, eulerZ);
};
protoOf(Quaternion).toString = function () {
  var euler = this.toEulerDegrees();
  return 'Euler(' + euler.X + '\xB0, ' + euler.Y + '\xB0, ' + euler.Z + '\xB0) Q:(' + this.w + ',' + this.x + ',' + this.y + ',' + this.z + ')';
};
protoOf(Quaternion).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof Quaternion))
    THROW_CCE();
  return this.almostEquals(other);
};
protoOf(Quaternion).b2x = function (other, epsilon) {
  var w0 = this.tf();
  var x0 = this.uf();
  var y0 = this.m1m();
  var z0 = this.n1m();
  var w1 = other.tf();
  var x1 = other.uf();
  var y1 = other.m1m();
  var z1 = other.n1m();
  var diff = (w0 < w1 ? w1 - w0 : w0 - w1) + (x0 < x1 ? x1 - x0 : x0 - x1) + (y0 < y1 ? y1 - y0 : y0 - y1) + (z0 < z1 ? z1 - z0 : z0 - z1);
  if (diff < epsilon)
    return true;
  w1 = -w1;
  x1 = -x1;
  y1 = -y1;
  z1 = -z1;
  diff = (w0 < w1 ? w1 - w0 : w0 - w1) + (x0 < x1 ? x1 - x0 : x0 - x1) + (y0 < y1 ? y1 - y0 : y0 - y1) + (z0 < z1 ? z1 - z0 : z0 - z1);
  if (diff < epsilon)
    return true;
  return false;
};
protoOf(Quaternion).almostEquals = function (other, epsilon, $super) {
  epsilon = epsilon === VOID ? 1.0E-7 : epsilon;
  return this.b2x(other, epsilon);
};
protoOf(Quaternion).hashCode = function () {
  return 0;
};
protoOf(Quaternion).c2x = function () {
  return this.isIdentity;
};
protoOf(Quaternion).tf = function () {
  return this.w;
};
protoOf(Quaternion).uf = function () {
  return this.x;
};
protoOf(Quaternion).m1m = function () {
  return this.y;
};
protoOf(Quaternion).n1m = function () {
  return this.z;
};
function Radians(value) {
  this.value = value;
}
protoOf(Radians).c2 = function () {
  return this.value;
};
protoOf(Radians).toDegree = function () {
  return new Degrees(this.value / 3.141592653589793 * 180);
};
protoOf(Radians).tf = function () {
  return this.value;
};
protoOf(Radians).s2u = function (value) {
  return new Radians(value);
};
protoOf(Radians).copy = function (value, $super) {
  value = value === VOID ? this.value : value;
  return this.s2u(value);
};
protoOf(Radians).toString = function () {
  return 'Radians(value=' + this.value + ')';
};
protoOf(Radians).hashCode = function () {
  return getNumberHashCode(this.value);
};
protoOf(Radians).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Radians))
    return false;
  var tmp0_other_with_cast = other instanceof Radians ? other : THROW_CCE();
  if (!equals(this.value, tmp0_other_with_cast.value))
    return false;
  return true;
};
function RelativeBoxOffset(relativeTo, offsetVector) {
  offsetVector = offsetVector === VOID ? Companion_getInstance_81().ZERO : offsetVector;
  this.relativeTo = relativeTo;
  this.offsetVector = offsetVector;
}
protoOf(RelativeBoxOffset).d2x = function () {
  return this.relativeTo;
};
protoOf(RelativeBoxOffset).e2x = function () {
  return this.offsetVector;
};
protoOf(RelativeBoxOffset).applyToBox = function (aabb) {
  var tmp0_subject = this.relativeTo.x;
  var tmp = tmp0_subject === Companion_instance_74.f2x_1 ? aabb.min.X + this.offsetVector.X : tmp0_subject === Companion_instance_74.h2x_1 ? aabb.max.X + this.offsetVector.X : this.offsetVector.X;
  var tmp1_subject = this.relativeTo.y;
  var tmp_0 = tmp1_subject === Companion_instance_75.k2x_1 ? aabb.max.Y + this.offsetVector.Y : tmp1_subject === Companion_instance_75.i2x_1 ? aabb.min.Y + this.offsetVector.Y : this.offsetVector.Y;
  var tmp2_subject = this.relativeTo.z;
  return new Vector(tmp, tmp_0, tmp2_subject === Companion_instance_76.l2x_1 ? aabb.min.Z + this.offsetVector.Z : tmp2_subject === Companion_instance_76.n2x_1 ? aabb.max.Z + this.offsetVector.Z : this.offsetVector.Z);
};
protoOf(RelativeBoxOffset).tf = function () {
  return this.relativeTo;
};
protoOf(RelativeBoxOffset).uf = function () {
  return this.offsetVector;
};
protoOf(RelativeBoxOffset).o2x = function (relativeTo, offsetVector) {
  return new RelativeBoxOffset(relativeTo, offsetVector);
};
protoOf(RelativeBoxOffset).copy = function (relativeTo, offsetVector, $super) {
  relativeTo = relativeTo === VOID ? this.relativeTo : relativeTo;
  offsetVector = offsetVector === VOID ? this.offsetVector : offsetVector;
  return this.o2x(relativeTo, offsetVector);
};
protoOf(RelativeBoxOffset).toString = function () {
  return 'RelativeBoxOffset(relativeTo=' + this.relativeTo.toString() + ', offsetVector=' + this.offsetVector.toString() + ')';
};
protoOf(RelativeBoxOffset).hashCode = function () {
  var result = this.relativeTo.hashCode();
  result = imul(result, 31) + this.offsetVector.hashCode() | 0;
  return result;
};
protoOf(RelativeBoxOffset).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RelativeBoxOffset))
    return false;
  var tmp0_other_with_cast = other instanceof RelativeBoxOffset ? other : THROW_CCE();
  if (!this.relativeTo.equals(tmp0_other_with_cast.relativeTo))
    return false;
  if (!this.offsetVector.equals(tmp0_other_with_cast.offsetVector))
    return false;
  return true;
};
function Companion_74() {
  this.f2x_1 = 0;
  this.g2x_1 = 1;
  this.h2x_1 = 2;
}
protoOf(Companion_74).p2x = function () {
  return this.f2x_1;
};
protoOf(Companion_74).q2x = function () {
  return this.g2x_1;
};
protoOf(Companion_74).r2x = function () {
  return this.h2x_1;
};
var Companion_instance_74;
function Companion_getInstance_75() {
  return Companion_instance_74;
}
function get_LEFT() {
  return Companion_instance_74.f2x_1;
}
function get_CENTER() {
  return Companion_instance_74.g2x_1;
}
function get_RIGHT() {
  return Companion_instance_74.h2x_1;
}
function RelationOriginAlongX() {
}
function Companion_75() {
  this.i2x_1 = 0;
  this.j2x_1 = 1;
  this.k2x_1 = 2;
}
protoOf(Companion_75).s2x = function () {
  return this.i2x_1;
};
protoOf(Companion_75).q2x = function () {
  return this.j2x_1;
};
protoOf(Companion_75).t2x = function () {
  return this.k2x_1;
};
var Companion_instance_75;
function Companion_getInstance_76() {
  return Companion_instance_75;
}
function get_BOTTOM() {
  return Companion_instance_75.i2x_1;
}
function get_CENTER_0() {
  return Companion_instance_75.j2x_1;
}
function get_TOP() {
  return Companion_instance_75.k2x_1;
}
function RelationOriginAlongY() {
}
function Companion_76() {
  this.l2x_1 = 0;
  this.m2x_1 = 1;
  this.n2x_1 = 2;
}
protoOf(Companion_76).u2x = function () {
  return this.l2x_1;
};
protoOf(Companion_76).q2x = function () {
  return this.m2x_1;
};
protoOf(Companion_76).v2x = function () {
  return this.n2x_1;
};
var Companion_instance_76;
function Companion_getInstance_77() {
  return Companion_instance_76;
}
function get_BACK() {
  return Companion_instance_76.l2x_1;
}
function get_CENTER_1() {
  return Companion_instance_76.m2x_1;
}
function get_FRONT() {
  return Companion_instance_76.n2x_1;
}
function RelationOriginAlongZ() {
}
function Companion_77() {
}
protoOf(Companion_77).z18 = function () {
  return $serializer_getInstance_5();
};
var Companion_instance_77;
function Companion_getInstance_78() {
  return Companion_instance_77;
}
function $serializer_5() {
  $serializer_instance_5 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.RelationOrigin', this, 3);
  tmp0_serialDesc.lw('x', true);
  tmp0_serialDesc.lw('y', true);
  tmp0_serialDesc.lw('z', true);
  this.w2x_1 = tmp0_serialDesc;
}
protoOf($serializer_5).x2x = function (encoder, value) {
  var tmp0_desc = this.w2x_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.x === Companion_instance_74.g2x_1)) {
    tmp1_output.lq(tmp0_desc, 0, value.x);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.y === Companion_instance_75.j2x_1)) {
    tmp1_output.lq(tmp0_desc, 1, value.y);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.z === Companion_instance_76.m2x_1)) {
    tmp1_output.lq(tmp0_desc, 2, value.z);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_5).ul = function (encoder, value) {
  return this.x2x(encoder, value instanceof RelationOrigin ? value : THROW_CCE());
};
protoOf($serializer_5).vl = function (decoder) {
  var tmp0_desc = this.w2x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0;
  var tmp5_local1 = 0;
  var tmp6_local2 = 0;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.gp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.gp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.gp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.gp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.gp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.gp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return RelationOrigin_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_5).tl = function () {
  return this.w2x_1;
};
protoOf($serializer_5).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
};
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 == null)
    new $serializer_5();
  return $serializer_instance_5;
}
function RelationOrigin_init_$Init$(seen0, x, y, z, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_5().w2x_1);
  }
  if (0 === (seen0 & 1))
    $this.x = Companion_instance_74.g2x_1;
  else
    $this.x = x;
  if (0 === (seen0 & 2))
    $this.y = Companion_instance_75.j2x_1;
  else
    $this.y = y;
  if (0 === (seen0 & 4))
    $this.z = Companion_instance_76.m2x_1;
  else
    $this.z = z;
  return $this;
}
function RelationOrigin_init_$Create$(seen0, x, y, z, serializationConstructorMarker) {
  return RelationOrigin_init_$Init$(seen0, x, y, z, serializationConstructorMarker, objectCreate(protoOf(RelationOrigin)));
}
function RelationOrigin(x, y, z) {
  x = x === VOID ? Companion_instance_74.g2x_1 : x;
  y = y === VOID ? Companion_instance_75.j2x_1 : y;
  z = z === VOID ? Companion_instance_76.m2x_1 : z;
  this.x = x;
  this.y = y;
  this.z = z;
}
protoOf(RelationOrigin).w2w = function () {
  return this.x;
};
protoOf(RelationOrigin).x2w = function () {
  return this.y;
};
protoOf(RelationOrigin).y2w = function () {
  return this.z;
};
protoOf(RelationOrigin).toString = function () {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.arrayOf' call
  var tmp0_subject = this.x;
  var tmp = tmp0_subject === Companion_instance_74.f2x_1 ? 'left' : tmp0_subject === Companion_instance_74.h2x_1 ? 'right' : '';
  var tmp1_subject = this.y;
  var tmp_0 = tmp1_subject === Companion_instance_75.k2x_1 ? 'top' : tmp1_subject === Companion_instance_75.i2x_1 ? 'bottom' : '';
  var tmp2_subject = this.z;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = [tmp, tmp_0, tmp2_subject === Companion_instance_76.n2x_1 ? 'front' : tmp2_subject === Companion_instance_76.l2x_1 ? 'back' : ''];
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.math.RelationOrigin.toString.<anonymous>' call
    if (!(element === '')) {
      destination.h(element);
    }
  }
  return joinToString(destination, '-');
};
protoOf(RelationOrigin).tf = function () {
  return this.x;
};
protoOf(RelationOrigin).uf = function () {
  return this.y;
};
protoOf(RelationOrigin).m1m = function () {
  return this.z;
};
protoOf(RelationOrigin).y2x = function (x, y, z) {
  return new RelationOrigin(x, y, z);
};
protoOf(RelationOrigin).copy = function (x, y, z, $super) {
  x = x === VOID ? this.x : x;
  y = y === VOID ? this.y : y;
  z = z === VOID ? this.z : z;
  return this.y2x(x, y, z);
};
protoOf(RelationOrigin).hashCode = function () {
  var result = this.x;
  result = imul(result, 31) + this.y | 0;
  result = imul(result, 31) + this.z | 0;
  return result;
};
protoOf(RelationOrigin).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RelationOrigin))
    return false;
  var tmp0_other_with_cast = other instanceof RelationOrigin ? other : THROW_CCE();
  if (!(this.x === tmp0_other_with_cast.x))
    return false;
  if (!(this.y === tmp0_other_with_cast.y))
    return false;
  if (!(this.z === tmp0_other_with_cast.z))
    return false;
  return true;
};
function Size_init_$Init$(vector, $this) {
  Size.call($this, vector.X, vector.Y, vector.Z);
  return $this;
}
function SizeFromVector(vector) {
  return Size_init_$Init$(vector, objectCreate(protoOf(Size)));
}
function Companion_78() {
  Companion_instance_78 = this;
  this.NONE = new Size();
}
protoOf(Companion_78).h2h = function () {
  return this.NONE;
};
protoOf(Companion_78).z18 = function () {
  return $serializer_getInstance_6();
};
var Companion_instance_78;
function Companion_getInstance_79() {
  if (Companion_instance_78 == null)
    new Companion_78();
  return Companion_instance_78;
}
function $serializer_6() {
  $serializer_instance_6 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Size', this, 3);
  tmp0_serialDesc.lw('width', true);
  tmp0_serialDesc.lw('height', true);
  tmp0_serialDesc.lw('depth', true);
  this.z2x_1 = tmp0_serialDesc;
}
protoOf($serializer_6).a2y = function (encoder, value) {
  var tmp0_desc = this.z2x_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !equals(value.b2y_1, 0.0)) {
    tmp1_output.oq(tmp0_desc, 0, value.b2y_1);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !equals(value.c2y_1, 0.0)) {
    tmp1_output.oq(tmp0_desc, 1, value.c2y_1);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !equals(value.d2y_1, 0.0)) {
    tmp1_output.oq(tmp0_desc, 2, value.d2y_1);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_6).ul = function (encoder, value) {
  return this.a2y(encoder, value instanceof Size ? value : THROW_CCE());
};
protoOf($serializer_6).vl = function (decoder) {
  var tmp0_desc = this.z2x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp8_input = decoder.bp(tmp0_desc);
  if (tmp8_input.rp()) {
    tmp4_local0 = tmp8_input.jp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.jp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.jp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.jp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.jp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.jp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.cp(tmp0_desc);
  return Size_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_6).tl = function () {
  return this.z2x_1;
};
protoOf($serializer_6).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
};
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 == null)
    new $serializer_6();
  return $serializer_instance_6;
}
function Size_init_$Init$_0(seen0, width, height, depth, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_6().z2x_1);
  }
  if (0 === (seen0 & 1))
    $this.b2y_1 = 0.0;
  else
    $this.b2y_1 = width;
  if (0 === (seen0 & 2))
    $this.c2y_1 = 0.0;
  else
    $this.c2y_1 = height;
  if (0 === (seen0 & 4))
    $this.d2y_1 = 0.0;
  else
    $this.d2y_1 = depth;
  $this.vector = new Vector($this.b2y_1, $this.c2y_1, $this.d2y_1);
  return $this;
}
function Size_init_$Create$(seen0, width, height, depth, serializationConstructorMarker) {
  return Size_init_$Init$_0(seen0, width, height, depth, serializationConstructorMarker, objectCreate(protoOf(Size)));
}
function Size(width, height, depth) {
  Companion_getInstance_79();
  width = width === VOID ? 0.0 : width;
  height = height === VOID ? 0.0 : height;
  depth = depth === VOID ? 0.0 : depth;
  this.b2y_1 = width;
  this.c2y_1 = height;
  this.d2y_1 = depth;
  this.vector = new Vector(this.b2y_1, this.c2y_1, this.d2y_1);
}
protoOf(Size).t2u = function () {
  return this.b2y_1;
};
protoOf(Size).u2u = function () {
  return this.c2y_1;
};
protoOf(Size).v2u = function () {
  return this.d2y_1;
};
protoOf(Size).times = function (s) {
  return new Size(this.b2y_1 * s, this.c2y_1 * s, this.d2y_1 * s);
};
protoOf(Size).e2y = function () {
  return this.vector;
};
protoOf(Size).tf = function () {
  return this.b2y_1;
};
protoOf(Size).uf = function () {
  return this.c2y_1;
};
protoOf(Size).m1m = function () {
  return this.d2y_1;
};
protoOf(Size).f2y = function (width, height, depth) {
  return new Size(width, height, depth);
};
protoOf(Size).copy = function (width, height, depth, $super) {
  width = width === VOID ? this.b2y_1 : width;
  height = height === VOID ? this.c2y_1 : height;
  depth = depth === VOID ? this.d2y_1 : depth;
  return this.f2y(width, height, depth);
};
protoOf(Size).toString = function () {
  return 'Size(width=' + this.b2y_1 + ', height=' + this.c2y_1 + ', depth=' + this.d2y_1 + ')';
};
protoOf(Size).hashCode = function () {
  var result = getNumberHashCode(this.b2y_1);
  result = imul(result, 31) + getNumberHashCode(this.c2y_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.d2y_1) | 0;
  return result;
};
protoOf(Size).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Size))
    return false;
  var tmp0_other_with_cast = other instanceof Size ? other : THROW_CCE();
  if (!equals(this.b2y_1, tmp0_other_with_cast.b2y_1))
    return false;
  if (!equals(this.c2y_1, tmp0_other_with_cast.c2y_1))
    return false;
  if (!equals(this.d2y_1, tmp0_other_with_cast.d2y_1))
    return false;
  return true;
};
function Companion_79() {
  Companion_instance_79 = this;
  this.c1x_1 = new Transform(Companion_getInstance_81().ZERO, Companion_getInstance_74().q2b_1);
}
protoOf(Companion_79).n2w = function () {
  return this.c1x_1;
};
protoOf(Companion_79).z18 = function () {
  return $serializer_getInstance_7();
};
var Companion_instance_79;
function Companion_getInstance_80() {
  if (Companion_instance_79 == null)
    new Companion_79();
  return Companion_instance_79;
}
function $serializer_7() {
  $serializer_instance_7 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Transform', this, 2);
  tmp0_serialDesc.lw('position', false);
  tmp0_serialDesc.lw('rotation', true);
  this.g2y_1 = tmp0_serialDesc;
}
protoOf($serializer_7).h2y = function (encoder, value) {
  var tmp0_desc = this.g2y_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.sq(tmp0_desc, 0, $serializer_getInstance_8(), value.position);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !value.rotation.equals(Companion_getInstance_74().q2b_1)) {
    tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance_4(), value.rotation);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_7).ul = function (encoder, value) {
  return this.h2y(encoder, value instanceof Transform ? value : THROW_CCE());
};
protoOf($serializer_7).vl = function (decoder) {
  var tmp0_desc = this.g2y_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return Transform_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_7).tl = function () {
  return this.g2y_1;
};
protoOf($serializer_7).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_8(), $serializer_getInstance_4()];
};
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 == null)
    new $serializer_7();
  return $serializer_instance_7;
}
function Transform_init_$Init$(seen0, position, rotation, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_7().g2y_1);
  }
  $this.position = position;
  if (0 === (seen0 & 2))
    $this.rotation = Companion_getInstance_74().q2b_1;
  else
    $this.rotation = rotation;
  return $this;
}
function Transform_init_$Create$(seen0, position, rotation, serializationConstructorMarker) {
  return Transform_init_$Init$(seen0, position, rotation, serializationConstructorMarker, objectCreate(protoOf(Transform)));
}
function get_IDENTITY_0() {
  return Companion_getInstance_80().c1x_1;
}
function Transform(position, rotation) {
  Companion_getInstance_80();
  rotation = rotation === VOID ? Companion_getInstance_74().q2b_1 : rotation;
  this.position = position;
  this.rotation = rotation;
}
protoOf(Transform).f2w = function () {
  return this.position;
};
protoOf(Transform).m2g = function () {
  return this.rotation;
};
protoOf(Transform).i2y = function () {
  return this.transformVector(Companion_getInstance_81().FORWARD);
};
protoOf(Transform).j2y = function () {
  return this.transformVector(Companion_getInstance_81().UP);
};
protoOf(Transform).c2v = function () {
  return this.transformVector(Companion_getInstance_81().RIGHT);
};
protoOf(Transform).delta = function (other) {
  return new Transform(other.inverseTransformPosition(this.position), other.inverseTransformRotation(this.rotation));
};
protoOf(Transform).concatenate = function (next) {
  return new Transform(this.transformPosition(next.position), this.transformRotation(next.rotation));
};
protoOf(Transform).transformPosition = function (point) {
  return point.rotate(this.rotation).plus(this.position);
};
protoOf(Transform).transformVector = function (v) {
  return v.rotate(this.rotation);
};
protoOf(Transform).inverseTransformPosition = function (point) {
  return point.minus(this.position).rotate(this.rotation.unaryMinus());
};
protoOf(Transform).inverseTransformVector = function (v) {
  return v.rotate(this.rotation.unaryMinus());
};
protoOf(Transform).transformRotation = function (q) {
  return q.times(this.rotation);
};
protoOf(Transform).inverseTransformRotation = function (q) {
  return q.times(this.rotation.inverse());
};
protoOf(Transform).exactEquals = function (other) {
  return this.position.exact(other.position) && this.rotation.equals(other.rotation);
};
protoOf(Transform).k2y = function (other, epsilon) {
  var aPosition = this.position;
  var bPosition = other.position;
  var positionAlmostTheSame = aPosition.minus(bPosition).size < epsilon;
  var aRotation = this.rotation.toEuler();
  var bRotation = other.rotation.toEuler();
  var rotationAlmostTheSame = aRotation.minus(bRotation).size < epsilon;
  return positionAlmostTheSame && rotationAlmostTheSame;
};
protoOf(Transform).almostEquals = function (other, epsilon, $super) {
  epsilon = epsilon === VOID ? 0.001 : epsilon;
  return this.k2y(other, epsilon);
};
protoOf(Transform).inverse = function () {
  return new Transform(this.inverseTransformVector(this.position).unaryMinus(), this.rotation.inverse());
};
protoOf(Transform).tf = function () {
  return this.position;
};
protoOf(Transform).uf = function () {
  return this.rotation;
};
protoOf(Transform).l2y = function (position, rotation) {
  return new Transform(position, rotation);
};
protoOf(Transform).copy = function (position, rotation, $super) {
  position = position === VOID ? this.position : position;
  rotation = rotation === VOID ? this.rotation : rotation;
  return this.l2y(position, rotation);
};
protoOf(Transform).toString = function () {
  return 'Transform(position=' + this.position.toString() + ', rotation=' + this.rotation.toString() + ')';
};
protoOf(Transform).hashCode = function () {
  var result = this.position.hashCode();
  result = imul(result, 31) + this.rotation.hashCode() | 0;
  return result;
};
protoOf(Transform).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Transform))
    return false;
  var tmp0_other_with_cast = other instanceof Transform ? other : THROW_CCE();
  if (!this.position.equals(tmp0_other_with_cast.position))
    return false;
  if (!this.rotation.equals(tmp0_other_with_cast.rotation))
    return false;
  return true;
};
function get_zero() {
  _init_properties_Vector_kt__7ulyhp();
  return zero;
}
var zero;
function Vector_init_$Init$(xInt, yInt, zInt, $this) {
  Vector.call($this, xInt, yInt, zInt);
  return $this;
}
function __VectorIntConstructorKotlin(xInt, yInt, zInt) {
  return Vector_init_$Init$(xInt, yInt, zInt, objectCreate(protoOf(Vector)));
}
function Companion_80() {
  Companion_instance_80 = this;
  this.LEFT = __VectorIntConstructorKotlin(-1, 0, 0);
  this.RIGHT = __VectorIntConstructorKotlin(1, 0, 0);
  this.DOWN = __VectorIntConstructorKotlin(0, -1, 0);
  this.UP = __VectorIntConstructorKotlin(0, 1, 0);
  this.FORWARD = __VectorIntConstructorKotlin(0, 0, -1);
  this.BACK = __VectorIntConstructorKotlin(0, 0, 1);
  this.ZERO = __VectorIntConstructorKotlin(0, 0, 0);
  this.INFINITY = new Vector(Infinity, Infinity, Infinity);
  this.ONE = __VectorIntConstructorKotlin(1, 1, 1);
}
protoOf(Companion_80).p2x = function () {
  return this.LEFT;
};
protoOf(Companion_80).r2x = function () {
  return this.RIGHT;
};
protoOf(Companion_80).m2y = function () {
  return this.DOWN;
};
protoOf(Companion_80).n2y = function () {
  return this.UP;
};
protoOf(Companion_80).o2y = function () {
  return this.FORWARD;
};
protoOf(Companion_80).u2x = function () {
  return this.BACK;
};
protoOf(Companion_80).p2y = function () {
  return this.ZERO;
};
protoOf(Companion_80).q2y = function () {
  return this.INFINITY;
};
protoOf(Companion_80).i2h = function () {
  return this.ONE;
};
protoOf(Companion_80).z18 = function () {
  return $serializer_getInstance_8();
};
var Companion_instance_80;
function Companion_getInstance_81() {
  if (Companion_instance_80 == null)
    new Companion_80();
  return Companion_instance_80;
}
function $serializer_8() {
  $serializer_instance_8 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.math.Vector', this, 3);
  tmp0_serialDesc.lw('x', true);
  tmp0_serialDesc.lw('y', true);
  tmp0_serialDesc.lw('z', true);
  this.r2y_1 = tmp0_serialDesc;
}
protoOf($serializer_8).s2y = function (encoder, value) {
  var tmp0_desc = this.r2y_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !equals(value.X, 0.0)) {
    tmp1_output.oq(tmp0_desc, 0, value.X);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !equals(value.Y, 0.0)) {
    tmp1_output.oq(tmp0_desc, 1, value.Y);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !equals(value.Z, 0.0)) {
    tmp1_output.oq(tmp0_desc, 2, value.Z);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_8).ul = function (encoder, value) {
  return this.s2y(encoder, value instanceof Vector ? value : THROW_CCE());
};
protoOf($serializer_8).vl = function (decoder) {
  var tmp0_desc = this.r2y_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_input = decoder.bp(tmp0_desc);
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.jp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.jp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.jp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.jp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.jp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.jp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return Vector_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_8).tl = function () {
  return this.r2y_1;
};
protoOf($serializer_8).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
};
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 == null)
    new $serializer_8();
  return $serializer_instance_8;
}
function Vector_init_$Init$_0(seen0, X, Y, Z, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_8().r2y_1);
  }
  if (0 === (seen0 & 1))
    $this.X = 0.0;
  else
    $this.X = X;
  if (0 === (seen0 & 2))
    $this.Y = 0.0;
  else
    $this.Y = Y;
  if (0 === (seen0 & 4))
    $this.Z = 0.0;
  else
    $this.Z = Z;
  return $this;
}
function Vector_init_$Create$(seen0, X, Y, Z, serializationConstructorMarker) {
  return Vector_init_$Init$_0(seen0, X, Y, Z, serializationConstructorMarker, objectCreate(protoOf(Vector)));
}
function Vector(X, Y, Z) {
  Companion_getInstance_81();
  X = X === VOID ? 0.0 : X;
  Y = Y === VOID ? 0.0 : Y;
  Z = Z === VOID ? 0.0 : Z;
  this.X = X;
  this.Y = Y;
  this.Z = Z;
}
protoOf(Vector).t2y = function () {
  return this.X;
};
protoOf(Vector).u2y = function () {
  return this.Y;
};
protoOf(Vector).v2y = function () {
  return this.Z;
};
protoOf(Vector).toJson = function () {
  return '{' + toJson(this.X, 'x') + ',' + toJson(this.Y, 'y') + ', ' + toJson(this.Z, 'z') + '}';
};
protoOf(Vector).t2u = function () {
  return this.X;
};
protoOf(Vector).u2u = function () {
  return this.Y;
};
protoOf(Vector).v2u = function () {
  return this.Z;
};
protoOf(Vector).xxx = function () {
  return new Vector(this.X, this.X, this.X);
};
protoOf(Vector).xxy = function () {
  return new Vector(this.X, this.X, this.Y);
};
protoOf(Vector).xxz = function () {
  return new Vector(this.X, this.X, this.Z);
};
protoOf(Vector).xyx = function () {
  return new Vector(this.X, this.Y, this.X);
};
protoOf(Vector).xyy = function () {
  return new Vector(this.X, this.Y, this.Y);
};
protoOf(Vector).xyz = function () {
  return new Vector(this.X, this.Y, this.Z);
};
protoOf(Vector).xzx = function () {
  return new Vector(this.X, this.Z, this.X);
};
protoOf(Vector).xzy = function () {
  return new Vector(this.X, this.Z, this.Y);
};
protoOf(Vector).xzz = function () {
  return new Vector(this.X, this.Z, this.Z);
};
protoOf(Vector).yxx = function () {
  return new Vector(this.Y, this.X, this.X);
};
protoOf(Vector).yxy = function () {
  return new Vector(this.Y, this.X, this.Y);
};
protoOf(Vector).yxz = function () {
  return new Vector(this.Y, this.X, this.Z);
};
protoOf(Vector).yyx = function () {
  return new Vector(this.Y, this.Y, this.X);
};
protoOf(Vector).yyy = function () {
  return new Vector(this.Y, this.Y, this.Y);
};
protoOf(Vector).yyz = function () {
  return new Vector(this.Y, this.Y, this.Z);
};
protoOf(Vector).yzx = function () {
  return new Vector(this.Y, this.Z, this.X);
};
protoOf(Vector).yzy = function () {
  return new Vector(this.Y, this.Z, this.Y);
};
protoOf(Vector).yzz = function () {
  return new Vector(this.Y, this.Z, this.Z);
};
protoOf(Vector).zxx = function () {
  return new Vector(this.Z, this.X, this.X);
};
protoOf(Vector).zxy = function () {
  return new Vector(this.Z, this.X, this.Y);
};
protoOf(Vector).zxz = function () {
  return new Vector(this.Z, this.X, this.Z);
};
protoOf(Vector).zyx = function () {
  return new Vector(this.Z, this.Y, this.X);
};
protoOf(Vector).zyy = function () {
  return new Vector(this.Z, this.Y, this.Y);
};
protoOf(Vector).zyz = function () {
  return new Vector(this.Z, this.Y, this.Z);
};
protoOf(Vector).zzx = function () {
  return new Vector(this.Z, this.Z, this.X);
};
protoOf(Vector).zzy = function () {
  return new Vector(this.Z, this.Z, this.Y);
};
protoOf(Vector).zzz = function () {
  return new Vector(this.Z, this.Z, this.Z);
};
protoOf(Vector).xx = function () {
  return new Vector(this.X, this.X, 0.0);
};
protoOf(Vector).xy = function () {
  return new Vector(this.X, this.Y, 0.0);
};
protoOf(Vector).xz = function () {
  return new Vector(this.X, this.Z, 0.0);
};
protoOf(Vector).x0z = function () {
  return new Vector(this.X, 0.0, this.Z);
};
protoOf(Vector).yx = function () {
  return new Vector(this.Y, this.X, 0.0);
};
protoOf(Vector).yy = function () {
  return new Vector(this.Y, this.Y, 0.0);
};
protoOf(Vector).yz = function () {
  return new Vector(this.Y, this.Z, 0.0);
};
protoOf(Vector).zx = function () {
  return new Vector(this.Z, this.X, 0.0);
};
protoOf(Vector).zy = function () {
  return new Vector(this.Z, this.Y, 0.0);
};
protoOf(Vector).zz = function () {
  return new Vector(this.Z, this.Z, 0.0);
};
protoOf(Vector).plus = function (vector) {
  return new Vector(vector.X + this.X, vector.Y + this.Y, vector.Z + this.Z);
};
protoOf(Vector).__timesOperatorKotlin = function (vector) {
  return this.dot(vector);
};
protoOf(Vector).timesElementWise = function (vector) {
  return new Vector(this.X * vector.X, this.Y * vector.Y, this.Z * vector.Z);
};
protoOf(Vector).divideElementWise = function (vector) {
  return new Vector(this.X / vector.X, this.Y / vector.Y, this.Z / vector.Z);
};
protoOf(Vector).dot = function (vector) {
  return vector.X * this.X + vector.Y * this.Y + vector.Z * this.Z;
};
protoOf(Vector).cross = function (vector) {
  return new Vector(this.Y * vector.Z - this.Z * vector.Y, this.Z * vector.X - this.X * vector.Z, this.X * vector.Y - this.Y * vector.X);
};
protoOf(Vector).times = function (scalar) {
  return new Vector(scalar * this.X, scalar * this.Y, scalar * this.Z);
};
protoOf(Vector).__timesIntForKotlin = function (scalar) {
  return new Vector(scalar * this.X, scalar * this.Y, scalar * this.Z);
};
protoOf(Vector).minus = function (vector) {
  return new Vector(this.X - vector.X, this.Y - vector.Y, this.Z - vector.Z);
};
protoOf(Vector).div = function (scalar) {
  return new Vector(this.X / scalar, this.Y / scalar, this.Z / scalar);
};
protoOf(Vector).__divIntForKotlin = function (scalar) {
  return new Vector(this.X / scalar, this.Y / scalar, this.Z / scalar);
};
protoOf(Vector).unaryMinus = function () {
  return this.times(-1.0);
};
protoOf(Vector).rotateAroundPivot = function (rotation, pivot) {
  return this.minus(pivot).rotate(rotation).plus(pivot);
};
protoOf(Vector).rotateZ = function (theta) {
  return this.rotate(Companion_getInstance_74().n2v(Companion_getInstance_81().BACK, theta.toRadian()));
};
protoOf(Vector).rotateY = function (theta) {
  return this.rotate(Companion_getInstance_74().n2v(Companion_getInstance_81().UP, theta.toRadian()));
};
protoOf(Vector).rotateX = function (theta) {
  return this.rotate(Companion_getInstance_74().n2v(Companion_getInstance_81().RIGHT, theta.toRadian()));
};
protoOf(Vector).rotateAroundAxis = function (axis, angle) {
  return this.rotate(Companion_getInstance_74().n2v(axis, angle));
};
protoOf(Vector).rotate = function (quaternion) {
  var tmp;
  if (quaternion.isIdentity) {
    tmp = this;
  } else {
    var q = quaternion.normalize();
    var qDiff = q.w * q.w - (q.x * q.x + q.y * q.y + q.z * q.z);
    var thisTimesQ = 2 * (this.X * q.x + this.Y * q.y + this.Z * q.z);
    var twoQW = 2 * q.w;
    tmp = new Vector(this.X * qDiff + q.x * thisTimesQ + (q.y * this.Z - q.z * this.Y) * twoQW, this.Y * qDiff + q.y * thisTimesQ + (q.z * this.X - q.x * this.Z) * twoQW, this.Z * qDiff + q.z * thisTimesQ + (q.x * this.Y - q.y * this.X) * twoQW);
  }
  return tmp;
};
protoOf(Vector).distanceTo = function (otherPoint) {
  var xx = this.X - otherPoint.X;
  var yy = this.Y - otherPoint.Y;
  var zz = this.Z - otherPoint.Z;
  // Inline function 'kotlin.math.sqrt' call
  var x = xx * xx + yy * yy + zz * zz;
  return Math.sqrt(x);
};
protoOf(Vector).normalize = function () {
  var size = this.size;
  var tmp;
  if (size === 0.0) {
    tmp = this;
  } else {
    tmp = this.div(size);
  }
  return tmp;
};
protoOf(Vector).setSize = function (newSize) {
  return this.div(this.size).times(newSize);
};
protoOf(Vector).angle = function (other) {
  var cosValue = this.__timesOperatorKotlin(other) / (this.size * other.size);
  // Inline function 'kotlin.math.acos' call
  var result = Math.acos(cosValue);
  if (isNaN_0(result)) {
    return cosValue < -1 ? 3.141592653589793 : 0.0;
  }
  return result;
};
protoOf(Vector).w2y = function (other, up) {
  var unsignedAngle = this.angle(other);
  var perpendicular = this.cross(other);
  var dot = up.dot(perpendicular);
  // Inline function 'kotlin.math.sign' call
  var signedDot = sign(dot);
  if (signedDot === 0.0)
    return unsignedAngle;
  return signedDot * unsignedAngle;
};
protoOf(Vector).signedAngle = function (other, up, $super) {
  up = up === VOID ? Companion_getInstance_81().UP : up;
  return this.w2y(other, up);
};
protoOf(Vector).getRotationTo = function (other) {
  var angle = this.angle(other);
  var cross = this.cross(other);
  var tmp;
  if (cross.equals(Companion_getInstance_81().ZERO)) {
    var tmp_0;
    if (almostEquals(angle, 0.0)) {
      tmp_0 = Companion_getInstance_81().UP;
    } else {
      var tmp_1;
      if (almostEquals(this.X, 0.0) && almostEquals(this.Z, 0.0)) {
        tmp_1 = Companion_getInstance_81().RIGHT;
      } else if (almostEquals(this.Y, 0.0)) {
        tmp_1 = Companion_getInstance_81().UP;
      } else {
        tmp_1 = this.cross(Companion_getInstance_81().UP);
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  } else {
    tmp = cross;
  }
  var axis = tmp;
  return Companion_getInstance_74().n2v(axis, new Radians(angle));
};
protoOf(Vector).o = function () {
  var tmp;
  if (this.X === 0.0 && this.Y === 0.0 && this.Z === 0.0) {
    tmp = 0.0;
  } else {
    // Inline function 'kotlin.math.sqrt' call
    var x = this.X * this.X + this.Y * this.Y + this.Z * this.Z;
    tmp = Math.sqrt(x);
  }
  return tmp;
};
protoOf(Vector).abs = function () {
  // Inline function 'kotlin.math.abs' call
  var x = this.X;
  var tmp = Math.abs(x);
  // Inline function 'kotlin.math.abs' call
  var x_0 = this.Y;
  var tmp_0 = Math.abs(x_0);
  // Inline function 'kotlin.math.abs' call
  var x_1 = this.Z;
  var tmp$ret$2 = Math.abs(x_1);
  return new Vector(tmp, tmp_0, tmp$ret$2);
};
protoOf(Vector).equals = function (other) {
  var tmp;
  if (null == other) {
    tmp = true;
  } else {
    tmp = !(other instanceof Vector);
  }
  if (tmp)
    return false;
  return almostEquals(other.X, this.X) && almostEquals(other.Y, this.Y) && almostEquals(other.Z, this.Z);
};
protoOf(Vector).hashCode = function () {
  return 0;
};
protoOf(Vector).projectOnPlaneFromPoints = function (p1, p2, p3) {
  var n = p3.minus(p2).cross(p1.minus(p2)).normalize();
  return this.projectOnPlane(n, p1);
};
protoOf(Vector).projectOnPlane = function (normal, pointOnPlane) {
  return this.minus(times(normal.__timesOperatorKotlin(this.minus(pointOnPlane)), normal));
};
protoOf(Vector).projectOn = function (direction) {
  var s = this.__timesOperatorKotlin(direction);
  return direction.times(s);
};
protoOf(Vector).project = function (ptSet, output) {
  var minAlong = 1.7976931348623157E308;
  var maxAlong = -1.7976931348623157E308;
  var inductionVariable = 0;
  var last = ptSet.length;
  while (inductionVariable < last) {
    var pt = ptSet[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var dotVal = pt.__timesOperatorKotlin(this);
    if (dotVal < minAlong)
      minAlong = dotVal;
    if (dotVal > maxAlong)
      maxAlong = dotVal;
  }
  output.first = minAlong;
  output.last = maxAlong;
};
protoOf(Vector).pointOnLine = function (p1, p2) {
  var p = this;
  var line = p2.minus(p1);
  var p1_p = p.minus(p1);
  var p_p2 = p2.minus(p);
  var segmentsSum = p1_p.size + p_p2.size;
  return almostEquals(line.size, segmentsSum, 1.0E-4);
};
protoOf(Vector).isZero = function () {
  return this.X === 0.0 && this.Y === 0.0 && this.Z === 0.0;
};
protoOf(Vector).notZero = function () {
  return !(this.X === 0.0) || !(this.Y === 0.0) || !(this.Z === 0.0);
};
protoOf(Vector).exact = function (other) {
  return this.X === other.X && this.Y === other.Y && this.Z === other.Z;
};
protoOf(Vector).toString = function () {
  return 'X: ' + this.X + ' Y: ' + this.Y + ' Z: ' + this.Z;
};
protoOf(Vector).notExact = function (other) {
  return !(this.X === other.X) || !(this.Y === other.Y) || !(this.Z === other.Z);
};
protoOf(Vector).elementWiseInverse = function () {
  return new Vector(1.0 / this.X, 1.0 / this.Y, 1.0 / this.Z);
};
protoOf(Vector).x2y = function (x, y, z) {
  var tmp = x == null ? this.X : x;
  var tmp_0 = y == null ? this.Y : y;
  return new Vector(tmp, tmp_0, z == null ? this.Z : z);
};
protoOf(Vector).with = function (x, y, z, $super) {
  x = x === VOID ? null : x;
  y = y === VOID ? null : y;
  z = z === VOID ? null : z;
  return this.x2y(x, y, z);
};
protoOf(Vector).tf = function () {
  return this.X;
};
protoOf(Vector).uf = function () {
  return this.Y;
};
protoOf(Vector).m1m = function () {
  return this.Z;
};
protoOf(Vector).f2y = function (X, Y, Z) {
  return new Vector(X, Y, Z);
};
protoOf(Vector).copy = function (X, Y, Z, $super) {
  X = X === VOID ? this.X : X;
  Y = Y === VOID ? this.Y : Y;
  Z = Z === VOID ? this.Z : Z;
  return this.f2y(X, Y, Z);
};
function Companion_81() {
  Companion_instance_81 = this;
  this.y2y_1 = __VectorIntConstructorKotlin(-1, 0, 0);
  this.z2y_1 = __VectorIntConstructorKotlin(1, 0, 0);
  this.a2z_1 = __VectorIntConstructorKotlin(0, -1, 0);
  this.b2z_1 = __VectorIntConstructorKotlin(0, 1, 0);
  this.c2z_1 = __VectorIntConstructorKotlin(0, 0, -1);
  this.d2z_1 = __VectorIntConstructorKotlin(0, 0, 1);
  this.e2z_1 = __VectorIntConstructorKotlin(0, 0, 0);
  this.f2z_1 = new Vector(Infinity, Infinity, Infinity);
  this.g2z_1 = __VectorIntConstructorKotlin(1, 1, 1);
}
protoOf(Companion_81).p2x = function () {
  return this.y2y_1;
};
protoOf(Companion_81).r2x = function () {
  return this.z2y_1;
};
protoOf(Companion_81).m2y = function () {
  return this.a2z_1;
};
protoOf(Companion_81).n2y = function () {
  return this.b2z_1;
};
protoOf(Companion_81).o2y = function () {
  return this.c2z_1;
};
protoOf(Companion_81).u2x = function () {
  return this.d2z_1;
};
protoOf(Companion_81).p2y = function () {
  return this.e2z_1;
};
protoOf(Companion_81).q2y = function () {
  return this.f2z_1;
};
protoOf(Companion_81).i2h = function () {
  return this.g2z_1;
};
var Companion_instance_81;
function Companion_getInstance_82() {
  if (Companion_instance_81 == null)
    new Companion_81();
  return Companion_instance_81;
}
function get_LEFT_0() {
  return Companion_getInstance_82().y2y_1;
}
function get_RIGHT_0() {
  return Companion_getInstance_82().z2y_1;
}
function get_DOWN() {
  return Companion_getInstance_82().a2z_1;
}
function get_UP() {
  return Companion_getInstance_82().b2z_1;
}
function get_FORWARD() {
  return Companion_getInstance_82().c2z_1;
}
function get_BACK_0() {
  return Companion_getInstance_82().d2z_1;
}
function get_ZERO() {
  return Companion_getInstance_82().e2z_1;
}
function get_INFINITY() {
  return Companion_getInstance_82().f2z_1;
}
function get_ONE_0() {
  return Companion_getInstance_82().g2z_1;
}
function VectorConstants() {
  Companion_getInstance_82();
}
function get_geometricMean(_this__u8e3s4) {
  _init_properties_Vector_kt__7ulyhp();
  var mean = Companion_getInstance_81().ZERO;
  var num = 0;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  while (inductionVariable < last) {
    var element = _this__u8e3s4[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.math.<get-geometricMean>.<anonymous>' call
    mean = mean.plus(element);
    num = num + 1 | 0;
  }
  mean = mean.times(1.0 / num);
  return mean;
}
function almostEquals(_this__u8e3s4, other, epsilon) {
  epsilon = epsilon === VOID ? 0.001 : epsilon;
  _init_properties_Vector_kt__7ulyhp();
  var tmp;
  if (_this__u8e3s4 === other) {
    tmp = true;
  } else {
    // Inline function 'kotlin.math.abs' call
    var x = _this__u8e3s4 - other;
    tmp = Math.abs(x) < epsilon;
  }
  return tmp;
}
var properties_initialized_Vector_kt_6ddpp7;
function _init_properties_Vector_kt__7ulyhp() {
  if (!properties_initialized_Vector_kt_6ddpp7) {
    properties_initialized_Vector_kt_6ddpp7 = true;
    zero = new Vector(0.0, 0.0, 0.0);
  }
}
function times(_this__u8e3s4, other) {
  return other.times(_this__u8e3s4);
}
function InnerMeasurement$distance$delegate$lambda(this$0) {
  return function () {
    return this$0.start.point.distanceTo(this$0.end.point);
  };
}
function InnerMeasurement(start, end) {
  this.start = start;
  this.end = end;
  var tmp = this;
  tmp.h2z_1 = lazy(InnerMeasurement$distance$delegate$lambda(this));
}
protoOf(InnerMeasurement).kd = function () {
  return this.start;
};
protoOf(InnerMeasurement).i2i = function () {
  return this.end;
};
protoOf(InnerMeasurement).i2z = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.h2z_1;
  distance$factory();
  return this_0.c2();
};
protoOf(InnerMeasurement).tf = function () {
  return this.start;
};
protoOf(InnerMeasurement).uf = function () {
  return this.end;
};
protoOf(InnerMeasurement).j2z = function (start, end) {
  return new InnerMeasurement(start, end);
};
protoOf(InnerMeasurement).copy = function (start, end, $super) {
  start = start === VOID ? this.start : start;
  end = end === VOID ? this.end : end;
  return this.j2z(start, end);
};
protoOf(InnerMeasurement).toString = function () {
  return 'InnerMeasurement(start=' + this.start.toString() + ', end=' + this.end.toString() + ')';
};
protoOf(InnerMeasurement).hashCode = function () {
  var result = this.start.hashCode();
  result = imul(result, 31) + this.end.hashCode() | 0;
  return result;
};
protoOf(InnerMeasurement).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof InnerMeasurement))
    return false;
  var tmp0_other_with_cast = other instanceof InnerMeasurement ? other : THROW_CCE();
  if (!this.start.equals(tmp0_other_with_cast.start))
    return false;
  if (!this.end.equals(tmp0_other_with_cast.end))
    return false;
  return true;
};
function Companion_82() {
  Companion_instance_82 = this;
  this.k2z_1 = LoggerState_getInstance().g1v('MeasurementUtils');
}
protoOf(Companion_82).l2z = function (entity) {
  return get_axisAlignedBoundingBoxForHierarchy(entity);
};
protoOf(Companion_82).m2z = function (entities) {
  return Companion_getInstance_13().axisAlignedBoundingBoxForEntityHierarchies(entities);
};
protoOf(Companion_82).n2z = function (entity) {
  var tmp0_safe_receiver = get_collider(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
};
protoOf(Companion_82).o2z = function (entities) {
  return Companion_getInstance_13().axisAlignedBoundingBoxForEntities(entities);
};
protoOf(Companion_82).p2z = function (entities, baseWorldTransform) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var vertices = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.measuring.Companion.getLocalOutsideMeasurementForEntities.<anonymous>' call
    var transform = get_worldTransform(element);
    var tmp0_safe_receiver = get_colliderShapeComponent(element);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.measuring.Companion.getLocalOutsideMeasurementForEntities.<anonymous>.<anonymous>' call
      tmp = Companion_getInstance_129().m1x(tmp0_safe_receiver.polyhedron, transform);
    }
    var transformedVerticesForShape = tmp;
    if (!(transformedVerticesForShape == null)) {
      vertices.p(transformedVerticesForShape);
    }
  }
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var tmp0_iterator = vertices.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.measuring.Companion.getLocalOutsideMeasurementForEntities.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var i = checkIndexOverflow(tmp1);
    vertices.n2(i, baseWorldTransform.inverseTransformPosition(item));
  }
  var tmp_0;
  if (vertices.r()) {
    return null;
  } else {
    var tmp_1 = Companion_getInstance_125();
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(vertices);
    tmp_0 = tmp_1.z2v(tmp$ret$3);
  }
  return tmp_0;
};
protoOf(Companion_82).q2z = function (entity, root, directionLocalSpace, requiredComponents) {
  var directionWorldSpace = get_worldTransform(entity).transformVector(directionLocalSpace);
  return this.r2z(entity, root, directionWorldSpace, requiredComponents);
};
protoOf(Companion_82).getInsideMeasurementLocalSpace$default = function (entity, root, directionLocalSpace, requiredComponents, $super) {
  requiredComponents = requiredComponents === VOID ? null : requiredComponents;
  return $super === VOID ? this.q2z(entity, root, directionLocalSpace, requiredComponents) : $super.q2z.call(this, entity, root, directionLocalSpace, requiredComponents);
};
protoOf(Companion_82).r2z = function (entity, root, directionWorldSpace, requiredComponents) {
  var ray = new Ray(get_worldPosition(entity), directionWorldSpace);
  var tmp0_elvis_lhs = Companion_instance_89.s2z(ray, root, entity, requiredComponents);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var outerHit = tmp;
  var epsilonOffset = directionWorldSpace.times(Companion_instance_15.c1y_1);
  var reverseRayOrigin = outerHit.point.plus(epsilonOffset);
  var reverseRay = new Ray(reverseRayOrigin, directionWorldSpace.unaryMinus());
  var selfHit = Companion_instance_89.raycast$default(reverseRay, entity);
  if (selfHit == null || selfHit.distance > outerHit.distance) {
    selfHit = new RaycastHit(get_worldPosition(entity), entity, reverseRay.origin.distanceTo(get_worldPosition(entity)), reverseRay.direction.normalize());
  }
  return new InnerMeasurement(selfHit, outerHit);
};
protoOf(Companion_82).getInsideMeasurementWorldSpace$default = function (entity, root, directionWorldSpace, requiredComponents, $super) {
  requiredComponents = requiredComponents === VOID ? null : requiredComponents;
  return $super === VOID ? this.r2z(entity, root, directionWorldSpace, requiredComponents) : $super.r2z.call(this, entity, root, directionWorldSpace, requiredComponents);
};
var Companion_instance_82;
function Companion_getInstance_83() {
  if (Companion_instance_82 == null)
    new Companion_82();
  return Companion_instance_82;
}
function getOutsideMeasurementSingle(entity) {
  return Companion_getInstance_83().l2z(entity);
}
function getOutsideMeasurement(entities) {
  return Companion_getInstance_83().m2z(entities);
}
function getOutsideMeasurementSingleWithoutHierarchy(entity) {
  return Companion_getInstance_83().n2z(entity);
}
function getOutsideMeasurementWithoutHierarchies(entities) {
  return Companion_getInstance_83().o2z(entities);
}
function getLocalOutsideMeasurementForEntities(entities, baseWorldTransform) {
  return Companion_getInstance_83().p2z(entities, baseWorldTransform);
}
function getInsideMeasurementLocalSpace(entity, root, directionLocalSpace, requiredComponents) {
  return Companion_getInstance_83().q2z(entity, root, directionLocalSpace, requiredComponents);
}
function getInsideMeasurementLocalSpace_0(entity, root, directionLocalSpace, requiredComponents, $super) {
  requiredComponents = requiredComponents === VOID ? null : requiredComponents;
  return getInsideMeasurementLocalSpace(entity, root, directionLocalSpace, requiredComponents);
}
function getInsideMeasurementWorldSpace(entity, root, directionWorldSpace, requiredComponents) {
  return Companion_getInstance_83().r2z(entity, root, directionWorldSpace, requiredComponents);
}
function getInsideMeasurementWorldSpace_0(entity, root, directionWorldSpace, requiredComponents, $super) {
  requiredComponents = requiredComponents === VOID ? null : requiredComponents;
  return getInsideMeasurementWorldSpace(entity, root, directionWorldSpace, requiredComponents);
}
function MeasurementUtils() {
  Companion_getInstance_83();
}
function distance$factory() {
  return getPropertyCallableRef('distance', 1, KProperty1, function (receiver) {
    return receiver.distance;
  }, null);
}
function Companion_83() {
  Companion_instance_83 = this;
  this.id = Companion_instance_21.l1n_1;
}
protoOf(Companion_83).n1s = function () {
  return this.id;
};
var Companion_instance_83;
function Companion_getInstance_84() {
  if (Companion_instance_83 == null)
    new Companion_83();
  return Companion_instance_83;
}
function DisplayNameComponent(name) {
  Companion_getInstance_84();
  this.name = name;
}
protoOf(DisplayNameComponent).v2 = function () {
  return this.name;
};
protoOf(DisplayNameComponent).p1s = function () {
  return Companion_getInstance_84().id;
};
protoOf(DisplayNameComponent).eq = function (other) {
  return (other instanceof DisplayNameComponent ? other : THROW_CCE()).name === this.name;
};
protoOf(DisplayNameComponent).equals = function (other) {
  var tmp;
  if (other instanceof DisplayNameComponent) {
    tmp = other.name === this.name;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(DisplayNameComponent).hashCode = function () {
  return getStringHashCode(this.name);
};
protoOf(DisplayNameComponent).tf = function () {
  return this.name;
};
protoOf(DisplayNameComponent).h1t = function (name) {
  return new DisplayNameComponent(name);
};
protoOf(DisplayNameComponent).copy = function (name, $super) {
  name = name === VOID ? this.name : name;
  return this.h1t(name);
};
protoOf(DisplayNameComponent).toString = function () {
  return 'DisplayNameComponent(name=' + this.name + ')';
};
function set_displayName(_this__u8e3s4, value) {
  if (!(value == null))
    _this__u8e3s4.addComponentInternal(new DisplayNameComponent(value));
  else
    _this__u8e3s4.removeComponentInternal(Companion_getInstance_84().id);
}
function get_displayName(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.isDisposed) {
    tmp = 'Disposed entity ' + _this__u8e3s4.id;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_84().id);
    tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name;
  }
  return tmp;
}
function ProductUtils$Companion$getProductScale$lambda() {
  return 'Entity does not have a CatalogSizeComponent';
}
function ProductUtils$Companion$getProductScale$lambda_0() {
  return 'Entity does not have a ProductParamsComponent with size';
}
function Companion_84() {
  Companion_instance_84 = this;
  this.t2z_1 = LoggerState_getInstance().g1v('ProductUtils');
}
protoOf(Companion_84).u2z = function (entity) {
  return get_productComponent(entity);
};
protoOf(Companion_84).v2z = function (entity) {
  return get_productRef(entity);
};
protoOf(Companion_84).w2z = function (entity) {
  return get_productRefOrEmptyString(entity);
};
protoOf(Companion_84).y28 = function (entity) {
  return Companion_instance_25.y28(entity);
};
protoOf(Companion_84).z28 = function (entity) {
  return Companion_instance_25.z28(entity);
};
protoOf(Companion_84).b29 = function (entity) {
  return Companion_instance_25.b29(entity);
};
protoOf(Companion_84).x2z = function (entity) {
  return get_partKey(entity);
};
protoOf(Companion_84).y2z = function (originalSize, productParams) {
  var tmp1_elvis_lhs = productParams == null ? null : productParams.size;
  return tmp1_elvis_lhs == null ? originalSize : tmp1_elvis_lhs;
};
protoOf(Companion_84).z2z = function (entity) {
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_6().id);
  var originalSize = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var productParams = entity.__getComponentForKotlin(Companion_getInstance_10().id);
  if (originalSize == null) {
    this.t2z_1.warn(ProductUtils$Companion$getProductScale$lambda);
    return null;
  }
  var tmp2_safe_receiver = productParams == null ? null : productParams.params;
  if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.size) == null) {
    this.t2z_1.warn(ProductUtils$Companion$getProductScale$lambda_0);
    return null;
  }
  if (productParams.isOriginalParams) {
    return Companion_getInstance_81().ONE;
  }
  return productParams.params.size.vector.divideElementWise(originalSize.vector);
};
var Companion_instance_84;
function Companion_getInstance_85() {
  if (Companion_instance_84 == null)
    new Companion_84();
  return Companion_instance_84;
}
function productComponent(entity) {
  return Companion_getInstance_85().u2z(entity);
}
function productRef(entity) {
  return Companion_getInstance_85().v2z(entity);
}
function productRefOrEmptyString(entity) {
  return Companion_getInstance_85().w2z(entity);
}
function isConnectionRoot_0(entity) {
  return Companion_getInstance_85().y28(entity);
}
function connectionRootEntity_0(entity) {
  return Companion_getInstance_85().z28(entity);
}
function immediateConnectionRootDescendants_0(entity) {
  return Companion_getInstance_85().b29(entity);
}
function partKey(entity) {
  return Companion_getInstance_85().x2z(entity);
}
function applyResize(originalSize, productParams) {
  return Companion_getInstance_85().y2z(originalSize, productParams);
}
function getProductScale(entity) {
  return Companion_getInstance_85().z2z(entity);
}
function ProductUtils() {
  Companion_getInstance_85();
}
function Companion_85() {
}
protoOf(Companion_85).n1s = function () {
  return Companion_instance_21.d1n_1;
};
var Companion_instance_85;
function Companion_getInstance_86() {
  return Companion_instance_85;
}
function get_id_0() {
  return Companion_instance_85.n1s();
}
function ProppingComponent() {
}
protoOf(ProppingComponent).p1s = function () {
  return Companion_instance_85.n1s();
};
protoOf(ProppingComponent).eq = function (other) {
  return true;
};
function get_isPropping(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_instance_85.n1s());
}
function Companion_86() {
  Companion_instance_86 = this;
  this.id = Companion_instance_21.s1o_1;
}
protoOf(Companion_86).n1s = function () {
  return this.id;
};
var Companion_instance_86;
function Companion_getInstance_87() {
  if (Companion_instance_86 == null)
    new Companion_86();
  return Companion_instance_86;
}
function TemplateDataComponent(templateId, size, comSize, family, variant) {
  Companion_getInstance_87();
  family = family === VOID ? '' : family;
  variant = variant === VOID ? null : variant;
  this.templateId = templateId;
  this.size = size;
  this.comSize = comSize;
  this.family = family;
  this.variant = variant;
}
protoOf(TemplateDataComponent).a30 = function () {
  return this.templateId;
};
protoOf(TemplateDataComponent).o = function () {
  return this.size;
};
protoOf(TemplateDataComponent).b30 = function () {
  return this.comSize;
};
protoOf(TemplateDataComponent).c30 = function () {
  return this.family;
};
protoOf(TemplateDataComponent).k1m = function () {
  return this.variant;
};
protoOf(TemplateDataComponent).p1s = function () {
  return Companion_getInstance_87().id;
};
protoOf(TemplateDataComponent).eq = function (other) {
  var otherC = other instanceof TemplateDataComponent ? other : THROW_CCE();
  return otherC.templateId === this.templateId && otherC.size.equals(this.size) && otherC.comSize.equals(this.comSize) && otherC.family == this.family && otherC.variant == this.variant;
};
protoOf(TemplateDataComponent).equals = function (other) {
  var tmp;
  if (!(other instanceof TemplateDataComponent)) {
    tmp = true;
  } else {
    tmp = !(other.templateId === this.templateId);
  }
  if (tmp)
    return false;
  if (!(other.variant == this.variant))
    return false;
  return other.comSize.exact(this.comSize);
};
protoOf(TemplateDataComponent).hashCode = function () {
  return getStringHashCode(this.templateId);
};
protoOf(TemplateDataComponent).tf = function () {
  return this.templateId;
};
protoOf(TemplateDataComponent).uf = function () {
  return this.size;
};
protoOf(TemplateDataComponent).m1m = function () {
  return this.comSize;
};
protoOf(TemplateDataComponent).n1m = function () {
  return this.family;
};
protoOf(TemplateDataComponent).o1m = function () {
  return this.variant;
};
protoOf(TemplateDataComponent).d30 = function (templateId, size, comSize, family, variant) {
  return new TemplateDataComponent(templateId, size, comSize, family, variant);
};
protoOf(TemplateDataComponent).copy = function (templateId, size, comSize, family, variant, $super) {
  templateId = templateId === VOID ? this.templateId : templateId;
  size = size === VOID ? this.size : size;
  comSize = comSize === VOID ? this.comSize : comSize;
  family = family === VOID ? this.family : family;
  variant = variant === VOID ? this.variant : variant;
  return this.d30(templateId, size, comSize, family, variant);
};
protoOf(TemplateDataComponent).toString = function () {
  return 'TemplateDataComponent(templateId=' + this.templateId + ', size=' + this.size.toString() + ', comSize=' + this.comSize.toString() + ', family=' + this.family + ', variant=' + this.variant + ')';
};
function createAndAddPartToParent($this, parent, productStructureItem, productManager) {
  var childEntity = productManager.createEntity(productStructureItem.productRef);
  if (childEntity == null) {
    $this.e30_1.warn(ProductStructureBuilder$Companion$createAndAddPartToParent$lambda(productStructureItem));
    return null;
  }
  if (!childEntity.hasComponent(Companion_getInstance_149().id)) {
    Companion_instance_146.z1l(childEntity, get_worldTransform(parent));
  }
  transformPart($this, childEntity, productStructureItem.relativeTransform);
  setParentMaintainWorldTransform(childEntity, parent);
  return childEntity;
}
function createAndSnapPartToParent($this, host, root, productStructureItem, productManager) {
  var tmp0_elvis_lhs = createAndAddPartToParent($this, host, productStructureItem, productManager);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var childEntity = tmp;
  var snap = getSnap($this, childEntity, host, productStructureItem);
  if (snap == null) {
    $this.e30_1.warn(ProductStructureBuilder$Companion$createAndSnapPartToParent$lambda(productStructureItem, host));
    childEntity.dispose();
    return null;
  }
  if (snap.guestConnector.type === Companion_instance_32.o2b_1 || snap.guestConnector.type === Companion_instance_32.n2b_1 || snap.hostConnector.type === Companion_instance_32.n2b_1 || snap.hostConnector.type === Companion_instance_32.o2b_1) {
    snap.performMove();
    var nonAlignmentSnapInThisPosition = findSnapToNonAlignmentConnector($this, childEntity, root);
    if (!(nonAlignmentSnapInThisPosition == null)) {
      nonAlignmentSnapInThisPosition.performMoveAndConnect();
    } else {
      setParentMaintainWorldTransform(snap.guestRoot, root);
    }
  } else {
    snap.performMoveAndConnect();
  }
  return childEntity;
}
function findSnapToNonAlignmentConnector($this, childEntity, root) {
  var allConnections = Companion_instance_25.d29(childEntity, root);
  // Inline function 'kotlin.collections.isEmpty' call
  if (allConnections.length === 0) {
    return null;
  }
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.maxBy' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (allConnections.length === 0)
      throw NoSuchElementException_init_$Create$();
    var maxElem = allConnections[0];
    var lastIndex = get_lastIndex(allConnections);
    if (lastIndex === 0) {
      tmp$ret$2 = maxElem;
      break $l$block;
    }
    // Inline function 'com.ikea.core.productstructure.Companion.findSnapToNonAlignmentConnector.<anonymous>' call
    var maxValue = maxElem.priority;
    var inductionVariable = 1;
    if (inductionVariable <= lastIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = allConnections[i];
        // Inline function 'com.ikea.core.productstructure.Companion.findSnapToNonAlignmentConnector.<anonymous>' call
        var v = e.priority;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (!(i === lastIndex));
    tmp$ret$2 = maxElem;
  }
  var highestPriorityConnection = tmp$ret$2;
  return Companion_instance_137.f30(highestPriorityConnection.guestConnectorEntity, highestPriorityConnection.guestConnector, highestPriorityConnection.hostConnectorEntity, highestPriorityConnection.hostConnector);
}
function getSnap($this, demandingEntity, offeringEntity, productStructureItem) {
  var tmp0_elvis_lhs = productStructureItem.snap;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var connectionData = tmp;
  var demandingConnectorKey = connectionData.demandingConnector;
  var offeringConnectorKey = connectionData.offeringConnector;
  // Inline function 'kotlin.sequences.find' call
  var this_0 = get_snappingEntitiesSequence(demandingEntity);
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.sequences.firstOrNull' call
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.productstructure.Companion.getSnap.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.any' call
        var indexedObject = get_connectors(element);
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element_0 = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.productstructure.Companion.getSnap.<anonymous>.<anonymous>' call
          if (element_0.key === demandingConnectorKey) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
        tmp$ret$1 = false;
      }
      if (tmp$ret$1) {
        tmp$ret$3 = element;
        break $l$block_0;
      }
    }
    tmp$ret$3 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$3;
  var realDemandingEntity = tmp1_elvis_lhs == null ? demandingEntity : tmp1_elvis_lhs;
  var offeringConnectorTmp = null;
  // Inline function 'kotlin.collections.find' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_1 = get_snappingHierarchyEntities(offeringEntity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.productstructure.Companion.getSnap.<anonymous>' call
    if (element_1.hasComponent(Companion_getInstance_35().id)) {
      destination.h(element_1);
    }
  }
  var tmp$ret$9;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator_0 = destination.k();
    while (tmp0_iterator_0.m()) {
      var element_2 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.productstructure.Companion.getSnap.<anonymous>' call
      var foundConnector = element_2.getComponentUnsafe(Companion_getInstance_35().id).getConnectorByKey(offeringConnectorKey);
      var tmp_0;
      if (!(foundConnector == null)) {
        offeringConnectorTmp = foundConnector;
        tmp_0 = true;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$9 = element_2;
        break $l$block_1;
      }
    }
    tmp$ret$9 = null;
  }
  var tmp2_elvis_lhs = tmp$ret$9;
  var realOfferingEntity = tmp2_elvis_lhs == null ? offeringEntity : tmp2_elvis_lhs;
  var tmp3_safe_receiver = get_connectorsComponent(realDemandingEntity);
  var demandingConnector = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.getConnectorByKey(demandingConnectorKey);
  var offeringConnector = offeringConnectorTmp;
  if (demandingConnector == null) {
    $this.e30_1.warn(ProductStructureBuilder$Companion$getSnap$lambda(demandingConnectorKey, productStructureItem));
    return null;
  }
  if (offeringConnector == null) {
    $this.e30_1.warn(ProductStructureBuilder$Companion$getSnap$lambda_0(offeringConnectorKey, realOfferingEntity));
    return null;
  }
  return Companion_instance_137.f30(realDemandingEntity, demandingConnector, realOfferingEntity, offeringConnector);
}
function transformPart($this, entity, transform) {
  if (!(transform == null)) {
    Companion_instance_146.g30(entity, transform.position);
    Companion_instance_146.h30(entity, transform.rotation);
  }
}
function ProductStructureBuilder$Companion$buildProductStructure$lambda() {
  return 'The product has no root. At least one item must be without the snap property, so we have somewhere to start.';
}
function ProductStructureBuilder$Companion$buildProductStructure$lambda_0() {
  return 'The product structure contains duplicate part keys. Each part key must be unique.';
}
function ProductStructureBuilder$Companion$buildProductStructure$lambda_1($firstProductData) {
  return function () {
    return 'Could not find the product for the root of the product structure: ' + $firstProductData.productRef;
  };
}
function ProductStructureBuilder$Companion$buildProductStructure$lambda_2($it) {
  return function () {
    return 'Could not find the host for a product structure item (' + $it.partKey + '): ' + $it.snap.offeringPartKey;
  };
}
function ProductStructureBuilder$Companion$createAndAddPartToParent$lambda($productStructureItem) {
  return function () {
    return 'Could not find the product for a product structure item (' + $productStructureItem.partKey + '): ' + $productStructureItem.productRef;
  };
}
function ProductStructureBuilder$Companion$createAndSnapPartToParent$lambda($productStructureItem, $host) {
  return function () {
    return 'Could not snap ' + $productStructureItem.productRef + ' to ' + Companion_getInstance_85().v2z($host) + '. Will not add part ' + $productStructureItem.partKey + ' to product structure.';
  };
}
function ProductStructureBuilder$Companion$getSnap$lambda($demandingConnectorKey, $productStructureItem) {
  return function () {
    return 'Could not find demanding connector ' + $demandingConnectorKey + ' in ' + $productStructureItem.productRef + '.';
  };
}
function ProductStructureBuilder$Companion$getSnap$lambda_0($offeringConnectorKey, $realOfferingEntity) {
  return function () {
    return 'Could not find offering connector ' + $offeringConnectorKey + ' in entity ' + get_productRef($realOfferingEntity) + '.';
  };
}
function Companion_87() {
  Companion_instance_87 = this;
  this.e30_1 = LoggerState_getInstance().g1v('ProductStructureBuilder');
}
protoOf(Companion_87).buildProductStructure = function (structure, productManager, entityManager) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = structure.products;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.productstructure.Companion.buildProductStructure.<anonymous>' call
    if (element.snap == null) {
      destination.h(element);
    }
  }
  var roots = destination;
  if (roots.r()) {
    this.e30_1.warn(ProductStructureBuilder$Companion$buildProductStructure$lambda);
    return null;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = structure.products;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(this_1.length);
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var item = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.productstructure.Companion.buildProductStructure.<anonymous>' call
    var tmp$ret$3 = item.partKey;
    destination_0.h(tmp$ret$3);
  }
  if (!(distinct(destination_0).o() === structure.products.length)) {
    this.e30_1.warn(ProductStructureBuilder$Companion$buildProductStructure$lambda_0);
    return null;
  }
  var firstProductData = first_0(roots);
  var temporarySceneRoot = entityManager.createEntity();
  temporarySceneRoot.addComponent(new SnapRootComponent());
  var firstProduct = createAndAddPartToParent(this, temporarySceneRoot, firstProductData, productManager);
  if (firstProduct == null) {
    temporarySceneRoot.dispose();
    this.e30_1.warn(ProductStructureBuilder$Companion$buildProductStructure$lambda_1(firstProductData));
    return null;
  }
  // Inline function 'kotlin.collections.mutableMapOf' call
  var createdEntitiesMap = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.set' call
  var key = firstProductData.partKey;
  createdEntitiesMap.q2(key, firstProduct);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_2 = structure.products;
  var destination_1 = ArrayList_init_$Create$();
  var inductionVariable_1 = 0;
  var last_1 = this_2.length;
  while (inductionVariable_1 < last_1) {
    var element_0 = this_2[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.productstructure.Companion.buildProductStructure.<anonymous>' call
    if (!(element_0.partKey === firstProductData.partKey)) {
      destination_1.h(element_0);
    }
  }
  var tmp0_iterator = destination_1.k();
  while (tmp0_iterator.m()) {
    var element_1 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.productstructure.Companion.buildProductStructure.<anonymous>' call
    var tmp;
    if (element_1.snap == null) {
      tmp = createAndAddPartToParent(Companion_getInstance_88(), temporarySceneRoot, element_1, productManager);
    } else {
      var host = createdEntitiesMap.f2(element_1.snap.offeringPartKey);
      var tmp_0;
      if (host == null) {
        var tmp_1 = Companion_getInstance_88().e30_1;
        tmp_1.warn(ProductStructureBuilder$Companion$buildProductStructure$lambda_2(element_1));
        tmp_0 = null;
      } else {
        tmp_0 = createAndSnapPartToParent(Companion_getInstance_88(), host, temporarySceneRoot, element_1, productManager);
      }
      tmp = tmp_0;
    }
    var newEntity = tmp;
    if (newEntity == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var key_0 = element_1.partKey;
      createdEntitiesMap.q2(key_0, newEntity);
    }
  }
  var tmp_2;
  if (get_children(temporarySceneRoot).length > 1) {
    var group = entityManager.createEntity();
    set_displayName(group, 'ProductStructure temporary parent');
    group.addComponent(new SnapRootComponent());
    var children = get_children(temporarySceneRoot);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_2 = 0;
    var last_2 = children.length;
    while (inductionVariable_2 < last_2) {
      var element_2 = children[inductionVariable_2];
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      // Inline function 'com.ikea.core.productstructure.Companion.buildProductStructure.<anonymous>' call
      setParent_0(element_2, group);
      element_2.removeComponent(Companion_getInstance_137().id);
    }
    group.addComponent(new TemporaryParentComponent());
    entityManager.disposeEntity(temporarySceneRoot);
    tmp_2 = group;
  } else {
    var tmp0_elvis_lhs = firstOrNull(get_children(temporarySceneRoot));
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      var message = 'No child found';
      throw IllegalStateException_init_$Create$(toString_0(message));
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var onlyChild = tmp_3;
    setParent_0(onlyChild, null);
    temporarySceneRoot.removeComponent(Companion_getInstance_65().id);
    entityManager.disposeEntity(temporarySceneRoot);
    tmp_2 = onlyChild;
  }
  var product = tmp_2;
  Companion_instance_146.b1m(product, Companion_getInstance_80().c1x_1);
  return product;
};
var Companion_instance_87;
function Companion_getInstance_88() {
  if (Companion_instance_87 == null)
    new Companion_87();
  return Companion_instance_87;
}
function ProductStructureBuilder() {
  Companion_getInstance_88();
}
function Companion_88() {
}
protoOf(Companion_88).createFromPoints = function (from, to) {
  var direction = to.minus(from).normalize();
  return new Ray(from, direction);
};
var Companion_instance_88;
function Companion_getInstance_89() {
  return Companion_instance_88;
}
function Ray(origin, direction) {
  this.origin = origin;
  this.direction = direction;
}
protoOf(Ray).i30 = function () {
  return this.origin;
};
protoOf(Ray).k2e = function () {
  return this.direction;
};
protoOf(Ray).toString = function () {
  return 'Ray origin ' + this.origin.toString() + ' direction ' + this.direction.toString();
};
protoOf(Ray).getPointAlongRay = function (distance) {
  return this.origin.plus(times(distance, this.direction));
};
protoOf(Ray).hitsPoint = function (point) {
  var directionToPoint = point.minus(this.origin);
  return directionToPoint.normalize().equals(this.direction.normalize());
};
protoOf(Ray).closestPointOnRay = function (point) {
  var rayDir = this.direction.normalize();
  var fromRayOriginToPoint = point.minus(this.origin);
  var weight = rayDir.dot(fromRayOriginToPoint);
  var tmp;
  if (weight < 0) {
    tmp = this.origin;
  } else {
    tmp = this.origin.plus(times(weight, rayDir));
  }
  return tmp;
};
protoOf(Ray).tf = function () {
  return this.origin;
};
protoOf(Ray).uf = function () {
  return this.direction;
};
protoOf(Ray).l2w = function (origin, direction) {
  return new Ray(origin, direction);
};
protoOf(Ray).copy = function (origin, direction, $super) {
  origin = origin === VOID ? this.origin : origin;
  direction = direction === VOID ? this.direction : direction;
  return this.l2w(origin, direction);
};
protoOf(Ray).hashCode = function () {
  var result = this.origin.hashCode();
  result = imul(result, 31) + this.direction.hashCode() | 0;
  return result;
};
protoOf(Ray).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Ray))
    return false;
  var tmp0_other_with_cast = other instanceof Ray ? other : THROW_CCE();
  if (!this.origin.equals(tmp0_other_with_cast.origin))
    return false;
  if (!this.direction.equals(tmp0_other_with_cast.direction))
    return false;
  return true;
};
function RaycastHit(point, entity, distance, surfaceNormal) {
  this.point = point;
  this.entity = entity;
  this.distance = distance;
  this.surfaceNormal = surfaceNormal;
}
protoOf(RaycastHit).x2j = function () {
  return this.point;
};
protoOf(RaycastHit).v2i = function () {
  return this.entity;
};
protoOf(RaycastHit).i2z = function () {
  return this.distance;
};
protoOf(RaycastHit).j30 = function () {
  return this.surfaceNormal;
};
protoOf(RaycastHit).asRaycastResult = function () {
  return new RaycastResult(this.point, this.surfaceNormal);
};
protoOf(RaycastHit).tf = function () {
  return this.point;
};
protoOf(RaycastHit).uf = function () {
  return this.entity;
};
protoOf(RaycastHit).m1m = function () {
  return this.distance;
};
protoOf(RaycastHit).n1m = function () {
  return this.surfaceNormal;
};
protoOf(RaycastHit).k30 = function (point, entity, distance, surfaceNormal) {
  return new RaycastHit(point, entity, distance, surfaceNormal);
};
protoOf(RaycastHit).copy = function (point, entity, distance, surfaceNormal, $super) {
  point = point === VOID ? this.point : point;
  entity = entity === VOID ? this.entity : entity;
  distance = distance === VOID ? this.distance : distance;
  surfaceNormal = surfaceNormal === VOID ? this.surfaceNormal : surfaceNormal;
  return this.k30(point, entity, distance, surfaceNormal);
};
protoOf(RaycastHit).toString = function () {
  return 'RaycastHit(point=' + this.point.toString() + ', entity=' + this.entity.toString() + ', distance=' + this.distance + ', surfaceNormal=' + this.surfaceNormal.toString() + ')';
};
protoOf(RaycastHit).hashCode = function () {
  var result = this.point.hashCode();
  result = imul(result, 31) + this.entity.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.distance) | 0;
  result = imul(result, 31) + this.surfaceNormal.hashCode() | 0;
  return result;
};
protoOf(RaycastHit).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RaycastHit))
    return false;
  var tmp0_other_with_cast = other instanceof RaycastHit ? other : THROW_CCE();
  if (!this.point.equals(tmp0_other_with_cast.point))
    return false;
  if (!this.entity.equals(tmp0_other_with_cast.entity))
    return false;
  if (!equals(this.distance, tmp0_other_with_cast.distance))
    return false;
  if (!this.surfaceNormal.equals(tmp0_other_with_cast.surfaceNormal))
    return false;
  return true;
};
function RaycastResult(point, surfaceNormal) {
  this.point = point;
  this.surfaceNormal = surfaceNormal;
}
protoOf(RaycastResult).x2j = function () {
  return this.point;
};
protoOf(RaycastResult).j30 = function () {
  return this.surfaceNormal;
};
protoOf(RaycastResult).tf = function () {
  return this.point;
};
protoOf(RaycastResult).uf = function () {
  return this.surfaceNormal;
};
protoOf(RaycastResult).l2w = function (point, surfaceNormal) {
  return new RaycastResult(point, surfaceNormal);
};
protoOf(RaycastResult).copy = function (point, surfaceNormal, $super) {
  point = point === VOID ? this.point : point;
  surfaceNormal = surfaceNormal === VOID ? this.surfaceNormal : surfaceNormal;
  return this.l2w(point, surfaceNormal);
};
protoOf(RaycastResult).toString = function () {
  return 'RaycastResult(point=' + this.point.toString() + ', surfaceNormal=' + this.surfaceNormal.toString() + ')';
};
protoOf(RaycastResult).hashCode = function () {
  var result = this.point.hashCode();
  result = imul(result, 31) + this.surfaceNormal.hashCode() | 0;
  return result;
};
protoOf(RaycastResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RaycastResult))
    return false;
  var tmp0_other_with_cast = other instanceof RaycastResult ? other : THROW_CCE();
  if (!this.point.equals(tmp0_other_with_cast.point))
    return false;
  if (!this.surfaceNormal.equals(tmp0_other_with_cast.surfaceNormal))
    return false;
  return true;
};
function raycast$iterator($requiredComponents, $ray, closestHit, entity) {
  if ($requiredComponents == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = $requiredComponents.length;
    while (inductionVariable < last) {
      var element = $requiredComponents[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.raycasting.Companion.raycast.iterator.<anonymous>' call
      if (!entity.hasComponent(element))
        return Unit_instance;
    }
  }
  var tmp1_safe_receiver = get_collider(entity);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.worldPolyhedron;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.raycasting.Companion.raycast.iterator.<anonymous>' call
    var tmp0_safe_receiver = tmp2_safe_receiver.raycast($ray);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var hitDistance = $ray.origin.distanceTo(tmp0_safe_receiver.point);
      var tmp0_safe_receiver_0 = closestHit._v;
      var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.distance;
      var closestDistance = tmp1_elvis_lhs == null ? Infinity : tmp1_elvis_lhs;
      if (hitDistance < closestDistance) {
        closestHit._v = new RaycastHit(tmp0_safe_receiver.point, entity, hitDistance, tmp0_safe_receiver.surfaceNormal);
      }
      tmp = Unit_instance;
    }
  }
}
function raycastAll$iterator($requiredComponents, $ray, hits, entity) {
  if ($requiredComponents == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = $requiredComponents.length;
    while (inductionVariable < last) {
      var element = $requiredComponents[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.raycasting.Companion.raycastAll.iterator.<anonymous>' call
      if (!entity.hasComponent(element))
        return Unit_instance;
    }
  }
  var tmp1_safe_receiver = get_collider(entity);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.worldPolyhedron;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.raycasting.Companion.raycastAll.iterator.<anonymous>' call
    var tmp0_safe_receiver = tmp2_safe_receiver.raycast($ray);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.raycasting.Companion.raycastAll.iterator.<anonymous>.<anonymous>' call
      var hitDistance = $ray.origin.distanceTo(tmp0_safe_receiver.point);
      tmp = hits.h(new RaycastHit(tmp0_safe_receiver.point, entity, hitDistance, tmp0_safe_receiver.surfaceNormal));
    }
  }
}
function RaycastUtils$Companion$raycast$iterator$ref($requiredComponents, $ray, $closestHit) {
  var l = function (p0) {
    raycast$iterator($requiredComponents, $ray, $closestHit, p0);
    return Unit_instance;
  };
  l.callableName = 'iterator';
  return l;
}
function RaycastUtils$Companion$raycast$iterator$ref_0($requiredComponents, $ray, $closestHit) {
  var l = function (p0) {
    raycast$iterator($requiredComponents, $ray, $closestHit, p0);
    return Unit_instance;
  };
  l.callableName = 'iterator';
  return l;
}
function RaycastUtils$Companion$raycastAll$iterator$ref($requiredComponents, $ray, $hits) {
  var l = function (p0) {
    raycastAll$iterator($requiredComponents, $ray, $hits, p0);
    return Unit_instance;
  };
  l.callableName = 'iterator';
  return l;
}
function RaycastUtils$Companion$raycastAll$iterator$ref_0($requiredComponents, $ray, $hits) {
  var l = function (p0) {
    raycastAll$iterator($requiredComponents, $ray, $hits, p0);
    return Unit_instance;
  };
  l.callableName = 'iterator';
  return l;
}
function Companion_89() {
}
protoOf(Companion_89).s2z = function (ray, root, hierarchyToIgnore, requiredComponents) {
  var closestHit = {_v: null};
  if (hierarchyToIgnore == null) {
    forEachInHierarchy_0(root, RaycastUtils$Companion$raycast$iterator$ref(requiredComponents, ray, closestHit));
  } else {
    forEachInHierarchyExceptHierarchyOfIgnored_0(root, hierarchyToIgnore, RaycastUtils$Companion$raycast$iterator$ref_0(requiredComponents, ray, closestHit));
  }
  return closestHit._v;
};
protoOf(Companion_89).raycast$default = function (ray, root, hierarchyToIgnore, requiredComponents, $super) {
  hierarchyToIgnore = hierarchyToIgnore === VOID ? null : hierarchyToIgnore;
  requiredComponents = requiredComponents === VOID ? null : requiredComponents;
  return $super === VOID ? this.s2z(ray, root, hierarchyToIgnore, requiredComponents) : $super.s2z.call(this, ray, root, hierarchyToIgnore, requiredComponents);
};
protoOf(Companion_89).l30 = function (ray, root, hierarchyToIgnore, requiredComponents) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var hits = ArrayList_init_$Create$();
  if (hierarchyToIgnore == null) {
    forEachInHierarchy_0(root, RaycastUtils$Companion$raycastAll$iterator$ref(requiredComponents, ray, hits));
  } else {
    forEachInHierarchyExceptHierarchyOfIgnored_0(root, hierarchyToIgnore, RaycastUtils$Companion$raycastAll$iterator$ref_0(requiredComponents, ray, hits));
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(hits);
};
protoOf(Companion_89).raycastAll$default = function (ray, root, hierarchyToIgnore, requiredComponents, $super) {
  hierarchyToIgnore = hierarchyToIgnore === VOID ? null : hierarchyToIgnore;
  requiredComponents = requiredComponents === VOID ? null : requiredComponents;
  return $super === VOID ? this.l30(ray, root, hierarchyToIgnore, requiredComponents) : $super.l30.call(this, ray, root, hierarchyToIgnore, requiredComponents);
};
var Companion_instance_89;
function Companion_getInstance_90() {
  return Companion_instance_89;
}
function raycast(ray, root, hierarchyToIgnore, requiredComponents) {
  return Companion_instance_89.s2z(ray, root, hierarchyToIgnore, requiredComponents);
}
function raycast_0(ray, root, hierarchyToIgnore, requiredComponents, $super) {
  hierarchyToIgnore = hierarchyToIgnore === VOID ? null : hierarchyToIgnore;
  requiredComponents = requiredComponents === VOID ? null : requiredComponents;
  return raycast(ray, root, hierarchyToIgnore, requiredComponents);
}
function raycastAll(ray, root, hierarchyToIgnore, requiredComponents) {
  return Companion_instance_89.l30(ray, root, hierarchyToIgnore, requiredComponents);
}
function raycastAll_0(ray, root, hierarchyToIgnore, requiredComponents, $super) {
  hierarchyToIgnore = hierarchyToIgnore === VOID ? null : hierarchyToIgnore;
  requiredComponents = requiredComponents === VOID ? null : requiredComponents;
  return raycastAll(ray, root, hierarchyToIgnore, requiredComponents);
}
function RaycastUtils() {
}
function Raycastable() {
}
function Companion_90() {
  Companion_instance_90 = this;
  this.id = Companion_instance_21.q1n_1;
}
protoOf(Companion_90).n1s = function () {
  return this.id;
};
protoOf(Companion_90).m30 = function (hasFinishedLoading) {
  return new LoadedModelInfoComponent(hasFinishedLoading);
};
protoOf(Companion_90).createForTest = function (hasFinishedLoading, $super) {
  hasFinishedLoading = hasFinishedLoading === VOID ? true : hasFinishedLoading;
  return this.m30(hasFinishedLoading);
};
var Companion_instance_90;
function Companion_getInstance_91() {
  if (Companion_instance_90 == null)
    new Companion_90();
  return Companion_instance_90;
}
function LoadedModelInfoComponent(hasFinishedLoading, hasFailedLoading) {
  Companion_getInstance_91();
  hasFinishedLoading = hasFinishedLoading === VOID ? true : hasFinishedLoading;
  hasFailedLoading = hasFailedLoading === VOID ? false : hasFailedLoading;
  this.hasFinishedLoading = hasFinishedLoading;
  this.hasFailedLoading = hasFailedLoading;
  this.n30_1 = false;
}
protoOf(LoadedModelInfoComponent).o30 = function () {
  return this.hasFinishedLoading;
};
protoOf(LoadedModelInfoComponent).p30 = function () {
  return this.hasFailedLoading;
};
protoOf(LoadedModelInfoComponent).p1s = function () {
  return Companion_getInstance_91().id;
};
protoOf(LoadedModelInfoComponent).withFinishedLoading = function () {
  return new LoadedModelInfoComponent(true);
};
protoOf(LoadedModelInfoComponent).withFailedLoading = function () {
  return new LoadedModelInfoComponent(false, true);
};
protoOf(LoadedModelInfoComponent).eq = function (other) {
  var tmp;
  if ((other instanceof LoadedModelInfoComponent ? other : THROW_CCE()).hasFinishedLoading === this.hasFinishedLoading) {
    tmp = other.hasFailedLoading === this.hasFinishedLoading;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(LoadedModelInfoComponent).s1s = function () {
  return this.n30_1;
};
protoOf(LoadedModelInfoComponent).tf = function () {
  return this.hasFinishedLoading;
};
protoOf(LoadedModelInfoComponent).uf = function () {
  return this.hasFailedLoading;
};
protoOf(LoadedModelInfoComponent).q30 = function (hasFinishedLoading, hasFailedLoading) {
  return new LoadedModelInfoComponent(hasFinishedLoading, hasFailedLoading);
};
protoOf(LoadedModelInfoComponent).copy = function (hasFinishedLoading, hasFailedLoading, $super) {
  hasFinishedLoading = hasFinishedLoading === VOID ? this.hasFinishedLoading : hasFinishedLoading;
  hasFailedLoading = hasFailedLoading === VOID ? this.hasFailedLoading : hasFailedLoading;
  return this.q30(hasFinishedLoading, hasFailedLoading);
};
protoOf(LoadedModelInfoComponent).toString = function () {
  return 'LoadedModelInfoComponent(hasFinishedLoading=' + this.hasFinishedLoading + ', hasFailedLoading=' + this.hasFailedLoading + ')';
};
protoOf(LoadedModelInfoComponent).hashCode = function () {
  var result = getBooleanHashCode(this.hasFinishedLoading);
  result = imul(result, 31) + getBooleanHashCode(this.hasFailedLoading) | 0;
  return result;
};
protoOf(LoadedModelInfoComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LoadedModelInfoComponent))
    return false;
  var tmp0_other_with_cast = other instanceof LoadedModelInfoComponent ? other : THROW_CCE();
  if (!(this.hasFinishedLoading === tmp0_other_with_cast.hasFinishedLoading))
    return false;
  if (!(this.hasFailedLoading === tmp0_other_with_cast.hasFailedLoading))
    return false;
  return true;
};
function Companion_91() {
  Companion_instance_91 = this;
  this.id = Companion_instance_21.j1n_1;
}
protoOf(Companion_91).n1s = function () {
  return this.id;
};
var Companion_instance_91;
function Companion_getInstance_92() {
  if (Companion_instance_91 == null)
    new Companion_91();
  return Companion_instance_91;
}
function ModelInfoComponent(modelRootUrl, model, texture) {
  Companion_getInstance_92();
  texture = texture === VOID ? null : texture;
  this.modelRootUrl = modelRootUrl;
  this.model = model;
  this.texture = texture;
  this.modelUrl = UrlHelper_instance.r30(this.modelRootUrl, this.model);
}
protoOf(ModelInfoComponent).s30 = function () {
  return this.modelRootUrl;
};
protoOf(ModelInfoComponent).t30 = function () {
  return this.model;
};
protoOf(ModelInfoComponent).u30 = function () {
  return this.texture;
};
protoOf(ModelInfoComponent).p1s = function () {
  return Companion_getInstance_92().id;
};
protoOf(ModelInfoComponent).v30 = function () {
  return this.modelUrl;
};
protoOf(ModelInfoComponent).sameModel = function (other) {
  return this.model == other.model && this.modelRootUrl == other.modelRootUrl && this.texture == other.texture;
};
protoOf(ModelInfoComponent).eq = function (other) {
  return this.sameModel(other instanceof ModelInfoComponent ? other : THROW_CCE());
};
protoOf(ModelInfoComponent).tf = function () {
  return this.modelRootUrl;
};
protoOf(ModelInfoComponent).uf = function () {
  return this.model;
};
protoOf(ModelInfoComponent).m1m = function () {
  return this.texture;
};
protoOf(ModelInfoComponent).w30 = function (modelRootUrl, model, texture) {
  return new ModelInfoComponent(modelRootUrl, model, texture);
};
protoOf(ModelInfoComponent).copy = function (modelRootUrl, model, texture, $super) {
  modelRootUrl = modelRootUrl === VOID ? this.modelRootUrl : modelRootUrl;
  model = model === VOID ? this.model : model;
  texture = texture === VOID ? this.texture : texture;
  return this.w30(modelRootUrl, model, texture);
};
protoOf(ModelInfoComponent).toString = function () {
  return 'ModelInfoComponent(modelRootUrl=' + this.modelRootUrl + ', model=' + this.model + ', texture=' + this.texture + ')';
};
protoOf(ModelInfoComponent).hashCode = function () {
  var result = this.modelRootUrl == null ? 0 : getStringHashCode(this.modelRootUrl);
  result = imul(result, 31) + (this.model == null ? 0 : getStringHashCode(this.model)) | 0;
  result = imul(result, 31) + (this.texture == null ? 0 : getStringHashCode(this.texture)) | 0;
  return result;
};
protoOf(ModelInfoComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ModelInfoComponent))
    return false;
  var tmp0_other_with_cast = other instanceof ModelInfoComponent ? other : THROW_CCE();
  if (!(this.modelRootUrl == tmp0_other_with_cast.modelRootUrl))
    return false;
  if (!(this.model == tmp0_other_with_cast.model))
    return false;
  if (!(this.texture == tmp0_other_with_cast.texture))
    return false;
  return true;
};
function Companion_92() {
  Companion_instance_92 = this;
  this.ID = Companion_getInstance_143().r1v_1;
  this.x30_1 = LoggerState_getInstance().g1v('ModelLoaderSystem');
}
protoOf(Companion_92).j1y = function () {
  return this.ID;
};
var Companion_instance_92;
function Companion_getInstance_93() {
  if (Companion_instance_92 == null)
    new Companion_92();
  return Companion_instance_92;
}
function refreshModelsOnScene($this) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.l31_1.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.refreshModelsOnScene.<anonymous>' call
    if (element.__getComponentForKotlin(Companion_instance_21.j1n_1) == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.refreshModelsOnScene.<anonymous>.<anonymous>' call
      onModelInfoChanged($this, element);
    }
  }
}
function onModelInfoChanged($this, entity) {
  if (get_isInScene(entity)) {
    var oldViewerObject = entity.__getComponentForKotlin(Companion_instance_101.n1s());
    if (oldViewerObject == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      Companion_getInstance_95().p31(oldViewerObject.viewerObject, $this.m31_1);
    }
    loadModel_0($this, entity);
  }
}
function loadModel_0($this, entity) {
  Companion_getInstance_95().q31(entity, $this.m31_1);
}
function ModelLoaderSystem(entityManager, viewer) {
  Companion_getInstance_93();
  var tmp = Companion_getInstance_93().ID;
  var tmp_0 = Companion_instance_21.j1n_1;
  var tmp_1 = Companion_instance_21.b1n_1;
  var tmp_2 = Companion_instance_21.q1n_1;
  var tmp_3 = Companion_instance_21.n1r_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_4 = [Companion_instance_21.q1n_1];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [Companion_getInstance_143().t1v_1, Companion_getInstance_143().s1v_1];
  SystemBase4.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, null, tmp$ret$5);
  this.l31_1 = entityManager;
  this.m31_1 = viewer;
}
protoOf(ModelLoaderSystem).enable = function () {
  protoOf(SystemBase4).enable.call(this);
  refreshModelsOnScene(this);
};
protoOf(ModelLoaderSystem).onRegister = function () {
  protoOf(SystemBase4).onRegister.call(this);
  refreshModelsOnScene(this);
};
protoOf(ModelLoaderSystem).r31 = function (entity, newComponent) {
  onModelInfoChanged(this, entity);
};
protoOf(ModelLoaderSystem).v1v = function (entity, newComponent) {
  return this.r31(entity, newComponent instanceof ModelInfoComponent ? newComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).s31 = function (entity, oldComponent, newComponent) {
  if (!oldComponent.sameModel(newComponent) || get_viewerObject(entity) == null) {
    onModelInfoChanged(this, entity);
  }
};
protoOf(ModelLoaderSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ModelInfoComponent ? oldComponent : THROW_CCE();
  return this.s31(entity, tmp, newComponent instanceof ModelInfoComponent ? newComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).t31 = function (entity, oldComponent) {
};
protoOf(ModelLoaderSystem).z1v = function (entity, oldComponent) {
  return this.t31(entity, oldComponent instanceof ModelInfoComponent ? oldComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).u31 = function (entity, newComponent) {
  if (!entity.hasComponent(Companion_getInstance_91().id)) {
    loadModel_0(this, entity);
  }
};
protoOf(ModelLoaderSystem).l1z = function (entity, newComponent) {
  return this.u31(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).v31 = function (entity, oldComponent, newComponent) {
};
protoOf(ModelLoaderSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.v31(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).w31 = function (entity, oldComponent) {
};
protoOf(ModelLoaderSystem).p1z = function (entity, oldComponent) {
  return this.w31(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).x31 = function (entity, newComponent) {
};
protoOf(ModelLoaderSystem).n2m = function (entity, newComponent) {
  return this.x31(entity, newComponent instanceof LoadedModelInfoComponent ? newComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).y31 = function (entity, oldComponent, newComponent) {
};
protoOf(ModelLoaderSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof LoadedModelInfoComponent ? oldComponent : THROW_CCE();
  return this.y31(entity, tmp, newComponent instanceof LoadedModelInfoComponent ? newComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).z31 = function (entity, oldComponent) {
  var viewerObject = get_viewerObject(entity);
  if (viewerObject == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    Companion_getInstance_95().p31(viewerObject, this.m31_1);
  }
  entity.removeComponent(Companion_instance_101.n1s());
};
protoOf(ModelLoaderSystem).p2m = function (entity, oldComponent) {
  return this.z31(entity, oldComponent instanceof LoadedModelInfoComponent ? oldComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).a32 = function (entity, newComponent) {
  var tmp;
  var tmp0_safe_receiver = newComponent.entity;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_getInstance_92().id);
  if (tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs) {
    tmp = get_isInScene(entity);
  } else {
    tmp = false;
  }
  var shouldHaveComponent = tmp;
  var tmp2_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
  var didHaveComponent = (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hasComponent(Companion_getInstance_91().id)) === true;
  var modelWasRemoved = didHaveComponent && !shouldHaveComponent;
  var modelWasAdded = !didHaveComponent && shouldHaveComponent;
  var modelKept = didHaveComponent && shouldHaveComponent;
  if (modelWasRemoved) {
    var tmp3_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.getComponent(Companion_instance_101.n1s());
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.onAddComponent4.<anonymous>' call
      Companion_getInstance_95().p31(tmp4_safe_receiver.viewerObject, this.m31_1);
      entity.removeComponent(Companion_getInstance_91().id);
    }
  } else if (modelWasAdded) {
    loadModel_0(this, entity);
  } else if (modelKept) {
    var tmp5_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.getComponent(Companion_getInstance_91().id);
    if (tmp6_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.onAddComponent4.<anonymous>' call
      entity.addComponentInternal(tmp6_safe_receiver);
    }
    var tmp7_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.getComponent(Companion_instance_101.n1s());
    if (tmp8_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.rendering.ModelLoaderSystem.onAddComponent4.<anonymous>' call
      entity.addComponentInternal(tmp8_safe_receiver);
    }
  }
};
protoOf(ModelLoaderSystem).d2n = function (entity, newComponent) {
  return this.a32(entity, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).d32 = function (entity, oldComponent, newComponent) {
};
protoOf(ModelLoaderSystem).e2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE();
  return this.d32(entity, tmp, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(ModelLoaderSystem).e32 = function (entity, oldComponent) {
};
protoOf(ModelLoaderSystem).f2n = function (entity, oldComponent) {
  return this.e32(entity, oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE());
};
function Companion_93() {
}
protoOf(Companion_93).n1s = function () {
  return Companion_instance_21.o1r_1;
};
var Companion_instance_93;
function Companion_getInstance_94() {
  return Companion_instance_93;
}
function ModelTransformComponent(transform) {
  this.transform = transform;
}
protoOf(ModelTransformComponent).z2a = function () {
  return this.transform;
};
protoOf(ModelTransformComponent).p1s = function () {
  return Companion_instance_93.id;
};
protoOf(ModelTransformComponent).eq = function (other) {
  var tmp0_elvis_lhs = other instanceof ModelTransformComponent ? other : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var that = tmp;
  return that.transform.equals(this.transform);
};
function ModelUtils$Companion$loadModelFromModelInfo$lambda$lambda() {
  return 'Loading of model was completed after the entity was disposed or the viewer object was deleted.';
}
function ModelUtils$Companion$loadModelFromModelInfo$lambda($entity, $viewer) {
  return function (viewerObject) {
    if (!$entity.isDisposed && $viewer.existsModel(viewerObject.getViewerObjectId())) {
      var modelComponent = $entity.__getComponentForKotlin(Companion_getInstance_91().id);
      if (modelComponent == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        $entity.addComponent(modelComponent.withFinishedLoading());
      }
    } else {
      var tmp = Companion_getInstance_95().o31_1;
      tmp.info(ModelUtils$Companion$loadModelFromModelInfo$lambda$lambda);
    }
    return Unit_instance;
  };
}
function ModelUtils$Companion$loadModelFromModelInfo$o$lambda($entity) {
  return function () {
    return 'Failed to load model for ' + $entity.toString() + '. Listen to LoadedModelInfoComponent and check the hasFailedLoading property to handle this.';
  };
}
function ModelUtils$Companion$loadModelFromModelInfo$o($entity) {
  return function (_unused_var__etf5q3) {
    var tmp;
    if ($entity.isDisposed) {
      return Unit_instance;
    }
    var tmp_0 = Companion_getInstance_95().o31_1;
    tmp_0.warn(ModelUtils$Companion$loadModelFromModelInfo$o$lambda($entity));
    $entity.removeComponent(Companion_instance_101.n1s());
    var modelComponent = $entity.__getComponentForKotlin(Companion_getInstance_91().id);
    if (modelComponent == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      $entity.addComponent(modelComponent.withFailedLoading());
    }
    return Unit_instance;
  };
}
function ModelUtils$Companion$unloadModel$lambda($viewerObject) {
  return function () {
    return 'not removing model that does not exist ' + $viewerObject.getViewerObjectId();
  };
}
function ModelUtils$Companion$hide$lambda(it) {
  it.removeComponent(Companion_instance_98.id);
  return Unit_instance;
}
function ModelUtils$Companion$show$lambda(it) {
  it.addComponent(new RenderedComponent());
  return Unit_instance;
}
function Companion_94() {
  Companion_instance_94 = this;
  this.o31_1 = LoggerState_getInstance().g1v('ModelUtils');
}
protoOf(Companion_94).q31 = function (entity, viewer) {
  var tmp0_elvis_lhs = entity.__getComponentForKotlin(Companion_instance_21.j1n_1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var modelInfo = tmp;
  var onModelLoaded = ModelUtils$Companion$loadModelFromModelInfo$lambda(entity, viewer);
  var onModelLoadFailed = ModelUtils$Companion$loadModelFromModelInfo$o(entity);
  var loadingBox = this.f32(entity);
  var tmp1_elvis_lhs = modelInfo.modelUrl;
  var tmp_0 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = modelInfo.texture;
  var viewerObject = viewer.loadModel(entity, tmp_0, tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs, onModelLoaded, onModelLoadFailed, loadingBox.size.equals(Companion_getInstance_81().ZERO) ? null : loadingBox.size, loadingBox.size.equals(Companion_getInstance_81().ZERO) ? null : loadingBox.center);
  viewerObject.setCastShadows(true);
  if (get_isPropping(entity)) {
    viewerObject.setOutlined(false);
    viewerObject.setBlockOutlined(false);
  }
  entity.addComponent(new LoadedModelInfoComponent(false));
  entity.addComponent(new ViewerObjectComponent(viewerObject));
};
protoOf(Companion_94).f32 = function (entity) {
  var tmp;
  if (get_isPropping(entity)) {
    tmp = Companion_getInstance_125().y2v_1;
  } else {
    var tmp0_safe_receiver = get_colliderShapeComponent(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
    tmp = tmp2_elvis_lhs == null ? Companion_getInstance_125().y2v_1 : tmp2_elvis_lhs;
  }
  var aabb = tmp;
  return aabb;
};
protoOf(Companion_94).p31 = function (viewerObject, viewer) {
  if (viewer.existsModel(viewerObject.getViewerObjectId())) {
    viewerObject.deleteObject();
  } else {
    this.o31_1.warn(ModelUtils$Companion$unloadModel$lambda(viewerObject));
  }
};
protoOf(Companion_94).g32 = function (entity, traverseHierarchy) {
  if (traverseHierarchy) {
    var tmp = Companion_instance_62;
    tmp.d2r(entity, ModelUtils$Companion$hide$lambda);
  } else
    entity.removeComponent(Companion_instance_98.id);
};
protoOf(Companion_94).h32 = function (entity, traverseHierarchy) {
  if (traverseHierarchy) {
    var tmp = Companion_instance_62;
    tmp.d2r(entity, ModelUtils$Companion$show$lambda);
  } else
    entity.addComponent(new RenderedComponent());
};
var Companion_instance_94;
function Companion_getInstance_95() {
  if (Companion_instance_94 == null)
    new Companion_94();
  return Companion_instance_94;
}
function loadModelFromModelInfo(entity, viewer) {
  return Companion_getInstance_95().q31(entity, viewer);
}
function getLoadingBox(entity) {
  return Companion_getInstance_95().f32(entity);
}
function unloadModel(viewerObject, viewer) {
  return Companion_getInstance_95().p31(viewerObject, viewer);
}
function hide(entity, traverseHierarchy) {
  return Companion_getInstance_95().g32(entity, traverseHierarchy);
}
function show(entity, traverseHierarchy) {
  return Companion_getInstance_95().h32(entity, traverseHierarchy);
}
function ModelUtils() {
  Companion_getInstance_95();
}
function Companion_95() {
  Companion_instance_95 = this;
  this.id = Companion_instance_21.a1p_1;
}
protoOf(Companion_95).n1s = function () {
  return this.id;
};
var Companion_instance_95;
function Companion_getInstance_96() {
  if (Companion_instance_95 == null)
    new Companion_95();
  return Companion_instance_95;
}
function OutlineableComponent() {
  Companion_getInstance_96();
}
protoOf(OutlineableComponent).p1s = function () {
  return Companion_getInstance_96().id;
};
protoOf(OutlineableComponent).eq = function (other) {
  return true;
};
function Companion_96() {
  Companion_instance_96 = this;
  this.ID = Companion_instance_21.h1q_1;
}
protoOf(Companion_96).j1y = function () {
  return this.ID;
};
var Companion_instance_96;
function Companion_getInstance_97() {
  if (Companion_instance_96 == null)
    new Companion_96();
  return Companion_instance_96;
}
function PauseViewerUpdatesComponent() {
  Companion_getInstance_97();
}
protoOf(PauseViewerUpdatesComponent).p1s = function () {
  return Companion_getInstance_97().ID;
};
protoOf(PauseViewerUpdatesComponent).eq = function (other) {
  return true;
};
function get_hasPausedViewerUpdates(_this__u8e3s4) {
  var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_getInstance_97().ID)) === true;
}
function resumeViewerUpdatesOnDraggedEntity(sceneManager) {
  var tmp0_safe_receiver = sceneManager.scene.__getComponentForKotlin(Companion_getInstance_46().id);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.entity;
  if (tmp1_safe_receiver == null)
    null;
  else {
    resumeViewerUpdates(tmp1_safe_receiver);
  }
}
function pauseViewerUpdatesOnDraggedEntity(sceneManager) {
  var tmp0_safe_receiver = sceneManager.scene.__getComponentForKotlin(Companion_getInstance_46().id);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.entity;
  if (tmp1_safe_receiver == null)
    null;
  else {
    pauseViewerUpdates(tmp1_safe_receiver);
  }
}
function resumeViewerUpdates(_this__u8e3s4) {
  var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.removeComponent(Companion_getInstance_97().ID);
}
function pauseViewerUpdates(_this__u8e3s4) {
  var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.addComponent(new PauseViewerUpdatesComponent());
}
function Companion_97() {
  this.i32_1 = 'RenderSystem';
}
var Companion_instance_97;
function Companion_getInstance_98() {
  return Companion_instance_97;
}
function RenderSystem() {
  SystemBase.call(this, Companion_instance_97.i32_1, Companion_instance_21.b1n_1);
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.s32_1 = [Companion_instance_21.f1n_1];
}
protoOf(RenderSystem).j1w = function () {
  return this.s32_1;
};
protoOf(RenderSystem).t32 = function (entity, newComponent) {
  if (!entity.hasComponent(Companion_instance_98.id)) {
    entity.addComponent(new RenderedComponent());
    var tmp0_safe_receiver = get_parentComponent(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.rendering.RenderSystem.onAddComponent.<anonymous>' call
        this.t32(element, newComponent);
      }
    }
  }
};
protoOf(RenderSystem).v1v = function (entity, newComponent) {
  return this.t32(entity, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(RenderSystem).u32 = function (entity, oldComponent, newComponent) {
};
protoOf(RenderSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE();
  return this.u32(entity, tmp, newComponent instanceof InSceneComponent ? newComponent : THROW_CCE());
};
protoOf(RenderSystem).v32 = function (entity, oldComponent) {
  entity.removeComponent(Companion_instance_98.id);
  var tmp0_safe_receiver = get_parentComponent(entity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.rendering.RenderSystem.onRemoveComponent.<anonymous>' call
      this.v32(element, oldComponent);
    }
  }
};
protoOf(RenderSystem).z1v = function (entity, oldComponent) {
  return this.v32(entity, oldComponent instanceof InSceneComponent ? oldComponent : THROW_CCE());
};
function Companion_98() {
}
protoOf(Companion_98).n1s = function () {
  return Companion_instance_21.f1n_1;
};
var Companion_instance_98;
function Companion_getInstance_99() {
  return Companion_instance_98;
}
function RenderedComponent() {
}
protoOf(RenderedComponent).p1s = function () {
  return Companion_instance_98.id;
};
protoOf(RenderedComponent).eq = function (other) {
  return true;
};
function Viewer() {
}
function Companion_99() {
  Companion_instance_99 = this;
  this.ID = Companion_instance_21.z1p_1;
}
protoOf(Companion_99).j1y = function () {
  return this.ID;
};
var Companion_instance_99;
function Companion_getInstance_100() {
  if (Companion_instance_99 == null)
    new Companion_99();
  return Companion_instance_99;
}
function ViewerComponent(viewer) {
  Companion_getInstance_100();
  this.viewer = viewer;
  this.j33_1 = Companion_getInstance_100().ID;
}
protoOf(ViewerComponent).k33 = function () {
  return this.viewer;
};
protoOf(ViewerComponent).p1s = function () {
  return this.j33_1;
};
protoOf(ViewerComponent).eq = function (other) {
  var tmp;
  if (other instanceof ViewerComponent) {
    tmp = equals(this.viewer, other.viewer);
  } else {
    tmp = false;
  }
  return tmp;
};
function Companion_100() {
  Companion_instance_100 = this;
  this.id = Companion_instance_21.k1q_1;
}
protoOf(Companion_100).n1s = function () {
  return this.id;
};
var Companion_instance_100;
function Companion_getInstance_101() {
  if (Companion_instance_100 == null)
    new Companion_100();
  return Companion_instance_100;
}
function ViewerLineIdsComponent(lineIds) {
  Companion_getInstance_101();
  this.lineIds = lineIds;
  this.l33_1 = false;
}
protoOf(ViewerLineIdsComponent).m33 = function () {
  return this.lineIds;
};
protoOf(ViewerLineIdsComponent).p1s = function () {
  return Companion_getInstance_101().id;
};
protoOf(ViewerLineIdsComponent).eq = function (other) {
  return contentDeepEquals(this.lineIds, (other instanceof ViewerLineIdsComponent ? other : THROW_CCE()).lineIds);
};
protoOf(ViewerLineIdsComponent).s1s = function () {
  return this.l33_1;
};
function ViewerObject() {
}
function Companion_101() {
}
protoOf(Companion_101).n1s = function () {
  return Companion_instance_21.f1o_1;
};
var Companion_instance_101;
function Companion_getInstance_102() {
  return Companion_instance_101;
}
function get_id_1() {
  return Companion_instance_101.n1s();
}
function ViewerObjectComponent(viewerObject) {
  this.viewerObject = viewerObject;
  this.n31_1 = false;
}
protoOf(ViewerObjectComponent).o33 = function () {
  return this.viewerObject;
};
protoOf(ViewerObjectComponent).p1s = function () {
  return Companion_instance_101.n1s();
};
protoOf(ViewerObjectComponent).eq = function (other) {
  return equals((other instanceof ViewerObjectComponent ? other : THROW_CCE()).viewerObject, this.viewerObject);
};
protoOf(ViewerObjectComponent).s1s = function () {
  return this.n31_1;
};
protoOf(ViewerObjectComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof ViewerObjectComponent))
    THROW_CCE();
  return this.viewerObject.getViewerObjectId() === other.viewerObject.getViewerObjectId();
};
protoOf(ViewerObjectComponent).hashCode = function () {
  return this.viewerObject.getViewerObjectId();
};
protoOf(ViewerObjectComponent).tf = function () {
  return this.viewerObject;
};
protoOf(ViewerObjectComponent).p33 = function (viewerObject) {
  return new ViewerObjectComponent(viewerObject);
};
protoOf(ViewerObjectComponent).copy = function (viewerObject, $super) {
  viewerObject = viewerObject === VOID ? this.viewerObject : viewerObject;
  return this.p33(viewerObject);
};
protoOf(ViewerObjectComponent).toString = function () {
  return 'ViewerObjectComponent(viewerObject=' + toString_0(this.viewerObject) + ')';
};
function get_viewerObject(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_instance_101.n1s());
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.viewerObject;
}
function updateViewerObjectTransform($this, entity) {
  var tmp0_elvis_lhs = get_viewerObject(entity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var viewerObject = tmp;
  updateViewerObjectTransform_0($this, viewerObject, entity);
}
function updateViewerObjectTransform_0($this, viewerObject, entity) {
  viewerObject.setPosition(get_worldPosition(entity));
  viewerObject.setRotation(get_worldRotation(entity));
}
function ViewerObjectTransformSystem() {
  var tmp = Companion_getInstance_143().s1v_1;
  var tmp_0 = Companion_instance_21.g1n_1;
  var tmp_1 = Companion_instance_101.n1s();
  var tmp_2 = Companion_getInstance_131().id;
  var tmp_3 = Companion_instance_21.n1r_1;
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  SystemBase4.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp$ret$0, null, null);
}
protoOf(ViewerObjectTransformSystem).h1z = function (entity, newComponent) {
  if (get_hasPausedViewerUpdates(entity))
    return Unit_instance;
  updateViewerObjectTransform(this, entity);
};
protoOf(ViewerObjectTransformSystem).v1v = function (entity, newComponent) {
  return this.h1z(entity, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).i1z = function (entity, oldComponent, newComponent) {
  if (get_hasPausedViewerUpdates(entity))
    return Unit_instance;
  updateViewerObjectTransform(this, entity);
};
protoOf(ViewerObjectTransformSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE();
  return this.i1z(entity, tmp, newComponent instanceof WorldTransformComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).j1z = function (entity, oldComponent) {
};
protoOf(ViewerObjectTransformSystem).z1v = function (entity, oldComponent) {
  return this.j1z(entity, oldComponent instanceof WorldTransformComponent ? oldComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).d34 = function (entity, newComponent) {
  var viewerObject = newComponent.viewerObject;
  updateViewerObjectTransform_0(this, viewerObject, entity);
};
protoOf(ViewerObjectTransformSystem).l1z = function (entity, newComponent) {
  return this.d34(entity, newComponent instanceof ViewerObjectComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).e34 = function (entity, oldComponent, newComponent) {
  var viewerObject = newComponent.viewerObject;
  updateViewerObjectTransform_0(this, viewerObject, entity);
};
protoOf(ViewerObjectTransformSystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerObjectComponent ? oldComponent : THROW_CCE();
  return this.e34(entity, tmp, newComponent instanceof ViewerObjectComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).f34 = function (entity, oldComponent) {
};
protoOf(ViewerObjectTransformSystem).p1z = function (entity, oldComponent) {
  return this.f34(entity, oldComponent instanceof ViewerObjectComponent ? oldComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).g34 = function (entity, newComponent) {
};
protoOf(ViewerObjectTransformSystem).n2m = function (entity, newComponent) {
  return this.g34(entity, newComponent instanceof MovedToValidSnapPositionComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).h34 = function (entity, oldComponent, newComponent) {
};
protoOf(ViewerObjectTransformSystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof MovedToValidSnapPositionComponent ? oldComponent : THROW_CCE();
  return this.h34(entity, tmp, newComponent instanceof MovedToValidSnapPositionComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).i34 = function (entity, oldComponent) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_snapRootSubTree(entity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.rendering.ViewerObjectTransformSystem.onRemoveComponent3.<anonymous>' call
    updateViewerObjectTransform(this, element);
  }
};
protoOf(ViewerObjectTransformSystem).p2m = function (entity, oldComponent) {
  return this.i34(entity, oldComponent instanceof MovedToValidSnapPositionComponent ? oldComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).a32 = function (entity, newComponent) {
  var tmp0_elvis_lhs = newComponent.entity;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var newEntity = tmp;
  updateViewerObjectTransform(this, newEntity);
};
protoOf(ViewerObjectTransformSystem).d2n = function (entity, newComponent) {
  return this.a32(entity, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).d32 = function (entity, oldComponent, newComponent) {
};
protoOf(ViewerObjectTransformSystem).e2n = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE();
  return this.d32(entity, tmp, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectTransformSystem).e32 = function (entity, oldComponent) {
};
protoOf(ViewerObjectTransformSystem).f2n = function (entity, oldComponent) {
  return this.e32(entity, oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE());
};
function setVisibilityOfObject($this, entity, viewerObjectComponent) {
  if (entity.hasComponent(Companion_instance_21.f1n_1))
    viewerObjectComponent.viewerObject.setVisible(true);
  else
    viewerObjectComponent.viewerObject.setVisible(false);
}
function ViewerObjectVisibilitySystem() {
  var tmp = Companion_getInstance_143().t1v_1;
  var tmp_0 = Companion_instance_21.f1n_1;
  var tmp_1 = Companion_instance_21.f1o_1;
  var tmp_2 = Companion_instance_21.n1r_1;
  // Inline function 'kotlin.emptyArray' call
  var tmp_3 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_4 = [Companion_getInstance_143().n1v_1];
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$4 = [];
  SystemBase3.call(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$4);
}
protoOf(ViewerObjectVisibilitySystem).v34 = function (entity, newComponent) {
  var tmp0_safe_receiver = get_viewerObject(entity);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.setVisible(true);
};
protoOf(ViewerObjectVisibilitySystem).v1v = function (entity, newComponent) {
  return this.v34(entity, newComponent instanceof RenderedComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectVisibilitySystem).w34 = function (entity, oldComponent, newComponent) {
};
protoOf(ViewerObjectVisibilitySystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof RenderedComponent ? oldComponent : THROW_CCE();
  return this.w34(entity, tmp, newComponent instanceof RenderedComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectVisibilitySystem).x34 = function (entity, oldComponent) {
  var tmp0_safe_receiver = get_viewerObject(entity);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.setVisible(false);
};
protoOf(ViewerObjectVisibilitySystem).z1v = function (entity, oldComponent) {
  return this.x34(entity, oldComponent instanceof RenderedComponent ? oldComponent : THROW_CCE());
};
protoOf(ViewerObjectVisibilitySystem).d34 = function (entity, newComponent) {
  setVisibilityOfObject(this, entity, newComponent);
};
protoOf(ViewerObjectVisibilitySystem).l1z = function (entity, newComponent) {
  return this.d34(entity, newComponent instanceof ViewerObjectComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectVisibilitySystem).e34 = function (entity, oldComponent, newComponent) {
  setVisibilityOfObject(this, entity, newComponent);
};
protoOf(ViewerObjectVisibilitySystem).n1z = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerObjectComponent ? oldComponent : THROW_CCE();
  return this.e34(entity, tmp, newComponent instanceof ViewerObjectComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectVisibilitySystem).f34 = function (entity, oldComponent) {
};
protoOf(ViewerObjectVisibilitySystem).p1z = function (entity, oldComponent) {
  return this.f34(entity, oldComponent instanceof ViewerObjectComponent ? oldComponent : THROW_CCE());
};
protoOf(ViewerObjectVisibilitySystem).y34 = function (entity, newComponent) {
  var tmp0_elvis_lhs = newComponent.entity;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var newEntity = tmp;
  var tmp1_safe_receiver = newEntity.__getComponentForKotlin(Companion_instance_101.n1s());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    setVisibilityOfObject(this, newEntity, tmp1_safe_receiver);
  }
};
protoOf(ViewerObjectVisibilitySystem).n2m = function (entity, newComponent) {
  return this.y34(entity, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectVisibilitySystem).z34 = function (entity, oldComponent, newComponent) {
};
protoOf(ViewerObjectVisibilitySystem).o2m = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE();
  return this.z34(entity, tmp, newComponent instanceof UpdatedFromSnapshotEventComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerObjectVisibilitySystem).a35 = function (entity, oldComponent) {
};
protoOf(ViewerObjectVisibilitySystem).p2m = function (entity, oldComponent) {
  return this.a35(entity, oldComponent instanceof UpdatedFromSnapshotEventComponent ? oldComponent : THROW_CCE());
};
function registerAll($this, newViewer) {
  var modelLoaderSystem = new ModelLoaderSystem($this.k35_1, newViewer);
  $this.k35_1.registerSystem(modelLoaderSystem);
  $this.m35_1 = modelLoaderSystem;
}
function unregisterAll($this) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.k35_1.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.rendering.ViewerPresenceSystem.unregisterAll.<anonymous>' call
    $this.k35_1.removeComponent(element, Companion_instance_21.q1n_1);
  }
  var tmp0_safe_receiver = $this.m35_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.disable();
  }
  var tmp1_safe_receiver = $this.m35_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.m2d($this.k35_1);
  }
}
function ViewerPresenceSystem(entityManager) {
  SystemBase.call(this, Companion_getInstance_143().q1v_1, Companion_instance_21.z1p_1);
  this.k35_1 = entityManager;
  var tmp = this;
  // Inline function 'kotlin.emptyArray' call
  tmp.l35_1 = [];
  this.m35_1 = null;
}
protoOf(ViewerPresenceSystem).j1w = function () {
  return this.l35_1;
};
protoOf(ViewerPresenceSystem).n35 = function (entity, newComponent) {
  registerAll(this, newComponent.viewer);
};
protoOf(ViewerPresenceSystem).v1v = function (entity, newComponent) {
  return this.n35(entity, newComponent instanceof ViewerComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerPresenceSystem).o35 = function (entity, oldComponent, newComponent) {
  unregisterAll(this);
  registerAll(this, newComponent.viewer);
};
protoOf(ViewerPresenceSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof ViewerComponent ? oldComponent : THROW_CCE();
  return this.o35(entity, tmp, newComponent instanceof ViewerComponent ? newComponent : THROW_CCE());
};
protoOf(ViewerPresenceSystem).p35 = function (entity, oldComponent) {
  unregisterAll(this);
};
protoOf(ViewerPresenceSystem).z1v = function (entity, oldComponent) {
  return this.p35(entity, oldComponent instanceof ViewerComponent ? oldComponent : THROW_CCE());
};
function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda($oldEntity) {
  return function (it) {
    return hierarchyContains($oldEntity, it.hostConnectorEntity);
  };
}
function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_0($oldEntity) {
  return function (it) {
    return !hierarchyContains($oldEntity, it.guestConnectorEntity);
  };
}
function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_1(it) {
  return it.guestConnectionRoot;
}
function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_2($oldEntity, $newEntity) {
  return function (guestConnectionRoot) {
    var tmp0_safe_receiver = get_snapRoot(guestConnectionRoot);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_highestPriorityConnection(tmp0_safe_receiver);
    var host = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hostConnectorEntity;
    var tmp;
    if (equals(host == null ? null : get_connectionRootEntity(host), $oldEntity)) {
      tmp = new Pair(guestConnectionRoot, $newEntity);
    } else {
      tmp = new Pair(guestConnectionRoot, host);
    }
    return tmp;
  };
}
function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_3($oldEntity) {
  return function (_destruct__k2r9zo) {
    var host = _destruct__k2r9zo.uf();
    return !equals(host, $oldEntity);
  };
}
function EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_4($validationService) {
  return function (_destruct__k2r9zo) {
    var connectionRoot = _destruct__k2r9zo.tf();
    var host = _destruct__k2r9zo.uf();
    var tmp0_safe_receiver = get_snapRoot(connectionRoot);
    var oldConnection = tmp0_safe_receiver == null ? null : get_highestPriorityConnection(tmp0_safe_receiver);
    return new EntityReplaceHelper(connectionRoot, oldConnection, host, $validationService, 0.0);
  };
}
function EntityReplaceHelper_init_$Init$(entity, host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy, $this) {
  allowedMovementsOfChildrenInMilliMeter = allowedMovementsOfChildrenInMilliMeter === VOID ? 1.7976931348623157E308 : allowedMovementsOfChildrenInMilliMeter;
  snapSelectStrategy = snapSelectStrategy === VOID ? Companion_getInstance_133().r35_1 : snapSelectStrategy;
  EntityReplaceHelper.call($this, entity, get_highestPriorityConnection(entity), host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy);
  return $this;
}
function EntityReplaceHelper_init_$Create$(entity, host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy) {
  return EntityReplaceHelper_init_$Init$(entity, host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy, objectCreate(protoOf(EntityReplaceHelper)));
}
function snap($this, host) {
  var tmp0_elvis_lhs = get_snapRoot($this.w1k_1);
  var entityRoot = tmp0_elvis_lhs == null ? $this.w1k_1 : tmp0_elvis_lhs;
  var tmp1_safe_receiver = tryCreateCandidateToExactlyTheSameConnectors($this, entityRoot, host);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    if (isCandidateValid($this, tmp1_safe_receiver)) {
      tmp1_safe_receiver.performMoveAndConnect();
      return Unit_instance;
    }
  }
  var epsilon = 1.0E-4;
  var settings = new SnapSettings(true, false, true, true);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.b1l_1.sortAndSelect(Companion_instance_137.p1l(entityRoot, host, settings));
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.replace.EntityReplaceHelper.snap.<anonymous>' call
    if (element.movement.size <= $this.a1l_1 + epsilon) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.replace.EntityReplaceHelper.snap.<anonymous>' call
    if (isCandidateValid($this, element_0)) {
      destination_0.h(element_0);
    }
  }
  var candidates = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = candidates.k();
  while (tmp0_iterator_0.m()) {
    var element_1 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.replace.EntityReplaceHelper.snap.<anonymous>' call
    if (element_1.hostConnector.key === $this.d1l_1) {
      destination_1.h(element_1);
    }
  }
  var candidateWithSameHostConnector = destination_1;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$11;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator_1 = candidateWithSameHostConnector.k();
    while (tmp0_iterator_1.m()) {
      var element_2 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.replace.EntityReplaceHelper.snap.<anonymous>' call
      if (element_2.guestConnector.key === $this.e1l_1) {
        tmp$ret$11 = element_2;
        break $l$block;
      }
    }
    tmp$ret$11 = null;
  }
  var candidatesWithSameGuestConnector = tmp$ret$11;
  var tmp3_elvis_lhs = candidatesWithSameGuestConnector == null ? firstOrNull_1(candidateWithSameHostConnector) : candidatesWithSameGuestConnector;
  var candidate = tmp3_elvis_lhs == null ? firstOrNull_1(candidates) : tmp3_elvis_lhs;
  if (candidate == null)
    null;
  else {
    candidate.performMoveAndConnect();
  }
}
function tryCreateCandidateToExactlyTheSameConnectors($this, guest, host) {
  if (!($this.x1k_1 == null) && !(host == null)) {
    var sameHostConnector = findSameHostConnector($this, host);
    var sameGuestConnector = findSameGuestConnector($this, guest);
    if (!(sameHostConnector == null) && !(sameGuestConnector == null) && sameGuestConnector.hasMatchingTypeAndDemandsTo(sameHostConnector)) {
      return Companion_instance_137.f30(guest, sameGuestConnector, host, sameHostConnector);
    }
  }
  return null;
}
function findSameHostConnector($this, host) {
  var tmp0_safe_receiver = get_connectorsComponent(host);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r27();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp1_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.replace.EntityReplaceHelper.findSameHostConnector.<anonymous>' call
      if (element.key === $this.d1l_1) {
        return element;
      } else {
        if (element instanceof PointSeriesConnector) {
          // Inline function 'kotlin.sequences.find' call
          var this_0 = element.u2b();
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.sequences.firstOrNull' call
            var tmp0_iterator_0 = this_0.k();
            while (tmp0_iterator_0.m()) {
              var element_0 = tmp0_iterator_0.n();
              // Inline function 'com.ikea.core.replace.EntityReplaceHelper.findSameHostConnector.<anonymous>.<anonymous>' call
              if (element_0.key === $this.d1l_1) {
                tmp$ret$1 = element_0;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var foundSubConnector = tmp$ret$1;
          if (!(foundSubConnector == null))
            return foundSubConnector;
        }
      }
    }
  }
  return null;
}
function findSameGuestConnector($this, guest) {
  var tmp0_safe_receiver = get_connectorsComponent(guest);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp1_safe_receiver.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.replace.EntityReplaceHelper.findSameGuestConnector.<anonymous>' call
        if (element.key === $this.e1l_1) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  return tmp;
}
function isCandidateValid($this, candidate) {
  var tmp0_safe_receiver = $this.z1k_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.validateSnapCandidate(candidate);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.valid;
  var isValid = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
  return isValid;
}
function Companion_102() {
}
protoOf(Companion_102).q1t = function (oldEntity, newEntity, validationService) {
  var tmp0_safe_receiver = get_connectionRootEntity(oldEntity);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_hostedConnections(tmp0_safe_receiver);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : asSequence_0(tmp1_safe_receiver);
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    tmp = filter(tmp2_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda(oldEntity));
  }
  var tmp3_safe_receiver = tmp;
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    tmp_0 = filter(tmp3_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_0(oldEntity));
  }
  var tmp4_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp4_safe_receiver == null) {
    tmp_1 = null;
  } else {
    tmp_1 = map(tmp4_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_1);
  }
  var tmp5_safe_receiver = tmp_1;
  var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : distinct_0(tmp5_safe_receiver);
  var tmp_2;
  if (tmp6_safe_receiver == null) {
    tmp_2 = null;
  } else {
    tmp_2 = map(tmp6_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_2(oldEntity, newEntity));
  }
  var tmp7_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp7_safe_receiver == null) {
    tmp_3 = null;
  } else {
    tmp_3 = filter(tmp7_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_3(oldEntity));
  }
  var tmp8_safe_receiver = tmp_3;
  var tmp_4;
  if (tmp8_safe_receiver == null) {
    tmp_4 = null;
  } else {
    tmp_4 = map(tmp8_safe_receiver, EntityReplaceHelper$Companion$entityHelpersForHostedConnectionsInProductHierarchy$lambda_4(validationService));
  }
  var tmp9_safe_receiver = tmp_4;
  var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : toList_0(tmp9_safe_receiver);
  return tmp10_elvis_lhs == null ? emptyList() : tmp10_elvis_lhs;
};
var Companion_instance_102;
function Companion_getInstance_103() {
  return Companion_instance_102;
}
function EntityReplaceHelper(entity, oldConnection, host, validationService, allowedMovementsOfChildrenInMilliMeter, snapSelectStrategy) {
  allowedMovementsOfChildrenInMilliMeter = allowedMovementsOfChildrenInMilliMeter === VOID ? 1.7976931348623157E308 : allowedMovementsOfChildrenInMilliMeter;
  snapSelectStrategy = snapSelectStrategy === VOID ? Companion_getInstance_133().r35_1 : snapSelectStrategy;
  this.w1k_1 = entity;
  this.x1k_1 = oldConnection;
  this.y1k_1 = host;
  this.z1k_1 = validationService;
  this.a1l_1 = allowedMovementsOfChildrenInMilliMeter;
  this.b1l_1 = snapSelectStrategy;
  var tmp = this;
  var tmp0_safe_receiver = this.x1k_1;
  tmp.c1l_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectorEntity;
  var tmp_0 = this;
  var tmp0_safe_receiver_0 = this.x1k_1;
  tmp_0.d1l_1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.hostConnectorKey;
  var tmp_1 = this;
  var tmp0_safe_receiver_1 = this.x1k_1;
  tmp_1.e1l_1 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.guestConnectorKey;
}
protoOf(EntityReplaceHelper).s4 = function () {
  var worldTransform = get_worldTransform(this.w1k_1);
  Companion_instance_25.j29(this.w1k_1);
  setParent_0(this.w1k_1, null);
  this.w1k_1.addComponent(new LocalTransformComponent(worldTransform));
};
protoOf(EntityReplaceHelper).u35 = function (checkIfDisposed) {
  if (checkIfDisposed && this.w1k_1.isDisposed) {
    return Unit_instance;
  }
  if (this.y1k_1 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    snap(this, this.y1k_1);
  }
};
protoOf(EntityReplaceHelper).v35 = function (checkIfDisposed, $super) {
  checkIfDisposed = checkIfDisposed === VOID ? false : checkIfDisposed;
  var tmp;
  if ($super === VOID) {
    this.u35(checkIfDisposed);
    tmp = Unit_instance;
  } else {
    tmp = $super.u35.call(this, checkIfDisposed);
  }
  return tmp;
};
protoOf(EntityReplaceHelper).r1t = function () {
  if (this.c1l_1 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    snap(this, this.c1l_1);
  }
};
function entityGroupStuff($this, entityGroup, newEntity, oldEntity) {
  if (entityGroup == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    addAutomaticGroupMember(entityGroup, newEntity);
    removeAutomaticGroupMember(entityGroup, oldEntity);
    Companion_getInstance_54().setGroupMemberComponents(newEntity, entityGroup);
    Companion_getInstance_54().removeFromEntityGroup(oldEntity);
    Companion_getInstance_54().handleLockedMembersOfGroup(entityGroup);
  }
}
function replaceInScene($this, newEntity, oldEntity) {
  setParentMaintainWorldTransform(newEntity, get_parent(oldEntity));
  setParentMaintainWorldTransform(oldEntity, null);
}
function adoptChildren($this, newEntity, oldEntity) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_immediateConnectionRootDescendants(oldEntity);
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptChildren.<anonymous>' call
    if (get_isConnectionRoot(element)) {
      destination.h(element);
    }
  }
  var tmp0_iterator_0 = destination.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptChildren.<anonymous>' call
    setParent_0(element_0, newEntity);
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_1 = get_children(oldEntity);
  var destination_0 = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_1.length;
  while (inductionVariable < last) {
    var element_1 = this_1[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptChildren.<anonymous>' call
    if (element_1.hasComponent(Companion_instance_21.g1s_1)) {
      destination_0.h(element_1);
    }
  }
  var tmp0_iterator_1 = destination_0.k();
  while (tmp0_iterator_1.m()) {
    var element_2 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptChildren.<anonymous>' call
    setParent_0(element_2, newEntity);
  }
}
function adoptConnections($this, newEntity, oldEntity) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = get_guestConnections(oldEntity);
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptConnections.<anonymous>' call
    var tmp0_safe_receiver = createSimilarGuestConnection($this, newEntity, element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  var newGuestConnections = copyToArray(destination);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_1 = get_hostedConnections(oldEntity);
  var destination_0 = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = this_1.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = this_1[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptConnections.<anonymous>' call
    var tmp0_safe_receiver_0 = createSimilarHostConnection($this, newEntity, element_0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_0.h(tmp0_safe_receiver_0);
    }
  }
  var newHostConnections = copyToArray(destination_0);
  // Inline function 'kotlin.collections.set' call
  var this_2 = $this.b36_1;
  var value = oldEntity.__getComponentForKotlin(Companion_getInstance_27().id);
  this_2.q2(oldEntity, value);
  oldEntity.removeComponent(Companion_getInstance_27().id);
  if (any(newGuestConnections)) {
    newEntity.addComponent(new GuestConnectionsComponent(newGuestConnections));
  } else
    newEntity.removeComponent(Companion_getInstance_27().id);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_1 = 0;
  var last_1 = newHostConnections.length;
  while (inductionVariable_1 < last_1) {
    var element_1 = newHostConnections[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.core.replace.FastReplaceAction.adoptConnections.<anonymous>' call
    var tmp0_elvis_lhs = get_connectionRootEntity(element_1.guestConnectorEntity);
    var guest = tmp0_elvis_lhs == null ? element_1.guestConnectorEntity : tmp0_elvis_lhs;
    var tmp1_safe_receiver = guest.__getComponentForKotlin(Companion_getInstance_27().id);
    var newGuestConnectionsComponent = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.withReplacedConnection(element_1);
    if (!(newGuestConnectionsComponent == null)) {
      var wasPaused = guest.hasComponent(Companion_getInstance_29().s29_1);
      guest.addComponent(new TemporarilyPauseConnectionParentingComponent());
      // Inline function 'kotlin.collections.set' call
      var this_3 = $this.b36_1;
      var value_0 = guest.__getComponentForKotlin(Companion_getInstance_27().id);
      this_3.q2(guest, value_0);
      guest.addComponent(newGuestConnectionsComponent);
      if (!wasPaused) {
        guest.removeComponent(Companion_getInstance_29().s29_1);
      }
    }
  }
}
function createSimilarGuestConnection($this, newEntity, connection) {
  var tmp0_safe_receiver = get_connectorsComponent(newEntity);
  var newGuestConnector = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey(connection.guestConnectorKey);
  if (newGuestConnector == null) {
    // Inline function 'kotlin.collections.find' call
    var tmp = Companion_instance_25;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [connection.hostConnectorEntity];
    var this_0 = tmp.e29(newEntity, tmp$ret$2);
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.replace.FastReplaceAction.createSimilarGuestConnection.<anonymous>' call
        if (element.hostConnectorEntity.equals(connection.hostConnectorEntity) && element.hostConnectorKey === connection.hostConnectorKey) {
          tmp$ret$4 = element;
          break $l$block;
        }
      }
      tmp$ret$4 = null;
    }
    var tmp1_safe_receiver = tmp$ret$4;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp1_safe_receiver;
    }
    var tmp_0 = Companion_getInstance_104().d36_1;
    tmp_0.warn(FastReplaceAction$createSimilarGuestConnection$lambda(connection, newEntity));
    return null;
  }
  return new Connection(newEntity, newGuestConnector.key, connection.hostConnectorEntity, connection.hostConnectorKey, connection.hostGuestConnectorDeltaTransform);
}
function createSimilarHostConnection($this, newEntity, connection) {
  var tmp0_safe_receiver = get_connectorsComponent(newEntity);
  var newHostConnector = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey(connection.hostConnectorKey);
  if (newHostConnector == null) {
    // Inline function 'kotlin.collections.find' call
    var tmp = Companion_instance_25;
    var tmp_0 = connection.guestConnectionRoot;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [newEntity];
    var this_0 = tmp.e29(tmp_0, tmp$ret$2);
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.replace.FastReplaceAction.createSimilarHostConnection.<anonymous>' call
        if (element.guestConnectorEntity.equals(connection.guestConnectorEntity) && element.guestConnectorKey === connection.guestConnectorKey) {
          tmp$ret$4 = element;
          break $l$block;
        }
      }
      tmp$ret$4 = null;
    }
    var tmp1_safe_receiver = tmp$ret$4;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp1_safe_receiver;
    }
    var tmp_1 = Companion_getInstance_104().d36_1;
    tmp_1.warn(FastReplaceAction$createSimilarHostConnection$lambda(connection, newEntity));
    return null;
  }
  return fromConnectors(connection.guestConnectorEntity, connection.guestConnector, newEntity, newHostConnector, connection.hostGuestConnectorDeltaTransform);
}
function Companion_103() {
  Companion_instance_103 = this;
  this.d36_1 = LoggerState_getInstance().g1v('FastReplaceAction');
}
var Companion_instance_103;
function Companion_getInstance_104() {
  if (Companion_instance_103 == null)
    new Companion_103();
  return Companion_instance_103;
}
function FastReplaceAction$createSimilarGuestConnection$lambda($connection, $newEntity) {
  return function () {
    return 'Could not find corresponding guest connector to ' + $connection.guestConnectorKey + ' on ' + get_displayName($newEntity);
  };
}
function FastReplaceAction$createSimilarHostConnection$lambda($connection, $newEntity) {
  return function () {
    return 'Could not find corresponding host connector to ' + $connection.hostConnectorKey + ' on ' + get_displayName($newEntity);
  };
}
function FastReplaceAction(oldEntity, newEntity, entityManager, validationService, sceneManager) {
  Companion_getInstance_104();
  this.w35_1 = oldEntity;
  this.x35_1 = newEntity;
  this.y35_1 = entityManager;
  this.z35_1 = validationService;
  this.a36_1 = sceneManager;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.b36_1 = LinkedHashMap_init_$Create$_0();
  this.c36_1 = get_automaticEntityGroup(this.w35_1);
  this.x35_1.addComponent(new LocalTransformComponent(get_worldTransform(this.w35_1)));
}
protoOf(FastReplaceAction).f1l = function () {
  this.w35_1.addComponent(new TemporarilyPauseConnectionParentingComponent());
  this.x35_1.addComponent(new TemporarilyPauseConnectionParentingComponent());
  adoptChildren(this, this.x35_1, this.w35_1);
  replaceInScene(this, this.x35_1, this.w35_1);
  adoptConnections(this, this.x35_1, this.w35_1);
  entityGroupStuff(this, this.c36_1, this.x35_1, this.w35_1);
  this.w35_1.removeComponent(Companion_getInstance_29().s29_1);
  this.x35_1.removeComponent(Companion_getInstance_29().s29_1);
};
protoOf(FastReplaceAction).toString = function () {
  return 'Fast Replace Action old ' + this.w35_1.toString() + ' for new ' + this.x35_1.toString();
};
function ReplaceAction(oldEntity, newEntity, allowedMovementsOfChildrenInMilliMeter, validationService, sceneManager) {
  this.e36_1 = oldEntity;
  this.f36_1 = newEntity;
  this.g36_1 = allowedMovementsOfChildrenInMilliMeter;
  this.h36_1 = validationService;
  this.i36_1 = sceneManager;
  this.e36_1.addComponent(new SlowReplaceInProgressComponent());
  this.f36_1.addComponent(new LocalTransformComponent(get_worldTransform(this.e36_1)));
  this.j36_1 = Companion_instance_102.q1t(this.e36_1, this.f36_1, this.h36_1);
  var tmp = this;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_immediateConnectionRootDescendants(this.e36_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.replace.ReplaceAction.descendantEntityHelpers.<anonymous>' call
    var tmp$ret$0 = EntityReplaceHelper_init_$Create$(item, this.f36_1, this.h36_1, this.g36_1);
    destination.h(tmp$ret$0);
  }
  tmp.k36_1 = destination;
  this.l36_1 = EntityReplaceHelper_init_$Create$(this.e36_1, null, this.h36_1);
  var tmp_0 = this;
  var tmp0_safe_receiver = get_snapRoot(this.e36_1);
  var tmp_1 = tmp0_safe_receiver == null ? null : get_highestPriorityConnection(tmp0_safe_receiver);
  var tmp1_safe_receiver = get_snapRoot(this.e36_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_highestPriorityConnection(tmp1_safe_receiver);
  tmp_0.m36_1 = new EntityReplaceHelper(this.f36_1, tmp_1, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hostConnectorEntity, this.h36_1);
}
protoOf(ReplaceAction).f1l = function () {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.j36_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.replace.ReplaceAction.perform.<anonymous>' call
    element.s4();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = this.k36_1.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.replace.ReplaceAction.perform.<anonymous>' call
    element_0.s4();
  }
  this.l36_1.s4();
  this.m36_1.v35();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_1 = this.k36_1.k();
  while (tmp0_iterator_1.m()) {
    var element_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.replace.ReplaceAction.perform.<anonymous>' call
    element_1.u35(true);
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_2 = this.j36_1.k();
  while (tmp0_iterator_2.m()) {
    var element_2 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.replace.ReplaceAction.perform.<anonymous>' call
    element_2.v35();
  }
  this.e36_1.removeComponent(Companion_instance_104.n1s());
};
protoOf(ReplaceAction).toString = function () {
  return 'Replace Action old ' + this.e36_1.toString() + ' for new ' + this.f36_1.toString();
};
function replacePartInAssembly($this, entityToAdd, entityToReplace) {
  connectPartToAssembly_1($this, entityToAdd);
  adoptAllChildrenParts($this, entityToReplace, entityToAdd, $this.p36_1);
}
function removeAllConnectionRoots($this, newEntity) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_descendants(newEntity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.replace.ReplacePartAction.removeAllConnectionRoots.<anonymous>' call
    if (get_isConnectionRoot(element)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.removeAllConnectionRoots.<anonymous>' call
    $this.r36_1.disposeEntity(element_0);
  }
}
function connectPartToAssembly_1($this, entity) {
  Companion_instance.u1k($this.q36_1, entity, $this.p36_1);
}
function adoptAllChildrenParts($this, entityToReplace, entityToAdd, assemblyPart) {
  var childrenParts = assemblyPart.children;
  if (childrenParts == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = childrenParts.length;
    while (inductionVariable < last) {
      var element = childrenParts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $l$block_0: {
        // Inline function 'com.ikea.core.replace.ReplacePartAction.adoptAllChildrenParts.<anonymous>' call
        // Inline function 'kotlin.collections.find' call
        var this_0 = get_children(entityToReplace);
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable_0 = 0;
          var last_0 = this_0.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = this_0[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.replace.ReplacePartAction.adoptAllChildrenParts.<anonymous>.<anonymous>' call
            if (get_partKey(element_0) === element.partKey) {
              tmp$ret$1 = element_0;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_elvis_lhs = tmp$ret$1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$block_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childEntity = tmp;
        Companion_instance.u1k(entityToAdd, childEntity, element);
      }
    }
  }
}
function ReplacePartAction(oldEntity, newEntity, assemblyPart, parent, entityManager, validationService, sceneManager) {
  this.n36_1 = oldEntity;
  this.o36_1 = newEntity;
  this.p36_1 = assemblyPart;
  this.q36_1 = parent;
  this.r36_1 = entityManager;
  this.s36_1 = validationService;
  this.t36_1 = sceneManager;
  var tmp = this;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = get_children(this.n36_1);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.replace.ReplacePartAction.childEntityHelpers.<anonymous>' call
    if (get_isConnectionRoot(element)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.childEntityHelpers.<anonymous>' call
    var tmp$ret$3 = EntityReplaceHelper_init_$Create$(item, this.o36_1, this.s36_1);
    destination_0.h(tmp$ret$3);
  }
  tmp.u36_1 = destination_0;
  this.v36_1 = Companion_instance_102.q1t(this.n36_1, this.o36_1, this.s36_1);
  var tmp_0 = this;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get_immediateConnectionRootDescendants(this.n36_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.k();
  while (tmp0_iterator_0.m()) {
    var item_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.descendantEntityHelpers.<anonymous>' call
    var tmp$ret$6 = EntityReplaceHelper_init_$Create$(item_0, this.o36_1, this.s36_1, 1.7976931348623157E308);
    destination_1.h(tmp$ret$6);
  }
  tmp_0.w36_1 = destination_1;
  this.x36_1 = EntityReplaceHelper_init_$Create$(this.n36_1, null, this.s36_1);
  var tmp_1 = this;
  var tmp0_safe_receiver = get_connectionRootEntity(this.n36_1);
  var tmp_2 = tmp0_safe_receiver == null ? null : get_highestPriorityConnection(tmp0_safe_receiver);
  var tmp1_safe_receiver = get_connectionRootEntity(this.n36_1);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_highestPriorityConnection(tmp1_safe_receiver);
  tmp_1.y36_1 = new EntityReplaceHelper(this.o36_1, tmp_2, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hostConnectorEntity, this.s36_1);
}
protoOf(ReplacePartAction).v1k = function () {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.v36_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.rollback.<anonymous>' call
    element.s4();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = this.u36_1.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.rollback.<anonymous>' call
    element_0.s4();
  }
  this.y36_1.s4();
  replacePartInAssembly(this, this.n36_1, this.o36_1);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_1 = this.w36_1.k();
  while (tmp0_iterator_1.m()) {
    var element_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.rollback.<anonymous>' call
    element_1.r1t();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_2 = this.v36_1.k();
  while (tmp0_iterator_2.m()) {
    var element_2 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.rollback.<anonymous>' call
    element_2.r1t();
  }
};
protoOf(ReplacePartAction).f1l = function () {
  removeAllConnectionRoots(this, this.o36_1);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.v36_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.perform.<anonymous>' call
    element.s4();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = this.w36_1.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.perform.<anonymous>' call
    element_0.s4();
  }
  this.x36_1.s4();
  replacePartInAssembly(this, this.o36_1, this.n36_1);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_1 = this.w36_1.k();
  while (tmp0_iterator_1.m()) {
    var element_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.perform.<anonymous>' call
    element_1.v35();
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_2 = this.v36_1.k();
  while (tmp0_iterator_2.m()) {
    var element_2 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.replace.ReplacePartAction.perform.<anonymous>' call
    element_2.v35();
  }
};
protoOf(ReplacePartAction).toString = function () {
  return 'Replace part Action old ' + this.n36_1.toString() + ' for new ' + this.o36_1.toString();
};
function Companion_104() {
}
protoOf(Companion_104).n1s = function () {
  return Companion_instance_21.k1s_1;
};
var Companion_instance_104;
function Companion_getInstance_105() {
  return Companion_instance_104;
}
function get_id_2() {
  return Companion_instance_104.n1s();
}
function SlowReplaceInProgressComponent() {
}
protoOf(SlowReplaceInProgressComponent).p1s = function () {
  return Companion_instance_104.n1s();
};
protoOf(SlowReplaceInProgressComponent).eq = function (other) {
  return true;
};
function Companion_105() {
  Companion_instance_105 = this;
  this.id = Companion_instance_21.d1q_1;
}
protoOf(Companion_105).n1s = function () {
  return this.id;
};
var Companion_instance_105;
function Companion_getInstance_106() {
  if (Companion_instance_105 == null)
    new Companion_105();
  return Companion_instance_105;
}
function ClickEventComponent(screenSpaceCoord) {
  Companion_getInstance_106();
  this.screenSpaceCoord = screenSpaceCoord;
  this.z36_1 = Companion_getInstance_106().id;
}
protoOf(ClickEventComponent).a37 = function () {
  return this.screenSpaceCoord;
};
protoOf(ClickEventComponent).p1s = function () {
  return this.z36_1;
};
protoOf(ClickEventComponent).eq = function (other) {
  if (!(other instanceof ClickEventComponent))
    return false;
  return other.screenSpaceCoord.equals(this.screenSpaceCoord);
};
function MultiSelectionEnabledComponent_0() {
}
protoOf(MultiSelectionEnabledComponent_0).p1s = function () {
  return this.id;
};
protoOf(MultiSelectionEnabledComponent_0).n1s = function () {
  return Companion_instance_21.z1o_1;
};
protoOf(MultiSelectionEnabledComponent_0).eq = function (other) {
  return true;
};
var MultiSelectionEnabledComponent_instance;
function MultiSelectionEnabledComponent_getInstance() {
  return MultiSelectionEnabledComponent_instance;
}
function Companion_106() {
  Companion_instance_106 = this;
  this.id = Companion_instance_21.x1m_1;
}
protoOf(Companion_106).n1s = function () {
  return this.id;
};
var Companion_instance_106;
function Companion_getInstance_107() {
  if (Companion_instance_106 == null)
    new Companion_106();
  return Companion_instance_106;
}
function SelectableComponent() {
  Companion_getInstance_107();
}
protoOf(SelectableComponent).p1s = function () {
  return Companion_getInstance_107().id;
};
protoOf(SelectableComponent).eq = function (other) {
  return true;
};
function get_selectableComponent(_this__u8e3s4) {
  return _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_107().id);
}
function get_isSelectable(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_getInstance_107().id);
}
function Companion_107() {
  Companion_instance_107 = this;
  this.id = Companion_instance_21.w1m_1;
}
protoOf(Companion_107).n1s = function () {
  return this.id;
};
var Companion_instance_107;
function Companion_getInstance_108() {
  if (Companion_instance_107 == null)
    new Companion_107();
  return Companion_instance_107;
}
function SelectedComponent() {
  Companion_getInstance_108();
}
protoOf(SelectedComponent).p1s = function () {
  return this.id;
};
protoOf(SelectedComponent).n1s = function () {
  return Companion_instance_21.w1m_1;
};
protoOf(SelectedComponent).eq = function (other) {
  return true;
};
function get_isSelected(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_getInstance_108().id);
}
function CatalogVersion(rangeId, version) {
  this.rangeId = rangeId;
  this.version = version;
}
protoOf(CatalogVersion).b37 = function () {
  return this.rangeId;
};
protoOf(CatalogVersion).c37 = function () {
  return this.version;
};
protoOf(CatalogVersion).tf = function () {
  return this.rangeId;
};
protoOf(CatalogVersion).uf = function () {
  return this.version;
};
protoOf(CatalogVersion).c1t = function (rangeId, version) {
  return new CatalogVersion(rangeId, version);
};
protoOf(CatalogVersion).copy = function (rangeId, version, $super) {
  rangeId = rangeId === VOID ? this.rangeId : rangeId;
  version = version === VOID ? this.version : version;
  return this.c1t(rangeId, version);
};
protoOf(CatalogVersion).toString = function () {
  return 'CatalogVersion(rangeId=' + this.rangeId + ', version=' + this.version + ')';
};
protoOf(CatalogVersion).hashCode = function () {
  var result = getStringHashCode(this.rangeId);
  result = imul(result, 31) + getStringHashCode(this.version) | 0;
  return result;
};
protoOf(CatalogVersion).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CatalogVersion))
    return false;
  var tmp0_other_with_cast = other instanceof CatalogVersion ? other : THROW_CCE();
  if (!(this.rangeId === tmp0_other_with_cast.rangeId))
    return false;
  if (!(this.version === tmp0_other_with_cast.version))
    return false;
  return true;
};
function Companion_108() {
  Companion_instance_108 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.d37_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
}
protoOf(Companion_108).z18 = function () {
  return $serializer_getInstance_9();
};
var Companion_instance_108;
function Companion_getInstance_109() {
  if (Companion_instance_108 == null)
    new Companion_108();
  return Companion_instance_108;
}
function $serializer_9() {
  $serializer_instance_9 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.CatalogsHeader', this, 1);
  tmp0_serialDesc.lw('catalogs', false);
  this.e37_1 = tmp0_serialDesc;
}
protoOf($serializer_9).f37 = function (encoder, value) {
  var tmp0_desc = this.e37_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_109().d37_1;
  tmp1_output.uq(tmp0_desc, 0, tmp2_cached[0], value.g37_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_9).ul = function (encoder, value) {
  return this.f37(encoder, value instanceof CatalogsHeader ? value : THROW_CCE());
};
protoOf($serializer_9).vl = function (decoder) {
  var tmp0_desc = this.e37_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  var tmp6_cached = Companion_getInstance_109().d37_1;
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.pp(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.pp(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return CatalogsHeader_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_9).tl = function () {
  return this.e37_1;
};
protoOf($serializer_9).ex = function () {
  var tmp0_cached = Companion_getInstance_109().d37_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(tmp0_cached[0])];
};
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 == null)
    new $serializer_9();
  return $serializer_instance_9;
}
function CatalogsHeader_init_$Init$(seen0, catalogs, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_9().e37_1);
  }
  $this.g37_1 = catalogs;
  return $this;
}
function CatalogsHeader_init_$Create$(seen0, catalogs, serializationConstructorMarker) {
  return CatalogsHeader_init_$Init$(seen0, catalogs, serializationConstructorMarker, objectCreate(protoOf(CatalogsHeader)));
}
function CatalogsHeader() {
}
protoOf(CatalogsHeader).toString = function () {
  return 'CatalogsHeader(catalogs=' + toString(this.g37_1) + ')';
};
protoOf(CatalogsHeader).hashCode = function () {
  return this.g37_1 == null ? 0 : hashCode(this.g37_1);
};
protoOf(CatalogsHeader).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CatalogsHeader))
    return false;
  var tmp0_other_with_cast = other instanceof CatalogsHeader ? other : THROW_CCE();
  if (!equals(this.g37_1, tmp0_other_with_cast.g37_1))
    return false;
  return true;
};
function ComponentDeserializer() {
}
function ComponentDeserializerRegistry() {
  var tmp = this;
  // Inline function 'kotlin.emptyArray' call
  tmp.h37_1 = [];
}
protoOf(ComponentDeserializerRegistry).i37 = function () {
  return this.h37_1;
};
protoOf(ComponentDeserializerRegistry).register = function (componentDeserializer) {
  if (!componentDeserializer.thisClassIsGuaranteedToNotModifyOrQueryCoreState) {
    // Inline function 'kotlin.error' call
    var message = "You haven't read and accepted the class documentation for ComponentSerializer for " + toString_0(componentDeserializer);
    throw IllegalStateException_init_$Create$(toString_0(message));
  }
  var tmp = this;
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = this.h37_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [componentDeserializer];
  tmp.h37_1 = tmp$ret$0.concat(tmp$ret$3);
};
protoOf(ComponentDeserializerRegistry).unregister = function (componentDeserializer) {
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = minus(toMutableList(this.h37_1), componentDeserializer);
  tmp.h37_1 = copyToArray(this_0);
};
function DeserializationInterceptor() {
}
function DeserializationInterceptorRegistry() {
  var tmp = this;
  // Inline function 'kotlin.emptyArray' call
  tmp.j37_1 = [];
}
protoOf(DeserializationInterceptorRegistry).k37 = function () {
  return this.j37_1;
};
protoOf(DeserializationInterceptorRegistry).register = function (interceptor) {
  var tmp = this;
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = this.j37_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [interceptor];
  tmp.j37_1 = tmp$ret$0.concat(tmp$ret$3);
};
protoOf(DeserializationInterceptorRegistry).unregister = function (componentDeserializer) {
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = minus(toMutableList(this.j37_1), componentDeserializer);
  tmp.j37_1 = copyToArray(this_0);
};
function JsonSerializable() {
}
function JsonSerializer$Companion$StrictPretty$lambda($this$Json) {
  $this$Json.q17_1 = false;
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  $this$Json.p17_1 = true;
  return Unit_instance;
}
function JsonSerializer$Companion$NonStrictPretty$lambda($this$Json) {
  $this$Json.q17_1 = false;
  $this$Json.s17_1 = true;
  $this$Json.u17_1 = true;
  $this$Json.p17_1 = true;
  return Unit_instance;
}
function JsonSerializer$Companion$NonStrictPrettyIgnoreUnknownKeys$lambda($this$Json) {
  $this$Json.q17_1 = false;
  $this$Json.s17_1 = true;
  $this$Json.r17_1 = true;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function createANewCoreInstance($this, coreServices) {
  var tmpCore = coreServices.coreFactory.createNewCoreInstance();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = coreServices.productManager.catalogs;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.JsonSerializer.createANewCoreInstance.<anonymous>' call
    tmpCore.services.productManager.addCatalog(element);
  }
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject_0 = coreServices.componentDeserializerRegistry.componentDeserializers;
  var inductionVariable_0 = 0;
  var last_0 = indexedObject_0.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = indexedObject_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.serialization.JsonSerializer.createANewCoreInstance.<anonymous>' call
    tmpCore.services.componentDeserializerRegistry.register(element_0);
  }
  return tmpCore;
}
function rebuildTreeFromScratch($this, coreServices, serializableTree) {
  var entityTreeBuilder = new EntityTreeBuilder(coreServices.entityManager, coreServices.productManager, coreServices.validations);
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = serializableTree.roots;
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.serialization.JsonSerializer.rebuildTreeFromScratch.<anonymous>' call
    var tmp0_safe_receiver = entityTreeBuilder.q37(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  var newRoots = destination;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = newRoots.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.serialization.JsonSerializer.rebuildTreeFromScratch.<anonymous>' call
    serializableTree.afterRebuildTree(element_0, coreServices);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(newRoots);
}
function letCatalogsUpdateTreeWhenDone($this, root, catalogsArray) {
  var tmp0_safe_receiver = $this.s37_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptors;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.JsonSerializer.letCatalogsUpdateTreeWhenDone.<anonymous>' call
      element.afterDeserializeComplete(root, catalogsArray);
    }
  }
}
function letCatalogsUpdateTreeBeforeParsingComponents($this, serializableTree, catalogsArray) {
  var tmp0_safe_receiver = $this.s37_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptors;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.JsonSerializer.letCatalogsUpdateTreeBeforeParsingComponents.<anonymous>' call
      element.beforeParsingComponents(serializableTree, catalogsArray);
    }
  }
}
function letCatalogsUpdateTreeBeforeBuildingEntities($this, serializableTree, catalogsArray) {
  var tmp0_safe_receiver = $this.s37_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptors;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.JsonSerializer.letCatalogsUpdateTreeBeforeBuildingEntities.<anonymous>' call
      element.beforeBuildingEntities(serializableTree, catalogsArray);
    }
  }
}
function letCatalogsUpdateJSON($this, bundle, catalogsArray) {
  var newJson = bundle;
  var tmp0_safe_receiver = $this.s37_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptors;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.JsonSerializer.letCatalogsUpdateJSON.<anonymous>' call
      newJson = element.beforeDeserialize(newJson, catalogsArray);
    }
  }
  return newJson;
}
function catalogVersions($this, bundle) {
  var tmp;
  try {
    var tmp0_elvis_lhs = Companion_getInstance_110().v37_1.w16(Companion_getInstance_109().z18(), bundle).g37_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0 = emptyMap();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof SerializationException) {
      var se = $p;
      // Inline function 'kotlin.collections.mapOf' call
      tmp_1 = emptyMap();
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function fromJson($this, bundle) {
  var version = Companion_getInstance_110().v37_1.w16(Companion_instance_117.z18(), bundle).w37_1;
  return fromJson_0($this, version, bundle);
}
function fromJson_0($this, version, bundle) {
  var tmp;
  if (version === '1.3') {
    tmp = Companion_getInstance_110().u37_1.w16(Companion_getInstance_124().z18(), bundle);
  } else {
    throw IllegalStateException_init_$Create$('Can not deserialize version ' + version);
  }
  return tmp;
}
function Companion_109() {
  Companion_instance_109 = this;
  var tmp = this;
  tmp.t37_1 = Json(VOID, JsonSerializer$Companion$StrictPretty$lambda);
  var tmp_0 = this;
  tmp_0.u37_1 = Json(VOID, JsonSerializer$Companion$NonStrictPretty$lambda);
  var tmp_1 = this;
  tmp_1.v37_1 = Json(VOID, JsonSerializer$Companion$NonStrictPrettyIgnoreUnknownKeys$lambda);
}
var Companion_instance_109;
function Companion_getInstance_110() {
  if (Companion_instance_109 == null)
    new Companion_109();
  return Companion_instance_109;
}
function JsonSerializer(productManager, interceptorRegistry) {
  Companion_getInstance_110();
  productManager = productManager === VOID ? null : productManager;
  interceptorRegistry = interceptorRegistry === VOID ? null : interceptorRegistry;
  this.r37_1 = productManager;
  this.s37_1 = interceptorRegistry;
}
protoOf(JsonSerializer).deserializeToEntityHierarchies = function (json, coreServices) {
  var catalogs = catalogVersions(this, json);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(catalogs.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = catalogs.i2().k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.serialization.JsonSerializer.deserializeToEntityHierarchies.<anonymous>' call
    var tmp$ret$1 = new CatalogVersion(item.b2(), item.c2());
    destination.h(tmp$ret$1);
  }
  var catalogsArray = copyToArray(destination);
  var updatedJson = letCatalogsUpdateJSON(this, json, catalogsArray);
  var serializableTree = fromJson(this, updatedJson);
  letCatalogsUpdateTreeBeforeParsingComponents(this, serializableTree, catalogsArray);
  serializableTree.deserializeComponents(coreServices);
  letCatalogsUpdateTreeBeforeBuildingEntities(this, serializableTree, catalogsArray);
  var tmpCore = createANewCoreInstance(this, coreServices);
  serializableTree.afterDeserialized(tmpCore.services);
  var newRoots = rebuildTreeFromScratch(this, coreServices, serializableTree);
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = newRoots.length;
  while (inductionVariable < last) {
    var element = newRoots[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.JsonSerializer.deserializeToEntityHierarchies.<anonymous>' call
    element.addComponent(new LocalTransformComponent(get_worldTransform(element)));
    element.addComponent(new WorldTransformComponent(Companion_getInstance_80().c1x_1));
    Companion_instance_146.z37(element);
  }
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = newRoots.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = newRoots[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.serialization.JsonSerializer.deserializeToEntityHierarchies.<anonymous>' call
    letCatalogsUpdateTreeWhenDone(this, element_0, catalogsArray);
  }
  return newRoots;
};
protoOf(JsonSerializer).hierarchiesToJsonString = function (roots) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = roots.length;
  while (inductionVariable < last) {
    var element = roots[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.JsonSerializer.hierarchiesToJsonString.<anonymous>' call
    var list = toList_1(get_hierarchy(element));
    addAll(destination, list);
  }
  var allEntities = copyToArray(destination);
  return this.singleEntitiesToJsonString(allEntities);
};
protoOf(JsonSerializer).singleEntitiesToJsonString = function (entities) {
  return Companion_getInstance_124().a38(entities, this.r37_1);
};
protoOf(JsonSerializer).toJsonString = function (root) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [root];
  return this.hierarchiesToJsonString(tmp$ret$2);
};
function Companion_110() {
  Companion_instance_110 = this;
  this.id = Companion_instance_21.r1q_1;
}
protoOf(Companion_110).n1s = function () {
  return this.id;
};
var Companion_instance_110;
function Companion_getInstance_111() {
  if (Companion_instance_110 == null)
    new Companion_110();
  return Companion_instance_110;
}
function PreviouslySerializedIdComponent(serializedId) {
  Companion_getInstance_111();
  this.serializedId = serializedId;
  this.b38_1 = Companion_getInstance_111().id;
}
protoOf(PreviouslySerializedIdComponent).c38 = function () {
  return this.serializedId;
};
protoOf(PreviouslySerializedIdComponent).p1s = function () {
  return this.b38_1;
};
protoOf(PreviouslySerializedIdComponent).eq = function (other) {
  var tmp0_safe_receiver = other instanceof PreviouslySerializedIdComponent ? other : null;
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializedId) === this.serializedId;
};
function get_previousId(_this__u8e3s4) {
  var tmp0_safe_receiver = get_previousStringId(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
}
function get_previousStringId(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_111().id);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializedId;
}
function Companion_111() {
}
protoOf(Companion_111).n1s = function () {
  return Companion_instance_21.q1p_1;
};
var Companion_instance_111;
function Companion_getInstance_112() {
  return Companion_instance_111;
}
function SceneReloadingComponent() {
}
protoOf(SceneReloadingComponent).p1s = function () {
  return Companion_instance_111.id;
};
protoOf(SceneReloadingComponent).eq = function (other) {
  return true;
};
function SerializableComponent() {
}
function SerializableEntity() {
}
function SerializableGuestConnectionsComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_112() {
}
protoOf(Companion_112).k38 = function (connection) {
  return new SerializableConnection(connection.guestConnectorEntity.id.toString(), connection.hostConnectorEntity.id.toString(), connection.guestConnectorKey, connection.hostConnectorKey);
};
var Companion_instance_112;
function Companion_getInstance_113() {
  return Companion_instance_112;
}
function $serializer_10() {
  $serializer_instance_10 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.SerializableGuestConnectionsComponent.SerializableConnection', this, 4);
  tmp0_serialDesc.lw('guestId', false);
  tmp0_serialDesc.lw('hostId', false);
  tmp0_serialDesc.lw('guestConnector', false);
  tmp0_serialDesc.lw('hostConnector', false);
  this.l38_1 = tmp0_serialDesc;
}
protoOf($serializer_10).m38 = function (encoder, value) {
  var tmp0_desc = this.l38_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.n38_1);
  tmp1_output.qq(tmp0_desc, 1, value.o38_1);
  tmp1_output.qq(tmp0_desc, 2, value.p38_1);
  tmp1_output.qq(tmp0_desc, 3, value.q38_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_10).ul = function (encoder, value) {
  return this.m38(encoder, value instanceof SerializableConnection ? value : THROW_CCE());
};
protoOf($serializer_10).vl = function (decoder) {
  var tmp0_desc = this.l38_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.bp(tmp0_desc);
  if (tmp8_input.rp()) {
    tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.lp(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.lp(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.cp(tmp0_desc);
  return SerializableConnection_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_10).tl = function () {
  return this.l38_1;
};
protoOf($serializer_10).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 == null)
    new $serializer_10();
  return $serializer_instance_10;
}
function SerializableConnection_init_$Init$(seen0, guestId, hostId, guestConnector, hostConnector, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_10().l38_1);
  }
  $this.n38_1 = guestId;
  $this.o38_1 = hostId;
  $this.p38_1 = guestConnector;
  $this.q38_1 = hostConnector;
  return $this;
}
function SerializableConnection_init_$Create$(seen0, guestId, hostId, guestConnector, hostConnector, serializationConstructorMarker) {
  return SerializableConnection_init_$Init$(seen0, guestId, hostId, guestConnector, hostConnector, serializationConstructorMarker, objectCreate(protoOf(SerializableConnection)));
}
function Companion_113() {
  Companion_instance_113 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.r38_1 = [new ArrayListSerializer($serializer_getInstance_10()), null];
  this.s38_1 = Companion_instance_21.x1q_1;
  this.t38_1 = 'Connections';
  var tmp_0 = this;
  tmp_0.u38_1 = Json(VOID, SerializableGuestConnectionsComponent$Companion$serializer$lambda);
}
protoOf(Companion_113).v38 = function (connectionsComponent) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = connectionsComponent.connections;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.Companion.fromConnectionsComponent.<anonymous>' call
    var tmp$ret$0 = Companion_instance_112.k38(item);
    destination.h(tmp$ret$0);
  }
  return new SerializableGuestConnectionsComponent(destination);
};
protoOf(Companion_113).x1s = function (json) {
  return this.u38_1.y16(this.z18(), json);
};
protoOf(Companion_113).z18 = function () {
  return $serializer_getInstance_11();
};
var Companion_instance_113;
function Companion_getInstance_114() {
  if (Companion_instance_113 == null)
    new Companion_113();
  return Companion_instance_113;
}
function SerializableConnection(guestId, hostId, guestConnector, hostConnector) {
  this.n38_1 = guestId;
  this.o38_1 = hostId;
  this.p38_1 = guestConnector;
  this.q38_1 = hostConnector;
}
protoOf(SerializableConnection).w38 = function (guestId, hostId, guestConnector, hostConnector) {
  return new SerializableConnection(guestId, hostId, guestConnector, hostConnector);
};
protoOf(SerializableConnection).x38 = function (guestId, hostId, guestConnector, hostConnector, $super) {
  guestId = guestId === VOID ? this.n38_1 : guestId;
  hostId = hostId === VOID ? this.o38_1 : hostId;
  guestConnector = guestConnector === VOID ? this.p38_1 : guestConnector;
  hostConnector = hostConnector === VOID ? this.q38_1 : hostConnector;
  return $super === VOID ? this.w38(guestId, hostId, guestConnector, hostConnector) : $super.w38.call(this, guestId, hostId, guestConnector, hostConnector);
};
protoOf(SerializableConnection).toString = function () {
  return 'SerializableConnection(guestId=' + this.n38_1 + ', hostId=' + this.o38_1 + ', guestConnector=' + this.p38_1 + ', hostConnector=' + this.q38_1 + ')';
};
protoOf(SerializableConnection).hashCode = function () {
  var result = getStringHashCode(this.n38_1);
  result = imul(result, 31) + getStringHashCode(this.o38_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.p38_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.q38_1) | 0;
  return result;
};
protoOf(SerializableConnection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SerializableConnection))
    return false;
  var tmp0_other_with_cast = other instanceof SerializableConnection ? other : THROW_CCE();
  if (!(this.n38_1 === tmp0_other_with_cast.n38_1))
    return false;
  if (!(this.o38_1 === tmp0_other_with_cast.o38_1))
    return false;
  if (!(this.p38_1 === tmp0_other_with_cast.p38_1))
    return false;
  if (!(this.q38_1 === tmp0_other_with_cast.q38_1))
    return false;
  return true;
};
function $serializer_11() {
  $serializer_instance_11 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.SerializableGuestConnectionsComponent', this, 2);
  tmp0_serialDesc.lw('connections', false);
  tmp0_serialDesc.lw('typeId', true);
  this.y38_1 = tmp0_serialDesc;
}
protoOf($serializer_11).z38 = function (encoder, value) {
  var tmp0_desc = this.y38_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_114().r38_1;
  tmp1_output.sq(tmp0_desc, 0, tmp2_cached[0], value.a39_1);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.b39_1 === Companion_getInstance_114().s38_1)) {
    tmp1_output.lq(tmp0_desc, 1, value.b39_1);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_11).ul = function (encoder, value) {
  return this.z38(encoder, value instanceof SerializableGuestConnectionsComponent ? value : THROW_CCE());
};
protoOf($serializer_11).vl = function (decoder) {
  var tmp0_desc = this.y38_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0;
  var tmp6_input = decoder.bp(tmp0_desc);
  var tmp7_cached = Companion_getInstance_114().r38_1;
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.gp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.gp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return SerializableGuestConnectionsComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_11).tl = function () {
  return this.y38_1;
};
protoOf($serializer_11).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_114().r38_1[0], IntSerializer_getInstance()];
};
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 == null)
    new $serializer_11();
  return $serializer_instance_11;
}
function SerializableGuestConnectionsComponent_init_$Init$(seen0, connections, typeId, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_11().y38_1);
  }
  $this.a39_1 = connections;
  if (0 === (seen0 & 2))
    $this.b39_1 = Companion_getInstance_114().s38_1;
  else
    $this.b39_1 = typeId;
  return $this;
}
function SerializableGuestConnectionsComponent_init_$Create$(seen0, connections, typeId, serializationConstructorMarker) {
  return SerializableGuestConnectionsComponent_init_$Init$(seen0, connections, typeId, serializationConstructorMarker, objectCreate(protoOf(SerializableGuestConnectionsComponent)));
}
function SerializableGuestConnectionsComponent(connections) {
  Companion_getInstance_114();
  this.a39_1 = connections;
  this.b39_1 = Companion_getInstance_114().s38_1;
}
protoOf(SerializableGuestConnectionsComponent).toJson = function (parse) {
  return Companion_getInstance_114().u38_1.x16(Companion_getInstance_114().z18(), this);
};
protoOf(SerializableGuestConnectionsComponent).serializationKey = function () {
  return Companion_getInstance_114().t38_1;
};
protoOf(SerializableGuestConnectionsComponent).p1s = function () {
  return this.b39_1;
};
protoOf(SerializableGuestConnectionsComponent).eq = function (other) {
  var that = unsafeCast(other);
  return equals(this.a39_1, that.a39_1);
};
function SerializableRootComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_114() {
  Companion_instance_114 = this;
  this.c39_1 = Companion_instance_21.g1q_1;
  this.d39_1 = 'root';
  var tmp = this;
  tmp.e39_1 = Json(VOID, SerializableRootComponent$Companion$serializer$lambda);
}
protoOf(Companion_114).f39 = function () {
  return new SerializableRootComponent();
};
var Companion_instance_114;
function Companion_getInstance_115() {
  if (Companion_instance_114 == null)
    new Companion_114();
  return Companion_instance_114;
}
function SerializableRootComponent() {
  Companion_getInstance_115();
}
protoOf(SerializableRootComponent).p1s = function () {
  return Companion_getInstance_115().c39_1;
};
protoOf(SerializableRootComponent).r1s = function () {
  return true;
};
protoOf(SerializableRootComponent).toJson = function (parse) {
  return Companion_getInstance_115().e39_1.x16(serializer(BooleanCompanionObject_instance), true);
};
protoOf(SerializableRootComponent).serializationKey = function () {
  return Companion_getInstance_115().d39_1;
};
protoOf(SerializableRootComponent).toString = function () {
  return Companion_getInstance_115().d39_1;
};
protoOf(SerializableRootComponent).eq = function (other) {
  return true;
};
function SerializableSceneComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function Companion_115() {
  Companion_instance_115 = this;
  this.g39_1 = Companion_instance_21.t1p_1;
  this.h39_1 = 'scene';
  var tmp = this;
  tmp.i39_1 = Json(VOID, SerializableSceneComponent$Companion$serializer$lambda);
}
protoOf(Companion_115).x1s = function (json) {
  return this.i39_1.y16(serializer(BooleanCompanionObject_instance), json) ? new SerializableSceneComponent() : null;
};
var Companion_instance_115;
function Companion_getInstance_116() {
  if (Companion_instance_115 == null)
    new Companion_115();
  return Companion_instance_115;
}
function SerializableSceneComponent() {
  Companion_getInstance_116();
}
protoOf(SerializableSceneComponent).p1s = function () {
  return Companion_getInstance_116().g39_1;
};
protoOf(SerializableSceneComponent).r1s = function () {
  return true;
};
protoOf(SerializableSceneComponent).toJson = function (parse) {
  return Companion_getInstance_116().i39_1.x16(serializer(BooleanCompanionObject_instance), true);
};
protoOf(SerializableSceneComponent).serializationKey = function () {
  return Companion_getInstance_116().h39_1;
};
protoOf(SerializableSceneComponent).toString = function () {
  return Companion_getInstance_116().h39_1;
};
protoOf(SerializableSceneComponent).eq = function (other) {
  return true;
};
function SerializableTree() {
}
function toJsonString(_this__u8e3s4) {
  return (new JsonSerializer()).toJsonString(_this__u8e3s4);
}
function Serializer() {
}
function Companion_116() {
}
protoOf(Companion_116).n1s = function () {
  return Companion_instance_21.v1n_1;
};
var Companion_instance_116;
function Companion_getInstance_117() {
  return Companion_instance_116;
}
function UnserializableEntityComponent() {
}
protoOf(UnserializableEntityComponent).p1s = function () {
  return Companion_instance_116.id;
};
protoOf(UnserializableEntityComponent).eq = function (other) {
  return true;
};
function Companion_117() {
}
protoOf(Companion_117).z18 = function () {
  return $serializer_getInstance_12();
};
var Companion_instance_117;
function Companion_getInstance_118() {
  return Companion_instance_117;
}
function $serializer_12() {
  $serializer_instance_12 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.VersionHeader', this, 1);
  tmp0_serialDesc.lw('version', false);
  this.k39_1 = tmp0_serialDesc;
}
protoOf($serializer_12).l39 = function (encoder, value) {
  var tmp0_desc = this.k39_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.w37_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_12).ul = function (encoder, value) {
  return this.l39(encoder, value instanceof VersionHeader ? value : THROW_CCE());
};
protoOf($serializer_12).vl = function (decoder) {
  var tmp0_desc = this.k39_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.bp(tmp0_desc);
  if (tmp5_input.rp()) {
    tmp4_local0 = tmp5_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.cp(tmp0_desc);
  return VersionHeader_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_12).tl = function () {
  return this.k39_1;
};
protoOf($serializer_12).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 == null)
    new $serializer_12();
  return $serializer_instance_12;
}
function VersionHeader_init_$Init$(seen0, version, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_12().k39_1);
  }
  $this.w37_1 = version;
  return $this;
}
function VersionHeader_init_$Create$(seen0, version, serializationConstructorMarker) {
  return VersionHeader_init_$Init$(seen0, version, serializationConstructorMarker, objectCreate(protoOf(VersionHeader)));
}
function VersionHeader() {
}
protoOf(VersionHeader).toString = function () {
  return 'VersionHeader(version=' + this.w37_1 + ')';
};
protoOf(VersionHeader).hashCode = function () {
  return getStringHashCode(this.w37_1);
};
protoOf(VersionHeader).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof VersionHeader))
    return false;
  var tmp0_other_with_cast = other instanceof VersionHeader ? other : THROW_CCE();
  if (!(this.w37_1 === tmp0_other_with_cast.w37_1))
    return false;
  return true;
};
function findCorrectEntityGroupOrderFromConnectionGraph($this, shadowEntity) {
  var childrenLeft = toMutableList(get_children(shadowEntity));
  // Inline function 'kotlin.collections.mutableListOf' call
  var childrenInOrder = ArrayList_init_$Create$();
  var index = 0;
  $l$loop: while (true) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!childrenLeft.r()) {
      tmp = index < childrenLeft.o();
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop;
    }
    var child = childrenLeft.q(index);
    var connectionsComponents = child.__getComponentForKotlin(Companion_getInstance_114().s38_1);
    var tmp1_safe_receiver = connectionsComponents == null ? null : connectionsComponents.a39_1;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp$ret$2;
      $l$block_3: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(tmp1_safe_receiver, Collection)) {
          tmp_1 = tmp1_safe_receiver.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$2 = false;
          break $l$block_3;
        }
        var tmp0_iterator = tmp1_safe_receiver.k();
        while (tmp0_iterator.m()) {
          var element = tmp0_iterator.n();
          // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.findCorrectEntityGroupOrderFromConnectionGraph.<anonymous>' call
          var hostId = toInt(element.o38_1);
          var tmp$ret$3;
          $l$block_2: {
            // Inline function 'kotlin.collections.any' call
            var tmp_2;
            if (isInterface(childrenLeft, Collection)) {
              tmp_2 = childrenLeft.r();
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp$ret$3 = false;
              break $l$block_2;
            }
            var tmp0_iterator_0 = childrenLeft.k();
            while (tmp0_iterator_0.m()) {
              var element_0 = tmp0_iterator_0.n();
              // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.findCorrectEntityGroupOrderFromConnectionGraph.<anonymous>.<anonymous>' call
              var tmp_3;
              if (element_0.id === hostId) {
                tmp_3 = true;
              } else {
                var tmp$ret$5;
                $l$block_1: {
                  // Inline function 'kotlin.sequences.any' call
                  var tmp0_iterator_1 = hierarchyExceptSubTreesWithComponentSequence(element_0, Companion_getInstance_25().id).k();
                  while (tmp0_iterator_1.m()) {
                    var element_1 = tmp0_iterator_1.n();
                    // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.findCorrectEntityGroupOrderFromConnectionGraph.<anonymous>.<anonymous>.<anonymous>' call
                    if (element_1.id === hostId) {
                      tmp$ret$5 = true;
                      break $l$block_1;
                    }
                  }
                  tmp$ret$5 = false;
                }
                tmp_3 = tmp$ret$5;
              }
              if (tmp_3) {
                tmp$ret$3 = true;
                break $l$block_2;
              }
            }
            tmp$ret$3 = false;
          }
          if (tmp$ret$3) {
            tmp$ret$2 = true;
            break $l$block_3;
          }
        }
        tmp$ret$2 = false;
      }
      tmp_0 = tmp$ret$2;
    }
    var tmp2_elvis_lhs = tmp_0;
    var hasAnyConnectionsToOther = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
    index = index + 1 | 0;
    if (!hasAnyConnectionsToOther) {
      childrenInOrder.h(child);
      childrenLeft.j2(child);
      index = 0;
    }
  }
  return childrenInOrder;
}
function Companion_118() {
}
protoOf(Companion_118).m39 = function (shadowEntity) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = get_children(shadowEntity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.findCorrectEntityGroupOrder.<anonymous>' call
      if (element.hasComponent(Companion_getInstance_114().s38_1)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  var hasNewConnectionsComponent = tmp$ret$1;
  var tmp;
  if (hasNewConnectionsComponent) {
    var orderOfChildren = findCorrectEntityGroupOrderFromConnectionGraph(this, shadowEntity);
    tmp = orderOfChildren;
  } else {
    var childrenLeft = toMutableList(get_children(shadowEntity));
    // Inline function 'kotlin.collections.mutableListOf' call
    var childrenInOrder = ArrayList_init_$Create$();
    var index = 0;
    $l$loop: while (true) {
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!childrenLeft.r()) {
        tmp_0 = index < childrenLeft.o();
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        break $l$loop;
      }
      var child = childrenLeft.q(index);
      var tmp_1 = Companion_instance_25;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$4 = copyToArray(childrenLeft);
      var hasPossibleGuestConnections = tmp_1.e29(child, tmp$ret$4);
      index = index + 1 | 0;
      // Inline function 'kotlin.collections.isEmpty' call
      if (hasPossibleGuestConnections.length === 0) {
        childrenInOrder.h(child);
        childrenLeft.j2(child);
        index = 0;
      }
    }
    return childrenInOrder;
  }
  return tmp;
};
var Companion_instance_118;
function Companion_getInstance_119() {
  return Companion_instance_118;
}
function EntityTreeBuilder$InterceptingAssemblyPartCatalog$productSpecification$lambda($productRef) {
  return function (it) {
    return get_productRef(it) === $productRef;
  };
}
function modifyAssemblyComponentsIfNeeded($this, idMap, specification, shadowEntity) {
  var tmp;
  if ((specification == null ? null : specification.hasComponent(Companion_getInstance_3().id)) === true) {
    var withoutUnlockedChildren = removeNonLockedPartsFromAssemblyStructure($this, specification);
    var withPartsMap = addPartsMap($this, shadowEntity, withoutUnlockedChildren);
    tmp = addIdsMap($this, shadowEntity, idMap, withPartsMap);
  } else {
    tmp = specification;
  }
  return tmp;
}
function removeNonLockedPartsFromAssemblyStructure($this, specification) {
  var tmp0_elvis_lhs = specification.findComponent(Companion_getInstance_3().id);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return specification;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var assemblyStructureComponent = tmp;
  var newParts = removeLockedChildren($this, assemblyStructureComponent.parts);
  var tmp_0;
  if (!(newParts == null)) {
    tmp_0 = specification.addComponent(new AssemblyStructureComponent(newParts));
  } else {
    tmp_0 = specification;
  }
  return tmp_0;
}
function addPartsMap($this, shadowEntity, specification) {
  var partsMap = Companion_instance_6.u1t(shadowEntity);
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (partsMap.length === 0) {
    tmp = specification;
  } else {
    tmp = specification.addComponent(fromPartPairs(partsMap));
  }
  return tmp;
}
function removeLockedChildren($this, parts) {
  if (parts == null)
    return null;
  // Inline function 'kotlin.collections.isEmpty' call
  if (parts.length === 0) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = parts.length;
  while (inductionVariable < last) {
    var element = parts[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.removeLockedChildren.<anonymous>' call
    var tmp;
    if (element.locked) {
      tmp = element.copy(VOID, VOID, VOID, removeLockedChildren(Companion_getInstance_120(), element.children));
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return copyToArray(destination);
}
function addIdsMap($this, entity, idMap, specification) {
  if (specification == null)
    return null;
  // Inline function 'kotlin.collections.mapValues' call
  var this_0 = Companion_instance.e1m(entity, true);
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap_init_$Create$(mapCapacity(this_0.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
    var tmp = element.b2();
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.Companion.addIdsMap.<anonymous>' call
    // Inline function 'kotlin.collections.component2' call
    var shadowId = element.c2();
    var tmp$ret$2 = idMap(shadowId);
    destination.q2(tmp, tmp$ret$2);
  }
  var partsMap = destination;
  var tmp_0;
  if (partsMap.r()) {
    tmp_0 = specification;
  } else {
    tmp_0 = specification.addComponent(new AssemblyPartIdsComponent(partsMap));
  }
  return tmp_0;
}
function mapShadowIdToRealId($this, shadowId) {
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = $this.o37_1;
  var value = this_0.f2(shadowId);
  var tmp;
  if (value == null) {
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.mapShadowIdToRealId.<anonymous>' call
    var answer = $this.l37_1.getNextId();
    this_0.q2(shadowId, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
function buildAutomaticGroupEntityTree($this, groupShadowRoot) {
  var tmp0_elvis_lhs = createEntityFromShadow($this, groupShadowRoot);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var root = tmp;
  var newEntitiesWithChildren = buildEntityTreeInternal$default($this, groupShadowRoot, null);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = newEntitiesWithChildren.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildAutomaticGroupEntityTree.<anonymous>' call
    setParentMaintainWorldTransform(element.n39_1, root);
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var hosts = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = newEntitiesWithChildren.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildAutomaticGroupEntityTree.<anonymous>' call
    if (any_0(hosts)) {
      var snapSettings = new SnapSettings(true, true, false, true);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      var tmp_0 = Companion_getInstance_133().s35_1;
      var tmp_1 = Companion_instance_137;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$1 = copyToArray(hosts);
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = tmp_0.sortAndSelect(tmp_1.p39(element_0.n39_1, tmp$ret$1, snapSettings));
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_1 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildAutomaticGroupEntityTree.<anonymous>.<anonymous>' call
        if (element_1.movement.equals(Companion_getInstance_81().ZERO) && element_1.deltaRotation.equals(Companion_getInstance_74().q2b_1)) {
          destination.h(element_1);
        }
      }
      var candidates = copyToArray(destination);
      var validCandidate = $this.n37_1.getFirstValidSnap(candidates, false).tf();
      if (validCandidate == null)
        null;
      else {
        validCandidate.performMoveAndConnect();
      }
    }
    hosts.h(element_0.n39_1);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = element_0.o39_1.k();
    while (tmp0_iterator_1.m()) {
      var element_2 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildAutomaticGroupEntityTree.<anonymous>.<anonymous>' call
      $this.t39(element_2.q39_1, element_0.n39_1);
    }
  }
  var group = get_automaticEntityGroup(first_0(newEntitiesWithChildren).n39_1);
  if (group == null)
    null;
  else {
    setParent_0(group, null);
  }
  return group;
}
function hasAnyEntityWithSerializedConnections($this, shadowRoot) {
  var tmp = Companion_instance_62;
  return !(tmp.h2r(shadowRoot, EntityTreeBuilder$hasAnyEntityWithSerializedConnections$lambda) == null);
}
function ShadowEntityWithParent(shadowEntity, parent, existingChild) {
  existingChild = existingChild === VOID ? null : existingChild;
  this.q39_1 = shadowEntity;
  this.r39_1 = parent;
  this.s39_1 = existingChild;
}
protoOf(ShadowEntityWithParent).toString = function () {
  return 'ShadowEntityWithParent(shadowEntity=' + this.q39_1.toString() + ', parent=' + toString(this.r39_1) + ', existingChild=' + toString(this.s39_1) + ')';
};
protoOf(ShadowEntityWithParent).hashCode = function () {
  var result = this.q39_1.hashCode();
  result = imul(result, 31) + (this.r39_1 == null ? 0 : this.r39_1.hashCode()) | 0;
  result = imul(result, 31) + (this.s39_1 == null ? 0 : this.s39_1.hashCode()) | 0;
  return result;
};
protoOf(ShadowEntityWithParent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShadowEntityWithParent))
    return false;
  var tmp0_other_with_cast = other instanceof ShadowEntityWithParent ? other : THROW_CCE();
  if (!this.q39_1.equals(tmp0_other_with_cast.q39_1))
    return false;
  if (!equals(this.r39_1, tmp0_other_with_cast.r39_1))
    return false;
  if (!equals(this.s39_1, tmp0_other_with_cast.s39_1))
    return false;
  return true;
};
function NewEntityWithShadowChildren(newEntity, children) {
  this.n39_1 = newEntity;
  this.o39_1 = children;
}
protoOf(NewEntityWithShadowChildren).toString = function () {
  return 'NewEntityWithShadowChildren(newEntity=' + this.n39_1.toString() + ', children=' + toString_0(this.o39_1) + ')';
};
protoOf(NewEntityWithShadowChildren).hashCode = function () {
  var result = this.n39_1.hashCode();
  result = imul(result, 31) + hashCode(this.o39_1) | 0;
  return result;
};
protoOf(NewEntityWithShadowChildren).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NewEntityWithShadowChildren))
    return false;
  var tmp0_other_with_cast = other instanceof NewEntityWithShadowChildren ? other : THROW_CCE();
  if (!this.n39_1.equals(tmp0_other_with_cast.n39_1))
    return false;
  if (!equals(this.o39_1, tmp0_other_with_cast.o39_1))
    return false;
  return true;
};
function buildEntityTreeInternal($this, shadowRoot, parent, preCreated) {
  var tmp;
  if (get_isAutomaticGroup(shadowRoot)) {
    var theSecretOrderOfTheShadowChildren = findCorrectEntityGroupOrder($this, shadowRoot);
    var temporaryGroupInfoComponent = new GroupInfoDuringDeserializingComponent(theSecretOrderOfTheShadowChildren);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = theSecretOrderOfTheShadowChildren.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>' call
      element.removeComponentInternal(Companion_getInstance_59().z2o_1);
      element.removeComponentInternal(Companion_getInstance_145().id);
      element.addComponent(temporaryGroupInfoComponent);
      var list = buildEntityTreeInternal$default($this, element, parent);
      addAll(destination, list);
    }
    var newChildren = destination;
    var tmp0_safe_receiver = firstOrNull_1(newChildren);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n39_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_automaticEntityGroup(tmp1_safe_receiver);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = shadowRoot.components();
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>.<anonymous>' call
        if (element_0.serializable && !tmp2_safe_receiver.hasComponent(element_0.typeId)) {
          destination_0.h(element_0);
        }
      }
      var tmp0_iterator_0 = destination_0.k();
      while (tmp0_iterator_0.m()) {
        var element_1 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>.<anonymous>' call
        tmp2_safe_receiver.addComponent(element_1);
      }
    }
    tmp = newChildren;
  } else {
    var newEntity = buildEntityTreeNode($this, shadowRoot, parent, preCreated);
    var tmp_0;
    if (newEntity == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTreeInternal.<anonymous>' call
      tmp_0 = listOf(newEntity);
    }
    var tmp4_elvis_lhs = tmp_0;
    tmp = tmp4_elvis_lhs == null ? emptyList() : tmp4_elvis_lhs;
  }
  var newChildren_0 = tmp;
  return newChildren_0;
}
function buildEntityTreeInternal$default($this, shadowRoot, parent, preCreated, $super) {
  parent = parent === VOID ? null : parent;
  preCreated = preCreated === VOID ? null : preCreated;
  return buildEntityTreeInternal($this, shadowRoot, parent, preCreated);
}
function buildEntityTreeNode($this, shadowEntity, parent, preCreated) {
  var tmp;
  if (!(preCreated == null)) {
    tmp = preCreated;
  } else {
    var tmp0_elvis_lhs = createEntityFromShadow($this, shadowEntity);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var entity = tmp_0;
    repositionAndAddComponentsToPartsOfAssembly($this, entity, shadowEntity);
    addSerializedComponents($this, shadowEntity, entity);
    placeNewEntity($this, shadowEntity, entity, parent);
    tmp = entity;
  }
  var newEntity = tmp;
  var children = buildChildren($this, shadowEntity, newEntity);
  return new NewEntityWithShadowChildren(newEntity, children);
}
function buildChildren($this, shadowEntity, newEntity) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = immediateNonPartDescendants($this, shadowEntity);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildChildren.<anonymous>' call
    var childParent = findParentAmongCreatedEntities($this, item, newEntity);
    // Inline function 'kotlin.collections.find' call
    var this_1 = get_children(newEntity);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_1.length;
      while (inductionVariable < last) {
        var element = this_1[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildChildren.<anonymous>.<anonymous>' call
        var mappedShadowId = mapShadowIdToRealId($this, item.id);
        if (element.id === mappedShadowId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var existingChild = tmp$ret$1;
    var tmp;
    if (!(existingChild == null)) {
      existingChild.addComponent(new LocalTransformComponent(get_localTransform(item)));
      tmp = new ShadowEntityWithParent(item, childParent, existingChild);
    } else {
      tmp = new ShadowEntityWithParent(item, childParent);
    }
    var tmp$ret$3 = tmp;
    destination.h(tmp$ret$3);
  }
  var children = destination;
  return children;
}
function findParentAmongCreatedEntities($this, shadowChild, newEntity) {
  var tmp0_safe_receiver = get_childComponent(shadowChild);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parent;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.id;
  var shadowParentId = tmp2_elvis_lhs == null ? newEntity.id : tmp2_elvis_lhs;
  var mappedShadowParentId = mapShadowIdToRealId($this, shadowParentId);
  // Inline function 'kotlin.sequences.find' call
  var this_0 = get_hierarchySequence(newEntity);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.sequences.firstOrNull' call
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.findParentAmongCreatedEntities.<anonymous>' call
      if (element.id === mappedShadowParentId) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp3_elvis_lhs = tmp$ret$1;
  return tmp3_elvis_lhs == null ? newEntity : tmp3_elvis_lhs;
}
function repositionAndAddComponentsToPartsOfAssembly($this, newEntity, shadowEntity) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_descendants(newEntity);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.repositionAndAddComponentsToPartsOfAssembly.<anonymous>' call
    var shadowVersion = findInHierarchy_0(shadowEntity, EntityTreeBuilder$repositionAndAddComponentsToPartsOfAssembly$lambda($this, element));
    if (!(shadowVersion == null)) {
      Companion_instance_146.z1l(element, get_worldTransform(shadowVersion));
      addSerializedComponents($this, shadowVersion, element);
    }
  }
}
function immediateNonPartDescendants($this, entity) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = get_children(entity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.immediateNonPartDescendants.<anonymous>' call
    var list = !get_isProductPart(element) ? listOf(element) : immediateNonPartDescendants($this, element);
    addAll(destination, list);
  }
  return destination;
}
function createEntityFromShadow($this, shadowEntity) {
  var tmp;
  if (shadowEntity.hasComponent(Companion_getInstance_8().id)) {
    tmp = recreateProduct($this, shadowEntity);
  } else {
    var entityId = mapShadowIdToRealId($this, shadowEntity.id);
    tmp = $this.l37_1.createEntityInternal(entityId);
  }
  var newEntity = tmp;
  if (newEntity == null)
    null;
  else
    newEntity.addComponent(new LocalTransformComponent(get_worldTransform(shadowEntity)));
  if (newEntity == null)
    null;
  else
    newEntity.addComponent(new WorldTransformComponent(get_worldTransform(shadowEntity)));
  return newEntity;
}
function addSerializedComponents($this, shadowEntity, newEntity) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = shadowEntity.components();
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.addSerializedComponents.<anonymous>' call
    if (!(element.typeId === Companion_getInstance_149().id) && !(element.typeId === Companion_getInstance_145().id) && !(element.typeId === Companion_getInstance_65().id) && !(element.typeId === Companion_getInstance_59().z2o_1)) {
      destination.h(element);
    }
  }
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.addSerializedComponents.<anonymous>' call
    newEntity.addComponent(element_0);
  }
}
function placeNewEntity($this, shadowEntity, newEntity, parent) {
  var hasShadowParent = !(get_parent(shadowEntity) == null);
  if (hasShadowParent || !(parent == null)) {
    var hadConnectionBefore = shadowEntity.hasComponent(Companion_getInstance_114().s38_1);
    var shouldResnap = $this.p37_1 && hadConnectionBefore || !$this.p37_1;
    if (shouldResnap) {
      resnapNewEntity($this, hasShadowParent, newEntity, parent);
    } else {
      setParentMaintainWorldTransform(newEntity, parent);
    }
  } else if (!get_localTransform(shadowEntity).rotation.isIdentity || !get_localTransform(shadowEntity).position.isZero()) {
    newEntity.addComponent(new LocalTransformComponent(get_localTransform(shadowEntity)));
  }
}
function resnapNewEntity($this, hasShadowParent, newEntity, parent) {
  var candidates = findSnapsForNewEntity($this, hasShadowParent, newEntity, parent);
  var filteredCandidates = filterOutInvalidSnapCandidatesForGroupMember($this, candidates, newEntity, parent);
  var tmp;
  if (filteredCandidates == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    tmp = !(filteredCandidates.length === 0);
  }
  if (tmp === true) {
    var validCandidate = $this.n37_1.getFirstValidSnap(filteredCandidates, false).tf();
    if (!(validCandidate == null)) {
      validCandidate.performMoveAndConnect();
    } else {
      var tmp_0 = Companion_getInstance_120().u39_1;
      tmp_0.warn(EntityTreeBuilder$resnapNewEntity$lambda(newEntity));
      first(filteredCandidates).performMoveAndConnect();
    }
  } else {
    setParentMaintainWorldTransform(newEntity, parent);
  }
}
function filterOutInvalidSnapCandidatesForGroupMember($this, candidates, entity, parent) {
  var groupInfo = entity.__getComponentForKotlin(Companion_getInstance_121().w39_1);
  var serializedConnections = entity.__getComponentForKotlin(Companion_getInstance_114().s38_1);
  if (groupInfo == null || serializedConnections == null)
    return candidates;
  var tmp;
  if (candidates == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = candidates.length;
    while (inductionVariable < last) {
      var element = candidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.filterOutInvalidSnapCandidatesForGroupMember.<anonymous>' call
      if (entityHadConnectionToThisHostBeforeSerializing($this, serializedConnections, element.host) || element.host.equals(parent)) {
        destination.h(element);
      }
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp1_safe_receiver);
  }
  return tmp_0;
}
function entityHadConnectionToThisHostBeforeSerializing($this, serializedConnections, candidateHost) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var this_0 = serializedConnections.a39_1;
    var tmp;
    if (isInterface(this_0, Collection)) {
      tmp = this_0.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.entityHadConnectionToThisHostBeforeSerializing.<anonymous>' call
      var newConnectionHostId = mapShadowIdToRealId($this, toInt(element.o38_1));
      if (newConnectionHostId === candidateHost.id) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function findSnapsForNewEntity($this, hasShadowParent, newEntity, parent) {
  var hasShadowParentSnapSettings = new SnapSettings(true, true, true, true);
  var nonNullParentSettings = new SnapSettings(true, true, false, true);
  var tmp;
  if (hasShadowParent && !(parent == null)) {
    tmp = Companion_getInstance_133().s35_1.sortAndSelect(Companion_instance_137.p1l(newEntity, parent, hasShadowParentSnapSettings));
  } else if (!(parent == null)) {
    var tmp_0 = Companion_getInstance_133().s35_1;
    var tmp_1 = Companion_instance_137;
    // Inline function 'kotlin.collections.plus' call
    var this_0 = get_upwardsHierarchy(parent);
    var elements = get_descendants(parent);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this_0.concat(elements);
    tmp = tmp_0.sortAndSelect(tmp_1.p39(newEntity, tmp$ret$1, nonNullParentSettings));
  } else {
    tmp = null;
  }
  return tmp;
}
function recreateProduct($this, shadowEntity) {
  var params = getModifiedParamsOnly($this, shadowEntity);
  var specification = $this.m37_1.productSpecification(get_productRefOrEmptyString(shadowEntity), params);
  var tmp = Companion_getInstance_120();
  var refinedSpecification = modifyAssemblyComponentsIfNeeded(tmp, EntityTreeBuilder$mapShadowIdToRealId$ref($this), specification, shadowEntity);
  var interceptorCatalog = new InterceptingAssemblyPartCatalog(shadowEntity, $this.m37_1, EntityTreeBuilder$mapShadowIdToRealId$ref_0($this));
  $this.m37_1.addCatalog(interceptorCatalog);
  var tmp_0;
  if (refinedSpecification == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>' call
    var entityId = mapShadowIdToRealId($this, shadowEntity.id);
    var product = $this.m37_1.createFromSpecification(get_productRefOrEmptyString(shadowEntity), refinedSpecification, entityId);
    var tmp1_safe_receiver = product == null ? null : get_descendants(product);
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>.<anonymous>' call
        if (!element.hasComponent(Companion_instance_116.id)) {
          destination.h(element);
        }
      }
      tmp_1 = destination;
    }
    var tmp2_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator = tmp2_safe_receiver.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>.<anonymous>' call
        if (!element_0.hasComponent(Companion_getInstance_5().id)) {
          destination_0.h(element_0);
        }
      }
      tmp_2 = destination_0;
    }
    var tmp3_safe_receiver = tmp_2;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = tmp3_safe_receiver.k();
      while (tmp0_iterator_0.m()) {
        var element_1 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>.<anonymous>' call
        $this.l37_1.disposeEntity(element_1);
      }
    }
    $this.m37_1.removeCatalog(interceptorCatalog);
    var tmp5_safe_receiver = product == null ? null : get_hierarchySequence(product);
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.sequences.forEach' call
      var tmp0_iterator_1 = tmp5_safe_receiver.k();
      while (tmp0_iterator_1.m()) {
        var element_2 = tmp0_iterator_1.n();
        // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.recreateProduct.<anonymous>.<anonymous>' call
        element_2.removeComponent(Companion_getInstance_1().id);
      }
    }
    tmp_0 = product;
  }
  return tmp_0;
}
function getModifiedParamsOnly($this, shadowEntity) {
  var component = shadowEntity.__getComponentForKotlin(Companion_getInstance_10().id);
  if (component == null || component.isOriginalParams) {
    return null;
  }
  return component.params;
}
function InterceptingAssemblyPartCatalog(currentProductRoot, productManager, idMapper) {
  this.x39_1 = currentProductRoot;
  this.y39_1 = productManager;
  this.z39_1 = idMapper;
  this.a3a_1 = true;
  this.b3a_1 = false;
}
protoOf(InterceptingAssemblyPartCatalog).s1t = function () {
  return this.a3a_1;
};
protoOf(InterceptingAssemblyPartCatalog).t1t = function (productRef, params) {
  if (this.b3a_1) {
    return null;
  }
  var tmp0_elvis_lhs = findInHierarchy_0(this.x39_1, EntityTreeBuilder$InterceptingAssemblyPartCatalog$productSpecification$lambda(productRef));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var entityToCreate = tmp;
  this.b3a_1 = true;
  var specification = this.y39_1.productSpecification(productRef);
  this.b3a_1 = false;
  return modifyAssemblyComponentsIfNeeded(Companion_getInstance_120(), this.z39_1, specification, entityToCreate);
};
protoOf(InterceptingAssemblyPartCatalog).rangeId = function () {
  return 'InterceptingAssemblyPartCatalog';
};
protoOf(InterceptingAssemblyPartCatalog).rangeVersion = function () {
  return '1.0';
};
protoOf(InterceptingAssemblyPartCatalog).toString = function () {
  return this.rangeId() + this.rangeVersion();
};
protoOf(InterceptingAssemblyPartCatalog).allProductRefs = function () {
  // Inline function 'kotlin.emptyArray' call
  return [];
};
function findCorrectEntityGroupOrder($this, shadowEntity) {
  return Companion_instance_118.m39(shadowEntity);
}
function Companion_119() {
  Companion_instance_119 = this;
  this.u39_1 = LoggerState_getInstance().g1v('EntityTreeBuilder');
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.v39_1 = [Companion_instance_21.k1o_1, Companion_instance_21.r1q_1];
}
var Companion_instance_119;
function Companion_getInstance_120() {
  if (Companion_instance_119 == null)
    new Companion_119();
  return Companion_instance_119;
}
function EntityTreeBuilder$hasAnyEntityWithSerializedConnections$lambda(it) {
  return it.hasComponent(Companion_getInstance_114().s38_1);
}
function EntityTreeBuilder$repositionAndAddComponentsToPartsOfAssembly$lambda(this$0, $newEntityPart) {
  return function (shadowEntity) {
    var mappedShadowId = mapShadowIdToRealId(this$0, shadowEntity.id);
    return mappedShadowId === $newEntityPart.id;
  };
}
function EntityTreeBuilder$resnapNewEntity$lambda($newEntity) {
  return function () {
    return 'Could not find a valid snap, for ' + $newEntity.toString() + ' with product ref ' + get_productRefOrEmptyString($newEntity) + ', when rebuilding scene. Will use the first non valid snap.';
  };
}
function EntityTreeBuilder$mapShadowIdToRealId$ref($boundThis) {
  var l = function (p0) {
    return mapShadowIdToRealId($boundThis, p0);
  };
  l.callableName = 'mapShadowIdToRealId';
  return l;
}
function EntityTreeBuilder$mapShadowIdToRealId$ref_0($boundThis) {
  var l = function (p0) {
    return mapShadowIdToRealId($boundThis, p0);
  };
  l.callableName = 'mapShadowIdToRealId';
  return l;
}
function EntityTreeBuilder(entityManager, productManager, validationService) {
  Companion_getInstance_120();
  this.l37_1 = entityManager;
  this.m37_1 = productManager;
  this.n37_1 = validationService;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.o37_1 = LinkedHashMap_init_$Create$_0();
  this.p37_1 = false;
}
protoOf(EntityTreeBuilder).t39 = function (shadowRoot, parent) {
  this.p37_1 = hasAnyEntityWithSerializedConnections(this, shadowRoot);
  if (get_isAutomaticGroup(shadowRoot))
    return buildAutomaticGroupEntityTree(this, shadowRoot);
  // Inline function 'kotlin.collections.mutableListOf' call
  var remainingToBuild = ArrayList_init_$Create$();
  remainingToBuild.h(new ShadowEntityWithParent(shadowRoot, parent));
  var root = null;
  $l$loop: while (true) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!!remainingToBuild.r()) {
      break $l$loop;
    }
    var next = removeFirst(remainingToBuild);
    var newEntitiesWithChildren = buildEntityTreeInternal$default(this, next.q39_1, next.r39_1);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = newEntitiesWithChildren.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.serialization.entitytreebuilder.EntityTreeBuilder.buildEntityTree.<anonymous>' call
      remainingToBuild.p(element.o39_1);
    }
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!newEntitiesWithChildren.r()) {
      tmp = root == null;
    } else {
      tmp = false;
    }
    if (tmp) {
      root = newEntitiesWithChildren.q(0).n39_1;
    }
  }
  return root;
};
protoOf(EntityTreeBuilder).q37 = function (shadowRoot, parent, $super) {
  parent = parent === VOID ? null : parent;
  return $super === VOID ? this.t39(shadowRoot, parent) : $super.t39.call(this, shadowRoot, parent);
};
function Companion_120() {
  Companion_instance_120 = this;
  this.w39_1 = Companion_instance_21.b1s_1;
}
var Companion_instance_120;
function Companion_getInstance_121() {
  if (Companion_instance_120 == null)
    new Companion_120();
  return Companion_instance_120;
}
function GroupInfoDuringDeserializingComponent(members) {
  Companion_getInstance_121();
  this.c3a_1 = members;
  this.d3a_1 = Companion_getInstance_121().w39_1;
}
protoOf(GroupInfoDuringDeserializingComponent).p1s = function () {
  return this.d3a_1;
};
protoOf(GroupInfoDuringDeserializingComponent).eq = function (other) {
  return equals((other instanceof GroupInfoDuringDeserializingComponent ? other : THROW_CCE()).c3a_1, this.c3a_1);
};
function createSerializableEntitiesWithRelations($this, entity, parentProductRoot) {
  var realParent = get_parent(entity);
  var needsResnap = !equals(realParent, parentProductRoot);
  var tmp0_safe_receiver = entity.__getComponentForKotlin(Companion_getInstance_27().id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.serialization.v13.Companion.createSerializableEntitiesWithRelations.<anonymous>' call
    entity.addComponentInternal(Companion_getInstance_114().v38(tmp0_safe_receiver));
  }
  if (entity.__getComponentForKotlin(SceneComponent_instance.id) == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.serialization.v13.Companion.createSerializableEntitiesWithRelations.<anonymous>' call
    entity.addComponentInternal(new SerializableSceneComponent());
  }
  // Inline function 'kotlin.apply' call
  var this_0 = new SerializableEntityV13();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.serialization.v13.Companion.createSerializableEntitiesWithRelations.<anonymous>' call
  this_0.k3a(entity, Json$parseToJsonElement$ref(Companion_getInstance_110().u37_1));
  var currentSerializedEntity = this_0;
  if (!(parentProductRoot == null)) {
    currentSerializedEntity.l3a(parentProductRoot, needsResnap);
  }
  entity.removeComponentInternal(Companion_getInstance_114().s38_1);
  entity.removeComponentInternal(Companion_getInstance_116().g39_1);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_1 = get_children(entity);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_1.length;
  while (inductionVariable < last) {
    var element = this_1[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.v13.Companion.createSerializableEntitiesWithRelations.<anonymous>' call
    var list = createSerializableEntitiesWithRelations(Companion_getInstance_122(), element, entity);
    addAll(destination, list);
  }
  var children = destination;
  return plus_1(children, new Pair(entity, currentSerializedEntity));
}
function Json$parseToJsonElement$ref($boundThis) {
  var l = function (p0) {
    return $boundThis.z16(p0);
  };
  l.callableName = 'parseToJsonElement';
  return l;
}
function SerializableEntityConverter$Companion$cleanUp$lambda(it) {
  it.removeComponentInternal(Companion_getInstance_114().s38_1);
  return Unit_instance;
}
function deserializeId($this, stringId) {
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = $this.o3a_1;
  var value = this_0.f2(stringId);
  var tmp;
  if (value == null) {
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.deserializeId.<anonymous>' call
    var answer = $this.m3a_1.getNextId();
    this_0.q2(stringId, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
function ProductRefLevel(ref, level) {
  this.p3a_1 = ref;
  this.q3a_1 = level;
}
protoOf(ProductRefLevel).toString = function () {
  return 'ProductRefLevel(ref=' + this.p3a_1 + ', level=' + this.q3a_1 + ')';
};
protoOf(ProductRefLevel).hashCode = function () {
  var result = getStringHashCode(this.p3a_1);
  result = imul(result, 31) + this.q3a_1 | 0;
  return result;
};
protoOf(ProductRefLevel).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProductRefLevel))
    return false;
  var tmp0_other_with_cast = other instanceof ProductRefLevel ? other : THROW_CCE();
  if (!(this.p3a_1 === tmp0_other_with_cast.p3a_1))
    return false;
  if (!(this.q3a_1 === tmp0_other_with_cast.q3a_1))
    return false;
  return true;
};
function extractAssemblyParts($this, entityDOs, components) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var parts = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var childToParentMap = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var parentToChildMap = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = entityDOs.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.<anonymous>' call
    var tmp0_safe_receiver = element.g3a_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var parentId = deserializeId($this, tmp0_safe_receiver);
      var entityId = deserializeId($this, element.e3a_1);
      // Inline function 'kotlin.collections.set' call
      childToParentMap.q2(entityId, parentId);
      // Inline function 'kotlin.collections.getOrPut' call
      var value = parentToChildMap.f2(parentId);
      var tmp;
      if (value == null) {
        // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.mutableSetOf' call
        var answer = LinkedHashSet_init_$Create$();
        parentToChildMap.q2(parentId, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      tmp.h(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator_0 = entityDOs.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.<anonymous>' call
    if (element_0.g3a_1 == null) {
      destination.h(element_0);
    }
  }
  var tmp0_iterator_1 = destination.k();
  while (tmp0_iterator_1.m()) {
    var element_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.<anonymous>' call
    extractAssemblyParts$checkComponents($this, parentToChildMap, components, childToParentMap, entityDOs, parts, element_1);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(parts.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_2 = parts.i2().k();
  while (tmp0_iterator_2.m()) {
    var item = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.<anonymous>' call
    var tmp_0 = item.b2();
    // Inline function 'kotlin.collections.map' call
    var this_0 = item.c2();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(this_0.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_3 = this_0.i2().k();
    while (tmp0_iterator_3.m()) {
      var item_0 = tmp0_iterator_3.n();
      // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.<anonymous>.<anonymous>' call
      var tmp$ret$12 = new Pair(item_0.b2(), item_0.c2().p3a_1);
      destination_1.h(tmp$ret$12);
    }
    var tmp$ret$15 = new Pair(tmp_0, AssemblyPartsComponent_init_$Create$(toMap(destination_1)));
    destination_0.h(tmp$ret$15);
  }
  return toMap(destination_0);
}
function createEntity_0($this, entityDO, partKeyComponents, assemblyParts) {
  var entity = createProductWithoutProductRootChildren($this, entityDO, $this.n3a_1, partKeyComponents, assemblyParts);
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = entityDO.f3a_1;
  if (charSequenceLength(this_0) > 0) {
    tmp = entity == null;
  } else {
    tmp = false;
  }
  if (tmp) {
    throw IllegalStateException_init_$Create$('Tried loading entity ' + entityDO.e3a_1 + ' with reference that is not present in catalog, product reference ' + entityDO.f3a_1);
  }
  if (entity == null && entityDO.f3a_1 === '') {
    var entityId = deserializeId($this, entityDO.e3a_1);
    entity = $this.m3a_1.createEntityInternal(entityId);
  }
  var tmp0_safe_receiver = entity;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.createEntity.<anonymous>' call
    tmp_0 = new EntityAndDO(tmp0_safe_receiver, entityDO);
  }
  return tmp_0;
}
function asList_0($this, entityDO) {
  var tmp0_safe_receiver = entityDO.j3a_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : asList(tmp0_safe_receiver);
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
function addComponents($this, entityAndDO, components) {
  if (components == null)
    null;
  else {
    // Inline function 'kotlin.collections.onEach' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.onEach.<anonymous>' call
    var tmp0_iterator = components.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.addComponents.<anonymous>' call
      if (element instanceof SerializableGuestConnectionsComponent) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = element.a39_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator_0 = this_0.k();
        while (tmp0_iterator_0.m()) {
          var item = tmp0_iterator_0.n();
          // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.addComponents.<anonymous>.<anonymous>' call
          var tmp$ret$0 = item.x38(deserializeId($this, item.n38_1).toString(), deserializeId($this, item.o38_1).toString());
          destination.h(tmp$ret$0);
        }
        var newConnections = destination;
        $this.m3a_1.addComponent(entityAndDO.r3a_1, new SerializableGuestConnectionsComponent(newConnections));
      } else {
        $this.m3a_1.addComponent(entityAndDO.r3a_1, element);
      }
    }
  }
}
function fixProductPartComponents($this, entity, connectionRoot, partKeyComponents) {
  if (!(connectionRoot == null) && entity.hasComponent(Companion_getInstance_5().id)) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = entity.components();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.fixProductPartComponents.<anonymous>' call
      if (!element.serializable && !(element.typeId === Companion_getInstance_65().id) && !(element.typeId === Companion_getInstance_59().z2o_1) && !(element.typeId === Companion_instance_101.n1s()) && !(element.typeId === Companion_getInstance_145().id) && !(element.typeId === Companion_getInstance_111().id) && !(element.typeId === Companion_getInstance_10().id)) {
        entity.removeComponentInternal(element.typeId);
      }
    }
    var toAdd = partKeyComponents.f2(new EntityPartKey(connectionRoot.id, ensureNotNull(get_partKey(entity))));
    if (toAdd == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = toAdd.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.fixProductPartComponents.<anonymous>' call
        if (!entity.hasComponent(element_0.typeId)) {
          entity.addComponent(element_0);
        }
      }
    }
  }
  var meRoot = entity.hasComponent(Companion_getInstance_25().id) ? entity : connectionRoot;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject_0 = get_children(entity);
  var inductionVariable_0 = 0;
  var last_0 = indexedObject_0.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = indexedObject_0[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.fixProductPartComponents.<anonymous>' call
    if (!element_1.isDisposed) {
      fixProductPartComponents($this, element_1, meRoot, partKeyComponents);
    }
  }
}
function buildProductRootHierarchy($this, entityAndDO, entities) {
  var entity = entityAndDO.tf();
  var serializableEntity = entityAndDO.uf();
  var tmp0_elvis_lhs = serializableEntity.g3a_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parentId = tmp;
  var deserializedParentID = deserializeId($this, parentId);
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = entities.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.buildProductRootHierarchy.<anonymous>' call
      if (element.id === deserializedParentID) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp1_safe_receiver = tmp$ret$1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.buildProductRootHierarchy.<anonymous>' call
    setParentMaintainWorldTransform(entity, tmp1_safe_receiver);
    var tmp0_safe_receiver = get_parentComponent(tmp1_safe_receiver);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.addChild(entity);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$5 = [entity];
      tmp_0 = new ParentComponent(tmp$ret$5);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var pc = tmp_0;
    $this.m3a_1.addComponent(tmp1_safe_receiver, pc);
  }
}
function createProductWithoutProductRootChildren($this, entityDO, productManager, partKeyComponents, partKeyProducts) {
  var entityId = deserializeId($this, entityDO.e3a_1);
  var tmp0_safe_receiver = entityDO.j3a_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.createProductWithoutProductRootChildren.<anonymous>' call
        if (element.typeId === Companion_getInstance_10().id) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp1_safe_receiver = tmp_0 instanceof ProductParamsComponent ? tmp_0 : null;
  var params = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.params;
  var tmp2_safe_receiver = productManager.productSpecification(entityDO.f3a_1, params);
  var tmp_1;
  if (tmp2_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.createProductWithoutProductRootChildren.<anonymous>' call
    var spec = tmp2_safe_receiver;
    var tmp0_safe_receiver_0 = partKeyProducts.f2(entityId);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      spec = tmp2_safe_receiver.addComponent(tmp0_safe_receiver_0);
    }
    var entity = productManager.createFromSpecificationInternal(entityDO.f3a_1, spec, entityId);
    var tmp2_safe_receiver_0 = entity == null ? null : get_descendants(entity);
    if (tmp2_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp2_safe_receiver_0.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp2_safe_receiver_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.createProductWithoutProductRootChildren.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_1 = get_partKey(element_0);
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_2 = new EntityPartKey(entityId, tmp0_safe_receiver_1);
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var this_0 = element_0.components();
          var destination = ArrayList_init_$Create$();
          var inductionVariable_1 = 0;
          var last_1 = this_0.length;
          while (inductionVariable_1 < last_1) {
            var element_1 = this_0[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.createProductWithoutProductRootChildren.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            if (!element_1.serializable) {
              destination.h(element_1);
            }
          }
          partKeyComponents.q2(tmp_2, destination);
        }
      }
    }
    var tmp4_safe_receiver = entity == null ? null : get_descendants(entity);
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_2 = 0;
      var last_2 = tmp4_safe_receiver.length;
      while (inductionVariable_2 < last_2) {
        var element_2 = tmp4_safe_receiver[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.createProductWithoutProductRootChildren.<anonymous>.<anonymous>' call
        if (!element_2.isDisposed) {
          $this.m3a_1.removeAllComponents(element_2);
          $this.m3a_1.disposeEntity(element_2);
        }
      }
    }
    tmp_1 = entity;
  }
  return tmp_1;
}
function Companion_121() {
  Companion_instance_121 = this;
  this.t3a_1 = LoggerState_getInstance().g1v('SerializerV13');
}
protoOf(Companion_121).u3a = function (productManager) {
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp1_safe_receiver = productManager == null ? null : productManager.catalogs;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(tmp1_safe_receiver.length), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'com.ikea.core.serialization.v13.Companion.serializeCatalogs.<anonymous>' call
      var pair = new Pair(element.rangeId(), element.rangeVersion());
      destination.q2(pair.rf_1, pair.sf_1);
    }
    tmp = destination;
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
};
protoOf(Companion_121).v3a = function (entities) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = entities.length;
  while (inductionVariable < last) {
    var element = entities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
    if (get_parent(element) == null || !contains(entities, get_parent(element))) {
      destination.h(element);
    }
  }
  var roots = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = roots.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
    var list = createSerializableEntitiesWithRelations(Companion_getInstance_122(), element_0, null);
    addAll(destination_0, list);
  }
  var serializableEntities = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.distinctBy' call
  var this_0 = serializableEntities;
  var set = HashSet_init_$Create$();
  var list_0 = ArrayList_init_$Create$();
  var tmp0_iterator_0 = this_0.k();
  while (tmp0_iterator_0.m()) {
    var e = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
    var key = e.rf_1;
    if (set.h(key)) {
      list_0.h(e);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$();
  var tmp0_iterator_1 = list_0.k();
  while (tmp0_iterator_1.m()) {
    var element_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
    var entity = element_1.tf();
    if (contains(entities, entity)) {
      destination_1.h(element_1);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$();
  var tmp0_iterator_2 = destination_1.k();
  while (tmp0_iterator_2.m()) {
    var element_2 = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
    var entity_0 = element_2.tf();
    if (!entity_0.hasComponent(Companion_instance_116.id)) {
      destination_2.h(element_2);
    }
  }
  serializableEntities = destination_2;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_3 = serializableEntities.k();
  while (tmp0_iterator_3.m()) {
    var element_3 = tmp0_iterator_3.n();
    // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
    var serializableEntity = element_3.uf();
    var parentId = serializableEntity.g3a_1;
    // Inline function 'kotlin.collections.find' call
    var this_1 = serializableEntities;
    var tmp$ret$15;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator_4 = this_1.k();
      while (tmp0_iterator_4.m()) {
        var element_4 = tmp0_iterator_4.n();
        // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>.<anonymous>' call
        if (element_4.sf_1.e3a_1 === parentId) {
          tmp$ret$15 = element_4;
          break $l$block;
        }
      }
      tmp$ret$15 = null;
    }
    var parent = tmp$ret$15;
    if (parent == null)
      serializableEntity.g3a_1 = null;
  }
  // Inline function 'kotlin.collections.map' call
  var this_2 = serializableEntities;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_5 = this_2.k();
  while (tmp0_iterator_5.m()) {
    var item = tmp0_iterator_5.n();
    // Inline function 'com.ikea.core.serialization.v13.Companion.serializeForest.<anonymous>' call
    var serializableEntity_0 = item.uf();
    destination_3.h(serializableEntity_0);
  }
  return destination_3;
};
protoOf(Companion_121).w3a = function (root) {
  forEachInHierarchy_0(root, SerializableEntityConverter$Companion$cleanUp$lambda);
};
var Companion_instance_121;
function Companion_getInstance_122() {
  if (Companion_instance_121 == null)
    new Companion_121();
  return Companion_instance_121;
}
function EntityAndDO(entity, entityDO) {
  this.r3a_1 = entity;
  this.s3a_1 = entityDO;
}
protoOf(EntityAndDO).tf = function () {
  return this.r3a_1;
};
protoOf(EntityAndDO).uf = function () {
  return this.s3a_1;
};
protoOf(EntityAndDO).toString = function () {
  return 'EntityAndDO(entity=' + this.r3a_1.toString() + ', entityDO=' + toString_0(this.s3a_1) + ')';
};
protoOf(EntityAndDO).hashCode = function () {
  var result = this.r3a_1.hashCode();
  result = imul(result, 31) + hashCode(this.s3a_1) | 0;
  return result;
};
protoOf(EntityAndDO).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EntityAndDO))
    return false;
  var tmp0_other_with_cast = other instanceof EntityAndDO ? other : THROW_CCE();
  if (!this.r3a_1.equals(tmp0_other_with_cast.r3a_1))
    return false;
  if (!equals(this.s3a_1, tmp0_other_with_cast.s3a_1))
    return false;
  return true;
};
function EntityPartKey(entityId, partKey) {
  this.x3a_1 = entityId;
  this.y3a_1 = partKey;
}
protoOf(EntityPartKey).toString = function () {
  return 'EntityPartKey(entityId=' + this.x3a_1 + ', partKey=' + this.y3a_1 + ')';
};
protoOf(EntityPartKey).hashCode = function () {
  var result = this.x3a_1;
  result = imul(result, 31) + getStringHashCode(this.y3a_1) | 0;
  return result;
};
protoOf(EntityPartKey).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EntityPartKey))
    return false;
  var tmp0_other_with_cast = other instanceof EntityPartKey ? other : THROW_CCE();
  if (!(this.x3a_1 === tmp0_other_with_cast.x3a_1))
    return false;
  if (!(this.y3a_1 === tmp0_other_with_cast.y3a_1))
    return false;
  return true;
};
function extractAssemblyParts$checkComponents(this$0, parentToChildMap, $components, childToParentMap, $entityDOs, parts, me) {
  var entityId = deserializeId(this$0, me.e3a_1);
  var tmp0_safe_receiver = parentToChildMap.f2(entityId);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp0_safe_receiver.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.checkComponents.<anonymous>' call
      extractAssemblyParts$checkComponents(this$0, parentToChildMap, $components, childToParentMap, $entityDOs, parts, element);
    }
  }
  var tmp1_safe_receiver = $components.f2(entityId);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = tmp1_safe_receiver.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.checkComponents.<anonymous>.<anonymous>' call
      if (element_0 instanceof ProductPartComponent) {
        var rootie = childToParentMap.f2(entityId);
        var level = 0;
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator_1 = $entityDOs.k();
          while (tmp0_iterator_1.m()) {
            var element_1 = tmp0_iterator_1.n();
            // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.checkComponents.<anonymous>.<anonymous>.<anonymous>' call
            if (element_1.e3a_1 === me.e3a_1) {
              tmp$ret$1 = element_1;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp$ret$2 = tmp$ret$1;
        var productRef = ensureNotNull(tmp$ret$2).f3a_1;
        while (!(rootie == null)) {
          // Inline function 'kotlin.collections.getOrPut' call
          var key = rootie;
          var value = parts.f2(key);
          var tmp;
          if (value == null) {
            // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.extractAssemblyParts.checkComponents.<anonymous>.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.collections.mutableMapOf' call
            var answer = LinkedHashMap_init_$Create$_0();
            parts.q2(key, answer);
            tmp = answer;
          } else {
            tmp = value;
          }
          var map = tmp;
          var there = map.f2(element_0.partKey);
          if (there == null) {
            // Inline function 'kotlin.collections.set' call
            var key_0 = element_0.partKey;
            var value_0 = new ProductRefLevel(productRef, level);
            map.q2(key_0, value_0);
            rootie = childToParentMap.f2(rootie);
          } else {
            if (there.q3a_1 > level) {
              // Inline function 'kotlin.collections.set' call
              var key_1 = element_0.partKey;
              var value_1 = new ProductRefLevel(productRef, level);
              map.q2(key_1, value_1);
            }
            rootie = null;
          }
          level = level + 1 | 0;
        }
      }
    }
  }
}
function SerializableEntityConverter(entityManager, productManager) {
  Companion_getInstance_122();
  this.m3a_1 = entityManager;
  this.n3a_1 = productManager;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.o3a_1 = LinkedHashMap_init_$Create$_0();
}
protoOf(SerializableEntityConverter).z3a = function (entityDOs) {
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(entityDOs, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var tmp0_iterator = entityDOs.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'kotlin.collections.plusAssign' call
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>' call
    var entityId = deserializeId(this, element.e3a_1);
    var pair = to(entityId, asList_0(this, element));
    destination.q2(pair.rf_1, pair.sf_1);
  }
  var components = destination;
  var assemblyParts = extractAssemblyParts(this, entityDOs, components);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = entityDOs.k();
  while (tmp0_iterator_0.m()) {
    var element_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>' call
    var parentID = element_0.g3a_1;
    if (!(parentID == null)) {
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp;
        if (isInterface(entityDOs, Collection)) {
          tmp = entityDOs.r();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$3 = true;
          break $l$block_0;
        }
        var tmp0_iterator_1 = entityDOs.k();
        while (tmp0_iterator_1.m()) {
          var element_1 = tmp0_iterator_1.n();
          // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>.<anonymous>' call
          if (element_1.e3a_1 === parentID) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
        }
        tmp$ret$3 = true;
      }
      if (tmp$ret$3) {
        throw IllegalStateException_init_$Create$('Did not find parent ' + parentID + ' for entity ' + element_0.e3a_1 + ' with reference ' + element_0.f3a_1 + ' in deserialized json.');
      }
    }
  }
  // Inline function 'kotlin.collections.mutableMapOf' call
  var partKeyComponents = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_2 = entityDOs.k();
  while (tmp0_iterator_2.m()) {
    var element_2 = tmp0_iterator_2.n();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>' call
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.m3a_1.entities;
    var tmp$ret$7;
    $l$block_1: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_3 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>.<anonymous>' call
        if (element_3.id === deserializeId(this, element_2.e3a_1)) {
          tmp$ret$7 = element_3;
          break $l$block_1;
        }
      }
      tmp$ret$7 = null;
    }
    var found = tmp$ret$7;
    var tmp0_safe_receiver = found == null ? createEntity_0(this, element_2, partKeyComponents, assemblyParts) : new EntityAndDO(found, element_2);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination_0.h(tmp0_safe_receiver);
    }
  }
  var entityAndDOs = destination_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(entityAndDOs, 10));
  var tmp0_iterator_3 = entityAndDOs.k();
  while (tmp0_iterator_3.m()) {
    var item = tmp0_iterator_3.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>' call
    var entity = item.tf();
    destination_1.h(entity);
  }
  var entities = destination_1;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_4 = entityAndDOs.k();
  while (tmp0_iterator_4.m()) {
    var element_4 = tmp0_iterator_4.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>' call
    addComponents(this, element_4, components.f2(element_4.r3a_1.id));
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_5 = entityAndDOs.k();
  while (tmp0_iterator_5.m()) {
    var element_5 = tmp0_iterator_5.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>' call
    buildProductRootHierarchy(this, element_5, entities);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$();
  var tmp0_iterator_6 = entities.k();
  while (tmp0_iterator_6.m()) {
    var element_6 = tmp0_iterator_6.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>' call
    if (get_parent(element_6) == null) {
      destination_2.h(element_6);
    }
  }
  var roots = destination_2;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_7 = roots.k();
  while (tmp0_iterator_7.m()) {
    var element_7 = tmp0_iterator_7.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityConverter.rebuildEntities.<anonymous>' call
    fixProductPartComponents(this, element_7, null, partKeyComponents);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(roots);
};
function Companion_122() {
  Companion_instance_122 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.a3b_1 = [null, null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance())];
}
var Companion_instance_122;
function Companion_getInstance_123() {
  if (Companion_instance_122 == null)
    new Companion_122();
  return Companion_instance_122;
}
function $serializer_13() {
  $serializer_instance_13 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.v13.SerializableEntityV13', this, 5);
  tmp0_serialDesc.lw('id', true);
  tmp0_serialDesc.lw('ref', true);
  tmp0_serialDesc.lw('parent', true);
  tmp0_serialDesc.lw('needsResnap', true);
  tmp0_serialDesc.lw('c', true);
  this.b3b_1 = tmp0_serialDesc;
}
protoOf($serializer_13).c3b = function (encoder, value) {
  var tmp0_desc = this.b3b_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_123().a3b_1;
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.e3a_1 === 'N/A')) {
    tmp1_output.qq(tmp0_desc, 0, value.e3a_1);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.f3a_1 === '')) {
    tmp1_output.qq(tmp0_desc, 1, value.f3a_1);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.g3a_1 == null)) {
    tmp1_output.uq(tmp0_desc, 2, StringSerializer_getInstance(), value.g3a_1);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.h3a_1 === false)) {
    tmp1_output.iq(tmp0_desc, 3, value.h3a_1);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.i3a_1 == null)) {
    tmp1_output.uq(tmp0_desc, 4, tmp2_cached[4], value.i3a_1);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_13).ul = function (encoder, value) {
  return this.c3b(encoder, value instanceof SerializableEntityV13 ? value : THROW_CCE());
};
protoOf($serializer_13).vl = function (decoder) {
  var tmp0_desc = this.b3b_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = false;
  var tmp8_local4 = null;
  var tmp10_input = decoder.bp(tmp0_desc);
  var tmp11_cached = Companion_getInstance_123().a3b_1;
  if (tmp10_input.rp()) {
    tmp4_local0 = tmp10_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.dp(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.pp(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.dp(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.pp(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.cp(tmp0_desc);
  return SerializableEntityV13_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_13).tl = function () {
  return this.b3b_1;
};
protoOf($serializer_13).ex = function () {
  var tmp0_cached = Companion_getInstance_123().a3b_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[4])];
};
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 == null)
    new $serializer_13();
  return $serializer_instance_13;
}
function SerializableEntityV13_init_$Init$(seen0, id, ref, parent, needsResnap, serializedComponents, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_13().b3b_1);
  }
  if (0 === (seen0 & 1))
    $this.e3a_1 = 'N/A';
  else
    $this.e3a_1 = id;
  if (0 === (seen0 & 2))
    $this.f3a_1 = '';
  else
    $this.f3a_1 = ref;
  if (0 === (seen0 & 4))
    $this.g3a_1 = null;
  else
    $this.g3a_1 = parent;
  if (0 === (seen0 & 8))
    $this.h3a_1 = false;
  else
    $this.h3a_1 = needsResnap;
  if (0 === (seen0 & 16))
    $this.i3a_1 = null;
  else
    $this.i3a_1 = serializedComponents;
  $this.j3a_1 = null;
  return $this;
}
function SerializableEntityV13_init_$Create$(seen0, id, ref, parent, needsResnap, serializedComponents, serializationConstructorMarker) {
  return SerializableEntityV13_init_$Init$(seen0, id, ref, parent, needsResnap, serializedComponents, serializationConstructorMarker, objectCreate(protoOf(SerializableEntityV13)));
}
function init$add(base, $parse, c) {
  var serializable = unsafeCast(c);
  // Inline function 'kotlin.collections.set' call
  var key = serializable.serializationKey();
  var value = serializable.toJson($parse);
  base.q2(key, value);
}
function SerializableEntityV13() {
  Companion_getInstance_123();
  this.e3a_1 = 'N/A';
  this.f3a_1 = '';
  this.g3a_1 = null;
  this.h3a_1 = false;
  this.i3a_1 = null;
  this.j3a_1 = null;
}
protoOf(SerializableEntityV13).d38 = function (_set____db54di) {
  this.e3a_1 = _set____db54di;
};
protoOf(SerializableEntityV13).n1s = function () {
  return this.e3a_1;
};
protoOf(SerializableEntityV13).e38 = function (_set____db54di) {
  this.f3a_1 = _set____db54di;
};
protoOf(SerializableEntityV13).f38 = function () {
  return this.f3a_1;
};
protoOf(SerializableEntityV13).g38 = function (_set____db54di) {
  this.g3a_1 = _set____db54di;
};
protoOf(SerializableEntityV13).a2p = function () {
  return this.g3a_1;
};
protoOf(SerializableEntityV13).h38 = function (_set____db54di) {
  this.i3a_1 = _set____db54di;
};
protoOf(SerializableEntityV13).i38 = function () {
  return this.i3a_1;
};
protoOf(SerializableEntityV13).j38 = function (_set____db54di) {
  this.j3a_1 = _set____db54di;
};
protoOf(SerializableEntityV13).l1u = function () {
  return this.j3a_1;
};
protoOf(SerializableEntityV13).k3a = function (entity, parse) {
  this.e3a_1 = entity.id.toString();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var base = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = entity.components();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.v13.SerializableEntityV13.init.<anonymous>' call
    if (element.serializable) {
      init$add(base, parse, element);
    } else if (element.typeId === Companion_getInstance_8().id) {
      var tmp = this;
      tmp.f3a_1 = (element instanceof ProductComponent ? element : THROW_CCE()).productRef;
    }
  }
  this.i3a_1 = base;
};
protoOf(SerializableEntityV13).l3a = function (parent, needsResnap) {
  this.g3a_1 = parent.id.toString();
  this.h3a_1 = needsResnap;
};
function deserializeComponentsForEntity($this, entityDO, serializers) {
  var tmp0_safe_receiver = entityDO.i3a_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = tmp0_safe_receiver.i2().k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.serialization.v13.SerializableTreeV13.deserializeComponentsForEntity.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.b2();
      // Inline function 'kotlin.collections.component2' call
      var value = element.c2();
      var tmp0_safe_receiver_0 = deserializeComponent($this, key, value, serializers);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver_0);
      }
    }
    tmp = destination;
  }
  var tmp1_elvis_lhs = tmp;
  var components = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  var tmp_0 = entityDO;
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = copyToArray(components);
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [new PreviouslySerializedIdComponent(entityDO.e3a_1)];
  tmp_0.j3a_1 = this_0.concat(tmp$ret$11);
}
function deserializeComponent($this, key, json, serializers) {
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = serializers.length;
    while (inductionVariable < last) {
      var element = serializers[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.serialization.v13.SerializableTreeV13.deserializeComponent.<anonymous>' call
      if (element.canHandle(key)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var found = tmp$ret$1;
  if (found == null) {
    var tmp = Companion_getInstance_124().y37_1;
    tmp.warn(SerializableTreeV13$deserializeComponent$lambda(key));
  }
  return found == null ? null : found.deserialize(key, json);
}
function Companion_123() {
  Companion_instance_123 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.x37_1 = [new ArrayListSerializer($serializer_getInstance_13()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), null];
  this.y37_1 = LoggerState_getInstance().g1v('SerializableTreeV13');
}
protoOf(Companion_123).a38 = function (roots, productManager) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.filterNotTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = roots.length;
  while (inductionVariable < last) {
    var element = roots[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.serialization.v13.Companion.buildTreeAndSerialize.<anonymous>' call
    if (!element.hasComponent(Companion_instance_116.id)) {
      destination.h(element);
    }
  }
  var cleanedEntities = copyToArray(destination);
  var serializableEntities = Companion_getInstance_122().v3a(cleanedEntities);
  var serializableCatalogs = Companion_getInstance_122().u3a(productManager);
  return Companion_getInstance_110().t37_1.v16(this.z18(), new SerializableTreeV13(toMutableList_0(serializableEntities), serializableCatalogs));
};
protoOf(Companion_123).z18 = function () {
  return $serializer_getInstance_14();
};
var Companion_instance_123;
function Companion_getInstance_124() {
  if (Companion_instance_123 == null)
    new Companion_123();
  return Companion_instance_123;
}
function $serializer_14() {
  $serializer_instance_14 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.serialization.v13.SerializableTreeV13', this, 3);
  tmp0_serialDesc.lw('entities', true);
  tmp0_serialDesc.lw('catalogs', false);
  tmp0_serialDesc.lw('version', true);
  this.d3b_1 = tmp0_serialDesc;
}
protoOf($serializer_14).e3b = function (encoder, value) {
  var tmp0_desc = this.d3b_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_124().x37_1;
  var tmp;
  if (tmp1_output.yq(tmp0_desc, 0)) {
    tmp = true;
  } else {
    var tmp_0 = value.f3b_1;
    // Inline function 'kotlin.collections.mutableListOf' call
    var tmp$ret$0 = ArrayList_init_$Create$();
    tmp = !equals(tmp_0, tmp$ret$0);
  }
  if (tmp) {
    tmp1_output.sq(tmp0_desc, 0, tmp2_cached[0], value.f3b_1);
  }
  tmp1_output.sq(tmp0_desc, 1, tmp2_cached[1], value.g3b_1);
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.i3b_1 === '1.3')) {
    tmp1_output.qq(tmp0_desc, 2, value.i3b_1);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_14).ul = function (encoder, value) {
  return this.e3b(encoder, value instanceof SerializableTreeV13 ? value : THROW_CCE());
};
protoOf($serializer_14).vl = function (decoder) {
  var tmp0_desc = this.d3b_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp8_input = decoder.bp(tmp0_desc);
  var tmp9_cached = Companion_getInstance_124().x37_1;
  if (tmp8_input.rp()) {
    tmp4_local0 = tmp8_input.np(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.np(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.np(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.np(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.cp(tmp0_desc);
  return SerializableTreeV13_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_14).tl = function () {
  return this.d3b_1;
};
protoOf($serializer_14).ex = function () {
  var tmp0_cached = Companion_getInstance_124().x37_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [tmp0_cached[0], tmp0_cached[1], StringSerializer_getInstance()];
};
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 == null)
    new $serializer_14();
  return $serializer_instance_14;
}
function SerializableTreeV13_init_$Init$(seen0, entities, catalogs, version, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_14().d3b_1);
  }
  if (0 === (seen0 & 1)) {
    var tmp = $this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.f3b_1 = ArrayList_init_$Create$();
  } else
    $this.f3b_1 = entities;
  $this.g3b_1 = catalogs;
  var tmp_0 = $this;
  // Inline function 'kotlin.emptyArray' call
  tmp_0.h3b_1 = [];
  if (0 === (seen0 & 4))
    $this.i3b_1 = '1.3';
  else
    $this.i3b_1 = version;
  return $this;
}
function SerializableTreeV13_init_$Create$(seen0, entities, catalogs, version, serializationConstructorMarker) {
  return SerializableTreeV13_init_$Init$(seen0, entities, catalogs, version, serializationConstructorMarker, objectCreate(protoOf(SerializableTreeV13)));
}
function SerializableTreeV13$deserializeComponent$lambda($key) {
  return function () {
    return 'There is no deserializer for ' + $key;
  };
}
function SerializableTreeV13$removeEntity$lambda($id) {
  return function (it) {
    return it.e3a_1 === $id;
  };
}
function SerializableTreeV13(entities, catalogs) {
  Companion_getInstance_124();
  var tmp;
  if (entities === VOID) {
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp = ArrayList_init_$Create$();
  } else {
    tmp = entities;
  }
  entities = tmp;
  this.f3b_1 = entities;
  this.g3b_1 = catalogs;
  var tmp_0 = this;
  // Inline function 'kotlin.emptyArray' call
  tmp_0.h3b_1 = [];
  this.i3b_1 = '1.3';
}
protoOf(SerializableTreeV13).n2k = function () {
  return this.f3b_1;
};
protoOf(SerializableTreeV13).j39 = function () {
  return this.h3b_1;
};
protoOf(SerializableTreeV13).c37 = function () {
  return this.i3b_1;
};
protoOf(SerializableTreeV13).deserializeComponents = function (coreServices) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.f3b_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.serialization.v13.SerializableTreeV13.deserializeComponents.<anonymous>' call
    deserializeComponentsForEntity(this, element, coreServices.componentDeserializerRegistry.componentDeserializers);
    element.i3a_1 = null;
  }
};
protoOf(SerializableTreeV13).afterDeserialized = function (coreServices) {
  var dataObjectToEntityConverter = new SerializableEntityConverter(coreServices.entityManager, coreServices.productManager);
  this.h3b_1 = dataObjectToEntityConverter.z3a(this.f3b_1);
};
protoOf(SerializableTreeV13).afterRebuildTree = function (root, coreServices) {
  Companion_getInstance_122().w3a(root);
};
protoOf(SerializableTreeV13).removeEntity = function (id) {
  var tmp = this.f3b_1;
  removeAll(tmp, SerializableTreeV13$removeEntity$lambda(id));
};
protoOf(SerializableTreeV13).toString = function () {
  return 'SerializableTreeV13(entities=' + toString_0(this.f3b_1) + ', catalogs=' + toString_0(this.g3b_1) + ')';
};
protoOf(SerializableTreeV13).hashCode = function () {
  var result = hashCode(this.f3b_1);
  result = imul(result, 31) + hashCode(this.g3b_1) | 0;
  return result;
};
protoOf(SerializableTreeV13).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SerializableTreeV13))
    return false;
  var tmp0_other_with_cast = other instanceof SerializableTreeV13 ? other : THROW_CCE();
  if (!equals(this.f3b_1, tmp0_other_with_cast.f3b_1))
    return false;
  if (!equals(this.g3b_1, tmp0_other_with_cast.g3b_1))
    return false;
  return true;
};
function Companion_124() {
  Companion_instance_124 = this;
  this.x2v_1 = new AxisAlignedBox(new Vector(-Infinity, -Infinity, -Infinity), new Vector(Infinity, Infinity, Infinity));
  this.y2v_1 = new AxisAlignedBox(Companion_getInstance_81().ZERO, Companion_getInstance_81().ZERO);
}
protoOf(Companion_124).j3b = function () {
  return this.x2v_1;
};
protoOf(Companion_124).k3b = function () {
  return this.y2v_1;
};
protoOf(Companion_124).z2v = function (vertices) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (vertices.length === 0) {
    throw IllegalArgumentException_init_$Create$('Can not create an axis aligned box from zero vertices');
  }
  var xMin = Infinity;
  var xMax = -Infinity;
  var yMin = Infinity;
  var yMax = -Infinity;
  var zMin = Infinity;
  var zMax = -Infinity;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = vertices.length;
  while (inductionVariable < last) {
    var element = vertices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.shapes.Companion.fromVertices.<anonymous>' call
    if (element.X < xMin)
      xMin = element.X;
    if (element.X > xMax)
      xMax = element.X;
    if (element.Y < yMin)
      yMin = element.Y;
    if (element.Y > yMax)
      yMax = element.Y;
    if (element.Z < zMin)
      zMin = element.Z;
    if (element.Z > zMax)
      zMax = element.Z;
  }
  return new AxisAlignedBox(new Vector(xMin, yMin, zMin), new Vector(xMax, yMax, zMax));
};
protoOf(Companion_124).l3b = function (size, center) {
  return new AxisAlignedBox(size.unaryMinus().__divIntForKotlin(2).plus(center), size.__divIntForKotlin(2).plus(center));
};
protoOf(Companion_124).fromSize$default = function (size, center, $super) {
  center = center === VOID ? Companion_getInstance_81().ZERO : center;
  return $super === VOID ? this.l3b(size, center) : $super.l3b.call(this, size, center);
};
var Companion_instance_124;
function Companion_getInstance_125() {
  if (Companion_instance_124 == null)
    new Companion_124();
  return Companion_instance_124;
}
function get_INFINITE_AABB() {
  return Companion_getInstance_125().x2v_1;
}
function get_EMPTY_AABB() {
  return Companion_getInstance_125().y2v_1;
}
function fromVertices(vertices) {
  return Companion_getInstance_125().z2v(vertices);
}
function fromSize(size, center) {
  return Companion_getInstance_125().l3b(size, center);
}
function fromSize_0(size, center, $super) {
  center = center === VOID ? Companion_getInstance_81().ZERO : center;
  return fromSize(size, center);
}
function AxisAlignedBox(min, max) {
  Companion_getInstance_125();
  this.min = min;
  this.max = max;
}
protoOf(AxisAlignedBox).m3b = function () {
  return this.min;
};
protoOf(AxisAlignedBox).n3b = function () {
  return this.max;
};
protoOf(AxisAlignedBox).o3b = function () {
  return this.max.plus(this.min).times(0.5);
};
protoOf(AxisAlignedBox).t2u = function () {
  return this.size.X;
};
protoOf(AxisAlignedBox).u2u = function () {
  return this.size.Y;
};
protoOf(AxisAlignedBox).v2u = function () {
  return this.size.Z;
};
protoOf(AxisAlignedBox).o = function () {
  return this.max.minus(this.min);
};
protoOf(AxisAlignedBox).containsPoint = function (point) {
  return this.min.X <= point.X && this.min.Y <= point.Y && this.min.Z <= point.Z && this.max.X >= point.X && this.max.Y >= point.Y && this.max.Z >= point.Z;
};
protoOf(AxisAlignedBox).doIntersectWith = function (otherAABB) {
  return this.min.X <= otherAABB.max.X && this.max.X >= otherAABB.min.X && (this.min.Y <= otherAABB.max.Y && this.max.Y >= otherAABB.min.Y) && (this.min.Z <= otherAABB.max.Z && this.max.Z >= otherAABB.min.Z);
};
protoOf(AxisAlignedBox).createCombined = function (otherAABB) {
  if (otherAABB == null)
    return this;
  if (equals(otherAABB, this))
    return this;
  var tmp = Companion_getInstance_125();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [this.min, this.max, otherAABB.min, otherAABB.max];
  return tmp.z2v(tmp$ret$2);
};
protoOf(AxisAlignedBox).tf = function () {
  return this.min;
};
protoOf(AxisAlignedBox).uf = function () {
  return this.max;
};
protoOf(AxisAlignedBox).l2w = function (min, max) {
  return new AxisAlignedBox(min, max);
};
protoOf(AxisAlignedBox).copy = function (min, max, $super) {
  min = min === VOID ? this.min : min;
  max = max === VOID ? this.max : max;
  return this.l2w(min, max);
};
protoOf(AxisAlignedBox).toString = function () {
  return 'AxisAlignedBox(min=' + this.min.toString() + ', max=' + this.max.toString() + ')';
};
protoOf(AxisAlignedBox).hashCode = function () {
  var result = this.min.hashCode();
  result = imul(result, 31) + this.max.hashCode() | 0;
  return result;
};
protoOf(AxisAlignedBox).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AxisAlignedBox))
    return false;
  var tmp0_other_with_cast = other instanceof AxisAlignedBox ? other : THROW_CCE();
  if (!this.min.equals(tmp0_other_with_cast.min))
    return false;
  if (!this.max.equals(tmp0_other_with_cast.max))
    return false;
  return true;
};
function convexPolyhedronPenetration($this, other) {
  var minDistance = {_v: 1.7976931348623157E308};
  var penetrationAxis = {_v: get_zero()};
  var shape1 = new DualDouble(0.0, 0.0);
  var shape2 = new DualDouble(0.0, 0.0);
  var tmp;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var indexedObject = $this.unsignedNormals;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.convexPolyhedronPenetration.<anonymous>' call
      if (convexPolyhedronPenetration$isSeparatingPlane(other, shape2, $this, shape1, minDistance, penetrationAxis, element)) {
        tmp$ret$1 = true;
        break $l$block;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    tmp = true;
  } else {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject_0 = other.unsignedNormals;
      var inductionVariable_0 = 0;
      var last_0 = indexedObject_0.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = indexedObject_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.convexPolyhedronPenetration.<anonymous>' call
        if (convexPolyhedronPenetration$isSeparatingPlane(other, shape2, $this, shape1, minDistance, penetrationAxis, element_0)) {
          tmp$ret$3 = true;
          break $l$block_0;
        }
      }
      tmp$ret$3 = false;
    }
    tmp = tmp$ret$3;
  }
  if (tmp) {
    return null;
  }
  // Inline function 'kotlin.math.abs' call
  var x = minDistance._v;
  if (Math.abs(x) < Companion_instance_15.c1y_1)
    return null;
  var indexedObject_1 = $this.edgeDirections;
  var inductionVariable_1 = 0;
  var last_1 = indexedObject_1.length;
  while (inductionVariable_1 < last_1) {
    var edge1 = indexedObject_1[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    var indexedObject_2 = other.edgeDirections;
    var inductionVariable_2 = 0;
    var last_2 = indexedObject_2.length;
    while (inductionVariable_2 < last_2) {
      var edge2 = indexedObject_2[inductionVariable_2];
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var cross = edge1.cross(edge2);
      if (!almostEquals(cross.size, 0.0) && convexPolyhedronPenetration$isSeparatingPlane(other, shape2, $this, shape1, minDistance, penetrationAxis, cross))
        return null;
    }
  }
  return penetrationAxis._v.normalize().times(minDistance._v);
}
function distance($this, min1, max1, min2, max2) {
  var d1 = max2 - min1;
  var d2 = max1 - min2;
  var tmp;
  // Inline function 'kotlin.math.abs' call
  var tmp_0 = Math.abs(d1);
  // Inline function 'kotlin.math.abs' call
  if (tmp_0 < Math.abs(d2)) {
    tmp = -d1;
  } else {
    tmp = d2;
  }
  return tmp;
}
function overlaps($this, min1, max1, min2, max2) {
  return isBetweenOrdered($this, min2, min1, max1) || isBetweenOrdered($this, min1, min2, max2);
}
function isBetweenOrdered($this, value, lowerBound, upperBound) {
  return lowerBound <= value && value <= upperBound;
}
function raycastEachFaceIndividually($this, ray) {
  var closestHit = null;
  var hitPlaneNormal = Companion_getInstance_81().ZERO;
  var closestDistance = Infinity;
  var inductionVariable = 0;
  var last = $this.faces.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var faceIndex = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = $this.faces[faceIndex].indices;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(this_0.length);
      var inductionVariable_0 = 0;
      var last_0 = this_0.length;
      while (inductionVariable_0 < last_0) {
        var item = this_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.raycastEachFaceIndividually.<anonymous>' call
        var tmp$ret$0 = $this.vertices[item];
        destination.h(tmp$ret$0);
      }
      var faceVertices = copyToArray(destination);
      var facePolygon = Companion_instance_72.createPolygonAndCalculateNormal(faceVertices);
      var tmp1_safe_receiver = facePolygon == null ? null : facePolygon.raycast(ray);
      var hit = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.point;
      if (hit == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var distance = ray.origin.distanceTo(hit);
        if (distance < closestDistance) {
          closestHit = hit;
          hitPlaneNormal = facePolygon.normal;
          closestDistance = distance;
        }
      }
    }
     while (inductionVariable <= last);
  var tmp3_safe_receiver = closestHit;
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.raycastEachFaceIndividually.<anonymous>' call
    tmp = new RaycastResult(tmp3_safe_receiver, hitPlaneNormal);
  }
  return tmp;
}
function Companion_125() {
  Companion_instance_125 = this;
  this.q3b_1 = LoggerState_getInstance().g1v('ConvexPolyhedron');
}
protoOf(Companion_125).scaleVertices = function (vertices, scaleAmount) {
  // Inline function 'com.ikea.core.utils.mapToArray' call
  // Inline function 'kotlin.arrayOfNulls' call
  var size = vertices.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = vertices.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Companion.scaleVertices.<anonymous>' call
      arr[i] = vertices[i].timesElementWise(scaleAmount);
    }
     while (inductionVariable <= last);
  return isArray(arr) ? arr : THROW_CCE();
};
protoOf(Companion_125).scaleNormals = function (normals, scaleAmount) {
  var inverseScale = new Vector(1 / scaleAmount.X, 1 / scaleAmount.Y, 1 / scaleAmount.Y);
  // Inline function 'com.ikea.core.utils.mapToArray' call
  // Inline function 'kotlin.arrayOfNulls' call
  var size = normals.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = normals.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Companion.scaleNormals.<anonymous>' call
      arr[i] = normals[i].timesElementWise(inverseScale).normalize();
    }
     while (inductionVariable <= last);
  return isArray(arr) ? arr : THROW_CCE();
};
var Companion_instance_125;
function Companion_getInstance_126() {
  if (Companion_instance_125 == null)
    new Companion_125();
  return Companion_instance_125;
}
function convexPolyhedronPenetration$isSeparatingPlane($other, shape2, this$0, shape1, minDistance, penetrationAxis, planeNormal) {
  planeNormal.project($other.vertices, shape2);
  planeNormal.project(this$0.vertices, shape1);
  if (!overlaps(this$0, shape1.first, shape1.last, shape2.first, shape2.last)) {
    return true;
  }
  var d = distance(this$0, shape1.first, shape1.last, shape2.first, shape2.last);
  // Inline function 'kotlin.math.abs' call
  var tmp = Math.abs(d);
  // Inline function 'kotlin.math.abs' call
  var x = minDistance._v;
  if (tmp < Math.abs(x)) {
    minDistance._v = d;
    penetrationAxis._v = planeNormal;
  }
  return false;
}
function ConvexPolyhedron$axisAlignedBoundingBox$delegate$lambda(this$0) {
  return function () {
    return Companion_getInstance_125().z2v(this$0.vertices);
  };
}
function ConvexPolyhedron(normals, vertices, faces, edgeDirections) {
  Companion_getInstance_126();
  this.normals = normals;
  this.vertices = vertices;
  this.faces = faces;
  this.edgeDirections = edgeDirections;
  var tmp = this;
  tmp.p3b_1 = lazy(ConvexPolyhedron$axisAlignedBoundingBox$delegate$lambda(this));
}
protoOf(ConvexPolyhedron).r3b = function () {
  return this.normals;
};
protoOf(ConvexPolyhedron).d2i = function () {
  return this.vertices;
};
protoOf(ConvexPolyhedron).s3b = function () {
  return this.faces;
};
protoOf(ConvexPolyhedron).t3b = function () {
  return this.edgeDirections;
};
protoOf(ConvexPolyhedron).u3b = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.p3b_1;
  axisAlignedBoundingBox$factory();
  return this_0.c2();
};
protoOf(ConvexPolyhedron).center = function () {
  var x = 0.0;
  var y = 0.0;
  var z = 0.0;
  var indexedObject = this.vertices;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var v = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    x = x + v.X;
    y = y + v.Y;
    z = z + v.Z;
  }
  return new Vector(x / this.vertices.length, y / this.vertices.length, z / this.vertices.length);
};
protoOf(ConvexPolyhedron).transform = function (transform) {
  return this.rotate(transform.rotation).move(transform.position);
};
protoOf(ConvexPolyhedron).rotate = function (quaternion) {
  if (quaternion.isIdentity)
    return this;
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.normals;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.rotate.<anonymous>' call
      arr[i] = this_0[i].rotate(quaternion);
    }
     while (inductionVariable <= last);
  var tmp0_normals = isArray(arr) ? arr : THROW_CCE();
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_1 = this.vertices;
  // Inline function 'kotlin.arrayOfNulls' call
  var size_0 = this_1.length;
  var arr_0 = fillArrayVal(Array(size_0), null);
  var inductionVariable_0 = 0;
  var last_0 = this_1.length - 1 | 0;
  if (inductionVariable_0 <= last_0)
    do {
      var i_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.rotate.<anonymous>' call
      arr_0[i_0] = this_1[i_0].rotate(quaternion);
    }
     while (inductionVariable_0 <= last_0);
  var tmp1_vertices = isArray(arr_0) ? arr_0 : THROW_CCE();
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_2 = this.edgeDirections;
  // Inline function 'kotlin.arrayOfNulls' call
  var size_1 = this_2.length;
  var arr_1 = fillArrayVal(Array(size_1), null);
  var inductionVariable_1 = 0;
  var last_1 = this_2.length - 1 | 0;
  if (inductionVariable_1 <= last_1)
    do {
      var i_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.rotate.<anonymous>' call
      arr_1[i_1] = this_2[i_1].rotate(quaternion);
    }
     while (inductionVariable_1 <= last_1);
  var tmp2_edgeDirections = isArray(arr_1) ? arr_1 : THROW_CCE();
  var tmp3_faces = this.faces;
  return new ConvexPolyhedron(tmp0_normals, tmp1_vertices, tmp3_faces, tmp2_edgeDirections);
};
protoOf(ConvexPolyhedron).move = function (displacement) {
  if (displacement.equals(Companion_getInstance_81().ZERO))
    return this;
  var tmp0_normals = this.normals;
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.vertices;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.move.<anonymous>' call
      arr[i] = this_0[i].plus(displacement);
    }
     while (inductionVariable <= last);
  var tmp1_vertices = isArray(arr) ? arr : THROW_CCE();
  var tmp2_edgeDirections = this.edgeDirections;
  var tmp3_faces = this.faces;
  return new ConvexPolyhedron(tmp0_normals, tmp1_vertices, tmp3_faces, tmp2_edgeDirections);
};
protoOf(ConvexPolyhedron).scaleUniform = function (scaleAmount) {
  var tmp0_normals = this.normals;
  var tmp1_vertices = Companion_getInstance_126().scaleVertices(this.vertices, times(scaleAmount, Companion_getInstance_81().ONE));
  var tmp2_edgeDirections = this.edgeDirections;
  var tmp3_faces = this.faces;
  return new ConvexPolyhedron(tmp0_normals, tmp1_vertices, tmp3_faces, tmp2_edgeDirections);
};
protoOf(ConvexPolyhedron).scale = function (scaleAmount) {
  var tmp0_normals = Companion_getInstance_126().scaleNormals(this.normals, scaleAmount);
  var tmp1_vertices = Companion_getInstance_126().scaleVertices(this.vertices, scaleAmount);
  var tmp2_edgeDirections = scaleEdgeDirections(this.edgeDirections, scaleAmount);
  var tmp3_faces = this.faces;
  return new ConvexPolyhedron(tmp0_normals, tmp1_vertices, tmp3_faces, tmp2_edgeDirections);
};
protoOf(ConvexPolyhedron).v3b = function () {
  return this.normals;
};
protoOf(ConvexPolyhedron).penetration = function (other) {
  if (!this.hasCoarseCollision(other))
    return null;
  var tmp;
  if (other instanceof ConvexPolyhedron) {
    tmp = convexPolyhedronPenetration(this, other);
  } else {
    var tmp1_safe_receiver = other.penetration(this);
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.penetration.<anonymous>' call
      tmp_0 = tmp1_safe_receiver.unaryMinus();
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(ConvexPolyhedron).penetrationAlongAxis = function (other, axis) {
  var tmp0_safe_receiver = this.penetration(other);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.penetration.<anonymous>' call
    tmp = tmp0_safe_receiver.size > axis.size ? axis : tmp0_safe_receiver;
  }
  return tmp;
};
protoOf(ConvexPolyhedron).hasCoarseCollision = function (otherShape) {
  return this.axisAlignedBoundingBox.doIntersectWith(otherShape.axisAlignedBoundingBox);
};
protoOf(ConvexPolyhedron).hashCode = function () {
  return hashCode(this.vertices);
};
protoOf(ConvexPolyhedron).raycast = function (ray) {
  if (this.faces.length < 4) {
    return raycastEachFaceIndividually(this, ray);
  }
  var nearPlaneNormal = null;
  var near = -Infinity;
  var far = Infinity;
  var inductionVariable = 0;
  var last = this.faces.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var faceIndex = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var pointInPlane = this.vertices[this.faces[faceIndex].indices[1]];
      var planeNormal = this.normals[faceIndex];
      var planeD = -(pointInPlane.X * planeNormal.X + pointInPlane.Y * planeNormal.Y + pointInPlane.Z * planeNormal.Z);
      var vN = planeD + planeNormal.__timesOperatorKotlin(ray.origin);
      var vD = planeNormal.__timesOperatorKotlin(ray.direction);
      if (almostEquals(vD, 0.0)) {
        if (vN > 0.0) {
          return null;
        }
      } else {
        var distanceToPlane = -vN / vD;
        if (vD < 0.0) {
          if (distanceToPlane > near) {
            near = distanceToPlane;
            nearPlaneNormal = planeNormal;
          }
        } else {
          if (distanceToPlane < far) {
            far = distanceToPlane;
          }
        }
        if (near > far)
          return null;
      }
    }
     while (inductionVariable <= last);
  if (near < 0 || nearPlaneNormal == null)
    return null;
  return new RaycastResult(ray.direction.times(near).plus(ray.origin), nearPlaneNormal);
};
protoOf(ConvexPolyhedron).equals = function (other) {
  var tmp;
  if (other instanceof ConvexPolyhedron) {
    var tmp_0;
    if (other.vertices.length === this.vertices.length) {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var this_0 = zip(other.vertices, this.vertices);
        var tmp_1;
        if (isInterface(this_0, Collection)) {
          tmp_1 = this_0.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var tmp0_iterator = this_0.k();
        while (tmp0_iterator.m()) {
          var element = tmp0_iterator.n();
          // Inline function 'com.ikea.core.shapes.ConvexPolyhedron.equals.<anonymous>' call
          if (!element.rf_1.equals(element.sf_1)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      tmp_0 = tmp$ret$0;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
function scaleEdgeDirections(edgeDirections, scaleAmount) {
  var inverseScale = new Vector(1 / scaleAmount.X, 1 / scaleAmount.Y, 1 / scaleAmount.Y);
  // Inline function 'com.ikea.core.utils.mapToArray' call
  // Inline function 'kotlin.arrayOfNulls' call
  var size = edgeDirections.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = edgeDirections.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.scaleEdgeDirections.<anonymous>' call
      arr[i] = edgeDirections[i].timesElementWise(inverseScale).normalize();
    }
     while (inductionVariable <= last);
  return isArray(arr) ? arr : THROW_CCE();
}
function axisAlignedBoundingBox$factory() {
  return getPropertyCallableRef('axisAlignedBoundingBox', 1, KProperty1, function (receiver) {
    return receiver.axisAlignedBoundingBox;
  }, null);
}
function calcNormals($this) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new Vector(1.0, 0.0, 0.0), new Vector(-1.0, 0.0, 0.0), new Vector(0.0, 1.0, 0.0), new Vector(0.0, -1.0, 0.0), new Vector(0.0, 0.0, 1.0), new Vector(0.0, 0.0, -1.0)];
}
function calcVertices($this, size) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new Vector(size.width / 2, size.height / 2, size.depth / 2), new Vector(size.width / 2, size.height / 2, -size.depth / 2), new Vector(size.width / 2, -size.height / 2, size.depth / 2), new Vector(size.width / 2, -size.height / 2, -size.depth / 2), new Vector(-size.width / 2, size.height / 2, size.depth / 2), new Vector(-size.width / 2, size.height / 2, -size.depth / 2), new Vector(-size.width / 2, -size.height / 2, size.depth / 2), new Vector(-size.width / 2, -size.height / 2, -size.depth / 2)];
}
function calcVertices_0($this, size, center) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new Vector(size.width / 2 + center.X, size.height / 2 + center.Y, size.depth / 2 + center.Z), new Vector(size.width / 2 + center.X, size.height / 2 + center.Y, -size.depth / 2 + center.Z), new Vector(size.width / 2 + center.X, -size.height / 2 + center.Y, size.depth / 2 + center.Z), new Vector(size.width / 2 + center.X, -size.height / 2 + center.Y, -size.depth / 2 + center.Z), new Vector(-size.width / 2 + center.X, size.height / 2 + center.Y, size.depth / 2 + center.Z), new Vector(-size.width / 2 + center.X, size.height / 2 + center.Y, -size.depth / 2 + center.Z), new Vector(-size.width / 2 + center.X, -size.height / 2 + center.Y, size.depth / 2 + center.Z), new Vector(-size.width / 2 + center.X, -size.height / 2 + center.Y, -size.depth / 2 + center.Z)];
}
function Cuboid_init_$Init$(size, $this) {
  Cuboid.call($this, calcVertices(Companion_getInstance_127(), size));
  return $this;
}
function fromSize_1(size) {
  return Cuboid_init_$Init$(size, objectCreate(protoOf(Cuboid)));
}
function Cuboid_init_$Init$_0(size, center, $this) {
  Cuboid.call($this, calcVertices_0(Companion_getInstance_127(), size, center));
  return $this;
}
function fromSizeAndCenter(size, center) {
  return Cuboid_init_$Init$_0(size, center, objectCreate(protoOf(Cuboid)));
}
function Companion_126() {
  Companion_instance_126 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [0, 2, 3, 1];
  tmp.d1x_1 = new Face(tmp$ret$2);
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [5, 7, 6, 4];
  tmp_0.e1x_1 = new Face(tmp$ret$5);
  var tmp_1 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [1, 5, 4, 0];
  tmp_1.f1x_1 = new Face(tmp$ret$8);
  var tmp_2 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [3, 2, 6, 7];
  tmp_2.g1x_1 = new Face(tmp$ret$11);
  var tmp_3 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$14 = [4, 6, 2, 0];
  tmp_3.h1x_1 = new Face(tmp$ret$14);
  var tmp_4 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$17 = [1, 3, 7, 5];
  tmp_4.i1x_1 = new Face(tmp$ret$17);
  var tmp_5 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_5.j1x_1 = [new Vector(1.0), new Vector(VOID, 1.0), new Vector(VOID, VOID, 1.0)];
  var tmp_6 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_6.k1x_1 = [this.d1x_1, this.e1x_1, this.f1x_1, this.g1x_1, this.h1x_1, this.i1x_1];
  this.ZERO = fromSize_1(new Vector(0.0, 0.0, 0.0));
}
protoOf(Companion_126).fromNonCuboidVertices = function (vertices) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (vertices.length === 0) {
    throw IllegalArgumentException_init_$Create$('Can not create an axis aligned box from zero vertices');
  }
  return this.fromAABB(Companion_getInstance_125().z2v(vertices));
};
protoOf(Companion_126).fromAABB = function (aabb) {
  return fromSizeAndCenter(aabb.size, aabb.center);
};
protoOf(Companion_126).p2y = function () {
  return this.ZERO;
};
var Companion_instance_126;
function Companion_getInstance_127() {
  if (Companion_instance_126 == null)
    new Companion_126();
  return Companion_instance_126;
}
function Cuboid$size$delegate$lambda($vertices) {
  return function () {
    // Inline function 'kotlin.math.abs' call
    var x = $vertices[0].X - $vertices[4].X;
    var tmp = Math.abs(x);
    // Inline function 'kotlin.math.abs' call
    var x_0 = $vertices[0].Y - $vertices[2].Y;
    var tmp_0 = Math.abs(x_0);
    // Inline function 'kotlin.math.abs' call
    var x_1 = $vertices[0].Z - $vertices[1].Z;
    var tmp$ret$2 = Math.abs(x_1);
    return new Vector(tmp, tmp_0, tmp$ret$2);
  };
}
function Cuboid(vertices) {
  Companion_getInstance_127();
  var tmp0_edgeDirections = Companion_getInstance_127().j1x_1;
  var tmp1_normals = calcNormals(Companion_getInstance_127());
  var tmp2_faces = Companion_getInstance_127().k1x_1;
  ConvexPolyhedron.call(this, tmp1_normals, vertices, tmp2_faces, tmp0_edgeDirections);
  var tmp = this;
  tmp.x3b_1 = lazy(Cuboid$size$delegate$lambda(vertices));
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.y3b_1 = [this.normals[0], this.normals[2], this.normals[4]];
}
protoOf(Cuboid).o = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.x3b_1;
  size$factory();
  return this_0.c2();
};
protoOf(Cuboid).applyMargin = function (margin) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var newVertices = [new Vector(this.vertices[0].X + margin.right, this.vertices[0].Y + margin.top, this.vertices[0].Z + margin.front), new Vector(this.vertices[1].X + margin.right, this.vertices[1].Y + margin.top, this.vertices[1].Z - margin.back), new Vector(this.vertices[2].X + margin.right, this.vertices[2].Y - margin.bottom, this.vertices[2].Z + margin.front), new Vector(this.vertices[3].X + margin.right, this.vertices[3].Y - margin.bottom, this.vertices[3].Z - margin.back), new Vector(this.vertices[4].X - margin.left, this.vertices[4].Y + margin.top, this.vertices[4].Z + margin.front), new Vector(this.vertices[5].X - margin.left, this.vertices[5].Y + margin.top, this.vertices[5].Z - margin.back), new Vector(this.vertices[6].X - margin.left, this.vertices[6].Y - margin.bottom, this.vertices[6].Z + margin.front), new Vector(this.vertices[7].X - margin.left, this.vertices[7].Y - margin.bottom, this.vertices[7].Z - margin.back)];
  return new Cuboid(newVertices);
};
protoOf(Cuboid).move = function (displacement) {
  if (displacement.equals(Companion_getInstance_81().ZERO))
    return this;
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.vertices;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Cuboid.move.<anonymous>' call
      arr[i] = this_0[i].plus(displacement);
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return new Cuboid(tmp$ret$2);
};
protoOf(Cuboid).scale = function (scaleAmount) {
  return new Cuboid(Companion_getInstance_126().scaleVertices(this.vertices, scaleAmount));
};
protoOf(Cuboid).scaleUniform = function (scaleAmount) {
  return new Cuboid(Companion_getInstance_126().scaleVertices(this.vertices, Companion_getInstance_81().ONE.times(scaleAmount)));
};
protoOf(Cuboid).v3b = function () {
  return this.y3b_1;
};
function size$factory() {
  return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
    return receiver.size;
  }, null);
}
function calculatePositions($this, radius, height, segments, center) {
  if (segments < 5)
    throw IllegalArgumentException_init_$Create$('A cylinder is considered to have segments >= 5');
  var vertexAngleStep = 2 * 3.141592653589793 / segments;
  var topOrBottom = {_v: 1.0};
  var tmp = 0;
  var tmp_0 = imul(segments, 2);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = fillArrayVal(Array(tmp_0), null);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    var theta = tmp_2 * vertexAngleStep;
    // Inline function 'kotlin.math.cos' call
    var x = radius * Math.cos(theta);
    // Inline function 'kotlin.math.sin' call
    var z = radius * Math.sin(theta);
    if (tmp_2 >= segments) {
      topOrBottom._v = -1.0;
    }
    tmp_1[tmp_2] = new Vector(x / 2.0 + center.X, topOrBottom._v * height / 2.0 + center.Y, z / 2.0 + center.Z);
    tmp = tmp + 1 | 0;
  }
  var vertices = tmp_1;
  return vertices;
}
function calculateFaceNormals($this, positions) {
  var halfSize = positions.length / 2 | 0;
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList_init_$Create$_0(halfSize);
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < halfSize)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.MutableList.<anonymous>' call
      // Inline function 'com.ikea.core.shapes.Companion.calculateFaceNormals.<anonymous>' call
      var vertexInTopFace = positions[index];
      var nextVertex = positions[index + 1 | 0];
      var v1 = nextVertex.minus(vertexInTopFace);
      var v2 = Companion_getInstance_81().DOWN;
      var tmp$ret$0 = v1.cross(v2).normalize();
      list.h(tmp$ret$0);
    }
     while (inductionVariable < halfSize);
  var faceNormals = list;
  faceNormals.h(Companion_getInstance_81().UP);
  faceNormals.h(Companion_getInstance_81().DOWN);
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(faceNormals);
}
function calculateFaces($this, positions) {
  var halfSize = positions.length / 2 | 0;
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList_init_$Create$_0(halfSize);
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < halfSize)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.MutableList.<anonymous>' call
      // Inline function 'com.ikea.core.shapes.Companion.calculateFaces.<anonymous>' call
      var indexPlusOne = (index + 1 | 0) % halfSize | 0;
      var p1 = index;
      var p2 = indexPlusOne;
      var p3 = halfSize + indexPlusOne | 0;
      var p4 = halfSize + index | 0;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [p1, p2, p3, p4];
      var tmp$ret$3 = new Face(tmp$ret$2);
      list.h(tmp$ret$3);
    }
     while (inductionVariable < halfSize);
  var faces = list;
  var tmp = 0;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_0 = fillArrayVal(Array(halfSize), null);
  while (tmp < halfSize) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = (halfSize - 1 | 0) - tmp_1 | 0;
    tmp = tmp + 1 | 0;
  }
  var topFace = new Face(tmp_0);
  var tmp_2 = 0;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_3 = fillArrayVal(Array(halfSize), null);
  while (tmp_2 < halfSize) {
    var tmp_4 = tmp_2;
    tmp_3[tmp_4] = halfSize + tmp_4 | 0;
    tmp_2 = tmp_2 + 1 | 0;
  }
  var bottomFace = new Face(tmp_3);
  faces.h(topFace);
  faces.h(bottomFace);
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(faces);
}
function calculateEdges($this, positions) {
  var halfSize = positions.length / 2 | 0;
  var numberOfEdges = (halfSize % 2 | 0) === 0 ? halfSize / 2 | 0 : halfSize;
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList_init_$Create$_0(numberOfEdges);
  // Inline function 'kotlin.repeat' call
  // Inline function 'kotlin.contracts.contract' call
  var inductionVariable = 0;
  if (inductionVariable < numberOfEdges)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.MutableList.<anonymous>' call
      // Inline function 'com.ikea.core.shapes.Companion.calculateEdges.<anonymous>' call
      var tmp$ret$0 = positions[(index + 1 | 0) % halfSize | 0].minus(positions[index]).normalize();
      list.h(tmp$ret$0);
    }
     while (inductionVariable < numberOfEdges);
  var edges = list;
  edges.h(Companion_getInstance_81().UP);
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(edges);
}
function Cylinder_init_$Init$(radius, height, segments, center, $this) {
  segments = segments === VOID ? 8 : segments;
  center = center === VOID ? Companion_getInstance_81().ZERO : center;
  Cylinder.call($this, calculatePositions(Companion_instance_127, radius, height, segments, center));
  return $this;
}
function fromParameters(radius, height, segments, center) {
  return Cylinder_init_$Init$(radius, height, segments, center, objectCreate(protoOf(Cylinder)));
}
function Companion_127() {
}
var Companion_instance_127;
function Companion_getInstance_128() {
  return Companion_instance_127;
}
function Cylinder(vertices) {
  var tmp0_edgeDirections = calculateEdges(Companion_instance_127, vertices);
  var tmp1_normals = calculateFaceNormals(Companion_instance_127, vertices);
  var tmp2_faces = calculateFaces(Companion_instance_127, vertices);
  ConvexPolyhedron.call(this, tmp1_normals, vertices, tmp2_faces, tmp0_edgeDirections);
}
protoOf(Cylinder).move = function (displacement) {
  if (displacement.equals(Companion_getInstance_81().ZERO))
    return this;
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.vertices;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Cylinder.move.<anonymous>' call
      arr[i] = this_0[i].plus(displacement);
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return new Cylinder(tmp$ret$2);
};
protoOf(Cylinder).scale = function (scaleAmount) {
  return new Cylinder(Companion_getInstance_126().scaleVertices(this.vertices, scaleAmount));
};
protoOf(Cylinder).scaleUniform = function (scaleAmount) {
  return new Cylinder(Companion_getInstance_126().scaleVertices(this.vertices, Companion_getInstance_81().ONE.times(scaleAmount)));
};
function Face(indices) {
  this.indices = indices;
}
protoOf(Face).z3b = function () {
  return this.indices;
};
protoOf(Face).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  return contentEquals(this.indices, (other instanceof Face ? other : THROW_CCE()).indices);
};
protoOf(Face).hashCode = function () {
  return contentHashCode(this.indices);
};
protoOf(Face).tf = function () {
  return this.indices;
};
protoOf(Face).a3c = function (indices) {
  return new Face(indices);
};
protoOf(Face).copy = function (indices, $super) {
  indices = indices === VOID ? this.indices : indices;
  return this.a3c(indices);
};
protoOf(Face).toString = function () {
  return 'Face(indices=' + toString_0(this.indices) + ')';
};
function Polyhedron() {
}
function calcAxisAlignedBoundingBox($this) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.polyhedra;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.shapes.PolyhedronGroup.calcAxisAlignedBoundingBox.<anonymous>' call
    var tmp$ret$0 = item.axisAlignedBoundingBox;
    destination.h(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.shapes.PolyhedronGroup.calcAxisAlignedBoundingBox.<anonymous>' call
    var list = listOf_0([element.min, element.max]);
    addAll(destination_0, list);
  }
  var axisAlignedVertices = copyToArray(destination_0);
  return Companion_getInstance_125().z2v(axisAlignedVertices);
}
function penetration$check(maxSize, max, v) {
  if (v == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var itSize = v.size;
    if (itSize > maxSize._v) {
      max._v = v;
      maxSize._v = itSize;
    }
  }
}
function PolyhedronGroup$axisAlignedBoundingBox$delegate$lambda(this$0) {
  return function () {
    return calcAxisAlignedBoundingBox(this$0);
  };
}
function PolyhedronGroup(polyhedra) {
  this.polyhedra = polyhedra;
  var tmp = this;
  tmp.b3c_1 = lazy(PolyhedronGroup$axisAlignedBoundingBox$delegate$lambda(this));
}
protoOf(PolyhedronGroup).c3c = function () {
  return this.polyhedra;
};
protoOf(PolyhedronGroup).u3b = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.b3c_1;
  axisAlignedBoundingBox$factory_0();
  return this_0.c2();
};
protoOf(PolyhedronGroup).rotate = function (quaternion) {
  if (quaternion.isIdentity)
    return this;
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.polyhedra;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.rotate.<anonymous>' call
      arr[i] = this_0[i].rotate(quaternion);
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return new PolyhedronGroup(tmp$ret$2);
};
protoOf(PolyhedronGroup).move = function (displacement) {
  if (displacement.equals(Companion_getInstance_81().ZERO))
    return this;
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.polyhedra;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.move.<anonymous>' call
      arr[i] = this_0[i].move(displacement);
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return new PolyhedronGroup(tmp$ret$2);
};
protoOf(PolyhedronGroup).scaleUniform = function (scaleAmount) {
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.polyhedra;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.scaleUniform.<anonymous>' call
      arr[i] = this_0[i].scaleUniform(scaleAmount);
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return new PolyhedronGroup(tmp$ret$2);
};
protoOf(PolyhedronGroup).scale = function (scaleAmount) {
  // Inline function 'com.ikea.core.utils.mapToArray' call
  var this_0 = this.polyhedra;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this_0.length;
  var arr = fillArrayVal(Array(size), null);
  var inductionVariable = 0;
  var last = this_0.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.scale.<anonymous>' call
      arr[i] = this_0[i].scale(scaleAmount);
    }
     while (inductionVariable <= last);
  var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
  return new PolyhedronGroup(tmp$ret$2);
};
protoOf(PolyhedronGroup).penetration = function (other) {
  if (!this.hasCoarseCollision(other))
    return null;
  var max = {_v: null};
  var maxSize = {_v: -1.0};
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.polyhedra;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>' call
    if (other instanceof PolyhedronGroup) {
      var tmp1_safe_receiver = other.penetration(element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        penetration$check(maxSize, max, tmp1_safe_receiver.unaryMinus());
      }
    } else {
      penetration$check(maxSize, max, element.penetration(other));
    }
  }
  return max._v;
};
protoOf(PolyhedronGroup).penetrationAlongAxis = function (other, axis) {
  if (!this.hasCoarseCollision(other))
    return null;
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxByOrNull' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.polyhedra;
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>' call
      var tmp;
      if (other instanceof PolyhedronGroup) {
        var tmp1_safe_receiver = other.penetrationAlongAxis(element, axis.unaryMinus());
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>.<anonymous>' call
          tmp_0 = tmp1_safe_receiver.unaryMinus();
        }
        tmp = tmp_0;
      } else {
        tmp = element.penetrationAlongAxis(other, axis);
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    var iterator = destination.k();
    if (!iterator.m()) {
      tmp$ret$6 = null;
      break $l$block_0;
    }
    var maxElem = iterator.n();
    if (!iterator.m()) {
      tmp$ret$6 = maxElem;
      break $l$block_0;
    }
    // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>' call
    var maxValue = maxElem.size;
    do {
      var e = iterator.n();
      // Inline function 'com.ikea.core.shapes.PolyhedronGroup.penetration.<anonymous>' call
      var v = e.size;
      if (compareTo(maxValue, v) < 0) {
        maxElem = e;
        maxValue = v;
      }
    }
     while (iterator.m());
    tmp$ret$6 = maxElem;
  }
  return tmp$ret$6;
};
protoOf(PolyhedronGroup).hasCoarseCollision = function (otherShape) {
  return this.axisAlignedBoundingBox.doIntersectWith(otherShape.axisAlignedBoundingBox);
};
protoOf(PolyhedronGroup).raycast = function (ray) {
  var closestDistance = Infinity;
  var closestHit = null;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = this.polyhedra;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.shapes.PolyhedronGroup.raycast.<anonymous>' call
    var tmp0_safe_receiver = isInterface(element, Raycastable) ? element : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.raycast(ray);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var hitDistance = ray.origin.distanceTo(tmp0_safe_receiver_0.point);
        if (hitDistance < closestDistance) {
          closestHit = tmp0_safe_receiver_0;
          closestDistance = hitDistance;
        }
      }
    }
  }
  return closestHit;
};
function merge(_this__u8e3s4) {
  return new PolyhedronGroup(_this__u8e3s4);
}
function axisAlignedBoundingBox$factory_0() {
  return getPropertyCallableRef('axisAlignedBoundingBox', 1, KProperty1, function (receiver) {
    return receiver.axisAlignedBoundingBox;
  }, null);
}
function isConcaveVertex($this, p1, p2, p3, normal) {
  var vertexNormal = $this.d3c(p1, p2, p3);
  return vertexNormal.dot(normal) < 0;
}
function isConvexVertex($this, p1, p2, p3, normal) {
  var vertexNormal = $this.d3c(p1, p2, p3);
  return vertexNormal.dot(normal) > 0;
}
function isPlanarPointContainedInTriangle($this, p1, p2, p3, testPoint) {
  var f1 = p1.minus(testPoint);
  var f2 = p2.minus(testPoint);
  var f3 = p3.minus(testPoint);
  var va = p1.minus(p2).cross(p1.minus(p3));
  var va1 = f2.cross(f3);
  var va2 = f3.cross(f1);
  var va3 = f1.cross(f2);
  var triangleArea = va.size;
  var tmp = va1.size / triangleArea;
  // Inline function 'kotlin.math.sign' call
  var this_0 = va.dot(va1);
  var uvFactor1 = tmp * sign(this_0);
  var tmp_0 = va2.size / triangleArea;
  // Inline function 'kotlin.math.sign' call
  var this_1 = va.dot(va2);
  var uvFactor2 = tmp_0 * sign(this_1);
  var tmp_1 = va3.size / triangleArea;
  // Inline function 'kotlin.math.sign' call
  var this_2 = va.dot(va3);
  var uvFactor3 = tmp_1 * sign(this_2);
  var uv1 = new Vector(0.0, 0.0);
  var uv2 = new Vector(1.0, 0.0);
  var uv3 = new Vector(0.0, 1.0);
  var pointCoordinate = uv1.times(uvFactor1).plus(uv2.times(uvFactor2)).plus(uv3.times(uvFactor3));
  return pointCoordinate.X >= 0.0 && pointCoordinate.X <= 1.0 && pointCoordinate.Y >= 0.0 && pointCoordinate.Y <= 1.0 && pointCoordinate.X + pointCoordinate.Y <= 1.0;
}
function getVerticesFromSinglePolyhedron($this, polyhedron) {
  var tmp;
  if (polyhedron instanceof ConvexPolyhedron) {
    tmp = new Pair(polyhedron.vertices, polyhedron.faces);
  } else {
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp = new Pair(tmp_0, tmp$ret$1);
  }
  return tmp;
}
function earClipTriangulation$isNotCornerAndNotInsideTriangle(p1, p2, p3, testPoint) {
  if (!(testPoint === p1) && !(testPoint === p2) && !(testPoint === p3)) {
    return isPlanarPointContainedInTriangle(Companion_getInstance_129(), p1, p2, p3, testPoint);
  }
  return false;
}
function earClipTriangulation$findValidEar(remainingVertices, shapeNormal) {
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var tmp0_iterator = remainingVertices.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.shapes.Companion.earClipTriangulation.findValidEar.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var currentVertexIndex = checkIndexOverflow(tmp1);
    var previousVertexIndex = Companion_getInstance_129().circularIndex(currentVertexIndex - 1 | 0, remainingVertices.o());
    var nextVertexIndex = Companion_getInstance_129().circularIndex(currentVertexIndex + 1 | 0, remainingVertices.o());
    var previousVertex = remainingVertices.q(previousVertexIndex);
    var nextVertex = remainingVertices.q(nextVertexIndex);
    var tmp;
    if (isConvexVertex(Companion_getInstance_129(), previousVertex, item, nextVertex, shapeNormal)) {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp_0;
        if (isInterface(remainingVertices, Collection)) {
          tmp_0 = remainingVertices.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var tmp0_iterator_0 = remainingVertices.k();
        while (tmp0_iterator_0.m()) {
          var element = tmp0_iterator_0.n();
          // Inline function 'com.ikea.core.shapes.Companion.earClipTriangulation.findValidEar.<anonymous>.<anonymous>' call
          if (earClipTriangulation$isNotCornerAndNotInsideTriangle(previousVertex, item, nextVertex, element)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = [previousVertex, item, nextVertex];
      return new Pair(currentVertexIndex, tmp$ret$4);
    }
  }
  return null;
}
function PolyhedronUtils$Companion$singleSidedPolyhedronFromPolygon$lambda() {
  return 'Unsupported amount of vertices supplied to generateSurfaceCollider, will return empty Collider';
}
function PolyhedronUtils$Companion$polyhedronFromConvexPolygon$lambda() {
  return 'Less than three vertices supplied to generateSurfaceCollider, will return empty Collider';
}
function PolyhedronUtils$Companion$polyhedronFromConvexPolygon$lambda_0() {
  return 'Invalid amount of edge vertices, will return empty collider';
}
function PolyhedronUtils$Companion$polyhedronFromConvexPolygon$lambda_1() {
  return 'Invalid vertex, will return empty collider';
}
function PolyhedronUtils$Companion$pointInPolygon$lambda(projectionLambda) {
  return projectionLambda.yz();
}
function PolyhedronUtils$Companion$pointInPolygon$lambda_0(projectionLambda) {
  return projectionLambda.xz();
}
function PolyhedronUtils$Companion$pointInPolygon$lambda_1(projectionLambda) {
  return projectionLambda.xy();
}
function PolyhedronUtils$Companion$flatPolyhedronFromConvexPolygon$lambda() {
  return 'Unsupported amount of vertices supplied to generateSurfaceCollider, will return empty Collider';
}
function PolyhedronUtils$Companion$transformAndExtractVerticesFromPolyhedron$lambda($poly) {
  return function () {
    return 'Shape not supported by getLocalOutsideMeasurementForEntities! ' + toString_0($poly);
  };
}
function Companion_128() {
  Companion_instance_128 = this;
  this.l1x_1 = LoggerState_getInstance().g1v('PolyhedronUtils');
}
protoOf(Companion_128).e3c = function (vertices) {
  var tmp;
  if (this.g3c(vertices)) {
    tmp = this.flatPolyhedronFromConvexPolygon(vertices);
  } else {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.f3c(vertices);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Companion.createFromPolygon.<anonymous>' call
      var tmp$ret$0 = Companion_getInstance_129().flatPolyhedronFromConvexPolygon(item);
      destination.h(tmp$ret$0);
    }
    var all = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(all);
    tmp = new PolyhedronGroup(tmp$ret$3);
  }
  return tmp;
};
protoOf(Companion_128).h3c = function (size, margin, padding, compartment) {
  var outerWidth = size.b2y_1 - margin.left - margin.right;
  var outerDepth = size.d2y_1 - margin.front - margin.back;
  var innerHeight = size.c2y_1 - (margin.top + margin.bottom + padding.top + padding.bottom);
  var innerWidth = size.b2y_1 - (margin.left + margin.right + padding.left + padding.right);
  var innerDepth = size.d2y_1 - (margin.front + margin.back + padding.front + padding.back);
  var innerDx = (margin.left - margin.right + padding.left - padding.right) / 2;
  var innerDy = (-margin.top + margin.bottom - padding.top + padding.bottom) / 2;
  var innerDz = -(margin.front - margin.back + padding.front - padding.back) / 2;
  var outerDz = -(margin.front - margin.back) / 2;
  var outerDx = (margin.left - margin.right) / 2;
  var topY = size.c2y_1 / 2.0 - margin.top - padding.top / 2.0;
  var bottomY = -size.c2y_1 / 2.0 + margin.bottom + padding.bottom / 2.0;
  var leftX = -size.b2y_1 / 2.0 + margin.left + padding.left / 2.0;
  var rightX = size.b2y_1 / 2.0 - margin.right - padding.right / 2.0;
  var frontZ = size.d2y_1 / 2.0 - margin.front - padding.front / 2.0;
  var backZ = -size.d2y_1 / 2.0 + margin.back + padding.back / 2.0;
  var compartmentWidth = !(compartment == null) && compartment.b2y_1 > 0.0 ? compartment.b2y_1 : innerWidth;
  var compartmentHeight = !(compartment == null) && compartment.c2y_1 > 0.0 ? compartment.c2y_1 : innerHeight;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.collections.mutableListOf' call
  var this_0 = ArrayList_init_$Create$();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.shapes.Companion.createFramePolyhedrons.<anonymous>' call
  if (padding.top > 0) {
    this_0.h(fromSizeAndCenter(new Vector(outerWidth, padding.top, outerDepth), new Vector(outerDx, topY, outerDz)));
  }
  if (padding.bottom > 0) {
    this_0.h(fromSizeAndCenter(new Vector(outerWidth, padding.bottom, outerDepth), new Vector(outerDx, bottomY, outerDz)));
  }
  if (padding.left > 0) {
    this_0.h(fromSizeAndCenter(new Vector(padding.left, innerHeight, outerDepth), new Vector(leftX, innerDy, outerDz)));
  }
  if (padding.right > 0) {
    this_0.h(fromSizeAndCenter(new Vector(padding.right, innerHeight, outerDepth), new Vector(rightX, innerDy, outerDz)));
  }
  if (padding.front > 0) {
    this_0.h(fromSizeAndCenter(new Vector(innerWidth, innerHeight, padding.front), new Vector(innerDx, innerDy, frontZ)));
  }
  if (padding.back > 0) {
    this_0.h(fromSizeAndCenter(new Vector(innerWidth, innerHeight, padding.back), new Vector(innerDx, innerDy, backZ)));
  }
  var outerCuboids = copyToArray(this_0);
  var horizontalCompartmentCount = numberToInt(innerWidth / compartmentWidth);
  var verticalComparmentCount = numberToInt(innerHeight / compartmentHeight);
  var horizontalGap = (innerWidth - compartmentWidth * horizontalCompartmentCount) / (horizontalCompartmentCount - 1 | 0);
  var verticalGap = (innerHeight - compartmentHeight * verticalComparmentCount) / (verticalComparmentCount - 1 | 0);
  var tmp;
  if (compartment == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.shapes.Companion.createFramePolyhedrons.<anonymous>' call
    // Inline function 'kotlin.collections.mutableListOf' call
    var dividerCuboids = ArrayList_init_$Create$();
    var dividerDx = compartmentWidth + horizontalGap;
    var dividerDy = compartmentHeight + verticalGap;
    var currentDividerX = innerDx - innerWidth / 2 + compartmentWidth + horizontalGap / 2;
    var currentDividerY = innerDy - innerHeight / 2 + compartmentHeight + verticalGap / 2;
    if (horizontalCompartmentCount > 1) {
      var inductionVariable = 0;
      var last = horizontalCompartmentCount - 1 | 0;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          dividerCuboids.h(fromSizeAndCenter(new Vector(horizontalGap, innerHeight, innerDepth), new Vector(currentDividerX, innerDy, innerDz)));
          currentDividerX = currentDividerX + dividerDx;
        }
         while (inductionVariable < last);
    }
    if (verticalComparmentCount > 1) {
      currentDividerX = innerDx - innerWidth / 2 + compartmentWidth / 2;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < horizontalCompartmentCount)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var inductionVariable_1 = 0;
          var last_0 = verticalComparmentCount - 1 | 0;
          if (inductionVariable_1 < last_0)
            do {
              var j = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              dividerCuboids.h(fromSizeAndCenter(new Vector(compartmentWidth, verticalGap, innerDepth), new Vector(currentDividerX, currentDividerY, innerDz)));
              currentDividerY = currentDividerY + dividerDy;
            }
             while (inductionVariable_1 < last_0);
          currentDividerX = currentDividerX + dividerDx;
          currentDividerY = innerDy - innerHeight / 2 + compartmentHeight + verticalGap / 2;
        }
         while (inductionVariable_0 < horizontalCompartmentCount);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = plus_2(dividerCuboids, outerCuboids);
    tmp = copyToArray(this_1);
  }
  var tmp1_elvis_lhs = tmp;
  var cuboids = tmp1_elvis_lhs == null ? outerCuboids : tmp1_elvis_lhs;
  return cuboids;
};
protoOf(Companion_128).createFramePolyhedrons$default = function (size, margin, padding, compartment, $super) {
  compartment = compartment === VOID ? null : compartment;
  return $super === VOID ? this.h3c(size, margin, padding, compartment) : $super.h3c.call(this, size, margin, padding, compartment);
};
protoOf(Companion_128).i3c = function (vertices) {
  if (vertices.length < 3) {
    this.l1x_1.warn(PolyhedronUtils$Companion$singleSidedPolyhedronFromPolygon$lambda);
    return Companion_getInstance_127().ZERO;
  }
  var normal = this.a2i(vertices);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = toList(get_indices(vertices));
  var tmp$ret$0 = copyToArray(this_0);
  var face = new Face(tmp$ret$0);
  // Inline function 'kotlin.collections.mutableListOf' call
  var edgeDirections = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = get_lastIndex(vertices);
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      edgeDirections.h(vertices[this.circularIndex(i, vertices.length)].minus(vertices[this.circularIndex(i + 1 | 0, vertices.length)]).normalize());
    }
     while (!(i === last));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [normal];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [face];
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$8 = copyToArray(edgeDirections);
  return new ConvexPolyhedron(tmp, vertices, tmp_0, tmp$ret$8);
};
protoOf(Companion_128).circularIndex = function (index, length) {
  var tmp;
  if (index >= length) {
    tmp = index % length | 0;
  } else if (index < 0) {
    tmp = (index % length | 0) + length | 0;
  } else {
    tmp = index;
  }
  return tmp;
};
protoOf(Companion_128).j3c = function (points, thickness) {
  var tmp;
  if (this.g3c(points)) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [this.k3c(points, thickness)];
  } else {
    var triangles = this.f3c(points);
    // Inline function 'kotlin.collections.mutableListOf' call
    var polyhedrons = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = triangles.length;
    while (inductionVariable < last) {
      var element = triangles[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Companion.polyhedronFromPolygon.<anonymous>' call
      polyhedrons.h(Companion_getInstance_129().k3c(element, thickness));
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp = copyToArray(polyhedrons);
  }
  return tmp;
};
protoOf(Companion_128).k3c = function (points, thickness) {
  if (points.length < 3) {
    this.l1x_1.warn(PolyhedronUtils$Companion$polyhedronFromConvexPolygon$lambda);
    return Companion_getInstance_127().ZERO;
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var faceIndices = ArrayList_init_$Create$();
  // Inline function 'kotlin.arrayOfNulls' call
  // Inline function 'kotlin.collections.count' call
  var tmp$ret$1 = points.length;
  var size = imul(tmp$ret$1, 2);
  var vertices = fillArrayVal(Array(size), null);
  var negativeFaceNormal = this.d3c(points[0], points[1], points[2]).unaryMinus();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = toList(get_indices(points));
  var frontFaceIndices = copyToArray(this_0);
  faceIndices.h(frontFaceIndices);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.count' call
  var tmp = points.length;
  // Inline function 'kotlin.collections.count' call
  var tmp$ret$5 = points.length;
  var this_1 = toList(reversed(until(tmp, imul(tmp$ret$5, 2))));
  var backfaceIndicesReversed = copyToArray(this_1);
  faceIndices.h(backfaceIndicesReversed);
  var inductionVariable = 0;
  var last = get_lastIndex(points);
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      vertices[i] = points[i];
      vertices[points.length + i | 0] = points[i].plus(negativeFaceNormal.times(thickness));
      var j = i + points.length | 0;
      var k = (i + 1 | 0) % points.length | 0;
      var l = k + points.length | 0;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$9 = [i, j, l, k];
      faceIndices.h(tmp$ret$9);
    }
     while (!(i === last));
  // Inline function 'kotlin.collections.mutableListOf' call
  var polyhedronNormals = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.mutableListOf' call
  var polyhedronFaces = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.mutableListOf' call
  var polyhedronEdgeDirections = ArrayList_init_$Create$();
  var _iterator__ex2g4s = faceIndices.k();
  while (_iterator__ex2g4s.m()) {
    var face = _iterator__ex2g4s.n();
    var triangleVertex1 = vertices[face[0]];
    var triangleVertex2 = vertices[face[1]];
    var triangleVertex3 = vertices[face[2]];
    if (!(triangleVertex1 == null) && !(triangleVertex2 == null) && !(triangleVertex3 == null)) {
      var currentFaceNormal = this.d3c(triangleVertex1, triangleVertex2, triangleVertex3);
      polyhedronNormals.h(currentFaceNormal);
      polyhedronFaces.h(new Face(face));
      var nextFaceIndex = get_lastIndex(face);
      var inductionVariable_0 = 0;
      var last_0 = get_lastIndex(face);
      if (inductionVariable_0 <= last_0)
        do {
          var index = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var fromVertex = vertices[nextFaceIndex];
          var toVertex = vertices[index];
          if (!(toVertex == null) && !(fromVertex == null)) {
            polyhedronEdgeDirections.h(toVertex.minus(fromVertex));
          }
          nextFaceIndex = index;
        }
         while (!(index === last_0));
    } else {
      this.l1x_1.warn(PolyhedronUtils$Companion$polyhedronFromConvexPolygon$lambda_0);
      return Companion_getInstance_127().ZERO;
    }
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var polyhedronVertices = ArrayList_init_$Create$();
  var inductionVariable_1 = 0;
  // Inline function 'kotlin.collections.count' call
  var tmp$ret$14 = points.length;
  var last_1 = imul(tmp$ret$14, 2);
  if (inductionVariable_1 < last_1)
    do {
      var i_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var vertex = vertices[i_0];
      if (!(vertex == null)) {
        polyhedronVertices.h(vertex);
      } else {
        this.l1x_1.warn(PolyhedronUtils$Companion$polyhedronFromConvexPolygon$lambda_1);
        return Companion_getInstance_127().ZERO;
      }
    }
     while (inductionVariable_1 < last_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_0 = copyToArray(polyhedronNormals);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_1 = copyToArray(polyhedronVertices);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_2 = copyToArray(polyhedronFaces);
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$18 = copyToArray(polyhedronEdgeDirections);
  return new ConvexPolyhedron(tmp_0, tmp_1, tmp_2, tmp$ret$18);
};
protoOf(Companion_128).pointInPolygon = function (point, vertices, normal) {
  // Inline function 'kotlin.math.abs' call
  var x = point.minus(vertices[0]).dot(normal);
  if (Math.abs(x) > 0.1)
    return false;
  // Inline function 'kotlin.math.abs' call
  var x_0 = normal.X;
  var absX = Math.abs(x_0);
  // Inline function 'kotlin.math.abs' call
  var x_1 = normal.Y;
  var absY = Math.abs(x_1);
  // Inline function 'kotlin.math.abs' call
  var x_2 = normal.Z;
  var absZ = Math.abs(x_2);
  var tmp;
  if (absX >= absY && absX >= absZ) {
    tmp = PolyhedronUtils$Companion$pointInPolygon$lambda;
  } else if (absY >= absX && absY >= absZ) {
    tmp = PolyhedronUtils$Companion$pointInPolygon$lambda_0;
  } else {
    tmp = PolyhedronUtils$Companion$pointInPolygon$lambda_1;
  }
  var projectionLambda = tmp;
  var projectedPoint = projectionLambda(point);
  var crossings = 0;
  // Inline function 'kotlin.collections.count' call
  var j = vertices.length - 1 | 0;
  var inductionVariable = 0;
  // Inline function 'kotlin.collections.count' call
  var last = vertices.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var point1 = projectionLambda(vertices[i]);
      var point2 = projectionLambda(vertices[j]);
      if (!(point1.Y > projectedPoint.Y === point2.Y > projectedPoint.Y) && projectedPoint.X < (point2.X - point1.X) * (projectedPoint.Y - point1.Y) / (point2.Y - point1.Y) + point1.X) {
        crossings = crossings + 1 | 0;
      }
      j = i;
    }
     while (inductionVariable < last);
  return !((crossings % 2 | 0) === 0);
};
protoOf(Companion_128).flatPolyhedronFromConvexPolygon = function (vertices) {
  if (vertices.length < 3) {
    this.l1x_1.warn(PolyhedronUtils$Companion$flatPolyhedronFromConvexPolygon$lambda);
    return Companion_getInstance_127().ZERO;
  }
  var normal = this.generateNormalFromClockwiseTriangle(vertices[0], vertices[1], vertices[2]);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = toList(get_indices(vertices));
  var tmp$ret$0 = copyToArray(this_0);
  var face = new Face(tmp$ret$0);
  // Inline function 'kotlin.collections.mutableListOf' call
  var edgeDirections = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = get_lastIndex(vertices);
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      edgeDirections.h(vertices[this.circularIndex(i, vertices.length)].minus(vertices[this.circularIndex(i + 1 | 0, vertices.length)]).normalize());
    }
     while (!(i === last));
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [normal];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [face];
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$8 = copyToArray(edgeDirections);
  return new ConvexPolyhedron(tmp, vertices, tmp_0, tmp$ret$8);
};
protoOf(Companion_128).g3c = function (vertices) {
  var normal = this.d3c(vertices[0], vertices[1], vertices[2]);
  var inductionVariable = 0;
  var last = vertices.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var previousIndex = this.circularIndex(i - 1 | 0, vertices.length);
      var nextIndex = this.circularIndex(i + 1 | 0, vertices.length);
      if (isConcaveVertex(this, vertices[previousIndex], vertices[i], vertices[nextIndex], normal)) {
        return false;
      }
    }
     while (inductionVariable <= last);
  return true;
};
protoOf(Companion_128).a2i = function (vertices) {
  var surfaceX = 0.0;
  var surfaceY = 0.0;
  var surfaceZ = 0.0;
  var inductionVariable = 0;
  var last = vertices.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.mod' call
      var this_0 = i + 1 | 0;
      var other = vertices.length;
      var r = this_0 % other | 0;
      var j = r + (other & ((r ^ other) & (r | (-r | 0))) >> 31) | 0;
      surfaceX = surfaceX + (vertices[i].Y - vertices[j].Y) * (vertices[i].Z + vertices[j].Z);
      surfaceY = surfaceY + (vertices[i].Z - vertices[j].Z) * (vertices[i].X + vertices[j].X);
      surfaceZ = surfaceZ + (vertices[i].X - vertices[j].X) * (vertices[i].Y + vertices[j].Y);
    }
     while (!(i === last));
  return (new Vector(surfaceX, surfaceY, surfaceZ)).normalize();
};
protoOf(Companion_128).generateNormalFromClockwiseTriangle = function (previous, middle, next) {
  return next.minus(middle).cross(middle.minus(previous)).normalize();
};
protoOf(Companion_128).d3c = function (previous, middle, next) {
  return middle.minus(previous).cross(next.minus(middle)).normalize();
};
protoOf(Companion_128).isPointContainedInTriangle = function (p1, p2, p3, testPoint) {
  var normal = this.d3c(p1, p2, p3);
  var plane = new Plane(p1, normal);
  if (plane.contains(testPoint, 0.01)) {
    return isPlanarPointContainedInTriangle(this, p1, p2, p3, testPoint);
  }
  return false;
};
protoOf(Companion_128).l3c = function (polyhedrons) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var faceList = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = polyhedrons.length;
  while (inductionVariable < last) {
    var element = polyhedrons[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.shapes.Companion.getVerticesFromPolyhedrons.<anonymous>' call
    if (element instanceof PolyhedronGroup)
      addAll_1(faceList, Companion_getInstance_129().l3c(element.polyhedra));
    else {
      faceList.h(getVerticesFromSinglePolyhedron(Companion_getInstance_129(), element));
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(faceList);
};
protoOf(Companion_128).m3c = function (polyhedrons) {
  var surfaces = this.l3c(polyhedrons);
  // Inline function 'kotlin.collections.mutableListOf' call
  var polygons = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = surfaces.length;
  while (inductionVariable < last) {
    var element = surfaces[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.shapes.Companion.getPolygonsFromPolyhedrons.<anonymous>' call
    var vertices = element.tf();
    var faces = element.uf();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = faces.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = faces[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Companion.getPolygonsFromPolyhedrons.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = element_0.indices;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(this_0.length);
      var inductionVariable_1 = 0;
      var last_1 = this_0.length;
      while (inductionVariable_1 < last_1) {
        var item = this_0[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.shapes.Companion.getPolygonsFromPolyhedrons.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$1 = vertices[item];
        destination.h(tmp$ret$1);
      }
      var faceVertices = copyToArray(destination);
      polygons.h(new Polygon(faceVertices, Companion_getInstance_129().a2i(faceVertices)));
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(polygons);
};
protoOf(Companion_128).f3c = function (vertices) {
  var shapeNormal = this.a2i(vertices);
  // Inline function 'kotlin.collections.mutableListOf' call
  var triangles = ArrayList_init_$Create$();
  var remainingVertices = toMutableList(vertices);
  $l$loop: while (true) {
    // Inline function 'kotlin.collections.count' call
    if (!(remainingVertices.o() > 2)) {
      break $l$loop;
    }
    var ear = earClipTriangulation$findValidEar(remainingVertices, shapeNormal);
    if (!(ear == null)) {
      var index = ear.tf();
      var triangle = ear.uf();
      triangles.h(triangle);
      remainingVertices.p2(index);
    } else {
      throw IllegalStateException_init_$Create$('Core was unable to triangulate polygon, please supply a non-degenerate polygon.');
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(triangles);
};
protoOf(Companion_128).m1x = function (poly, worldTransform) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var vertices = ArrayList_init_$Create$();
  if (poly instanceof ConvexPolyhedron) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = poly.transform(worldTransform).vertices;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.shapes.Companion.transformAndExtractVerticesFromPolyhedron.<anonymous>' call
      vertices.h(element);
    }
  } else {
    if (poly instanceof PolyhedronGroup) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_0 = poly.polyhedra;
      var inductionVariable_0 = 0;
      var last_0 = indexedObject_0.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = indexedObject_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.shapes.Companion.transformAndExtractVerticesFromPolyhedron.<anonymous>' call
        vertices.p(Companion_getInstance_129().m1x(element_0, worldTransform));
      }
    } else {
      this.l1x_1.warn(PolyhedronUtils$Companion$transformAndExtractVerticesFromPolyhedron$lambda(poly));
    }
  }
  return vertices;
};
protoOf(Companion_128).n3c = function (polyhedron) {
  return polyhedron instanceof ConvexPolyhedron;
};
protoOf(Companion_128).o3c = function (polyhedron) {
  return polyhedron instanceof Cuboid;
};
protoOf(Companion_128).p3c = function (polyhedron) {
  return polyhedron instanceof Cylinder;
};
protoOf(Companion_128).q3c = function (polyhedron) {
  return polyhedron instanceof PolyhedronGroup;
};
var Companion_instance_128;
function Companion_getInstance_129() {
  if (Companion_instance_128 == null)
    new Companion_128();
  return Companion_instance_128;
}
function createFromPolygon(vertices) {
  return Companion_getInstance_129().e3c(vertices);
}
function createFramePolyhedrons(size, margin, padding, compartment) {
  return Companion_getInstance_129().h3c(size, margin, padding, compartment);
}
function createFramePolyhedrons_0(size, margin, padding, compartment, $super) {
  compartment = compartment === VOID ? null : compartment;
  return createFramePolyhedrons(size, margin, padding, compartment);
}
function singleSidedPolyhedronFromPolygon(vertices) {
  return Companion_getInstance_129().i3c(vertices);
}
function polyhedronFromPolygon(points, thickness) {
  return Companion_getInstance_129().j3c(points, thickness);
}
function polyhedronFromConvexPolygon(points, thickness) {
  return Companion_getInstance_129().k3c(points, thickness);
}
function isConvexPolygon(vertices) {
  return Companion_getInstance_129().g3c(vertices);
}
function surfaceNormal(vertices) {
  return Companion_getInstance_129().a2i(vertices);
}
function generateNormalFromCounterClockwiseTriangle(previous, middle, next) {
  return Companion_getInstance_129().d3c(previous, middle, next);
}
function getPolygonsFromPolyhedrons(polyhedrons) {
  return Companion_getInstance_129().m3c(polyhedrons);
}
function earClipTriangulation(vertices) {
  return Companion_getInstance_129().f3c(vertices);
}
function isConvexPolyhedron(polyhedron) {
  return Companion_getInstance_129().n3c(polyhedron);
}
function isCuboid(polyhedron) {
  return Companion_getInstance_129().o3c(polyhedron);
}
function isCylinder(polyhedron) {
  return Companion_getInstance_129().p3c(polyhedron);
}
function isPolyhedronGroup(polyhedron) {
  return Companion_getInstance_129().q3c(polyhedron);
}
function PolyhedronUtils() {
  Companion_getInstance_129();
}
function Companion_129() {
}
protoOf(Companion_129).n1s = function () {
  return Companion_instance_21.l1p_1;
};
var Companion_instance_129;
function Companion_getInstance_130() {
  return Companion_instance_129;
}
function MovedToCandidateSnapPositionComponent(snap) {
  this.snap = snap;
}
protoOf(MovedToCandidateSnapPositionComponent).t1u = function () {
  return this.snap;
};
protoOf(MovedToCandidateSnapPositionComponent).p1s = function () {
  return Companion_instance_129.id;
};
protoOf(MovedToCandidateSnapPositionComponent).eq = function (other) {
  return true;
};
function triggerMovedToCandidateSnapPositionComponent(_this__u8e3s4, snap) {
  _this__u8e3s4.addComponent(new MovedToCandidateSnapPositionComponent(snap));
  _this__u8e3s4.removeComponent(Companion_instance_129.id);
}
function Companion_130() {
  Companion_instance_130 = this;
  this.id = Companion_instance_21.o1o_1;
}
protoOf(Companion_130).n1s = function () {
  return this.id;
};
var Companion_instance_130;
function Companion_getInstance_131() {
  if (Companion_instance_130 == null)
    new Companion_130();
  return Companion_instance_130;
}
function MovedToValidSnapPositionComponent(snap) {
  Companion_getInstance_131();
  this.snap = snap;
}
protoOf(MovedToValidSnapPositionComponent).t1u = function () {
  return this.snap;
};
protoOf(MovedToValidSnapPositionComponent).p1s = function () {
  return Companion_getInstance_131().id;
};
protoOf(MovedToValidSnapPositionComponent).eq = function (other) {
  return true;
};
function triggerMovedToValidSnapPositionComponent(_this__u8e3s4, snap) {
  _this__u8e3s4.addComponent(new MovedToValidSnapPositionComponent(snap));
  _this__u8e3s4.removeComponent(Companion_getInstance_131().id);
}
function Companion_131() {
}
protoOf(Companion_131).n1s = function () {
  return Companion_instance_21.e1n_1;
};
var Companion_instance_131;
function Companion_getInstance_132() {
  return Companion_instance_131;
}
function RestrictAllowedRequiredHostsComponent(allowedHosts) {
  this.allowedHosts = allowedHosts;
  this.h2c_1 = 0;
}
protoOf(RestrictAllowedRequiredHostsComponent).r3c = function () {
  return this.allowedHosts;
};
protoOf(RestrictAllowedRequiredHostsComponent).p1s = function () {
  return Companion_instance_131.id;
};
protoOf(RestrictAllowedRequiredHostsComponent).eq = function (other) {
  var otherC = other instanceof RestrictAllowedRequiredHostsComponent ? other : THROW_CCE();
  var tmp;
  if (otherC.allowedHosts.length === this.allowedHosts.length) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var indexedObject = otherC.allowedHosts;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.snapping.RestrictAllowedRequiredHostsComponent.eq.<anonymous>' call
        if (!contains(this.allowedHosts, element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    tmp = tmp$ret$1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(RestrictAllowedRequiredHostsComponent).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof RestrictAllowedRequiredHostsComponent))
    THROW_CCE();
  if (!contentEquals(this.allowedHosts, other.allowedHosts))
    return false;
  return true;
};
protoOf(RestrictAllowedRequiredHostsComponent).hashCode = function () {
  if (this.h2c_1 === 0)
    this.h2c_1 = contentHashCode(this.allowedHosts);
  return this.h2c_1;
};
protoOf(RestrictAllowedRequiredHostsComponent).tf = function () {
  return this.allowedHosts;
};
protoOf(RestrictAllowedRequiredHostsComponent).w2s = function (allowedHosts) {
  return new RestrictAllowedRequiredHostsComponent(allowedHosts);
};
protoOf(RestrictAllowedRequiredHostsComponent).copy = function (allowedHosts, $super) {
  allowedHosts = allowedHosts === VOID ? this.allowedHosts : allowedHosts;
  return this.w2s(allowedHosts);
};
protoOf(RestrictAllowedRequiredHostsComponent).toString = function () {
  return 'RestrictAllowedRequiredHostsComponent(allowedHosts=' + toString_0(this.allowedHosts) + ')';
};
function _get_guestInitialTransform__2jc47l($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.t1l_1;
  guestInitialTransform$factory();
  return this_0.c2();
}
function performMovement($this, productRoot) {
  Companion_instance_146.z1l(productRoot, $this.endTransform);
}
function revertMovement($this) {
  Companion_instance_146.z1l($this.guestRoot, $this.initialTransform);
}
function _get_nonDisposedGuest__7a6v6j($this) {
  var tmp;
  if ($this.guest.isDisposed) {
    tmp = null;
  } else {
    tmp = $this.guest;
  }
  return tmp;
}
function createConnections($this) {
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = getHierarchyWithComponent_0($this.guestRoot, Companion_getInstance_25().id);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Snap.createConnections.<anonymous>' call
    if (equals(element.entityManager.findEntity(element.id), element)) {
      Companion_instance_25.g29(element, Companion_instance_62.h29($this.host));
    }
  }
}
function getAffectedGroups($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = getHierarchyWithComponent_0($this.guestRoot, Companion_getInstance_25().id);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Snap.getAffectedGroups.<anonymous>' call
    var tmp$ret$0 = get_guestConnections(item);
    destination.h(tmp$ret$0);
  }
  var guestConnectionsAfterSnapping = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = guestConnectionsAfterSnapping.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.snapping.Snap.getAffectedGroups.<anonymous>' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_1 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = element.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = element[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.snapping.Snap.getAffectedGroups.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = get_automaticEntityGroup(element_0.guestConnectionRoot);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_1.h(tmp0_safe_receiver);
      }
    }
    var list = destination_1;
    addAll(destination_0, list);
  }
  var entityGroups = distinct(destination_0);
  return entityGroups;
}
function _get_inActivationDistance__r405b9($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.u1l_1;
  inActivationDistance$factory();
  return this_0.c2();
}
function Snap$guestRootToGuestDeltaTransform$delegate$lambda(this$0) {
  return function () {
    return get_worldTransform(this$0.guest).delta(get_worldTransform(this$0.guestRoot));
  };
}
function Snap$guestRootToGuestConnectorDeltaTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.guestRootToGuestDeltaTransform.concatenate(this$0.guestConnector.transform);
  };
}
function Snap$guestEndTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.endTransform.concatenate(this$0.guestRootToGuestDeltaTransform);
  };
}
function Snap$guestInitialTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.initialTransform.concatenate(this$0.guestRootToGuestDeltaTransform);
  };
}
function Snap$inActivationDistance$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.alignmentInitiatorCandidate;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnector;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.activationDistance;
    var hostActivationDistance = tmp2_elvis_lhs == null ? this$0.hostConnector.activationDistance : tmp2_elvis_lhs;
    var tmp3_safe_receiver = this$0.alignmentInitiatorCandidate;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.guestConnector;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.activationDistance;
    var guestActivationDistance = tmp5_elvis_lhs == null ? this$0.guestConnector.activationDistance : tmp5_elvis_lhs;
    var activationDistance = hostActivationDistance + guestActivationDistance;
    var tmp6_safe_receiver = this$0.alignmentInitiatorCandidate;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.guestConnector;
    var usedGuestConnector = tmp7_elvis_lhs == null ? this$0.guestConnector : tmp7_elvis_lhs;
    var guestConnectorInitialWorldPos = usedGuestConnector.getWorldPositionFromOwnerTransform(_get_guestInitialTransform__2jc47l(this$0));
    var guestConnectorEndTransformWorldPos = usedGuestConnector.getWorldPositionFromOwnerTransform(this$0.guestEndTransform);
    var dist = guestConnectorEndTransformWorldPos.minus(guestConnectorInitialWorldPos).size;
    return dist <= activationDistance;
  };
}
function Snap(host, guest, guestRoot, hostConnector, guestConnector, initialTransform, endTransform, overridePriority, alignmentInitiatorCandidate) {
  overridePriority = overridePriority === VOID ? null : overridePriority;
  alignmentInitiatorCandidate = alignmentInitiatorCandidate === VOID ? null : alignmentInitiatorCandidate;
  this.host = host;
  this.guest = guest;
  this.guestRoot = guestRoot;
  this.hostConnector = hostConnector;
  this.guestConnector = guestConnector;
  this.initialTransform = initialTransform;
  this.endTransform = endTransform;
  this.alignmentInitiatorCandidate = alignmentInitiatorCandidate;
  this.movement = this.endTransform.position.minus(this.initialTransform.position);
  this.deltaRotation = this.initialTransform.rotation.inverse().times(this.endTransform.rotation);
  var tmp = this;
  tmp.priority = overridePriority == null ? this.guestConnector.priority + this.hostConnector.priority | 0 : overridePriority;
  var tmp_0 = this;
  tmp_0.q1l_1 = lazy(Snap$guestRootToGuestDeltaTransform$delegate$lambda(this));
  var tmp_1 = this;
  tmp_1.r1l_1 = lazy(Snap$guestRootToGuestConnectorDeltaTransform$delegate$lambda(this));
  var tmp_2 = this;
  tmp_2.s1l_1 = lazy(Snap$guestEndTransform$delegate$lambda(this));
  var tmp_3 = this;
  tmp_3.t1l_1 = lazy(Snap$guestInitialTransform$delegate$lambda(this));
  var tmp_4 = this;
  tmp_4.u1l_1 = lazy(Snap$inActivationDistance$delegate$lambda(this));
}
protoOf(Snap).s3c = function () {
  return this.host;
};
protoOf(Snap).t3c = function () {
  return this.guest;
};
protoOf(Snap).u3c = function () {
  return this.guestRoot;
};
protoOf(Snap).p28 = function () {
  return this.hostConnector;
};
protoOf(Snap).o28 = function () {
  return this.guestConnector;
};
protoOf(Snap).v3c = function () {
  return this.initialTransform;
};
protoOf(Snap).w3c = function () {
  return this.endTransform;
};
protoOf(Snap).x3c = function () {
  return this.alignmentInitiatorCandidate;
};
protoOf(Snap).y3c = function () {
  return this.movement;
};
protoOf(Snap).z3c = function () {
  return this.deltaRotation;
};
protoOf(Snap).n28 = function () {
  return this.priority;
};
protoOf(Snap).a3d = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.q1l_1;
  guestRootToGuestDeltaTransform$factory();
  return this_0.c2();
};
protoOf(Snap).b3d = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.r1l_1;
  guestRootToGuestConnectorDeltaTransform$factory();
  return this_0.c2();
};
protoOf(Snap).c3d = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.s1l_1;
  guestEndTransform$factory();
  return this_0.c2();
};
protoOf(Snap).d3d = function () {
  return this.guestConnector.type === Companion_instance_32.n2b_1;
};
protoOf(Snap).performMove = function () {
  performMovement(this, this.guestRoot);
  triggerMovedToCandidateSnapPositionComponent(this.guestRoot, this);
};
protoOf(Snap).rollbackMove = function () {
  revertMovement(this);
  triggerMovedToCandidateSnapPositionComponent(this.guestRoot, null);
};
protoOf(Snap).performMoveAndConnect = function () {
  this.guest.addComponent(new SnapActionInProgressComponent());
  this.performMove();
  createConnections(this);
  var entityGroups = getAffectedGroups(this);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = entityGroups.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.snapping.Snap.performMoveAndConnect.<anonymous>' call
    setAutomaticGroupParentToHighestPrioConnectionOutsideGroup(element);
  }
  triggerMovedToValidSnapPositionComponent(this.guestRoot, this);
  var tmp0_safe_receiver = _get_nonDisposedGuest__7a6v6j(this);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.removeComponent(Companion_getInstance_134().id);
};
protoOf(Snap).doInitialAssemblySnap = function () {
  Companion_instance_146.z1l(this.guestRoot, this.endTransform);
  setParent_0(this.guestRoot, this.host);
};
protoOf(Snap).toString = function () {
  if (!this.guestRoot.equals(this.guest)) {
    return 'Snap guest root ' + get_displayName(this.guestRoot) + ',' + this.guestRoot.id + ', ' + ('Guest ' + get_displayName(this.guest) + ',' + this.guest.id + ', ') + ('Host ' + get_displayName(this.host) + ',' + this.host.id);
  }
  return 'Snap,' + ('Guest ' + get_displayName(this.guest) + ', ' + this.guestConnector.key + ', ' + this.guest.id + ',') + ('Host ' + get_displayName(this.host) + ', ' + this.hostConnector.key + ', ' + this.host.id);
};
protoOf(Snap).inActivationDistance = function () {
  return _get_inActivationDistance__r405b9(this);
};
protoOf(Snap).withInitialTransform = function (io) {
  return new Snap(this.host, this.guest, this.guestRoot, this.hostConnector, this.guestConnector, io, this.endTransform, VOID, this.alignmentInitiatorCandidate);
};
protoOf(Snap).withNewEndPosition = function (newEndPosition) {
  return new Snap(this.host, this.guest, this.guestRoot, this.hostConnector, this.guestConnector, this.initialTransform, new Transform(newEndPosition, this.endTransform.rotation));
};
function guestRootToGuestDeltaTransform$factory() {
  return getPropertyCallableRef('guestRootToGuestDeltaTransform', 1, KProperty1, function (receiver) {
    return receiver.guestRootToGuestDeltaTransform;
  }, null);
}
function guestRootToGuestConnectorDeltaTransform$factory() {
  return getPropertyCallableRef('guestRootToGuestConnectorDeltaTransform', 1, KProperty1, function (receiver) {
    return receiver.guestRootToGuestConnectorDeltaTransform;
  }, null);
}
function guestEndTransform$factory() {
  return getPropertyCallableRef('guestEndTransform', 1, KProperty1, function (receiver) {
    return receiver.guestEndTransform;
  }, null);
}
function guestInitialTransform$factory() {
  return getPropertyCallableRef('guestInitialTransform', 1, KProperty1, function (receiver) {
    return _get_guestInitialTransform__2jc47l(receiver);
  }, null);
}
function inActivationDistance$factory() {
  return getPropertyCallableRef('inActivationDistance', 1, KProperty1, function (receiver) {
    return _get_inActivationDistance__r405b9(receiver);
  }, null);
}
function Companion_132() {
  Companion_instance_132 = this;
  this.q35_1 = new SelectAll();
  this.r35_1 = new SortByPriorityInActivationDistanceThenDistance();
  this.s35_1 = new SortByDistance();
  this.t35_1 = new SortByPriorityThenDistance();
}
protoOf(Companion_132).e3d = function () {
  return this.q35_1;
};
protoOf(Companion_132).f3d = function () {
  return this.r35_1;
};
protoOf(Companion_132).g3d = function () {
  return this.s35_1;
};
protoOf(Companion_132).h3d = function () {
  return this.t35_1;
};
var Companion_instance_132;
function Companion_getInstance_133() {
  if (Companion_instance_132 == null)
    new Companion_132();
  return Companion_instance_132;
}
function get_SELECT_ALL() {
  return Companion_getInstance_133().q35_1;
}
function get_SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE() {
  return Companion_getInstance_133().r35_1;
}
function get_SORT_BY_DISTANCE() {
  return Companion_getInstance_133().s35_1;
}
function get_SORT_BY_PRIORITY_THEN_DISTANCE() {
  return Companion_getInstance_133().t35_1;
}
function SnapActionCandidateSortAndSelectStrategies() {
  Companion_getInstance_133();
}
function SnapActionCandidateSortAndSelectStrategy() {
}
function SelectAll() {
}
protoOf(SelectAll).sortAndSelect = function (snaps) {
  return snaps;
};
function sam$kotlin_Comparator$0_2(function_0) {
  this.i3d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_2).md = function (a, b) {
  return this.i3d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_2).s3 = function () {
  return this.i3d_1;
};
protoOf(sam$kotlin_Comparator$0_2).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_2).hashCode = function () {
  return hashCode(this.s3());
};
function SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda(it) {
  return it.movement.size;
}
function SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
  var tmp = b.priority;
  // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
  var tmp$ret$1 = a.priority;
  return compareValues(tmp, tmp$ret$1);
}
function SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
  var tmp = b.priority;
  // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
  var tmp$ret$1 = a.priority;
  return compareValues(tmp, tmp$ret$1);
}
function SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_2($minimumDistanceElement) {
  return function (it) {
    return minimumDistanceOrMovementDistance($minimumDistanceElement, it);
  };
}
function SortByPriorityInActivationDistanceThenDistance() {
}
protoOf(SortByPriorityInActivationDistanceThenDistance).sortAndSelect = function (snaps) {
  // Inline function 'kotlin.collections.partition' call
  var first = ArrayList_init_$Create$();
  var second = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = snaps.length;
  while (inductionVariable < last) {
    var element = snaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
    if (element.inActivationDistance()) {
      first.h(element);
    } else {
      second.h(element);
    }
  }
  var _destruct__k2r9zo = new Pair(first, second);
  var snapsInActivationDistance = _destruct__k2r9zo.tf();
  var otherSnaps = _destruct__k2r9zo.uf();
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = sortedByWithEpsilon(snapsInActivationDistance, VOID, SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_0;
  var tmp$ret$2 = new sam$kotlin_Comparator$0_2(tmp);
  var this_1 = sortedWith_0(this_0, tmp$ret$2);
  var result = copyToArray(this_1);
  var tmp$ret$5;
  $l$block_0: {
    // Inline function 'kotlin.collections.minByOrNull' call
    var iterator = otherSnaps.k();
    if (!iterator.m()) {
      tmp$ret$5 = null;
      break $l$block_0;
    }
    var minElem = iterator.n();
    if (!iterator.m()) {
      tmp$ret$5 = minElem;
      break $l$block_0;
    }
    // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
    var minValue = minElem.movement.size;
    do {
      var e = iterator.n();
      // Inline function 'com.ikea.core.snapping.SortByPriorityInActivationDistanceThenDistance.sortAndSelect.<anonymous>' call
      var v = e.movement.size;
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.m());
    tmp$ret$5 = minElem;
  }
  var minimumDistanceElement = tmp$ret$5;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_0 = SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_1;
  var tmp$ret$8 = new sam$kotlin_Comparator$0_2(tmp_0);
  var tmp_1 = sortedWith_0(otherSnaps, tmp$ret$8);
  var this_2 = sortedByWithEpsilon(tmp_1, VOID, SortByPriorityInActivationDistanceThenDistance$sortAndSelect$lambda_2(minimumDistanceElement));
  var othersByDistance = copyToArray(this_2);
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  return result.concat(othersByDistance);
};
function sam$kotlin_Comparator$0_3(function_0) {
  this.j3d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_3).md = function (a, b) {
  return this.j3d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_3).s3 = function () {
  return this.j3d_1;
};
protoOf(sam$kotlin_Comparator$0_3).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_3).hashCode = function () {
  return hashCode(this.s3());
};
function SortByPriorityThenDistance$sortAndSelect$lambda(it) {
  return it.movement.size;
}
function SortByPriorityThenDistance$sortAndSelect$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.snapping.SortByPriorityThenDistance.sortAndSelect.<anonymous>' call
  var tmp = b.priority;
  // Inline function 'com.ikea.core.snapping.SortByPriorityThenDistance.sortAndSelect.<anonymous>' call
  var tmp$ret$1 = a.priority;
  return compareValues(tmp, tmp$ret$1);
}
function SortByPriorityThenDistance() {
}
protoOf(SortByPriorityThenDistance).sortAndSelect = function (snaps) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = sortedByWithEpsilon_0(snaps, VOID, SortByPriorityThenDistance$sortAndSelect$lambda);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = SortByPriorityThenDistance$sortAndSelect$lambda_0;
  var tmp$ret$0 = new sam$kotlin_Comparator$0_3(tmp);
  var this_1 = sortedWith_0(this_0, tmp$ret$0);
  return copyToArray(this_1);
};
function sam$kotlin_Comparator$0_4(function_0) {
  this.k3d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_4).md = function (a, b) {
  return this.k3d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_4).s3 = function () {
  return this.k3d_1;
};
protoOf(sam$kotlin_Comparator$0_4).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_4).hashCode = function () {
  return hashCode(this.s3());
};
function SortByDistance$sortAndSelect$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.core.snapping.SortByDistance.sortAndSelect.<anonymous>' call
  var tmp = b.priority;
  // Inline function 'com.ikea.core.snapping.SortByDistance.sortAndSelect.<anonymous>' call
  var tmp$ret$1 = a.priority;
  return compareValues(tmp, tmp$ret$1);
}
function SortByDistance$sortAndSelect$lambda_0(it) {
  return it.movement.size;
}
function SortByDistance() {
}
protoOf(SortByDistance).sortAndSelect = function (snaps) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = SortByDistance$sortAndSelect$lambda;
  var tmp$ret$0 = new sam$kotlin_Comparator$0_4(tmp);
  var tmp_0 = sortedWith(snaps, tmp$ret$0);
  var this_0 = sortedByWithEpsilon(tmp_0, VOID, SortByDistance$sortAndSelect$lambda_0);
  return copyToArray(this_0);
};
function sortedByWithEpsilon(_this__u8e3s4, epsilon, selector) {
  epsilon = epsilon === VOID ? 0.001 : epsilon;
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = sortedByWithEpsilon$lambda(selector, epsilon);
  var tmp$ret$0 = new sam$kotlin_Comparator$0_5(tmp);
  return sortedWith_0(_this__u8e3s4, tmp$ret$0);
}
function minimumDistanceOrMovementDistance(minimumDistanceElement, it) {
  return !(minimumDistanceElement == null) && almostEquals(it.movement.size, minimumDistanceElement.movement.size) ? minimumDistanceElement.movement.size : it.movement.size;
}
function sortedByWithEpsilon_0(_this__u8e3s4, epsilon, selector) {
  epsilon = epsilon === VOID ? 0.001 : epsilon;
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = sortedByWithEpsilon$lambda_0(selector, epsilon);
  var tmp$ret$0 = new sam$kotlin_Comparator$0_6(tmp);
  return sortedWith(_this__u8e3s4, tmp$ret$0);
}
function sam$kotlin_Comparator$0_5(function_0) {
  this.l3d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_5).md = function (a, b) {
  return this.l3d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_5).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_5).s3 = function () {
  return this.l3d_1;
};
protoOf(sam$kotlin_Comparator$0_5).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_5).hashCode = function () {
  return hashCode(this.s3());
};
function sam$kotlin_Comparator$0_6(function_0) {
  this.m3d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_6).md = function (a, b) {
  return this.m3d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_6).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0_6).s3 = function () {
  return this.m3d_1;
};
protoOf(sam$kotlin_Comparator$0_6).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_6).hashCode = function () {
  return hashCode(this.s3());
};
function sortedByWithEpsilon$lambda($selector, $epsilon) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.snapping.sortedByWithEpsilon.<anonymous>' call
    var tmp = roundToInt($selector(a) / $epsilon);
    // Inline function 'com.ikea.core.snapping.sortedByWithEpsilon.<anonymous>' call
    var tmp$ret$1 = roundToInt($selector(b) / $epsilon);
    return compareValues(tmp, tmp$ret$1);
  };
}
function sortedByWithEpsilon$lambda_0($selector, $epsilon) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.snapping.sortedByWithEpsilon.<anonymous>' call
    var tmp = roundToInt($selector(a) / $epsilon);
    // Inline function 'com.ikea.core.snapping.sortedByWithEpsilon.<anonymous>' call
    var tmp$ret$1 = roundToInt($selector(b) / $epsilon);
    return compareValues(tmp, tmp$ret$1);
  };
}
function Companion_133() {
  Companion_instance_133 = this;
  this.id = Companion_instance_21.e1o_1;
}
protoOf(Companion_133).n1s = function () {
  return this.id;
};
var Companion_instance_133;
function Companion_getInstance_134() {
  if (Companion_instance_133 == null)
    new Companion_133();
  return Companion_instance_133;
}
function SnapActionInProgressComponent() {
  Companion_getInstance_134();
  this.n3d_1 = Companion_getInstance_134().id;
}
protoOf(SnapActionInProgressComponent).p1s = function () {
  return this.n3d_1;
};
protoOf(SnapActionInProgressComponent).eq = function (other) {
  return other instanceof SnapActionInProgressComponent;
};
function Companion_134() {
}
protoOf(Companion_134).n1s = function () {
  return Companion_instance_21.r1n_1;
};
var Companion_instance_134;
function Companion_getInstance_135() {
  return Companion_instance_134;
}
function SnapCandidateComponent() {
}
protoOf(SnapCandidateComponent).p1s = function () {
  return Companion_instance_134.id;
};
protoOf(SnapCandidateComponent).eq = function (other) {
  return true;
};
function isCloseToValidCandidateWithSameHostInActivationDistance($this, candidate, validCandidates) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = validCandidates.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.snapping.Companion.isCloseToValidCandidateWithSameHostInActivationDistance.<anonymous>' call
    if (!element.equals(candidate) && element.snap.hostConnector.isContinuousConnector && element.snap.host.equals(candidate.snap.host) && element.snap.priority > candidate.snap.priority) {
      destination.h(element);
    }
  }
  var betterCandidatesOnSameHost = destination;
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(betterCandidatesOnSameHost, Collection)) {
      tmp = betterCandidatesOnSameHost.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$3 = false;
      break $l$block_0;
    }
    var tmp0_iterator_0 = betterCandidatesOnSameHost.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.snapping.Companion.isCloseToValidCandidateWithSameHostInActivationDistance.<anonymous>' call
      if (betterIsInActivationDistance(Companion_instance_135, element_0, candidate)) {
        tmp$ret$3 = true;
        break $l$block_0;
      }
    }
    tmp$ret$3 = false;
  }
  var foundBetter = tmp$ret$3;
  return foundBetter;
}
function betterIsInActivationDistance($this, existingValidatedSnap, candidate) {
  var testActivationDistanceSnap = existingValidatedSnap.snap.withInitialTransform(candidate.snap.endTransform);
  var inActivationDistance = testActivationDistanceSnap.inActivationDistance();
  return inActivationDistance;
}
function Companion_135() {
}
protoOf(Companion_135).q3d = function (candidates) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = candidates.length;
  while (inductionVariable < last) {
    var element = candidates[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Companion.filterOutCandidateInActivationDistanceFromAlignment.<anonymous>' call
    if (element.valid) {
      destination.h(element);
    }
  }
  var validCandidates = destination;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = candidates.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = candidates[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Companion.filterOutCandidateInActivationDistanceFromAlignment.<anonymous>' call
    if (!isCloseToValidCandidateWithSameHostInActivationDistance(Companion_instance_135, element_0, validCandidates)) {
      destination_0.h(element_0);
    }
  }
  var candidatesThatCouldNotBeReplaced = copyToArray(destination_0);
  return candidatesThatCouldNotBeReplaced;
};
var Companion_instance_135;
function Companion_getInstance_136() {
  return Companion_instance_135;
}
function filterOutCandidateInActivationDistanceFromAlignment(candidates) {
  return Companion_instance_135.q3d(candidates);
}
function SnapPostProcessingUtil() {
}
function Companion_136() {
  Companion_instance_136 = this;
  this.id = Companion_instance_21.q1o_1;
}
protoOf(Companion_136).n1s = function () {
  return this.id;
};
var Companion_instance_136;
function Companion_getInstance_137() {
  if (Companion_instance_136 == null)
    new Companion_136();
  return Companion_instance_136;
}
function SnapRootComponent() {
  Companion_getInstance_137();
}
protoOf(SnapRootComponent).p1s = function () {
  return Companion_getInstance_137().id;
};
protoOf(SnapRootComponent).eq = function (other) {
  return true;
};
function get_snapRoot(_this__u8e3s4) {
  return findWithComponentInUpwardsHierarchy_0(_this__u8e3s4, Companion_getInstance_137().id);
}
function get_snappingHierarchyEntitiesList(_this__u8e3s4) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = hierarchyExceptSubTreesWithComponentArray(_this__u8e3s4, Companion_getInstance_137().id);
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.<get-snappingHierarchyEntitiesList>.<anonymous>' call
    if (element.hasComponent(Companion_getInstance_35().id)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.snapping.<get-snappingHierarchyEntitiesList>.<anonymous>' call
    var tmp;
    var tmp0_safe_receiver = get_connectorsComponent(element_0);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
    if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
      tmp = true;
    } else {
      var tmp2_safe_receiver = get_connectorsComponent(element_0);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
      tmp = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
    }
    if (tmp) {
      destination_0.h(element_0);
    }
  }
  return destination_0;
}
function get_snappingHierarchyEntitiesSequence(_this__u8e3s4) {
  var tmp = hierarchyExceptSubTreesWithComponentSequence(_this__u8e3s4, Companion_getInstance_137().id);
  var tmp_0 = filter(tmp, _get_snappingHierarchyEntitiesSequence_$lambda_6umhyj);
  return filter(tmp_0, _get_snappingHierarchyEntitiesSequence_$lambda_6umhyj_0);
}
function get_snappingHierarchyEntities(_this__u8e3s4) {
  return hierarchyExceptSubTreesWithComponentArray(_this__u8e3s4, Companion_getInstance_137().id);
}
function get_snapRootSubTree(_this__u8e3s4) {
  var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_snappingHierarchyEntities(tmp0_safe_receiver);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function forEachSnappingHierarchyEntity(_this__u8e3s4, func) {
  forEachInHierarchyExceptSubHierarchiesWithComponent_0(_this__u8e3s4, Companion_getInstance_137().id, func);
}
function _get_snappingHierarchyEntitiesSequence_$lambda_6umhyj(it) {
  return it.hasComponent(Companion_getInstance_35().id);
}
function _get_snappingHierarchyEntitiesSequence_$lambda_6umhyj_0(it) {
  var tmp;
  var tmp0_safe_receiver = get_connectorsComponent(it);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f29();
  if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
    tmp = true;
  } else {
    var tmp2_safe_receiver = get_connectorsComponent(it);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
    tmp = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
  }
  return tmp;
}
function SnapSettings(includeAllSubConnectors, includeInternalConnectors, includeHostAssemblyParts, includeAlignmentConnectorsOutsideActivationDistance) {
  includeAllSubConnectors = includeAllSubConnectors === VOID ? false : includeAllSubConnectors;
  includeInternalConnectors = includeInternalConnectors === VOID ? false : includeInternalConnectors;
  includeHostAssemblyParts = includeHostAssemblyParts === VOID ? false : includeHostAssemblyParts;
  includeAlignmentConnectorsOutsideActivationDistance = includeAlignmentConnectorsOutsideActivationDistance === VOID ? false : includeAlignmentConnectorsOutsideActivationDistance;
  this.r3d_1 = includeAllSubConnectors;
  this.s3d_1 = includeInternalConnectors;
  this.t3d_1 = includeHostAssemblyParts;
  this.u3d_1 = includeAlignmentConnectorsOutsideActivationDistance;
}
protoOf(SnapSettings).v3d = function () {
  return this.r3d_1;
};
protoOf(SnapSettings).w3d = function () {
  return this.s3d_1;
};
protoOf(SnapSettings).x3d = function () {
  return this.t3d_1;
};
protoOf(SnapSettings).y3d = function () {
  return this.u3d_1;
};
function _get_logger__rkp4sl($this) {
  return LoggerState_getInstance().g1v('SnapUtils');
}
function findContinuousAlternativeToAlignment($this, alignmentSnap, continuousCandidates) {
  alignmentSnap.performMove();
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxByOrNull' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = continuousCandidates.length;
    while (inductionVariable < last) {
      var element = continuousCandidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.Companion.findContinuousAlternativeToAlignment.<anonymous>' call
      if (element.hostConnector.containsConnector(get_worldTransform(element.host), get_worldTransform(element.guest), element.guestConnector) && element.guestConnector.calculateRotation(get_worldTransform(element.host), element.hostConnector, get_worldTransform(element.guest)).almostEquals(Companion_getInstance_74().q2b_1)) {
        destination.h(element);
      }
    }
    var iterator = destination.k();
    if (!iterator.m()) {
      tmp$ret$3 = null;
      break $l$block_0;
    }
    var maxElem = iterator.n();
    if (!iterator.m()) {
      tmp$ret$3 = maxElem;
      break $l$block_0;
    }
    // Inline function 'com.ikea.core.snapping.Companion.findContinuousAlternativeToAlignment.<anonymous>' call
    var maxValue = maxElem.priority;
    do {
      var e = iterator.n();
      // Inline function 'com.ikea.core.snapping.Companion.findContinuousAlternativeToAlignment.<anonymous>' call
      var v = e.priority;
      if (compareTo(maxValue, v) < 0) {
        maxElem = e;
        maxValue = v;
      }
    }
     while (iterator.m());
    tmp$ret$3 = maxElem;
  }
  var bestCandidate = tmp$ret$3;
  alignmentSnap.rollbackMove();
  if (bestCandidate == null)
    return null;
  return new AlternativeSnap(bestCandidate.host, bestCandidate.guest, bestCandidate.hostConnector, bestCandidate.guestConnector);
}
function AlternativeSnap(hostEntity, guestEntity, hostConnector, guestConnector) {
  this.z3d_1 = hostEntity;
  this.a3e_1 = guestEntity;
  this.b3e_1 = hostConnector;
  this.c3e_1 = guestConnector;
}
protoOf(AlternativeSnap).toString = function () {
  return 'AlternativeSnap(hostEntity=' + this.z3d_1.toString() + ', guestEntity=' + this.a3e_1.toString() + ', hostConnector=' + toString_0(this.b3e_1) + ', guestConnector=' + toString_0(this.c3e_1) + ')';
};
protoOf(AlternativeSnap).hashCode = function () {
  var result = this.z3d_1.hashCode();
  result = imul(result, 31) + this.a3e_1.hashCode() | 0;
  result = imul(result, 31) + this.b3e_1.hashCode() | 0;
  result = imul(result, 31) + this.c3e_1.hashCode() | 0;
  return result;
};
protoOf(AlternativeSnap).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AlternativeSnap))
    return false;
  var tmp0_other_with_cast = other instanceof AlternativeSnap ? other : THROW_CCE();
  if (!this.z3d_1.equals(tmp0_other_with_cast.z3d_1))
    return false;
  if (!this.a3e_1.equals(tmp0_other_with_cast.a3e_1))
    return false;
  if (!this.b3e_1.equals(tmp0_other_with_cast.b3e_1))
    return false;
  if (!this.c3e_1.equals(tmp0_other_with_cast.c3e_1))
    return false;
  return true;
};
function getMatchingSnapsOnHost$isCloseEnough($snapSettings, $hostEntity, guestConnector, snappingGuest, hostSubConnector) {
  var tmp;
  if (guestConnector.type === Companion_instance_32.n2b_1) {
    tmp = $snapSettings.includeAlignmentConnectorsOutsideActivationDistance || guestConnector.isInActivationDistance(get_worldTransform(snappingGuest), hostSubConnector, get_worldTransform($hostEntity));
  } else {
    tmp = true;
  }
  return tmp;
}
function getMatchingSnapsOnHost$isFree(snappingGuest, hostConnector, hostEntity) {
  if (!(hostConnector instanceof PointConnector))
    return true;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.none' call
    var indexedObject = get_hostedConnections(hostEntity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsOnHost.isFree.<anonymous>' call
      if (element.hostConnectorKey === hostConnector.x2e_1 && element.hostConnectorEntity.equals(hostEntity) && get_isInScene(element.hostConnectorEntity) === get_isInScene(element.guestConnectorEntity) && !equals(get_snapRoot(snappingGuest), get_snapRoot(element.guestConnectorEntity))) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function SnapUtils$Companion$getClosestSnap$lambda($hostEntity, $closestSnapCandidate) {
  return function (snappingGuest) {
    var tmp0_safe_receiver = get_guestConnectors(snappingGuest);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = tmp0_safe_receiver.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.snapping.Companion.getClosestSnap.<anonymous>.<anonymous>' call
        if (element.enabled) {
          destination.h(element);
        }
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = tmp1_safe_receiver.k();
      while (tmp0_iterator_0.m()) {
        var element_0 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.snapping.Companion.getClosestSnap.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = get_hostConnectors($hostEntity);
        var tmp_0;
        if (tmp0_safe_receiver_0 == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList_init_$Create$();
          var tmp0_iterator_1 = tmp0_safe_receiver_0.k();
          while (tmp0_iterator_1.m()) {
            var element_1 = tmp0_iterator_1.n();
            // Inline function 'com.ikea.core.snapping.Companion.getClosestSnap.<anonymous>.<anonymous>.<anonymous>' call
            if (element_1.enabled && element_0.hasMatchingTypeAndDemandsTo(element_1)) {
              destination_0.h(element_1);
            }
          }
          tmp_0 = destination_0;
        }
        var tmp1_safe_receiver_0 = tmp_0;
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var tmp0_iterator_2 = tmp1_safe_receiver_0.k();
          while (tmp0_iterator_2.m()) {
            var element_2 = tmp0_iterator_2.n();
            // Inline function 'com.ikea.core.snapping.Companion.getClosestSnap.<anonymous>.<anonymous>.<anonymous>' call
            var snapCandidate = Companion_instance_137.createCandidate(snappingGuest, element_0, $hostEntity, element_2);
            var tmp0_safe_receiver_1 = $closestSnapCandidate._v;
            var tmp1_safe_receiver_1 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.movement;
            var tmp2_elvis_lhs = tmp1_safe_receiver_1 == null ? null : tmp1_safe_receiver_1.size;
            var currentDistance = tmp2_elvis_lhs == null ? 1.7976931348623157E308 : tmp2_elvis_lhs;
            if (snapCandidate.movement.size < currentDistance) {
              $closestSnapCandidate._v = snapCandidate;
            }
          }
        }
      }
    }
    return Unit_instance;
  };
}
function SnapUtils$Companion$getMatchingAlignmentSnapsOnHost$lambda($hostEntity, $alignmentSnaps) {
  return function (snappingGuest) {
    var tmp0_safe_receiver = get_alignmentConnectors(snappingGuest);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = tmp0_safe_receiver.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.core.snapping.Companion.getMatchingAlignmentSnapsOnHost.<anonymous>.<anonymous>' call
        if (element.enabled) {
          destination.h(element);
        }
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = tmp1_safe_receiver.k();
      while (tmp0_iterator_0.m()) {
        var element_0 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.snapping.Companion.getMatchingAlignmentSnapsOnHost.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = get_connectors($hostEntity);
        var destination_0 = ArrayList_init_$Create$();
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element_1 = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.snapping.Companion.getMatchingAlignmentSnapsOnHost.<anonymous>.<anonymous>.<anonymous>' call
          if (element_1.enabled && element_0.hasMatchingTypeAndDemandsTo(element_1)) {
            destination_0.h(element_1);
          }
        }
        var tmp0_iterator_1 = destination_0.k();
        while (tmp0_iterator_1.m()) {
          var element_2 = tmp0_iterator_1.n();
          // Inline function 'com.ikea.core.snapping.Companion.getMatchingAlignmentSnapsOnHost.<anonymous>.<anonymous>.<anonymous>' call
          $alignmentSnaps.h(Companion_instance_137.createCandidate(snappingGuest, element_0, $hostEntity, element_2));
        }
      }
    }
    return Unit_instance;
  };
}
function SnapUtils$Companion$getMatchingSnapsOnHost$lambda($snapSettings, $hostEntity, $matchingCandidates) {
  return function (snappingGuest) {
    var tmp0_safe_receiver = get_connectorsComponent(snappingGuest);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsOnHost.<anonymous>.<anonymous>' call
        if (!(element.type === Companion_instance_32.m2b_1) && element.enabled && ($snapSettings.includeInternalConnectors || !(element.type === Companion_instance_32.o2b_1))) {
          // Inline function 'kotlin.collections.forEach' call
          var indexedObject = get_connectors($hostEntity);
          var inductionVariable_0 = 0;
          var last_0 = indexedObject.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsOnHost.<anonymous>.<anonymous>.<anonymous>' call
            if (element_0.enabled && element.hasMatchingTypeAndDemandsTo(element_0) && getMatchingSnapsOnHost$isFree(snappingGuest, element_0, $hostEntity)) {
              if (element_0.hasSubConnectors && $snapSettings.includeAllSubConnectors) {
                // Inline function 'kotlin.sequences.forEach' call
                var tmp0_iterator = element_0.u2b().k();
                while (tmp0_iterator.m()) {
                  var element_1 = tmp0_iterator.n();
                  // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsOnHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  if (getMatchingSnapsOnHost$isCloseEnough($snapSettings, $hostEntity, element, snappingGuest, element_1)) {
                    $matchingCandidates.h(Companion_instance_137.createCandidate(snappingGuest, element, $hostEntity, element_1));
                  }
                }
              } else {
                var tmp;
                if (element_0.hasSubConnectors) {
                  tmp = element_0.closestSubConnectorFromOwnerEntity($hostEntity, get_worldTransform(snappingGuest).transformPosition(element.transform.position));
                } else {
                  tmp = element_0;
                }
                var actualHostConnector = tmp;
                if (getMatchingSnapsOnHost$isCloseEnough($snapSettings, $hostEntity, element, snappingGuest, actualHostConnector)) {
                  $matchingCandidates.h(Companion_instance_137.createCandidate(snappingGuest, element, $hostEntity, actualHostConnector));
                }
              }
            }
          }
        }
      }
    }
    return Unit_instance;
  };
}
function SnapUtils$Companion$getMatchingSnapsOnMultipleHosts$lambda() {
  return 'Trying to snap to an empty array of hosts will no longer result in snapping to the scene. If you want the old behaviour you need to call matchingSnapActionCandidatesInScene instead.';
}
function SnapUtils$Companion$getMatchingSnapsOnMultipleHosts$lambda_0($snapsList, $guestSnapRoot, $snapSettings) {
  return function (hostPart) {
    $snapsList.p(Companion_instance_137.d3e($guestSnapRoot, hostPart, $snapSettings));
    return Unit_instance;
  };
}
function SnapUtils$Companion$getSnap$lambda() {
  return 'Cannot create snap, you are probably trying to snap connectors that do not have matching offers/demands.';
}
function Companion_137() {
}
protoOf(Companion_137).i27 = function (entity) {
  return get_snapRoot(entity);
};
protoOf(Companion_137).e3e = function (guestSnapRoot, hostHierarchyRoot) {
  var closestSnapCandidate = null;
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = get_hierarchy(hostHierarchyRoot);
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Companion.getClosestSnapInHierarchy.<anonymous>' call
    var tmp0_safe_receiver = Companion_instance_137.f3e(guestSnapRoot, element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_safe_receiver_0 = closestSnapCandidate;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.movement;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.size;
      var currentDistance = tmp2_elvis_lhs == null ? 1.7976931348623157E308 : tmp2_elvis_lhs;
      if (currentDistance > tmp0_safe_receiver.movement.size)
        closestSnapCandidate = tmp0_safe_receiver;
    }
  }
  return closestSnapCandidate;
};
protoOf(Companion_137).f3e = function (guestSnapRoot, hostEntity) {
  var closestSnapCandidate = {_v: null};
  forEachSnappingHierarchyEntity(guestSnapRoot, SnapUtils$Companion$getClosestSnap$lambda(hostEntity, closestSnapCandidate));
  return closestSnapCandidate._v;
};
protoOf(Companion_137).g3e = function (guestSnapRoot, hostEntity) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var alignmentSnaps = ArrayList_init_$Create$();
  forEachSnappingHierarchyEntity(guestSnapRoot, SnapUtils$Companion$getMatchingAlignmentSnapsOnHost$lambda(hostEntity, alignmentSnaps));
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(alignmentSnaps);
};
protoOf(Companion_137).h3e = function (newEntity, oldEntity) {
  var tmp0_elvis_lhs = Companion_instance_25.x28(oldEntity);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var oldConnection = tmp;
  var oldHostConnector = oldConnection.hostConnector;
  // Inline function 'kotlin.collections.find' call
  var this_0 = get_connectors(newEntity);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.snapping.Companion.getSimilarSnapAsOldEntityExistingConnection.<anonymous>' call
      if (element.key === oldConnection.guestConnectorKey) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.collections.find' call
    var this_1 = get_connectors(newEntity);
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.snapping.Companion.getSimilarSnapAsOldEntityExistingConnection.<anonymous>' call
        if (element_0.hasMatchingTypeAndDemandsTo(oldHostConnector)) {
          tmp$ret$4 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$4 = null;
    }
    tmp_0 = tmp$ret$4;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var tmp2_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var guestConnector = tmp_1;
  var newCandidate = this.f30(newEntity, guestConnector, oldConnection.hostConnectorEntity, oldHostConnector);
  return newCandidate;
};
protoOf(Companion_137).d3e = function (guestSnapRoot, hostEntity, snapSettings) {
  if (hostEntity.equals(guestSnapRoot) || isDescendantOf_0(hostEntity, guestSnapRoot)) {
    return emptyList();
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var matchingCandidates = ArrayList_init_$Create$();
  forEachSnappingHierarchyEntity(guestSnapRoot, SnapUtils$Companion$getMatchingSnapsOnHost$lambda(snapSettings, hostEntity, matchingCandidates));
  return matchingCandidates;
};
protoOf(Companion_137).getMatchingSnapsOnHost$default = function (guestSnapRoot, hostEntity, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
  return $super === VOID ? this.d3e(guestSnapRoot, hostEntity, snapSettings) : $super.d3e.call(this, guestSnapRoot, hostEntity, snapSettings);
};
protoOf(Companion_137).i3e = function (guestSnapRoot, sceneManager, snapSettings) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var result = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = sceneManager.entities;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsInScene.<anonymous>' call
    var tmp;
    if (!element.equals(guestSnapRoot)) {
      var tmp_0;
      var tmp0_safe_receiver = get_connectorsComponent(element);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r27();
      if ((tmp1_safe_receiver == null ? null : any_0(tmp1_safe_receiver)) === true) {
        tmp_0 = true;
      } else {
        var tmp2_safe_receiver = get_connectorsComponent(element);
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2c();
        tmp_0 = (tmp3_safe_receiver == null ? null : any_0(tmp3_safe_receiver)) === true;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = Companion_instance_137.d3e(guestSnapRoot, element, snapSettings).k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsInScene.<anonymous>.<anonymous>' call
        result.h(element_0);
      }
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var snaps = copyToArray(result);
  this.replaceAlignmentSnapsWithRealSnapsWherePossible(snaps);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = snaps.length;
  while (inductionVariable_0 < last_0) {
    var element_1 = snaps[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsInScene.<anonymous>' call
    if (!element_1.isAlignmentSnap) {
      destination.h(element_1);
    }
  }
  return copyToArray(destination);
};
protoOf(Companion_137).getMatchingSnapsInScene$default = function (guestSnapRoot, sceneManager, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
  return $super === VOID ? this.i3e(guestSnapRoot, sceneManager, snapSettings) : $super.i3e.call(this, guestSnapRoot, sceneManager, snapSettings);
};
protoOf(Companion_137).p39 = function (guestSnapRoot, hostEntities, snapSettings) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (hostEntities.length === 0) {
    var tmp = _get_logger__rkp4sl(this);
    tmp.warn(SnapUtils$Companion$getMatchingSnapsOnMultipleHosts$lambda);
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var snapsList = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = hostEntities.length;
  while (inductionVariable < last) {
    var element = hostEntities[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsOnMultipleHosts.<anonymous>' call
    if (snapSettings.includeHostAssemblyParts) {
      var tmp_0 = Companion_getInstance_25().id;
      forEachInHierarchyExceptSubHierarchiesWithComponent_0(element, tmp_0, SnapUtils$Companion$getMatchingSnapsOnMultipleHosts$lambda_0(snapsList, guestSnapRoot, snapSettings));
    } else {
      snapsList.p(Companion_instance_137.d3e(guestSnapRoot, element, snapSettings));
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var snaps = copyToArray(snapsList);
  this.replaceAlignmentSnapsWithRealSnapsWherePossible(snaps);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable_0 = 0;
  var last_0 = snaps.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = snaps[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Companion.getMatchingSnapsOnMultipleHosts.<anonymous>' call
    if (!element_0.isAlignmentSnap) {
      destination.h(element_0);
    }
  }
  return copyToArray(destination);
};
protoOf(Companion_137).getMatchingSnapsOnMultipleHosts$default = function (guestSnapRoot, hostEntities, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
  return $super === VOID ? this.p39(guestSnapRoot, hostEntities, snapSettings) : $super.p39.call(this, guestSnapRoot, hostEntities, snapSettings);
};
protoOf(Companion_137).p1l = function (guestSnapRoot, hostEntity, snapSettings) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [hostEntity];
  return this.p39(guestSnapRoot, tmp$ret$2, snapSettings);
};
protoOf(Companion_137).getMatchingSnaps$default = function (guestSnapRoot, hostEntity, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
  return $super === VOID ? this.p1l(guestSnapRoot, hostEntity, snapSettings) : $super.p1l.call(this, guestSnapRoot, hostEntity, snapSettings);
};
protoOf(Companion_137).f30 = function (snappingGuest, guestConnector, hostEntity, hostConnector) {
  if (guestConnector.hasMatchingTypeAndDemandsTo(hostConnector))
    return this.createCandidate(snappingGuest, guestConnector, hostEntity, hostConnector);
  var tmp = _get_logger__rkp4sl(this);
  tmp.error(SnapUtils$Companion$getSnap$lambda);
  return null;
};
protoOf(Companion_137).c1m = function (hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey) {
  var tmp;
  if (!(connectorOnHostKey == null)) {
    var tmp0_safe_receiver = get_connectorsComponent(hostEntity);
    tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey(connectorOnHostKey);
  } else {
    tmp = null;
  }
  var hostBaseConnector = tmp;
  var tmp1_safe_receiver = get_connectorsComponent(guestEntity);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.connectors;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.snapping.Companion.getForcedSnap.<anonymous>' call
        if (element.key === connectorOnGuestKey) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp_0 = tmp$ret$1;
  }
  var guestConnector = tmp_0;
  var guestTransform = get_worldTransform(guestEntity);
  var tmp_1;
  if (!(hostBaseConnector instanceof PointSeriesSubConnector)) {
    tmp_1 = hostBaseConnector == null ? null : hostBaseConnector.closestSubConnector(get_localTransform(guestEntity).position);
  } else {
    tmp_1 = hostBaseConnector;
  }
  var hostConnector = tmp_1;
  var tmp_2;
  if (hostConnector == null || guestConnector == null) {
    tmp_2 = get_worldTransform(guestEntity);
  } else {
    var tmp4_hostTransform = get_worldTransform(hostEntity);
    tmp_2 = guestConnector.calculateEndTransform(tmp4_hostTransform, hostConnector, guestTransform, guestTransform);
  }
  var forcedEndTransform = tmp_2;
  if (hostConnector == null || guestConnector == null) {
    var forcedHostConnector = new PointConnector('forced', Companion_instance_32.o2b_1, Companion_getInstance_80().c1x_1);
    var tmp5_safe_receiver = hostEntity.__getComponentForKotlin(Companion_instance_21.h1n_1);
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$5 = [forcedHostConnector];
      tmp_3 = tmp5_safe_receiver.plusConnectors(tmp$ret$5);
    }
    var newHostConnectionsComponent = tmp_3;
    if (!(newHostConnectionsComponent == null)) {
      hostEntity.addComponent(newHostConnectionsComponent);
    }
    var forcedGuestConnector = new PointConnector('forced', Companion_instance_32.o2b_1, Companion_getInstance_80().c1x_1);
    var tmp6_safe_receiver = guestEntity.__getComponentForKotlin(Companion_instance_21.h1n_1);
    var tmp_4;
    if (tmp6_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = [forcedGuestConnector];
      tmp_4 = tmp6_safe_receiver.plusConnectors(tmp$ret$8);
    }
    var newGuestConnectorsComponent = tmp_4;
    if (!(newGuestConnectorsComponent == null)) {
      guestEntity.addComponent(newGuestConnectorsComponent);
    }
    var tmp7_elvis_lhs = get_snapRoot(guestEntity);
    return new Snap(hostEntity, guestEntity, tmp7_elvis_lhs == null ? guestEntity : tmp7_elvis_lhs, forcedHostConnector, forcedGuestConnector, guestTransform, forcedEndTransform);
  } else {
    var tmp8_elvis_lhs = get_snapRoot(guestEntity);
    return new Snap(hostEntity, guestEntity, tmp8_elvis_lhs == null ? guestEntity : tmp8_elvis_lhs, hostConnector, guestConnector, guestTransform, forcedEndTransform);
  }
};
protoOf(Companion_137).getForcedSnap$default = function (hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey, $super) {
  connectorOnHostKey = connectorOnHostKey === VOID ? '' : connectorOnHostKey;
  connectorOnGuestKey = connectorOnGuestKey === VOID ? '' : connectorOnGuestKey;
  return $super === VOID ? this.c1m(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey) : $super.c1m.call(this, hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey);
};
protoOf(Companion_137).j3e = function (snappingGuest, guestConnector, hostEntity, hostConnector, forcedEndTransform, forcedPriority, alignmentInitiatorCandidate, initialTransform) {
  var tmp0_elvis_lhs = get_snapRoot(snappingGuest);
  var guestRoot = tmp0_elvis_lhs == null ? snappingGuest : tmp0_elvis_lhs;
  var usedHostConnector = hostConnector.closestSubConnectorFromOwnerAndGuest(hostEntity, snappingGuest, guestConnector);
  var endTransform = forcedEndTransform == null ? guestConnector.calculateEndTransform(get_worldTransform(hostEntity), usedHostConnector, get_worldTransform(snappingGuest), get_worldTransform(guestRoot)) : forcedEndTransform;
  return new Snap(hostEntity, snappingGuest, guestRoot, usedHostConnector, guestConnector, initialTransform == null ? get_worldTransform(guestRoot) : initialTransform, endTransform, forcedPriority, alignmentInitiatorCandidate);
};
protoOf(Companion_137).createCandidate = function (snappingGuest, guestConnector, hostEntity, hostConnector, forcedEndTransform, forcedPriority, alignmentInitiatorCandidate, initialTransform, $super) {
  forcedEndTransform = forcedEndTransform === VOID ? null : forcedEndTransform;
  forcedPriority = forcedPriority === VOID ? null : forcedPriority;
  alignmentInitiatorCandidate = alignmentInitiatorCandidate === VOID ? null : alignmentInitiatorCandidate;
  initialTransform = initialTransform === VOID ? null : initialTransform;
  return this.j3e(snappingGuest, guestConnector, hostEntity, hostConnector, forcedEndTransform, forcedPriority, alignmentInitiatorCandidate, initialTransform);
};
protoOf(Companion_137).replaceAlignmentSnapsWithRealSnapsWherePossible = function (snaps) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = snaps.length;
  while (inductionVariable < last) {
    var element = snaps[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapping.Companion.replaceAlignmentSnapsWithRealSnapsWherePossible.<anonymous>' call
    if (!element.isAlignmentSnap) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.snapping.Companion.replaceAlignmentSnapsWithRealSnapsWherePossible.<anonymous>' call
    if (element_0.hostConnector.isContinuousConnector) {
      destination_0.h(element_0);
    }
  }
  var continuousCandidates = copyToArray(destination_0);
  var inductionVariable_0 = 0;
  var last_0 = snaps.length;
  while (inductionVariable_0 < last_0) {
    var i = inductionVariable_0;
    var snapCandidate = snaps[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    if (snapCandidate.isAlignmentSnap) {
      var tmp0_elvis_lhs = this.k3e(snapCandidate, continuousCandidates);
      snaps[i] = tmp0_elvis_lhs == null ? snapCandidate : tmp0_elvis_lhs;
    }
  }
};
protoOf(Companion_137).k3e = function (alignmentSnap, continuousCandidates) {
  var alternativeRealCandidate = findContinuousAlternativeToAlignment(this, alignmentSnap, continuousCandidates);
  var tmp;
  if (alternativeRealCandidate == null) {
    tmp = null;
  } else {
    var forcedPriority = alignmentSnap.priority;
    tmp = this.createCandidate(alternativeRealCandidate.a3e_1, alternativeRealCandidate.c3e_1, alternativeRealCandidate.z3d_1, alternativeRealCandidate.b3e_1, alignmentSnap.endTransform, forcedPriority, alignmentSnap);
  }
  return tmp;
};
protoOf(Companion_137).isNewPositionOnHostConnector = function (candidate, newPos) {
  return this.isNewTransformOnHostConnector(candidate, candidate.endTransform.copy(newPos));
};
protoOf(Companion_137).isNewTransformOnHostConnector = function (candidate, newEndTransform) {
  var transformFromRootToConnectingEntity = get_worldTransform(candidate.guest).delta(get_worldTransform(candidate.guestRoot));
  var newConnectingEntityTransform = newEndTransform.concatenate(transformFromRootToConnectingEntity);
  var newPositionStillCanConnectToToSameConnector = candidate.hostConnector.containsConnector(get_worldTransform(candidate.host), newConnectingEntityTransform, candidate.guestConnector);
  return newPositionStillCanConnectToToSameConnector;
};
protoOf(Companion_137).f1y = function (snap, entity) {
  var tmp1_elvis_lhs = snap == null ? null : snap.host;
  var mainEntity = tmp1_elvis_lhs == null ? entity : tmp1_elvis_lhs;
  return Companion_instance_62.h29(mainEntity);
};
var Companion_instance_137;
function Companion_getInstance_138() {
  return Companion_instance_137;
}
function snapRoot_0(entity) {
  return Companion_instance_137.i27(entity);
}
function getClosestSnapInHierarchy(guestSnapRoot, hostHierarchyRoot) {
  return Companion_instance_137.e3e(guestSnapRoot, hostHierarchyRoot);
}
function getClosestSnap(guestSnapRoot, hostEntity) {
  return Companion_instance_137.f3e(guestSnapRoot, hostEntity);
}
function getMatchingAlignmentSnapsOnHost(guestSnapRoot, hostEntity) {
  return Companion_instance_137.g3e(guestSnapRoot, hostEntity);
}
function getSimilarSnapAsOldEntityExistingConnection(newEntity, oldEntity) {
  return Companion_instance_137.h3e(newEntity, oldEntity);
}
function getMatchingSnapsInScene(guestSnapRoot, sceneManager, snapSettings) {
  return Companion_instance_137.i3e(guestSnapRoot, sceneManager, snapSettings);
}
function getMatchingSnapsInScene_0(guestSnapRoot, sceneManager, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
  return getMatchingSnapsInScene(guestSnapRoot, sceneManager, snapSettings);
}
function getMatchingSnapsOnMultipleHosts(guestSnapRoot, hostEntities, snapSettings) {
  return Companion_instance_137.p39(guestSnapRoot, hostEntities, snapSettings);
}
function getMatchingSnapsOnMultipleHosts_0(guestSnapRoot, hostEntities, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
  return getMatchingSnapsOnMultipleHosts(guestSnapRoot, hostEntities, snapSettings);
}
function getMatchingSnaps(guestSnapRoot, hostEntity, snapSettings) {
  return Companion_instance_137.p1l(guestSnapRoot, hostEntity, snapSettings);
}
function getMatchingSnaps_0(guestSnapRoot, hostEntity, snapSettings, $super) {
  snapSettings = snapSettings === VOID ? new SnapSettings() : snapSettings;
  return getMatchingSnaps(guestSnapRoot, hostEntity, snapSettings);
}
function getSnap_0(snappingGuest, guestConnector, hostEntity, hostConnector) {
  return Companion_instance_137.f30(snappingGuest, guestConnector, hostEntity, hostConnector);
}
function getForcedSnap(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey) {
  return Companion_instance_137.c1m(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey);
}
function getForcedSnap_0(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey, $super) {
  connectorOnHostKey = connectorOnHostKey === VOID ? '' : connectorOnHostKey;
  connectorOnGuestKey = connectorOnGuestKey === VOID ? '' : connectorOnGuestKey;
  return getForcedSnap(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey);
}
function tryToReplaceAlignmentSnapWithRealSnap(alignmentSnap, continuousCandidates) {
  return Companion_instance_137.k3e(alignmentSnap, continuousCandidates);
}
function SnapUtils() {
}
function EntityState(entityId, components) {
  var tmp;
  if (components === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = components;
  }
  components = tmp;
  this.entityId = entityId;
  this.l3e_1 = new ComponentHolder();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = components.length;
  while (inductionVariable < last) {
    var element = components[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapshot.EntityState.<anonymous>' call
    this.l3e_1.e2k(element);
  }
}
protoOf(EntityState).m3e = function () {
  return this.entityId;
};
protoOf(EntityState).components = function () {
  return this.l3e_1.c2k();
};
protoOf(EntityState).getComponent = function (componentId) {
  return this.l3e_1.__getComponentForKotlin(componentId);
};
protoOf(EntityState).hasComponent = function (componentId) {
  return this.l3e_1.g2k(componentId);
};
protoOf(EntityState).toString = function () {
  return 'Entity ' + this.entityId;
};
function Companion_138() {
}
protoOf(Companion_138).n1s = function () {
  return Companion_instance_21.g1o_1;
};
var Companion_instance_138;
function Companion_getInstance_139() {
  return Companion_instance_138;
}
function IsLoadingSnapshotComponent() {
  this.n3e_1 = false;
}
protoOf(IsLoadingSnapshotComponent).p1s = function () {
  return Companion_instance_138.id;
};
protoOf(IsLoadingSnapshotComponent).s1s = function () {
  return this.n3e_1;
};
protoOf(IsLoadingSnapshotComponent).eq = function (other) {
  return true;
};
function Companion_139() {
  Companion_instance_139 = this;
  this.ID = Companion_instance_21.m1q_1;
}
protoOf(Companion_139).j1y = function () {
  return this.ID;
};
var Companion_instance_139;
function Companion_getInstance_140() {
  if (Companion_instance_139 == null)
    new Companion_139();
  return Companion_instance_139;
}
function SnapshotIgnoreComponent() {
  Companion_getInstance_140();
  this.o3e_1 = Companion_getInstance_140().ID;
}
protoOf(SnapshotIgnoreComponent).p1s = function () {
  return this.o3e_1;
};
protoOf(SnapshotIgnoreComponent).eq = function (other) {
  return true;
};
function setExistingEntityStates($this, snapshot) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = snapshot.p3e().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.snapshot.SnapshotService.setExistingEntityStates.<anonymous>' call
    var currentEntity = $this.entityManager.findEntity(element.entityId);
    var entityStateBeforeLoadingSnapshot = currentEntity == null ? null : new EntityState(element.entityId, currentEntity.components());
    var tmp1_safe_receiver = currentEntity == null ? null : currentEntity.components();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element_0 = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.snapshot.SnapshotService.setExistingEntityStates.<anonymous>.<anonymous>' call
        if (element_0.doStoreInSnapshot) {
          destination.h(element_0);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = tmp2_safe_receiver.k();
      while (tmp0_iterator_0.m()) {
        var element_1 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.snapshot.SnapshotService.setExistingEntityStates.<anonymous>.<anonymous>' call
        currentEntity.removeComponentInternal(element_1.typeId);
      }
    }
    var entityAfterSnapshot = currentEntity == null ? $this.entityManager.createEntityInternal(element.entityId) : currentEntity;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = element.components();
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var element_2 = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.snapshot.SnapshotService.setExistingEntityStates.<anonymous>.<anonymous>' call
      entityAfterSnapshot.addComponentInternal(element_2);
    }
    entityAfterSnapshot.addComponent(new UpdatedFromSnapshotEventComponent(entityStateBeforeLoadingSnapshot, entityAfterSnapshot));
    entityAfterSnapshot.removeComponent(Companion_getInstance_142().q3e_1);
  }
}
function removeEntitiesNoLongerPresent($this, snapshot) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.entityManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>' call
    if (!element.hasComponent(Companion_getInstance_140().ID)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element_0 = tmp0_iterator.n();
    // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>' call
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var this_1 = snapshot.p3e();
      var tmp;
      if (isInterface(this_1, Collection)) {
        tmp = this_1.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$3 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_1.k();
      while (tmp0_iterator_0.m()) {
        var element_1 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>.<anonymous>' call
        if (element_1.entityId === element_0.id) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
      }
      tmp$ret$3 = true;
    }
    if (tmp$ret$3) {
      destination_0.h(element_0);
    }
  }
  var entitiesToRemove = destination_0;
  var tmp_0 = Companion_getInstance_141().logger;
  tmp_0.debug(SnapshotService$removeEntitiesNoLongerPresent$lambda(entitiesToRemove));
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_1 = entitiesToRemove.k();
  while (tmp0_iterator_1.m()) {
    var element_2 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>' call
    element_2.addComponent(new UpdatedFromSnapshotEventComponent(createEntityState($this, element_2), null));
    element_2.removeComponent(Companion_getInstance_142().q3e_1);
    $this.entityManager.removeEntityInternal(element_2);
  }
}
function createEntityState($this, entity) {
  return new EntityState(entity.id, entity.components());
}
function Companion_140() {
  Companion_instance_140 = this;
  this.logger = LoggerState_getInstance().g1v('SnapshotService');
}
protoOf(Companion_140).l1k = function () {
  return this.logger;
};
var Companion_instance_140;
function Companion_getInstance_141() {
  if (Companion_instance_140 == null)
    new Companion_140();
  return Companion_instance_140;
}
function SnapshotService$removeEntitiesNoLongerPresent$lambda($entitiesToRemove) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $entitiesToRemove;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.core.snapshot.SnapshotService.removeEntitiesNoLongerPresent.<anonymous>.<anonymous>' call
      destination.h(item);
    }
    return 'Will remove entities when loading snapshot: ' + toString_0(destination);
  };
}
function SnapshotService(entityManager, sceneManager) {
  Companion_getInstance_141();
  this.entityManager = entityManager;
  this.sceneManager = sceneManager;
}
protoOf(SnapshotService).c1k = function () {
  return this.entityManager;
};
protoOf(SnapshotService).d1k = function () {
  return this.sceneManager;
};
protoOf(SnapshotService).takeSnapshot = function (name) {
  if (this.sceneManager.root.hasComponent(Companion_instance_138.id)) {
    // Inline function 'kotlin.error' call
    var message = 'Not allowed to take snapshot while another snapshot is being loaded.';
    throw IllegalStateException_init_$Create$(toString_0(message));
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.entityManager.entities;
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.core.snapshot.SnapshotService.takeSnapshot.<anonymous>' call
    if (!element.hasComponent(Companion_getInstance_140().ID)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.snapshot.SnapshotService.takeSnapshot.<anonymous>' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = item.components();
    var destination_1 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.snapshot.SnapshotService.takeSnapshot.<anonymous>.<anonymous>' call
      if (element_0.doStoreInSnapshot) {
        destination_1.h(element_0);
      }
    }
    var clonedComponents = copyToArray(destination_1);
    var tmp$ret$7 = new EntityState(item.id, clonedComponents);
    destination_0.h(tmp$ret$7);
  }
  var entityStates = destination_0;
  return new SnapshotImpl(name, entityStates);
};
protoOf(SnapshotService).compare = function (snapshot1, snapshot2) {
  println(snapshot1);
  println(snapshot2);
};
protoOf(SnapshotService).loadSnapshot = function (snapshot) {
  this.sceneManager.root.addComponent(new IsLoadingSnapshotComponent());
  removeEntitiesNoLongerPresent(this, snapshot);
  setExistingEntityStates(this, snapshot);
  this.sceneManager.root.removeComponent(Companion_instance_138.id);
};
function Snapshot() {
}
function SnapshotImpl(name, entityStates) {
  this.s3e_1 = name;
  this.t3e_1 = entityStates;
}
protoOf(SnapshotImpl).v2 = function () {
  return this.s3e_1;
};
protoOf(SnapshotImpl).p3e = function () {
  return this.t3e_1;
};
protoOf(SnapshotImpl).r3e = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.t3e_1;
  return copyToArray(this_0);
};
protoOf(SnapshotImpl).toString = function () {
  return 'SnapshotImpl(name=' + this.s3e_1 + ', entityStates=' + toString_0(this.t3e_1) + ')';
};
protoOf(SnapshotImpl).hashCode = function () {
  var result = getStringHashCode(this.s3e_1);
  result = imul(result, 31) + hashCode(this.t3e_1) | 0;
  return result;
};
protoOf(SnapshotImpl).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SnapshotImpl))
    return false;
  var tmp0_other_with_cast = other instanceof SnapshotImpl ? other : THROW_CCE();
  if (!(this.s3e_1 === tmp0_other_with_cast.s3e_1))
    return false;
  if (!equals(this.t3e_1, tmp0_other_with_cast.t3e_1))
    return false;
  return true;
};
function Companion_141() {
  Companion_instance_141 = this;
  this.q3e_1 = Companion_instance_21.n1r_1;
}
protoOf(Companion_141).n1s = function () {
  return this.q3e_1;
};
var Companion_instance_141;
function Companion_getInstance_142() {
  if (Companion_instance_141 == null)
    new Companion_141();
  return Companion_instance_141;
}
function get_id_3() {
  return Companion_getInstance_142().q3e_1;
}
function UpdatedFromSnapshotEventComponent(entityStateBeforeLoadingSnapshot, entity) {
  Companion_getInstance_142();
  this.entityStateBeforeLoadingSnapshot = entityStateBeforeLoadingSnapshot;
  this.entity = entity;
  this.b32_1 = Companion_getInstance_142().q3e_1;
  this.c32_1 = false;
}
protoOf(UpdatedFromSnapshotEventComponent).u3e = function () {
  return this.entityStateBeforeLoadingSnapshot;
};
protoOf(UpdatedFromSnapshotEventComponent).v2i = function () {
  return this.entity;
};
protoOf(UpdatedFromSnapshotEventComponent).p1s = function () {
  return this.b32_1;
};
protoOf(UpdatedFromSnapshotEventComponent).eq = function (other) {
  return false;
};
protoOf(UpdatedFromSnapshotEventComponent).s1s = function () {
  return this.c32_1;
};
protoOf(UpdatedFromSnapshotEventComponent).tf = function () {
  return this.entityStateBeforeLoadingSnapshot;
};
protoOf(UpdatedFromSnapshotEventComponent).uf = function () {
  return this.entity;
};
protoOf(UpdatedFromSnapshotEventComponent).v3e = function (entityStateBeforeLoadingSnapshot, entity) {
  return new UpdatedFromSnapshotEventComponent(entityStateBeforeLoadingSnapshot, entity);
};
protoOf(UpdatedFromSnapshotEventComponent).copy = function (entityStateBeforeLoadingSnapshot, entity, $super) {
  entityStateBeforeLoadingSnapshot = entityStateBeforeLoadingSnapshot === VOID ? this.entityStateBeforeLoadingSnapshot : entityStateBeforeLoadingSnapshot;
  entity = entity === VOID ? this.entity : entity;
  return this.v3e(entityStateBeforeLoadingSnapshot, entity);
};
protoOf(UpdatedFromSnapshotEventComponent).toString = function () {
  return 'UpdatedFromSnapshotEventComponent(entityStateBeforeLoadingSnapshot=' + toString(this.entityStateBeforeLoadingSnapshot) + ', entity=' + toString(this.entity) + ')';
};
protoOf(UpdatedFromSnapshotEventComponent).hashCode = function () {
  var result = this.entityStateBeforeLoadingSnapshot == null ? 0 : hashCode(this.entityStateBeforeLoadingSnapshot);
  result = imul(result, 31) + (this.entity == null ? 0 : this.entity.hashCode()) | 0;
  return result;
};
protoOf(UpdatedFromSnapshotEventComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UpdatedFromSnapshotEventComponent))
    return false;
  var tmp0_other_with_cast = other instanceof UpdatedFromSnapshotEventComponent ? other : THROW_CCE();
  if (!equals(this.entityStateBeforeLoadingSnapshot, tmp0_other_with_cast.entityStateBeforeLoadingSnapshot))
    return false;
  if (!equals(this.entity, tmp0_other_with_cast.entity))
    return false;
  return true;
};
function Companion_142() {
  Companion_instance_142 = this;
  this.h1v_1 = Companion_getInstance_60().j2a_1;
  this.i1v_1 = Companion_getInstance_54().ID;
  this.j1v_1 = Companion_instance_61.ID;
  this.k1v_1 = Companion_instance_65.h2t_1;
  this.l1v_1 = Companion_instance_145.ID;
  this.m1v_1 = Companion_instance_35.ID;
  this.n1v_1 = Companion_instance_97.i32_1;
  this.o1v_1 = Companion_instance_19.u1y_1;
  this.p1v_1 = 'ProductParamsSystem';
  this.q1v_1 = 'ViewerPresenceSystem';
  this.r1v_1 = 'ModelLoaderSystem';
  this.s1v_1 = 'ViewerObjectTransformSystem';
  this.t1v_1 = 'ViewerObjectVisibilitySystem';
}
protoOf(Companion_142).w3e = function () {
  return this.h1v_1;
};
protoOf(Companion_142).x3e = function () {
  return this.i1v_1;
};
protoOf(Companion_142).y3e = function () {
  return this.j1v_1;
};
protoOf(Companion_142).z3e = function () {
  return this.k1v_1;
};
protoOf(Companion_142).a3f = function () {
  return this.l1v_1;
};
protoOf(Companion_142).b3f = function () {
  return this.m1v_1;
};
protoOf(Companion_142).c3f = function () {
  return this.n1v_1;
};
protoOf(Companion_142).d3f = function () {
  return this.o1v_1;
};
protoOf(Companion_142).e3f = function () {
  return this.p1v_1;
};
protoOf(Companion_142).f3f = function () {
  return this.q1v_1;
};
protoOf(Companion_142).g3f = function () {
  return this.r1v_1;
};
protoOf(Companion_142).h3f = function () {
  return this.s1v_1;
};
protoOf(Companion_142).i3f = function () {
  return this.t1v_1;
};
var Companion_instance_142;
function Companion_getInstance_143() {
  if (Companion_instance_142 == null)
    new Companion_142();
  return Companion_instance_142;
}
function get_CONNECTION_PARENTING_SYSTEM_ID() {
  return Companion_getInstance_143().h1v_1;
}
function get_AUTOMATIC_GROUP_BUILDER_SYSTEM_ID() {
  return Companion_getInstance_143().i1v_1;
}
function get_HIERARCHY_SYSTEM_ID() {
  return Companion_getInstance_143().j1v_1;
}
function get_SCENE_GRAPH_SYSTEM_ID() {
  return Companion_getInstance_143().k1v_1;
}
function get_TRANSFORM_SYSTEM_ID() {
  return Companion_getInstance_143().l1v_1;
}
function get_DISABLE_CONNECTORS_SYSTEM_ID() {
  return Companion_getInstance_143().m1v_1;
}
function get_RENDER_SYSTEM_ID() {
  return Companion_getInstance_143().n1v_1;
}
function get_WORLD_COLLIDER_UPDATE_SYSTEM_ID() {
  return Companion_getInstance_143().o1v_1;
}
function get_PRODUCT_RESIZING_SYSTEM_ID() {
  return Companion_getInstance_143().p1v_1;
}
function get_VIEWER_PRESENCE_SYSTEM_ID() {
  return Companion_getInstance_143().q1v_1;
}
function get_MODEL_LOADER_SYSTEM_ID() {
  return Companion_getInstance_143().r1v_1;
}
function get_VIEWER_OBJECT_TRANSFORM_SYSTEM_ID() {
  return Companion_getInstance_143().s1v_1;
}
function get_VIEWER_OBJECT_VISIBILITY_SYSTEM_ID() {
  return Companion_getInstance_143().t1v_1;
}
function ApiSystemIds() {
  Companion_getInstance_143();
}
function AlwaysHangDownComponent_0() {
}
protoOf(AlwaysHangDownComponent_0).p1s = function () {
  return this.id;
};
protoOf(AlwaysHangDownComponent_0).n1s = function () {
  return Companion_instance_21.w1n_1;
};
protoOf(AlwaysHangDownComponent_0).eq = function (other) {
  return true;
};
var AlwaysHangDownComponent_instance;
function AlwaysHangDownComponent_getInstance() {
  return AlwaysHangDownComponent_instance;
}
function get_isHanging(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(AlwaysHangDownComponent_instance.id);
}
function Companion_143() {
}
protoOf(Companion_143).z18 = function () {
  return $serializer_getInstance_15();
};
var Companion_instance_143;
function Companion_getInstance_144() {
  return Companion_instance_143;
}
function $serializer_15() {
  $serializer_instance_15 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.transforms.LocalTransformComponent.Serialized', this, 2);
  tmp0_serialDesc.lw('p', false);
  tmp0_serialDesc.lw('r', false);
  this.j3f_1 = tmp0_serialDesc;
}
protoOf($serializer_15).k3f = function (encoder, value) {
  var tmp0_desc = this.j3f_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.sq(tmp0_desc, 0, $serializer_getInstance_8(), value.l3f_1);
  tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance_4(), value.m3f_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_15).ul = function (encoder, value) {
  return this.k3f(encoder, value instanceof Serialized_0 ? value : THROW_CCE());
};
protoOf($serializer_15).vl = function (decoder) {
  var tmp0_desc = this.j3f_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return Serialized_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_15).tl = function () {
  return this.j3f_1;
};
protoOf($serializer_15).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_8(), $serializer_getInstance_4()];
};
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 == null)
    new $serializer_15();
  return $serializer_instance_15;
}
function Serialized_init_$Init$_0(seen0, p, r, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_15().j3f_1);
  }
  $this.l3f_1 = p;
  $this.m3f_1 = r;
  return $this;
}
function Serialized_init_$Create$_0(seen0, p, r, serializationConstructorMarker) {
  return Serialized_init_$Init$_0(seen0, p, r, serializationConstructorMarker, objectCreate(protoOf(Serialized_0)));
}
function LocalTransformComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function LocalTransformComponent_init_$Init$(pos, rot, $this) {
  LocalTransformComponent.call($this, new Transform(pos, rot));
  return $this;
}
function LocalTransformComponentFromPosAndRot(pos, rot) {
  return LocalTransformComponent_init_$Init$(pos, rot, objectCreate(protoOf(LocalTransformComponent)));
}
function Serialized_0(p, r) {
  this.l3f_1 = p;
  this.m3f_1 = r;
}
function Companion_144() {
  Companion_instance_144 = this;
  this.id = Companion_instance_21.c1n_1;
  this.IDENTITY = LocalTransformComponentFromPosAndRot(Companion_getInstance_81().ZERO, Companion_getInstance_74().q2b_1);
  this.serializationKey = 'LocalTransformComponent';
  var tmp = this;
  tmp.n2q_1 = Json(VOID, LocalTransformComponent$Companion$serializer$lambda);
}
protoOf(Companion_144).n1s = function () {
  return this.id;
};
protoOf(Companion_144).n2w = function () {
  return this.IDENTITY;
};
protoOf(Companion_144).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_144).x1s = function (json) {
  var result = this.n2q_1.y16(Companion_instance_143.z18(), json);
  return new LocalTransformComponent(new Transform(result.l3f_1, result.m3f_1));
};
var Companion_instance_144;
function Companion_getInstance_145() {
  if (Companion_instance_144 == null)
    new Companion_144();
  return Companion_instance_144;
}
function LocalTransformComponent(transform) {
  Companion_getInstance_145();
  this.transform = transform;
  this.n3f_1 = false;
}
protoOf(LocalTransformComponent).z2a = function () {
  return this.transform;
};
protoOf(LocalTransformComponent).toJson = function (parse) {
  return Companion_getInstance_145().n2q_1.x16(Companion_instance_143.z18(), new Serialized_0(this.transform.position, this.transform.rotation));
};
protoOf(LocalTransformComponent).serializationKey = function () {
  return Companion_getInstance_145().serializationKey;
};
protoOf(LocalTransformComponent).r1s = function () {
  return this.n3f_1;
};
protoOf(LocalTransformComponent).p1s = function () {
  return Companion_getInstance_145().id;
};
protoOf(LocalTransformComponent).hashCode = function () {
  return this.transform.hashCode();
};
protoOf(LocalTransformComponent).equals = function (other) {
  var tmp;
  if (other instanceof LocalTransformComponent) {
    tmp = this.transform.equals(other.transform);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(LocalTransformComponent).eq = function (other) {
  var otherLoc = other instanceof LocalTransformComponent ? other : THROW_CCE();
  return this.transform.equals(otherLoc.transform);
};
protoOf(LocalTransformComponent).moveInParentSpace = function (v) {
  return LocalTransformComponentFromPosAndRot(this.transform.position.plus(v), this.transform.rotation);
};
protoOf(LocalTransformComponent).applyMoveInParentSpace = function (entity, v) {
  if (v.notZero()) {
    entity.addComponent(this.moveInParentSpace(v));
  }
  return entity;
};
protoOf(LocalTransformComponent).o3f = function (q) {
  return LocalTransformComponentFromPosAndRot(this.transform.position, this.transform.rotation.times(q));
};
protoOf(LocalTransformComponent).rotate = function (entity, q) {
  if (!q.isIdentity) {
    if (this.transform.rotation.isIdentity)
      entity.addComponent(LocalTransformComponentFromPosAndRot(this.transform.position, q));
    else {
      entity.addComponent(this.o3f(q));
    }
  }
  return entity;
};
protoOf(LocalTransformComponent).transformToWorld = function (me) {
  var tmp0_safe_receiver = get_parent(me);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.transforms.LocalTransformComponent.transformToWorld.<anonymous>' call
    var tmp_0;
    if (this.transform.position.isZero() && this.transform.rotation.isIdentity) {
      tmp_0 = get_worldTransform(tmp0_safe_receiver);
    } else {
      var parentWorld = get_worldTransform(tmp0_safe_receiver);
      var worldPos = parentWorld.transformPosition(this.transform.position);
      var worldRot = this.transform.rotation.times(parentWorld.rotation);
      tmp_0 = new Transform(worldPos, worldRot);
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? this.transform : tmp1_elvis_lhs;
};
protoOf(LocalTransformComponent).tf = function () {
  return this.transform;
};
protoOf(LocalTransformComponent).p3f = function (transform) {
  return new LocalTransformComponent(transform);
};
protoOf(LocalTransformComponent).copy = function (transform, $super) {
  transform = transform === VOID ? this.transform : transform;
  return this.p3f(transform);
};
protoOf(LocalTransformComponent).toString = function () {
  return 'LocalTransformComponent(transform=' + this.transform.toString() + ')';
};
function get_localTransform(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_145().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.transform;
  return tmp1_elvis_lhs == null ? Companion_getInstance_80().c1x_1 : tmp1_elvis_lhs;
}
function Companion_145() {
  this.ID = 'TransformSystem';
}
protoOf(Companion_145).j1y = function () {
  return this.ID;
};
var Companion_instance_145;
function Companion_getInstance_146() {
  return Companion_instance_145;
}
function TransformSystem() {
  var tmp = Companion_instance_21.c1n_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [Companion_instance_21.g1n_1];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [Companion_instance_61.ID];
  SystemBase.call(this, 'TransformSystem', tmp, tmp_0, tmp$ret$5, null);
}
protoOf(TransformSystem).z3f = function (entity, newComponent) {
  Companion_instance_146.z37(entity);
};
protoOf(TransformSystem).v1v = function (entity, newComponent) {
  return this.z3f(entity, newComponent instanceof LocalTransformComponent ? newComponent : THROW_CCE());
};
protoOf(TransformSystem).a3g = function (entity, oldComponent, newComponent) {
  Companion_instance_146.z37(entity);
};
protoOf(TransformSystem).x1v = function (entity, oldComponent, newComponent) {
  var tmp = oldComponent instanceof LocalTransformComponent ? oldComponent : THROW_CCE();
  return this.a3g(entity, tmp, newComponent instanceof LocalTransformComponent ? newComponent : THROW_CCE());
};
protoOf(TransformSystem).b3g = function (entity, oldComponent) {
};
protoOf(TransformSystem).z1v = function (entity, oldComponent) {
  return this.b3g(entity, oldComponent instanceof LocalTransformComponent ? oldComponent : THROW_CCE());
};
function Companion_146() {
}
protoOf(Companion_146).c3g = function (entity) {
  return get_worldTransform(entity);
};
protoOf(Companion_146).d3g = function (entity) {
  return get_localTransform(entity);
};
protoOf(Companion_146).e3g = function (entity) {
  return get_worldPosition(entity);
};
protoOf(Companion_146).f3g = function (entity) {
  return get_localTransform(entity).position;
};
protoOf(Companion_146).g3g = function (entity) {
  return get_worldRotation(entity);
};
protoOf(Companion_146).h30 = function (entity, rotation) {
  var localTransform = get_localTransform(entity);
  localTransform = new Transform(localTransform.position, localTransform.rotation.times(rotation));
  var localTransformComponent = new LocalTransformComponent(localTransform);
  entity.addComponent(localTransformComponent);
};
protoOf(Companion_146).g30 = function (entity, v) {
  var localTransformComponent = LocalTransformComponentFromPosAndRot(get_localTransform(entity).position.plus(v), get_localTransform(entity).rotation);
  entity.addComponent(localTransformComponent);
};
protoOf(Companion_146).h3g = function (entity, v) {
  var localV = v.rotate(get_localTransform(entity).rotation);
  var localTransformComponent = LocalTransformComponentFromPosAndRot(get_localTransform(entity).position.plus(localV), get_localTransform(entity).rotation);
  entity.addComponent(localTransformComponent);
};
protoOf(Companion_146).i3g = function (entity, v) {
  var newWorldPos = get_worldPosition(entity).plus(v);
  this.z1l(entity, new Transform(newWorldPos, get_worldRotation(entity)));
};
protoOf(Companion_146).z37 = function (entity) {
  var newWorld = Companion_getInstance_149().calculate(entity);
  if (!entity.hasComponent(Companion_getInstance_149().id) || !newWorld.transform.equals(get_worldTransform(entity))) {
    entity.addComponent(newWorld);
    var tmp0_safe_receiver = get_parentComponent(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allDescendants();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.transforms.Companion.updateWorldTransform.<anonymous>' call
        Companion_instance_146.z37(element);
      }
    }
  }
};
protoOf(Companion_146).v1y = function (polyhedron, entity) {
  return polyhedron.transform(get_worldTransform(entity));
};
protoOf(Companion_146).j3g = function (entity, position) {
  var old = get_localTransform(entity);
  this.b1m(entity, new Transform(position, old.rotation));
};
protoOf(Companion_146).k3g = function (entity, rotation) {
  var old = get_localTransform(entity);
  this.b1m(entity, new Transform(old.position, rotation));
};
protoOf(Companion_146).b1m = function (entity, transform) {
  entity.addComponent(new LocalTransformComponent(transform));
};
protoOf(Companion_146).z1l = function (entity, transform) {
  var tmp0_safe_receiver = get_parent(entity);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
  var parentTransform = tmp1_elvis_lhs == null ? Companion_getInstance_80().c1x_1 : tmp1_elvis_lhs;
  var relativePosition = parentTransform.inverseTransformPosition(transform.position);
  var relativeRotation = transform.rotation.times(parentTransform.rotation.inverse());
  var newLocalTransform = new Transform(relativePosition, relativeRotation);
  this.b1m(entity, newLocalTransform);
};
protoOf(Companion_146).b2i = function (normalizedNormal, center) {
  var upProjection = normalizedNormal.dot(Companion_getInstance_81().UP);
  var up = upProjection < -0.999 ? Companion_getInstance_81().BACK : upProjection > 0.999 ? Companion_getInstance_81().FORWARD : Companion_getInstance_81().UP;
  var rotation = Companion_getInstance_74().fromEulerDegrees$default(new Degrees(90.0)).times(Companion_getInstance_74().r2v(normalizedNormal.unaryMinus(), up));
  return new Transform(center, rotation);
};
protoOf(Companion_146).l3g = function (entity, position) {
  this.z1l(entity, new Transform(position, get_worldRotation(entity)));
};
var Companion_instance_146;
function Companion_getInstance_147() {
  return Companion_instance_146;
}
function worldTransform(entity) {
  return Companion_instance_146.c3g(entity);
}
function localTransform(entity) {
  return Companion_instance_146.d3g(entity);
}
function worldPosition(entity) {
  return Companion_instance_146.e3g(entity);
}
function localPosition(entity) {
  return Companion_instance_146.f3g(entity);
}
function worldRotation(entity) {
  return Companion_instance_146.g3g(entity);
}
function rotate(entity, rotation) {
  return Companion_instance_146.h30(entity, rotation);
}
function moveInParentSpace(entity, v) {
  return Companion_instance_146.g30(entity, v);
}
function moveInLocalSpace(entity, v) {
  return Companion_instance_146.h3g(entity, v);
}
function moveInWorldSpace(entity, v) {
  return Companion_instance_146.i3g(entity, v);
}
function updateWorldTransform(entity) {
  return Companion_instance_146.z37(entity);
}
function applyWorldTransform(polyhedron, entity) {
  return Companion_instance_146.v1y(polyhedron, entity);
}
function setLocalPosition(entity, position) {
  return Companion_instance_146.j3g(entity, position);
}
function setLocalRotation(entity, rotation) {
  return Companion_instance_146.k3g(entity, rotation);
}
function setLocalTransform(entity, transform) {
  return Companion_instance_146.b1m(entity, transform);
}
function setWorldTransform(entity, transform) {
  return Companion_instance_146.z1l(entity, transform);
}
function transformForSurface(normalizedNormal, center) {
  return Companion_instance_146.b2i(normalizedNormal, center);
}
function setWorldPosition(entity, position) {
  return Companion_instance_146.l3g(entity, position);
}
function TransformUtils() {
}
function Companion_147() {
}
protoOf(Companion_147).z18 = function () {
  return $serializer_getInstance_16();
};
var Companion_instance_147;
function Companion_getInstance_148() {
  return Companion_instance_147;
}
function $serializer_16() {
  $serializer_instance_16 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.transforms.WorldTransformComponent.Serialized', this, 2);
  tmp0_serialDesc.lw('p', false);
  tmp0_serialDesc.lw('r', false);
  this.m3g_1 = tmp0_serialDesc;
}
protoOf($serializer_16).n3g = function (encoder, value) {
  var tmp0_desc = this.m3g_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.sq(tmp0_desc, 0, $serializer_getInstance_8(), value.o3g_1);
  tmp1_output.sq(tmp0_desc, 1, $serializer_getInstance_4(), value.p3g_1);
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_16).ul = function (encoder, value) {
  return this.n3g(encoder, value instanceof Serialized_1 ? value : THROW_CCE());
};
protoOf($serializer_16).vl = function (decoder) {
  var tmp0_desc = this.m3g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.bp(tmp0_desc);
  if (tmp6_input.rp()) {
    tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.np(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.np(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.cp(tmp0_desc);
  return Serialized_init_$Create$_1(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_16).tl = function () {
  return this.m3g_1;
};
protoOf($serializer_16).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_8(), $serializer_getInstance_4()];
};
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 == null)
    new $serializer_16();
  return $serializer_instance_16;
}
function Serialized_init_$Init$_1(seen0, p, r, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_16().m3g_1);
  }
  $this.o3g_1 = p;
  $this.p3g_1 = r;
  return $this;
}
function Serialized_init_$Create$_1(seen0, p, r, serializationConstructorMarker) {
  return Serialized_init_$Init$_1(seen0, p, r, serializationConstructorMarker, objectCreate(protoOf(Serialized_1)));
}
function WorldTransformComponent$Companion$serializer$lambda($this$Json) {
  $this$Json.s17_1 = false;
  $this$Json.u17_1 = true;
  return Unit_instance;
}
function WorldTransformComponent_init_$Init$(pos, rot, $this) {
  WorldTransformComponent.call($this, new Transform(pos, rot));
  return $this;
}
function WorldTransformComponentFromPosAndRot(pos, rot) {
  return WorldTransformComponent_init_$Init$(pos, rot, objectCreate(protoOf(WorldTransformComponent)));
}
function Serialized_1(p, r) {
  this.o3g_1 = p;
  this.p3g_1 = r;
}
function Companion_148() {
  Companion_instance_148 = this;
  this.id = Companion_instance_21.g1n_1;
  this.IDENTITY = WorldTransformComponentFromPosAndRot(Companion_getInstance_81().ZERO, Companion_getInstance_74().q2b_1);
  this.serializationKey = 'WorldTransformComponent';
  var tmp = this;
  tmp.a1m_1 = Json(VOID, WorldTransformComponent$Companion$serializer$lambda);
}
protoOf(Companion_148).n1s = function () {
  return this.id;
};
protoOf(Companion_148).n2w = function () {
  return this.IDENTITY;
};
protoOf(Companion_148).calculate = function (entity) {
  var tmp0_elvis_lhs = entity.__getComponentForKotlin(Companion_getInstance_145().id);
  var local = tmp0_elvis_lhs == null ? Companion_getInstance_145().IDENTITY : tmp0_elvis_lhs;
  var world = local.transformToWorld(entity);
  return new WorldTransformComponent(world);
};
protoOf(Companion_148).w1s = function () {
  return this.serializationKey;
};
protoOf(Companion_148).x1s = function (json) {
  var result = this.a1m_1.y16(Companion_instance_147.z18(), json);
  return new WorldTransformComponent(new Transform(result.o3g_1, result.p3g_1));
};
var Companion_instance_148;
function Companion_getInstance_149() {
  if (Companion_instance_148 == null)
    new Companion_148();
  return Companion_instance_148;
}
function WorldTransformComponent(transform) {
  Companion_getInstance_149();
  this.transform = transform;
}
protoOf(WorldTransformComponent).z2a = function () {
  return this.transform;
};
protoOf(WorldTransformComponent).p1s = function () {
  return Companion_getInstance_149().id;
};
protoOf(WorldTransformComponent).toJson = function (parse) {
  return Companion_getInstance_149().a1m_1.x16(Companion_instance_147.z18(), new Serialized_1(this.transform.position, this.transform.rotation));
};
protoOf(WorldTransformComponent).serializationKey = function () {
  return Companion_getInstance_149().serializationKey;
};
protoOf(WorldTransformComponent).hashCode = function () {
  return this.transform.hashCode();
};
protoOf(WorldTransformComponent).equals = function (other) {
  var tmp;
  if (other instanceof WorldTransformComponent) {
    tmp = this.transform.equals(other.transform);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(WorldTransformComponent).eq = function (other) {
  return (other instanceof WorldTransformComponent ? other : THROW_CCE()).transform.equals(this.transform);
};
protoOf(WorldTransformComponent).toString = function () {
  return 'World :' + this.transform.toString();
};
protoOf(WorldTransformComponent).tf = function () {
  return this.transform;
};
protoOf(WorldTransformComponent).p3f = function (transform) {
  return new WorldTransformComponent(transform);
};
protoOf(WorldTransformComponent).copy = function (transform, $super) {
  transform = transform === VOID ? this.transform : transform;
  return this.p3f(transform);
};
function get_worldTransform(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(Companion_getInstance_149().id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.transform;
  return tmp1_elvis_lhs == null ? Companion_getInstance_80().c1x_1 : tmp1_elvis_lhs;
}
function get_worldRotation(_this__u8e3s4) {
  return get_worldTransform(_this__u8e3s4).rotation;
}
function get_worldPosition(_this__u8e3s4) {
  return get_worldTransform(_this__u8e3s4).position;
}
function sum(_this__u8e3s4) {
  var sum = Companion_getInstance().yd_1;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = _this__u8e3s4.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.utils.sum.<anonymous>' call
    var it = element.xd_1;
    sum = Duration__plus_impl_yu9v8f(sum, it);
  }
  return sum;
}
function Measurer() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.q3g_1 = LinkedHashMap_init_$Create$_0();
  this.r3g_1 = Monotonic_instance;
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_0.s3g_1 = LinkedHashMap_init_$Create$_0();
}
protoOf(Measurer).m2 = function () {
  this.q3g_1.m2();
  this.s3g_1.m2();
};
protoOf(Measurer).t3g = function (id) {
  // Inline function 'kotlin.collections.set' call
  var this_0 = this.s3g_1;
  var value = new ValueTimeMark(this.r3g_1.rd());
  this_0.q2(id, value);
};
protoOf(Measurer).u3g = function (id) {
  var tmp0_safe_receiver = this.s3g_1.f2(id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.utils.Measurer.stop.<anonymous>' call
    var duration = tmp0_safe_receiver.zi();
    $l$block: {
      // Inline function 'com.ikea.core.utils.orElse' call
      var tmp0_safe_receiver_0 = this.q3g_1.f2(id);
      if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.h(new Duration(duration))) == null) {
        var this_0 = this.q3g_1;
        var value = mutableListOf([new Duration(duration)]);
        this_0.q2(id, value);
        break $l$block;
      }
    }
  }
};
protoOf(Measurer).v3g = function () {
  // Inline function 'kotlin.collections.mutableListOf' call
  var result = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.q3g_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.utils.Measurer.getMeasurementsFormatted.<anonymous>' call
    var tmp$ret$2 = new Triple(item.b2(), new Duration(sum(item.c2())), item.c2().o());
    destination.h(tmp$ret$2);
  }
  var idSumCalls = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(idSumCalls, 10));
  var tmp0_iterator_0 = idSumCalls.k();
  while (tmp0_iterator_0.m()) {
    var item_0 = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.utils.Measurer.getMeasurementsFormatted.<anonymous>' call
    var tmp$ret$5 = item_0.pj_1;
    destination_0.h(tmp$ret$5);
  }
  var total = sum(destination_0);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_1 = idSumCalls.k();
  while (tmp0_iterator_1.m()) {
    var element = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.utils.Measurer.getMeasurementsFormatted.<anonymous>' call
    result.h(element.oj_1 + ' ' + Duration__toString_impl_8d916b(element.pj_1.xd_1) + ' (' + numberToLong(100).e3(_Duration___get_inWholeNanoseconds__impl__r5x4mr(element.pj_1.xd_1)).f3(_Duration___get_inWholeNanoseconds__impl__r5x4mr(total)).toString() + '%) calls: ' + element.qj_1);
  }
  sort(result);
  result.o2(0, 'Total: ' + Duration__toString_impl_8d916b(total));
  return result;
};
function UrlHelper() {
}
protoOf(UrlHelper).r30 = function (baseurl, url) {
  if (baseurl == null)
    return url;
  if (url == null)
    return baseurl;
  var urlDetails = this.w3g(url);
  if (!(urlDetails.x3g_1 == null))
    return url;
  var baseUrlDetails = this.w3g(baseurl);
  var tmp1_safe_receiver = urlDetails.y3g_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : startsWith(tmp1_safe_receiver, '/');
  if (tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs) {
    var tmp0_elvis_lhs = baseUrlDetails.x3g_1;
    var protocolAndServer = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    return protocolAndServer + urlDetails.y3g_1;
  }
  var slash = endsWith(baseurl, '/') ? '' : '/';
  return baseurl + slash + url;
};
protoOf(UrlHelper).w3g = function (url) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var lowerUrl = url.toLowerCase();
  if (startsWith(lowerUrl, 'http')) {
    var endOfProtocolPos = indexOf(url, '//');
    var startOfPath = indexOf(url, '/', endOfProtocolPos + 2 | 0);
    if (startOfPath === -1)
      startOfPath = url.length + 1 | 0;
    var protocolAndServer = substring(url, numberRangeToNumber(0, startOfPath - 1 | 0));
    // Inline function 'kotlin.text.substring' call
    var startIndex = startOfPath;
    // Inline function 'kotlin.js.asDynamic' call
    var path = url.substring(startIndex);
    return new UrlDetails(protocolAndServer, path);
  } else {
    return new UrlDetails(null, url);
  }
};
var UrlHelper_instance;
function UrlHelper_getInstance() {
  return UrlHelper_instance;
}
function UrlDetails(protocolAndServer, path) {
  this.x3g_1 = protocolAndServer;
  this.y3g_1 = path;
}
protoOf(UrlDetails).toString = function () {
  return 'UrlDetails(protocolAndServer=' + this.x3g_1 + ', path=' + this.y3g_1 + ')';
};
protoOf(UrlDetails).hashCode = function () {
  var result = this.x3g_1 == null ? 0 : getStringHashCode(this.x3g_1);
  result = imul(result, 31) + (this.y3g_1 == null ? 0 : getStringHashCode(this.y3g_1)) | 0;
  return result;
};
protoOf(UrlDetails).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UrlDetails))
    return false;
  var tmp0_other_with_cast = other instanceof UrlDetails ? other : THROW_CCE();
  if (!(this.x3g_1 == tmp0_other_with_cast.x3g_1))
    return false;
  if (!(this.y3g_1 == tmp0_other_with_cast.y3g_1))
    return false;
  return true;
};
function toJson(_this__u8e3s4, key) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.ikea.core.utils.toJson.<anonymous>' call
  var it = toString_0(_this__u8e3s4);
  var tmp;
  if (startsWith(it, '{') || startsWith(it, '[') || startsWith(it, '"')) {
    tmp = '"' + key + '":' + it;
  } else {
    if (typeof _this__u8e3s4 === 'number') {
      tmp = '"' + key + '":' + it;
    } else {
      if (typeof _this__u8e3s4 === 'number') {
        tmp = '"' + key + '":' + it;
      } else {
        if (typeof _this__u8e3s4 === 'number') {
          tmp = '"' + key + '":' + it;
        } else {
          if (typeof _this__u8e3s4 === 'boolean') {
            tmp = '"' + key + '":' + it;
          } else {
            if (_this__u8e3s4 instanceof Long) {
              tmp = '"' + key + '":' + it;
            } else {
              tmp = '"' + key + '":"' + it + '"';
            }
          }
        }
      }
    }
  }
  return tmp;
}
function Companion_149() {
  this.z3g_1 = 'NoValidConnectorAvailableValidationResult';
}
var Companion_instance_149;
function Companion_getInstance_150() {
  return Companion_instance_149;
}
function NoValidConnectorAvailableValidationResult(productRef) {
  ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef);
}
protoOf(NoValidConnectorAvailableValidationResult).n1s = function () {
  return Companion_instance_149.z3g_1;
};
protoOf(NoValidConnectorAvailableValidationResult).toString = function () {
  return 'Validation failed for ' + this.productRef + ': No valid connector available';
};
function SnapValidationResult$errors$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.errorsAndWarnings;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.validation.SnapValidationResult.errors$delegate.<anonymous>.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
        destination.h(element);
      }
    }
    return copyToArray(destination);
  };
}
function SnapValidationResult$warnings$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.errorsAndWarnings;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.validation.SnapValidationResult.warnings$delegate.<anonymous>.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_WARNING_getInstance())) {
        destination.h(element);
      }
    }
    return copyToArray(destination);
  };
}
function SnapValidationResult(snap, errorsAndWarnings) {
  var tmp;
  if (errorsAndWarnings === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = errorsAndWarnings;
  }
  errorsAndWarnings = tmp;
  this.snap = snap;
  this.errorsAndWarnings = errorsAndWarnings;
  var tmp_0 = this;
  tmp_0.o3d_1 = lazy(SnapValidationResult$errors$delegate$lambda(this));
  var tmp_1 = this;
  tmp_1.p3d_1 = lazy(SnapValidationResult$warnings$delegate$lambda(this));
}
protoOf(SnapValidationResult).t1u = function () {
  return this.snap;
};
protoOf(SnapValidationResult).b3h = function () {
  return this.errorsAndWarnings;
};
protoOf(SnapValidationResult).c3h = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.o3d_1;
  errors$factory();
  return this_0.c2();
};
protoOf(SnapValidationResult).d3h = function () {
  // Inline function 'kotlin.getValue' call
  var this_0 = this.p3d_1;
  warnings$factory();
  return this_0.c2();
};
protoOf(SnapValidationResult).e3h = function () {
  // Inline function 'kotlin.collections.isEmpty' call
  return this.errors.length === 0;
};
protoOf(SnapValidationResult).toValidSnapActionCandidateOrErrors = function () {
  var tmp;
  if (this.valid) {
    tmp = new ValidSnapActionCandidateOrErrors(this.snap, this.warnings);
  } else {
    tmp = new ValidSnapActionCandidateOrErrors(null, this.warnings, this.errors);
  }
  return tmp;
};
protoOf(SnapValidationResult).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof SnapValidationResult))
    THROW_CCE();
  if (!equals(this.snap, other.snap))
    return false;
  if (!contentEquals(this.errorsAndWarnings, other.errorsAndWarnings))
    return false;
  return true;
};
protoOf(SnapValidationResult).hashCode = function () {
  var result = hashCode(this.snap);
  result = imul(31, result) + contentHashCode(this.errorsAndWarnings) | 0;
  return result;
};
protoOf(SnapValidationResult).tf = function () {
  return this.snap;
};
protoOf(SnapValidationResult).uf = function () {
  return this.errorsAndWarnings;
};
protoOf(SnapValidationResult).f3h = function (snap, errorsAndWarnings) {
  return new SnapValidationResult(snap, errorsAndWarnings);
};
protoOf(SnapValidationResult).copy = function (snap, errorsAndWarnings, $super) {
  snap = snap === VOID ? this.snap : snap;
  errorsAndWarnings = errorsAndWarnings === VOID ? this.errorsAndWarnings : errorsAndWarnings;
  return this.f3h(snap, errorsAndWarnings);
};
protoOf(SnapValidationResult).toString = function () {
  return 'SnapValidationResult(snap=' + this.snap.toString() + ', errorsAndWarnings=' + toString_0(this.errorsAndWarnings) + ')';
};
function errors$factory() {
  return getPropertyCallableRef('errors', 1, KProperty1, function (receiver) {
    return receiver.errors;
  }, null);
}
function warnings$factory() {
  return getPropertyCallableRef('warnings', 1, KProperty1, function (receiver) {
    return receiver.warnings;
  }, null);
}
function Companion_150() {
  this.g3h_1 = 'UnknownErrorValidationResult';
}
var Companion_instance_150;
function Companion_getInstance_151() {
  return Companion_instance_150;
}
function UnknownErrorValidationResult(productRef) {
  ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef);
}
protoOf(UnknownErrorValidationResult).n1s = function () {
  return Companion_instance_150.g3h_1;
};
protoOf(UnknownErrorValidationResult).toString = function () {
  return 'Validation failed for ' + this.productRef + ' for unknown reasons. This could be a bug';
};
function Companion_151() {
}
protoOf(Companion_151).noSnappingEntity = function (guest) {
  // Inline function 'kotlin.emptyArray' call
  var tmp = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [Companion_instance_153.noSnappingEntity(guest)];
  return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$3);
};
protoOf(Companion_151).noSnapCandidates = function (guest) {
  // Inline function 'kotlin.emptyArray' call
  var tmp = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [Companion_instance_153.noSnapCandidates(guest)];
  return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$3);
};
var Companion_instance_151;
function Companion_getInstance_152() {
  return Companion_instance_151;
}
function ValidSnapActionCandidateOrErrors(snap, warnings, errors) {
  var tmp;
  if (warnings === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = warnings;
  }
  warnings = tmp;
  var tmp_0;
  if (errors === VOID) {
    // Inline function 'kotlin.emptyArray' call
    tmp_0 = [];
  } else {
    tmp_0 = errors;
  }
  errors = tmp_0;
  this.snap = snap;
  this.warnings = warnings;
  this.errors = errors;
}
protoOf(ValidSnapActionCandidateOrErrors).t1u = function () {
  return this.snap;
};
protoOf(ValidSnapActionCandidateOrErrors).d3h = function () {
  return this.warnings;
};
protoOf(ValidSnapActionCandidateOrErrors).c3h = function () {
  return this.errors;
};
protoOf(ValidSnapActionCandidateOrErrors).e3h = function () {
  return !(this.snap == null);
};
protoOf(ValidSnapActionCandidateOrErrors).combineFailures = function (other) {
  if (!(this.snap == null)) {
    return this;
  }
  if (!(other.snap == null)) {
    return other;
  }
  // Inline function 'kotlin.collections.plus' call
  var this_0 = this.warnings;
  var elements = other.warnings;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = this_0.concat(elements);
  // Inline function 'kotlin.collections.plus' call
  var this_1 = this.errors;
  var elements_0 = other.errors;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = this_1.concat(elements_0);
  return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$3);
};
protoOf(ValidSnapActionCandidateOrErrors).combineFailuresWithValidatedSnapCandidate = function (other) {
  if (!(this.snap == null)) {
    return this;
  }
  if (other.valid) {
    return other.toValidSnapActionCandidateOrErrors();
  }
  // Inline function 'kotlin.collections.plus' call
  var this_0 = this.warnings;
  var elements = other.warnings;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = this_0.concat(elements);
  // Inline function 'kotlin.collections.plus' call
  var this_1 = this.errors;
  var elements_0 = other.errors;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = this_1.concat(elements_0);
  return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$3);
};
protoOf(ValidSnapActionCandidateOrErrors).tf = function () {
  return this.snap;
};
protoOf(ValidSnapActionCandidateOrErrors).uf = function () {
  return this.warnings;
};
protoOf(ValidSnapActionCandidateOrErrors).m1m = function () {
  return this.errors;
};
protoOf(ValidSnapActionCandidateOrErrors).i3h = function (snap, warnings, errors) {
  return new ValidSnapActionCandidateOrErrors(snap, warnings, errors);
};
protoOf(ValidSnapActionCandidateOrErrors).copy = function (snap, warnings, errors, $super) {
  snap = snap === VOID ? this.snap : snap;
  warnings = warnings === VOID ? this.warnings : warnings;
  errors = errors === VOID ? this.errors : errors;
  return this.i3h(snap, warnings, errors);
};
protoOf(ValidSnapActionCandidateOrErrors).toString = function () {
  return 'ValidSnapActionCandidateOrErrors(snap=' + toString(this.snap) + ', warnings=' + toString_0(this.warnings) + ', errors=' + toString_0(this.errors) + ')';
};
protoOf(ValidSnapActionCandidateOrErrors).hashCode = function () {
  var result = this.snap == null ? 0 : hashCode(this.snap);
  result = imul(result, 31) + hashCode(this.warnings) | 0;
  result = imul(result, 31) + hashCode(this.errors) | 0;
  return result;
};
protoOf(ValidSnapActionCandidateOrErrors).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ValidSnapActionCandidateOrErrors))
    return false;
  var tmp0_other_with_cast = other instanceof ValidSnapActionCandidateOrErrors ? other : THROW_CCE();
  if (!equals(this.snap, tmp0_other_with_cast.snap))
    return false;
  if (!equals(this.warnings, tmp0_other_with_cast.warnings))
    return false;
  if (!equals(this.errors, tmp0_other_with_cast.errors))
    return false;
  return true;
};
function ValidationImpl() {
  this.m1y_1 = true;
}
protoOf(ValidationImpl).s1w = function () {
  return this.m1y_1;
};
protoOf(ValidationImpl).enable = function () {
  this.m1y_1 = true;
};
protoOf(ValidationImpl).disable = function () {
  this.m1y_1 = false;
};
function Validation() {
}
var ValidationResultType_WARNING_instance;
var ValidationResultType_FAIL_instance;
function values_1() {
  return [ValidationResultType_WARNING_getInstance(), ValidationResultType_FAIL_getInstance()];
}
function valueOf_1(value) {
  switch (value) {
    case 'WARNING':
      return ValidationResultType_WARNING_getInstance();
    case 'FAIL':
      return ValidationResultType_FAIL_getInstance();
    default:
      ValidationResultType_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var ValidationResultType_entriesInitialized;
function ValidationResultType_initEntries() {
  if (ValidationResultType_entriesInitialized)
    return Unit_instance;
  ValidationResultType_entriesInitialized = true;
  ValidationResultType_WARNING_instance = new ValidationResultType('WARNING', 0);
  ValidationResultType_FAIL_instance = new ValidationResultType('FAIL', 1);
}
function ValidationResultType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Companion_152() {
  this.GENERIC_FAILURE = 'Generic ValidationResultFail';
}
protoOf(Companion_152).l3h = function () {
  return this.GENERIC_FAILURE;
};
var Companion_instance_152;
function Companion_getInstance_153() {
  return Companion_instance_152;
}
function ValidationResultFail(message, productRef, rule) {
  rule = rule === VOID ? null : rule;
  ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef, rule);
  this.message = message;
}
protoOf(ValidationResultFail).ka = function () {
  return this.message;
};
protoOf(ValidationResultFail).n1s = function () {
  var tmp0_safe_receiver = this.failedRule;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id;
  return tmp1_elvis_lhs == null ? Companion_instance_152.GENERIC_FAILURE : tmp1_elvis_lhs;
};
protoOf(ValidationResultFail).toString = function () {
  return 'Validation failed: ' + this.message;
};
function ValidationResultWarning(message, productRef, rule) {
  rule = rule === VOID ? null : rule;
  ValidationResult.call(this, ValidationResultType_WARNING_getInstance(), productRef, rule);
  this.message = message;
}
protoOf(ValidationResultWarning).ka = function () {
  return this.message;
};
protoOf(ValidationResultWarning).n1s = function () {
  return 'Generic ValidationResultWarning';
};
protoOf(ValidationResultWarning).toString = function () {
  return 'Validation warning: ' + this.message;
};
function ValidationResultType_WARNING_getInstance() {
  ValidationResultType_initEntries();
  return ValidationResultType_WARNING_instance;
}
function ValidationResultType_FAIL_getInstance() {
  ValidationResultType_initEntries();
  return ValidationResultType_FAIL_instance;
}
function Companion_153() {
}
protoOf(Companion_153).o3h = function (message, productRef, rule) {
  return new ValidationResultFail(message, productRef, rule);
};
protoOf(Companion_153).fail = function (message, productRef, rule, $super) {
  productRef = productRef === VOID ? null : productRef;
  rule = rule === VOID ? null : rule;
  return this.o3h(message, productRef, rule);
};
protoOf(Companion_153).p3h = function (message, productRef, rule) {
  return new ValidationResultWarning(message, productRef, rule);
};
protoOf(Companion_153).warning = function (message, productRef, rule, $super) {
  productRef = productRef === VOID ? null : productRef;
  rule = rule === VOID ? null : rule;
  return this.p3h(message, productRef, rule);
};
protoOf(Companion_153).noSnapCandidates = function (guest) {
  var tmp0_elvis_lhs = get_productRef(guest);
  return new ValidationResultFail('No snaps found', tmp0_elvis_lhs == null ? 'Entity ' + guest.id : tmp0_elvis_lhs, null);
};
protoOf(Companion_153).noSnappingEntity = function (guest) {
  var tmp0_elvis_lhs = get_productRef(guest);
  return new ValidationResultFail('No snapping entity found', tmp0_elvis_lhs == null ? 'Entity ' + guest.id : tmp0_elvis_lhs, null);
};
var Companion_instance_153;
function Companion_getInstance_154() {
  return Companion_instance_153;
}
function ValidationResult(resultType, productRef, failedRule) {
  failedRule = failedRule === VOID ? null : failedRule;
  this.resultType = resultType;
  this.r1y_1 = productRef;
  this.failedRule = failedRule;
}
protoOf(ValidationResult).s1y = function () {
  return this.resultType;
};
protoOf(ValidationResult).b1t = function () {
  return this.r1y_1;
};
protoOf(ValidationResult).t1y = function () {
  return this.failedRule;
};
protoOf(ValidationResult).toString = function () {
  var tmp;
  switch (this.resultType.u2_1) {
    case 1:
      tmp = 'Validation failed';
      break;
    case 0:
      tmp = 'Validation warned';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
function ValidationService() {
}
function ValidationMeasurement(id, snapValidationDurationInSeconds, snapValidationCalls, stateValidationDurationInSeconds, stateValidationCalls) {
  this.id = id;
  this.snapValidationDurationInSeconds = snapValidationDurationInSeconds;
  this.snapValidationCalls = snapValidationCalls;
  this.stateValidationDurationInSeconds = stateValidationDurationInSeconds;
  this.stateValidationCalls = stateValidationCalls;
}
protoOf(ValidationMeasurement).n1s = function () {
  return this.id;
};
protoOf(ValidationMeasurement).c3i = function () {
  return this.snapValidationDurationInSeconds;
};
protoOf(ValidationMeasurement).d3i = function () {
  return this.snapValidationCalls;
};
protoOf(ValidationMeasurement).e3i = function () {
  return this.stateValidationDurationInSeconds;
};
protoOf(ValidationMeasurement).f3i = function () {
  return this.stateValidationCalls;
};
protoOf(ValidationMeasurement).tf = function () {
  return this.id;
};
protoOf(ValidationMeasurement).uf = function () {
  return this.snapValidationDurationInSeconds;
};
protoOf(ValidationMeasurement).m1m = function () {
  return this.snapValidationCalls;
};
protoOf(ValidationMeasurement).n1m = function () {
  return this.stateValidationDurationInSeconds;
};
protoOf(ValidationMeasurement).o1m = function () {
  return this.stateValidationCalls;
};
protoOf(ValidationMeasurement).g3i = function (id, snapValidationDurationInSeconds, snapValidationCalls, stateValidationDurationInSeconds, stateValidationCalls) {
  return new ValidationMeasurement(id, snapValidationDurationInSeconds, snapValidationCalls, stateValidationDurationInSeconds, stateValidationCalls);
};
protoOf(ValidationMeasurement).copy = function (id, snapValidationDurationInSeconds, snapValidationCalls, stateValidationDurationInSeconds, stateValidationCalls, $super) {
  id = id === VOID ? this.id : id;
  snapValidationDurationInSeconds = snapValidationDurationInSeconds === VOID ? this.snapValidationDurationInSeconds : snapValidationDurationInSeconds;
  snapValidationCalls = snapValidationCalls === VOID ? this.snapValidationCalls : snapValidationCalls;
  stateValidationDurationInSeconds = stateValidationDurationInSeconds === VOID ? this.stateValidationDurationInSeconds : stateValidationDurationInSeconds;
  stateValidationCalls = stateValidationCalls === VOID ? this.stateValidationCalls : stateValidationCalls;
  return this.g3i(id, snapValidationDurationInSeconds, snapValidationCalls, stateValidationDurationInSeconds, stateValidationCalls);
};
protoOf(ValidationMeasurement).toString = function () {
  return 'ValidationMeasurement(id=' + this.id + ', snapValidationDurationInSeconds=' + this.snapValidationDurationInSeconds + ', snapValidationCalls=' + this.snapValidationCalls + ', stateValidationDurationInSeconds=' + this.stateValidationDurationInSeconds + ', stateValidationCalls=' + this.stateValidationCalls + ')';
};
protoOf(ValidationMeasurement).hashCode = function () {
  var result = getStringHashCode(this.id);
  result = imul(result, 31) + getNumberHashCode(this.snapValidationDurationInSeconds) | 0;
  result = imul(result, 31) + this.snapValidationCalls | 0;
  result = imul(result, 31) + getNumberHashCode(this.stateValidationDurationInSeconds) | 0;
  result = imul(result, 31) + this.stateValidationCalls | 0;
  return result;
};
protoOf(ValidationMeasurement).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ValidationMeasurement))
    return false;
  var tmp0_other_with_cast = other instanceof ValidationMeasurement ? other : THROW_CCE();
  if (!(this.id === tmp0_other_with_cast.id))
    return false;
  if (!equals(this.snapValidationDurationInSeconds, tmp0_other_with_cast.snapValidationDurationInSeconds))
    return false;
  if (!(this.snapValidationCalls === tmp0_other_with_cast.snapValidationCalls))
    return false;
  if (!equals(this.stateValidationDurationInSeconds, tmp0_other_with_cast.stateValidationDurationInSeconds))
    return false;
  if (!(this.stateValidationCalls === tmp0_other_with_cast.stateValidationCalls))
    return false;
  return true;
};
function ValidationMeasurements(totalTimeInSeconds, measurements) {
  this.totalTimeInSeconds = totalTimeInSeconds;
  this.measurements = measurements;
}
protoOf(ValidationMeasurements).h3i = function () {
  return this.totalTimeInSeconds;
};
protoOf(ValidationMeasurements).i3i = function () {
  return this.measurements;
};
protoOf(ValidationMeasurements).tf = function () {
  return this.totalTimeInSeconds;
};
protoOf(ValidationMeasurements).uf = function () {
  return this.measurements;
};
protoOf(ValidationMeasurements).j3i = function (totalTimeInSeconds, measurements) {
  return new ValidationMeasurements(totalTimeInSeconds, measurements);
};
protoOf(ValidationMeasurements).copy = function (totalTimeInSeconds, measurements, $super) {
  totalTimeInSeconds = totalTimeInSeconds === VOID ? this.totalTimeInSeconds : totalTimeInSeconds;
  measurements = measurements === VOID ? this.measurements : measurements;
  return this.j3i(totalTimeInSeconds, measurements);
};
protoOf(ValidationMeasurements).toString = function () {
  return 'ValidationMeasurements(totalTimeInSeconds=' + this.totalTimeInSeconds + ', measurements=' + toString_0(this.measurements) + ')';
};
protoOf(ValidationMeasurements).hashCode = function () {
  var result = getNumberHashCode(this.totalTimeInSeconds);
  result = imul(result, 31) + hashCode(this.measurements) | 0;
  return result;
};
protoOf(ValidationMeasurements).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ValidationMeasurements))
    return false;
  var tmp0_other_with_cast = other instanceof ValidationMeasurements ? other : THROW_CCE();
  if (!equals(this.totalTimeInSeconds, tmp0_other_with_cast.totalTimeInSeconds))
    return false;
  if (!equals(this.measurements, tmp0_other_with_cast.measurements))
    return false;
  return true;
};
function getTotalsForMode($this, durations, validationMode) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$();
  var tmp0_iterator = durations.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getTotalsForMode.<anonymous>' call
    var mode = element.uf();
    if (mode.equals(validationMode)) {
      destination.h(element);
    }
  }
  var filteredDurations = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(filteredDurations, 10));
  var tmp0_iterator_0 = filteredDurations.k();
  while (tmp0_iterator_0.m()) {
    var item = tmp0_iterator_0.n();
    // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getTotalsForMode.<anonymous>' call
    var duration = item.tf().xd_1;
    var tmp$ret$3 = new Duration(duration);
    destination_0.h(tmp$ret$3);
  }
  return new Pair(Duration__toDouble_impl_a56y2b(sum(destination_0), DurationUnit_SECONDS_getInstance()), filteredDurations.o());
}
function ValidationServiceMeasurer() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.k3i_1 = LinkedHashMap_init_$Create$_0();
  this.l3i_1 = Monotonic_instance;
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_0.m3i_1 = LinkedHashMap_init_$Create$_0();
}
protoOf(ValidationServiceMeasurer).m2 = function () {
  this.k3i_1.m2();
  this.m3i_1.m2();
};
protoOf(ValidationServiceMeasurer).t3g = function (id) {
  // Inline function 'kotlin.collections.set' call
  var this_0 = this.m3i_1;
  var value = new ValueTimeMark(this.l3i_1.rd());
  this_0.q2(id, value);
};
protoOf(ValidationServiceMeasurer).n3i = function (id, mode) {
  var tmp0_safe_receiver = this.m3i_1.f2(id);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.stop.<anonymous>' call
    var durationAndMode = new Pair(new Duration(tmp0_safe_receiver.zi()), mode);
    $l$block: {
      // Inline function 'com.ikea.core.utils.orElse' call
      var tmp0_safe_receiver_0 = this.k3i_1.f2(id);
      if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.h(durationAndMode)) == null) {
        var this_0 = this.k3i_1;
        var value = mutableListOf([durationAndMode]);
        this_0.q2(id, value);
        break $l$block;
      }
    }
  }
};
protoOf(ValidationServiceMeasurer).v3g = function () {
  // Inline function 'kotlin.collections.mutableListOf' call
  var result = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.k3i_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(this_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getMeasurementsFormatted.<anonymous>' call
    var tmp = item.b2();
    // Inline function 'kotlin.collections.map' call
    var this_1 = item.c2();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.k();
    while (tmp0_iterator_0.m()) {
      var item_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getMeasurementsFormatted.<anonymous>.<anonymous>' call
      var duration = item_0.tf().xd_1;
      var tmp$ret$2 = new Duration(duration);
      destination_0.h(tmp$ret$2);
    }
    var tmp$ret$5 = new Triple(tmp, new Duration(sum(destination_0)), item.c2().o());
    destination.h(tmp$ret$5);
  }
  var idSumCalls = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(idSumCalls, 10));
  var tmp0_iterator_1 = idSumCalls.k();
  while (tmp0_iterator_1.m()) {
    var item_1 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getMeasurementsFormatted.<anonymous>' call
    var tmp$ret$8 = item_1.pj_1;
    destination_1.h(tmp$ret$8);
  }
  var total = sum(destination_1);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_2 = idSumCalls.k();
  while (tmp0_iterator_2.m()) {
    var element = tmp0_iterator_2.n();
    // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getMeasurementsFormatted.<anonymous>' call
    result.h(element.oj_1 + ' ' + Duration__toString_impl_8d916b(element.pj_1.xd_1) + ' (' + numberToLong(100).e3(_Duration___get_inWholeNanoseconds__impl__r5x4mr(element.pj_1.xd_1)).f3(_Duration___get_inWholeNanoseconds__impl__r5x4mr(total)).toString() + '%) calls: ' + element.qj_1);
  }
  sort(result);
  result.o2(0, 'Total: ' + Duration__toString_impl_8d916b(total));
  return result;
};
protoOf(ValidationServiceMeasurer).o3i = function () {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = this.k3i_1;
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getMeasurementsStructured.<anonymous>' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = element.c2();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.k();
    while (tmp0_iterator_0.m()) {
      var item = tmp0_iterator_0.n();
      // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getMeasurementsStructured.<anonymous>.<anonymous>' call
      var duration = item.tf().xd_1;
      var tmp$ret$1 = new Duration(duration);
      destination_0.h(tmp$ret$1);
    }
    var list = destination_0;
    addAll(destination, list);
  }
  var totalDuration = Duration__toDouble_impl_a56y2b(sum(destination), DurationUnit_SECONDS_getInstance());
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_2 = this.k3i_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$_0(this_2.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_1 = this_2.i2().k();
  while (tmp0_iterator_1.m()) {
    var item_0 = tmp0_iterator_1.n();
    // Inline function 'com.ikea.core.validation.ValidationServiceMeasurer.getMeasurementsStructured.<anonymous>' call
    var _destruct__k2r9zo = getTotalsForMode(this, item_0.c2(), ValidationMode_SNAP_getInstance());
    var snapDuration = _destruct__k2r9zo.tf();
    var snapCalls = _destruct__k2r9zo.uf();
    var _destruct__k2r9zo_0 = getTotalsForMode(this, item_0.c2(), ValidationMode_STATE_getInstance());
    var stateDuration = _destruct__k2r9zo_0.tf();
    var stateCalls = _destruct__k2r9zo_0.uf();
    var tmp$ret$8 = new ValidationMeasurement(item_0.b2(), snapDuration, snapCalls, stateDuration, stateCalls);
    destination_1.h(tmp$ret$8);
  }
  var measurements = copyToArray(destination_1);
  return new ValidationMeasurements(totalDuration, measurements);
};
var ValidationMode_STATE_instance;
var ValidationMode_SNAP_instance;
var ValidationMode_entriesInitialized;
function ValidationMode_initEntries() {
  if (ValidationMode_entriesInitialized)
    return Unit_instance;
  ValidationMode_entriesInitialized = true;
  ValidationMode_STATE_instance = new ValidationMode('STATE', 0);
  ValidationMode_SNAP_instance = new ValidationMode('SNAP', 1);
}
function ValidationMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ValidationMode_STATE_getInstance() {
  ValidationMode_initEntries();
  return ValidationMode_STATE_instance;
}
function ValidationMode_SNAP_getInstance() {
  ValidationMode_initEntries();
  return ValidationMode_SNAP_instance;
}
function fastComponent(entity, componentId) {
  var tmp0_safe_receiver = entity.d2k(componentId);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = tmp0_safe_receiver;
  }
  return tmp;
}
function unsafeCast(obj) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return obj;
}
function echoStandardConsole(a) {
  console.log(a);
}
//region block: post-declaration
defineProp(protoOf(CoreServices), 'logger', protoOf(CoreServices).l1k);
protoOf(AssemblyPartIdsComponent).r1s = get_serializable;
protoOf(AssemblyPartIdsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AssemblyPartIdsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AssemblyPartIdsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AssemblyPartIdsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer).fx = typeParametersSerializers;
protoOf(AssemblyPartsComponent).r1s = get_serializable;
protoOf(AssemblyPartsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AssemblyPartsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AssemblyPartsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AssemblyPartsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(AssemblyStructureComponent).r1s = get_serializable;
protoOf(AssemblyStructureComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AssemblyStructureComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AssemblyStructureComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AssemblyStructureComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_0).fx = typeParametersSerializers;
protoOf(ProductPartComponent).r1s = get_serializable_0;
protoOf(ProductPartComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProductPartComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProductPartComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProductPartComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(CatalogSizeComponent).r1s = get_serializable;
protoOf(CatalogSizeComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(CatalogSizeComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(CatalogSizeComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(CatalogSizeComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ProductComponent).r1s = get_serializable;
protoOf(ProductComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProductComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProductComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProductComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_1).fx = typeParametersSerializers;
protoOf(ProductParamsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProductParamsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProductParamsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProductParamsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_10), 'id', protoOf(Companion_10).n1s);
protoOf(ProductStructureComponent).r1s = get_serializable;
protoOf(ProductStructureComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProductStructureComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProductStructureComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProductStructureComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(EcsSystemImpl), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(EcsSystemImpl), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(EcsSystemImpl), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(EcsSystemImpl), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(EcsSystemImpl), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(EcsSystemImpl), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(EcsSystemImpl), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(EcsSystemImpl), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SystemBase), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SystemBase), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SystemBase), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SystemBase), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SystemBase), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SystemBase), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SystemBase), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SystemBase), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(ProductResizingSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ProductResizingSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ProductResizingSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ProductResizingSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ProductResizingSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ProductResizingSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ProductResizingSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ProductResizingSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(ColliderComponent).r1s = get_serializable;
protoOf(ColliderComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ColliderComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ColliderComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ColliderComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ColliderShapeComponent).r1s = get_serializable;
protoOf(ColliderShapeComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ColliderShapeComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ColliderShapeComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ColliderShapeComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ValidationImpl), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(ValidationImpl), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ValidationResult), 'productRef', function () {
  return this.b1t();
});
defineProp(protoOf(ValidationResult), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(CollisionValidationResult), 'aabbOfAllCollidedWith', protoOf(CollisionValidationResult).q1y);
defineProp(protoOf(SystemBase2), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SystemBase2), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SystemBase2), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SystemBase2), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SystemBase2), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SystemBase2), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SystemBase2), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SystemBase2), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(WorldColliderUpdateSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(WorldColliderUpdateSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(WorldColliderUpdateSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(WorldColliderUpdateSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(WorldColliderUpdateSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(WorldColliderUpdateSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(WorldColliderUpdateSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(WorldColliderUpdateSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(Connection), 'guestConnectionRoot', protoOf(Connection).l28);
defineProp(protoOf(Connection), 'hostConnectionRoot', protoOf(Connection).m28);
defineProp(protoOf(Connection), 'priority', protoOf(Connection).n28);
defineProp(protoOf(Connection), 'guestConnector', protoOf(Connection).o28);
defineProp(protoOf(Connection), 'hostConnector', protoOf(Connection).p28);
defineProp(protoOf(Connection), 'guestIsConnectionRoot', protoOf(Connection).r28);
defineProp(protoOf(Connection), 'guestConnectorWorldPosition', protoOf(Connection).s28);
defineProp(protoOf(Connection), 'hostConnectorWorldPosition', protoOf(Connection).t28);
protoOf(ConnectionRootComponent).r1s = get_serializable;
protoOf(ConnectionRootComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ConnectionRootComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ConnectionRootComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ConnectionRootComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(GuestConnectionsComponent).r1s = get_serializable;
protoOf(GuestConnectionsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(GuestConnectionsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(GuestConnectionsComponent), 'hasMultipleHosts', protoOf(GuestConnectionsComponent).p29);
defineProp(protoOf(GuestConnectionsComponent), 'highestPriorityConnection', protoOf(GuestConnectionsComponent).q29);
defineProp(protoOf(GuestConnectionsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(GuestConnectionsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(HostConnectionsComponent).r1s = get_serializable;
protoOf(HostConnectionsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(HostConnectionsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(HostConnectionsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(HostConnectionsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(TemporarilyPauseConnectionParentingComponent).r1s = get_serializable;
protoOf(TemporarilyPauseConnectionParentingComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(TemporarilyPauseConnectionParentingComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(TemporarilyPauseConnectionParentingComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(TemporarilyPauseConnectionParentingComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(UpdateHostConnectionsSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(UpdateHostConnectionsSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(UpdateHostConnectionsSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(UpdateHostConnectionsSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(UpdateHostConnectionsSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(UpdateHostConnectionsSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(UpdateHostConnectionsSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(UpdateHostConnectionsSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(Connector), 'key', function () {
  return this.b2();
});
defineProp(protoOf(Connector), 'type', function () {
  return this.w2a();
});
defineProp(protoOf(Connector), 'required', function () {
  return this.x2a();
});
defineProp(protoOf(Connector), 'worldSpaceOffsetOnHanging', function () {
  return this.y2a();
});
defineProp(protoOf(Connector), 'transform', function () {
  return this.z2a();
});
defineProp(protoOf(Connector), 'rotationalDegreeOfFreedom', function () {
  return this.a2b();
});
defineProp(protoOf(Connector), 'tagArray', function () {
  return this.c2b();
}, function (value) {
  this.b2b(value);
});
defineProp(protoOf(Connector), 'offersArray', function () {
  return this.e2b();
}, function (value) {
  this.d2b(value);
});
defineProp(protoOf(Connector), 'demandsArray', function () {
  return this.g2b();
}, function (value) {
  this.f2b(value);
});
defineProp(protoOf(Connector), 'priority', function () {
  return this.n28();
});
defineProp(protoOf(Connector), 'activationDistance', function () {
  return this.h2b();
});
defineProp(protoOf(Connector), 'enabled', function () {
  return this.i2b();
});
defineProp(protoOf(Connector), 'isContinuousConnector', function () {
  return this.j2b();
});
defineProp(protoOf(Connector), 'hasSubConnectors', function () {
  return this.v2b();
});
protoOf(ConnectorsComponent).r1s = get_serializable;
protoOf(ConnectorsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ConnectorsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ConnectorsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ConnectorsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(DisableConnectorsSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DisableConnectorsSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DisableConnectorsSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DisableConnectorsSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DisableConnectorsSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DisableConnectorsSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DisableConnectorsSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DisableConnectorsSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(DisabledConnectorsComponent).r1s = get_serializable;
protoOf(DisabledConnectorsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DisabledConnectorsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DisabledConnectorsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DisabledConnectorsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(RelativeConnectorsComponent).r1s = get_serializable;
protoOf(RelativeConnectorsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RelativeConnectorsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RelativeConnectorsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RelativeConnectorsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(DebugLinesComponent).r1s = get_serializable;
protoOf(DebugLinesComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DebugLinesComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DebugLinesComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DebugLinesComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(DebugSurfacesComponent).r1s = get_serializable;
protoOf(DebugSurfacesComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DebugSurfacesComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DebugSurfacesComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DebugSurfacesComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(DragSurfacesComponent).r1s = get_serializable;
protoOf(DragSurfacesComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DragSurfacesComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DragSurfacesComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DragSurfacesComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(DraggableComponent).r1s = get_serializable;
protoOf(DraggableComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DraggableComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DraggableComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DraggableComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(SomethingIsDraggedComponent).r1s = get_serializable;
defineProp(protoOf(SomethingIsDraggedComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SomethingIsDraggedComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(SomethingIsDraggedComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(ViewerDragEventComponent).r1s = get_serializable;
defineProp(protoOf(ViewerDragEventComponent), 'rayFromCameraToDragEnd', protoOf(ViewerDragEventComponent).d2j);
defineProp(protoOf(ViewerDragEventComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ViewerDragEventComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ViewerDragEventComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(WorldDragSurfaceUpdateSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(WorldDragSurfaceUpdateSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(WorldDragSurfaceUpdateSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(WorldDragSurfaceUpdateSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(WorldDragSurfaceUpdateSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(WorldDragSurfaceUpdateSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(WorldDragSurfaceUpdateSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(WorldDragSurfaceUpdateSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(WorldDragSurfacesComponent).r1s = get_serializable;
protoOf(WorldDragSurfacesComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(WorldDragSurfacesComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(WorldDragSurfacesComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(WorldDragSurfacesComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(WorldSpaceDragEventComponent).r1s = get_serializable;
defineProp(protoOf(WorldSpaceDragEventComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(WorldSpaceDragEventComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(WorldSpaceDragEventComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(Entity), 'allComponents', protoOf(Entity).i2k);
defineProp(protoOf(Entity), 'isDisposed', protoOf(Entity).j2k);
defineProp(protoOf(Entity), 'isBeingDisposed', protoOf(Entity).m2k);
defineProp(protoOf(EntityManagerImpl), 'entities', function () {
  return this.n2k();
});
defineProp(protoOf(ComponentListenerImpl), 'ownerSystem', function () {
  return this.h2k();
});
defineProp(protoOf(ComponentListenerImpl), 'componentId', function () {
  return this.k2d();
});
defineProp(protoOf(SystemBase3), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SystemBase3), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SystemBase3), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SystemBase3), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SystemBase3), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SystemBase3), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SystemBase3), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SystemBase3), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SystemBase4), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SystemBase4), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SystemBase4), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SystemBase4), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SystemBase4), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SystemBase4), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SystemBase4), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SystemBase4), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(SystemBase5), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SystemBase5), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SystemBase5), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SystemBase5), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SystemBase5), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SystemBase5), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SystemBase5), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SystemBase5), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(AutomaticGroupBuilderSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(AutomaticGroupBuilderSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(AutomaticGroupBuilderSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(AutomaticGroupBuilderSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(AutomaticGroupBuilderSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(AutomaticGroupBuilderSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(AutomaticGroupBuilderSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(AutomaticGroupBuilderSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(AutomaticGroupComponent).r1s = get_serializable_0;
protoOf(AutomaticGroupComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutomaticGroupComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutomaticGroupComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutomaticGroupComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(AutomaticGroupIdCountComponent).r1s = get_serializable;
protoOf(AutomaticGroupIdCountComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AutomaticGroupIdCountComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AutomaticGroupIdCountComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AutomaticGroupIdCountComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(StaticComponent).r1s = get_serializable;
protoOf(StaticComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(StaticComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(StaticComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(StaticComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ChildComponent).r1s = get_serializable;
protoOf(ChildComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ChildComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ChildComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ChildComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ConnectionParentingSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ConnectionParentingSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ConnectionParentingSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ConnectionParentingSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ConnectionParentingSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ConnectionParentingSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ConnectionParentingSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ConnectionParentingSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(DisposeTemporaryParentSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(DisposeTemporaryParentSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(DisposeTemporaryParentSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(DisposeTemporaryParentSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(DisposeTemporaryParentSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(DisposeTemporaryParentSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(DisposeTemporaryParentSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(DisposeTemporaryParentSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(HierarchySystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(HierarchySystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(HierarchySystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(HierarchySystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(HierarchySystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(HierarchySystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(HierarchySystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(HierarchySystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(Companion_63), 'id', protoOf(Companion_63).n1s);
protoOf(InSceneComponent).r1s = get_serializable;
protoOf(InSceneComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(InSceneComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(InSceneComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(InSceneComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ParentComponent).r1s = get_serializable;
protoOf(ParentComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ParentComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ParentComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ParentComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(RestoreSnapRootOnChildrenOfTemporaryParentSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(SceneComponent_0).r1s = get_serializable;
protoOf(SceneComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SceneComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SceneComponent_0), 'id', protoOf(SceneComponent_0).n1s);
defineProp(protoOf(SceneComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SceneComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(SceneGraphSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(SceneGraphSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(SceneGraphSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(SceneGraphSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(SceneGraphSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(SceneGraphSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(SceneGraphSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(SceneGraphSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(TemporaryParentComponent).r1s = get_serializable;
protoOf(TemporaryParentComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(TemporaryParentComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(TemporaryParentComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(TemporaryParentComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(HistoryEvent), 'name', protoOf(HistoryEvent).v2);
defineProp(protoOf(HistoryEvent), 'ordinal', protoOf(HistoryEvent).w2);
protoOf(HistoryChangedEventComponent).r1s = get_serializable;
protoOf(HistoryChangedEventComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(HistoryChangedEventComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(HistoryChangedEventComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(HistoryChangedEventComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(HistoryImpl).takeSnapshot = takeSnapshot;
defineProp(protoOf(HistoryImpl), 'isPaused', function () {
  return this.u2t();
});
defineProp(protoOf(LogLevel), 'name', protoOf(LogLevel).v2);
defineProp(protoOf(LogLevel), 'ordinal', protoOf(LogLevel).w2);
defineProp(protoOf(LoggerImpl), 'logLevel', function () {
  return this.k2u();
}, function (value) {
  this.j2u(value);
});
defineProp(protoOf(LoggerWrap), 'logLevel', function () {
  return this.k2u();
}, function (value) {
  this.j2u(value);
});
defineProp(protoOf(DualDouble), 'midPoint', protoOf(DualDouble).y2u);
defineProp(protoOf(DualDouble), 'length', protoOf(DualDouble).a);
protoOf($serializer_2).fx = typeParametersSerializers;
protoOf($serializer_3).fx = typeParametersSerializers;
defineProp(protoOf(ModelTransform), 'transform', protoOf(ModelTransform).z2a);
protoOf($serializer_4).fx = typeParametersSerializers;
defineProp(protoOf(Quaternion), 'eulerDegrees', protoOf(Quaternion).a2x);
protoOf($serializer_5).fx = typeParametersSerializers;
protoOf($serializer_6).fx = typeParametersSerializers;
protoOf(Size).alignBottom = alignBottom;
protoOf(Size).alignTop = alignTop;
protoOf(Size).alignRight = alignRight;
protoOf(Size).alignLeft = alignLeft;
protoOf(Size).alignFront = alignFront;
protoOf(Size).alignBack = alignBack;
defineProp(protoOf(Size), 'width', function () {
  return this.t2u();
});
defineProp(protoOf(Size), 'height', function () {
  return this.u2u();
});
defineProp(protoOf(Size), 'depth', function () {
  return this.v2u();
});
protoOf($serializer_7).fx = typeParametersSerializers;
defineProp(protoOf(Transform), 'forward', protoOf(Transform).i2y);
defineProp(protoOf(Transform), 'up', protoOf(Transform).j2y);
defineProp(protoOf(Transform), 'right', protoOf(Transform).c2v);
protoOf($serializer_8).fx = typeParametersSerializers;
protoOf(Vector).alignBottom = alignBottom;
protoOf(Vector).alignTop = alignTop;
protoOf(Vector).alignRight = alignRight;
protoOf(Vector).alignLeft = alignLeft;
protoOf(Vector).alignFront = alignFront;
protoOf(Vector).alignBack = alignBack;
defineProp(protoOf(Vector), 'width', function () {
  return this.t2u();
});
defineProp(protoOf(Vector), 'height', function () {
  return this.u2u();
});
defineProp(protoOf(Vector), 'depth', function () {
  return this.v2u();
});
defineProp(protoOf(Vector), 'size', protoOf(Vector).o);
defineProp(protoOf(InnerMeasurement), 'distance', protoOf(InnerMeasurement).i2z);
protoOf(DisplayNameComponent).r1s = get_serializable;
protoOf(DisplayNameComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(DisplayNameComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(DisplayNameComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(DisplayNameComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ProppingComponent).r1s = get_serializable;
protoOf(ProppingComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ProppingComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ProppingComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ProppingComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(TemplateDataComponent).r1s = get_serializable;
protoOf(TemplateDataComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(TemplateDataComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(TemplateDataComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(TemplateDataComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(LoadedModelInfoComponent).r1s = get_serializable;
defineProp(protoOf(LoadedModelInfoComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(LoadedModelInfoComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(LoadedModelInfoComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(ModelInfoComponent).r1s = get_serializable;
protoOf(ModelInfoComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ModelInfoComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ModelInfoComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ModelInfoComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ModelLoaderSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ModelLoaderSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ModelLoaderSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ModelLoaderSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ModelLoaderSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ModelLoaderSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ModelLoaderSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ModelLoaderSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(Companion_93), 'id', protoOf(Companion_93).n1s);
protoOf(ModelTransformComponent).r1s = get_serializable;
protoOf(ModelTransformComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ModelTransformComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ModelTransformComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ModelTransformComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(OutlineableComponent).r1s = get_serializable;
protoOf(OutlineableComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(OutlineableComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(OutlineableComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(OutlineableComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(PauseViewerUpdatesComponent).r1s = get_serializable;
protoOf(PauseViewerUpdatesComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(PauseViewerUpdatesComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(PauseViewerUpdatesComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(PauseViewerUpdatesComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(RenderSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(RenderSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(RenderSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(RenderSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(RenderSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(RenderSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(RenderSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(RenderSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(Companion_98), 'id', protoOf(Companion_98).n1s);
protoOf(RenderedComponent).r1s = get_serializable;
protoOf(RenderedComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RenderedComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RenderedComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RenderedComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ViewerComponent).r1s = get_serializable;
protoOf(ViewerComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ViewerComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ViewerComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ViewerComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ViewerLineIdsComponent).r1s = get_serializable;
defineProp(protoOf(ViewerLineIdsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ViewerLineIdsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ViewerLineIdsComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(ViewerObjectComponent).r1s = get_serializable;
defineProp(protoOf(ViewerObjectComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ViewerObjectComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(ViewerObjectComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ViewerObjectTransformSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ViewerObjectTransformSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ViewerObjectTransformSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ViewerObjectTransformSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ViewerObjectTransformSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ViewerObjectTransformSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ViewerObjectTransformSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ViewerObjectTransformSystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(ViewerObjectVisibilitySystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ViewerObjectVisibilitySystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ViewerObjectVisibilitySystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ViewerObjectVisibilitySystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ViewerObjectVisibilitySystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ViewerObjectVisibilitySystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ViewerObjectVisibilitySystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ViewerObjectVisibilitySystem), 'isEnabled', function () {
  return this.s1w();
});
defineProp(protoOf(ViewerPresenceSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(ViewerPresenceSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(ViewerPresenceSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(ViewerPresenceSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(ViewerPresenceSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(ViewerPresenceSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(ViewerPresenceSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(ViewerPresenceSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf(SlowReplaceInProgressComponent).r1s = get_serializable;
protoOf(SlowReplaceInProgressComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SlowReplaceInProgressComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SlowReplaceInProgressComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SlowReplaceInProgressComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(ClickEventComponent).r1s = get_serializable;
protoOf(ClickEventComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(ClickEventComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(ClickEventComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(ClickEventComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(MultiSelectionEnabledComponent_0).r1s = get_serializable;
protoOf(MultiSelectionEnabledComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(MultiSelectionEnabledComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(MultiSelectionEnabledComponent_0), 'id', protoOf(MultiSelectionEnabledComponent_0).n1s);
defineProp(protoOf(MultiSelectionEnabledComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(MultiSelectionEnabledComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(SelectableComponent).r1s = get_serializable;
protoOf(SelectableComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SelectableComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SelectableComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SelectableComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(SelectedComponent).r1s = get_serializable;
protoOf(SelectedComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SelectedComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SelectedComponent), 'id', protoOf(SelectedComponent).n1s);
defineProp(protoOf(SelectedComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SelectedComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_9).fx = typeParametersSerializers;
defineProp(protoOf(ComponentDeserializerRegistry), 'componentDeserializers', protoOf(ComponentDeserializerRegistry).i37);
defineProp(protoOf(DeserializationInterceptorRegistry), 'interceptors', protoOf(DeserializationInterceptorRegistry).k37);
protoOf(PreviouslySerializedIdComponent).r1s = get_serializable;
protoOf(PreviouslySerializedIdComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(PreviouslySerializedIdComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(PreviouslySerializedIdComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(PreviouslySerializedIdComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_111), 'id', protoOf(Companion_111).n1s);
protoOf(SceneReloadingComponent).r1s = get_serializable;
protoOf(SceneReloadingComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SceneReloadingComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SceneReloadingComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SceneReloadingComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_10).fx = typeParametersSerializers;
protoOf($serializer_11).fx = typeParametersSerializers;
protoOf(SerializableGuestConnectionsComponent).r1s = get_serializable_0;
protoOf(SerializableGuestConnectionsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SerializableGuestConnectionsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SerializableGuestConnectionsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SerializableGuestConnectionsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(SerializableRootComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SerializableRootComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SerializableRootComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SerializableRootComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(SerializableSceneComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SerializableSceneComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SerializableSceneComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SerializableSceneComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_116), 'id', protoOf(Companion_116).n1s);
protoOf(UnserializableEntityComponent).r1s = get_serializable;
protoOf(UnserializableEntityComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(UnserializableEntityComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(UnserializableEntityComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(UnserializableEntityComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_12).fx = typeParametersSerializers;
protoOf(InterceptingAssemblyPartCatalog).productSpecification = productSpecification;
protoOf(InterceptingAssemblyPartCatalog).createCustomAssembly = createCustomAssembly;
protoOf(InterceptingAssemblyPartCatalog).createCustomAssemblySpecification = createCustomAssemblySpecification;
protoOf(InterceptingAssemblyPartCatalog).beforeDeserialize = beforeDeserialize;
protoOf(InterceptingAssemblyPartCatalog).beforeParsingComponents = beforeParsingComponents;
protoOf(InterceptingAssemblyPartCatalog).beforeBuildingEntities = beforeBuildingEntities;
protoOf(InterceptingAssemblyPartCatalog).afterDeserializeComplete = afterDeserializeComplete;
defineProp(protoOf(InterceptingAssemblyPartCatalog), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
  return this.s1t();
});
protoOf(GroupInfoDuringDeserializingComponent).r1s = get_serializable;
protoOf(GroupInfoDuringDeserializingComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(GroupInfoDuringDeserializingComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(GroupInfoDuringDeserializingComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(GroupInfoDuringDeserializingComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_13).fx = typeParametersSerializers;
protoOf(SerializableEntityV13).addComponent = addComponent;
defineProp(protoOf(SerializableEntityV13), 'id', function () {
  return this.n1s();
}, function (value) {
  this.d38(value);
});
defineProp(protoOf(SerializableEntityV13), 'ref', function () {
  return this.f38();
}, function (value) {
  this.e38(value);
});
defineProp(protoOf(SerializableEntityV13), 'parent', function () {
  return this.a2p();
}, function (value) {
  this.g38(value);
});
defineProp(protoOf(SerializableEntityV13), 'components', function () {
  return this.l1u();
}, function (value) {
  this.j38(value);
});
protoOf($serializer_14).fx = typeParametersSerializers;
protoOf(SerializableTreeV13).entitiesArray = entitiesArray;
defineProp(protoOf(SerializableTreeV13), 'roots', function () {
  return this.j39();
});
defineProp(protoOf(SerializableTreeV13), 'version', function () {
  return this.c37();
});
defineProp(protoOf(AxisAlignedBox), 'center', protoOf(AxisAlignedBox).o3b);
defineProp(protoOf(AxisAlignedBox), 'width', protoOf(AxisAlignedBox).t2u);
defineProp(protoOf(AxisAlignedBox), 'height', protoOf(AxisAlignedBox).u2u);
defineProp(protoOf(AxisAlignedBox), 'depth', protoOf(AxisAlignedBox).v2u);
defineProp(protoOf(AxisAlignedBox), 'size', protoOf(AxisAlignedBox).o);
defineProp(protoOf(ConvexPolyhedron), 'axisAlignedBoundingBox', function () {
  return this.u3b();
});
defineProp(protoOf(ConvexPolyhedron), 'unsignedNormals', function () {
  return this.v3b();
});
defineProp(protoOf(Cuboid), 'size', protoOf(Cuboid).o);
protoOf(PolyhedronGroup).transform = transform;
defineProp(protoOf(PolyhedronGroup), 'axisAlignedBoundingBox', function () {
  return this.u3b();
});
defineProp(protoOf(Companion_129), 'id', protoOf(Companion_129).n1s);
protoOf(MovedToCandidateSnapPositionComponent).r1s = get_serializable;
protoOf(MovedToCandidateSnapPositionComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(MovedToCandidateSnapPositionComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(MovedToCandidateSnapPositionComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(MovedToCandidateSnapPositionComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(MovedToValidSnapPositionComponent).r1s = get_serializable;
protoOf(MovedToValidSnapPositionComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(MovedToValidSnapPositionComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(MovedToValidSnapPositionComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(MovedToValidSnapPositionComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_131), 'id', protoOf(Companion_131).n1s);
protoOf(RestrictAllowedRequiredHostsComponent).r1s = get_serializable;
protoOf(RestrictAllowedRequiredHostsComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RestrictAllowedRequiredHostsComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RestrictAllowedRequiredHostsComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RestrictAllowedRequiredHostsComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Snap), 'guestRootToGuestDeltaTransform', protoOf(Snap).a3d);
defineProp(protoOf(Snap), 'guestRootToGuestConnectorDeltaTransform', protoOf(Snap).b3d);
defineProp(protoOf(Snap), 'guestEndTransform', protoOf(Snap).c3d);
defineProp(protoOf(Snap), 'isAlignmentSnap', protoOf(Snap).d3d);
protoOf(SnapActionInProgressComponent).r1s = get_serializable;
protoOf(SnapActionInProgressComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SnapActionInProgressComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SnapActionInProgressComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SnapActionInProgressComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(Companion_134), 'id', protoOf(Companion_134).n1s);
protoOf(SnapCandidateComponent).r1s = get_serializable;
protoOf(SnapCandidateComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SnapCandidateComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SnapCandidateComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SnapCandidateComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(SnapRootComponent).r1s = get_serializable;
protoOf(SnapRootComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SnapRootComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SnapRootComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SnapRootComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(SnapSettings), 'includeAllSubConnectors', function () {
  return this.v3d();
});
defineProp(protoOf(SnapSettings), 'includeInternalConnectors', function () {
  return this.w3d();
});
defineProp(protoOf(SnapSettings), 'includeHostAssemblyParts', function () {
  return this.x3d();
});
defineProp(protoOf(SnapSettings), 'includeAlignmentConnectorsOutsideActivationDistance', function () {
  return this.y3d();
});
defineProp(protoOf(Companion_138), 'id', protoOf(Companion_138).n1s);
protoOf(IsLoadingSnapshotComponent).r1s = get_serializable;
defineProp(protoOf(IsLoadingSnapshotComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(IsLoadingSnapshotComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(IsLoadingSnapshotComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(SnapshotIgnoreComponent).r1s = get_serializable;
protoOf(SnapshotIgnoreComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(SnapshotIgnoreComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(SnapshotIgnoreComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(SnapshotIgnoreComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(SnapshotImpl), 'name', function () {
  return this.v2();
});
defineProp(protoOf(SnapshotImpl), 'allEntityStates', function () {
  return this.r3e();
});
protoOf(UpdatedFromSnapshotEventComponent).r1s = get_serializable;
defineProp(protoOf(UpdatedFromSnapshotEventComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(UpdatedFromSnapshotEventComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(UpdatedFromSnapshotEventComponent), 'serializable', function () {
  return this.r1s();
});
protoOf(AlwaysHangDownComponent_0).r1s = get_serializable;
protoOf(AlwaysHangDownComponent_0).s1s = get_doStoreInSnapshot;
defineProp(protoOf(AlwaysHangDownComponent_0), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(AlwaysHangDownComponent_0), 'id', protoOf(AlwaysHangDownComponent_0).n1s);
defineProp(protoOf(AlwaysHangDownComponent_0), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(AlwaysHangDownComponent_0), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf($serializer_15).fx = typeParametersSerializers;
protoOf(LocalTransformComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(LocalTransformComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(LocalTransformComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(LocalTransformComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(TransformSystem), 'id', function () {
  return this.n1s();
});
defineProp(protoOf(TransformSystem), 'doingChangesOnComponent', function () {
  return this.j1w();
});
defineProp(protoOf(TransformSystem), 'systemsBeforeMe', function () {
  return this.k1w();
});
defineProp(protoOf(TransformSystem), 'systemsAfterMe', function () {
  return this.l1w();
});
defineProp(protoOf(TransformSystem), 'mandatoryComponents', function () {
  return this.m1w();
});
defineProp(protoOf(TransformSystem), 'ignoreEntitiesWithComponents', function () {
  return this.n1w();
});
defineProp(protoOf(TransformSystem), 'componentListeners', function () {
  return this.o1w();
});
defineProp(protoOf(TransformSystem), 'isEnabled', function () {
  return this.s1w();
});
protoOf($serializer_16).fx = typeParametersSerializers;
protoOf(WorldTransformComponent).r1s = get_serializable_0;
protoOf(WorldTransformComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(WorldTransformComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(WorldTransformComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(WorldTransformComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(SnapValidationResult), 'errors', protoOf(SnapValidationResult).c3h);
defineProp(protoOf(SnapValidationResult), 'warnings', protoOf(SnapValidationResult).d3h);
defineProp(protoOf(SnapValidationResult), 'valid', protoOf(SnapValidationResult).e3h);
defineProp(protoOf(ValidSnapActionCandidateOrErrors), 'valid', protoOf(ValidSnapActionCandidateOrErrors).e3h);
defineProp(protoOf(ValidationResultType), 'name', protoOf(ValidationResultType).v2);
defineProp(protoOf(ValidationResultType), 'ordinal', protoOf(ValidationResultType).w2);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_3 = new Companion_3();
Companion_instance_6 = new Companion_6();
Companion_instance_8 = new Companion_8();
Companion_instance_10 = new Companion_10();
Companion_instance_14 = new Companion_14();
Companion_instance_15 = new Companion_15();
Companion_instance_16 = new Companion_16();
Companion_instance_17 = new Companion_17();
Companion_instance_18 = new Companion_18();
Companion_instance_19 = new Companion_19();
Companion_instance_20 = new Companion_20();
Companion_instance_21 = new Companion_21();
Companion_instance_22 = new Companion_22();
Companion_instance_23 = new Companion_23();
Companion_instance_25 = new Companion_25();
Companion_instance_29 = new Companion_29();
Companion_instance_30 = new Companion_30();
Companion_instance_31 = new Companion_31();
ConnectorTagConstants_instance = new ConnectorTagConstants();
Companion_instance_32 = new Companion_32();
Companion_instance_33 = new Companion_33();
Companion_instance_35 = new Companion_35();
Companion_instance_37 = new Companion_37();
Companion_instance_39 = new Companion_39();
Companion_instance_47 = new Companion_47();
Companion_instance_56 = new Companion_56();
Companion_instance_60 = new Companion_60();
Companion_instance_61 = new Companion_61();
Companion_instance_62 = new Companion_62();
Companion_instance_63 = new Companion_63();
SceneComponent_instance = new SceneComponent_0();
Companion_instance_65 = new Companion_65();
Companion_instance_68 = new Companion_68();
Companion_instance_70 = new Companion_70();
Companion_instance_71 = new Companion_71();
Companion_instance_72 = new Companion_72();
Companion_instance_74 = new Companion_74();
Companion_instance_75 = new Companion_75();
Companion_instance_76 = new Companion_76();
Companion_instance_77 = new Companion_77();
Companion_instance_85 = new Companion_85();
Companion_instance_88 = new Companion_88();
Companion_instance_89 = new Companion_89();
Companion_instance_93 = new Companion_93();
Companion_instance_97 = new Companion_97();
Companion_instance_98 = new Companion_98();
Companion_instance_101 = new Companion_101();
Companion_instance_102 = new Companion_102();
Companion_instance_104 = new Companion_104();
MultiSelectionEnabledComponent_instance = new MultiSelectionEnabledComponent_0();
Companion_instance_111 = new Companion_111();
Companion_instance_112 = new Companion_112();
Companion_instance_116 = new Companion_116();
Companion_instance_117 = new Companion_117();
Companion_instance_118 = new Companion_118();
Companion_instance_127 = new Companion_127();
Companion_instance_129 = new Companion_129();
Companion_instance_131 = new Companion_131();
Companion_instance_134 = new Companion_134();
Companion_instance_135 = new Companion_135();
Companion_instance_137 = new Companion_137();
Companion_instance_138 = new Companion_138();
AlwaysHangDownComponent_instance = new AlwaysHangDownComponent_0();
Companion_instance_143 = new Companion_143();
Companion_instance_145 = new Companion_145();
Companion_instance_146 = new Companion_146();
Companion_instance_147 = new Companion_147();
UrlHelper_instance = new UrlHelper();
Companion_instance_149 = new Companion_149();
Companion_instance_150 = new Companion_150();
Companion_instance_151 = new Companion_151();
Companion_instance_152 = new Companion_152();
Companion_instance_153 = new Companion_153();
//endregion
//region block: exports
defineProp(AssemblyPartIdsComponent, 'Companion', Companion_getInstance_1);
AssemblyPartsComponent.fromPartPairs = fromPartPairs;
defineProp(AssemblyPartsComponent, 'Companion', Companion_getInstance_2);
defineProp(AssemblyStructureComponent, 'Companion', Companion_getInstance_3);
defineProp(ProductPartComponent, 'Companion', Companion_getInstance_5);
defineProp(CatalogSizeComponent, 'Companion', Companion_getInstance_6);
ProductCatalogFunctions.getPartsMap = getPartsMap;
ProductCatalogFunctions.createAssemblyPartsComponent = createAssemblyPartsComponent_0;
ProductCatalogFunctions.createAssemblyParts = createAssemblyParts_0;
defineProp(ProductCatalogFunctions, 'Companion', Companion_getInstance_7);
defineProp(ProductComponent, 'Companion', Companion_getInstance_8);
defineProp(ProductParams, 'Companion', Companion_getInstance_9);
defineProp(ProductParamsComponent, 'Companion', Companion_getInstance_10);
defineProp(ProductStructureComponent, 'Companion', Companion_getInstance_11);
defineProp(ColliderComponent, 'Companion', Companion_getInstance_13);
defineProp(ColliderShapeComponent, 'Companion', Companion_getInstance_14);
ColliderUtils.colliderShapeComponent = colliderShapeComponent;
ColliderUtils.colliderComponent = colliderComponent;
ColliderUtils.axisAlignedBoundingBoxForHierarchy = axisAlignedBoundingBoxForHierarchy;
ColliderUtils.objectOrientedBoundingBoxForHierarchy = objectOrientedBoundingBoxForHierarchy;
ColliderUtils.objectOrientedBoundingBoxForAssemblyHierarchy = objectOrientedBoundingBoxForAssemblyHierarchy;
defineProp(ColliderUtils, 'Companion', Companion_getInstance_15);
CollisionUtils.getAllCollisions = getAllCollisions;
CollisionUtils.getFirstCollision = getFirstCollision;
defineProp(CollisionUtils, 'Companion', Companion_getInstance_17);
defineProp(CollisionValidation, 'Companion', Companion_getInstance_18);
defineProp(CollisionValidationResult, 'Companion', Companion_getInstance_19);
defineProp(ComponentIdSpan, 'CORE_BASE_ID', get_CORE_BASE_ID);
defineProp(ComponentIdSpan, 'PAX_RANGE_BASE_ID', get_PAX_RANGE_BASE_ID);
defineProp(ComponentIdSpan, 'BESTA_RANGE_BASE_ID', get_BESTA_RANGE_BASE_ID);
defineProp(ComponentIdSpan, 'STORAGEONE_RANGE_BASE_ID', get_STORAGEONE_RANGE_BASE_ID);
defineProp(ComponentIdSpan, 'SNYGGIS_BASE_ID', get_SNYGGIS_BASE_ID);
defineProp(ComponentIdSpan, 'CONCEPT_PLANNER_BASE_ID', get_CONCEPT_PLANNER_BASE_ID);
defineProp(ComponentIdSpan, 'PAX_PLANNER_BASE_ID', get_PAX_PLANNER_BASE_ID);
defineProp(ComponentIdSpan, 'BESTA_PLANNER_BASE_ID', get_BESTA_PLANNER_BASE_ID);
defineProp(ComponentIdSpan, 'SPACE_PLANNER_BASE_ID', get_SPACE_PLANNER_BASE_ID);
defineProp(ComponentIdSpan, 'SKYTTA_PLANNER_BASE_ID', get_SKYTTA_PLANNER_BASE_ID);
defineProp(ComponentIdSpan, 'WALL_DECO_PLANNER_BASE_ID', get_WALL_DECO_PLANNER_BASE_ID);
defineProp(ComponentIdSpan, 'CORE_TOOLBOX_BASE_ID', get_CORE_TOOLBOX_BASE_ID);
defineProp(ComponentIdSpan, 'CORE_TOOLBOX_EXPERIMENTAL_BASE_ID', get_CORE_TOOLBOX_EXPERIMENTAL_BASE_ID);
defineProp(ComponentIdSpan, 'KVADRAT_BASE_ID', get_KVADRAT_BASE_ID);
defineProp(ComponentIdSpan, 'CORE_COMMUNITY_BASE_ID', get_CORE_COMMUNITY_BASE_ID);
defineProp(ComponentIdSpan, 'SOFA_BASE_ID', get_SOFA_BASE_ID);
defineProp(ComponentIdSpan, 'KITCHEN_CONFIGURATOR_BASE_ID', get_KITCHEN_CONFIGURATOR_BASE_ID);
defineProp(ComponentIdSpan, 'Companion', Companion_getInstance_21);
ComponentIds.isCoreComponent = isCoreComponent;
ComponentIds.isCoreComponentId = isCoreComponentId;
defineProp(ComponentIds, 'SELECTED_COMPONENT_ID', get_SELECTED_COMPONENT_ID);
defineProp(ComponentIds, 'SELECTABLE_COMPONENT_ID', get_SELECTABLE_COMPONENT_ID);
defineProp(ComponentIds, 'PROPPING_HOST_CONNECTORS_COMPONENT_ID', get_PROPPING_HOST_CONNECTORS_COMPONENT_ID);
defineProp(ComponentIds, 'DRAGGABLE_COMPONENT_ID', get_DRAGGABLE_COMPONENT_ID);
defineProp(ComponentIds, 'COLLISION_VISUALIZATION_SCENE_DATA_COMPONENT_ID', get_COLLISION_VISUALIZATION_SCENE_DATA_COMPONENT_ID);
defineProp(ComponentIds, 'IN_SCENE_COMPONENT_ID', get_IN_SCENE_COMPONENT_ID);
defineProp(ComponentIds, 'LOCAL_TRANSFORM_COMPONENT_ID', get_LOCAL_TRANSFORM_COMPONENT_ID);
defineProp(ComponentIds, 'PROPPING_COMPONENT_ID', get_PROPPING_COMPONENT_ID);
defineProp(ComponentIds, 'RESTRICT_ALLOWED_REQUIRED_HOSTS_COMPONENT_ID', get_RESTRICT_ALLOWED_REQUIRED_HOSTS_COMPONENT_ID);
defineProp(ComponentIds, 'RENDERED_COMPONENT_ID', get_RENDERED_COMPONENT_ID);
defineProp(ComponentIds, 'WORLD_TRANSFORM_COMPONENT_ID', get_WORLD_TRANSFORM_COMPONENT_ID);
defineProp(ComponentIds, 'CONNECTORS_COMPONENT_ID', get_CONNECTORS_COMPONENT_ID);
defineProp(ComponentIds, 'ASSEMBLY_STRUCTURE_COMPONENT_ID', get_ASSEMBLY_STRUCTURE_COMPONENT_ID);
defineProp(ComponentIds, 'MODEL_INFO_COMPONENT_ID', get_MODEL_INFO_COMPONENT_ID);
defineProp(ComponentIds, 'OUTLINED_COMPONENT_ID', get_OUTLINED_COMPONENT_ID);
defineProp(ComponentIds, 'DISPLAY_NAME_COMPONENT_ID', get_DISPLAY_NAME_COMPONENT_ID);
defineProp(ComponentIds, 'PARENT_COMPONENT_ID', get_PARENT_COMPONENT_ID);
defineProp(ComponentIds, 'CHILD_COMPONENT_ID', get_CHILD_COMPONENT_ID);
defineProp(ComponentIds, 'PRODUCT_COMPONENT_ID', get_PRODUCT_COMPONENT_ID);
defineProp(ComponentIds, 'COLLIDER_SHAPE_COMPONENT_ID', get_COLLIDER_SHAPE_COMPONENT_ID);
defineProp(ComponentIds, 'LOADED_MODEL_INFO_COMPONENT_ID', get_LOADED_MODEL_INFO_COMPONENT_ID);
defineProp(ComponentIds, 'SNAP_CANDIDATE_COMPONENT_ID', get_SNAP_CANDIDATE_COMPONENT_ID);
defineProp(ComponentIds, 'CONNECTOR_VISUALIZATION_NODE_COMPONENT_ID', get_CONNECTOR_VISUALIZATION_NODE_COMPONENT_ID);
defineProp(ComponentIds, 'COLLIDER_VISUALIZATION_NODE_COMPONENT_ID', get_COLLIDER_VISUALIZATION_NODE_COMPONENT_ID);
defineProp(ComponentIds, 'COLLIDER_COMPONENT_ID', get_COLLIDER_COMPONENT_ID);
defineProp(ComponentIds, 'UNSERIALIZABLE_ENTITY_COMPONENT_ID', get_UNSERIALIZABLE_ENTITY_COMPONENT_ID);
defineProp(ComponentIds, 'ALWAYS_HANG_DOWN_COMPONENT_ID', get_ALWAYS_HANG_DOWN_COMPONENT_ID);
defineProp(ComponentIds, 'VIEWER_CAMERA_STATE_COMPONENT_ID', get_VIEWER_CAMERA_STATE_COMPONENT_ID);
defineProp(ComponentIds, 'CONNECTION_ROOT_COMPONENT', get_CONNECTION_ROOT_COMPONENT);
defineProp(ComponentIds, 'ALLOWED_DOOR_PAIRS_COMPONENT_ID', get_ALLOWED_DOOR_PAIRS_COMPONENT_ID);
defineProp(ComponentIds, 'DOOR_COMPONENT_ID', get_DOOR_COMPONENT_ID);
defineProp(ComponentIds, 'FRAME_COMPONENT_ID', get_FRAME_COMPONENT_ID);
defineProp(ComponentIds, 'DOOR_FRONT_COMPONENT_ID', get_DOOR_FRONT_COMPONENT_ID);
defineProp(ComponentIds, 'COMMUNICATION_SIZE_COMPONENT_ID', get_COMMUNICATION_SIZE_COMPONENT_ID);
defineProp(ComponentIds, 'SNAP_ACTION_IN_PROGRESS_COMPONENT', get_SNAP_ACTION_IN_PROGRESS_COMPONENT);
defineProp(ComponentIds, 'VIEWER_OBJECT_COMPONENT_ID', get_VIEWER_OBJECT_COMPONENT_ID);
defineProp(ComponentIds, 'IS_LOADING_SNAPSHOT_COMPONENT_ID', get_IS_LOADING_SNAPSHOT_COMPONENT_ID);
defineProp(ComponentIds, 'AUTOMATIC_ENTITY_GROUP_COMPONENT_ID', get_AUTOMATIC_ENTITY_GROUP_COMPONENT_ID);
defineProp(ComponentIds, 'HANDLE_COMPONENT_ID', get_HANDLE_COMPONENT_ID);
defineProp(ComponentIds, 'META_DATA_COMPONENT_ID', get_META_DATA_COMPONENT_ID);
defineProp(ComponentIds, 'ROOM_DIMENSIONS_COMPONENT_ID', get_ROOM_DIMENSIONS_COMPONENT_ID);
defineProp(ComponentIds, 'RELATIVE_CONNECTORS_COMPONENT_ID', get_RELATIVE_CONNECTORS_COMPONENT_ID);
defineProp(ComponentIds, 'ASSEMBLY_PARTS_COMPONENT_ID', get_ASSEMBLY_PARTS_COMPONENT_ID);
defineProp(ComponentIds, 'PRODUCT_PART_COMPONENT_ID', get_PRODUCT_PART_COMPONENT_ID);
defineProp(ComponentIds, 'MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID', get_MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
defineProp(ComponentIds, 'INCLUDED_HANDLE_COMPONENT_ID', get_INCLUDED_HANDLE_COMPONENT_ID);
defineProp(ComponentIds, 'SNAP_ROOT_COMPONENT_ID', get_SNAP_ROOT_COMPONENT_ID);
defineProp(ComponentIds, 'LEG_COMPONENT_ID', get_LEG_COMPONENT_ID);
defineProp(ComponentIds, 'TEMPLATE_DATA_COMPONENT_ID', get_TEMPLATE_DATA_COMPONENT_ID);
defineProp(ComponentIds, 'DRAWER_COMPONENT_ID', get_DRAWER_COMPONENT_ID);
defineProp(ComponentIds, 'ALIGNMENT_CONNECTIONS_COMPONENT_ID', get_ALIGNMENT_CONNECTIONS_COMPONENT_ID);
defineProp(ComponentIds, 'HANDLE_UNDER_ALIGNMENT_COMPONENT_ID', get_HANDLE_UNDER_ALIGNMENT_COMPONENT_ID);
defineProp(ComponentIds, 'ROOM_COMPONENT_ID', get_ROOM_COMPONENT_ID);
defineProp(ComponentIds, 'ROOM_ACTIVE_CONNECTORS_COMPONENT_ID', get_ROOM_ACTIVE_CONNECTORS_COMPONENT_ID);
defineProp(ComponentIds, 'TEMPORARY_PARENT_COMPONENT_ID', get_TEMPORARY_PARENT_COMPONENT_ID);
defineProp(ComponentIds, 'MULTISELECTION_ENABLED_COMPONENT_ID', get_MULTISELECTION_ENABLED_COMPONENT_ID);
defineProp(ComponentIds, 'OUTLINEABLE_COMPONENT_ID', get_OUTLINEABLE_COMPONENT_ID);
defineProp(ComponentIds, 'PLACEMENT_ZONE_BY_HEIGHT_COMPONENT_ID', get_PLACEMENT_ZONE_BY_HEIGHT_COMPONENT_ID);
defineProp(ComponentIds, 'RECOMMENDED_INITIAL_POSITION_FROM_FLOOR_COMPONENT_ID', get_RECOMMENDED_INITIAL_POSITION_FROM_FLOOR_COMPONENT_ID);
defineProp(ComponentIds, 'RECOMMENDED_INITIAL_POSITION_FROM_PARENT_COMPONENT_ID', get_RECOMMENDED_INITIAL_POSITION_FROM_PARENT_COMPONENT_ID);
defineProp(ComponentIds, 'FUNCTIONAL_MARGIN_SHAPE_COMPONENT_ID', get_FUNCTIONAL_MARGIN_SHAPE_COMPONENT_ID);
defineProp(ComponentIds, 'FUNCTIONAL_MARGIN_COMPONENT_ID', get_FUNCTIONAL_MARGIN_COMPONENT_ID);
defineProp(ComponentIds, 'LIGHT_COMPONENT_ID', get_LIGHT_COMPONENT_ID);
defineProp(ComponentIds, 'ROOM_ALIGNMENT_EDGES_COMPONENT_ID', get_ROOM_ALIGNMENT_EDGES_COMPONENT_ID);
defineProp(ComponentIds, 'IS_DRAGGED_COMPONENT_ID', get_IS_DRAGGED_COMPONENT_ID);
defineProp(ComponentIds, 'SOMETHING_IS_DRAGGED_COMPONENT_ID', get_SOMETHING_IS_DRAGGED_COMPONENT_ID);
defineProp(ComponentIds, 'FREE_MOVE_COMPONENT_ID', get_FREE_MOVE_COMPONENT_ID);
defineProp(ComponentIds, 'MOVED_TO_CANDIDATE_SNAP_POSITION_COMPONENT_ID', get_MOVED_TO_CANDIDATE_SNAP_POSITION_COMPONENT_ID);
defineProp(ComponentIds, 'DRAG_STATE_COMPONENT', get_DRAG_STATE_COMPONENT);
defineProp(ComponentIds, 'ROOM_GEOMETRY_COMPONENT_ID', get_ROOM_GEOMETRY_COMPONENT_ID);
defineProp(ComponentIds, 'DISABLED_CONNECTOR_KEYS_COMPONENT_ID', get_DISABLED_CONNECTOR_KEYS_COMPONENT_ID);
defineProp(ComponentIds, 'VISUAL_LIGHT_SOURCE_COMPONENT_ID', get_VISUAL_LIGHT_SOURCE_COMPONENT_ID);
defineProp(ComponentIds, 'SCENE_RELOADING_COMPONENT_ID', get_SCENE_RELOADING_COMPONENT_ID);
defineProp(ComponentIds, 'DRAG_SURFACES_COMPONENT_ID', get_DRAG_SURFACES_COMPONENT_ID);
defineProp(ComponentIds, 'DISABLED_ROOM_CONNECTORS_COMPONENT_ID', get_DISABLED_ROOM_CONNECTORS_COMPONENT_ID);
defineProp(ComponentIds, 'SERIALIZABLE_SCENE_COMPONENT', get_SERIALIZABLE_SCENE_COMPONENT);
defineProp(ComponentIds, 'ENTITY_CONNECTOR_VISUALIZATION_COMPONENT_ID', get_ENTITY_CONNECTOR_VISUALIZATION_COMPONENT_ID);
defineProp(ComponentIds, 'ENTITY_COLLIDER_VISUALIZATION_COMPONENT_ID', get_ENTITY_COLLIDER_VISUALIZATION_COMPONENT_ID);
defineProp(ComponentIds, 'ENTITY_HOST_ZONE_VISUALIZATION_COMPONENT_ID', get_ENTITY_HOST_ZONE_VISUALIZATION_COMPONENT_ID);
defineProp(ComponentIds, 'ENTITY_FUNCTIONAL_ZONE_VISUALIZATION_COMPONENT_ID', get_ENTITY_FUNCTIONAL_ZONE_VISUALIZATION_COMPONENT_ID);
defineProp(ComponentIds, 'DRAG_SURFACE_ENTITY_PAIR_CACHE_COMPONENT', get_DRAG_SURFACE_ENTITY_PAIR_CACHE_COMPONENT);
defineProp(ComponentIds, 'VIEWER_COMPONENT_ID', get_VIEWER_COMPONENT_ID);
defineProp(ComponentIds, 'DECORATOR_COMPONENT_ID', get_DECORATOR_COMPONENT_ID);
defineProp(ComponentIds, 'VIEWER_DRAG_EVENT_COMPONENT_ID', get_VIEWER_DRAG_EVENT_COMPONENT_ID);
defineProp(ComponentIds, 'WORLD_SPACE_DRAG_EVENT_COMPONENT_ID', get_WORLD_SPACE_DRAG_EVENT_COMPONENT_ID);
defineProp(ComponentIds, 'CLICK_EVENT_COMPONENT_ID', get_CLICK_EVENT_COMPONENT_ID);
defineProp(ComponentIds, 'PROPPING_INFO_COMPONENT_ID', get_PROPPING_INFO_COMPONENT_ID);
defineProp(ComponentIds, 'HISTORY_CHANGED_EVENT_COMPONENT_ID', get_HISTORY_CHANGED_EVENT_COMPONENT_ID);
defineProp(ComponentIds, 'SERIALIZABLE_ROOT_COMPONENT_ID', get_SERIALIZABLE_ROOT_COMPONENT_ID);
defineProp(ComponentIds, 'PAUSE_VIEWER_UPDATES_COMPONENT', get_PAUSE_VIEWER_UPDATES_COMPONENT);
defineProp(ComponentIds, 'WORLD_DRAG_SURFACES_COMPONENT_ID', get_WORLD_DRAG_SURFACES_COMPONENT_ID);
defineProp(ComponentIds, 'DEBUG_LINES_COMPONENT', get_DEBUG_LINES_COMPONENT);
defineProp(ComponentIds, 'VIEWER_LINE_IDS_COMPONENT', get_VIEWER_LINE_IDS_COMPONENT);
defineProp(ComponentIds, 'GRAB_OFFSET_COMPONENT_ID', get_GRAB_OFFSET_COMPONENT_ID);
defineProp(ComponentIds, 'SNAPSHOT_IGNORE_COMPONENT', get_SNAPSHOT_IGNORE_COMPONENT);
defineProp(ComponentIds, 'ASSEMBLY_PART_IDS_COMPONENT_ID', get_ASSEMBLY_PART_IDS_COMPONENT_ID);
defineProp(ComponentIds, 'SCENE_COMPONENT_ID', get_SCENE_COMPONENT_ID);
defineProp(ComponentIds, 'COLLIDER_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID', get_COLLIDER_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID);
defineProp(ComponentIds, 'CONNECTOR_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID', get_CONNECTOR_VISUALIZER_VIEWER_OBJECTS_COMPONENT_ID);
defineProp(ComponentIds, 'PREVIOUSLY_SERIALIZED_ID_COMPONENT_ID', get_PREVIOUSLY_SERIALIZED_ID_COMPONENT_ID);
defineProp(ComponentIds, 'STATIC_COMPONENT_ID', get_STATIC_COMPONENT_ID);
defineProp(ComponentIds, 'POLYHEDRON_VISUALIZATION_HOLDER_COMPONENT_ID', get_POLYHEDRON_VISUALIZATION_HOLDER_COMPONENT_ID);
defineProp(ComponentIds, 'ROOM_PART_COMPONENT_ID', get_ROOM_PART_COMPONENT_ID);
defineProp(ComponentIds, 'GUEST_CONNECTIONS_COMPONENT_ID', get_GUEST_CONNECTIONS_COMPONENT_ID);
defineProp(ComponentIds, 'HOST_CONNECTIONS_COMPONENT_ID', get_HOST_CONNECTIONS_COMPONENT_ID);
defineProp(ComponentIds, 'SERIALIZABLE_CONNECTIONS_COMPONENT_ID', get_SERIALIZABLE_CONNECTIONS_COMPONENT_ID);
defineProp(ComponentIds, 'TEMPORARILY_PAUSE_CONNECTIONS_PARENTING_COMPONENT_ID', get_TEMPORARILY_PAUSE_CONNECTIONS_PARENTING_COMPONENT_ID);
defineProp(ComponentIds, 'POLYHEDRON_VISUALIZATION_NODE_COMPONENT_ID', get_POLYHEDRON_VISUALIZATION_NODE_COMPONENT_ID);
defineProp(ComponentIds, 'COLLIDER_VISUALIZATION_CONFIG_COMPONENT_ID', get_COLLIDER_VISUALIZATION_CONFIG_COMPONENT_ID);
defineProp(ComponentIds, 'CONNECTOR_VISUALIZATION_CONFIG_COMPONENT_ID', get_CONNECTOR_VISUALIZATION_CONFIG_COMPONENT_ID);
defineProp(ComponentIds, 'OUTLINE_BLOCKING_COMPONENT_ID', get_OUTLINE_BLOCKING_COMPONENT_ID);
defineProp(ComponentIds, 'LABEL_COMPONENT_ID', get_LABEL_COMPONENT_ID);
defineProp(ComponentIds, 'DRAG_PROJECTION_POINT_COMPONENT_ID', get_DRAG_PROJECTION_POINT_COMPONENT_ID);
defineProp(ComponentIds, 'COLORED_OUTLINE_COMPONENT_ID', get_COLORED_OUTLINE_COMPONENT_ID);
defineProp(ComponentIds, 'AUTOMATIC_GROUP_ID_COUNT_COMPONENT_ID', get_AUTOMATIC_GROUP_ID_COUNT_COMPONENT_ID);
defineProp(ComponentIds, 'SCENE_MANAGER_CACHE_COMPONENT_ID', get_SCENE_MANAGER_CACHE_COMPONENT_ID);
defineProp(ComponentIds, 'PRODUCT_STRUCTURE_COMPONENT_ID', get_PRODUCT_STRUCTURE_COMPONENT_ID);
defineProp(ComponentIds, 'CAMERA_COMPONENT_ID', get_CAMERA_COMPONENT_ID);
defineProp(ComponentIds, 'DEBUG_SURFACES_COMPONENT', get_DEBUG_SURFACES_COMPONENT);
defineProp(ComponentIds, 'FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID', get_FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID);
defineProp(ComponentIds, 'FUNCTIONAL_ZONES_WORLD_COMPONENT_ID', get_FUNCTIONAL_ZONES_WORLD_COMPONENT_ID);
defineProp(ComponentIds, 'UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID', get_UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID);
defineProp(ComponentIds, 'MODEL_TRANSFORM_COMPONENT_ID', get_MODEL_TRANSFORM_COMPONENT_ID);
defineProp(ComponentIds, 'AUTO_ADAPT_SESSION_COMPONENT_ID', get_AUTO_ADAPT_SESSION_COMPONENT_ID);
defineProp(ComponentIds, 'AUTO_ADAPT_GUEST_COMPONENT_ID', get_AUTO_ADAPT_GUEST_COMPONENT_ID);
defineProp(ComponentIds, 'AUTO_ADAPT_HOST_COMPONENT_ID', get_AUTO_ADAPT_HOST_COMPONENT_ID);
defineProp(ComponentIds, 'AUTO_ADAPT_CACHED_VARIANTS_COMPONENT_ID', get_AUTO_ADAPT_CACHED_VARIANTS_COMPONENT_ID);
defineProp(ComponentIds, 'AUTO_ADAPT_VARIANT_COMPONENT_ID', get_AUTO_ADAPT_VARIANT_COMPONENT_ID);
defineProp(ComponentIds, 'FORCE_AUTO_ADAPT_WHEN_PARENT_IS_DRAGGED_COMPONENT_ID', get_FORCE_AUTO_ADAPT_WHEN_PARENT_IS_DRAGGED_COMPONENT_ID);
defineProp(ComponentIds, 'REPLACED_WITH_AUTO_ADAPT_EVENT_COMPONENT_ID', get_REPLACED_WITH_AUTO_ADAPT_EVENT_COMPONENT_ID);
defineProp(ComponentIds, 'AUTO_ADAPT_CHILD_FAILED_EVENT_COMPONENT_ID', get_AUTO_ADAPT_CHILD_FAILED_EVENT_COMPONENT_ID);
defineProp(ComponentIds, 'AUTO_ADAPT_PRODUCT_SPECIFICATIONS_COMPONENT_ID', get_AUTO_ADAPT_PRODUCT_SPECIFICATIONS_COMPONENT_ID);
defineProp(ComponentIds, 'VISUALIZATION_ENTITY_COMPONENT_ID', get_VISUALIZATION_ENTITY_COMPONENT_ID);
defineProp(ComponentIds, 'ROOM_PART_ID_COMPONENT_ID', get_ROOM_PART_ID_COMPONENT_ID);
defineProp(ComponentIds, 'CATALOG_SIZE_COMPONENT_ID', get_CATALOG_SIZE_COMPONENT_ID);
defineProp(ComponentIds, 'GROUP_INFO_DURING_DESERIALIZING_COMPONENT_ID', get_GROUP_INFO_DURING_DESERIALIZING_COMPONENT_ID);
defineProp(ComponentIds, 'PRODUCT_PARAMS_COMPONENT_ID', get_PRODUCT_PARAMS_COMPONENT_ID);
defineProp(ComponentIds, 'MULTI_DRAG_COMMON_PARENT_COMPONENT_ID', get_MULTI_DRAG_COMMON_PARENT_COMPONENT_ID);
defineProp(ComponentIds, 'REMOVED_DRAG_COMPONENTS_COMPONENT_ID', get_REMOVED_DRAG_COMPONENTS_COMPONENT_ID);
defineProp(ComponentIds, 'PROPPING_PARENT_COMPONENT_ID', get_PROPPING_PARENT_COMPONENT_ID);
defineProp(ComponentIds, 'PROPPING_HOST_CONNECTOR_DATA_COMPONENT_ID', get_PROPPING_HOST_CONNECTOR_DATA_COMPONENT_ID);
defineProp(ComponentIds, 'LARGEST_FITTING_PROPPING_COMPONENT_ID', get_LARGEST_FITTING_PROPPING_COMPONENT_ID);
defineProp(ComponentIds, 'TEMPORARILY_IGNORE_MY_PROPPING_FUNCTIONAL_ZONES_COMPONENT_ID', get_TEMPORARILY_IGNORE_MY_PROPPING_FUNCTIONAL_ZONES_COMPONENT_ID);
defineProp(ComponentIds, 'CURRENT_PROPPING_COMPONENT_ID', get_CURRENT_PROPPING_COMPONENT_ID);
defineProp(ComponentIds, 'SLOW_REPLACE_IN_PROGRESS_COMPONENT_ID', get_SLOW_REPLACE_IN_PROGRESS_COMPONENT_ID);
defineProp(ComponentIds, 'SELECTION_GROUPS_COMPONENT_ID', get_SELECTION_GROUPS_COMPONENT_ID);
defineProp(ComponentIds, 'highestCoreComponentId', get_highestCoreComponentId);
defineProp(ComponentIds, 'Companion', Companion_getInstance_22);
ComponentUtils.isSelected = isSelected;
ComponentUtils.selectableComponent = selectableComponent;
ComponentUtils.isSelectable = isSelectable;
ComponentUtils.displayName = displayName;
ComponentUtils.connectorsComponent = connectorsComponent;
ComponentUtils.connectors = connectors;
ComponentUtils.connection = connection;
ComponentUtils.snapRoot = snapRoot;
ComponentUtils.isRoom = isRoom;
ComponentUtils.draggableRootEntity = draggableRootEntity;
ComponentUtils.selectableRootEntity = selectableRootEntity;
ComponentUtils.previousId = previousId;
defineProp(ComponentUtils, 'Companion', Companion_getInstance_23);
defineProp(ChildConnectionValidation, 'Companion', Companion_getInstance_24);
Connection.fromConnectors = fromConnectors;
defineProp(ConnectionRootComponent, 'Companion', Companion_getInstance_25);
ConnectionUtils.getGuestConnections = getGuestConnections;
ConnectionUtils.getHighestPriorityConnection = getHighestPriorityConnection;
ConnectionUtils.isConnectionRoot = isConnectionRoot;
ConnectionUtils.connectionRootEntity = connectionRootEntity;
ConnectionUtils.immediateConnectionRootDescendants = immediateConnectionRootDescendants;
ConnectionUtils.getExistingOutgoingGuestConnections = getExistingOutgoingGuestConnections;
ConnectionUtils.calculateAllConnectionsToHierarchy = calculateAllConnectionsToHierarchy;
ConnectionUtils.calculateAllConnectionsToHierarchies = calculateAllConnectionsToHierarchies;
ConnectionUtils.refreshConnections = refreshConnections;
ConnectionUtils.matchingAlignmentConnections = matchingAlignmentConnections;
ConnectionUtils.disconnect = disconnect;
ConnectionUtils.disconnectAndDisposeEntityAndHierarchy = disconnectAndDisposeEntityAndHierarchy;
ConnectionUtils.disconnectAndDisposeEntitiesAndHierarchies = disconnectAndDisposeEntitiesAndHierarchies;
defineProp(ConnectionUtils, 'Companion', Companion_getInstance_26);
defineProp(GuestConnectionsComponent, 'Companion', Companion_getInstance_27);
defineProp(HostConnectionsComponent, 'Companion', Companion_getInstance_28);
defineProp(TemporaryParentConnectionValidation, 'Companion', Companion_getInstance_30);
defineProp(Connector, 'Companion', Companion_getInstance_32);
ConnectorType.matches = matches;
defineProp(ConnectorType, 'GUEST', get_GUEST);
defineProp(ConnectorType, 'HOST', get_HOST);
defineProp(ConnectorType, 'ALIGNMENT', get_ALIGNMENT);
defineProp(ConnectorType, 'INTERNAL', get_INTERNAL);
defineProp(ConnectorType, 'Companion', Companion_getInstance_33);
ConnectorUtils.snappingEntitiesArray = snappingEntitiesArray;
ConnectorUtils.findUnfulfilledRequiredConnectors = findUnfulfilledRequiredConnectors;
ConnectorUtils.hasAtLeastOneConnectorWithMatchingOffersDemands = hasAtLeastOneConnectorWithMatchingOffersDemands;
ConnectorUtils.isEdgeConnector = isEdgeConnector;
ConnectorUtils.isPointConnector = isPointConnector;
ConnectorUtils.isPointSeriesConnector = isPointSeriesConnector;
ConnectorUtils.isPointSeriesSubConnector = isPointSeriesSubConnector;
ConnectorUtils.isSurfaceConnector = isSurfaceConnector;
ConnectorUtils.enableConnectorByKey = enableConnectorByKey;
ConnectorUtils.disableConnectorByKey = disableConnectorByKey;
defineProp(ConnectorUtils, 'Companion', Companion_getInstance_34);
defineProp(ConnectorsComponent, 'Companion', Companion_getInstance_35);
defineProp(DisableConnectorsSystem, 'Companion', Companion_getInstance_36);
defineProp(DisabledConnectorsComponent, 'Companion', Companion_getInstance_37);
RelativeConnectorRepositioner.repositionRelativeConnectorsFromBounds = repositionRelativeConnectorsFromBounds;
RelativeConnectorRepositioner.repositionRelativeConnectors = repositionRelativeConnectors;
RelativeConnectorRepositioner.repositionConnector = repositionConnector;
RelativeConnectorRepositioner.localBounds = localBounds;
defineProp(RelativeConnectorRepositioner, 'Companion', Companion_getInstance_38);
defineProp(RelativeConnectorsComponent, 'Companion', Companion_getInstance_39);
defineProp(RotationDegreeOfFreedom, 'NONE', get_NONE);
defineProp(RotationDegreeOfFreedom, 'ONE', get_ONE);
defineProp(RotationDegreeOfFreedom, 'Companion', Companion_getInstance_40);
defineProp(SurfaceConnector, 'Companion', Companion_getInstance_41);
defineProp(DebugLinesComponent, 'Companion', Companion_getInstance_42);
defineProp(DebugSurfacesComponent, 'Companion', Companion_getInstance_43);
defineProp(DragSurfacesComponent, 'Companion', Companion_getInstance_44);
defineProp(DraggableComponent, 'Companion', Companion_getInstance_45);
defineProp(SomethingIsDraggedComponent, 'Companion', Companion_getInstance_46);
defineProp(ViewerDragEventComponent, 'Companion', Companion_getInstance_47);
defineProp(WorldDragSurfacesComponent, 'Companion', Companion_getInstance_49);
defineProp(WorldSpaceDragEventComponent, 'Companion', Companion_getInstance_50);
defineProp(Entity, 'Companion', Companion_getInstance_51);
defineProp(EntityManagerImpl, 'Companion', Companion_getInstance_52);
defineProp(AutomaticGroupBuilderSystem, 'Companion', Companion_getInstance_54);
defineProp(AutomaticGroupComponent, 'Companion', Companion_getInstance_55);
defineProp(AutomaticGroupIdCountComponent, 'Companion', Companion_getInstance_56);
EntityGroupUtils.isAutomaticGroup = isAutomaticGroup;
EntityGroupUtils.isEntityLockedInAutomaticGroup = isEntityLockedInAutomaticGroup;
EntityGroupUtils.isHostingMemberInThisAutomaticGroup = isHostingMemberInThisAutomaticGroup_0;
EntityGroupUtils.getAutomaticEntityGroupOfEntity = getAutomaticEntityGroupOfEntity;
EntityGroupUtils.createAutomaticEntityGroup = createAutomaticEntityGroup;
defineProp(EntityGroupUtils, 'Companion', Companion_getInstance_57);
defineProp(StaticComponent, 'Companion', Companion_getInstance_58);
defineProp(ChildComponent, 'id', get_id);
defineProp(ChildComponent, 'Companion', Companion_getInstance_59);
defineProp(HierarchySystem, 'Companion', Companion_getInstance_62);
HierarchyUtils.duplicateEntity = duplicateEntity;
HierarchyUtils.parentComponent = parentComponent;
HierarchyUtils.childComponent = childComponent;
HierarchyUtils.parent = parent;
HierarchyUtils.rootOf = rootOf;
HierarchyUtils.setParent = setParent;
HierarchyUtils.setParentMaintainTransform = setParentMaintainTransform;
HierarchyUtils.isAssembly = isAssembly;
HierarchyUtils.getAssemblyEntities = getAssemblyEntities;
HierarchyUtils.getAssemblyChildren = getAssemblyChildren;
HierarchyUtils.descendants = descendants;
HierarchyUtils.children = children;
HierarchyUtils.hierarchy = hierarchy;
HierarchyUtils.hierarchyExceptSubTreesWithComponent = hierarchyExceptSubTreesWithComponent;
HierarchyUtils.forEachDescendantWithComponent = forEachDescendantWithComponent;
HierarchyUtils.forEachInHierarchy = forEachInHierarchy;
HierarchyUtils.forEachInHierarchyExceptHierarchyOfIgnored = forEachInHierarchyExceptHierarchyOfIgnored;
HierarchyUtils.forEachInHierarchyExceptSubHierarchiesWithComponent = forEachInHierarchyExceptSubHierarchiesWithComponent;
HierarchyUtils.forEachInHierarchyWithComponent = forEachInHierarchyWithComponent;
HierarchyUtils.findInHierarchy = findInHierarchy;
HierarchyUtils.findInHierarchyExceptHierarchyOfIgnored = findInHierarchyExceptHierarchyOfIgnored;
HierarchyUtils.filterInHierarchy = filterInHierarchy;
HierarchyUtils.isDescendantOf = isDescendantOf;
HierarchyUtils.hasAncestor = hasAncestor;
HierarchyUtils.findWithComponentInUpwardsHierarchy = findWithComponentInUpwardsHierarchy;
HierarchyUtils.getEntityAndComponentForFirstEntityWithComponentInUpwardsHierarchy = getEntityAndComponentForFirstEntityWithComponentInUpwardsHierarchy;
HierarchyUtils.getDescendantsWithComponent = getDescendantsWithComponent;
HierarchyUtils.getEntitiesAndComponentsForDescendantsWithComponent = getEntitiesAndComponentsForDescendantsWithComponent;
HierarchyUtils.getDescendantWithComponent = getDescendantWithComponent;
HierarchyUtils.getEntityAndComponentForDescendantWithComponent = getEntityAndComponentForDescendantWithComponent;
HierarchyUtils.getHierarchyWithComponent = getHierarchyWithComponent;
HierarchyUtils.getEntitiesAndComponentsForHierarchyWithComponent = getEntitiesAndComponentsForHierarchyWithComponent;
HierarchyUtils.hasComponentInUpwardsHierarchy = hasComponentInUpwardsHierarchy;
HierarchyUtils.getUpwardsHierarchy = getUpwardsHierarchy;
HierarchyUtils.getAncestors = getAncestors;
HierarchyUtils.findInUpwardsHierarchy = findInUpwardsHierarchy;
defineProp(HierarchyUtils, 'Companion', Companion_getInstance_63);
defineProp(InSceneComponent, 'Companion', Companion_getInstance_64);
ParentComponent.generateHierarchy$default = generateHierarchy$default;
defineProp(ParentComponent, 'Companion', Companion_getInstance_65);
var SceneComponent = {getInstance: SceneComponent_getInstance};
HistoryEvent.values = values;
HistoryEvent.valueOf = valueOf;
defineProp(HistoryEvent, 'TAKE_SNAPSHOT', HistoryEvent_TAKE_SNAPSHOT_getInstance);
defineProp(HistoryEvent, 'UNDO', HistoryEvent_UNDO_getInstance);
defineProp(HistoryEvent, 'REDO', HistoryEvent_REDO_getInstance);
defineProp(HistoryEvent, 'CLEAR', HistoryEvent_CLEAR_getInstance);
defineProp(HistoryEvent, 'DISCARD_SNAPSHOT', HistoryEvent_DISCARD_SNAPSHOT_getInstance);
defineProp(HistoryChangedEventComponent, 'Companion', Companion_getInstance_68);
LogLevel.values = values_0;
LogLevel.valueOf = valueOf_0;
defineProp(LogLevel, 'DEBUG', LogLevel_DEBUG_getInstance);
defineProp(LogLevel, 'INFO', LogLevel_INFO_getInstance);
defineProp(LogLevel, 'WARN', LogLevel_WARN_getInstance);
defineProp(LogLevel, 'ERROR', LogLevel_ERROR_getInstance);
defineProp(LogLevel, 'NONE', LogLevel_NONE_getInstance);
defineProp(Margin, 'Companion', Companion_getInstance_69);
MathUtils.quaternionFromAxisAngle = quaternionFromAxisAngle;
MathUtils.quaternionFromLookDirection = quaternionFromLookDirection;
MathUtils.quaternionFromLookDirectionUnsafe = quaternionFromLookDirectionUnsafe;
MathUtils.quaternionFromBaseVectors = quaternionFromBaseVectors;
MathUtils.quaternionFromEulerDegrees = quaternionFromEulerDegrees;
MathUtils.quaternionFromEulerRadians = quaternionFromEulerRadians;
MathUtils.axisAlignedBoxFromVertices = axisAlignedBoxFromVertices;
MathUtils.geometricMeanFromPoints = geometricMeanFromPoints;
MathUtils.quaternionToRotationMatrix = quaternionToRotationMatrix;
defineProp(MathUtils, 'transformIdentity', get_transformIdentity);
defineProp(MathUtils, 'quaternionIdentity', get_quaternionIdentity);
defineProp(MathUtils, 'Companion', Companion_getInstance_70);
defineProp(ModelTransform, 'Companion', Companion_getInstance_71);
defineProp(Plane, 'Companion', Companion_getInstance_72);
defineProp(Polygon, 'Companion', Companion_getInstance_73);
Quaternion.fromCoefficients = fromCoefficients;
Quaternion.copy$default = copy$default;
Quaternion.toAxisAngle = toAxisAngle;
Quaternion.fromLookDirection = fromLookDirection_0;
Quaternion.fromLookDirectionUnsafe = fromLookDirectionUnsafe_0;
Quaternion.quaternionFromBaseVectors = quaternionFromBaseVectors_0;
Quaternion.fromAxisAngle = fromAxisAngle;
Quaternion.fromEulerDegreesVector = fromEulerDegreesVector;
Quaternion.fromEulerDegrees = fromEulerDegrees_0;
Quaternion.fromEulerDegreesRadians = fromEulerDegreesRadians;
Quaternion.fromEuler = fromEuler_0;
defineProp(Quaternion, 'IDENTITY', get_IDENTITY);
defineProp(Quaternion, 'PI2', get_PI2);
defineProp(Quaternion, 'RADIANS_TO_DEGREES', get_RADIANS_TO_DEGREES);
defineProp(Quaternion, 'PI2_DIV_360', get_PI2_DIV_360);
defineProp(Quaternion, 'Companion', Companion_getInstance_74);
defineProp(RelationOriginAlongX, 'LEFT', get_LEFT);
defineProp(RelationOriginAlongX, 'CENTER', get_CENTER);
defineProp(RelationOriginAlongX, 'RIGHT', get_RIGHT);
defineProp(RelationOriginAlongX, 'Companion', Companion_getInstance_75);
defineProp(RelationOriginAlongY, 'BOTTOM', get_BOTTOM);
defineProp(RelationOriginAlongY, 'CENTER', get_CENTER_0);
defineProp(RelationOriginAlongY, 'TOP', get_TOP);
defineProp(RelationOriginAlongY, 'Companion', Companion_getInstance_76);
defineProp(RelationOriginAlongZ, 'BACK', get_BACK);
defineProp(RelationOriginAlongZ, 'CENTER', get_CENTER_1);
defineProp(RelationOriginAlongZ, 'FRONT', get_FRONT);
defineProp(RelationOriginAlongZ, 'Companion', Companion_getInstance_77);
defineProp(RelationOrigin, 'Companion', Companion_getInstance_78);
Size.SizeFromVector = SizeFromVector;
defineProp(Size, 'Companion', Companion_getInstance_79);
defineProp(Transform, 'IDENTITY', get_IDENTITY_0);
defineProp(Transform, 'Companion', Companion_getInstance_80);
defineProp(Vector, 'Companion', Companion_getInstance_81);
defineProp(VectorConstants, 'LEFT', get_LEFT_0);
defineProp(VectorConstants, 'RIGHT', get_RIGHT_0);
defineProp(VectorConstants, 'DOWN', get_DOWN);
defineProp(VectorConstants, 'UP', get_UP);
defineProp(VectorConstants, 'FORWARD', get_FORWARD);
defineProp(VectorConstants, 'BACK', get_BACK_0);
defineProp(VectorConstants, 'ZERO', get_ZERO);
defineProp(VectorConstants, 'INFINITY', get_INFINITY);
defineProp(VectorConstants, 'ONE', get_ONE_0);
defineProp(VectorConstants, 'Companion', Companion_getInstance_82);
MeasurementUtils.getOutsideMeasurementSingle = getOutsideMeasurementSingle;
MeasurementUtils.getOutsideMeasurement = getOutsideMeasurement;
MeasurementUtils.getOutsideMeasurementSingleWithoutHierarchy = getOutsideMeasurementSingleWithoutHierarchy;
MeasurementUtils.getOutsideMeasurementWithoutHierarchies = getOutsideMeasurementWithoutHierarchies;
MeasurementUtils.getLocalOutsideMeasurementForEntities = getLocalOutsideMeasurementForEntities;
MeasurementUtils.getInsideMeasurementLocalSpace = getInsideMeasurementLocalSpace_0;
MeasurementUtils.getInsideMeasurementWorldSpace = getInsideMeasurementWorldSpace_0;
defineProp(MeasurementUtils, 'Companion', Companion_getInstance_83);
defineProp(DisplayNameComponent, 'Companion', Companion_getInstance_84);
ProductUtils.productComponent = productComponent;
ProductUtils.productRef = productRef;
ProductUtils.productRefOrEmptyString = productRefOrEmptyString;
ProductUtils.isConnectionRoot = isConnectionRoot_0;
ProductUtils.connectionRootEntity = connectionRootEntity_0;
ProductUtils.immediateConnectionRootDescendants = immediateConnectionRootDescendants_0;
ProductUtils.partKey = partKey;
ProductUtils.applyResize = applyResize;
ProductUtils.getProductScale = getProductScale;
defineProp(ProductUtils, 'Companion', Companion_getInstance_85);
defineProp(ProppingComponent, 'id', get_id_0);
defineProp(ProppingComponent, 'Companion', Companion_getInstance_86);
defineProp(TemplateDataComponent, 'Companion', Companion_getInstance_87);
defineProp(ProductStructureBuilder, 'Companion', Companion_getInstance_88);
defineProp(Ray, 'Companion', Companion_getInstance_89);
RaycastUtils.raycast = raycast_0;
RaycastUtils.raycastAll = raycastAll_0;
defineProp(RaycastUtils, 'Companion', Companion_getInstance_90);
defineProp(LoadedModelInfoComponent, 'Companion', Companion_getInstance_91);
defineProp(ModelInfoComponent, 'Companion', Companion_getInstance_92);
defineProp(ModelLoaderSystem, 'Companion', Companion_getInstance_93);
defineProp(ModelTransformComponent, 'Companion', Companion_getInstance_94);
ModelUtils.loadModelFromModelInfo = loadModelFromModelInfo;
ModelUtils.getLoadingBox = getLoadingBox;
ModelUtils.unloadModel = unloadModel;
ModelUtils.hide = hide;
ModelUtils.show = show;
defineProp(ModelUtils, 'Companion', Companion_getInstance_95);
defineProp(OutlineableComponent, 'Companion', Companion_getInstance_96);
defineProp(PauseViewerUpdatesComponent, 'Companion', Companion_getInstance_97);
defineProp(RenderedComponent, 'Companion', Companion_getInstance_99);
defineProp(ViewerComponent, 'Companion', Companion_getInstance_100);
defineProp(ViewerLineIdsComponent, 'Companion', Companion_getInstance_101);
defineProp(ViewerObjectComponent, 'id', get_id_1);
defineProp(ViewerObjectComponent, 'Companion', Companion_getInstance_102);
defineProp(SlowReplaceInProgressComponent, 'id', get_id_2);
defineProp(SlowReplaceInProgressComponent, 'Companion', Companion_getInstance_105);
defineProp(ClickEventComponent, 'Companion', Companion_getInstance_106);
var MultiSelectionEnabledComponent = {getInstance: MultiSelectionEnabledComponent_getInstance};
defineProp(SelectableComponent, 'Companion', Companion_getInstance_107);
defineProp(SelectedComponent, 'Companion', Companion_getInstance_108);
defineProp(PreviouslySerializedIdComponent, 'Companion', Companion_getInstance_111);
defineProp(SceneReloadingComponent, 'Companion', Companion_getInstance_112);
defineProp(UnserializableEntityComponent, 'Companion', Companion_getInstance_117);
AxisAlignedBox.fromVertices = fromVertices;
AxisAlignedBox.fromSize = fromSize_0;
defineProp(AxisAlignedBox, 'INFINITE_AABB', get_INFINITE_AABB);
defineProp(AxisAlignedBox, 'EMPTY_AABB', get_EMPTY_AABB);
defineProp(AxisAlignedBox, 'Companion', Companion_getInstance_125);
defineProp(ConvexPolyhedron, 'Companion', Companion_getInstance_126);
Cuboid.fromSize = fromSize_1;
Cuboid.fromSizeAndCenter = fromSizeAndCenter;
defineProp(Cuboid, 'Companion', Companion_getInstance_127);
Cylinder.fromParameters = fromParameters;
defineProp(Cylinder, 'Companion', Companion_getInstance_128);
PolyhedronUtils.createFromPolygon = createFromPolygon;
PolyhedronUtils.createFramePolyhedrons = createFramePolyhedrons_0;
PolyhedronUtils.singleSidedPolyhedronFromPolygon = singleSidedPolyhedronFromPolygon;
PolyhedronUtils.polyhedronFromPolygon = polyhedronFromPolygon;
PolyhedronUtils.polyhedronFromConvexPolygon = polyhedronFromConvexPolygon;
PolyhedronUtils.isConvexPolygon = isConvexPolygon;
PolyhedronUtils.surfaceNormal = surfaceNormal;
PolyhedronUtils.generateNormalFromCounterClockwiseTriangle = generateNormalFromCounterClockwiseTriangle;
PolyhedronUtils.getPolygonsFromPolyhedrons = getPolygonsFromPolyhedrons;
PolyhedronUtils.earClipTriangulation = earClipTriangulation;
PolyhedronUtils.isConvexPolyhedron = isConvexPolyhedron;
PolyhedronUtils.isCuboid = isCuboid;
PolyhedronUtils.isCylinder = isCylinder;
PolyhedronUtils.isPolyhedronGroup = isPolyhedronGroup;
defineProp(PolyhedronUtils, 'Companion', Companion_getInstance_129);
defineProp(MovedToCandidateSnapPositionComponent, 'Companion', Companion_getInstance_130);
defineProp(MovedToValidSnapPositionComponent, 'Companion', Companion_getInstance_131);
defineProp(RestrictAllowedRequiredHostsComponent, 'Companion', Companion_getInstance_132);
defineProp(SnapActionCandidateSortAndSelectStrategies, 'SELECT_ALL', get_SELECT_ALL);
defineProp(SnapActionCandidateSortAndSelectStrategies, 'SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE', get_SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE);
defineProp(SnapActionCandidateSortAndSelectStrategies, 'SORT_BY_DISTANCE', get_SORT_BY_DISTANCE);
defineProp(SnapActionCandidateSortAndSelectStrategies, 'SORT_BY_PRIORITY_THEN_DISTANCE', get_SORT_BY_PRIORITY_THEN_DISTANCE);
defineProp(SnapActionCandidateSortAndSelectStrategies, 'Companion', Companion_getInstance_133);
defineProp(SnapActionInProgressComponent, 'Companion', Companion_getInstance_134);
defineProp(SnapCandidateComponent, 'Companion', Companion_getInstance_135);
SnapPostProcessingUtil.filterOutCandidateInActivationDistanceFromAlignment = filterOutCandidateInActivationDistanceFromAlignment;
defineProp(SnapPostProcessingUtil, 'Companion', Companion_getInstance_136);
defineProp(SnapRootComponent, 'Companion', Companion_getInstance_137);
SnapUtils.snapRoot = snapRoot_0;
SnapUtils.getClosestSnapInHierarchy = getClosestSnapInHierarchy;
SnapUtils.getClosestSnap = getClosestSnap;
SnapUtils.getMatchingAlignmentSnapsOnHost = getMatchingAlignmentSnapsOnHost;
SnapUtils.getSimilarSnapAsOldEntityExistingConnection = getSimilarSnapAsOldEntityExistingConnection;
SnapUtils.getMatchingSnapsInScene = getMatchingSnapsInScene_0;
SnapUtils.getMatchingSnapsOnMultipleHosts = getMatchingSnapsOnMultipleHosts_0;
SnapUtils.getMatchingSnaps = getMatchingSnaps_0;
SnapUtils.getSnap = getSnap_0;
SnapUtils.getForcedSnap = getForcedSnap_0;
SnapUtils.tryToReplaceAlignmentSnapWithRealSnap = tryToReplaceAlignmentSnapWithRealSnap;
defineProp(SnapUtils, 'Companion', Companion_getInstance_138);
defineProp(IsLoadingSnapshotComponent, 'Companion', Companion_getInstance_139);
defineProp(SnapshotIgnoreComponent, 'Companion', Companion_getInstance_140);
defineProp(SnapshotService, 'Companion', Companion_getInstance_141);
defineProp(UpdatedFromSnapshotEventComponent, 'id', get_id_3);
defineProp(UpdatedFromSnapshotEventComponent, 'Companion', Companion_getInstance_142);
defineProp(ApiSystemIds, 'CONNECTION_PARENTING_SYSTEM_ID', get_CONNECTION_PARENTING_SYSTEM_ID);
defineProp(ApiSystemIds, 'AUTOMATIC_GROUP_BUILDER_SYSTEM_ID', get_AUTOMATIC_GROUP_BUILDER_SYSTEM_ID);
defineProp(ApiSystemIds, 'HIERARCHY_SYSTEM_ID', get_HIERARCHY_SYSTEM_ID);
defineProp(ApiSystemIds, 'SCENE_GRAPH_SYSTEM_ID', get_SCENE_GRAPH_SYSTEM_ID);
defineProp(ApiSystemIds, 'TRANSFORM_SYSTEM_ID', get_TRANSFORM_SYSTEM_ID);
defineProp(ApiSystemIds, 'DISABLE_CONNECTORS_SYSTEM_ID', get_DISABLE_CONNECTORS_SYSTEM_ID);
defineProp(ApiSystemIds, 'RENDER_SYSTEM_ID', get_RENDER_SYSTEM_ID);
defineProp(ApiSystemIds, 'WORLD_COLLIDER_UPDATE_SYSTEM_ID', get_WORLD_COLLIDER_UPDATE_SYSTEM_ID);
defineProp(ApiSystemIds, 'PRODUCT_RESIZING_SYSTEM_ID', get_PRODUCT_RESIZING_SYSTEM_ID);
defineProp(ApiSystemIds, 'VIEWER_PRESENCE_SYSTEM_ID', get_VIEWER_PRESENCE_SYSTEM_ID);
defineProp(ApiSystemIds, 'MODEL_LOADER_SYSTEM_ID', get_MODEL_LOADER_SYSTEM_ID);
defineProp(ApiSystemIds, 'VIEWER_OBJECT_TRANSFORM_SYSTEM_ID', get_VIEWER_OBJECT_TRANSFORM_SYSTEM_ID);
defineProp(ApiSystemIds, 'VIEWER_OBJECT_VISIBILITY_SYSTEM_ID', get_VIEWER_OBJECT_VISIBILITY_SYSTEM_ID);
defineProp(ApiSystemIds, 'Companion', Companion_getInstance_143);
var AlwaysHangDownComponent = {getInstance: AlwaysHangDownComponent_getInstance};
LocalTransformComponent.LocalTransformComponentFromPosAndRot = LocalTransformComponentFromPosAndRot;
defineProp(LocalTransformComponent, 'Companion', Companion_getInstance_145);
defineProp(TransformSystem, 'Companion', Companion_getInstance_146);
TransformUtils.worldTransform = worldTransform;
TransformUtils.localTransform = localTransform;
TransformUtils.worldPosition = worldPosition;
TransformUtils.localPosition = localPosition;
TransformUtils.worldRotation = worldRotation;
TransformUtils.rotate = rotate;
TransformUtils.moveInParentSpace = moveInParentSpace;
TransformUtils.moveInLocalSpace = moveInLocalSpace;
TransformUtils.moveInWorldSpace = moveInWorldSpace;
TransformUtils.updateWorldTransform = updateWorldTransform;
TransformUtils.applyWorldTransform = applyWorldTransform;
TransformUtils.setLocalPosition = setLocalPosition;
TransformUtils.setLocalRotation = setLocalRotation;
TransformUtils.setLocalTransform = setLocalTransform;
TransformUtils.setWorldTransform = setWorldTransform;
TransformUtils.transformForSurface = transformForSurface;
TransformUtils.setWorldPosition = setWorldPosition;
defineProp(TransformUtils, 'Companion', Companion_getInstance_147);
WorldTransformComponent.WorldTransformComponentFromPosAndRot = WorldTransformComponentFromPosAndRot;
defineProp(WorldTransformComponent, 'Companion', Companion_getInstance_149);
defineProp(ValidSnapActionCandidateOrErrors, 'Companion', Companion_getInstance_152);
ValidationResultType.values = values_1;
ValidationResultType.valueOf = valueOf_1;
defineProp(ValidationResultType, 'WARNING', ValidationResultType_WARNING_getInstance);
defineProp(ValidationResultType, 'FAIL', ValidationResultType_FAIL_getInstance);
defineProp(ValidationResultFail, 'Companion', Companion_getInstance_153);
defineProp(ValidationResult, 'Companion', Companion_getInstance_154);
export {
  CoreServices as CoreServices,
  AssemblyPart as AssemblyPart,
  AssemblyPartSnapInfo as AssemblyPartSnapInfo,
  AssemblyPartIdsComponent as AssemblyPartIdsComponent,
  AssemblyPartsComponent as AssemblyPartsComponent,
  AssemblyStructureComponent as AssemblyStructureComponent,
  PartPair as PartPair,
  ProductPartComponent as ProductPartComponent,
  CatalogSizeComponent as CatalogSizeComponent,
  ProductCatalogFunctions as ProductCatalogFunctions,
  ProductComponent as ProductComponent,
  ProductParams as ProductParams,
  ProductParamsComponent as ProductParamsComponent,
  ProductSpecification as ProductSpecification,
  ProductStructureComponent as ProductStructureComponent,
  ProductStructureConnection as ProductStructureConnection,
  ProductStructureItem as ProductStructureItem,
  ColliderComponent as ColliderComponent,
  ColliderShapeComponent as ColliderShapeComponent,
  ColliderUtils as ColliderUtils,
  Collision as Collision,
  CollisionUtils as CollisionUtils,
  CollisionValidation as CollisionValidation,
  CollisionValidationResult as CollisionValidationResult,
  ComponentIdSpan as ComponentIdSpan,
  ComponentIds as ComponentIds,
  ComponentUtils as ComponentUtils,
  AlignmentConnection as AlignmentConnection,
  ChildConnectionValidation as ChildConnectionValidation,
  Connection as Connection,
  ConnectionRootComponent as ConnectionRootComponent,
  ConnectionUtils as ConnectionUtils,
  GuestConnectionsComponent as GuestConnectionsComponent,
  HostConnectionsComponent as HostConnectionsComponent,
  TemporaryParentConnectionValidation as TemporaryParentConnectionValidation,
  Connector as Connector,
  ConnectorType as ConnectorType,
  ConnectorUtils as ConnectorUtils,
  ConnectorsComponent as ConnectorsComponent,
  DisableConnectorsSystem as DisableConnectorsSystem,
  DisabledConnectorsComponent as DisabledConnectorsComponent,
  EdgeConnector as EdgeConnector,
  PointConnector as PointConnector,
  PointSeriesConnector as PointSeriesConnector,
  PointSeriesSubConnector as PointSeriesSubConnector,
  RelativeConnectorData as RelativeConnectorData,
  RelativeConnectorRepositioner as RelativeConnectorRepositioner,
  RelativeConnectorsComponent as RelativeConnectorsComponent,
  RotationDegreeOfFreedom as RotationDegreeOfFreedom,
  SurfaceConnector as SurfaceConnector,
  DebugLine as DebugLine,
  DebugLinesComponent as DebugLinesComponent,
  DebugSurfacesComponent as DebugSurfacesComponent,
  DragSurfacesComponent as DragSurfacesComponent,
  DragSurface as DragSurface,
  DraggableComponent as DraggableComponent,
  SomethingIsDraggedComponent as SomethingIsDraggedComponent,
  ViewerDragEventComponent as ViewerDragEventComponent,
  WorldDragSurfacesComponent as WorldDragSurfacesComponent,
  WorldSpaceDragEventComponent as WorldSpaceDragEventComponent,
  Entity as Entity,
  EntityManagerImpl as EntityManagerImpl,
  AutomaticGroupBuilderSystem as AutomaticGroupBuilderSystem,
  AutomaticGroupComponent as AutomaticGroupComponent,
  AutomaticGroupIdCountComponent as AutomaticGroupIdCountComponent,
  EntityGroupUtils as EntityGroupUtils,
  StaticComponent as StaticComponent,
  ChildComponent as ChildComponent,
  EntityWithComponent as EntityWithComponent,
  HierarchySystem as HierarchySystem,
  HierarchyUtils as HierarchyUtils,
  InSceneComponent as InSceneComponent,
  ParentComponent as ParentComponent,
  SceneComponent as SceneComponent,
  HistoryEvent as HistoryEvent,
  HistoryChangedEventComponent as HistoryChangedEventComponent,
  LogLevel as LogLevel,
  AxisAngle as AxisAngle,
  Degrees as Degrees,
  DualDouble as DualDouble,
  Margin as Margin,
  MathUtils as MathUtils,
  ModelTransform as ModelTransform,
  Plane as Plane,
  Polygon as Polygon,
  Quaternion as Quaternion,
  Radians as Radians,
  RelativeBoxOffset as RelativeBoxOffset,
  RelationOriginAlongX as RelationOriginAlongX,
  RelationOriginAlongY as RelationOriginAlongY,
  RelationOriginAlongZ as RelationOriginAlongZ,
  RelationOrigin as RelationOrigin,
  Size as Size,
  Transform as Transform,
  Vector as Vector,
  VectorConstants as VectorConstants,
  InnerMeasurement as InnerMeasurement,
  MeasurementUtils as MeasurementUtils,
  DisplayNameComponent as DisplayNameComponent,
  ProductUtils as ProductUtils,
  ProppingComponent as ProppingComponent,
  TemplateDataComponent as TemplateDataComponent,
  ProductStructureBuilder as ProductStructureBuilder,
  Ray as Ray,
  RaycastHit as RaycastHit,
  RaycastResult as RaycastResult,
  RaycastUtils as RaycastUtils,
  LoadedModelInfoComponent as LoadedModelInfoComponent,
  ModelInfoComponent as ModelInfoComponent,
  ModelLoaderSystem as ModelLoaderSystem,
  ModelTransformComponent as ModelTransformComponent,
  ModelUtils as ModelUtils,
  OutlineableComponent as OutlineableComponent,
  PauseViewerUpdatesComponent as PauseViewerUpdatesComponent,
  RenderedComponent as RenderedComponent,
  ViewerComponent as ViewerComponent,
  ViewerLineIdsComponent as ViewerLineIdsComponent,
  ViewerObjectComponent as ViewerObjectComponent,
  ViewerObjectTransformSystem as ViewerObjectTransformSystem,
  ViewerObjectVisibilitySystem as ViewerObjectVisibilitySystem,
  ViewerPresenceSystem as ViewerPresenceSystem,
  SlowReplaceInProgressComponent as SlowReplaceInProgressComponent,
  ClickEventComponent as ClickEventComponent,
  MultiSelectionEnabledComponent as MultiSelectionEnabledComponent,
  SelectableComponent as SelectableComponent,
  SelectedComponent as SelectedComponent,
  CatalogVersion as CatalogVersion,
  ComponentDeserializerRegistry as ComponentDeserializerRegistry,
  DeserializationInterceptorRegistry as DeserializationInterceptorRegistry,
  PreviouslySerializedIdComponent as PreviouslySerializedIdComponent,
  SceneReloadingComponent as SceneReloadingComponent,
  UnserializableEntityComponent as UnserializableEntityComponent,
  AxisAlignedBox as AxisAlignedBox,
  ConvexPolyhedron as ConvexPolyhedron,
  Cuboid as Cuboid,
  Cylinder as Cylinder,
  Face as Face,
  PolyhedronGroup as PolyhedronGroup,
  PolyhedronUtils as PolyhedronUtils,
  MovedToCandidateSnapPositionComponent as MovedToCandidateSnapPositionComponent,
  MovedToValidSnapPositionComponent as MovedToValidSnapPositionComponent,
  RestrictAllowedRequiredHostsComponent as RestrictAllowedRequiredHostsComponent,
  Snap as Snap,
  SnapActionCandidateSortAndSelectStrategies as SnapActionCandidateSortAndSelectStrategies,
  SelectAll as SelectAll,
  SortByPriorityInActivationDistanceThenDistance as SortByPriorityInActivationDistanceThenDistance,
  SortByPriorityThenDistance as SortByPriorityThenDistance,
  SortByDistance as SortByDistance,
  SnapActionInProgressComponent as SnapActionInProgressComponent,
  SnapCandidateComponent as SnapCandidateComponent,
  SnapPostProcessingUtil as SnapPostProcessingUtil,
  SnapRootComponent as SnapRootComponent,
  SnapSettings as SnapSettings,
  SnapUtils as SnapUtils,
  EntityState as EntityState,
  IsLoadingSnapshotComponent as IsLoadingSnapshotComponent,
  SnapshotIgnoreComponent as SnapshotIgnoreComponent,
  SnapshotService as SnapshotService,
  UpdatedFromSnapshotEventComponent as UpdatedFromSnapshotEventComponent,
  ApiSystemIds as ApiSystemIds,
  AlwaysHangDownComponent as AlwaysHangDownComponent,
  LocalTransformComponent as LocalTransformComponent,
  TransformSystem as TransformSystem,
  TransformUtils as TransformUtils,
  WorldTransformComponent as WorldTransformComponent,
  SnapValidationResult as SnapValidationResult,
  ValidSnapActionCandidateOrErrors as ValidSnapActionCandidateOrErrors,
  ValidationImpl as ValidationImpl,
  ValidationResultType as ValidationResultType,
  ValidationResultFail as ValidationResultFail,
  ValidationResultWarning as ValidationResultWarning,
  ValidationResult as ValidationResult,
  ValidationMeasurement as ValidationMeasurement,
  ValidationMeasurements as ValidationMeasurements,
};
export {
  CoreFactory as CoreFactory46b0ey2kmo2y,
  CoreModules as CoreModules31i8kbsjf5lph,
  CoreServices as CoreServices1d8s33zxz6j84,
  Core as Core163cx1hmrsdyy,
  AddPartAction as AddPartActionh2vxb8orgybz,
  AssemblyPartSnapInfo as AssemblyPartSnapInfo3vtetiub067zv,
  AssemblyPart as AssemblyPart110oq599i90v0,
  AssemblyStructureComponent as AssemblyStructureComponent3qqm1io5f7l8g,
  RemovePartAction as RemovePartAction111eypffspa5d,
  get_partKey as get_partKey3h851didm8jbw,
  ProductResizingSystem as ProductResizingSystem3mplym8g6liji,
  CatalogSizeComponent as CatalogSizeComponent18xv9v502n7ro,
  createCustomAssemblySpecification as createCustomAssemblySpecificationrtotobw2qkrj,
  createCustomAssembly as createCustomAssembly2xru0w2yvxl0g,
  ProductCatalog as ProductCatalog103osycina0dv,
  ProductComponent as ProductComponent1yv8c90lajg3y,
  ProductManager as ProductManager3q354ka8inlkt,
  ProductParamsComponent as ProductParamsComponent3tz0lreyu4pf2,
  ProductParams as ProductParamsqcv385pfoovn,
  ProductSpecification as ProductSpecificationsunk1qtx1k13,
  ProductStructureComponent as ProductStructureComponent1n49mlfstxaxv,
  ProductStructureConnection as ProductStructureConnection2fj7164v4tcgh,
  ProductStructureItem as ProductStructureItem3ehsotxzwomz5,
  get_productRef as get_productRefzq8sc1a3ab3b,
  get_productRefOrEmptyString as get_productRefOrEmptyString34p0nb5m8rrfy,
  ColliderComponent as ColliderComponent2a9dwc5kghtvn,
  ColliderShapeComponent as ColliderShapeComponent102whak4g71e2,
  CollisionValidationResult as CollisionValidationResultsw0tl1zrikpj,
  CollisionValidation as CollisionValidation1d8vdntob7pqk,
  Collision as Collisionenvj3252kvhl,
  WorldColliderUpdateSystem as WorldColliderUpdateSystem3kld4ercvpe8u,
  get_axisAlignedBoundingBoxForHierarchy as get_axisAlignedBoundingBoxForHierarchy3uv948cp1omtd,
  get_collider as get_collider2fpb05srk6mij,
  get_colliderShapeComponent as get_colliderShapeComponent1cprwuuvy5ljn,
  get_objectOrientedBoundingBoxForHierarchy as get_objectOrientedBoundingBoxForHierarchy1259c236lwl7n,
  get_draggableRootEntity as get_draggableRootEntity2oj5yri14vpjv,
  get_selectableRoot as get_selectableRootqmacaz6hsycx,
  ConnectionRootComponent as ConnectionRootComponent3fd9sp0aqznxo,
  GuestConnectionsComponent as GuestConnectionsComponent3lmt1kel5okm5,
  HostConnectionsComponent as HostConnectionsComponent2io202gu4n681,
  TemporaryParentConnectionValidation as TemporaryParentConnectionValidation35xlu8n3k6kij,
  UpdateHostConnectionsSystem as UpdateHostConnectionsSystembhyds9smxfbm,
  centerOfConnections as centerOfConnections3rp3scnx08x94,
  get_connectionRootEntity as get_connectionRootEntity1dc9n7hgx8wjr,
  get_guestConnections as get_guestConnections389r296igrsm5,
  get_guests as get_guests2nnamzd9jyn03,
  get_highestPriorityConnection as get_highestPriorityConnectiono70rgyvqxphz,
  get_immediateConnectionRootDescendants as get_immediateConnectionRootDescendants3hbzl251uhi35,
  get_isConnectionRoot as get_isConnectionRoot7v6e5jlx4v0s,
  ConnectorsComponent as ConnectorsComponent32a4eg1gtppvf,
  DisableConnectorsSystem as DisableConnectorsSystemu2ju6yqn9d81,
  EdgeConnector as EdgeConnector18c5afzui3cj0,
  PointConnector as PointConnector2aof4iylw00ug,
  PointSeriesConnector as PointSeriesConnector14wrze1fez6ba,
  PointSeriesSubConnector as PointSeriesSubConnector119yjb8t0h9yl,
  RelativeConnectorData as RelativeConnectorData1sdpyngxtictl,
  RelativeConnectorsComponent as RelativeConnectorsComponent2s0o9ntl664k2,
  SurfaceConnector as SurfaceConnector2qgrveebgrhin,
  get_connectors as get_connectors3o1bagte2voxy,
  get_connectorsComponent as get_connectorsComponent2vyt6vnfllddk,
  get_guestConnectors as get_guestConnectors159rdzxuhz1ct,
  get_hostConnectors as get_hostConnectorsfy90ve2ifxxi,
  get_snappingEntitiesSequence as get_snappingEntitiesSequence2dh7f7wgfsw8h,
  DebugLinesComponent as DebugLinesComponent2rj8crh35vhgh,
  DebugLine as DebugLine34r2sssqo89ca,
  DebugSurfacesComponent as DebugSurfacesComponent2ye435zjrp3pw,
  DragSurfacesComponent as DragSurfacesComponent2obth6ol1y4en,
  DragSurface as DragSurface3d7ocyb1ribou,
  DraggableComponent as DraggableComponent2vg3of9uj9uwn,
  SomethingIsDraggedComponent as SomethingIsDraggedComponent5k4agol20ifb,
  ViewerDragEventComponent as ViewerDragEventComponentfzbgl8e0va3i,
  WorldDragSurfaceUpdateSystem as WorldDragSurfaceUpdateSystem371cykdjmc879,
  WorldDragSurfacesComponent as WorldDragSurfacesComponent1qlawlc64osxl,
  WorldSpaceDragEventComponent as WorldSpaceDragEventComponent5q5f03t88rlk,
  get_doStoreInSnapshot as get_doStoreInSnapshot2ouhd6iwtr8a6,
  get_serializable as get_serializabletahhnzjs6wap,
  Component as Component1lglqnbx5ofkj,
  EntityManagerImpl as EntityManagerImpla83sxdjwhxg6,
  EntityManagerWatcher as EntityManagerWatcher3o9hbfdtrb9zp,
  SystemBase2 as SystemBase23pr0o2du1qmtu,
  SystemBase3 as SystemBase33jliyb74mzyqn,
  SystemBase4 as SystemBase427s2ha2o9p0tz,
  SystemBase5 as SystemBase535eey1gt93lp7,
  SystemBase as SystemBase5u6rlp403okv,
  AutomaticGroupComponent as AutomaticGroupComponent3avj018e753er,
  StaticComponent as StaticComponent1ujjt0txbrs9g,
  get_isAutomaticGroup as get_isAutomaticGroup10cidqe09p5d0,
  ChildComponent as ChildComponent2d030zd3zomve,
  ConnectionParentingSystem as ConnectionParentingSystem3bmut6gfi2dkt,
  DisposeTemporaryParentSystem as DisposeTemporaryParentSystem2fdaj61fhb7sh,
  HierarchySystem as HierarchySystem3dwjzh9jtietj,
  InSceneComponent as InSceneComponentde0noxkj1mf1,
  ParentComponent as ParentComponentw4nmaz0u9znx,
  RestoreSnapRootOnChildrenOfTemporaryParentSystem as RestoreSnapRootOnChildrenOfTemporaryParentSystema0v8rm39o417,
  SceneGraphSystem as SceneGraphSystem1h1l1r73x8815,
  SceneManager as SceneManager1lgs33hi6mjvz,
  TemporaryParentComponent as TemporaryParentComponentjxe9t8sxbmn1,
  get_children as get_children2vj8fy0vljjod,
  get_descendants as get_descendantser7rkq0rhyf2,
  filterInHierarchy_0 as filterInHierarchy474mzjle21xm,
  findInHierarchy_0 as findInHierarchyzbv5qkxvu9fi,
  findInUpwardsHierarchy_0 as findInUpwardsHierarchyxs505279d5su,
  findWithComponentInUpwardsHierarchy_0 as findWithComponentInUpwardsHierarchy28ehb2p7f3g3t,
  forEachInHierarchy_0 as forEachInHierarchy2h9zs3d5h4wwz,
  getHierarchyWithComponent_0 as getHierarchyWithComponent1ciosii4aoq76,
  hasAncestor_0 as hasAncestor2y0z678tcabqy,
  hasComponentInUpwardsHierarchy_0 as hasComponentInUpwardsHierarchyketgpzoey4xa,
  get_hierarchy as get_hierarchy1sm75rhmsdka0,
  hierarchyContains as hierarchyContains3heici1vjajaj,
  hierarchyExceptSubTreeArray as hierarchyExceptSubTreeArray31ltqeh012j6d,
  hierarchyExceptSubTreesWithComponentArray as hierarchyExceptSubTreesWithComponentArray2vchkhklu6mmt,
  hierarchyExceptSubTreesWithComponentSequence as hierarchyExceptSubTreesWithComponentSequence3r6a5pldcjcbz,
  get_hierarchySequence as get_hierarchySequence36fwaxpen7dj9,
  isDescendantOf_0 as isDescendantOf2ougv59gaurds,
  get_isInScene as get_isInScene27litrxhfjomh,
  get_parent as get_parent37cf1epzwukp7,
  get_parentComponent as get_parentComponent913cs0fasf9z,
  setParentMaintainWorldTransform as setParentMaintainWorldTransform2mp81fq51dsun,
  setParent_0 as setParentsdc2yeqq589r,
  HistoryImpl as HistoryImpl2xce0gpcqs3z5,
  LoggerImpl as LoggerImpl39a3tj9gsxbr8,
  Logger as Logger353bsqefxu9f,
  echoStandardConsole as echoStandardConsole2oa0qqsaar076,
  Degrees as Degrees1pmrlnndueajq,
  Margin as Margin55v3iexvqdfb,
  Plane as Plane1msa79ko6z8u2,
  Radians as Radians3bflt61di9nby,
  RelationOrigin as RelationOrigin3sa84ujcjvad5,
  RelativeBoxOffset as RelativeBoxOffset2b8mgz1w3jy13,
  Size as Sizervsnigdp89bq,
  Transform as Transform2e9p9l2euepqa,
  Vector as Vector1cgy08ha6e7ya,
  almostEquals as almostEquals23kj4jzvxfqs8,
  get_geometricMean as get_geometricMean39gejc7rixqh6,
  DisplayNameComponent as DisplayNameComponent37eao6dtqdntj,
  ProppingComponent as ProppingComponent3ntna4jqkya3u,
  TemplateDataComponent as TemplateDataComponentpbjy7hrg15a7,
  get_displayName as get_displayName36i430b21ily,
  set_displayName as set_displayName21kc1688xgq2d,
  get_isPropping as get_isPropping1mjc1m9woiddx,
  RaycastHit as RaycastHit45545frb8lqu,
  RaycastResult as RaycastResult2x8clpf8hmgis,
  Ray as Ray11cma6fe4h4tn,
  LoadedModelInfoComponent as LoadedModelInfoComponent3liifkjcvcim3,
  ModelInfoComponent as ModelInfoComponentvt7uz6p6kni4,
  ModelTransformComponent as ModelTransformComponentljn0f1n2gsc8,
  OutlineableComponent as OutlineableComponent1wms50wedlllg,
  RenderSystem as RenderSystem1xa319w4fhpum,
  RenderedComponent as RenderedComponent23lei7ja9f7xq,
  ViewerComponent as ViewerComponent2txqc9jweitfp,
  ViewerLineIdsComponent as ViewerLineIdsComponent34apowetbbw0j,
  setScaleV as setScaleV340ooszze5w83,
  ViewerObjectComponent as ViewerObjectComponent27r4begfll99a,
  ViewerObjectTransformSystem as ViewerObjectTransformSystemksztxq365izc,
  ViewerObjectVisibilitySystem as ViewerObjectVisibilitySystem1jre14yw9hu5d,
  ViewerObject as ViewerObject3ep46jq2f8qyh,
  ViewerPresenceSystem as ViewerPresenceSystemv67ltk72nn0r,
  Viewer as Viewerqm0b0goijf8m,
  pauseViewerUpdatesOnDraggedEntity as pauseViewerUpdatesOnDraggedEntity2gxar8yfbd5og,
  resumeViewerUpdatesOnDraggedEntity as resumeViewerUpdatesOnDraggedEntity3h8us1qe5p1pl,
  get_viewerObject as get_viewerObject29ot7toalu4g9,
  FastReplaceAction as FastReplaceAction212dhglwlr3dq,
  ReplaceAction as ReplaceAction1fa7i0xxq6oq1,
  ReplacePartAction as ReplacePartAction1coduwrmfkb5,
  SlowReplaceInProgressComponent as SlowReplaceInProgressComponent1dbsrebp9hvu3,
  ClickEventComponent as ClickEventComponent21i5dkpzq1l7t,
  MultiSelectionEnabledComponent_0 as MultiSelectionEnabledComponent9yk5njwwbqmj,
  SelectableComponent as SelectableComponent2e9l9zv14vcv9,
  SelectedComponent as SelectedComponentmjsrq13g7qiz,
  get_isSelectable as get_isSelectableoo9b377znajq,
  get_isSelected as get_isSelected3w3gt1bz8axae,
  ComponentDeserializerRegistry as ComponentDeserializerRegistry1t0hod9zg4vr9,
  ComponentDeserializer as ComponentDeserializer3gfn2wcyjz4fh,
  afterDeserializeComplete as afterDeserializeComplete21wl460cpzfw1,
  beforeDeserialize as beforeDeserializeg4ijm0l5kwv,
  beforeParsingComponents as beforeParsingComponents1uddyhbyukgzt,
  DeserializationInterceptorRegistry as DeserializationInterceptorRegistryo6xua20lfv6o,
  DeserializationInterceptor as DeserializationInterceptor3bc7uplzjkuuu,
  JsonSerializable as JsonSerializablelbp1cvonvyw3,
  JsonSerializer as JsonSerializer24j7iub0ug4dd,
  SceneReloadingComponent as SceneReloadingComponentwzkuihaopsg1,
  get_serializable_0 as get_serializable1h8fjfkichiku,
  SerializableComponent as SerializableComponentkfm1jx9phpa4,
  SerializableRootComponent as SerializableRootComponentxsenof7kab27,
  UnserializableEntityComponent as UnserializableEntityComponent3dbbopzug8j88,
  AxisAlignedBox as AxisAlignedBox3der0ng81kho4,
  ConvexPolyhedron as ConvexPolyhedron31ds19umtd0r4,
  PolyhedronGroup as PolyhedronGroup3vtqeeg09ivxm,
  merge as merge14fhz8zclcclx,
  MovedToValidSnapPositionComponent as MovedToValidSnapPositionComponent2bg67k6jwdtcg,
  RestrictAllowedRequiredHostsComponent as RestrictAllowedRequiredHostsComponent1sbq773f5zt75,
  SnapCandidateComponent as SnapCandidateComponentt1m6a2tkmtdo,
  SnapRootComponent as SnapRootComponent157nyaf19ls92,
  SnapSettings as SnapSettingsu2m0ngibwcj8,
  get_snapRoot as get_snapRoot2o0fqu30dlj6i,
  get_snapRootSubTree as get_snapRootSubTree2hzdt81oiat82,
  get_snappingHierarchyEntities as get_snappingHierarchyEntities13s2ho7vt0q9e,
  triggerMovedToValidSnapPositionComponent as triggerMovedToValidSnapPositionComponent2zlcbcx5elfwb,
  IsLoadingSnapshotComponent as IsLoadingSnapshotComponentfhpzacbq70od,
  SnapshotService as SnapshotService3u6ccppzyz14z,
  UpdatedFromSnapshotEventComponent as UpdatedFromSnapshotEventComponent2v4gcwwpi6res,
  LocalTransformComponent as LocalTransformComponent1ihphzx3x7pnv,
  TransformSystem as TransformSystem26lghyta7a9eo,
  WorldTransformComponent as WorldTransformComponentm4lqdo5dza5x,
  get_isHanging as get_isHangingaizup6o5hh9d,
  get_localTransform as get_localTransform18l3q551qwat8,
  get_worldPosition as get_worldPositionwj6kte5ftqpq,
  get_worldRotation as get_worldRotationjykn4pgiq1i9,
  get_worldTransform as get_worldTransform2y1gcjubsjrt0,
  Measurer as Measurer3qj03p4urq95r,
  NoValidConnectorAvailableValidationResult as NoValidConnectorAvailableValidationResult51sgxuhhzcvw,
  SnapValidationResult as SnapValidationResult161dacj8es0md,
  UnknownErrorValidationResult as UnknownErrorValidationResult1fcieadp0rorb,
  ValidSnapActionCandidateOrErrors as ValidSnapActionCandidateOrErrors1t6fsuepjdmhc,
  ValidationImpl as ValidationImpl3mtow1d68cfbx,
  ValidationResultFail as ValidationResultFail37lbftt1xszsx,
  ValidationResultWarning as ValidationResultWarning2nfqcjukfyxxc,
  ValidationResult as ValidationResult2755ec0xe72le,
  ValidationServiceMeasurer as ValidationServiceMeasurern2cdhikkmaju,
  ValidationService as ValidationServicen25cawrb3gnh,
  RotationDegreeOfFreedom_NONE_getInstance as RotationDegreeOfFreedom_NONE_getInstance33hadjigf520i,
  RotationDegreeOfFreedom_ONE_getInstance as RotationDegreeOfFreedom_ONE_getInstance2o4nol40iudhw,
  LogLevel_DEBUG_getInstance as LogLevel_DEBUG_getInstance3vox4wckmki76,
  LogLevel_ERROR_getInstance as LogLevel_ERROR_getInstance203rtwgaav6kh,
  LogLevel_INFO_getInstance as LogLevel_INFO_getInstance2t7zae538qncw,
  LogLevel_WARN_getInstance as LogLevel_WARN_getInstance343yembho3ik6,
  ValidationMode_SNAP_getInstance as ValidationMode_SNAP_getInstance21t2mc3d7bdcn,
  ValidationMode_STATE_getInstance as ValidationMode_STATE_getInstance3a0ooc1lbbllq,
  ValidationResultType_FAIL_getInstance as ValidationResultType_FAIL_getInstance3pxpfo6jduhaj,
  ValidationResultType_WARNING_getInstance as ValidationResultType_WARNING_getInstance3uf8cr4ggrfxr,
  addHistoryModule as addHistoryModule30wboy3cvafvx,
  setLogModule as setLogModule28fol0nfx6ejr,
  productSpecification as productSpecification1di33unl59xxe,
  createEntityInternal as createEntityInternal3sy7rebiufsru,
  createEntity as createEntity38qxv713nv91g,
  createFromSpecificationInternal as createFromSpecificationInternal1cvmjoa6o87lg,
  createFromSpecification as createFromSpecification2g8y2k4pnelai,
  productSpecification_0 as productSpecificationtqv6dy51ctkj,
  cloneObject as cloneObject365f9airlgc11,
  createBox as createBox1wmf0pibluqwy,
  createEmpty as createEmpty7s3anc215c9c,
  createGhostModel as createGhostModel16b0p8lzbecmq,
  createPlane as createPlane14kzj3v1drqgb,
  createSphere as createSphereaf4ylyhldlue,
  createSurface as createSurface17gaiv854e1jm,
  createUiDashedLine as createUiDashedLinejdroy3k38xud,
  createUiLine as createUiLineaewijqnh08r,
  debug as debug14qh2dhfhqnvj,
  groupMeshes as groupMeshes3s0hr5pvbdigb,
  loadModel as loadModel16zcv8m5lo9ec,
  updateUiLine as updateUiLinecmyi944rl109,
  getFirstValidSnap as getFirstValidSnap2i0qt6mg9a6o2,
  validateCurrentState as validateCurrentState326fpy262zjc4,
  validateSnapCandidates as validateSnapCandidates21n6ndxamwgpm,
  validateSnapCandidate as validateSnapCandidate1igtax04zblqe,
  validateSnaps as validateSnapsjtiki3vjf94w,
  validateSnap as validateSnapff2l1bo2nula,
  AssemblyPartsComponent_init_$Create$ as AssemblyPartsComponent_init_$Create$30ms2ttoutmay,
  fromConnectors as fromConnectors3fh5yrw28qlfe,
  SizeFromVector as SizeFromVector3opll479fkt93,
  __VectorIntConstructorKotlin as __VectorIntConstructorKotlin23vz0u6hkz1es,
  fromSize_1 as fromSize34pw6a0b0kii5,
  fromSizeAndCenter as fromSizeAndCenter1wsnpvuimuz5l,
  LocalTransformComponentFromPosAndRot as LocalTransformComponentFromPosAndRot3l4w35iqp44oh,
  Companion_instance as Companion_instance25yt7vv7tdvma,
  Companion_getInstance_1 as Companion_getInstance2xkh7h77bkjex,
  Companion_getInstance_2 as Companion_getInstance1gt5uaft3z0z9,
  Companion_getInstance_3 as Companion_getInstance2hofax3pdsu41,
  Companion_getInstance_5 as Companion_getInstance7d85wexjlmvm,
  Companion_getInstance_8 as Companion_getInstance3c0i746p2b3f1,
  Companion_getInstance_10 as Companion_getInstancewxeheznrq82z,
  Companion_instance_10 as Companion_instance3tmi9s9ict1md,
  Companion_getInstance_13 as Companion_getInstance321ix5enib7je,
  Companion_getInstance_14 as Companion_getInstance3nop5w80d2fvp,
  Companion_instance_16 as Companion_instance2am4if0k0vik5,
  Companion_instance_17 as Companion_instancemu8gakosrpk3,
  Companion_instance_18 as Companion_instancelsy6jo6gbmmg,
  Companion_instance_21 as Companion_instance1jc5thgshmt53,
  Companion_instance_23 as Companion_instance2ofmo3pv93kda,
  Companion_getInstance_25 as Companion_getInstancemtg0kp3b7ax9,
  Companion_instance_25 as Companion_instance38lcv7tlpb3vd,
  Companion_getInstance_27 as Companion_getInstanceaxoswaeylgcr,
  Companion_getInstance_28 as Companion_getInstance2l3r2ra5znuy9,
  Companion_instance_29 as Companion_instance22st57uvtl8ku,
  Companion_instance_30 as Companion_instance3mp7ad30soxp7,
  Companion_instance_31 as Companion_instance2u0j4bg5mk4do,
  ConnectorTagConstants_instance as ConnectorTagConstants_instance25r6fly62d92a,
  Companion_instance_32 as Companion_instance1l2xi6jq9r026,
  Companion_instance_33 as Companion_instance1bk50smddux2z,
  Companion_getInstance_35 as Companion_getInstance2aog3ggbb4czi,
  Companion_instance_37 as Companion_instance180k82anvpmzv,
  Companion_getInstance_42 as Companion_getInstance16rqnzhjkimzu,
  Companion_getInstance_44 as Companion_getInstance1gjpn1yzol595,
  Companion_getInstance_45 as Companion_getInstance3orxffzckamdl,
  Companion_getInstance_46 as Companion_getInstance3h5g9rxuq57pv,
  Companion_getInstance_47 as Companion_getInstance3mtu0wpuna6mm,
  Companion_getInstance_49 as Companion_getInstance3jrtv4roftybv,
  Companion_getInstance_50 as Companion_getInstance2a3twbfroyz1e,
  Companion_getInstance_53 as Companion_getInstance2k1ozwc8kfagp,
  Companion_getInstance_55 as Companion_getInstance3fu6fg4j4924q,
  Companion_instance_56 as Companion_instance2v4yervvzae2n,
  Companion_getInstance_59 as Companion_getInstance1fi195ub4psxa,
  Companion_getInstance_60 as Companion_getInstance3md4pdk0vm7jd,
  Companion_instance_61 as Companion_instance3ca1skpyodlsq,
  Companion_instance_62 as Companion_instanceddwlqwaeornb,
  Companion_instance_63 as Companion_instanceauu711mmnozu,
  Companion_getInstance_65 as Companion_getInstance39qe8r3ndgbae,
  SceneComponent_instance as SceneComponent_instance2m1l3aroyspd4,
  Companion_instance_65 as Companion_instanceue8xml419xwh,
  LoggerState_getInstance as LoggerState_getInstance458njkt1c1yk,
  $serializer_getInstance_3 as $serializer_getInstance2thyfr0ndtc2i,
  Companion_instance_71 as Companion_instanceky5cav6lf93r,
  $serializer_getInstance_4 as $serializer_getInstance12w01pzkae8i7,
  Companion_getInstance_74 as Companion_getInstanceblwi6p98rjjg,
  Companion_instance_77 as Companion_instancebp32or5zv9ar,
  Companion_instance_74 as Companion_instance1crj6uacmrlqq,
  Companion_instance_75 as Companion_instanceydebsezhypgx,
  Companion_instance_76 as Companion_instance958nhgcvitga,
  $serializer_getInstance_6 as $serializer_getInstance2cm4qg7o1asp1,
  $serializer_getInstance_7 as $serializer_getInstance1u6uor4icd059,
  Companion_getInstance_80 as Companion_getInstancebkytj44sbgxv,
  $serializer_getInstance_8 as $serializer_getInstance1m03xnpu59c6l,
  Companion_getInstance_81 as Companion_getInstance1cmxj7l93cwya,
  Companion_getInstance_83 as Companion_getInstance1jzb2c9nz909x,
  Companion_getInstance_84 as Companion_getInstance1v24row485z1k,
  Companion_getInstance_85 as Companion_getInstanceiuj3shxmfy4i,
  Companion_instance_85 as Companion_instance2ncakbr3rm4n6,
  Companion_getInstance_88 as Companion_getInstance6pc1oksqwnwt,
  Companion_instance_88 as Companion_instance31r4dd7fkzkv0,
  Companion_instance_89 as Companion_instance2xadtclahfaol,
  Companion_getInstance_91 as Companion_getInstancehtw1u6p869r1,
  Companion_getInstance_92 as Companion_getInstance1g0yv2gl6yx8v,
  Companion_instance_93 as Companion_instance1wuloyan4lumr,
  Companion_getInstance_95 as Companion_getInstance27uf09vzwro99,
  Companion_getInstance_96 as Companion_getInstance15s3plxmm5ab3,
  Companion_instance_98 as Companion_instance3pyqhbbct0szg,
  Companion_getInstance_100 as Companion_getInstance3p2yxk0ezuu1y,
  Companion_getInstance_101 as Companion_getInstance1nwvy8hb5b24i,
  Companion_instance_101 as Companion_instance36lwzgsqf57la,
  Companion_instance_104 as Companion_instance22fugbyjy60j7,
  Companion_getInstance_106 as Companion_getInstance1dnxx5lu7yxa4,
  MultiSelectionEnabledComponent_instance as MultiSelectionEnabledComponent_instance221fiubaxomrq,
  Companion_getInstance_107 as Companion_getInstance3bt8g3cy89lt3,
  Companion_getInstance_108 as Companion_getInstance3k1r95ywn5kw9,
  Companion_instance_111 as Companion_instance1te2lwe2zlow7,
  Companion_getInstance_114 as Companion_getInstance38ogszviws7a1,
  Companion_getInstance_115 as Companion_getInstancec46jiz25vrpc,
  Companion_getInstance_116 as Companion_getInstance3fuwx9k23axgp,
  Companion_instance_116 as Companion_instancericwnzqb4avc,
  Companion_getInstance_125 as Companion_getInstance1k2wrnuhjrbuv,
  Companion_getInstance_129 as Companion_getInstanceoonrb8185bmg,
  Companion_getInstance_131 as Companion_getInstance22n010gwukty,
  Companion_instance_131 as Companion_instance3hfkidua2d4d9,
  Companion_getInstance_133 as Companion_getInstance13kmsjhjtfw4t,
  Companion_instance_134 as Companion_instance1714icf3ryhzu,
  Companion_instance_135 as Companion_instance29cjaupvwlme8,
  Companion_getInstance_137 as Companion_getInstance15akb0udr5r1u,
  Companion_instance_137 as Companion_instance11k45hlj7pzgo,
  Companion_instance_138 as Companion_instance3bnjpjo9eo1h9,
  Companion_getInstance_142 as Companion_getInstanceuteiyw5uqdpa,
  AlwaysHangDownComponent_instance as AlwaysHangDownComponent_instance2s6f7ev3q7y3y,
  Companion_getInstance_145 as Companion_getInstance27n1ww8f1u0xr,
  Companion_instance_145 as Companion_instance3o7m6i0by1hrp,
  Companion_instance_146 as Companion_instance1f7k6iwukor7l,
  Companion_getInstance_149 as Companion_getInstance2iuuydg1ibw9a,
  Companion_instance_149 as Companion_instance1st59rgzokdzq,
  Companion_instance_150 as Companion_instance1cg1b3a1w3dy5,
  Companion_instance_151 as Companion_instance31r63n71hpepn,
  Companion_instance_153 as Companion_instance3fe9ns9dryzgh,
};
//endregion

//# sourceMappingURL=core-core-api.mjs.map
